!function (t) {
  const e = t.en = t.en || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "(may require <kbd>Fn</kbd>)": "(may require <kbd>Fn</kbd>)",
    "%0 of %1": "%0 of %1",
    Accept: "Accept",
    Accessibility: "Accessibility",
    "Accessibility help": "Accessibility help",
    "Advanced options": "Advanced options",
    "Align cell text to the bottom": "Align cell text to the bottom",
    "Align cell text to the center": "Align cell text to the center",
    "Align cell text to the left": "Align cell text to the left",
    "Align cell text to the middle": "Align cell text to the middle",
    "Align cell text to the right": "Align cell text to the right",
    "Align cell text to the top": "Align cell text to the top",
    "Align center": "Align center",
    "Align left": "Align left",
    "Align right": "Align right",
    "Align table to the left": "Align table to the left",
    "Align table to the right": "Align table to the right",
    Alignment: "Alignment",
    All: "All",
    "Almost equal to": "Almost equal to",
    Angle: "Angle",
    "Approximately equal to": "Approximately equal to",
    Aquamarine: "Aquamarine",
    Arrows: "Arrows",
    "Asterisk operator": "Asterisk operator",
    "Austral sign": "Austral sign",
    "back with leftwards arrow above": "back with leftwards arrow above",
    Background: "Background",
    "Below, you can find a list of keyboard shortcuts that can be used in the editor.": "Below, you can find a list of keyboard shortcuts that can be used in the editor.",
    Big: "Big",
    "Bitcoin sign": "Bitcoin sign",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    "Blue marker": "Blue marker",
    Bold: "Bold",
    "Bold text": "Bold text",
    Border: "Border",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    "Bulleted list styles toolbar": "Bulleted list styles toolbar",
    Cancel: "Cancel",
    "Caption for image: %0": "Caption for image: %0",
    "Caption for the image": "Caption for the image",
    "Cedi sign": "Cedi sign",
    "Cell properties": "Cell properties",
    "Cent sign": "Cent sign",
    "Center table": "Center table",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Character categories": "Character categories",
    "Characters: %0": "Characters: %0",
    "Choose heading": "Choose heading",
    "Choose language": "Choose language",
    Circle: "Circle",
    Clear: "Clear",
    "Click to edit block": "Click to edit block",
    Close: "Close",
    "Close contextual balloons, dropdowns, and dialogs": "Close contextual balloons, dropdowns, and dialogs",
    Code: "Code",
    "Code block": "Code block",
    "Colon sign": "Colon sign",
    Color: "Color",
    "Color picker": "Color picker",
    Column: "Column",
    "Contains as member": "Contains as member",
    "Content editing keystrokes": "Content editing keystrokes",
    "Copy selected content": "Copy selected content",
    "Copyright sign": "Copyright sign",
    "Create link": "Create link",
    "Cruzeiro sign": "Cruzeiro sign",
    Currency: "Currency",
    "Currency sign": "Currency sign",
    Custom: "Custom",
    "Custom image size": "Custom image size",
    Dashed: "Dashed",
    Decimal: "Decimal",
    "Decimal with leading zero": "Decimal with leading zero",
    "Decrease indent": "Decrease indent",
    "Decrease list item indent": "Decrease list item indent",
    Default: "Default",
    "Degree sign": "Degree sign",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    Dimensions: "Dimensions",
    Disc: "Disc",
    "Division sign": "Division sign",
    "Document colors": "Document colors",
    "Dollar sign": "Dollar sign",
    "Dong sign": "Dong sign",
    Dotted: "Dotted",
    Double: "Double",
    "Double dagger": "Double dagger",
    "Double exclamation mark": "Double exclamation mark",
    "Double low-9 quotation mark": "Double low-9 quotation mark",
    "Double question mark": "Double question mark",
    Downloadable: "Downloadable",
    "downwards arrow to bar": "downwards arrow to bar",
    "downwards dashed arrow": "downwards dashed arrow",
    "downwards double arrow": "downwards double arrow",
    "downwards simple arrow": "downwards simple arrow",
    "Drachma sign": "Drachma sign",
    "Drag to move": "Drag to move",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit link": "Edit link",
    "Edit source": "Edit source",
    "Editor block content toolbar": "Editor block content toolbar",
    "Editor contextual toolbar": "Editor contextual toolbar",
    "Editor dialog": "Editor dialog",
    "Editor editing area: %0": "Editor editing area: %0",
    "Editor menu bar": "Editor menu bar",
    "Editor toolbar": "Editor toolbar",
    "Element of": "Element of",
    "Em dash": "Em dash",
    "Empty set": "Empty set",
    "Empty snippet content": "Empty snippet content",
    "En dash": "En dash",
    "end with leftwards arrow above": "end with leftwards arrow above",
    "Enter image caption": "Enter image caption",
    "Enter table caption": "Enter table caption",
    "Entering %0 code snippet": "Entering %0 code snippet",
    "Entering a to-do list": "Entering a to-do list",
    "Entering code snippet": "Entering code snippet",
    "Error during image upload": "Error during image upload",
    "Euro sign": "Euro sign",
    "Euro-currency sign": "Euro-currency sign",
    "Exclamation question mark": "Exclamation question mark",
    "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.": "Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.",
    Find: "Find",
    "Find and replace": "Find and replace",
    "Find in text…": "Find in text…",
    "Find in the document": "Find in the document",
    "Font Background Color": "Font Background Color",
    "Font Color": "Font Color",
    "Font Family": "Font Family",
    "Font Size": "Font Size",
    "For all": "For all",
    "Fraction slash": "Fraction slash",
    "French franc sign": "French franc sign",
    "Full size image": "Full size image",
    "German penny sign": "German penny sign",
    "Greater-than or equal to": "Greater-than or equal to",
    "Greater-than sign": "Greater-than sign",
    Green: "Green",
    "Green marker": "Green marker",
    "Green pen": "Green pen",
    Grey: "Grey",
    Groove: "Groove",
    "Guarani sign": "Guarani sign",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    Height: "Height",
    "Help Contents. To close this dialog press ESC.": "Help Contents. To close this dialog press ESC.",
    HEX: "HEX",
    Highlight: "Highlight",
    "Horizontal ellipsis": "Horizontal ellipsis",
    "Horizontal line": "Horizontal line",
    "Horizontal text alignment toolbar": "Horizontal text alignment toolbar",
    "Hryvnia sign": "Hryvnia sign",
    "HTML object": "HTML object",
    "HTML snippet": "HTML snippet",
    Huge: "Huge",
    "Identical to": "Identical to",
    "Image from computer": "Image from computer",
    "Image resize list": "Image resize list",
    "Image toolbar": "Image toolbar",
    "Image upload complete": "Image upload complete",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    "Increase list item indent": "Increase list item indent",
    "Indian rupee sign": "Indian rupee sign",
    Infinity: "Infinity",
    Insert: "Insert",
    "Insert a hard break (a new paragraph)": "Insert a hard break (a new paragraph)",
    "Insert a new paragraph directly after a widget": "Insert a new paragraph directly after a widget",
    "Insert a new paragraph directly before a widget": "Insert a new paragraph directly before a widget",
    "Insert a new table row (when in the last cell of a table)": "Insert a new table row (when in the last cell of a table)",
    "Insert a soft break (a <code>&lt;br&gt;</code> element)": "Insert a soft break (a <code>&lt;br&gt;</code> element)",
    "Insert code block": "Insert code block",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert HTML": "Insert HTML",
    "Insert image": "Insert image",
    "Insert image via URL": "Insert image via URL",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    Inset: "Inset",
    Integral: "Integral",
    Intersection: "Intersection",
    "Invalid start index value.": "Invalid start index value.",
    "Inverted exclamation mark": "Inverted exclamation mark",
    "Inverted question mark": "Inverted question mark",
    Italic: "Italic",
    "Italic text": "Italic text",
    Justify: "Justify",
    "Justify cell text": "Justify cell text",
    "Keystrokes that can be used in a list": "Keystrokes that can be used in a list",
    "Keystrokes that can be used in a table cell": "Keystrokes that can be used in a table cell",
    "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)": "Keystrokes that can be used when a widget is selected (for example: image, table, etc.)",
    "Kip sign": "Kip sign",
    Language: "Language",
    Latin: "Latin",
    "Latin capital letter a with breve": "Latin capital letter a with breve",
    "Latin capital letter a with macron": "Latin capital letter a with macron",
    "Latin capital letter a with ogonek": "Latin capital letter a with ogonek",
    "Latin capital letter c with acute": "Latin capital letter c with acute",
    "Latin capital letter c with caron": "Latin capital letter c with caron",
    "Latin capital letter c with circumflex": "Latin capital letter c with circumflex",
    "Latin capital letter c with dot above": "Latin capital letter c with dot above",
    "Latin capital letter d with caron": "Latin capital letter d with caron",
    "Latin capital letter d with stroke": "Latin capital letter d with stroke",
    "Latin capital letter e with breve": "Latin capital letter e with breve",
    "Latin capital letter e with caron": "Latin capital letter e with caron",
    "Latin capital letter e with dot above": "Latin capital letter e with dot above",
    "Latin capital letter e with macron": "Latin capital letter e with macron",
    "Latin capital letter e with ogonek": "Latin capital letter e with ogonek",
    "Latin capital letter eng": "Latin capital letter eng",
    "Latin capital letter g with breve": "Latin capital letter g with breve",
    "Latin capital letter g with cedilla": "Latin capital letter g with cedilla",
    "Latin capital letter g with circumflex": "Latin capital letter g with circumflex",
    "Latin capital letter g with dot above": "Latin capital letter g with dot above",
    "Latin capital letter h with circumflex": "Latin capital letter h with circumflex",
    "Latin capital letter h with stroke": "Latin capital letter h with stroke",
    "Latin capital letter i with breve": "Latin capital letter i with breve",
    "Latin capital letter i with dot above": "Latin capital letter i with dot above",
    "Latin capital letter i with macron": "Latin capital letter i with macron",
    "Latin capital letter i with ogonek": "Latin capital letter i with ogonek",
    "Latin capital letter i with tilde": "Latin capital letter i with tilde",
    "Latin capital letter j with circumflex": "Latin capital letter j with circumflex",
    "Latin capital letter k with cedilla": "Latin capital letter k with cedilla",
    "Latin capital letter l with acute": "Latin capital letter l with acute",
    "Latin capital letter l with caron": "Latin capital letter l with caron",
    "Latin capital letter l with cedilla": "Latin capital letter l with cedilla",
    "Latin capital letter l with middle dot": "Latin capital letter l with middle dot",
    "Latin capital letter l with stroke": "Latin capital letter l with stroke",
    "Latin capital letter n with acute": "Latin capital letter n with acute",
    "Latin capital letter n with caron": "Latin capital letter n with caron",
    "Latin capital letter n with cedilla": "Latin capital letter n with cedilla",
    "Latin capital letter o with breve": "Latin capital letter o with breve",
    "Latin capital letter o with double acute": "Latin capital letter o with double acute",
    "Latin capital letter o with macron": "Latin capital letter o with macron",
    "Latin capital letter r with acute": "Latin capital letter r with acute",
    "Latin capital letter r with caron": "Latin capital letter r with caron",
    "Latin capital letter r with cedilla": "Latin capital letter r with cedilla",
    "Latin capital letter s with acute": "Latin capital letter s with acute",
    "Latin capital letter s with caron": "Latin capital letter s with caron",
    "Latin capital letter s with cedilla": "Latin capital letter s with cedilla",
    "Latin capital letter s with circumflex": "Latin capital letter s with circumflex",
    "Latin capital letter t with caron": "Latin capital letter t with caron",
    "Latin capital letter t with cedilla": "Latin capital letter t with cedilla",
    "Latin capital letter t with stroke": "Latin capital letter t with stroke",
    "Latin capital letter u with breve": "Latin capital letter u with breve",
    "Latin capital letter u with double acute": "Latin capital letter u with double acute",
    "Latin capital letter u with macron": "Latin capital letter u with macron",
    "Latin capital letter u with ogonek": "Latin capital letter u with ogonek",
    "Latin capital letter u with ring above": "Latin capital letter u with ring above",
    "Latin capital letter u with tilde": "Latin capital letter u with tilde",
    "Latin capital letter w with circumflex": "Latin capital letter w with circumflex",
    "Latin capital letter y with circumflex": "Latin capital letter y with circumflex",
    "Latin capital letter y with diaeresis": "Latin capital letter y with diaeresis",
    "Latin capital letter z with acute": "Latin capital letter z with acute",
    "Latin capital letter z with caron": "Latin capital letter z with caron",
    "Latin capital letter z with dot above": "Latin capital letter z with dot above",
    "Latin capital ligature ij": "Latin capital ligature ij",
    "Latin capital ligature oe": "Latin capital ligature oe",
    "Latin small letter a with breve": "Latin small letter a with breve",
    "Latin small letter a with macron": "Latin small letter a with macron",
    "Latin small letter a with ogonek": "Latin small letter a with ogonek",
    "Latin small letter c with acute": "Latin small letter c with acute",
    "Latin small letter c with caron": "Latin small letter c with caron",
    "Latin small letter c with circumflex": "Latin small letter c with circumflex",
    "Latin small letter c with dot above": "Latin small letter c with dot above",
    "Latin small letter d with caron": "Latin small letter d with caron",
    "Latin small letter d with stroke": "Latin small letter d with stroke",
    "Latin small letter dotless i": "Latin small letter dotless i",
    "Latin small letter e with breve": "Latin small letter e with breve",
    "Latin small letter e with caron": "Latin small letter e with caron",
    "Latin small letter e with dot above": "Latin small letter e with dot above",
    "Latin small letter e with macron": "Latin small letter e with macron",
    "Latin small letter e with ogonek": "Latin small letter e with ogonek",
    "Latin small letter eng": "Latin small letter eng",
    "Latin small letter f with hook": "Latin small letter f with hook",
    "Latin small letter g with breve": "Latin small letter g with breve",
    "Latin small letter g with cedilla": "Latin small letter g with cedilla",
    "Latin small letter g with circumflex": "Latin small letter g with circumflex",
    "Latin small letter g with dot above": "Latin small letter g with dot above",
    "Latin small letter h with circumflex": "Latin small letter h with circumflex",
    "Latin small letter h with stroke": "Latin small letter h with stroke",
    "Latin small letter i with breve": "Latin small letter i with breve",
    "Latin small letter i with macron": "Latin small letter i with macron",
    "Latin small letter i with ogonek": "Latin small letter i with ogonek",
    "Latin small letter i with tilde": "Latin small letter i with tilde",
    "Latin small letter j with circumflex": "Latin small letter j with circumflex",
    "Latin small letter k with cedilla": "Latin small letter k with cedilla",
    "Latin small letter kra": "Latin small letter kra",
    "Latin small letter l with acute": "Latin small letter l with acute",
    "Latin small letter l with caron": "Latin small letter l with caron",
    "Latin small letter l with cedilla": "Latin small letter l with cedilla",
    "Latin small letter l with middle dot": "Latin small letter l with middle dot",
    "Latin small letter l with stroke": "Latin small letter l with stroke",
    "Latin small letter long s": "Latin small letter long s",
    "Latin small letter n preceded by apostrophe": "Latin small letter n preceded by apostrophe",
    "Latin small letter n with acute": "Latin small letter n with acute",
    "Latin small letter n with caron": "Latin small letter n with caron",
    "Latin small letter n with cedilla": "Latin small letter n with cedilla",
    "Latin small letter o with breve": "Latin small letter o with breve",
    "Latin small letter o with double acute": "Latin small letter o with double acute",
    "Latin small letter o with macron": "Latin small letter o with macron",
    "Latin small letter r with acute": "Latin small letter r with acute",
    "Latin small letter r with caron": "Latin small letter r with caron",
    "Latin small letter r with cedilla": "Latin small letter r with cedilla",
    "Latin small letter s with acute": "Latin small letter s with acute",
    "Latin small letter s with caron": "Latin small letter s with caron",
    "Latin small letter s with cedilla": "Latin small letter s with cedilla",
    "Latin small letter s with circumflex": "Latin small letter s with circumflex",
    "Latin small letter t with caron": "Latin small letter t with caron",
    "Latin small letter t with cedilla": "Latin small letter t with cedilla",
    "Latin small letter t with stroke": "Latin small letter t with stroke",
    "Latin small letter u with breve": "Latin small letter u with breve",
    "Latin small letter u with double acute": "Latin small letter u with double acute",
    "Latin small letter u with macron": "Latin small letter u with macron",
    "Latin small letter u with ogonek": "Latin small letter u with ogonek",
    "Latin small letter u with ring above": "Latin small letter u with ring above",
    "Latin small letter u with tilde": "Latin small letter u with tilde",
    "Latin small letter w with circumflex": "Latin small letter w with circumflex",
    "Latin small letter y with circumflex": "Latin small letter y with circumflex",
    "Latin small letter z with acute": "Latin small letter z with acute",
    "Latin small letter z with caron": "Latin small letter z with caron",
    "Latin small letter z with dot above": "Latin small letter z with dot above",
    "Latin small ligature ij": "Latin small ligature ij",
    "Latin small ligature oe": "Latin small ligature oe",
    "Leaving %0 code snippet": "Leaving %0 code snippet",
    "Leaving a to-do list": "Leaving a to-do list",
    "Leaving code snippet": "Leaving code snippet",
    "Left aligned image": "Left aligned image",
    "Left double quotation mark": "Left double quotation mark",
    "Left single quotation mark": "Left single quotation mark",
    "Left-pointing double angle quotation mark": "Left-pointing double angle quotation mark",
    "leftwards arrow to bar": "leftwards arrow to bar",
    "leftwards dashed arrow": "leftwards dashed arrow",
    "leftwards double arrow": "leftwards double arrow",
    "leftwards simple arrow": "leftwards simple arrow",
    "Less-than or equal to": "Less-than or equal to",
    "Less-than sign": "Less-than sign",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link image": "Link image",
    "Link URL": "Link URL",
    "Link URL must not be empty.": "Link URL must not be empty.",
    "Lira sign": "Lira sign",
    "List properties": "List properties",
    "Livre tournois sign": "Livre tournois sign",
    "Logical and": "Logical and",
    "Logical or": "Logical or",
    "Lower-latin": "Lower-latin",
    "Lower–roman": "Lower–roman",
    Macron: "Macron",
    "Manat sign": "Manat sign",
    "Match case": "Match case",
    Mathematical: "Mathematical",
    "Media toolbar": "Media toolbar",
    "Media URL": "Media URL",
    "media widget": "media widget",
    MENU_BAR_MENU_EDIT: "Edit",
    MENU_BAR_MENU_FILE: "File",
    MENU_BAR_MENU_FONT: "Font",
    MENU_BAR_MENU_FORMAT: "Format",
    MENU_BAR_MENU_HELP: "Help",
    MENU_BAR_MENU_INSERT: "Insert",
    MENU_BAR_MENU_TEXT: "Text",
    MENU_BAR_MENU_TOOLS: "Tools",
    MENU_BAR_MENU_VIEW: "View",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    "Mill sign": "Mill sign",
    "Minus sign": "Minus sign",
    "Move focus between form fields (inputs, buttons, etc.)": "Move focus between form fields (inputs, buttons, etc.)",
    "Move focus in and out of an active dialog window": "Move focus in and out of an active dialog window",
    "Move focus to the menu bar, navigate between menu bars": "Move focus to the menu bar, navigate between menu bars",
    "Move focus to the toolbar, navigate between toolbars": "Move focus to the toolbar, navigate between toolbars",
    "Move out of a link": "Move out of a link",
    "Move out of an inline code style": "Move out of an inline code style",
    "Move the caret to allow typing directly after a widget": "Move the caret to allow typing directly after a widget",
    "Move the caret to allow typing directly before a widget": "Move the caret to allow typing directly before a widget",
    "Move the selection to the next cell": "Move the selection to the next cell",
    "Move the selection to the previous cell": "Move the selection to the previous cell",
    "Multiplication sign": "Multiplication sign",
    "N-ary product": "N-ary product",
    "N-ary summation": "N-ary summation",
    Nabla: "Nabla",
    "Naira sign": "Naira sign",
    "Navigate through the table": "Navigate through the table",
    "Navigate through the toolbar or menu bar": "Navigate through the toolbar or menu bar",
    "New sheqel sign": "New sheqel sign",
    Next: "Next",
    "Next result": "Next result",
    "No preview available": "No preview available",
    "No results found": "No results found",
    "No searchable items": "No searchable items",
    None: "None",
    "Nordic mark sign": "Nordic mark sign",
    "Not an element of": "Not an element of",
    "Not equal to": "Not equal to",
    "Not sign": "Not sign",
    "Numbered List": "Numbered List",
    "Numbered list styles toolbar": "Numbered list styles toolbar",
    "on with exclamation mark with left right arrow above": "on with exclamation mark with left right arrow above",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    "Open media in new tab": "Open media in new tab",
    "Open the accessibility help dialog": "Open the accessibility help dialog",
    Orange: "Orange",
    Original: "Original",
    Outset: "Outset",
    Overline: "Overline",
    Padding: "Padding",
    "Page break": "Page break",
    Paragraph: "Paragraph",
    "Paragraph sign": "Paragraph sign",
    "Partial differential": "Partial differential",
    "Paste content": "Paste content",
    "Paste content as plain text": "Paste content as plain text",
    "Paste raw HTML here...": "Paste raw HTML here...",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    "Per mille sign": "Per mille sign",
    "Per ten thousand sign": "Per ten thousand sign",
    "Peseta sign": "Peseta sign",
    "Peso sign": "Peso sign",
    "Pink marker": "Pink marker",
    "Plain text": "Plain text",
    'Please enter a valid color (e.g. "ff0000").': 'Please enter a valid color (e.g. "ff0000").',
    "Plus-minus sign": "Plus-minus sign",
    "Pound sign": "Pound sign",
    "Press %0 for help.": "Press %0 for help.",
    "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget",
    Previous: "Previous",
    "Previous result": "Previous result",
    "Proportional to": "Proportional to",
    Purple: "Purple",
    "Question exclamation mark": "Question exclamation mark",
    Red: "Red",
    "Red pen": "Red pen",
    Redo: "Redo",
    "Registered sign": "Registered sign",
    "Remove color": "Remove color",
    "Remove Format": "Remove Format",
    "Remove highlight": "Remove highlight",
    "Remove language": "Remove language",
    Replace: "Replace",
    "Replace all": "Replace all",
    "Replace from computer": "Replace from computer",
    "Replace image": "Replace image",
    "Replace image from computer": "Replace image from computer",
    "Replace with…": "Replace with…",
    "Resize image": "Resize image",
    "Resize image (in %0)": "Resize image (in %0)",
    "Resize image to %0": "Resize image to %0",
    "Resize image to the original size": "Resize image to the original size",
    "Restore default": "Restore default",
    "Reversed order": "Reversed order",
    "Reversed paragraph sign": "Reversed paragraph sign",
    "Revert autoformatting action": "Revert autoformatting action",
    "Rich Text Editor": "Rich Text Editor",
    Ridge: "Ridge",
    "Right aligned image": "Right aligned image",
    "Right double quotation mark": "Right double quotation mark",
    "Right single quotation mark": "Right single quotation mark",
    "Right-pointing double angle quotation mark": "Right-pointing double angle quotation mark",
    "rightwards arrow to bar": "rightwards arrow to bar",
    "rightwards dashed arrow": "rightwards dashed arrow",
    "rightwards double arrow": "rightwards double arrow",
    "rightwards simple arrow": "rightwards simple arrow",
    Row: "Row",
    "Ruble sign": "Ruble sign",
    "Rupee sign": "Rupee sign",
    Save: "Save",
    "Save changes": "Save changes",
    "Section sign": "Section sign",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Show blocks": "Show blocks",
    "Show more items": "Show more items",
    "Show source": "Show source",
    "Side image": "Side image",
    "Single left-pointing angle quotation mark": "Single left-pointing angle quotation mark",
    "Single low-9 quotation mark": "Single low-9 quotation mark",
    "Single right-pointing angle quotation mark": "Single right-pointing angle quotation mark",
    Small: "Small",
    Solid: "Solid",
    "soon with rightwards arrow above": "soon with rightwards arrow above",
    Source: "Source",
    "Special characters": "Special characters",
    "Spesmilo sign": "Spesmilo sign",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    Square: "Square",
    "Square root": "Square root",
    "Start at": "Start at",
    "Start index must be greater than 0.": "Start index must be greater than 0.",
    Strikethrough: "Strikethrough",
    "Strikethrough text": "Strikethrough text",
    Style: "Style",
    Subscript: "Subscript",
    Superscript: "Superscript",
    Table: "Table",
    "Table alignment toolbar": "Table alignment toolbar",
    "Table cell text alignment": "Table cell text alignment",
    "Table properties": "Table properties",
    "Table toolbar": "Table toolbar",
    "Tenge sign": "Tenge sign",
    Text: "Text",
    "Text alignment": "Text alignment",
    "Text alignment toolbar": "Text alignment toolbar",
    "Text alternative": "Text alternative",
    "Text highlight toolbar": "Text highlight toolbar",
    "Text to find must not be empty.": "Text to find must not be empty.",
    'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".',
    "The URL must not be empty.": "The URL must not be empty.",
    'The value is invalid. Try "10px" or "2em" or simply "2".': 'The value is invalid. Try "10px" or "2em" or simply "2".',
    "The value must not be empty.": "The value must not be empty.",
    "The value should be a plain number.": "The value should be a plain number.",
    "There exists": "There exists",
    "These keyboard shortcuts allow for quick access to content editing features.": "These keyboard shortcuts allow for quick access to content editing features.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tilde operator": "Tilde operator",
    Tiny: "Tiny",
    "Tip: Find some text first in order to replace it.": "Tip: Find some text first in order to replace it.",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    "To-do List": "To-do List",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    "Toggle the circle list style": "Toggle the circle list style",
    "Toggle the decimal list style": "Toggle the decimal list style",
    "Toggle the decimal with leading zero list style": "Toggle the decimal with leading zero list style",
    "Toggle the disc list style": "Toggle the disc list style",
    "Toggle the lower–latin list style": "Toggle the lower–latin list style",
    "Toggle the lower–roman list style": "Toggle the lower–roman list style",
    "Toggle the square list style": "Toggle the square list style",
    "Toggle the upper–latin list style": "Toggle the upper–latin list style",
    "Toggle the upper–roman list style": "Toggle the upper–roman list style",
    "top with upwards arrow above": "top with upwards arrow above",
    "Trade mark sign": "Trade mark sign",
    "Tugrik sign": "Tugrik sign",
    "Turkish lira sign": "Turkish lira sign",
    Turquoise: "Turquoise",
    "Two dot leader": "Two dot leader",
    "Type or paste your content here.": "Type or paste your content here.",
    "Type your title": "Type your title",
    Underline: "Underline",
    "Underline text": "Underline text",
    Undo: "Undo",
    Union: "Union",
    Unlink: "Unlink",
    "up down arrow with base": "up down arrow with base",
    Update: "Update",
    "Update image URL": "Update image URL",
    "Upload failed": "Upload failed",
    "Upload from computer": "Upload from computer",
    "Upload image from computer": "Upload image from computer",
    "Upload in progress": "Upload in progress",
    "Uploading image": "Uploading image",
    "Upper-latin": "Upper-latin",
    "Upper-roman": "Upper-roman",
    "upwards arrow to bar": "upwards arrow to bar",
    "upwards dashed arrow": "upwards dashed arrow",
    "upwards double arrow": "upwards double arrow",
    "upwards simple arrow": "upwards simple arrow",
    "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.": "Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.",
    "User interface and content navigation keystrokes": "User interface and content navigation keystrokes",
    "Vertical text alignment toolbar": "Vertical text alignment toolbar",
    "Vulgar fraction one half": "Vulgar fraction one half",
    "Vulgar fraction one quarter": "Vulgar fraction one quarter",
    "Vulgar fraction three quarters": "Vulgar fraction three quarters",
    White: "White",
    "Whole words only": "Whole words only",
    "Widget toolbar": "Widget toolbar",
    Width: "Width",
    "Won sign": "Won sign",
    "Words: %0": "Words: %0",
    "Wrap text": "Wrap text",
    Yellow: "Yellow",
    "Yellow marker": "Yellow marker",
    "Yen sign": "Yen sign"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(globalThis, () => (() => {
  var t,
    e,
    n = {
      5659(t, e, n) {
        const i = n(8156),
          o = {};
        for (const t of Object.keys(i)) o[i[t]] = t;
        const r = {
          rgb: {
            channels: 3,
            labels: "rgb"
          },
          hsl: {
            channels: 3,
            labels: "hsl"
          },
          hsv: {
            channels: 3,
            labels: "hsv"
          },
          hwb: {
            channels: 3,
            labels: "hwb"
          },
          cmyk: {
            channels: 4,
            labels: "cmyk"
          },
          xyz: {
            channels: 3,
            labels: "xyz"
          },
          lab: {
            channels: 3,
            labels: "lab"
          },
          lch: {
            channels: 3,
            labels: "lch"
          },
          hex: {
            channels: 1,
            labels: ["hex"]
          },
          keyword: {
            channels: 1,
            labels: ["keyword"]
          },
          ansi16: {
            channels: 1,
            labels: ["ansi16"]
          },
          ansi256: {
            channels: 1,
            labels: ["ansi256"]
          },
          hcg: {
            channels: 3,
            labels: ["h", "c", "g"]
          },
          apple: {
            channels: 3,
            labels: ["r16", "g16", "b16"]
          },
          gray: {
            channels: 1,
            labels: ["gray"]
          }
        };
        t.exports = r;
        for (const t of Object.keys(r)) {
          if (!("channels" in r[t])) throw new Error("missing channels property: " + t);
          if (!("labels" in r[t])) throw new Error("missing channel labels property: " + t);
          if (r[t].labels.length !== r[t].channels) throw new Error("channel and label counts mismatch: " + t);
          const {
            channels: e,
            labels: n
          } = r[t];
          delete r[t].channels, delete r[t].labels, Object.defineProperty(r[t], "channels", {
            value: e
          }), Object.defineProperty(r[t], "labels", {
            value: n
          });
        }
        function s(t, e) {
          return (t[0] - e[0]) ** 2 + (t[1] - e[1]) ** 2 + (t[2] - e[2]) ** 2;
        }
        r.rgb.hsl = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            i = t[2] / 255,
            o = Math.min(e, n, i),
            r = Math.max(e, n, i),
            s = r - o;
          let a, l;
          r === o ? a = 0 : e === r ? a = (n - i) / s : n === r ? a = 2 + (i - e) / s : i === r && (a = 4 + (e - n) / s), a = Math.min(60 * a, 360), a < 0 && (a += 360);
          const c = (o + r) / 2;
          return l = r === o ? 0 : c <= .5 ? s / (r + o) : s / (2 - r - o), [a, 100 * l, 100 * c];
        }, r.rgb.hsv = function (t) {
          let e, n, i, o, r;
          const s = t[0] / 255,
            a = t[1] / 255,
            l = t[2] / 255,
            c = Math.max(s, a, l),
            d = c - Math.min(s, a, l),
            u = function (t) {
              return (c - t) / 6 / d + .5;
            };
          return 0 === d ? (o = 0, r = 0) : (r = d / c, e = u(s), n = u(a), i = u(l), s === c ? o = i - n : a === c ? o = 1 / 3 + e - i : l === c && (o = 2 / 3 + n - e), o < 0 ? o += 1 : o > 1 && (o -= 1)), [360 * o, 100 * r, 100 * c];
        }, r.rgb.hwb = function (t) {
          const e = t[0],
            n = t[1];
          let i = t[2];
          const o = r.rgb.hsl(t)[0],
            s = 1 / 255 * Math.min(e, Math.min(n, i));
          return i = 1 - 1 / 255 * Math.max(e, Math.max(n, i)), [o, 100 * s, 100 * i];
        }, r.rgb.cmyk = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            i = t[2] / 255,
            o = Math.min(1 - e, 1 - n, 1 - i);
          return [100 * ((1 - e - o) / (1 - o) || 0), 100 * ((1 - n - o) / (1 - o) || 0), 100 * ((1 - i - o) / (1 - o) || 0), 100 * o];
        }, r.rgb.keyword = function (t) {
          const e = o[t];
          if (e) return e;
          let n,
            r = 1 / 0;
          for (const e of Object.keys(i)) {
            const o = s(t, i[e]);
            o < r && (r = o, n = e);
          }
          return n;
        }, r.keyword.rgb = function (t) {
          return i[t];
        }, r.rgb.xyz = function (t) {
          let e = t[0] / 255,
            n = t[1] / 255,
            i = t[2] / 255;
          e = e > .04045 ? ((e + .055) / 1.055) ** 2.4 : e / 12.92, n = n > .04045 ? ((n + .055) / 1.055) ** 2.4 : n / 12.92, i = i > .04045 ? ((i + .055) / 1.055) ** 2.4 : i / 12.92;
          return [100 * (.4124 * e + .3576 * n + .1805 * i), 100 * (.2126 * e + .7152 * n + .0722 * i), 100 * (.0193 * e + .1192 * n + .9505 * i)];
        }, r.rgb.lab = function (t) {
          const e = r.rgb.xyz(t);
          let n = e[0],
            i = e[1],
            o = e[2];
          n /= 95.047, i /= 100, o /= 108.883, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116, o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
          return [116 * i - 16, 500 * (n - i), 200 * (i - o)];
        }, r.hsl.rgb = function (t) {
          const e = t[0] / 360,
            n = t[1] / 100,
            i = t[2] / 100;
          let o, r, s;
          if (0 === n) return s = 255 * i, [s, s, s];
          o = i < .5 ? i * (1 + n) : i + n - i * n;
          const a = 2 * i - o,
            l = [0, 0, 0];
          for (let t = 0; t < 3; t++) r = e + 1 / 3 * -(t - 1), r < 0 && r++, r > 1 && r--, s = 6 * r < 1 ? a + 6 * (o - a) * r : 2 * r < 1 ? o : 3 * r < 2 ? a + (o - a) * (2 / 3 - r) * 6 : a, l[t] = 255 * s;
          return l;
        }, r.hsl.hsv = function (t) {
          const e = t[0];
          let n = t[1] / 100,
            i = t[2] / 100,
            o = n;
          const r = Math.max(i, .01);
          i *= 2, n *= i <= 1 ? i : 2 - i, o *= r <= 1 ? r : 2 - r;
          return [e, 100 * (0 === i ? 2 * o / (r + o) : 2 * n / (i + n)), 100 * ((i + n) / 2)];
        }, r.hsv.rgb = function (t) {
          const e = t[0] / 60,
            n = t[1] / 100;
          let i = t[2] / 100;
          const o = Math.floor(e) % 6,
            r = e - Math.floor(e),
            s = 255 * i * (1 - n),
            a = 255 * i * (1 - n * r),
            l = 255 * i * (1 - n * (1 - r));
          switch (i *= 255, o) {
            case 0:
              return [i, l, s];
            case 1:
              return [a, i, s];
            case 2:
              return [s, i, l];
            case 3:
              return [s, a, i];
            case 4:
              return [l, s, i];
            case 5:
              return [i, s, a];
          }
        }, r.hsv.hsl = function (t) {
          const e = t[0],
            n = t[1] / 100,
            i = t[2] / 100,
            o = Math.max(i, .01);
          let r, s;
          s = (2 - n) * i;
          const a = (2 - n) * o;
          return r = n * o, r /= a <= 1 ? a : 2 - a, r = r || 0, s /= 2, [e, 100 * r, 100 * s];
        }, r.hwb.rgb = function (t) {
          const e = t[0] / 360;
          let n = t[1] / 100,
            i = t[2] / 100;
          const o = n + i;
          let r;
          o > 1 && (n /= o, i /= o);
          const s = Math.floor(6 * e),
            a = 1 - i;
          r = 6 * e - s, 1 & s && (r = 1 - r);
          const l = n + r * (a - n);
          let c, d, u;
          switch (s) {
            default:
            case 6:
            case 0:
              c = a, d = l, u = n;
              break;
            case 1:
              c = l, d = a, u = n;
              break;
            case 2:
              c = n, d = a, u = l;
              break;
            case 3:
              c = n, d = l, u = a;
              break;
            case 4:
              c = l, d = n, u = a;
              break;
            case 5:
              c = a, d = n, u = l;
          }
          return [255 * c, 255 * d, 255 * u];
        }, r.cmyk.rgb = function (t) {
          const e = t[0] / 100,
            n = t[1] / 100,
            i = t[2] / 100,
            o = t[3] / 100;
          return [255 * (1 - Math.min(1, e * (1 - o) + o)), 255 * (1 - Math.min(1, n * (1 - o) + o)), 255 * (1 - Math.min(1, i * (1 - o) + o))];
        }, r.xyz.rgb = function (t) {
          const e = t[0] / 100,
            n = t[1] / 100,
            i = t[2] / 100;
          let o, r, s;
          return o = 3.2406 * e + -1.5372 * n + -.4986 * i, r = -.9689 * e + 1.8758 * n + .0415 * i, s = .0557 * e + -.204 * n + 1.057 * i, o = o > .0031308 ? 1.055 * o ** (1 / 2.4) - .055 : 12.92 * o, r = r > .0031308 ? 1.055 * r ** (1 / 2.4) - .055 : 12.92 * r, s = s > .0031308 ? 1.055 * s ** (1 / 2.4) - .055 : 12.92 * s, o = Math.min(Math.max(0, o), 1), r = Math.min(Math.max(0, r), 1), s = Math.min(Math.max(0, s), 1), [255 * o, 255 * r, 255 * s];
        }, r.xyz.lab = function (t) {
          let e = t[0],
            n = t[1],
            i = t[2];
          e /= 95.047, n /= 100, i /= 108.883, e = e > .008856 ? e ** (1 / 3) : 7.787 * e + 16 / 116, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
          return [116 * n - 16, 500 * (e - n), 200 * (n - i)];
        }, r.lab.xyz = function (t) {
          let e, n, i;
          n = (t[0] + 16) / 116, e = t[1] / 500 + n, i = n - t[2] / 200;
          const o = n ** 3,
            r = e ** 3,
            s = i ** 3;
          return n = o > .008856 ? o : (n - 16 / 116) / 7.787, e = r > .008856 ? r : (e - 16 / 116) / 7.787, i = s > .008856 ? s : (i - 16 / 116) / 7.787, e *= 95.047, n *= 100, i *= 108.883, [e, n, i];
        }, r.lab.lch = function (t) {
          const e = t[0],
            n = t[1],
            i = t[2];
          let o;
          o = 360 * Math.atan2(i, n) / 2 / Math.PI, o < 0 && (o += 360);
          return [e, Math.sqrt(n * n + i * i), o];
        }, r.lch.lab = function (t) {
          const e = t[0],
            n = t[1],
            i = t[2] / 360 * 2 * Math.PI;
          return [e, n * Math.cos(i), n * Math.sin(i)];
        }, r.rgb.ansi16 = function (t) {
          let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          const [n, i, o] = t;
          let s = null === e ? r.rgb.hsv(t)[2] : e;
          if (s = Math.round(s / 50), 0 === s) return 30;
          let a = 30 + (Math.round(o / 255) << 2 | Math.round(i / 255) << 1 | Math.round(n / 255));
          return 2 === s && (a += 60), a;
        }, r.hsv.ansi16 = function (t) {
          return r.rgb.ansi16(r.hsv.rgb(t), t[2]);
        }, r.rgb.ansi256 = function (t) {
          const e = t[0],
            n = t[1],
            i = t[2];
          if (e === n && n === i) return e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232;
          return 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5);
        }, r.ansi16.rgb = function (t) {
          let e = t % 10;
          if (0 === e || 7 === e) return t > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
          const n = .5 * (1 + ~~(t > 50));
          return [(1 & e) * n * 255, (e >> 1 & 1) * n * 255, (e >> 2 & 1) * n * 255];
        }, r.ansi256.rgb = function (t) {
          if (t >= 232) {
            const e = 10 * (t - 232) + 8;
            return [e, e, e];
          }
          let e;
          t -= 16;
          return [Math.floor(t / 36) / 5 * 255, Math.floor((e = t % 36) / 6) / 5 * 255, e % 6 / 5 * 255];
        }, r.rgb.hex = function (t) {
          const e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
          return "000000".substring(e.length) + e;
        }, r.hex.rgb = function (t) {
          const e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!e) return [0, 0, 0];
          let n = e[0];
          3 === e[0].length && (n = n.split("").map(t => t + t).join(""));
          const i = parseInt(n, 16);
          return [i >> 16 & 255, i >> 8 & 255, 255 & i];
        }, r.rgb.hcg = function (t) {
          const e = t[0] / 255,
            n = t[1] / 255,
            i = t[2] / 255,
            o = Math.max(Math.max(e, n), i),
            r = Math.min(Math.min(e, n), i),
            s = o - r;
          let a, l;
          return a = s < 1 ? r / (1 - s) : 0, l = s <= 0 ? 0 : o === e ? (n - i) / s % 6 : o === n ? 2 + (i - e) / s : 4 + (e - n) / s, l /= 6, l %= 1, [360 * l, 100 * s, 100 * a];
        }, r.hsl.hcg = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100,
            i = n < .5 ? 2 * e * n : 2 * e * (1 - n);
          let o = 0;
          return i < 1 && (o = (n - .5 * i) / (1 - i)), [t[0], 100 * i, 100 * o];
        }, r.hsv.hcg = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100,
            i = e * n;
          let o = 0;
          return i < 1 && (o = (n - i) / (1 - i)), [t[0], 100 * i, 100 * o];
        }, r.hcg.rgb = function (t) {
          const e = t[0] / 360,
            n = t[1] / 100,
            i = t[2] / 100;
          if (0 === n) return [255 * i, 255 * i, 255 * i];
          const o = [0, 0, 0],
            r = e % 1 * 6,
            s = r % 1,
            a = 1 - s;
          let l = 0;
          switch (Math.floor(r)) {
            case 0:
              o[0] = 1, o[1] = s, o[2] = 0;
              break;
            case 1:
              o[0] = a, o[1] = 1, o[2] = 0;
              break;
            case 2:
              o[0] = 0, o[1] = 1, o[2] = s;
              break;
            case 3:
              o[0] = 0, o[1] = a, o[2] = 1;
              break;
            case 4:
              o[0] = s, o[1] = 0, o[2] = 1;
              break;
            default:
              o[0] = 1, o[1] = 0, o[2] = a;
          }
          return l = (1 - n) * i, [255 * (n * o[0] + l), 255 * (n * o[1] + l), 255 * (n * o[2] + l)];
        }, r.hcg.hsv = function (t) {
          const e = t[1] / 100,
            n = e + t[2] / 100 * (1 - e);
          let i = 0;
          return n > 0 && (i = e / n), [t[0], 100 * i, 100 * n];
        }, r.hcg.hsl = function (t) {
          const e = t[1] / 100,
            n = t[2] / 100 * (1 - e) + .5 * e;
          let i = 0;
          return n > 0 && n < .5 ? i = e / (2 * n) : n >= .5 && n < 1 && (i = e / (2 * (1 - n))), [t[0], 100 * i, 100 * n];
        }, r.hcg.hwb = function (t) {
          const e = t[1] / 100,
            n = e + t[2] / 100 * (1 - e);
          return [t[0], 100 * (n - e), 100 * (1 - n)];
        }, r.hwb.hcg = function (t) {
          const e = t[1] / 100,
            n = 1 - t[2] / 100,
            i = n - e;
          let o = 0;
          return i < 1 && (o = (n - i) / (1 - i)), [t[0], 100 * i, 100 * o];
        }, r.apple.rgb = function (t) {
          return [t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255];
        }, r.rgb.apple = function (t) {
          return [t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535];
        }, r.gray.rgb = function (t) {
          return [t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255];
        }, r.gray.hsl = function (t) {
          return [0, 0, t[0]];
        }, r.gray.hsv = r.gray.hsl, r.gray.hwb = function (t) {
          return [0, 100, t[0]];
        }, r.gray.cmyk = function (t) {
          return [0, 0, 0, t[0]];
        }, r.gray.lab = function (t) {
          return [t[0], 0, 0];
        }, r.gray.hex = function (t) {
          const e = 255 & Math.round(t[0] / 100 * 255),
            n = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
          return "000000".substring(n.length) + n;
        }, r.rgb.gray = function (t) {
          return [(t[0] + t[1] + t[2]) / 3 / 255 * 100];
        };
      },
      734(t, e, n) {
        const i = n(5659),
          o = n(8507),
          r = {};
        Object.keys(i).forEach(t => {
          r[t] = {}, Object.defineProperty(r[t], "channels", {
            value: i[t].channels
          }), Object.defineProperty(r[t], "labels", {
            value: i[t].labels
          });
          const e = o(t);
          Object.keys(e).forEach(n => {
            const i = e[n];
            r[t][n] = function (t) {
              const e = function () {
                for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                  e[_key] = arguments[_key];
                }
                const n = e[0];
                if (null == n) return n;
                n.length > 1 && (e = n);
                const i = t(e);
                if ("object" == typeof i) for (let t = i.length, e = 0; e < t; e++) i[e] = Math.round(i[e]);
                return i;
              };
              return "conversion" in t && (e.conversion = t.conversion), e;
            }(i), r[t][n].raw = function (t) {
              const e = function () {
                for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  e[_key2] = arguments[_key2];
                }
                const n = e[0];
                return null == n ? n : (n.length > 1 && (e = n), t(e));
              };
              return "conversion" in t && (e.conversion = t.conversion), e;
            }(i);
          });
        }), t.exports = r;
      },
      8507(t, e, n) {
        const i = n(5659);
        function o(t) {
          const e = function () {
              const t = {},
                e = Object.keys(i);
              for (let n = e.length, i = 0; i < n; i++) t[e[i]] = {
                distance: -1,
                parent: null
              };
              return t;
            }(),
            n = [t];
          for (e[t].distance = 0; n.length;) {
            const t = n.pop(),
              o = Object.keys(i[t]);
            for (let i = o.length, r = 0; r < i; r++) {
              const i = o[r],
                s = e[i];
              -1 === s.distance && (s.distance = e[t].distance + 1, s.parent = t, n.unshift(i));
            }
          }
          return e;
        }
        function r(t, e) {
          return function (n) {
            return e(t(n));
          };
        }
        function s(t, e) {
          const n = [e[t].parent, t];
          let o = i[e[t].parent][t],
            s = e[t].parent;
          for (; e[s].parent;) n.unshift(e[s].parent), o = r(i[e[s].parent][s], o), s = e[s].parent;
          return o.conversion = n, o;
        }
        t.exports = function (t) {
          const e = o(t),
            n = {},
            i = Object.keys(e);
          for (let t = i.length, o = 0; o < t; o++) {
            const t = i[o];
            null !== e[t].parent && (n[t] = s(t, e));
          }
          return n;
        };
      },
      8156(t) {
        "use strict";

        t.exports = {
          aliceblue: [240, 248, 255],
          antiquewhite: [250, 235, 215],
          aqua: [0, 255, 255],
          aquamarine: [127, 255, 212],
          azure: [240, 255, 255],
          beige: [245, 245, 220],
          bisque: [255, 228, 196],
          black: [0, 0, 0],
          blanchedalmond: [255, 235, 205],
          blue: [0, 0, 255],
          blueviolet: [138, 43, 226],
          brown: [165, 42, 42],
          burlywood: [222, 184, 135],
          cadetblue: [95, 158, 160],
          chartreuse: [127, 255, 0],
          chocolate: [210, 105, 30],
          coral: [255, 127, 80],
          cornflowerblue: [100, 149, 237],
          cornsilk: [255, 248, 220],
          crimson: [220, 20, 60],
          cyan: [0, 255, 255],
          darkblue: [0, 0, 139],
          darkcyan: [0, 139, 139],
          darkgoldenrod: [184, 134, 11],
          darkgray: [169, 169, 169],
          darkgreen: [0, 100, 0],
          darkgrey: [169, 169, 169],
          darkkhaki: [189, 183, 107],
          darkmagenta: [139, 0, 139],
          darkolivegreen: [85, 107, 47],
          darkorange: [255, 140, 0],
          darkorchid: [153, 50, 204],
          darkred: [139, 0, 0],
          darksalmon: [233, 150, 122],
          darkseagreen: [143, 188, 143],
          darkslateblue: [72, 61, 139],
          darkslategray: [47, 79, 79],
          darkslategrey: [47, 79, 79],
          darkturquoise: [0, 206, 209],
          darkviolet: [148, 0, 211],
          deeppink: [255, 20, 147],
          deepskyblue: [0, 191, 255],
          dimgray: [105, 105, 105],
          dimgrey: [105, 105, 105],
          dodgerblue: [30, 144, 255],
          firebrick: [178, 34, 34],
          floralwhite: [255, 250, 240],
          forestgreen: [34, 139, 34],
          fuchsia: [255, 0, 255],
          gainsboro: [220, 220, 220],
          ghostwhite: [248, 248, 255],
          gold: [255, 215, 0],
          goldenrod: [218, 165, 32],
          gray: [128, 128, 128],
          green: [0, 128, 0],
          greenyellow: [173, 255, 47],
          grey: [128, 128, 128],
          honeydew: [240, 255, 240],
          hotpink: [255, 105, 180],
          indianred: [205, 92, 92],
          indigo: [75, 0, 130],
          ivory: [255, 255, 240],
          khaki: [240, 230, 140],
          lavender: [230, 230, 250],
          lavenderblush: [255, 240, 245],
          lawngreen: [124, 252, 0],
          lemonchiffon: [255, 250, 205],
          lightblue: [173, 216, 230],
          lightcoral: [240, 128, 128],
          lightcyan: [224, 255, 255],
          lightgoldenrodyellow: [250, 250, 210],
          lightgray: [211, 211, 211],
          lightgreen: [144, 238, 144],
          lightgrey: [211, 211, 211],
          lightpink: [255, 182, 193],
          lightsalmon: [255, 160, 122],
          lightseagreen: [32, 178, 170],
          lightskyblue: [135, 206, 250],
          lightslategray: [119, 136, 153],
          lightslategrey: [119, 136, 153],
          lightsteelblue: [176, 196, 222],
          lightyellow: [255, 255, 224],
          lime: [0, 255, 0],
          limegreen: [50, 205, 50],
          linen: [250, 240, 230],
          magenta: [255, 0, 255],
          maroon: [128, 0, 0],
          mediumaquamarine: [102, 205, 170],
          mediumblue: [0, 0, 205],
          mediumorchid: [186, 85, 211],
          mediumpurple: [147, 112, 219],
          mediumseagreen: [60, 179, 113],
          mediumslateblue: [123, 104, 238],
          mediumspringgreen: [0, 250, 154],
          mediumturquoise: [72, 209, 204],
          mediumvioletred: [199, 21, 133],
          midnightblue: [25, 25, 112],
          mintcream: [245, 255, 250],
          mistyrose: [255, 228, 225],
          moccasin: [255, 228, 181],
          navajowhite: [255, 222, 173],
          navy: [0, 0, 128],
          oldlace: [253, 245, 230],
          olive: [128, 128, 0],
          olivedrab: [107, 142, 35],
          orange: [255, 165, 0],
          orangered: [255, 69, 0],
          orchid: [218, 112, 214],
          palegoldenrod: [238, 232, 170],
          palegreen: [152, 251, 152],
          paleturquoise: [175, 238, 238],
          palevioletred: [219, 112, 147],
          papayawhip: [255, 239, 213],
          peachpuff: [255, 218, 185],
          peru: [205, 133, 63],
          pink: [255, 192, 203],
          plum: [221, 160, 221],
          powderblue: [176, 224, 230],
          purple: [128, 0, 128],
          rebeccapurple: [102, 51, 153],
          red: [255, 0, 0],
          rosybrown: [188, 143, 143],
          royalblue: [65, 105, 225],
          saddlebrown: [139, 69, 19],
          salmon: [250, 128, 114],
          sandybrown: [244, 164, 96],
          seagreen: [46, 139, 87],
          seashell: [255, 245, 238],
          sienna: [160, 82, 45],
          silver: [192, 192, 192],
          skyblue: [135, 206, 235],
          slateblue: [106, 90, 205],
          slategray: [112, 128, 144],
          slategrey: [112, 128, 144],
          snow: [255, 250, 250],
          springgreen: [0, 255, 127],
          steelblue: [70, 130, 180],
          tan: [210, 180, 140],
          teal: [0, 128, 128],
          thistle: [216, 191, 216],
          tomato: [255, 99, 71],
          turquoise: [64, 224, 208],
          violet: [238, 130, 238],
          wheat: [245, 222, 179],
          white: [255, 255, 255],
          whitesmoke: [245, 245, 245],
          yellow: [255, 255, 0],
          yellowgreen: [154, 205, 50]
        };
      },
      9248(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content code{background-color:#c7c7c74d;border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:#c7c7c780}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-basic-styles/theme/code.css"],
          names: [],
          mappings: "AAKA,iBACC,0BAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,0BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\tpadding: .15em;\n\tborder-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n\tbackground-color: hsla(0, 0%, 78%, 0.5);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1501(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"],
          names: [],
          mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9262(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}.ck.ck-clipboard-drop-target-line{pointer-events:none;position:absolute}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) #0000 #0000 #0000;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{outline:none!important;zoom:.6}.ck.ck-clipboard-drop-target-line{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);height:0;margin-top:-1px}.ck.ck-clipboard-drop-target-line:before{border-style:solid;content:"";height:0;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-width)*-.5);width:0}[dir=ltr] .ck.ck-clipboard-drop-target-line:before{border-color:#0000 #0000 #0000 var(--ck-clipboard-drop-target-color);border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height);left:-1px}[dir=rtl] .ck.ck-clipboard-drop-target-line:before{border-color:#0000 var(--ck-clipboard-drop-target-color) #0000 #0000;border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0;right:-1px}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"],
          names: [],
          mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CAIF,kCAEC,mBAAoB,CADpB,iBAED,CC9BA,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,oEAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CAOF,kEACC,gGACD,CAKA,gDAEC,sBAAwB,CADxB,OAED,CAGD,kCAGC,gDAAiD,CADjD,sDAAuD,CADvD,QAAS,CAGT,eAwBD,CAtBC,yCAMC,kBAAmB,CALnB,UAAW,CAIX,QAAS,CAHT,iBAAkB,CAClB,uDAA0D,CAC1D,OAiBD,CArBA,mDAYE,oEAAuF,CADvF,+JAAoK,CAFpK,SAYF,CArBA,mDAmBE,oEAAuF,CADvF,+JAAmK,CAFnK,UAKF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\tposition: absolute;\n\tpointer-events: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"@ckeditor/ckeditor5-ui/theme/mixins/_dir.css\";\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\theight: 0;\n\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\tbackground: var(--ck-clipboard-drop-target-color);\n\tmargin-top: -1px;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-style: solid;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tleft: -1px;\n\n\t\t\tborder-width: calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height);\n\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tright: -1px;\n\n\t\t\tborder-width:calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0;\n\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2291(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content pre{background:#c7c7c74d;border:1px solid #c4c4c4;border-radius:2px;color:#353535;direction:ltr;font-style:normal;min-width:200px;padding:1em;tab-size:4;text-align:left;white-space:pre-wrap}.ck-content pre code{background:unset;border-radius:0;padding:0}.ck.ck-editor__editable pre{position:relative}.ck.ck-editor__editable pre[data-language]:after{content:attr(data-language);position:absolute}:root{--ck-color-code-block-label-background:#757575}.ck.ck-editor__editable pre[data-language]:after{background:var(--ck-color-code-block-label-background);color:#fff;font-family:var(--ck-font-face);font-size:10px;line-height:16px;padding:var(--ck-spacing-tiny) var(--ck-spacing-medium);right:10px;top:-1px;white-space:nowrap}.ck.ck-code-block-dropdown .ck-dropdown__panel{max-height:250px;overflow-x:hidden;overflow-y:auto}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-code-block/theme/codeblock.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-code-block/codeblock.css"],
          names: [],
          mappings: "AAKA,gBAGC,oBAAiC,CACjC,wBAAiC,CACjC,iBAAkB,CAHlB,aAAwB,CAOxB,aAAc,CAMd,iBAAkB,CAGlB,eAAgB,CAjBhB,WAAY,CAUZ,UAAW,CAHX,eAAgB,CAIhB,oBAaD,CALC,qBACC,gBAAiB,CAEjB,eAAgB,CADhB,SAED,CAGD,4BACC,iBAMD,CAJC,iDACC,2BAA4B,CAC5B,iBACD,CCjCD,MACC,8CACD,CAEA,iDAGC,sDAAuD,CAMvD,UAAuB,CAHvB,+BAAgC,CADhC,cAAe,CAEf,gBAAiB,CACjB,uDAAwD,CANxD,UAAW,CADX,QAAS,CAST,kBACD,CAEA,+CAEC,gBAAiB,CAEjB,iBAAkB,CADlB,eAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content pre {\n\tpadding: 1em;\n\tcolor: hsl(0, 0%, 20.8%);\n\tbackground: hsla(0, 0%, 78%, 0.3);\n\tborder: 1px solid hsl(0, 0%, 77%);\n\tborder-radius: 2px;\n\n\t/* Code block are language direction–agnostic. */\n\ttext-align: left;\n\tdirection: ltr;\n\n\ttab-size: 4;\n\twhite-space: pre-wrap;\n\n\t/* Don't inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* Don't let the code be squashed e.g. when in a table cell. */\n\tmin-width: 200px;\n\n\t& code {\n\t\tbackground: unset;\n\t\tpadding: 0;\n\t\tborder-radius: 0;\n\t}\n}\n\n.ck.ck-editor__editable pre {\n\tposition: relative;\n\n\t&[data-language]::after {\n\t\tcontent: attr(data-language);\n\t\tposition: absolute;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-code-block-label-background: hsl(0, 0%, 46%);\n}\n\n.ck.ck-editor__editable pre[data-language]::after {\n\ttop: -1px;\n\tright: 10px;\n\tbackground: var(--ck-color-code-block-label-background);\n\n\tfont-size: 10px;\n\tfont-family: var(--ck-font-face);\n\tline-height: 16px;\n\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-medium);\n\tcolor: hsl(0, 0%, 100%);\n\twhite-space: nowrap;\n}\n\n.ck.ck-code-block-dropdown .ck-dropdown__panel {\n\t/* There could be dozens of languages available. Use scroll to prevent a 10e6px dropdown. */\n\tmax-height: 250px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9881(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-panel)}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{border:solid var(--ck-color-base-border);border-width:1px 1px 0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content.ck-sticky-panel__content_sticky{border-bottom-width:1px}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-menu-bar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content .ck-toolbar{border:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,8DCED,eDeC,CAjBA,mKCMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAcF,CAjBA,8DAOC,wCAAsB,CAAtB,sBAUD,CARC,8FACC,uBACD,CAEA,qJAEC,QACD,CAMH,yCAEC,0CAA2C,CCtB3C,eDgCD,CAZA,yHChBE,qCAAsC,CDqBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-panel);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-sticky-panel__content {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\tborder-bottom-width: 0;\n\n\t\t\t&.ck-sticky-panel__content_sticky {\n\t\t\t\tborder-bottom-width: 1px;\n\t\t\t}\n\n\t\t\t& .ck-menu-bar,\n\t\t\t& .ck-toolbar {\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1111(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}@media (forced-colors:active){.ck .ck-placeholder,.ck.ck-placeholder{forced-color-adjust:preserve-parent-color}}.ck .ck-placeholder:before,.ck.ck-placeholder:before{cursor:text}@media (forced-colors:none){.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text)}}@media (forced-colors:active){.ck .ck-placeholder:before,.ck.ck-placeholder:before{font-style:italic;margin-left:1px}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
          names: [],
          mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC7BC,8BACC,uCCOA,yCDLA,CACD,CCOA,qDACC,WAmBD,CDvBA,4BACC,qDCMC,6CDJD,CACD,CAZA,8BACC,qDCsBC,iBAAkB,CAMlB,eD1BD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t@mixin ck-media-forced-colors {\n\t\t/*\n\t\t * This is needed for Edge on Windows to use the right color for the placeholder content (::before).\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t */\n\t\tforced-color-adjust: preserve-parent-color;\n\t}\n\n\t&::before {\n\t\tcursor: text;\n\n\t\t@mixin ck-media-default-colors {\n\t\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t\t}\n\n\t\t@mixin ck-media-forced-colors {\n\t\t\t/*\n\t\t\t * In the high contrast mode there is no telling between regular and placeholder text. Using\n\t\t\t * italic text to address that issue. See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tfont-style: italic;\n\n\t\t\t/*\n\t\t\t * Without this margin, the caret will not show up and blink when the user puts the selection\n\t\t\t * in the placeholder (Edge on Windows). See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t\t\t */\n\t\t\tmargin-left: 1px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6531(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css"],
          names: [],
          mappings: "AAMA,qDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5450(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-find-result{background:var(--ck-color-highlight-background);color:var(--ck-color-text)}.ck-find-result_selected{background:#ff9633}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-find-and-replace/theme/findandreplace.css"],
          names: [],
          mappings: "AAKA,gBACC,+CAAgD,CAChD,0BACD,CAEA,yBACC,kBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-find-result {\n\tbackground: var(--ck-color-highlight-background);\n\tcolor: var(--ck-color-text);\n}\n\n.ck-find-result_selected {\n\tbackground: hsl(29, 100%, 60%);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9388(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-find-and-replace-form{max-width:100%;& .ck-find-and-replace-form__inputs,.ck-find-and-replace-form__actions{display:flex}& .ck-find-and-replace-form__inputs.ck-find-and-replace-form__inputs .ck-results-counter,.ck-find-and-replace-form__actions.ck-find-and-replace-form__inputs .ck-results-counter{position:absolute}}.ck.ck-find-and-replace-form{width:400px}.ck.ck-find-and-replace-form:focus{outline:none}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions,.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs{align-content:stretch;align-items:center;flex:1 1 auto;flex-direction:row;flex-wrap:wrap;margin:0;padding:var(--ck-spacing-large)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions>.ck-button,.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-button{flex:0 0 auto}[dir=ltr] .ck.ck-find-and-replace-form .ck-find-and-replace-form__actions>*+*,[dir=ltr] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>*+*{margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-find-and-replace-form .ck-find-and-replace-form__actions>*+*,[dir=rtl] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>*+*{margin-right:var(--ck-spacing-standard)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions .ck-labeled-field-view,.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-labeled-field-view{flex:1 1 auto}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions .ck-labeled-field-view .ck-input,.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-labeled-field-view .ck-input{min-width:50px;width:100%}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs{align-items:flex-start}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-button-prev>.ck-icon{transform:rotate(90deg)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-button-next>.ck-icon{transform:rotate(-90deg)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-results-counter{top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-results-counter{right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-results-counter{left:var(--ck-spacing-standard)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs .ck-results-counter{color:var(--ck-color-base-border)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-labeled-field-replace{flex:0 0 100%;padding-top:var(--ck-spacing-standard)}[dir=ltr] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-labeled-field-replace{margin-left:0}[dir=rtl] .ck.ck-find-and-replace-form .ck-find-and-replace-form__inputs>.ck-labeled-field-replace{margin-right:0}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions{flex-wrap:wrap;justify-content:flex-end;margin-top:calc(var(--ck-spacing-large)*-1)}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions>.ck-button-find{font-weight:700}.ck.ck-find-and-replace-form .ck-find-and-replace-form__actions>.ck-button-find .ck-button__label{padding-left:var(--ck-spacing-large);padding-right:var(--ck-spacing-large)}.ck.ck-find-and-replace-form .ck-switchbutton{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;width:100%}@media screen and (max-width:600px){.ck.ck-find-and-replace-form{max-width:100%;width:300px}.ck.ck-find-and-replace-form.ck-find-and-replace-form__input{flex-wrap:wrap}.ck.ck-find-and-replace-form.ck-find-and-replace-form__input .ck-labeled-field-view{flex:1 0 auto;margin-bottom:var(--ck-spacing-standard);width:100%}.ck.ck-find-and-replace-form.ck-find-and-replace-form__input>.ck-button{text-align:center}.ck.ck-find-and-replace-form.ck-find-and-replace-form__input>.ck-button:first-of-type{flex:1 1 auto}[dir=ltr] .ck.ck-find-and-replace-form.ck-find-and-replace-form__input>.ck-button:first-of-type{margin-left:0}[dir=rtl] .ck.ck-find-and-replace-form.ck-find-and-replace-form__input>.ck-button:first-of-type{margin-right:0}.ck.ck-find-and-replace-form.ck-find-and-replace-form__input>.ck-button:first-of-type .ck-button__label{text-align:center;width:100%}.ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view){flex:1 1 auto;flex-wrap:wrap}.ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view)>.ck-button{text-align:center}.ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view)>.ck-button:first-of-type{flex:1 1 auto}[dir=ltr] .ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view)>.ck-button:first-of-type{margin-left:0}[dir=rtl] .ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view)>.ck-button:first-of-type{margin-right:0}.ck.ck-find-and-replace-form.ck-find-and-replace-form__actions>:not(.ck-labeled-field-view)>.ck-button .ck-button__label{text-align:center;width:100%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-find-and-replace/theme/findandreplaceform.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-find-and-replace/findandreplaceform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAKA,6BACC,cAAe,CAEf,uEACC,YAMD,CAHC,iLACC,iBACD,CAEF,CCRA,6BACC,WAoHD,CA9GC,mCACC,YACD,CAGA,+HAMC,qBAAsB,CADtB,kBAAmB,CAHnB,aAAc,CACd,kBAAmB,CACnB,cAAe,CAKf,QAAS,CADT,+BA4BD,CAzBC,qJACC,aACD,CAGC,2JACC,sCACD,CAIA,2JACC,uCACD,CAGD,6KACC,aAMD,CAJC,iMAEC,cAAe,CADf,UAED,CAMF,+DAEC,sBAqCD,CAnCC,wFACC,uBACD,CAEA,wFACC,wBACD,CAEA,mFACC,OAAQ,CACR,0BAWD,CAbA,6FAKE,gCAQF,CAbA,6FASE,+BAIF,CAbA,mFAYC,iCACD,CAEA,yFACC,aAAc,CACd,sCASD,CAXA,mGAKE,aAMF,CAXA,mGASE,cAEF,CAID,gEACC,cAAe,CACf,wBAAyB,CACzB,2CAWD,CATC,gFACC,eAOD,CAJC,kGACC,oCAAqC,CACrC,qCACD,CAIF,8CAMC,kBAAmB,CAJnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAJ9B,UAMD,CCtHA,oCD0HA,6BAIC,cAAe,CAHf,WA+DD,CAzDC,6DACC,cA4BD,CA1BC,oFACC,aAAc,CAEd,wCAAyC,CADzC,UAED,CAEA,wEACC,iBAkBD,CAhBC,sFACC,aAcD,CAfA,gGAIE,aAWF,CAfA,gGAQE,cAOF,CAJC,wGAEC,iBAAkB,CADlB,UAED,CAMH,4FAEC,aAAc,CADd,cAuBD,CApBC,uGACC,iBAkBD,CAhBC,qHACC,aASD,CAVA,+HAIE,aAMF,CAVA,+HAQE,cAEF,CAEA,yHAEC,iBAAkB,CADlB,UAED,CCrLH",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-find-and-replace-form {\n\tmax-width: 100%;\n\n\t& .ck-find-and-replace-form__inputs, .ck-find-and-replace-form__actions {\n\t\tdisplay: flex;\n\n\t\t/* The inputs area styles */\n\t\t&.ck-find-and-replace-form__inputs .ck-results-counter {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-find-and-replace-form {\n\twidth: 400px;\n\n\t/*\n\t * The <form> needs tabindex="-1" for proper Esc handling after being clicked\n\t * but the side effect is that this creates a nasty focus outline in some browsers.\n\t */\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t/* Generic styles for the form inputs and actions. */\n\t& .ck-find-and-replace-form__inputs,\n\t& .ck-find-and-replace-form__actions {\n\t\tflex: 1 1 auto;\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\talign-content: stretch;\n\n\t\tpadding: var(--ck-spacing-large);\n\t\tmargin: 0;\n\n\t\t& > .ck-button {\n\t\t\tflex: 0 0 auto;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t& > * + * {\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t& > * + * {\n\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex: 1 1 auto;\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\t\t\t\tmin-width: 50px;\n\t\t\t}\n\t\t}\n\n\t}\n\n\t/* Styles specific for inputs area. */\n\t& .ck-find-and-replace-form__inputs {\n\t\t/* To display all controls in line when there\'s an error under the input */\n\t\talign-items: flex-start;\n\n\t\t& > .ck-button-prev > .ck-icon {\n\t\t\ttransform: rotate(90deg);\n\t\t}\n\n\t\t& > .ck-button-next > .ck-icon {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\n\t\t& .ck-results-counter {\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tright: var(--ck-spacing-standard);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tleft: var(--ck-spacing-standard);\n\t\t\t}\n\n\t\t\tcolor: var(--ck-color-base-border);\n\t\t}\n\n\t\t& > .ck-labeled-field-replace {\n\t\t\tflex: 0 0 100%;\n\t\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Styles specific for actions area. */\n\t& .ck-find-and-replace-form__actions {\n\t\tflex-wrap: wrap;\n\t\tjustify-content: flex-end;\n\t\tmargin-top: calc( -1 * var(--ck-spacing-large) );\n\n\t\t& > .ck-button-find {\n\t\t\tfont-weight: bold;\n\n\t\t\t/* Beef the find button up a little. It\'s the main action button in the form */\n\t\t\t& .ck-button__label {\n\t\t\t\tpadding-left: var(--ck-spacing-large);\n\t\t\t\tpadding-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck-switchbutton {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n}\n\n@mixin ck-media-phone {\n\t.ck.ck-find-and-replace-form {\n\t\twidth: 300px;\n\n\t\t/* Don\'t let the form overflow from the dialog (https://github.com/cksource/ckeditor5-commercial/issues/5913) */\n\t\tmax-width: 100%;\n\n\t\t/* Styles specific for inputs area. */\n\t\t&.ck-find-and-replace-form__input {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tflex: 1 0 auto;\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: var(--ck-spacing-standard);\n\t\t\t}\n\n\t\t\t& > .ck-button {\n\t\t\t\ttext-align: center;\n\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tflex: 1 1 auto;\n\n\t\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t& .ck-button__label {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Styles specific for actions area. */\n\t\t&.ck-find-and-replace-form__actions > :not(.ck-labeled-field-view) {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex: 1 1 auto;\n\n\t\t\t& > .ck-button {\n\t\t\t\ttext-align: center;\n\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tflex: 1 1 auto;\n\n\t\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t& .ck-button__label {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9465(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content .text-tiny{font-size:.7em}.ck-content .text-small{font-size:.85em}.ck-content .text-big{font-size:1.4em}.ck-content .text-huge{font-size:1.8em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontsize.css"],
          names: [],
          mappings: "AAUC,uBACC,cACD,CAEA,wBACC,eACD,CAEA,sBACC,eACD,CAEA,uBACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The values should be synchronized with the "FONT_SIZE_PRESET_UNITS" object in the "/src/fontsize/utils.js" file. */\n\n/* Styles should be prefixed with the `.ck-content` class.\nSee https://github.com/ckeditor/ckeditor5/issues/6636 */\n.ck-content {\n\t& .text-tiny {\n\t\tfont-size: .7em;\n\t}\n\n\t& .text-small {\n\t\tfont-size: .85em;\n\t}\n\n\t& .text-big {\n\t\tfont-size: 1.4em;\n\t}\n\n\t& .text-huge {\n\t\tfont-size: 1.8em;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6186(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
          names: [],
          mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1862(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-highlight-marker-yellow:#fdfd77;--ck-highlight-marker-green:#62f962;--ck-highlight-marker-pink:#fc7899;--ck-highlight-marker-blue:#72ccfd;--ck-highlight-pen-red:#e71313;--ck-highlight-pen-green:#128a00}.ck-content .marker-yellow{background-color:var(--ck-highlight-marker-yellow)}.ck-content .marker-green{background-color:var(--ck-highlight-marker-green)}.ck-content .marker-pink{background-color:var(--ck-highlight-marker-pink)}.ck-content .marker-blue{background-color:var(--ck-highlight-marker-blue)}.ck-content .pen-red{background-color:initial;color:var(--ck-highlight-pen-red)}.ck-content .pen-green{background-color:initial;color:var(--ck-highlight-pen-green)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-highlight/theme/highlight.css"],
          names: [],
          mappings: "AAKA,MACC,oCAA+C,CAC/C,mCAA+C,CAC/C,kCAA8C,CAC9C,kCAA8C,CAC9C,8BAAwC,CACxC,gCACD,CAGC,2BACC,kDACD,CAFA,0BACC,iDACD,CAFA,yBACC,gDACD,CAFA,yBACC,gDACD,CAIA,qBAIC,wBAA6B,CAH7B,iCAID,CALA,uBAIC,wBAA6B,CAH7B,mCAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-highlight-marker-yellow: hsl(60, 97%, 73%);\n\t--ck-highlight-marker-green: hsl(120, 93%, 68%);\n\t--ck-highlight-marker-pink: hsl(345, 96%, 73%);\n\t--ck-highlight-marker-blue: hsl(201, 97%, 72%);\n\t--ck-highlight-pen-red: hsl(0, 85%, 49%);\n\t--ck-highlight-pen-green: hsl(112, 100%, 27%);\n}\n\n@define-mixin highlight-marker-color $color {\n\t.ck-content .marker-$color {\n\t\tbackground-color: var(--ck-highlight-marker-$color);\n\t}\n}\n\n@define-mixin highlight-pen-color $color {\n\t.ck-content .pen-$color {\n\t\tcolor: var(--ck-highlight-pen-$color);\n\n\t\t/* Override default yellow background of `<mark>` from user agent stylesheet */\n\t\tbackground-color: transparent;\n\t}\n}\n\n@mixin highlight-marker-color yellow;\n@mixin highlight-marker-color green;\n@mixin highlight-marker-color pink;\n@mixin highlight-marker-color blue;\n\n@mixin highlight-pen-color red;\n@mixin highlight-pen-color green;\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1799(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{background:#dedede;border:0;height:4px;margin:15px 0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css"],
          names: [],
          mappings: "AAMA,yCAEC,iBACD,CAEA,eAGC,kBAA2B,CAC3B,QAAS,CAFT,UAAW,CADX,aAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n\n.ck-editor__editable .ck-horizontal-line {\n\t/* Necessary to render properly next to floated objects, e.g. side image case. */\n\tdisplay: flow-root;\n}\n\n.ck-content hr {\n\tmargin: 15px 0;\n\theight: 4px;\n\tbackground: hsl(0, 0%, 87%);\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9856(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-widget.raw-html-embed{display:flow-root;font-style:normal;margin:.9em auto;min-width:15em;position:relative}.ck-widget.raw-html-embed:before{position:absolute;z-index:1}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{display:flex;flex-direction:column;position:absolute}.ck-widget.raw-html-embed .raw-html-embed__preview{display:flex;overflow:hidden;position:relative}.ck-widget.raw-html-embed .raw-html-embed__preview-content{border-collapse:initial;border-spacing:7px;display:table;margin:auto;position:relative;width:100%}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}:root{--ck-html-embed-content-width:calc(100% - var(--ck-icon-size)*1.5);--ck-html-embed-source-height:10em;--ck-html-embed-unfocused-outline-width:1px;--ck-html-embed-content-min-height:calc(var(--ck-icon-size) + var(--ck-spacing-standard));--ck-html-embed-source-disabled-background:var(--ck-color-base-foreground);--ck-html-embed-source-disabled-color:#737373}.ck-widget.raw-html-embed{background-color:var(--ck-color-base-foreground);font-size:var(--ck-font-size-base)}.ck-widget.raw-html-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.raw-html-embed[dir=ltr]{text-align:left}.ck-widget.raw-html-embed[dir=rtl]{text-align:right}.ck-widget.raw-html-embed:before{background:#999;border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);content:attr(data-html-embed-label);font-family:var(--ck-font-face);font-size:var(--ck-font-size-tiny);left:var(--ck-spacing-standard);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);top:calc(var(--ck-html-embed-unfocused-outline-width)*-1);transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck-widget.raw-html-embed[dir=rtl]:before{left:auto;right:var(--ck-spacing-standard)}.ck-widget.raw-html-embed[dir=ltr] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck.ck-editor__editable.ck-blurred .ck-widget.raw-html-embed.ck-widget_selected:before{padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck.ck-editor__editable:not(.ck-blurred) .ck-widget.raw-html-embed.ck-widget_selected:before{background:var(--ck-color-focus-border);padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck.ck-editor__editable .ck-widget.raw-html-embed:not(.ck-widget_selected):hover:before{padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck-widget.raw-html-embed .raw-html-embed__content-wrapper{padding:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{right:var(--ck-spacing-standard);top:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__save-button{color:var(--ck-color-button-save)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__cancel-button{color:var(--ck-color-button-cancel)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button:not(:first-child){margin-top:var(--ck-spacing-small)}.ck-widget.raw-html-embed[dir=rtl] .raw-html-embed__buttons-wrapper{left:var(--ck-spacing-standard);right:auto}.ck-widget.raw-html-embed .raw-html-embed__source{box-sizing:border-box;direction:ltr;font-family:monospace;font-size:var(--ck-font-size-base);height:var(--ck-html-embed-source-height);min-width:0;padding:var(--ck-spacing-standard);resize:none;tab-size:4;text-align:left;white-space:pre-wrap;width:var(--ck-html-embed-content-width)}.ck-widget.raw-html-embed .raw-html-embed__source[disabled]{background:var(--ck-html-embed-source-disabled-background);color:var(--ck-html-embed-source-disabled-color);-webkit-text-fill-color:var(--ck-html-embed-source-disabled-color);opacity:1}.ck-widget.raw-html-embed .raw-html-embed__preview{min-height:var(--ck-html-embed-content-min-height);width:var(--ck-html-embed-content-width)}.ck-editor__editable:not(.ck-read-only) .ck-widget.raw-html-embed .raw-html-embed__preview{pointer-events:none}.ck-widget.raw-html-embed .raw-html-embed__preview-content{background-color:var(--ck-color-base-foreground);box-sizing:border-box}.ck-widget.raw-html-embed .raw-html-embed__preview-content>*{margin-left:auto;margin-right:auto}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{color:var(--ck-html-embed-source-disabled-color)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-html-embed/theme/htmlembed.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-html-embed/htmlembed.css"],
          names: [],
          mappings: "AAMA,0BAMC,iBAAkB,CAOlB,iBAAkB,CATlB,gBAAkB,CAMlB,cAAe,CALf,iBAwDD,CA5CC,iCACC,iBAAkB,CAGlB,SACD,CAKA,2DAEC,YAAa,CACb,qBAAsB,CAFtB,iBAGD,CAEA,mDAGC,YAAa,CADb,eAAgB,CADhB,iBAGD,CAEA,2DAOC,uBAAyB,CACzB,kBAAmB,CAFnB,aAAc,CAHd,WAAY,CADZ,iBAAkB,CADlB,UAQD,CAEA,+DAQC,kBAAmB,CAHnB,QAAS,CAET,YAAa,CAEb,sBAAuB,CAPvB,MAAO,CADP,iBAAkB,CAGlB,OAAQ,CADR,KAOD,CC7DD,MACC,kEAAqE,CACrE,kCAAmC,CACnC,2CAA4C,CAC5C,yFAA0F,CAE1F,0EAA2E,CAC3E,6CACD,CAGA,0BAEC,gDAAiD,CADjD,kCA0ID,CAvIC,+DACC,iGACD,CAGA,mCACC,eACD,CAEA,mCACC,gBACD,CAIA,iCAIC,eAA4B,CAG5B,iEAAkE,CAClE,qCAAsC,CAPtC,mCAAoC,CASpC,+BAAgC,CADhC,kCAAmC,CANnC,+BAAgC,CAGhC,kIAAmI,CAJnI,yDAA4D,CAG5D,0GAMD,CAEA,0CACC,SAAU,CACV,gCACD,CAGA,iIACC,gBACD,CAxCD,uFA4CE,sDAAuD,CADvD,KAgGF,CA3IA,6FAkDE,uCAAwC,CADxC,sDAAuD,CADvD,KA2FF,CA3IA,wFAuDE,sDAAuD,CADvD,KAqFF,CA/EC,2DACC,kCACD,CAGA,2DAEC,gCAAiC,CADjC,8BAcD,CAXC,kGACC,iCACD,CAEA,oGACC,mCACD,CAEA,wFACC,kCACD,CAGD,oEACC,+BAAgC,CAChC,UACD,CAGA,kDACC,qBAAsB,CActB,aAAc,CAPd,qBAAsB,CAGtB,kCAAmC,CATnC,yCAA0C,CAG1C,WAAY,CACZ,kCAAmC,CAFnC,WAAY,CAKZ,UAAW,CAKX,eAAgB,CAJhB,oBAAqB,CAPrB,wCAsBD,CARC,4DACC,0DAA2D,CAC3D,gDAAiD,CAGjD,kEAAmE,CACnE,SACD,CAID,mDACC,kDAAmD,CACnD,wCAMD,CARA,2FAME,mBAEF,CAEA,2DAEC,gDAAiD,CADjD,qBAOD,CAJC,6DACC,gBAAiB,CACjB,iBACD,CAGD,+DACC,gDACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\t/* Give the embed some air. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tposition: relative;\n\tdisplay: flow-root;\n\n\t/* Give the html embed some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (https://github.com/ckeditor/ckeditor5/issues/8331) */\n\tmin-width: 15em;\n\n\t/* Don\'t inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* ----- Emebed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tposition: absolute;\n\n\t\t/* Make sure the content does not cover the label. */\n\t\tz-index: 1;\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t& .raw-html-embed__preview {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tmargin: auto;\n\n\t\t/* Gives spacing to the small renderable elements, so they always cover the placeholder. */\n\t\tdisplay: table;\n\t\tborder-collapse: separate;\n\t\tborder-spacing: 7px;\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-embed-content-width: calc(100% - 1.5 * var(--ck-icon-size));\n\t--ck-html-embed-source-height: 10em;\n\t--ck-html-embed-unfocused-outline-width: 1px;\n\t--ck-html-embed-content-min-height: calc(var(--ck-icon-size) + var(--ck-spacing-standard));\n\n\t--ck-html-embed-source-disabled-background: var(--ck-color-base-foreground);\n\t--ck-html-embed-source-disabled-color: hsl(0deg 0% 45%);\n}\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t/* HTML embed widget itself should respect UI language direction */\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* ----- Embed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tcontent: attr(data-html-embed-label);\n\t\ttop: calc(-1 * var(--ck-html-embed-unfocused-outline-width));\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t&[dir="rtl"]::before {\n\t\tleft: auto;\n\t\tright: var(--ck-spacing-standard);\n\t}\n\n\t/* Make space for label but it only collides in LTR languages */\n\t&[dir="ltr"] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t@nest .ck.ck-editor__editable.ck-blurred &.ck-widget_selected::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t@nest .ck.ck-editor__editable:not(.ck-blurred) &.ck-widget_selected::before {\n\t\ttop: 0;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t\tbackground: var(--ck-color-focus-border);\n\t}\n\n\t@nest .ck.ck-editor__editable &:not(.ck-widget_selected):hover::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t& .raw-html-embed__content-wrapper {\n\t\tpadding: var(--ck-spacing-standard);\n\t}\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\ttop: var(--ck-spacing-standard);\n\t\tright: var(--ck-spacing-standard);\n\n\t\t& .ck-button.raw-html-embed__save-button {\n\t\t\tcolor: var(--ck-color-button-save);\n\t\t}\n\n\t\t& .ck-button.raw-html-embed__cancel-button {\n\t\t\tcolor: var(--ck-color-button-cancel);\n\t\t}\n\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-top: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&[dir="rtl"] .raw-html-embed__buttons-wrapper {\n\t\tleft: var(--ck-spacing-standard);\n\t\tright: auto;\n\t}\n\n\t/* The edit source element. */\n\t& .raw-html-embed__source {\n\t\tbox-sizing: border-box;\n\t\theight: var(--ck-html-embed-source-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\t\tresize: none;\n\t\tmin-width: 0;\n\t\tpadding: var(--ck-spacing-standard);\n\n\t\tfont-family: monospace;\n\t\ttab-size: 4;\n\t\twhite-space: pre-wrap;\n\t\tfont-size: var(--ck-font-size-base); /* Safari needs this. */\n\n\t\t/* HTML code is direction–agnostic. */\n\t\ttext-align: left;\n\t\tdirection: ltr;\n\n\t\t&[disabled] {\n\t\t\tbackground: var(--ck-html-embed-source-disabled-background);\n\t\t\tcolor: var(--ck-html-embed-source-disabled-color);\n\n\t\t\t/* Safari needs this for the proper text color in disabled input (https://github.com/ckeditor/ckeditor5/issues/8320). */\n\t\t\t-webkit-text-fill-color: var(--ck-html-embed-source-disabled-color);\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* The preview data container. */\n\t& .raw-html-embed__preview {\n\t\tmin-height: var(--ck-html-embed-content-min-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\n\t\t/* Disable all mouse interaction as long as the editor is not read–only. */\n\t\t@nest .ck-editor__editable:not(.ck-read-only) & {\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\tbox-sizing: border-box;\n\t\tbackground-color: var(--ck-color-base-foreground);\n\n\t\t& > * {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tcolor: var(--ck-html-embed-source-disabled-color)\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8641(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-html-object-embed-unfocused-outline-width:1px}.ck-widget.html-object-embed{background-color:var(--ck-color-base-foreground);font-size:var(--ck-font-size-base);min-width:calc(76px + var(--ck-spacing-standard));padding:var(--ck-spacing-small);padding-top:calc(var(--ck-font-size-tiny) + var(--ck-spacing-large))}.ck-widget.html-object-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.html-object-embed:before{background:#999;border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);content:attr(data-html-object-embed-label);font-family:var(--ck-font-face);font-size:var(--ck-font-size-tiny);font-style:normal;font-weight:400;left:var(--ck-spacing-standard);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);position:absolute;top:0;transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck-widget.html-object-embed .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck-widget.html-object-embed .html-object-embed__content{pointer-events:none}div.ck-widget.html-object-embed{margin:1em auto}span.ck-widget.html-object-embed{display:inline-block}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-html-support/theme/datafilter.css"],
          names: [],
          mappings: "AAKA,MACC,kDACD,CAEA,6BAEC,gDAAiD,CADjD,kCAAmC,CAKnC,iDAAkD,CAHlD,+BAAgC,CAEhC,oEAgCD,CA7BC,kEACC,wGACD,CAEA,oCAOC,eAA4B,CAG5B,iEAAkE,CAClE,qCAAsC,CAPtC,0CAA2C,CAS3C,+BAAgC,CADhC,kCAAmC,CAVnC,iBAAkB,CADlB,eAAmB,CAKnB,+BAAgC,CAGhC,yIAA0I,CAN1I,iBAAkB,CAElB,KAAM,CAGN,0GAMD,CAGA,2HACC,gBACD,CAEA,yDAEC,mBACD,CAGD,gCACC,eACD,CAEA,iCACC,oBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-object-embed-unfocused-outline-width: 1px;\n}\n\n.ck-widget.html-object-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\tpadding: var(--ck-spacing-small);\n\t/* Leave space for label */\n\tpadding-top: calc(var(--ck-font-size-tiny) + var(--ck-spacing-large));\n\tmin-width: calc(76px + var(--ck-spacing-standard));\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t&::before {\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tposition: absolute;\n\t\tcontent: attr(data-html-object-embed-label);\n\t\ttop: 0;\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t/* Make space for label. */\n\t& .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t& .html-object-embed__content {\n\t\t/* Disable user interaction with embed content */\n\t\tpointer-events: none;\n\t}\n}\n\ndiv.ck-widget.html-object-embed {\n\tmargin: 1em auto;\n}\n\nspan.ck-widget.html-object-embed {\n\tdisplay: inline-block;\n}\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8574(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;height:auto;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image{z-index:1}.ck.ck-editor__editable .image.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable .image-inline img{height:auto}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css"],
          names: [],
          mappings: "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBA2BD,CAjBC,uBAEC,aAAc,CAad,WAAY,CAVZ,aAAc,CAGd,cAAe,CAGf,cAKD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAKA,+BACC,SASD,CAHC,kDACC,SACD,CAMD,sCACC,SAkBD,CAZC,yDACC,SAUD,CAHC,qEACC,YACD,CAMF,0CACC,WACD,CAMC,0FACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%;\n\n\t\t\t/* Keep proportions of the block image if the height is set and the image is wider than the editor width.\n\t\t\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\t\t}\n\t}\n\n\t/*\n\t * See https://github.com/ckeditor/ckeditor5/issues/15115.\n\t */\n\t& .image-inline {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the selected inline image always stays on top of its siblings.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t\t */\n\t\t&.ck-widget_selected {\n\t\t\tz-index: 2;\n\n\t\t\t/*\n\t\t\t * Make sure the native browser selection style is not displayed.\n\t\t\t * Inline image widgets have their own styles for the selected state and\n\t\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t\t */\n\t\t\t& ::selection {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Keep proportions of the inline image if the height is set and the image is wider than the editor width.\n\tSee https://github.com/ckeditor/ckeditor5/issues/14542. */\n\t& .image-inline img {\n\t\theight: auto;\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3038(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highlighted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}@media (forced-colors:active){.ck-content .image>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:none}}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highlighted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,oDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAYD,CAJC,8BAXD,8BAYE,sBAAuB,CACvB,WAEF,CADC,CCdA,4BACC,qEDmBA,iDCjBA,CACD,CDmBA,uCALD,qEAME,cAEF,CADC,CAGD,sCACC,GACC,qEACD,CAEA,GACC,yDACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@media (forced-colors: active) {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\t@mixin ck-media-default-colors {\n\t\tanimation: ck-image-caption-highlight .6s ease-out;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation: none;\n\t}\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1173(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-image-custom-resize-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{display:inline-block}.ck.ck-image-custom-resize-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-image-custom-resize-form{flex-wrap:wrap}.ck.ck-image-custom-resize-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-image-custom-resize-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecustomresizeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,gCAIC,sBAAuB,CAHvB,YAAa,CACb,kBAAmB,CACnB,gBAsBD,CAnBC,uDACC,oBACD,CAEA,0CACC,YACD,CCbA,oCDCD,gCAeE,cAUF,CARE,uDACC,eACD,CAEA,2CACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-image-custom-resize-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: flex-start;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1545(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-image-insert-url .ck-image-insert-url__action-row{display:grid;grid-template-columns:repeat(2,1fr)}:root{--ck-image-insert-insert-by-url-width:250px}.ck.ck-image-insert-url{--ck-input-width:100%}.ck.ck-image-insert-url .ck-image-insert-url__action-row{grid-column-gap:var(--ck-spacing-large);margin-top:var(--ck-spacing-large)}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-cancel,.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-save{justify-content:center;min-width:auto}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}.ck.ck-image-insert-form>.ck.ck-button{display:block;padding:var(--ck-list-button-padding);width:100%}[dir=ltr] .ck.ck-image-insert-form>.ck.ck-button{text-align:left}[dir=rtl] .ck.ck-image-insert-form>.ck.ck-button{text-align:right}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:first-child){border-top:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:last-child){border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible,.ck.ck-image-insert-form>.ck.ck-image-insert-url{min-width:var(--ck-image-insert-insert-by-url-width)}.ck.ck-image-insert-form>.ck.ck-image-insert-url{padding:var(--ck-spacing-large)}.ck.ck-image-insert-form:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageinsert.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageinsert.css"],
          names: [],
          mappings: "AAMC,yDACC,YAAa,CACb,mCACD,CCFD,MACC,2CACD,CAEA,wBACC,qBAgBD,CAdC,yDACC,uCAAwC,CACxC,kCAWD,CATC,oJAEC,sBAAuB,CACvB,cACD,CAEA,sFACC,0BACD,CAKD,uCACC,aAAc,CAEd,qCAAsC,CADtC,UAUD,CAZA,iDAME,eAMF,CAZA,iDAUE,gBAEF,CAGC,8DACC,gDACD,CAEA,6DACC,mDACD,CAMD,6FAJC,oDAOD,CAHA,iDAEC,+BACD,CAEA,+BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert-url {\n\t& .ck-image-insert-url__action-row {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-image-insert-insert-by-url-width: 250px;\n}\n\n.ck.ck-image-insert-url {\n\t--ck-input-width: 100%;\n\n\t& .ck-image-insert-url__action-row {\n\t\tgrid-column-gap: var(--ck-spacing-large);\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n\n.ck.ck-image-insert-form {\n\t& > .ck.ck-button {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& > .ck.ck-collapsible {\n\t\t&:not(:first-child) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t&:not(:last-child) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t}\n\n\t/* This is the case when there are no other integrations configured than insert by URL */\n\t& > .ck.ck-image-insert-url {\n\t\tmin-width: var(--ck-image-insert-insert-by-url-width);\n\t\tpadding: var(--ck-spacing-large);\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1091(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor__editable img.image_placeholder{background-size:100% 100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageplaceholder.css"],
          names: [],
          mappings: "AAMC,8CACC,yBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& img.image_placeholder {\n\t\tbackground-size: 100% 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4214(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content img.image_resized{height:auto}.ck-content .image.image_resized{box-sizing:border-box;display:block;max-width:100%}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}.ck.ck-editor__editable td .image-inline.image_resized img,.ck.ck-editor__editable th .image-inline.image_resized img{max-width:100%}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageresize.css"],
          names: [],
          mappings: "AAMA,8BACC,WACD,CAEA,iCAQC,qBAAsB,CADtB,aAAc,CANd,cAkBD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAQC,sHACC,cACD,CAIF,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Preserve aspect ratio of the resized image after introducing image height attribute. */\n.ck-content img.image_resized {\n\theight: auto;\n}\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/* The resized inline image nested in the table should respect its parent size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline.image_resized img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7879(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"],
          names: [],
          mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1230(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@media (prefers-reduced-motion:reduce){.ck-image-upload-complete-icon{animation-duration:0ms}.ck-image-upload-complete-icon:after{animation:none;height:.45em;opacity:1;width:.3em}}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
          names: [],
          mappings: "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFAqCD,CAjCC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAEA,uCA7CD,+BA8CE,sBASF,CAPE,qCACC,cAAe,CAGf,YAAc,CAFd,SAAU,CACV,UAED,CACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 0ms;\n\n\t\t&::after {\n\t\t\tanimation: none;\n\t\t\topacity: 1;\n\t\t\twidth: 0.3em;\n\t\t\theight: 0.45em;\n\t\t}\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1160(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid #0000;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
          names: [],
          mappings: "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,4BAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7504(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}@media (prefers-reduced-motion:reduce){.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:none;opacity:1}}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
          names: [],
          mappings: "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBAMD,CAJC,uCAHD,yFAKE,cAAe,CADf,SAGF,CADC,CAKF,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\topacity: 1;\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8429(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7456(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid #ffffff80}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
          names: [],
          mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,2BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8040(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
          names: [],
          mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2350(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-link-form{align-items:flex-start;display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
          names: [],
          mappings: "AAOA,iBAEC,sBAAuB,CADvB,YAkBD,CAfC,2BACC,YACD,CCPA,oCDCD,iBASE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CChBD,CDwBD,iCACC,aAYD,CALE,wHAEC,mCACD,CEhCF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3669(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:#0006;background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzUuNzUgMCAwIDEtLjIxNy4yMDYgNS4yNTEgNS4yNTEgMCAwIDEtOC41MDMtNS45NTUuNy43IDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NHptNS40OTQtNS4zMzVhLjc1Ljc1IDAgMCAxLS4xMi4yNzRsLTEuMTQ3IDEuNjM5YS43NS43NSAwIDEgMS0xLjIyOC0uODZsLjg2LTEuMjNhMy43NSAzLjc1IDAgMCAwLTYuMTQ0LTQuMzAxbC0uODYgMS4yMjlhLjc1Ljc1IDAgMCAxLTEuMjI5LS44NmwxLjE0OC0xLjY0YS43NS43NSAwIDAgMSAuMjE3LS4yMDYgNS4yNTEgNS4yNTEgMCAwIDEgOC41MDMgNS45NTVtLTQuNTYzLTIuNTMyYS43NS43NSAwIDAgMSAuMTg0IDEuMDQ1bC0zLjE1NSA0LjUwNWEuNzUuNzUgMCAxIDEtMS4yMjktLjg2bDMuMTU1LTQuNTA2YS43NS43NSAwIDAgMSAxLjA0NS0uMTg0Ii8+PC9zdmc+");background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkimage.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css"],
          names: [],
          mappings: "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,sBAAqC,CACrC,k2BAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Match the icon size with the upload indicator brought by the image upload feature. */\n\t--ck-link-image-indicator-icon-size: 20;\n\t--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tcontent: "";\n\n\t\t\t/*\n\t\t\t * Smaller images should have the icon closer to the border.\n\t\t\t * Match the icon position with the upload indicator brought by the image upload feature.\n\t\t\t */\n\t\t\ttop: min(var(--ck-spacing-medium), 6%);\n\t\t\tright: min(var(--ck-spacing-medium), 6%);\n\n\t\t\tbackground-color: hsla(0, 0%, 0%, .4);\n\t\t\tbackground-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n\t\t\tbackground-size: 14px;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius: 100%;\n\n\t\t\t/*\n\t\t\t* Use CSS math to simulate container queries.\n\t\t\t* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t\t\t*/\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t\theight: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7875(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-editor__editable .ck-list-bogus-paragraph{display:block}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/documentlist.css"],
          names: [],
          mappings: "AAKA,8CACC,aACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-editor__editable .ck-list-bogus-paragraph {\n\tdisplay: block;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      532(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/list.css"],
          names: [],
          mappings: "AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n\tlist-style-type: decimal;\n\n\t& ol {\n\t\tlist-style-type: lower-latin;\n\n\t\t& ol {\n\t\t\tlist-style-type: lower-roman;\n\n\t\t\t& ol {\n\t\t\t\tlist-style-type: upper-latin;\n\n\t\t\t\t& ol {\n\t\t\t\t\tlist-style-type: upper-roman;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-content ul {\n\tlist-style-type: disc;\n\n\t& ul {\n\t\tlist-style-type: circle;\n\n\t\t& ul {\n\t\t\tlist-style-type: square;\n\n\t\t\t& ul {\n\t\t\t\tlist-style-type: square;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1911(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-list-properties.ck-list-properties_without-styles{padding:var(--ck-spacing-large)}.ck.ck-list-properties.ck-list-properties_without-styles>*{min-width:14em}.ck.ck-list-properties.ck-list-properties_without-styles>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-list-styles-list{grid-template-columns:repeat(4,auto)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible{border-top:1px solid var(--ck-color-base-border)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*{width:100%}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties .ck.ck-numbered-list-properties__start-index .ck-input{min-width:auto;width:100%}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order{background:#0000;margin-bottom:calc(var(--ck-spacing-tiny)*-1);padding-left:0;padding-right:0}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:active,.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:hover{background:none;border-color:#0000;box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/listproperties.css"],
          names: [],
          mappings: "AAOC,yDACC,+BASD,CAPC,2DACC,cAKD,CAHC,6DACC,qCACD,CASD,wFACC,oCACD,CAGA,mFACC,gDAWD,CARE,+GACC,UAKD,CAHC,iHACC,qCACD,CAMJ,8EACC,cAAe,CACf,UACD,CAEA,uEACC,gBAAuB,CAGvB,6CAAgD,CAFhD,cAAe,CACf,eAQD,CALC,2JAGC,eAAgB,CADhB,kBAAyB,CADzB,eAGD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-properties {\n\t/* When there are no list styles and there is no collapsible. */\n\t&.ck-list-properties_without-styles {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * {\n\t\t\tmin-width: 14em;\n\n\t\t\t& + * {\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * When the numbered list property fields (start at, reversed) should be displayed,\n\t * more horizontal space is needed. Reconfigure the style grid to create that space.\n\t */\n\t&.ck-list-properties_with-numbered-properties {\n\t\t& > .ck-list-styles-list {\n\t\t\tgrid-template-columns: repeat( 4, auto );\n\t\t}\n\n\t\t/* When list styles are rendered and property fields are in a collapsible. */\n\t\t& > .ck-collapsible {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t& > .ck-collapsible__children {\n\t\t\t\t& > * {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t& + * {\n\t\t\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-numbered-list-properties__start-index .ck-input {\n\t\tmin-width: auto;\n\t\twidth: 100%;\n\t}\n\n\t& .ck.ck-numbered-list-properties__reversed-order {\n\t\tbackground: transparent;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-bottom: calc(-1 * var(--ck-spacing-tiny));\n\n\t\t&:active, &:hover {\n\t\t\tbox-shadow: none;\n\t\t\tborder-color: transparent;\n\t\t\tbackground: none;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1330(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-list-styles-list{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-list{column-gap:var(--ck-spacing-medium);grid-template-columns:repeat(3,auto);padding:var(--ck-spacing-large);row-gap:var(--ck-spacing-medium)}.ck.ck-list-styles-list .ck-button{box-sizing:initial;margin:0;padding:0}.ck.ck-list-styles-list .ck-button,.ck.ck-list-styles-list .ck-button .ck-icon{height:var(--ck-list-style-button-size);width:var(--ck-list-style-button-size)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/liststyles.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/liststyles.css"],
          names: [],
          mappings: "AAKA,wBACC,YACD,CCFA,MACC,gCACD,CAEA,wBAGC,mCAAoC,CAFpC,oCAAwC,CAGxC,+BAAgC,CAFhC,gCA4BD,CAxBC,mCAiBC,kBAAuB,CAPvB,QAAS,CANT,SAmBD,CAJC,+EAhBA,uCAAwC,CADxC,sCAoBA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-styles-list {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-list-style-button-size: 44px;\n}\n\n.ck.ck-list-styles-list {\n\tgrid-template-columns: repeat( 3, auto );\n\trow-gap: var(--ck-spacing-medium);\n\tcolumn-gap: var(--ck-spacing-medium);\n\tpadding: var(--ck-spacing-large);\n\n\t& .ck-button {\n\t\t/* Make the button look like a thumbnail (the icon "takes it all"). */\n\t\twidth: var(--ck-list-style-button-size);\n\t\theight: var(--ck-list-style-button-size);\n\t\tpadding: 0;\n\n\t\t/*\n\t\t * Buttons are aligned by the grid so disable default button margins to not collide with the\n\t\t * gaps in the grid.\n\t\t */\n\t\tmargin: 0;\n\n\t\t/*\n\t\t * Make sure the button border (which is displayed on focus, BTW) does not steal pixels\n\t\t * from the button dimensions and, as a result, decrease the size of the icon\n\t\t * (which becomes blurry as it scales down).\n\t\t */\n\t\tbox-sizing: content-box;\n\n\t\t& .ck-icon {\n\t\t\twidth: var(--ck-list-style-button-size);\n\t\t\theight: var(--ck-list-style-button-size);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5484(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ':root{--ck-todo-list-checkmark-size:16px}.ck-content .todo-list{list-style:none}.ck-content .todo-list li{margin-bottom:5px;position:relative}.ck-content .todo-list li .todo-list{margin-top:5px}.ck-content .todo-list .todo-list__label>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-content[dir=rtl] .todo-list .todo-list__label>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-content .todo-list .todo-list__label>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-content .todo-list .todo-list__label>input:before{transition:none}}.ck-content .todo-list .todo-list__label>input:after{border-color:#0000;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:initial;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-content .todo-list .todo-list__label>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-content .todo-list .todo-list__label>input[checked]:after{border-color:#fff}.ck-content .todo-list .todo-list__label .todo-list__label__description{vertical-align:middle}.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}.ck-editor__editable.ck-content .todo-list .todo-list__label>input,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{cursor:pointer}.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover:before,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover:before{box-shadow:0 0 0 5px #0000001a}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}@media (prefers-reduced-motion:reduce){.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{transition:none}}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:after{border-color:#0000;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:initial;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:after{border-color:#fff}.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-list/theme/todolist.css"],
          names: [],
          mappings: "AAKA,MACC,kCACD,CA4EA,uBACC,eAwBD,CAtBC,0BAEC,iBAAkB,CADlB,iBAMD,CAHC,qCACC,cACD,CAIA,+CAtFD,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAqFC,CAFA,wDApEA,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAoEA,CAhED,sDAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sDAYE,eAEF,CADC,CAGD,qDAaC,kBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,kBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+DACC,kBAA8B,CAC9B,oBACD,CAEA,8DACC,iBACD,CAwBA,wEACC,qBACD,CAEA,mGACC,iBACD,CAYD,kKAEC,cAKD,CAHC,4LACC,8BACD,CAMD,+FAxHA,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAuHA,CAFA,wGAtGC,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAsGD,CAlGA,sGAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UASD,CAHC,uCAXD,sGAYE,eAEF,CADC,CAGD,qGAaC,kBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,kBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+GACC,kBAA8B,CAC9B,oBACD,CAEA,8GACC,iBACD,CA2DA,uHACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-todo-list-checkmark-size: 16px;\n}\n\n@define-mixin todo-list-checkbox {\n\t-webkit-appearance: none;\n\tdisplay: inline-block;\n\tposition: relative;\n\twidth: var(--ck-todo-list-checkmark-size);\n\theight: var(--ck-todo-list-checkmark-size);\n\tvertical-align: middle;\n\n\t/* Needed on iOS */\n\tborder: 0;\n\n\t/* LTR styles */\n\tleft: -25px;\n\tmargin-right: -15px;\n\tright: 0;\n\tmargin-left: 0;\n\n\t/* RTL styles */\n\t@nest [dir=rtl]& {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t&::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\t}\n\n\t&::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\n\t\t/* Calculate tick position, size and border-width proportional to the checkmark size. */\n\t\tleft: calc( var(--ck-todo-list-checkmark-size) / 3 );\n\t\ttop: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\twidth: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\theight: calc( var(--ck-todo-list-checkmark-size) / 2.6 );\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&[checked] {\n\t\t&::before {\n\t\t\tbackground: hsl(126, 64%, 41%);\n\t\t\tborder-color: hsl(126, 64%, 41%);\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: hsl(0, 0%, 100%);\n\t\t}\n\t}\n}\n\n/*\n * To-do list content styles.\n */\n.ck-content .todo-list {\n\tlist-style: none;\n\n\t& li {\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\n\t\t& .todo-list {\n\t\t\tmargin-top: 5px;\n\t\t}\n\t}\n\n\t& .todo-list__label {\n\t\t& > input {\n\t\t\t@mixin todo-list-checkbox;\n\t\t}\n\n\t\t& .todo-list__label__description {\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t&.todo-list__label_without-description input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n/*\n * To-do list editing view styles.\n */\n.ck-editor__editable.ck-content .todo-list .todo-list__label {\n\t/*\n\t * To-do list should be interactive only during the editing\n\t * (https://github.com/ckeditor/ckeditor5/issues/2090).\n\t */\n\t& > input,\n\t& > span[contenteditable=false] > input {\n\t\tcursor: pointer;\n\n\t\t&:hover::before {\n\t\t\tbox-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n\t\t}\n\t}\n\n\t/*\n\t * Document Lists - editing view has an additional span around checkbox.\n\t */\n\t& > span[contenteditable=false] > input {\n\t\t@mixin todo-list-checkbox;\n\t}\n\n\t&.todo-list__label_without-description {\n\t\t& input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3155(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],
          names: [],
          mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5767(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDI0IiBoZWlnaHQ9IjEwMjQiPjxwYXRoIGZpbGw9IiNGRkZGRkUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTk2Ny40ODQgMEg1Ni41MTdDMjUuMzA0IDAgMCAyNS4zMDQgMCA1Ni41MTd2OTEwLjk2NkMwIDk5OC42OTQgMjUuMjk3IDEwMjQgNTYuNTIyIDEwMjRINTQ3VjYyOEg0MTRWNDczaDEzM1YzNTkuMDI5YzAtMTMyLjI2MiA4MC43NzMtMjA0LjI4MiAxOTguNzU2LTIwNC4yODIgNTYuNTEzIDAgMTA1LjA4NiA0LjIwOCAxMTkuMjQ0IDYuMDg5VjI5OWwtODEuNjE2LjAzN2MtNjMuOTkzIDAtNzYuMzg0IDMwLjQ5Mi03Ni4zODQgNzUuMjM2VjQ3M2gxNTMuNDg3bC0xOS45ODYgMTU1SDcwN3YzOTZoMjYwLjQ4NGMzMS4yMTMgMCA1Ni41MTYtMjUuMzAzIDU2LjUxNi01Ni41MTZWNTYuNTE1QzEwMjQgMjUuMzAzIDk5OC42OTcgMCA5NjcuNDg0IDAiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwME0xNjMuNCAzMDUuNWM4OC43IDAgMTM3LjItNzMuNSAxMzcuMi0xMzcuMiAwLTIuMSAwLTQuMi0uMS02LjIgOS40LTYuOCAxNy42LTE1LjMgMjQuMS0yNS04LjYgMy44LTE3LjkgNi40LTI3LjcgNy42IDEwLTYgMTcuNi0xNS40IDIxLjItMjYuNy05LjMgNS41LTE5LjYgOS41LTMwLjYgMTEuNy04LjgtOS40LTIxLjMtMTUuMi0zNS4yLTE1LjItMjYuNiAwLTQ4LjIgMjEuNi00OC4yIDQ4LjIgMCAzLjguNCA3LjUgMS4zIDExLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40LTQuMSA3LjEtNi41IDE1LjQtNi41IDI0LjIgMCAxNi43IDguNSAzMS41IDIxLjUgNDAuMS03LjktLjItMTUuMy0yLjQtMjEuOC02di42YzAgMjMuNCAxNi42IDQyLjggMzguNyA0Ny4zLTQgMS4xLTguMyAxLjctMTIuNyAxLjctMy4xIDAtNi4xLS4zLTkuMS0uOSA2LjEgMTkuMiAyMy45IDMzLjEgNDUgMzMuNS0xNi41IDEyLjktMzcuMyAyMC42LTU5LjkgMjAuNi0zLjkgMC03LjctLjItMTEuNS0uNyAyMS4xIDEzLjggNDYuNSAyMS44IDczLjcgMjEuOCIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
          names: [],
          mappings: "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,goGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,o+GACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,g/BACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6004(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1478(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-mention-background:#9900301a;--ck-color-mention-text:#990030}.ck-content .mention{background:var(--ck-color-mention-background);color:var(--ck-color-mention-text)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-mention/mention.css"],
          names: [],
          mappings: "AAKA,MACC,uCAAwD,CACxD,+BACD,CAEA,qBACC,6CAA8C,CAC9C,kCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-mention-background: hsla(341, 100%, 30%, 0.1);\n\t--ck-color-mention-text: hsl(341, 100%, 30%);\n}\n\n.ck-content .mention {\n\tbackground: var(--ck-color-mention-background);\n\tcolor: var(--ck-color-mention-text);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7216(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-mention-list-max-height:300px}.ck.ck-mentions{max-height:var(--ck-mention-list-max-height);overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain}.ck.ck-mentions>.ck-list__item{flex-shrink:0;overflow:hidden}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-mention/theme/mentionui.css"],
          names: [],
          mappings: "AAKA,MACC,kCACD,CAEA,gBACC,4CAA6C,CAM7C,iBAAkB,CAJlB,eAAgB,CAMhB,2BAQD,CAJC,+BAEC,aAAc,CADd,eAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-mention-list-max-height: 300px;\n}\n\n.ck.ck-mentions {\n\tmax-height: var(--ck-mention-list-max-height);\n\n\toverflow-y: auto;\n\n\t/* Prevent unnecessary horizontal scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\toverflow-x: hidden;\n\n\toverscroll-behavior: contain;\n\n\t/* Prevent unnecessary vertical scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\t& > .ck-list__item {\n\t\toverflow: hidden;\n\t\tflex-shrink: 0;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5079(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck-content .page-break{align-items:center;clear:both;display:flex;justify-content:center;padding:5px 0;position:relative}.ck-content .page-break:after{border-bottom:2px dashed #c4c4c4;content:"";position:absolute;width:100%}.ck-content .page-break__label{background:#fff;border:1px solid #c4c4c4;border-radius:2px;box-shadow:2px 2px 1px #00000026;color:#333;display:block;font-family:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;font-size:.75em;font-weight:700;padding:.3em .6em;position:relative;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1}@media print{.ck-content .page-break{padding:0}.ck-content .page-break:after{display:none}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-page-break/theme/pagebreak.css"],
          names: [],
          mappings: "AAKA,wBAKC,kBAAmB,CAHnB,UAAW,CAEX,YAAa,CAEb,sBAAuB,CAHvB,aAAc,CAFd,iBAaD,CANC,8BAGC,gCAAyC,CAFzC,UAAW,CACX,iBAAkB,CAElB,UACD,CAGD,+BAYC,eAA4B,CAN5B,wBAAiC,CACjC,iBAAkB,CAMlB,gCAA6C,CAF7C,UAAsB,CAPtB,aAAc,CAId,qDAA0D,CAC1D,eAAiB,CACjB,eAAiB,CAPjB,iBAAkB,CAFlB,iBAAkB,CAIlB,wBAAyB,CAWzB,wBAAyB,CACzB,qBAAsB,CACtB,oBAAqB,CACrB,gBAAiB,CAjBjB,SAkBD,CAGA,aACC,wBACC,SAKD,CAHC,8BACC,YACD,CAEF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .page-break {\n\tposition: relative;\n\tclear: both;\n\tpadding: 5px 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tborder-bottom: 2px dashed hsl(0, 0%, 77%);\n\t\twidth: 100%;\n\t}\n}\n\n.ck-content .page-break__label {\n\tposition: relative;\n\tz-index: 1;\n\tpadding: .3em .6em;\n\tdisplay: block;\n\ttext-transform: uppercase;\n\tborder: 1px solid hsl(0, 0%, 77%);\n\tborder-radius: 2px;\n\tfont-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\tfont-size: 0.75em;\n\tfont-weight: bold;\n\tcolor: hsl(0, 0%, 20%);\n\tbackground: hsl(0, 0%, 100%);\n\tbox-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);\n\n\t/* Disable the possibility to select the label text by the user. */\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n/* Do not show the page break element inside the print preview window. */\n@media print {\n\t.ck-content .page-break {\n\t\tpadding: 0;\n\n\t\t&::after {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4975(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-show-blocks-border-color:#757575}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) address{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ADDRESS</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ADDRESS</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) address:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) address{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ADDRESS</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) address{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ADDRESS</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) aside{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ASIDE</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ASIDE</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) aside:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) aside{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ASIDE</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) aside{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>ASIDE</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) blockquote{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>BLOCKQUOTE</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>BLOCKQUOTE</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) blockquote:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) blockquote{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>BLOCKQUOTE</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) blockquote{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>BLOCKQUOTE</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) details{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DETAILS</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DETAILS</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) details:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) details{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DETAILS</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) details{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DETAILS</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) div:not(.ck-widget,.ck-widget *){background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DIV</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DIV</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) div:not(.ck-widget,.ck-widget *):not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) div:not(.ck-widget,.ck-widget *){background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DIV</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) div:not(.ck-widget,.ck-widget *){background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>DIV</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) footer{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FOOTER</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FOOTER</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) footer:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) footer{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FOOTER</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) footer{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FOOTER</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h1{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H1</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H1</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h1:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h1{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H1</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h1{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H1</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h2{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H2</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H2</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h2:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h2{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H2</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h2{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H2</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h3{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H3</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H3</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h3:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h3{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H3</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h3{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H3</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h4{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H4</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H4</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h4:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h4{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H4</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h4{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H4</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h5{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H5</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H5</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h5:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h5{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H5</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h5{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H5</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h6{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H6</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H6</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h6:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h6{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H6</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) h6{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>H6</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) header{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>HEADER</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>HEADER</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) header:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) header{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>HEADER</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) header{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>HEADER</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) main{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>MAIN</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>MAIN</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) main:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) main{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>MAIN</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) main{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>MAIN</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) nav{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>NAV</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>NAV</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) nav:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) nav{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>NAV</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) nav{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>NAV</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) pre{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>PRE</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>PRE</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) pre:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) pre{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>PRE</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) pre{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>PRE</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ol{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>OL</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>OL</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ol:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ol{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>OL</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ol{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>OL</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ul{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>UL</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>UL</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ul:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ul{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>UL</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) ul{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>UL</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) p{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>P</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>P</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) p:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) p{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>P</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) p{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>P</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) section{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>SECTION</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>SECTION</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) section:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) section{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>SECTION</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) section{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>SECTION</text></svg>\");background-position:calc(100% - 1px) 1px}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) :where(figure.image,figure.table) figcaption{background-repeat:no-repeat;padding-top:15px;[dir=ltr] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FIGCAPTION</text></svg>\");background-position:1px 1px}[dir=rtl] &{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FIGCAPTION</text></svg>\");background-position:calc(100% - 1px) 1px}}.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) :where(figure.image,figure.table) figcaption:not(.ck-widget_selected):not(.ck-widget:hover){outline:1px dashed var(--ck-show-blocks-border-color)}[dir=ltr] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) :where(figure.image,figure.table) figcaption{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FIGCAPTION</text></svg>\");background-position:1px 1px}[dir=rtl] .ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) :where(figure.image,figure.table) figcaption{background-image:url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>FIGCAPTION</text></svg>\");background-position:calc(100% - 1px) 1px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-show-blocks/theme/showblocks.css"],
          names: [],
          mappings: "AAOA,MACC,qCACD,CAsCC,0FAzBA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,qfAAsf,CACtf,2BAgBA,CACA,YAbA,wiBAAyiB,CACziB,wCAcA,CAiBA,CAfA,yIACC,qDACD,CAWA,oGAnCA,qfAAsf,CACtf,2BAoCA,CAFA,oGA9BA,wiBAAyiB,CACziB,wCA+BA,CAEA,wFA7BA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,mfAAsf,CACtf,2BAgBA,CACA,YAbA,siBAAyiB,CACziB,wCAcA,CAqBA,CAnBA,uIACC,qDACD,CAeA,kGAvCA,mfAAsf,CACtf,2BAwCA,CAFA,kGAlCA,siBAAyiB,CACziB,wCAmCA,CAEA,6FAjCA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,wfAAsf,CACtf,2BAgBA,CACA,YAbA,2iBAAyiB,CACziB,wCAcA,CAyBA,CAvBA,4IACC,qDACD,CAmBA,uGA3CA,wfAAsf,CACtf,2BA4CA,CAFA,uGAtCA,2iBAAyiB,CACziB,wCAuCA,CAEA,0FArCA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,qfAAsf,CACtf,2BAgBA,CACA,YAbA,wiBAAyiB,CACziB,wCAcA,CA6BA,CA3BA,yIACC,qDACD,CAuBA,oGA/CA,qfAAsf,CACtf,2BAgDA,CAFA,oGA1CA,wiBAAyiB,CACziB,wCA2CA,CAEA,mHAzCA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,ifAAsf,CACtf,2BAgBA,CACA,YAbA,oiBAAyiB,CACziB,wCAcA,CAiCA,CA/BA,kKACC,qDACD,CA2BA,6HAnDA,ifAAsf,CACtf,2BAoDA,CAFA,6HA9CA,oiBAAyiB,CACziB,wCA+CA,CAEA,yFA7CA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,ofAAsf,CACtf,2BAgBA,CACA,YAbA,uiBAAyiB,CACziB,wCAcA,CAqCA,CAnCA,wIACC,qDACD,CA+BA,mGAvDA,ofAAsf,CACtf,2BAwDA,CAFA,mGAlDA,uiBAAyiB,CACziB,wCAmDA,CAEA,qFAjDA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAyCA,CAvCA,oIACC,qDACD,CAmCA,+FA3DA,gfAAsf,CACtf,2BA4DA,CAFA,+FAtDA,miBAAyiB,CACziB,wCAuDA,CAEA,qFArDA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CA6CA,CA3CA,oIACC,qDACD,CAuCA,+FA/DA,gfAAsf,CACtf,2BAgEA,CAFA,+FA1DA,miBAAyiB,CACziB,wCA2DA,CAEA,qFAzDA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAiDA,CA/CA,oIACC,qDACD,CA2CA,+FAnEA,gfAAsf,CACtf,2BAoEA,CAFA,+FA9DA,miBAAyiB,CACziB,wCA+DA,CAEA,qFA7DA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAqDA,CAnDA,oIACC,qDACD,CA+CA,+FAvEA,gfAAsf,CACtf,2BAwEA,CAFA,+FAlEA,miBAAyiB,CACziB,wCAmEA,CAEA,qFAjEA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAyDA,CAvDA,oIACC,qDACD,CAmDA,+FA3EA,gfAAsf,CACtf,2BA4EA,CAFA,+FAtEA,miBAAyiB,CACziB,wCAuEA,CAEA,qFArEA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CA6DA,CA3DA,oIACC,qDACD,CAuDA,+FA/EA,gfAAsf,CACtf,2BAgFA,CAFA,+FA1EA,miBAAyiB,CACziB,wCA2EA,CAEA,yFAzEA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,ofAAsf,CACtf,2BAgBA,CACA,YAbA,uiBAAyiB,CACziB,wCAcA,CAiEA,CA/DA,wIACC,qDACD,CA2DA,mGAnFA,ofAAsf,CACtf,2BAoFA,CAFA,mGA9EA,uiBAAyiB,CACziB,wCA+EA,CAEA,uFA7EA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,kfAAsf,CACtf,2BAgBA,CACA,YAbA,qiBAAyiB,CACziB,wCAcA,CAqEA,CAnEA,sIACC,qDACD,CA+DA,iGAvFA,kfAAsf,CACtf,2BAwFA,CAFA,iGAlFA,qiBAAyiB,CACziB,wCAmFA,CAEA,sFAjFA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,ifAAsf,CACtf,2BAgBA,CACA,YAbA,oiBAAyiB,CACziB,wCAcA,CAyEA,CAvEA,qIACC,qDACD,CAmEA,gGA3FA,ifAAsf,CACtf,2BA4FA,CAFA,gGAtFA,oiBAAyiB,CACziB,wCAuFA,CAEA,sFArFA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,ifAAsf,CACtf,2BAgBA,CACA,YAbA,oiBAAyiB,CACziB,wCAcA,CA6EA,CA3EA,qIACC,qDACD,CAuEA,gGA/FA,ifAAsf,CACtf,2BAgGA,CAFA,gGA1FA,oiBAAyiB,CACziB,wCA2FA,CAEA,qFAzFA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAiFA,CA/EA,oIACC,qDACD,CA2EA,+FAnGA,gfAAsf,CACtf,2BAoGA,CAFA,+FA9FA,miBAAyiB,CACziB,wCA+FA,CAEA,qFA7FA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,gfAAsf,CACtf,2BAgBA,CACA,YAbA,miBAAyiB,CACziB,wCAcA,CAqFA,CAnFA,oIACC,qDACD,CA+EA,+FAvGA,gfAAsf,CACtf,2BAwGA,CAFA,+FAlGA,miBAAyiB,CACziB,wCAmGA,CAEA,oFAjGA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,+eAAsf,CACtf,2BAgBA,CACA,YAbA,kiBAAyiB,CACziB,wCAcA,CAyFA,CAvFA,mIACC,qDACD,CAmFA,8FA3GA,+eAAsf,CACtf,2BA4GA,CAFA,8FAtGA,kiBAAyiB,CACziB,wCAuGA,CAEA,0FArGA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,qfAAsf,CACtf,2BAgBA,CACA,YAbA,wiBAAyiB,CACziB,wCAcA,CA6FA,CA3FA,yIACC,qDACD,CAuFA,oGA/GA,qfAAsf,CACtf,2BAgHA,CAFA,oGA1GA,wiBAAyiB,CACziB,wCA2GA,CAEA,+HAzGA,2BAA4B,CAC5B,gBAAiB,CAIjB,YAfA,wfAAsf,CACtf,2BAgBA,CACA,YAbA,2iBAAyiB,CACziB,wCAcA,CAiGA,CA/FA,8KACC,qDACD,CA2FA,yIAnHA,wfAAsf,CACtf,2BAoHA,CAFA,yIA9GA,2iBAAyiB,CACziB,wCA+GA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"@ckeditor/ckeditor5-ui/theme/mixins/_dir.css\";\n\n:root {\n\t--ck-show-blocks-border-color: hsl(0, 0%, 46%);\n}\n\n@define-mixin block-name-background-ltr $text {\n\tbackground-image: url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='3' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>$(text)</text></svg>\");\n\tbackground-position: 1px 1px;\n}\n\n@define-mixin block-name-background-rtl $text {\n\tbackground-image: url(\"data:image/svg+xml;utf8,<svg width='120' height='12' xmlns='http://www.w3.org/2000/svg' ><text style='paint-order:stroke fill; clip-path: inset(-3px); transform:translate(-2px, 0)' stroke='%23EAEAEA' stroke-width='13' dominant-baseline='middle' fill='black' x='100%' text-anchor='end' y='7' font-size='9px' font-family='Consolas, %22Lucida Console%22, %22Lucida Sans Typewriter%22, %22DejaVu Sans Mono%22, %22Bitstream Vera Sans Mono%22, %22Liberation Mono%22, Monaco, %22Courier New%22, Courier, monospace'>$(text)</text></svg>\");\n\tbackground-position: calc(100% - 1px) 1px;\n}\n\n@define-mixin block-name-background $text {\n\tbackground-repeat: no-repeat;\n\tpadding-top: 15px;\n\n\t/* Fix for Multi-root editor\n\thttps://github.com/ckeditor/ckeditor5/issues/15969 */\n\t[dir=ltr] & {\n\t\t@mixin block-name-background-ltr $text;\n\t}\n\t[dir=rtl] & {\n\t\t@mixin block-name-background-rtl $text;\n\t}\n\n\t&:not(.ck-widget_selected):not(.ck-widget:hover) {\n\t\toutline: 1px dashed var(--ck-show-blocks-border-color);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t@mixin block-name-background-ltr $text;\n\t}\n\t@mixin ck-dir rtl {\n\t\t@mixin block-name-background-rtl $text;\n\t}\n}\n\n.ck.ck-editor__editable.ck-editor__editable_inline.ck-show-blocks:not(.ck-widget) {\n\t& address {\n\t\t@mixin block-name-background ADDRESS;\n\t}\n\n\t& aside {\n\t\t@mixin block-name-background ASIDE;\n\t}\n\n\t& blockquote {\n\t\t@mixin block-name-background BLOCKQUOTE;\n\t}\n\n\t& details {\n\t\t@mixin block-name-background DETAILS;\n\t}\n\n\t& div:not(.ck-widget, .ck-widget *) {\n\t\t@mixin block-name-background DIV;\n\t}\n\n\t& footer {\n\t\t@mixin block-name-background FOOTER;\n\t}\n\n\t& h1 {\n\t\t@mixin block-name-background H1;\n\t}\n\n\t& h2 {\n\t\t@mixin block-name-background H2;\n\t}\n\n\t& h3 {\n\t\t@mixin block-name-background H3;\n\t}\n\n\t& h4 {\n\t\t@mixin block-name-background H4;\n\t}\n\n\t& h5 {\n\t\t@mixin block-name-background H5;\n\t}\n\n\t& h6 {\n\t\t@mixin block-name-background H6;\n\t}\n\n\t& header {\n\t\t@mixin block-name-background HEADER;\n\t}\n\n\t& main {\n\t\t@mixin block-name-background MAIN;\n\t}\n\n\t& nav {\n\t\t@mixin block-name-background NAV;\n\t}\n\n\t& pre {\n\t\t@mixin block-name-background PRE;\n\t}\n\n\t& ol {\n\t\t@mixin block-name-background OL;\n\t}\n\n\t& ul {\n\t\t@mixin block-name-background UL;\n\t}\n\n\t& p {\n\t\t@mixin block-name-background P;\n\t}\n\n\t& section {\n\t\t@mixin block-name-background SECTION;\n\t}\n\n\t& :where(figure.image, figure.table) figcaption {\n\t\t@mixin block-name-background FIGCAPTION;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9227(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck-source-editing-area{overflow:hidden;position:relative}.ck-source-editing-area textarea,.ck-source-editing-area:after{border:1px solid #0000;font-family:monospace;font-size:var(--ck-font-size-normal);line-height:var(--ck-line-height-base);margin:0;padding:var(--ck-spacing-large);white-space:pre-wrap}.ck-source-editing-area:after{content:attr(data-value) " ";display:block;visibility:hidden}.ck-source-editing-area textarea{border-color:var(--ck-color-base-border);border-radius:0;box-sizing:border-box;height:100%;outline:none;overflow:hidden;position:absolute;resize:none;width:100%}.ck-rounded-corners .ck-source-editing-area textarea,.ck-source-editing-area textarea.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck-source-editing-area textarea:not([readonly]):focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-source-editing/theme/sourceediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,wBAEC,eAAgB,CADhB,iBAED,CAEA,+DAIC,sBAA6B,CAG7B,qBAAsB,CADtB,oCAAqC,CADrC,sCAAuC,CAFvC,QAAS,CADT,+BAAgC,CAMhC,oBACD,CAEA,8BACC,4BAA6B,CAE7B,aAAc,CADd,iBAED,CAEA,iCASC,wCAAyC,CC7BzC,eAAgB,CD2BhB,qBAAsB,CAJtB,WAAY,CAEZ,YAAa,CACb,eAAgB,CALhB,iBAAkB,CAGlB,WAAY,CAFZ,UAkBD,CApBA,yGChBE,qCAAsC,CD4BtC,wBAAyB,CACzB,yBAOF,CAJC,uDEpCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFwCA",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck-source-editing-area {\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.ck-source-editing-area::after,\n.ck-source-editing-area textarea {\n\tpadding: var(--ck-spacing-large);\n\tmargin: 0;\n\tborder: 1px solid transparent;\n\tline-height: var(--ck-line-height-base);\n\tfont-size: var(--ck-font-size-normal);\n\tfont-family: monospace;\n\twhite-space: pre-wrap;\n}\n\n.ck-source-editing-area::after {\n\tcontent: attr(data-value) " ";\n\tvisibility: hidden;\n\tdisplay: block;\n}\n\n.ck-source-editing-area textarea {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tresize: none;\n\toutline: none;\n\toverflow: hidden;\n\tbox-sizing: border-box;\n\n\tborder-color: var(--ck-color-base-border);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not([readonly]):focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2221(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-character-grid{max-width:100%}.ck.ck-character-grid .ck-character-grid__tiles{display:grid}:root{--ck-character-grid-tile-size:24px}.ck.ck-character-grid{max-height:200px;overflow-x:hidden;overflow-y:auto;width:350px}@media screen and (max-width:600px){.ck.ck-character-grid{width:190px}}.ck.ck-character-grid .ck-character-grid__tiles{grid-template-columns:repeat(10,1fr);margin:var(--ck-spacing-standard) var(--ck-spacing-large);grid-gap:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-character-grid .ck-character-grid__tiles{grid-template-columns:repeat(5,1fr)}}.ck.ck-character-grid .ck-character-grid__tile{border:0;font-size:1.2em;height:var(--ck-character-grid-tile-size);min-height:var(--ck-character-grid-tile-size);min-width:var(--ck-character-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-character-grid-tile-size)}@media (prefers-reduced-motion:reduce){.ck.ck-character-grid .ck-character-grid__tile{transition:none}}.ck.ck-character-grid .ck-character-grid__tile:focus:not(.ck-disabled),.ck.ck-character-grid .ck-character-grid__tile:hover:not(.ck-disabled){border:0;box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-character-grid .ck-character-grid__tile .ck-button__label{line-height:var(--ck-character-grid-tile-size);text-align:center;width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-special-characters/theme/charactergrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-special-characters/charactergrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAKA,sBACC,cAKD,CAHC,gDACC,YACD,CCFD,MACC,kCACD,CAEA,sBAIC,gBAAiB,CAFjB,iBAAkB,CADlB,eAAgB,CAEhB,WA6CD,CCtDC,oCDMD,sBAOE,WAyCF,CCpDC,CDcA,gDACC,oCAAsC,CACtC,yDAA0D,CAC1D,mCAKD,CCxBA,oCDgBA,gDAME,mCAEF,CCtBA,CDwBA,+CAQC,QAAS,CAHT,eAAgB,CAHhB,yCAA0C,CAE1C,6CAA8C,CAD9C,4CAA6C,CAG7C,SAAU,CACV,8BAA+B,CAN/B,wCA0BD,CAjBC,uCAVD,+CAWE,eAgBF,CAfC,CAEA,8IAGC,QAAS,CACT,iGACD,CAGA,iEACC,8CAA+C,CAE/C,iBAAkB,CADlB,UAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-character-grid {\n\tmax-width: 100%;\n\n\t& .ck-character-grid__tiles {\n\t\tdisplay: grid;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-character-grid-tile-size: 24px;\n}\n\n.ck.ck-character-grid {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twidth: 350px;\n\tmax-height: 200px;\n\n\t@mixin ck-media-phone {\n\t\twidth: 190px;\n\t}\n\n\t& .ck-character-grid__tiles {\n\t\tgrid-template-columns: repeat(10, 1fr);\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\t\tgrid-gap: var(--ck-spacing-standard);\n\n\t\t@mixin ck-media-phone {\n\t\t\tgrid-template-columns: repeat(5, 1fr);\n\t\t}\n\t}\n\n\t& .ck-character-grid__tile {\n\t\twidth: var(--ck-character-grid-tile-size);\n\t\theight: var(--ck-character-grid-tile-size);\n\t\tmin-width: var(--ck-character-grid-tile-size);\n\t\tmin-height: var(--ck-character-grid-tile-size);\n\t\tfont-size: 1.2em;\n\t\tpadding: 0;\n\t\ttransition: .2s ease box-shadow;\n\t\tborder: 0;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\t/* Disable the default .ck-button\'s border ring. */\n\t\t\tborder: 0;\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t\t}\n\n\t\t/* Make sure the glyph is rendered in the center of the button */\n\t\t& .ck-button__label {\n\t\t\tline-height: var(--ck-character-grid-tile-size);\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3445(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-character-info{border-top:1px solid var(--ck-color-base-border);display:flex;justify-content:space-between;padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-character-info>*{font-size:var(--ck-font-size-small);text-transform:uppercase}.ck.ck-character-info .ck-character-info__name{max-width:280px;overflow:hidden;text-overflow:ellipsis}.ck.ck-character-info .ck-character-info__code{opacity:.6}@media screen and (max-width:600px){.ck.ck-character-info{max-width:190px}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-special-characters/theme/characterinfo.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-special-characters/characterinfo.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAKA,sBCIC,gDAAiD,CDHjD,YAAa,CACb,6BAA8B,CCC9B,uDDAD,CCGC,wBAEC,mCAAoC,CADpC,wBAED,CAEA,+CACC,eAAgB,CAEhB,eAAgB,CADhB,sBAED,CAEA,+CACC,UACD,CClBA,oCDCD,sBAoBE,eAEF,CCrBC",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-character-info {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-character-info {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t& > * {\n\t\ttext-transform: uppercase;\n\t\tfont-size: var(--ck-font-size-small);\n\t}\n\n\t& .ck-character-info__name {\n\t\tmax-width: 280px;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t}\n\n\t& .ck-character-info__code {\n\t\topacity: .6;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tmax-width: 190px;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7405(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-special-characters-navigation>.ck-label{max-width:160px;overflow:hidden;text-overflow:ellipsis}.ck.ck-special-characters-navigation>.ck-dropdown .ck-dropdown__panel{max-height:250px;overflow-x:hidden;overflow-y:auto}@media screen and (max-width:600px){.ck.ck-special-characters-navigation{max-width:190px}.ck.ck-special-characters-navigation>.ck-form__header__label{overflow:hidden;text-overflow:ellipsis}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-special-characters/specialcharacters.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAUC,+CACC,eAAgB,CAEhB,eAAgB,CADhB,sBAED,CAEA,sEAEC,gBAAiB,CAEjB,iBAAkB,CADlB,eAED,CCfA,oCDED,qCAgBE,eAOF,CALE,6DAEC,eAAgB,CADhB,sBAED,CCrBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-special-characters-navigation {\n\n\t& > .ck-label {\n\t\tmax-width: 160px;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t}\n\n\t& > .ck-dropdown .ck-dropdown__panel {\n\t\t/* There could be dozens of categories available. Use scroll to prevent a 10e6px dropdown. */\n\t\tmax-height: 250px;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tmax-width: 190px;\n\n\t\t& > .ck-form__header__label {\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4307(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-input-text:focus{z-index:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-top-left-radius:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-left:1px solid #0000}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-right:1px solid #0000}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}.ck.ck-input-color .ck.ck-input-color__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-input-border)}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/colorinput.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAcF,CAhBA,+CAQE,2BAA4B,CAD5B,wBASF,CAHC,2CACC,SACD,CAIA,wEACC,SA0CD,CA3CA,kFAKE,2BAA4B,CAD5B,wBAuCF,CApCE,8FACC,2BACD,CATF,kFAcE,4BAA6B,CAD7B,yBA8BF,CA3BE,8FACC,4BACD,CAGD,oFACC,oDACD,CAEA,4GC1CF,eD2DE,CAjBA,+PCtCD,qCDuDC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAIC,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CADxE,UA0BD,CApBC,gEACC,oDACD,CATD,8DAYE,yBAeF,CA3BA,8DAgBE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\n\t& > input.ck.ck-input-text {\n\t\tmin-width: auto;\n\t\tflex-grow: 1;\n\t}\n\n\t& > div.ck.ck-dropdown {\n\t\tmin-width: auto;\n\n\t\t/* This dropdown has no arrow but a color preview instead. */\n\t\t& > .ck-input-color__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__button {\n\t\t/* Resolving issue with misaligned buttons on Safari (see #10589) */\n\t\tdisplay: flex;\n\n\t\t& .ck.ck-input-color__button__preview {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\n\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n\t& > .ck.ck-input-text {\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* Make sure the focused input is always on top of the dropdown button so its\n\t\t   outline and border are never cropped (also when the input is read-only). */\n\t\t&:focus {\n\t\t\tz-index: 0;\n\t\t}\n\t}\n\n\t& > .ck.ck-dropdown {\n\t\t& > .ck.ck-button.ck-input-color__button {\n\t\t\tpadding: 0;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-left: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-right: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.ck-disabled {\n\t\t\t\tbackground: var(--ck-color-input-disabled-background);\n\t\t\t}\n\n\t\t\t& > .ck.ck-input-color__button__preview {\n\t\t\t\t@mixin ck-rounded-corners;\n\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder: 1px solid var(--ck-color-input-border);\n\n\t\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\t\ttop: -30%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 150%;\n\t\t\t\t\twidth: 8%;\n\t\t\t\t\tbackground: hsl(0, 100%, 50%);\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\ttransform-origin: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__remove-color {\n\t\twidth: 100%;\n\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-input-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\n\t\t& .ck.ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1806(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/form.css"],
          names: [],
          mappings: "AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n\tpadding: 0 0 var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t& .ck.ck-input-text {\n\t\tmin-width: 100%;\n\t\twidth: 0;\n\t}\n\n\t& .ck.ck-dropdown {\n\t\tmin-width: 100%;\n\n\t\t& .ck-dropdown__button {\n\t\t\t&:not(:focus) {\n\t\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck-button__label {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6016(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/formrow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css"],
          names: [],
          mappings: "AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n\tpadding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\t& + * {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-label {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8603(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}@media (prefers-reduced-motion:reduce){.ck .ck-insert-table-dropdown-grid-box{transition:none}}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
          names: [],
          mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAcD,CAZC,uCATD,uCAUE,eAWF,CAVC,CAEA,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label,\n.ck[dir=rtl] .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\tmin-width: var(--ck-insert-table-dropdown-box-width);\n\tmin-height: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\ttransition: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9969(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:#0000000d;font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css"],
          names: [],
          mappings: "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,oBAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7406(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-selector-caption-background:#f7f7f7;--ck-color-selector-caption-text:#333;--ck-color-selector-caption-highlighted-background:#fd0}.ck-content .table>figcaption{background-color:var(--ck-color-selector-caption-background);caption-side:top;color:var(--ck-color-selector-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;text-align:center;word-break:break-word}@media (forced-colors:active){.ck-content .table>figcaption{background-color:unset;color:unset}}@media (forced-colors:none){.ck.ck-editor__editable .table>figcaption.table__caption_highlighted{animation:ck-table-caption-highlight .6s ease-out}}.ck.ck-editor__editable .table>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}@keyframes ck-table-caption-highlight{0%{background-color:var(--ck-color-selector-caption-highlighted-background)}to{background-color:var(--ck-color-selector-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecaption.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAOA,MACC,8CAAuD,CACvD,qCAAiD,CACjD,uDACD,CAGA,8BAMC,4DAA6D,CAJ7D,gBAAiB,CAGjB,2CAA4C,CAJ5C,qBAAsB,CAOtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,iBAAkB,CADlB,qBAaD,CCxBC,8BACC,8BDoBA,sBAAuB,CACvB,WCnBA,CACD,CAIA,4BDqBC,qEACC,iDACD,CCnBD,CDsBA,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAGD,sCACC,GACC,wEACD,CAEA,GACC,4DACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-selector-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-selector-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-selector-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .table > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: top;\n\tword-break: break-word;\n\ttext-align: center;\n\tcolor: var(--ck-color-selector-caption-text);\n\tbackground-color: var(--ck-color-selector-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n\n\t/* Improve placeholder rendering in high-constrast mode (https://github.com/ckeditor/ckeditor5/issues/14907). */\n\t@mixin ck-media-forced-colors {\n\t\tbackground-color: unset;\n\t\tcolor: unset;\n\t}\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .table > figcaption {\n\t@mixin ck-media-default-colors {\n\t\t&.table__caption_highlighted {\n\t\t\tanimation: ck-table-caption-highlight .6s ease-out;\n\t\t}\n\t}\n\n\t&.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the table caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n}\n\n@keyframes ck-table-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-selector-caption-highlighted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-selector-caption-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6701(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecellproperties.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css"],
          names: [],
          mappings: "AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\t&:first-of-type {\n\t\t\t\t\t/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n\t\t\t\t\tflex-grow: 0.57;\n\t\t\t\t}\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\t/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n\t\t\t\t\tflex-grow: 0.43;\n\t\t\t\t}\n\n\t\t\t\t& .ck-button {\n\t\t\t\t\tflex-grow: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__padding-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\t\t\twidth: 25%;\n\t\t}\n\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4204(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-selector-column-resizer-hover:var(--ck-color-base-active);--ck-table-column-resizer-width:7px;--ck-table-column-resizer-position-offset:calc(var(--ck-table-column-resizer-width)*-0.5 - 0.5px)}.ck-content .table .ck-table-resized{table-layout:fixed}.ck-content .table table{overflow:hidden}.ck-content .table td,.ck-content .table th{overflow-wrap:break-word;position:relative}.ck.ck-editor__editable .table .ck-table-column-resizer{bottom:0;cursor:col-resize;position:absolute;right:var(--ck-table-column-resizer-position-offset);top:0;user-select:none;width:var(--ck-table-column-resizer-width);z-index:var(--ck-z-default)}.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer,.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer{display:none}.ck.ck-editor__editable .table .ck-table-column-resizer:hover,.ck.ck-editor__editable .table .ck-table-column-resizer__active{background-color:var(--ck-color-selector-column-resizer-hover);bottom:-999999px;opacity:.25;top:-999999px}.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer{left:var(--ck-table-column-resizer-position-offset);right:unset}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecolumnresize.css"],
          names: [],
          mappings: "AAKA,MACC,oEAAqE,CACrE,mCAAoC,CAIpC,iGACD,CAEA,qCACC,kBACD,CAEA,yBACC,eACD,CAEA,4CAIC,wBAAyB,CACzB,iBACD,CAEA,wDAGC,QAAS,CAGT,iBAAkB,CALlB,iBAAkB,CAGlB,oDAAqD,CAFrD,KAAM,CAKN,gBAAiB,CAFjB,0CAA2C,CAG3C,2BACD,CAQA,qJACC,YACD,CAEA,8HAEC,8DAA+D,CAO/D,gBAAiB,CANjB,WAAa,CAKb,aAED,CAEA,iEACC,mDAAoD,CACpD,WACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-column-resizer-hover: var(--ck-color-base-active);\n\t--ck-table-column-resizer-width: 7px;\n\n\t/* The offset used for absolute positioning of the resizer element, so that it is placed exactly above the cell border.\n\t   The value is: minus half the width of the resizer decreased additionaly by the half the width of the border (0.5px). */\n\t--ck-table-column-resizer-position-offset: calc(var(--ck-table-column-resizer-width) * -0.5 - 0.5px);\n}\n\n.ck-content .table .ck-table-resized {\n\ttable-layout: fixed;\n}\n\n.ck-content .table table {\n\toverflow: hidden;\n}\n\n.ck-content .table td,\n.ck-content .table th {\n\t/* To prevent text overflowing beyond its cell when columns are resized by resize handler\n\t(https://github.com/ckeditor/ckeditor5/pull/14379#issuecomment-1589460978). */\n\toverflow-wrap: break-word;\n\tposition: relative;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tright: var(--ck-table-column-resizer-position-offset);\n\twidth: var(--ck-table-column-resizer-width);\n\tcursor: col-resize;\n\tuser-select: none;\n\tz-index: var(--ck-z-default);\n}\n\n.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n/* The resizer elements, which are extended to an extremely high height, break the drag & drop feature in Chrome. To make it work again,\n   all resizers must be hidden while the table is dragged. */\n.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer {\n\tdisplay: none;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer:hover,\n.ck.ck-editor__editable .table .ck-table-column-resizer__active {\n\tbackground-color: var(--ck-color-selector-column-resizer-hover);\n\topacity: 0.25;\n\t/* The resizer element resides in each cell so to occupy the entire height of the table, which is unknown from a CSS point of view,\n\t   it is extended to an extremely high height. Even for screens with a very high pixel density, the resizer will fulfill its role as\n\t   it should, i.e. for a screen of 476 ppi the total height of the resizer will take over 350 sheets of A4 format, which is totally\n\t   unrealistic height for a single table. */\n\ttop: -999999px;\n\tbottom: -999999px;\n}\n\n.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer {\n\tleft: var(--ck-table-column-resizer-position-offset);\n\tright: unset;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8864(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-selector-focused-cell-background:#9ec9fa4d}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-selector-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
          names: [],
          mappings: "AAKA,MACC,qDACD,CAKE,8QAGC,2DAA4D,CAK5D,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-selector-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-selector-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5704(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:#0000 #0000 var(--ck-color-base-error) #0000;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}@media (prefers-reduced-motion:reduce){.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:none}}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableform.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCA6BD,CA3BC,8ECxCD,eD6DC,CArBA,mMCpCA,qCDyDA,CArBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAcD,CAXC,oFACC,yDAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEAKD,CAHC,uCAlBD,8EAmBE,cAEF,CADC,CAID,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__background-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tflex-wrap: wrap;\n\t\t\talign-items: center;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .ck.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\tflex-grow: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\t/* Allow absolute positioning of the status (error) balloons. */\n\t\tposition: relative;\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\ttransform: translate(-50%,100%);\n\n\t\t\t/* Make sure the balloon status stays on top of other form elements. */\n\t\t\tz-index: 1;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX( -50% );\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-table-properties-error-arrow-size: 6px;\n\t--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\t& > .ck-label {\n\t\t\t\t\tfont-size: var(--ck-font-size-tiny);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__border-style,\n\t\t\t& .ck-table-form__border-width {\n\t\t\t\twidth: 80px;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tmax-width: 80px;\n\t\t\t}\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tpadding: 0;\n\n\t\t\t& .ck-table-form__dimensions-row__width,\n\t\t\t& .ck-table-form__dimensions-row__height {\n\t\t\t\tmargin: 0\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\talign-self: flex-end;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: var(--ck-ui-component-min-height);\n\t\t\t\tline-height: var(--ck-ui-component-min-height);\n\t\t\t\tmargin: 0 var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\t@mixin ck-rounded-corners;\n\n\t\t\tbackground: var(--ck-color-base-error);\n\t\t\tcolor: var(--ck-color-base-background);\n\t\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\t\tmin-width: var(--ck-table-properties-min-error-width);\n\t\t\ttext-align: center;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tborder-color: transparent transparent var(--ck-color-base-error) transparent;\n\t\t\t\tborder-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\tanimation: ck-table-form-labeled-view-status-appear .15s ease both;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\t\t\t}\n\t\t}\n\n\t\t/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n\t\t& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4001(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableproperties.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css"],
          names: [],
          mappings: "AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-basis: 0;\n\t\t\talign-content: baseline;\n\n\t\t\t& .ck.ck-toolbar .ck-toolbar__items {\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t\t\t& .ck-toolbar__items > * {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2850(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ':root{--ck-table-selected-cell-background:#9ecffa4d}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:#0000;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:initial}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
          names: [],
          mappings: "AAKA,MACC,6CACD,CAGC,0IAKC,gBAAiB,CAFjB,iBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,wBACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1710(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-aria-live-announcer{left:-10000px;position:absolute;top:-10000px}.ck.ck-aria-live-region-list{list-style-type:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/arialiveannouncer/arialiveannouncer.css"],
          names: [],
          mappings: "AAKA,2BAEC,aAAc,CADd,iBAAkB,CAElB,YACD,CAEA,6BACC,oBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-aria-live-announcer {\n\tposition: absolute;\n\tleft: -10000px;\n\ttop: -10000px;\n}\n\n.ck.ck-aria-live-region-list {\n\tlist-style-type: none;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2688(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-autocomplete{position:relative}.ck.ck-autocomplete>.ck-search__results{position:absolute;z-index:var(--ck-z-panel)}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{bottom:100%}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{bottom:auto;top:100%}.ck.ck-autocomplete>.ck-search__results{border-radius:0}.ck-rounded-corners .ck.ck-autocomplete>.ck-search__results,.ck.ck-autocomplete>.ck-search__results.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-autocomplete>.ck-search__results{background:var(--ck-color-base-background);border:1px solid var(--ck-color-dropdown-panel-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:200px;min-width:auto;overflow-y:auto}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-1px}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{border-top-left-radius:0;border-top-right-radius:0;margin-top:-1px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/autocomplete/autocomplete.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/autocomplete/autocomplete.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,oBACC,iBAeD,CAbC,wCACC,iBAAkB,CAClB,yBAUD,CARC,6DACC,WACD,CAEA,6DAEC,WAAY,CADZ,QAED,CCVD,wCCEA,eDuBA,CAzBA,uHCMC,qCDmBD,CAzBA,wCAMC,0CAA2C,CAC3C,sDAAuD,CEPxD,oCAA8B,CFI7B,gBAAiB,CAIjB,cAAe,CAHf,eAoBD,CAfC,6DACC,2BAA4B,CAC5B,4BAA6B,CAG7B,kBACD,CAEA,6DACC,wBAAyB,CACzB,yBAA0B,CAG1B,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-autocomplete {\n\tposition: relative;\n\n\t& > .ck-search__results {\n\t\tposition: absolute;\n\t\tz-index: var(--ck-z-panel);\n\n\t\t&.ck-search__results_n {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck.ck-autocomplete {\n\t& > .ck-search__results {\n\t\t@mixin ck-rounded-corners;\n\t\t@mixin ck-drop-shadow;\n\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t\tbackground: var(--ck-color-base-background);\n\t\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\t\tmin-width: auto;\n\n\t\t&.ck-search__results_n {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-bottom: -1px;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-top-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8948(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}[dir=ltr] .ck.ck-button,[dir=ltr] a.ck.ck-button{justify-content:left}[dir=rtl] .ck.ck-button,[dir=rtl] a.ck.ck-button{justify-content:right}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid #0000;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}@media (prefers-reduced-motion:reduce){.ck.ck-button,a.ck.ck-button{transition:none}}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{opacity:.5}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAQA,6BAMC,kBAAmB,CADnB,mBAAoB,CADpB,iBAAkB,CCHlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD0BD,CA9BA,iDASE,oBAqBF,CA9BA,iDAaE,qBAiBF,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEzBD,6BCAC,oDD+ID,CC5IE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eFgJD,CA/IA,wIEGE,qCF4IF,CA/IA,6BA6BC,uBAAwB,CANxB,sBAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBA0ID,CAhHC,uCA/BD,6BAgCE,eA+GF,CA9GC,CAEA,oFGpCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHyCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAWD,CAZA,6FAIE,mCAQF,CAZA,6FAQE,oCAIF,CAZA,yEAWC,UACD,CAIC,oIIxFD,oDJ4FC,CAOA,gLKnGD,kCLqGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCClIA,+CDsIA,CCnIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDmHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CClJC,mDDuJD,CCpJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDmID,2CAIC,wCACD,CAEA,uCAEC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../../mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\n\t@mixin ck-dir ltr {\n\t\tjustify-content: left;\n\t}\n\n\t@mixin ck-dir rtl {\n\t\tjustify-content: right;\n\t}\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\topacity: .5;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9624(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:#0000;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid #0000;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{transition:none}}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:#0000;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,gBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eDgFA,CA5CA,yIChCC,qCD4ED,CA5CA,2DAKE,gBAuCF,CA5CA,2DAUE,iBAkCF,CA5CA,iDAkBC,uDAAwD,CAFxD,sBAA6B,CAD7B,iFAAsF,CAEtF,0CA2BD,CAxBC,2ECxDD,eDuEC,CAfA,6LCpDA,qCAAsC,CDsDpC,8CAaF,CAfA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAUD,CAHC,uCAZD,2EAaE,eAEF,CADC,CAGD,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEpFA,kCFsFA,CAGA,oCACC,kBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t/* Unlike a regular button, the switch button text color and background should never change.\n\t * Changing toggle switch (background, outline) is enough to carry the information about the\n\t * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n\t */\n\t&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t}\n\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1750(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-collapsible.ck-collapsible_collapsed>.ck-collapsible__children{display:none}:root{--ck-collapsible-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-collapsible>.ck.ck-button{border-radius:0;color:inherit;font-weight:700;padding:var(--ck-list-button-padding);width:100%}.ck.ck-collapsible>.ck.ck-button:focus{background:#0000}.ck.ck-collapsible>.ck.ck-button:active,.ck.ck-collapsible>.ck.ck-button:hover:not(:focus),.ck.ck-collapsible>.ck.ck-button:not(:focus){background:#0000;border-color:#0000;box-shadow:none}.ck.ck-collapsible>.ck.ck-button>.ck-icon{margin-right:var(--ck-spacing-medium);width:var(--ck-collapsible-arrow-size)}.ck.ck-collapsible>.ck-collapsible__children{padding:var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large)}.ck.ck-collapsible.ck-collapsible_collapsed>.ck.ck-button .ck-icon{transform:rotate(-90deg)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/collapsible/collapsible.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/collapsible/collapsible.css"],
          names: [],
          mappings: "AAMC,sEACC,YACD,CCHD,MACC,yDACD,CAGC,iCAIC,eAAgB,CAChB,aAAc,CAHd,eAAiB,CACjB,qCAAsC,CAFtC,UAoBD,CAdC,uCACC,gBACD,CAEA,wIACC,gBAAuB,CACvB,kBAAyB,CACzB,eACD,CAEA,0CACC,qCAAsC,CACtC,sCACD,CAGD,6CACC,gFACD,CAGC,mEACC,wBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-collapsible.ck-collapsible_collapsed {\n\t& > .ck-collapsible__children {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-collapsible-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-collapsible {\n\t& > .ck.ck-button {\n\t\twidth: 100%;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-list-button-padding);\n\t\tborder-radius: 0;\n\t\tcolor: inherit;\n\n\t\t&:focus {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&:active, &:not(:focus), &:hover:not(:focus) {\n\t\t\tbackground: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t& > .ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t\twidth: var(--ck-collapsible-arrow-size);\n\t\t}\n\t}\n\n\t& > .ck-collapsible__children {\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large);\n\t}\n\n\t&.ck-collapsible_collapsed {\n\t\t& > .ck.ck-button .ck-icon {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7962(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{transition:box-shadow .2s ease}@media (forced-colors:none){.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile.ck-color-selector__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}}@media (forced-colors:active){.ck.ck-color-grid__tile{height:unset;min-height:unset;min-width:unset;padding:0 var(--ck-spacing-small);width:unset}.ck.ck-color-grid__tile .ck-button__label{display:inline-block}}@media (prefers-reduced-motion:reduce){.ck.ck-color-grid__tile{transition:none}}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,kBACC,YACD,CCCA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,8BAkED,CC3EC,4BACC,wBDgBA,QAAS,CAJT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CAJV,oCCTA,CDgBA,8HAIC,QACD,CAEA,+DACC,gDACD,CAEA,8BACC,8FACD,CAEA,gGAEC,iGACD,CCjCD,CAZA,8BACC,wBDqDA,YAAa,CAEb,gBAAiB,CADjB,eAAgB,CAEhB,iCAAkC,CAJlC,WClDA,CDwDA,0CACC,oBACD,CCzDD,CD4DA,uCAhDD,wBAiDE,eAkBF,CAjBC,CAEA,oCACC,YAAa,CACb,gBACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAGC,0CACC,aACD,CAIF,yBACC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\ttransition: .2s ease box-shadow;\n\n\t@mixin ck-media-default-colors {\n\t\twidth: var(--ck-color-grid-tile-size);\n\t\theight: var(--ck-color-grid-tile-size);\n\t\tmin-width: var(--ck-color-grid-tile-size);\n\t\tmin-height: var(--ck-color-grid-tile-size);\n\t\tpadding: 0;\n\t\tborder: 0;\n\n\t\t&.ck-on,\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\t/* Disable the default .ck-button\'s border ring. */\n\t\t\tborder: 0;\n\t\t}\n\n\t\t&.ck-color-selector__color-tile_bordered {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\t\t}\n\n\t\t&:focus:not( .ck-disabled ),\n\t\t&:hover:not( .ck-disabled ) {\n\t\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t\t}\n\t}\n\n\t/*\n\t * In high contrast mode, the colors are replaced with text labels.\n\t * See https://github.com/ckeditor/ckeditor5/issues/14907.\n\t */\n\t@mixin ck-media-forced-colors {\n\t\twidth: unset;\n\t\theight: unset;\n\t\tmin-width: unset;\n\t\tmin-height: unset;\n\t\tpadding: 0 var(--ck-spacing-small);\n\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3086(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".color-picker-hex-input{width:max-content}.color-picker-hex-input .ck.ck-input{min-width:unset}.ck.ck-color-picker__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;margin:var(--ck-spacing-large) 0 0;width:unset}.ck.ck-color-picker__row .ck.ck-labeled-field-view{padding-top:unset}.ck.ck-color-picker__row .ck.ck-input-text{width:unset}.ck.ck-color-picker__row .ck-color-picker__hash-view{padding-right:var(--ck-spacing-medium);padding-top:var(--ck-spacing-tiny)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorpicker/colorpicker.css"],
          names: [],
          mappings: "AAKA,wBACC,iBAKD,CAHC,qCACC,eACD,CAGD,yBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAC9B,kCAAmC,CACnC,WAcD,CAZC,mDACC,iBACD,CAEA,2CACC,WACD,CAEA,qDAEC,sCAAuC,CADvC,kCAED",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.color-picker-hex-input {\n\twidth: max-content;\n\n\t& .ck.ck-input {\n\t\tmin-width: unset;\n\t}\n}\n\n.ck.ck-color-picker__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\tmargin: var(--ck-spacing-large) 0 0;\n\twidth: unset;\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: unset;\n\t}\n\n\t& .ck.ck-input-text {\n\t\twidth: unset;\n\t}\n\n\t& .ck-color-picker__hash-view {\n\t\tpadding-top: var(--ck-spacing-tiny);\n\t\tpadding-right: var(--ck-spacing-medium);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2922(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{align-items:center;display:flex}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{justify-content:flex-start}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{display:flex;flex-direction:row;justify-content:space-around}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-cancel,.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-save{flex:1}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{width:100%}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-left:var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment label.ck.ck-color-grid__label{font-weight:unset}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker{padding:8px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker{height:100px;min-width:180px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation){border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue){border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius)}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue-pointer),.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation-pointer){height:15px;width:15px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{padding:0 8px 8px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorselector/colorselector.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorselector/colorselector.css"],
          names: [],
          mappings: "AAUE,oLAGC,kBAAmB,CADnB,YAMD,CARA,wMAME,0BAEF,CAKA,iFACC,YAAa,CACb,kBAAmB,CACnB,4BAMD,CAJC,oMAEC,MACD,CCrBD,oLAEC,UACD,CAEA,0FAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,sGACC,gDACD,CAEA,gHAEE,uCAMF,CARA,gHAME,sCAEF,CAGD,6EACC,iBACD,CAKA,oEACC,WAoBD,CAlBC,sFACC,YAAa,CACb,eAeD,CAbC,wGACC,iEACD,CAEA,iGACC,iEACD,CAEA,yNAGC,WAAY,CADZ,UAED,CAIF,iFACC,iBACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-around;\n\n\t\t\t& .ck-button-save,\n\t\t\t& .ck-button-cancel {\n\t\t\t\tflex: 1\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck.ck-icon {\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& label.ck.ck-color-grid__label {\n\t\t\tfont-weight: unset;\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-picker {\n\t\t\tpadding: 8px;\n\n\t\t\t& .hex-color-picker {\n\t\t\t\theight: 100px;\n\t\t\t\tmin-width: 180px;\n\n\t\t\t\t&::part(saturation) {\n\t\t\t\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\t\t\t\t}\n\n\t\t\t\t&::part(hue) {\n\t\t\t\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\t\t\t}\n\n\t\t\t\t&::part(saturation-pointer),\n\t\t\t\t&::part(hue-pointer) {\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tpadding: 0 8px 8px;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      880(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-dialog-overlay{bottom:0;left:0;overscroll-behavior:none;position:fixed;right:0;top:0;user-select:none}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent{animation:none;background:none;pointer-events:none}.ck.ck-dialog{overscroll-behavior:none;position:absolute;width:fit-content}.ck.ck-dialog .ck.ck-form__header{flex-shrink:0}.ck.ck-dialog .ck.ck-form__header .ck-form__header__label{cursor:grab}.ck.ck-dialog-overlay.ck-dialog-overlay__transparent .ck.ck-dialog{pointer-events:all}:root{--ck-dialog-overlay-background-color:#00000080;--ck-dialog-drop-shadow:0px 0px 6px 2px #00000026;--ck-dialog-max-width:100vw;--ck-dialog-max-height:90vh;--ck-color-dialog-background:var(--ck-color-base-background);--ck-color-dialog-form-header-border:var(--ck-color-base-border)}.ck.ck-dialog-overlay{animation:ck-dialog-fade-in .3s;background:var(--ck-dialog-overlay-background-color);z-index:var(--ck-z-dialog)}.ck.ck-dialog{border-radius:0}.ck-rounded-corners .ck.ck-dialog,.ck.ck-dialog.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dialog{box-shadow:var(--ck-drop-shadow),0 0;--ck-drop-shadow:var(--ck-dialog-drop-shadow);background:var(--ck-color-dialog-background);border:1px solid var(--ck-color-base-border);max-height:var(--ck-dialog-max-height);max-width:var(--ck-dialog-max-width)}.ck.ck-dialog .ck.ck-form__header{border-bottom:1px solid var(--ck-color-dialog-form-header-border)}@keyframes ck-dialog-fade-in{0%{background:#0000}to{background:var(--ck-dialog-overlay-background-color)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dialog/dialog.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialog.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,sBAKC,QAAS,CACT,MAAO,CAJP,wBAAyB,CAEzB,cAAe,CAGf,OAAQ,CACR,KAAM,CAPN,gBAcD,CALC,qDAEC,cAAe,CACf,eAAgB,CAFhB,mBAGD,CAGD,cACC,wBAAyB,CAEzB,iBAAkB,CADlB,iBAcD,CAXC,kCACC,aAKD,CAHC,0DACC,WACD,CAVF,mEAcE,kBAEF,CC7BA,MACC,8CAA2D,CAC3D,iDAA8D,CAC9D,2BAA4B,CAC5B,2BAA4B,CAC5B,4DAA6D,CAC7D,gEACD,CAEA,sBACC,+BAAgC,CAChC,oDAAqD,CACrD,0BACD,CAEA,cCbC,eD2BD,CAdA,mECTE,qCDuBF,CAdA,cEfC,oCAA8B,CFmB9B,6CAA8C,CAE9C,4CAA6C,CAG7C,4CAA6C,CAF7C,sCAAuC,CACvC,oCAMD,CAHC,kCACC,iEACD,CAGD,6BACC,GACC,gBACD,CAEA,GACC,oDACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog-overlay {\n\tuser-select: none;\n\toverscroll-behavior: none;\n\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\n\t&.ck-dialog-overlay__transparent {\n\t\tpointer-events: none;\n\t\tanimation: none;\n\t\tbackground: none;\n\t}\n}\n\n.ck.ck-dialog {\n\toverscroll-behavior: none;\n\twidth: fit-content;\n\tposition: absolute;\n\n\t& .ck.ck-form__header  {\n\t\tflex-shrink: 0;\n\n\t\t& .ck-form__header__label {\n\t\t\tcursor: grab;\n\t\t}\n\t}\n\n\t@nest .ck.ck-dialog-overlay.ck-dialog-overlay__transparent & {\n\t\tpointer-events: all;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n:root {\n\t--ck-dialog-overlay-background-color: hsla( 0, 0%, 0%, .5 );\n\t--ck-dialog-drop-shadow: 0px 0px 6px 2px hsl(0deg 0% 0% / 15%);\n\t--ck-dialog-max-width: 100vw;\n\t--ck-dialog-max-height: 90vh;\n\t--ck-color-dialog-background: var(--ck-color-base-background);\n\t--ck-color-dialog-form-header-border: var(--ck-color-base-border);\n}\n\n.ck.ck-dialog-overlay {\n\tanimation: ck-dialog-fade-in .3s;\n\tbackground: var(--ck-dialog-overlay-background-color);\n\tz-index: var(--ck-z-dialog);\n}\n\n.ck.ck-dialog {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\t--ck-drop-shadow: var(--ck-dialog-drop-shadow);\n\n\tbackground: var(--ck-color-dialog-background);\n\tmax-height: var(--ck-dialog-max-height);\n\tmax-width: var(--ck-dialog-max-width);\n\tborder: 1px solid var(--ck-color-base-border);\n\n\t& .ck.ck-form__header {\n\t\tborder-bottom: 1px solid var(--ck-color-dialog-form-header-border);\n\t}\n}\n\n@keyframes ck-dialog-fade-in {\n\t0% {\n\t\tbackground: hsla( 0, 0%, 0%, 0 );\n\t}\n\n\t100% {\n\t\tbackground: var(--ck-dialog-overlay-background-color);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8091(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-dialog .ck.ck-dialog__actions{display:flex;justify-content:flex-end;padding:var(--ck-spacing-large)}.ck.ck-dialog .ck.ck-dialog__actions>*+*{margin-left:var(--ck-spacing-large)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dialog/dialogactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dialog/dialogactions.css"],
          names: [],
          mappings: "AAMC,qCACC,YAAa,CACb,wBAAyB,CCDzB,+BDED,CCAC,yCACC,mCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-dialog {\n\t& .ck.ck-dialog__actions {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * + * {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      426(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-panel) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}.ck.ck-dropdown__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eHkHD,CAhCA,qFG9EE,qCH8GF,CAhCA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAuBD,CAnBC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD,CAEA,6BACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-panel);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-panel) + 1 );\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2454(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-dropdown>.ck-dropdown__panel>.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:first-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button,.ck.ck-dropdown>.ck-dropdown__panel>.ck-list .ck-list__item:last-child>.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown > .ck-dropdown__panel > .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child > .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7133(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* Make sure the divider stretches 100% height of the button\n\thttps://github.com/ckeditor/ckeditor5/issues/10936 */\n\t& > .ck-splitbutton__arrow:not(:focus) {\n\t\tborder-top-width: 0px;\n\t\tborder-bottom-width: 0px;\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t/* Make sure the divider between the buttons looks fine when the button is focused */\n\t\t& > .ck-splitbutton__arrow:focus::after {\n\t\t\t--ck-color-split-button-hover-border: var(--ck-color-focus-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7475(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
          names: [],
          mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9550(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-accessibility-help-dialog-max-width:600px;--ck-accessibility-help-dialog-max-height:400px;--ck-accessibility-help-dialog-border-color:#ccced1;--ck-accessibility-help-dialog-code-background-color:#ededed;--ck-accessibility-help-dialog-kbd-shadow-color:#9c9c9c}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{border:1px solid #0000;max-height:var(--ck-accessibility-help-dialog-max-height);max-width:var(--ck-accessibility-help-dialog-max-width);overflow:auto;padding:var(--ck-spacing-large);user-select:text}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content{*{white-space:normal}}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content .ck-label{display:none}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3{font-size:1.2em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4{font-size:1em;font-weight:700}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h3,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content h4,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content p,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content table{margin:1em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl{border-bottom:none;border-top:1px solid var(--ck-accessibility-help-dialog-border-color);display:grid;grid-template-columns:2fr 1fr}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{border-bottom:1px solid var(--ck-accessibility-help-dialog-border-color);padding:.4em 0}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dt{grid-column-start:1}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content dl dd{grid-column-start:2;text-align:right}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code,.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{background:var(--ck-accessibility-help-dialog-code-background-color);border-radius:2px;display:inline-block;font-size:.9em;line-height:1;padding:.4em;text-align:center;vertical-align:middle}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content code{font-family:monospace}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd{box-shadow:0 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);margin:0 1px;min-width:1.8em}.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content kbd+kbd{margin-left:2px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/accessibilityhelp.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAQA,MACC,8CAA+C,CAC/C,+CAAgD,CAChD,mDAA8D,CAC9D,4DAAyE,CACzE,uDACD,CAEA,wEAOC,sBAA6B,CAJ7B,yDAA0D,CAD1D,uDAAwD,CAExD,aAAc,CAHd,+BAAgC,CAIhC,gBAgFD,CA5EC,8ECdA,2BAA2B,CCF3B,2CAA8B,CDC9B,YDkBA,CAZD,wEAcC,EACC,kBACD,CAqED,CAlEC,kFACC,YACD,CAEA,2EAEC,eAAgB,CADhB,eAED,CAEA,2EAEC,aAAc,CADd,eAED,CAEA,8SAIC,YACD,CAEA,2EAIC,kBAAmB,CADnB,qEAAsE,CAFtE,YAAa,CACb,6BAiBD,CAbC,4JACC,wEAAyE,CACzE,cACD,CAEA,8EACC,mBACD,CAEA,8EACC,mBAAoB,CACpB,gBACD,CAGD,yJAEC,oEAAqE,CAIrE,iBAAkB,CALlB,oBAAqB,CAOrB,cAAe,CAHf,aAAc,CAFd,YAAa,CAIb,iBAAkB,CAHlB,qBAKD,CAEA,6EACC,qBACD,CAEA,4EAEC,yEAA4E,CAC5E,YAAa,CAFb,eAOD,CAHC,gFACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-accessibility-help-dialog-max-width: 600px;\n\t--ck-accessibility-help-dialog-max-height: 400px;\n\t--ck-accessibility-help-dialog-border-color: hsl(220, 6%, 81%);\n\t--ck-accessibility-help-dialog-code-background-color: hsl(0deg 0% 92.94%);\n\t--ck-accessibility-help-dialog-kbd-shadow-color: hsl(0deg 0% 61%);\n}\n\n.ck.ck-accessibility-help-dialog .ck-accessibility-help-dialog__content {\n\tpadding: var(--ck-spacing-large);\n\tmax-width: var(--ck-accessibility-help-dialog-max-width);\n\tmax-height: var(--ck-accessibility-help-dialog-max-height);\n\toverflow: auto;\n\tuser-select: text;\n\n\tborder: 1px solid transparent;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t* {\n\t\twhite-space: normal;\n\t}\n\n\t/* Hide the main label of the content container. */\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t& h3 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1.2em;\n\t}\n\n\t& h4 {\n\t\tfont-weight: bold;\n\t\tfont-size: 1em;\n\t}\n\n\t& p,\n\t& h3,\n\t& h4,\n\t& table {\n\t\tmargin: 1em 0;\n\t}\n\n\t& dl {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 2fr 1fr;\n\t\tborder-top: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\tborder-bottom: none;\n\n\t\t& dt, & dd {\n\t\t\tborder-bottom: 1px solid var(--ck-accessibility-help-dialog-border-color);\n\t\t\tpadding: .4em 0;\n\t\t}\n\n\t\t& dt {\n\t\t\tgrid-column-start: 1;\n\t\t}\n\n\t\t& dd {\n\t\t\tgrid-column-start: 2;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& kbd, & code {\n\t\tdisplay: inline-block;\n\t\tbackground: var(--ck-accessibility-help-dialog-code-background-color);\n\t\tpadding: .4em;\n\t\tvertical-align: middle;\n\t\tline-height: 1;\n\t\tborder-radius: 2px;\n\t\ttext-align: center;\n\t\tfont-size: .9em;\n\t}\n\n\t& code {\n\t\tfont-family: monospace;\n\t}\n\n\t& kbd {\n\t\tmin-width: 1.8em;\n\t\tbox-shadow: 0px 1px 1px var(--ck-accessibility-help-dialog-kbd-shadow-color);\n\t\tmargin: 0 1px;\n\n\t\t& + kbd {\n\t\t\tmargin-left: 2px;\n\t\t}\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      178(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid #0000;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,sBAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,oDACD,CAIA,gEACC,iDACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-panel-background);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-panel-background);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4866(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__header h2.ck-form__header__label{flex-grow:1}:root{--ck-form-header-height:44px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}[dir=ltr] .ck.ck-form__header>.ck-icon{margin-right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-form__header>.ck-icon{margin-left:var(--ck-spacing-medium)}.ck.ck-form__header .ck-form__header__label{--ck-font-size-base:15px;font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"],
          names: [],
          mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BAKD,CAHC,8CACC,WACD,CCPD,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAmBD,CAdC,uCAEE,qCAMF,CARA,uCAME,oCAEF,CAEA,4CACC,wBAAyB,CACzB,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t& h2.ck-form__header__label {\n\t\tflex-grow: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-form-header-height: 44px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& > .ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-medium);\n\t\t}\n\t}\n\n\t& .ck-form__header__label {\n\t\t--ck-font-size-base: 15px;\n\t\tfont-weight: bold;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1998(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-highlighted-text mark{background:var(--ck-color-highlight-background);font-size:inherit;font-weight:inherit;line-height:inherit;vertical-align:initial}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/highlightedtext/highlightedtext.css"],
          names: [],
          mappings: "AAKA,6BACC,+CAAgD,CAIhD,iBAAkB,CAFlB,mBAAoB,CACpB,mBAAoB,CAFpB,sBAID",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-highlighted-text mark {\n\tbackground: var(--ck-color-highlight-background);\n\tvertical-align: initial;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tfont-size: inherit;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4106(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
          names: [],
          mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1546(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}@media (prefers-reduced-motion:reduce){.ck.ck-input{transition:none}}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}@media (prefers-reduced-motion:reduce){.ck.ck-input.ck-error{animation:none}}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eDmDD,CA9CA,iECDE,qCD+CF,CA9CA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DAkCD,CAhCC,uCAdD,aAeE,eA+BF,CA9BC,CAEA,mBEvBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YF2BA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BGnCD,oDHsCC,CAGD,sBAEC,sCAAuC,CADvC,+CAUD,CAPC,uCAJD,sBAKE,cAMF,CALC,CAEA,4BGjDD,iDHmDC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\tanimation: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4606(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
          names: [],
          mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6365(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0;transform:translate(calc(var(--ck-spacing-medium)*-1),-6px) scale(.75);transform-origin:100% 0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}@media (prefers-reduced-motion:reduce){.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transition:none}}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:#0000;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:#0000}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eDmHD,CA9GA,2FCDE,qCD+GF,CA3GC,mEACC,UAwCD,CAtCC,gFACC,KAoCD,CArCA,0FAIE,MAAS,CAGT,6DAA+D,CAF/D,oBAgCF,CArCA,0FAWE,OAAU,CAEV,sEAA0E,CAD1E,uBAyBF,CArCA,gFAkBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAH9C,mBAAoB,CAQpB,sBAAuB,CAKvB,+JAQD,CAHC,uCAlCD,gFAmCE,eAEF,CADC,CASD,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,2XAGE,+HAYF,CAfA,2XAOE,wIAQF,CAfA,uWAaC,gBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,gBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t\ttransform-origin: 0 0;\n\t\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t\ttransform-origin: 100% 0;\n\t\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), -6px) scale(.75);\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder):not(.ck-error) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6048(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}:root{--ck-list-button-padding:calc(var(--ck-line-height-base)*0.11*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item>.ck-button{border-radius:0;min-height:unset;width:100%}[dir=ltr] .ck.ck-list__item>.ck-button{text-align:left}[dir=rtl] .ck.ck-list__item>.ck-button{text-align:right}.ck.ck-list__item>.ck-button{padding:var(--ck-list-button-padding)}.ck.ck-list__item>.ck-button:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item>.ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item>.ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item>.ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item>.ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item>.ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item>.ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck-list .ck-list__group{padding-top:var(--ck-spacing-medium);:not(.ck-hidden)~&{border-top:1px solid var(--ck-color-base-border)}}.ck-list .ck-list__group>.ck-label{font-size:11px;font-weight:700;padding:var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium)}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEdD,MACC,qJAGD,CAEA,YCLC,eDUD,CALA,+DCDE,qCDMF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAGC,eAAgB,CAFhB,gBAAiB,CACjB,UAwCD,CA1CA,uCAME,eAoCF,CA1CA,uCAUE,gBAgCF,CA1CA,6BAgBC,qCA0BD,CAxBC,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,yBACC,oCAAqC,CAGrC,mBACC,gDACD,CAOD,CALC,mCACC,cAAe,CACf,eAAiB,CACjB,oFACD,CAGD,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-list-button-padding:\n\t\tcalc(.11 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n}\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& > .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\tborder-radius: 0;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding: var(--ck-list-button-padding);\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& > .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-list .ck-list__group {\n\tpadding-top: var(--ck-spacing-medium);\n\n\t/* The group should have a border when it\'s not the first item. */\n\t*:not(.ck-hidden) ~ & {\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& > .ck-label {\n\t\tfont-size: 11px;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium);\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4782(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-menu-bar{background:var(--ck-color-base-background);border:1px solid var(--ck-color-toolbar-border);display:flex;flex-wrap:wrap;gap:var(--ck-spacing-small);justify-content:flex-start;padding:var(--ck-spacing-small);width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubar.css"],
          names: [],
          mappings: "AAKA,gBAIC,0CAA2C,CAG3C,+CAAgD,CANhD,YAAa,CACb,cAAe,CAIf,2BAA4B,CAH5B,0BAA2B,CAE3B,+BAAgC,CAGhC,UACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-start;\n\tbackground: var(--ck-color-base-background);\n\tpadding: var(--ck-spacing-small);\n\tgap: var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\twidth: 100%;\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      55(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-menu-bar__menu{display:block;font-size:inherit;position:relative}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level{max-width:100%}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenu.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenu.css"],
          names: [],
          mappings: "AAKA,sBACC,aAAc,CCCd,iBAAkB,CDAlB,iBACD,CCCC,kDACC,cACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\tdisplay: block;\n\tposition: relative;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t&.ck-menu-bar__menu_top-level {\n\t\tmax-width: 100%;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5667(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button{padding:var(--ck-list-button-padding);width:100%}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button>.ck-button__label{flex-grow:1;overflow:hidden;text-overflow:ellipsis}.ck.ck-menu-bar__menu>.ck-menu-bar__menu__button.ck-disabled>.ck-button__label{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-menu-bar__menu>.ck-menu-bar__menu__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button{min-height:unset;padding:var(--ck-spacing-small) var(--ck-spacing-medium)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-button__label{line-height:unset;width:unset}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__button .ck-icon{display:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button{border-radius:0}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus{border-color:#0000;box-shadow:none}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(-90deg)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{transform:rotate(90deg)}.ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button.ck-disabled>.ck-menu-bar__menu__button__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-menu-bar__menu:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button>.ck-menu-bar__menu__button__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenubutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenubutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAMC,mFACC,mBAAoB,CACpB,2BACD,CCIA,iDACC,qCAAsC,CACtC,UAuBD,CArBC,mEACC,WAAY,CACZ,eAAgB,CAChB,sBACD,CAEA,+ECdD,kCDgBC,CAGC,qFACC,oCACD,CAIA,qFACC,qCACD,CAOF,6EAEC,gBAAiB,CADjB,wDAgBD,CAbC,+FAEC,iBAAkB,CADlB,WAED,CAEA,mFACC,2BAA4B,CAC5B,4BACD,CAEA,sFACC,YACD,CAMD,mFACC,eAiDD,CA/CC,yFACC,kBAAyB,CACzB,eAKD,CAHC,qGACC,0DACD,CAID,iIACC,+DACD,CAEA,qHACC,mCASD,CAVA,+HAIE,wBAMF,CAVA,+HAQE,uBAEF,CAEA,iICrFD,kCDuFC,CAGC,+HAIC,sCAAuC,CAHvC,gCAID,CAIA,+HACC,+BAAgC,CAGhC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu  {\n\t& > .ck-menu-bar__menu__button > .ck-menu-bar__menu__button__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * All menu buttons.\n\t */\n\t& > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-list-button-padding);\n\t\twidth: 100%;\n\n\t\t& > .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t&.ck-disabled > .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Top-level menu buttons only.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__button {\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tmin-height: unset;\n\n\t\t& .ck-button__label {\n\t\t\twidth: unset;\n\t\t\tline-height: unset;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/*\n\t * Sub-menu buttons.\n\t */\n\t&:not(.ck-menu-bar__menu_top-level) .ck-menu-bar__menu__button {\n\t\tborder-radius: 0;\n\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\n\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: rotate(90deg);\n\t\t\t}\n\t\t}\n\n\t\t&.ck-disabled > .ck-menu-bar__menu__button__arrow {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t& > .ck-menu-bar__menu__button__arrow {\n\t\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t\t/* A space to accommodate the triangle. */\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1214(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-menu-bar-menu-item-min-width:18em}.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item{min-width:var(--ck-menu-bar-menu-item-min-width)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitem.css"],
          names: [],
          mappings: "AAKA,MACC,sCACD,CAEA,kDACC,gDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-item-min-width: 18em;\n}\n\n.ck.ck-menu-bar__menu .ck.ck-menu-bar__menu__item {\n\tmin-width: var(--ck-menu-bar-menu-item-min-width);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5078(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button{border-radius:0}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container,.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container .ck-spinner{--ck-toolbar-spinner-size:20px}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button>.ck-spinner-container{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus{border-color:#0000;box-shadow:none}.ck.ck-menu-bar__menu .ck-button.ck-menu-bar__menu__item__button:focus:not(.ck-on){background:var(--ck-color-button-default-hover-background)}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level>.ck-menu-bar__menu__panel>ul>.ck-menu-bar__menu__item>.ck-menu-bar__menu__item__button:not(:has(.ck-button__icon))>.ck-button__label{margin-left:calc(var(--ck-icon-size) - var(--ck-spacing-small))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenulistitembutton.css"],
          names: [],
          mappings: "AASC,iEACC,eA0BD,CAxBC,0LAGC,8BACD,CAEA,uFAEC,4CAA+C,CAC/C,oCACD,CAMA,uEACC,kBAAyB,CACzB,eAKD,CAHC,mFACC,0DACD,CASD,uLACC,+DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-menu-bar__menu {\n\t/*\n\t * List item buttons.\n\t */\n\t& .ck-button.ck-menu-bar__menu__item__button {\n\t\tborder-radius: 0;\n\n\t\t& > .ck-spinner-container,\n\t\t& > .ck-spinner-container .ck-spinner {\n\t\t\t/* These styles correspond to .ck-icon so that the spinner seamlessly replaces the icon. */\n\t\t\t--ck-toolbar-spinner-size: 20px;\n\t\t}\n\n\t\t& > .ck-spinner-container {\n\t\t\t/* These margins are the same as for .ck-icon. */\n\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/*\n\t\t * Hovered items automatically get focused. Default focus styles look odd\n\t\t * while moving across a huge list of items so let's get rid of them\n\t\t */\n\t\t&:focus {\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\n\t\t\t&:not(.ck-on) {\n\t\t\t\tbackground: var(--ck-color-button-default-hover-background);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * First-level sub-menu item buttons.\n\t */\n\t&.ck-menu-bar__menu_top-level > .ck-menu-bar__menu__panel > ul > .ck-menu-bar__menu__item > .ck-menu-bar__menu__item__button {\n\t\t/* Spacing in buttons that miss the icon. */\n\t\t&:not(:has(.ck-button__icon)) > .ck-button__label {\n\t\t\tmargin-left: calc(var(--ck-icon-size) - var(--ck-spacing-small));\n\t\t}\n\t}\n}\n\n\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4873(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-menu-bar-menu-max-width:75vw;--ck-menu-bar-nested-menu-horizontal-offset:5px}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{max-width:var(--ck-menu-bar-menu-max-width);position:absolute;z-index:var(--ck-z-panel)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw{bottom:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{bottom:auto;top:100%}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{left:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw{right:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{left:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en{bottom:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{right:calc(100% - var(--ck-menu-bar-nested-menu-horizontal-offset))}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{top:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{bottom:0}:root{--ck-menu-bar-menu-panel-max-width:75vw}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{border-radius:0}.ck-rounded-corners .ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;height:fit-content;max-width:var(--ck-menu-bar-menu-panel-max-width)}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_es,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_se{border-top-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_sw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ws{border-top-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_en,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_ne{border-bottom-left-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_nw,.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel.ck-menu-bar__menu__panel_position_wn{border-bottom-right-radius:0}.ck.ck-menu-bar__menu>.ck.ck-menu-bar__menu__panel:focus{outline:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/menubar/menubarmenupanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/menubar/menubarmenupanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MACC,iCAAkC,CAClC,+CACD,CAEA,mDAEC,2CAA4C,CAC5C,iBAAkB,CAFlB,yBAkDD,CA9CC,gLAEC,WACD,CAEA,gLAGC,WAAY,CADZ,QAED,CAEA,gLAEC,MACD,CAEA,gLAEC,OACD,CAEA,gLAEC,kEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CAEA,gLAEC,mEACD,CAEA,wFACC,KACD,CAEA,wFACC,QACD,CCpDD,MACC,uCACD,CAEA,mDCDC,eDmCD,CAlCA,6ICGE,qCD+BF,CAlCA,mDAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CETT,oCAA8B,CFU9B,kBAAmB,CACnB,iDA0BD,CAvBC,gLAEC,wBACD,CAEA,gLAEC,yBACD,CAEA,gLAEC,2BACD,CAEA,gLAEC,4BACD,CAEA,yDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-menu-bar-menu-max-width: 75vw;\n\t--ck-menu-bar-nested-menu-horizontal-offset: 5px;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\tz-index: var(--ck-z-panel);\n\tmax-width: var(--ck-menu-bar-menu-max-width);\n\tposition: absolute;\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tbottom: 100%;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_se,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\ttop: 100%;\n\t\tbottom: auto;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ne,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tleft: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_nw,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tright: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tleft: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_es {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en {\n\t\tbottom: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tright: calc( 100% - var(--ck-menu-bar-nested-menu-horizontal-offset) );\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws {\n\t\ttop: 0px;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn {\n\t\tbottom: 0px;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-menu-bar-menu-panel-max-width: 75vw;\n}\n\n.ck.ck-menu-bar__menu > .ck.ck-menu-bar__menu__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\theight: fit-content;\n\tmax-width: var(--ck-menu-bar-menu-panel-max-width);\n\n\t/* Corner border radius consistent with the button. */\n\t&.ck-menu-bar__menu__panel_position_es,\n\t&.ck-menu-bar__menu__panel_position_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_ws,\n\t&.ck-menu-bar__menu__panel_position_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_en,\n\t&.ck-menu-bar__menu__panel_position_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-menu-bar__menu__panel_position_wn,\n\t&.ck-menu-bar__menu__panel_position_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5615(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-panel)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:#0000 #0000 var(--ck-color-panel-border) #0000;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:#0000 #0000 var(--ck-color-panel-background) #0000;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) #0000 #0000;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) #0000 #0000 #0000;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:#0000 #0000 #0000 var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:#0000 #0000 #0000 var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:#0000 var(--ck-color-panel-border) #0000 #0000;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:#0000 var(--ck-color-panel-background) #0000 #0000;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,kDACD,CAEA,2CACC,+DAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,qDAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,+DAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,oDACD,CAEA,2CACC,+DAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,2DAA8E,CAC9E,mDACD,CAEA,2CACC,+DAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-panel);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9938(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
          names: [],
          mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      3579(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-panel) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-panel) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      7289(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-panel)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-panel); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      871(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-number,.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
          names: [],
          mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAoED,CAlEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA+CF,CA7CE,8CACC,wDAYD,CAVC,4HAEC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDrEH",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text,\n\t\t\t& .ck-input-number {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5540(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{position:absolute;top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{left:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{right:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view .ck-search__reset{position:absolute;top:50%;transform:translateY(-50%)}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{display:block}.ck.ck-search>.ck-search__results>.ck-search__info:not(.ck-hidden)~*{display:none}:root{--ck-search-field-view-horizontal-spacing:calc(var(--ck-icon-size) + var(--ck-spacing-medium))}.ck.ck-search>.ck-labeled-field-view .ck-input{width:100%}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon{--ck-labeled-field-label-default-position-x:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon>.ck-labeled-field-view__input-wrapper>.ck-icon{opacity:.5;pointer-events:none}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input,[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input:not(.ck-input-text_empty){padding-left:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset{--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset.ck-labeled-field-view_empty{--ck-labeled-field-empty-unfocused-max-width:100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{background:none;min-height:auto;min-width:auto;opacity:.5;padding:0}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{left:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset:hover{opacity:1}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input:not(.ck-input-text_empty),[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{padding-right:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-search__results{min-width:100%}.ck.ck-search>.ck-search__results>.ck-search__info{padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-search>.ck-search__results>.ck-search__info *{white-space:normal}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{font-weight:700}.ck.ck-search>.ck-search__results>.ck-search__info>span:last-child{margin-top:var(--ck-spacing-medium)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/search/search.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/search/search.css"],
          names: [],
          mappings: "AASE,oFACC,iBAAkB,CAClB,OAAQ,CACR,0BASD,CAZA,8FAME,6BAMF,CAZA,8FAUE,8BAEF,CAEA,uDACC,iBAAkB,CAClB,OAAQ,CACR,0BACD,CAKC,oEACC,aACD,CAGA,qEACC,YACD,CChCH,MACC,8FACD,CAIE,+CACC,UACD,CAEA,gEACC,0FAoBD,CAlBC,+GACC,UAAW,CACX,mBACD,CAEA,0EACC,UAWD,CAJE,kMACC,2DACD,CAKH,iEACC,sGAwCD,CAtCC,6FACC,6HACD,CAEA,mFAIC,eAAgB,CAFhB,eAAgB,CADhB,cAAe,CAIf,UAAW,CACX,SAaD,CAnBA,6FASE,8BAUF,CAnBA,6FAaE,6BAMF,CAHC,yFACC,SACD,CAGD,2EACC,UAWD,CAZA,oMAUE,4DAEF,CAIF,kCACC,cAkBD,CAhBC,mDAEC,wDAAyD,CADzD,UAcD,CAXC,qDACC,kBACD,CAEA,oEACC,eACD,CAEA,mEACC,mCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-search__reset {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\t& > .ck-search__info {\n\t\t\t& > span:first-child {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t/* Hide the filtered view when nothing was found */\n\t\t\t&:not(.ck-hidden) ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-search-field-view-horizontal-spacing: calc(var(--ck-icon-size) + var(--ck-spacing-medium));\n}\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& .ck-input {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&.ck-search__query_with-icon {\n\t\t\t--ck-labeled-field-label-default-position-x: var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\t\topacity: .5;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-search__query_with-reset {\n\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t&.ck-labeled-field-view_empty {\n\t\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t& .ck-search__reset {\n\t\t\t\tmin-width: auto;\n\t\t\t\tmin-height: auto;\n\n\t\t\t\tbackground: none;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding: 0;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\tmin-width: 100%;\n\n\t\t& > .ck-search__info {\n\t\t\twidth: 100%;\n\t\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\n\t\t\t& * {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\n\t\t\t& > span:first-child {\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t& > span:last-child {\n\t\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\t}\n}\n\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      5706(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-spinner-container{display:block;position:relative}.ck.ck-spinner{left:0;margin:0 auto;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:1}:root{--ck-toolbar-spinner-size:18px}.ck.ck-spinner-container{animation:rotate 1.5s linear infinite;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@media (prefers-reduced-motion:reduce){.ck.ck-spinner-container{animation-duration:3s}}.ck.ck-spinner{border:2px solid var(--ck-color-text);border-radius:50%;border-top:2px solid #0000;height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}@keyframes rotate{to{transform:rotate(1turn)}}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/spinner/spinner.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/spinner/spinner.css"],
          names: [],
          mappings: "AASA,yBACC,aAAc,CACd,iBACD,CAEA,eAGC,MAAO,CAEP,aAAc,CAJd,iBAAkB,CAGlB,OAAQ,CAFR,OAAQ,CAIR,0BAA2B,CAC3B,SACD,CCjBA,MACC,8BACD,CAEA,yBAGC,qCAAsC,CADtC,qCAAsC,CADtC,oCAOD,CAHC,uCALD,yBAME,qBAEF,CADC,CAGD,eAKC,qCAA6B,CAF7B,iBAAkB,CAElB,0BAA6B,CAH7B,qCAAsC,CADtC,oCAKD,CAEA,kBACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\tdisplay: block;\n\tposition: relative;\n}\n\n.ck.ck-spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\tz-index: 1;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tanimation: 1.5s infinite rotate linear;\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\tanimation-duration: 3s;\n\t}\n}\n\n.ck.ck-spinner {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--ck-color-text);\n\tborder-top-color: transparent;\n}\n\n@keyframes rotate {\n\tto {\n\t\ttransform: rotate(360deg)\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      8368(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-textarea{overflow-x:hidden}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/textarea/textarea.css"],
          names: [],
          mappings: "AASA,aACC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/*\n * This fixes a problem in Firefox when the initial height of the complement does not match the number of rows.\n * This bug is especially visible when rows=1.\n */\n.ck-textarea {\n\toverflow-x: hidden\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      9939(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"],
          names: [],
          mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      66(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck.ck-toolbar:focus{outline:none}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDwGD,CA3GA,qECOE,qCDoGF,CA3GA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAuGD,CApGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAGD,qBACC,YACD,CAtGD,qCAyGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      4650(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-balloon-panel.ck-tooltip{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;z-index:calc(var(--ck-z-dialog) + 100);--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-tooltip-text-padding:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip.ck-tooltip_multi-line .ck-tooltip__text{display:inline-block;max-width:200px;padding:var(--ck-tooltip-text-padding) 0;white-space:break-spaces}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css"],
          names: [],
          mappings: "AAOA,gCCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,sCAAyC,CEFzC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,6BAA8B,CAC9B,8DAA+D,CAE/D,kCFJD,CEMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAEA,wEAEC,oBAAqB,CAErB,eAAgB,CADhB,wCAAyC,CAFzC,wBAID,CArBD,gCAwBC,eAMD,CAHC,uCACC,YACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t@mixin ck-unselectable;\n\n\tz-index: calc( var(--ck-z-dialog) + 100 );\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-tooltip-text-padding: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t&.ck-tooltip_multi-line .ck-tooltip__text {\n\t\twhite-space: break-spaces;\n\t\tdisplay: inline-block;\n\t\tpadding: var(--ck-tooltip-text-padding) 0;\n\t\tmax-width: 200px;\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      601(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck-hidden{display:none!important}:root{--ck-z-default:1;--ck-z-panel:calc(var(--ck-z-default) + 999);--ck-z-dialog:9999}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-powered-by-line-height:10px;--ck-powered-by-padding-vertical:2px;--ck-powered-by-padding-horizontal:4px;--ck-powered-by-text-color:#4f4f4f;--ck-powered-by-border-radius:var(--ck-border-radius);--ck-powered-by-background:#fff;--ck-powered-by-border-color:var(--ck-color-focus-border)}.ck.ck-balloon-panel.ck-powered-by-balloon{--ck-border-radius:var(--ck-powered-by-border-radius);background:var(--ck-powered-by-background);box-shadow:none;min-height:unset;z-index:calc(var(--ck-z-panel) - 1)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{line-height:var(--ck-powered-by-line-height)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by a{align-items:center;cursor:pointer;display:flex;filter:grayscale(80%);line-height:var(--ck-powered-by-line-height);opacity:.66;padding:var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-powered-by__label{color:var(--ck-powered-by-text-color);cursor:pointer;font-size:7.5px;font-weight:700;letter-spacing:-.2px;line-height:normal;margin-right:4px;padding-left:2px;text-transform:uppercase}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-icon{cursor:pointer;display:block}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by:hover a{filter:grayscale(0);opacity:1}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_inside]{border-color:#0000}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_border]{border:var(--ck-focus-ring);border-color:var(--ck-powered-by-border-color)}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:#77baf84d;--ck-color-focus-error-shadow:#ff401f4d;--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:#00000026;--ck-color-shadow-drop-active:#0003;--ck-color-shadow-inner:#0000001a;--ck-color-button-default-background:#0000;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:#0000;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:#0000001a;--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-dialog-background:var(--ck-custom-background);--ck-color-dialog-form-header-border:var(--ck-custom-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:#1fb0ff1a;--ck-color-link-fake-selection:#1fb0ff4d;--ck-color-highlight-background:#ff0;--ck-color-light-red:#fcc;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{background:#0000;border:0;box-sizing:border-box;height:auto;margin:0;padding:0;position:static;text-decoration:none;transition:none;vertical-align:middle;width:auto;word-wrap:break-word}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_poweredby.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
          names: [],
          mappings: "AAQA,WAGC,sBACD,CCPA,MACC,gBAAiB,CACjB,4CAA+C,CAC/C,kBACD,CCDA,oDAEC,yBACD,CCNA,MACC,gCAAiC,CACjC,oCAAqC,CACrC,sCAAuC,CACvC,kCAA2C,CAC3C,qDAAsD,CACtD,+BAA4C,CAC5C,yDACD,CAEA,2CACC,qDAAsD,CAGtD,0CAA2C,CAD3C,eAAgB,CAEhB,gBAAiB,CACjB,mCAiDD,CA/CC,6DACC,4CAoCD,CAlCC,+DAGC,kBAAmB,CAFnB,cAAe,CACf,YAAa,CAGb,qBAAsB,CACtB,4CAA6C,CAF7C,WAAY,CAGZ,qFACD,CAEA,mFASC,qCAAsC,CAFtC,cAAe,CANf,eAAgB,CAIhB,eAAiB,CAHjB,oBAAqB,CAMrB,kBAAmB,CAFnB,gBAAiB,CAHjB,gBAAiB,CACjB,wBAOD,CAEA,sEAEC,cAAe,CADf,aAED,CAGC,qEACC,mBAAqB,CACrB,SACD,CAIF,mEACC,kBACD,CAEA,mEACC,2BAA4B,CAC5B,8CACD,CChED,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,0CAA8D,CAC9D,uCAAyD,CACzD,yCAAqD,CACrD,gCAAsD,CACtD,mCAA0D,CAC1D,iCAAsD,CAItD,0CAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,mDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,+CAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,wDAAiE,CACjE,4DAAmE,CAInE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,6CAAmE,CACnE,wCAAgE,CAIhE,oCAAyD,CAIzD,yBAAgD,CChHhD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJgHD,CI1GA,2EAYC,gBAAuB,CADvB,QAAS,CART,qBAAsB,CAEtB,WAAY,CAIZ,QAAS,CACT,SAAU,CAJV,eAAgB,CAOhB,oBAAqB,CAErB,eAAgB,CADhB,qBAAsB,CAVtB,UAAW,CAcX,oBACD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCxFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-panel: calc( var(--ck-z-default) + 999 );\n\t--ck-z-dialog: 9999;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-powered-by-line-height: 10px;\n\t--ck-powered-by-padding-vertical: 2px;\n\t--ck-powered-by-padding-horizontal: 4px;\n\t--ck-powered-by-text-color: hsl(0, 0%, 31%);\n\t--ck-powered-by-border-radius: var(--ck-border-radius);\n\t--ck-powered-by-background: hsl(0, 0%, 100%);\n\t--ck-powered-by-border-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-balloon-panel.ck-powered-by-balloon {\n\t--ck-border-radius: var(--ck-powered-by-border-radius);\n\n\tbox-shadow: none;\n\tbackground: var(--ck-powered-by-background);\n\tmin-height: unset;\n\tz-index: calc( var(--ck-z-panel) - 1 );\n\n\t& .ck.ck-powered-by {\n\t\tline-height: var(--ck-powered-by-line-height);\n\n\t\t& a {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\topacity: .66;\n\t\t\tfilter: grayscale(80%);\n\t\t\tline-height: var(--ck-powered-by-line-height);\n\t\t\tpadding: var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal);\n\t\t}\n\n\t\t& .ck-powered-by__label {\n\t\t\tfont-size: 7.5px;\n\t\t\tletter-spacing: -.2px;\n\t\t\tpadding-left: 2px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-right: 4px;\n\t\t\tcursor: pointer;\n\t\t\tline-height: normal;\n\t\t\tcolor: var(--ck-powered-by-text-color);\n\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: block;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&:hover {\n\t\t\t& a {\n\t\t\t\tfilter: grayscale(0%);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[class*="position_inside"] {\n\t\tborder-color: transparent;\n\t}\n\n\t&[class*="position_border"] {\n\t\tborder: var(--ck-focus-ring);\n\t\tborder-color: var(--ck-powered-by-border-color);\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Dialog -------------------------------------------------------------------------------- */\n\n\t--ck-color-dialog-background: \t\t\t\t\t\t\t\tvar(--ck-custom-background);\n\t--ck-color-dialog-form-header-border: \t\t\t\t\t\tvar(--ck-custom-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------- */\n\n\t--ck-color-light-red:\t\t\t\t\t\t\t\t\t\thsl(0, 100%, 90%);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      1216(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:#0000;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget{transition:none}}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid #0000}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}@media (forced-colors:none){.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background)}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:initial;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}@media (prefers-reduced-motion:reduce){.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{transition:none}}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css"],
          names: [],
          mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CChFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,mBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAcD,CAZC,uCAND,eAOE,eAWF,CAVC,CAEA,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,sBAYD,CARC,yGCnCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YD2CA,CGvCA,4BACC,yGHoCC,iEGlCD,CACD,CHuCA,4EAKC,wBAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAwCD,CA3BC,uCAzBD,4EA0BE,eA0BF,CAzBC,CAEA,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAeD,CAVC,kHACC,SAAU,CAGV,+DAKD,CAHC,uCAND,kHAOE,eAEF,CADC,CAKF,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_mediacolors.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t@media (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t\t@mixin ck-media-default-colors {\n\t\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t\t}\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\n\t\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\t\ttransition: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-forced-colors {\n\t@media (forced-colors: active) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n\n@define-mixin ck-media-default-colors {\n\t@media (forced-colors: none) {\n\t\t& {\n\t\t\t@mixin-content;\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      2060(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"],
          names: [],
          mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6779(t, e, n) {
        "use strict";

        n.d(e, {
          A: () => a
        });
        var i = n(4991),
          o = n.n(i),
          r = n(6314),
          s = n.n(r)()(o());
        s.push([t.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button svg{transition:none}}.ck .ck-widget .ck-widget__type-around__button svg *{fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-dasharray:10;stroke-dashoffset:0;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}@media (prefers-reduced-motion:reduce){.ck .ck-widget .ck-widget__type-around__button:hover,.ck .ck-widget .ck-widget__type-around__button:hover svg line,.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:none}}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,#fff0,#ffffff4d);border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid #ffffff80;pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:#0000}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
          names: [],
          mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAwED,CAhEC,uCATD,+CAUE,eA+DF,CA9DC,CAEA,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAwBD,CAlBC,uCAPD,mDAQE,eAiBF,CAhBC,CAEA,qDAIC,SAAU,CACV,qDAAsD,CAJtD,mBAAoB,CACpB,mBAAoB,CAKpB,oBAAqB,CACrB,qBAAsB,CAFtB,kBAGD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DA4BD,CAtBE,kEACC,oDACD,CAEA,8DACC,wDACD,CAGD,uCAQE,qLACC,cACD,CAEF,CASD,uKA7FD,SAAU,CACV,mBA8FC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,kDAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,2BAAwC,CARxC,mBAUD,CAOC,6JAEC,mBACD,CAUA,yKACC,iDACD,CAMA,uOAxKD,SAAU,CACV,mBAyKC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAxNF,SAAU,CACV,mBAyNE,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\ttransition: none;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\ttransition: none;\n\t\t\t}\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@media (prefers-reduced-motion: reduce) {\n\t\t\t\tanimation: none;\n\n\t\t\t\t& svg {\n\t\t\t\t\t& polyline {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t& line {\n\t\t\t\t\t\tanimation: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
          sourceRoot: ""
        }]);
        const a = s;
      },
      6314(t) {
        "use strict";

        t.exports = function (t) {
          var e = [];
          return e.toString = function () {
            return this.map(function (e) {
              var n = t(e);
              return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
            }).join("");
          }, e.i = function (t, n, i) {
            "string" == typeof t && (t = [[null, t, ""]]);
            var o = {};
            if (i) for (var r = 0; r < this.length; r++) {
              var s = this[r][0];
              null != s && (o[s] = !0);
            }
            for (var a = 0; a < t.length; a++) {
              var l = [].concat(t[a]);
              i && o[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), e.push(l));
            }
          }, e;
        };
      },
      4991(t) {
        "use strict";

        function e(t, e) {
          return function (t) {
            if (Array.isArray(t)) return t;
          }(t) || function (t, e) {
            var n = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
            if (null == n) return;
            var i,
              o,
              r = [],
              s = !0,
              a = !1;
            try {
              for (n = n.call(t); !(s = (i = n.next()).done) && (r.push(i.value), !e || r.length !== e); s = !0);
            } catch (t) {
              a = !0, o = t;
            } finally {
              try {
                s || null == n.return || n.return();
              } finally {
                if (a) throw o;
              }
            }
            return r;
          }(t, e) || function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return n(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(t);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return n(t, e);
          }(t, e) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function n(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
          return i;
        }
        t.exports = function (t) {
          var n = e(t, 4),
            i = n[1],
            o = n[3];
          if (!o) return i;
          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(o)))),
              s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
              a = "/*# ".concat(s, " */"),
              l = o.sources.map(function (t) {
                return "/*# sourceURL=".concat(o.sourceRoot || "").concat(t, " */");
              });
            return [i].concat(l).concat([a]).join("\n");
          }
          return [i].join("\n");
        };
      },
      5072(t, e, n) {
        "use strict";

        var i,
          o = function () {
            return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
          },
          r = function () {
            var t = {};
            return function (e) {
              if (void 0 === t[e]) {
                var n = document.querySelector(e);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                  n = n.contentDocument.head;
                } catch (t) {
                  n = null;
                }
                t[e] = n;
              }
              return t[e];
            };
          }(),
          s = [];
        function a(t) {
          for (var e = -1, n = 0; n < s.length; n++) if (s[n].identifier === t) {
            e = n;
            break;
          }
          return e;
        }
        function l(t, e) {
          for (var n = {}, i = [], o = 0; o < t.length; o++) {
            var r = t[o],
              l = e.base ? r[0] + e.base : r[0],
              c = n[l] || 0,
              d = "".concat(l, " ").concat(c);
            n[l] = c + 1;
            var u = a(d),
              h = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== u ? (s[u].references++, s[u].updater(h)) : s.push({
              identifier: d,
              updater: f(h, e),
              references: 1
            }), i.push(d);
          }
          return i;
        }
        function c(t) {
          var e = document.createElement("style"),
            i = t.attributes || {};
          if (void 0 === i.nonce) {
            var o = n.nc;
            o && (i.nonce = o);
          }
          if (Object.keys(i).forEach(function (t) {
            e.setAttribute(t, i[t]);
          }), "function" == typeof t.insert) t.insert(e);else {
            var s = r(t.insert || "head");
            if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s.appendChild(e);
          }
          return e;
        }
        var d,
          u = (d = [], function (t, e) {
            return d[t] = e, d.filter(Boolean).join("\n");
          });
        function h(t, e, n, i) {
          var o = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
          if (t.styleSheet) t.styleSheet.cssText = u(e, o);else {
            var r = document.createTextNode(o),
              s = t.childNodes;
            s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
          }
        }
        function m(t, e, n) {
          var i = n.css,
            o = n.media,
            r = n.sourceMap;
          if (o ? t.setAttribute("media", o) : t.removeAttribute("media"), r && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
            for (; t.firstChild;) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(i));
          }
        }
        var g = null,
          p = 0;
        function f(t, e) {
          var n, i, o;
          if (e.singleton) {
            var r = p++;
            n = g || (g = c(e)), i = h.bind(null, n, r, !1), o = h.bind(null, n, r, !0);
          } else n = c(e), i = m.bind(null, n, e), o = function () {
            !function (t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            }(n);
          };
          return i(t), function (e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
              i(t = e);
            } else o();
          };
        }
        t.exports = function (t, e) {
          (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = o());
          var n = l(t = t || [], e);
          return function (t) {
            if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
              for (var i = 0; i < n.length; i++) {
                var o = a(n[i]);
                s[o].references--;
              }
              for (var r = l(t, e), c = 0; c < n.length; c++) {
                var d = a(n[c]);
                0 === s[d].references && (s[d].updater(), s.splice(d, 1));
              }
              n = r;
            }
          };
        };
      }
    },
    i = {};
  function o(t) {
    var e = i[t];
    if (void 0 !== e) return e.exports;
    var r = i[t] = {
      id: t,
      exports: {}
    };
    return n[t](r, r.exports, o), r.exports;
  }
  o.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return o.d(e, {
      a: e
    }), e;
  }, e = Object.getPrototypeOf ? t => Object.getPrototypeOf(t) : t => t.__proto__, o.t = function (n, i) {
    if (1 & i && (n = this(n)), 8 & i) return n;
    if ("object" == typeof n && n) {
      if (4 & i && n.__esModule) return n;
      if (16 & i && "function" == typeof n.then) return n;
    }
    var r = Object.create(null);
    o.r(r);
    var s = {};
    t = t || [null, e({}), e([]), e(e)];
    for (var a = 2 & i && n; ("object" == typeof a || "function" == typeof a) && !~t.indexOf(a); a = e(a)) Object.getOwnPropertyNames(a).forEach(t => s[t] = () => n[t]);
    return s.default = () => n, o.d(r, s), r;
  }, o.d = (t, e) => {
    for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
      enumerable: !0,
      get: e[n]
    });
  }, o.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), o.r = t => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.nc = void 0;
  var r = {};
  return (() => {
    "use strict";

    let t;
    o.d(r, {
      default: () => Iz
    });
    try {
      t = {
        window,
        document
      };
    } catch (e) {
      t = {
        window: {},
        document: {}
      };
    }
    const e = t;
    const n = function () {
        try {
          return navigator.userAgent.toLowerCase();
        } catch (t) {
          return "";
        }
      }(),
      i = {
        isMac: a(n),
        isWindows: function (t) {
          return t.indexOf("windows") > -1;
        }(n),
        isGecko: function (t) {
          return !!t.match(/gecko\/\d+/);
        }(n),
        isSafari: function (t) {
          return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
        }(n),
        isiOS: function (t) {
          return !!t.match(/iphone|ipad/i) || a(t) && navigator.maxTouchPoints > 0;
        }(n),
        isAndroid: function (t) {
          return t.indexOf("android") > -1;
        }(n),
        isBlink: function (t) {
          return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
        }(n),
        get isMediaForcedColors() {
          return !!e.window.matchMedia && e.window.matchMedia("(forced-colors: active)").matches;
        },
        get isMotionReduced() {
          return !!e.window.matchMedia && e.window.matchMedia("(prefers-reduced-motion)").matches;
        },
        features: {
          isRegExpUnicodePropertySupported: function () {
            let t = !1;
            try {
              t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
            } catch (t) {}
            return t;
          }()
        }
      },
      s = i;
    function a(t) {
      return t.indexOf("macintosh") > -1;
    }
    function l(t, e, n, i) {
      n = n || function (t, e) {
        return t === e;
      };
      const o = Array.isArray(t) ? t : Array.prototype.slice.call(t),
        r = Array.isArray(e) ? e : Array.prototype.slice.call(e),
        s = function (t, e, n) {
          const i = c(t, e, n);
          if (-1 === i) return {
            firstIndex: -1,
            lastIndexOld: -1,
            lastIndexNew: -1
          };
          const o = d(t, i),
            r = d(e, i),
            s = c(o, r, n),
            a = t.length - s,
            l = e.length - s;
          return {
            firstIndex: i,
            lastIndexOld: a,
            lastIndexNew: l
          };
        }(o, r, n),
        a = i ? function (t, e) {
          const {
            firstIndex: n,
            lastIndexOld: i,
            lastIndexNew: o
          } = t;
          if (-1 === n) return Array(e).fill("equal");
          let r = [];
          n > 0 && (r = r.concat(Array(n).fill("equal")));
          o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
          i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
          o < e && (r = r.concat(Array(e - o).fill("equal")));
          return r;
        }(s, r.length) : function (t, e) {
          const n = [],
            {
              firstIndex: i,
              lastIndexOld: o,
              lastIndexNew: r
            } = e;
          r - i > 0 && n.push({
            index: i,
            type: "insert",
            values: t.slice(i, r)
          });
          o - i > 0 && n.push({
            index: i + (r - i),
            type: "delete",
            howMany: o - i
          });
          return n;
        }(r, s);
      return a;
    }
    function c(t, e, n) {
      for (let i = 0; i < Math.max(t.length, e.length); i++) if (void 0 === t[i] || void 0 === e[i] || !n(t[i], e[i])) return i;
      return -1;
    }
    function d(t, e) {
      return t.slice(e).reverse();
    }
    function u(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };
      const i = t.length,
        o = e.length;
      if (i > 200 || o > 200 || i + o > 300) return u.fastDiff(t, e, n, !0);
      let r, s;
      if (o < i) {
        const n = t;
        t = e, e = n, r = "delete", s = "insert";
      } else r = "insert", s = "delete";
      const a = t.length,
        l = e.length,
        c = l - a,
        d = {},
        h = {};
      function m(i) {
        const o = (void 0 !== h[i - 1] ? h[i - 1] : -1) + 1,
          c = void 0 !== h[i + 1] ? h[i + 1] : -1,
          u = o > c ? -1 : 1;
        d[i + u] && (d[i] = d[i + u].slice(0)), d[i] || (d[i] = []), d[i].push(o > c ? r : s);
        let m = Math.max(o, c),
          g = m - i;
        for (; g < a && m < l && n(t[g], e[m]);) g++, m++, d[i].push("equal");
        return m;
      }
      let g,
        p = 0;
      do {
        for (g = -p; g < c; g++) h[g] = m(g);
        for (g = c + p; g > c; g--) h[g] = m(g);
        h[c] = m(c), p++;
      } while (h[c] !== l);
      return d[c].slice(1);
    }
    u.fastDiff = l;
    const h = function () {
      return function t() {
        t.called = !0;
      };
    };
    class m {
      constructor(t, e) {
        this.source = t, this.name = e, this.path = [], this.stop = h(), this.off = h();
      }
    }
    const g = new Array(256).fill("").map((t, e) => ("0" + e.toString(16)).slice(-2));
    function p() {
      const t = 4294967296 * Math.random() >>> 0,
        e = 4294967296 * Math.random() >>> 0,
        n = 4294967296 * Math.random() >>> 0,
        i = 4294967296 * Math.random() >>> 0;
      return "e" + g[255 & t] + g[t >> 8 & 255] + g[t >> 16 & 255] + g[t >> 24 & 255] + g[255 & e] + g[e >> 8 & 255] + g[e >> 16 & 255] + g[e >> 24 & 255] + g[255 & n] + g[n >> 8 & 255] + g[n >> 16 & 255] + g[n >> 24 & 255] + g[255 & i] + g[i >> 8 & 255] + g[i >> 16 & 255] + g[i >> 24 & 255];
    }
    const f = {
      get() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "normal";
        return "number" != typeof t ? this[t] || this.normal : t;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    function k(t, e) {
      const n = f.get(e.priority);
      for (let i = 0; i < t.length; i++) if (f.get(t[i].priority) < n) return void t.splice(i, 0, e);
      t.push(e);
    }
    class b extends Error {
      constructor(t, e, n) {
        super(function (t, e) {
          const n = new WeakSet(),
            i = (t, e) => {
              if ("object" == typeof e && null !== e) {
                if (n.has(e)) return `[object ${e.constructor.name}]`;
                n.add(e);
              }
              return e;
            },
            o = e ? ` ${JSON.stringify(e, i)}` : "",
            r = A(t);
          return t + o + r;
        }(t, n)), this.name = "CKEditorError", this.context = e, this.data = n;
      }
      is(t) {
        return "CKEditorError" === t;
      }
      static rethrowUnexpectedError(t, e) {
        if (t.is && t.is("CKEditorError")) throw t;
        const n = new b(t.message, e);
        throw n.stack = t.stack, n;
      }
    }
    function w(t, e) {
      console.warn(...C(t, e));
    }
    function A(t) {
      return `\nRead more: https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html#error-${t}`;
    }
    function C(t, e) {
      const n = A(t);
      return e ? [t, e, n] : [t, n];
    }
    const _ = "41.4.2",
      v = new Date(2024, 4, 17);
    if (globalThis.CKEDITOR_VERSION) throw new b("ckeditor-duplicated-modules", null);
    globalThis.CKEDITOR_VERSION = _;
    const y = Symbol("listeningTo"),
      x = Symbol("emitterId"),
      E = Symbol("delegations"),
      D = B(Object);
    function B(t) {
      if (!t) return D;
      return class extends t {
        on(t, e, n) {
          this.listenTo(this, t, e, n);
        }
        once(t, e, n) {
          var _this = this;
          let i = !1;
          this.listenTo(this, t, function (t) {
            for (var _len3 = arguments.length, n = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              n[_key3 - 1] = arguments[_key3];
            }
            i || (i = !0, t.off(), e.call(_this, t, ...n));
          }, n);
        }
        off(t, e) {
          this.stopListening(this, t, e);
        }
        listenTo(t, e, n) {
          let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          let o, r;
          this[y] || (this[y] = {});
          const s = this[y];
          T(t) || S(t);
          const a = T(t);
          (o = s[a]) || (o = s[a] = {
            emitter: t,
            callbacks: {}
          }), (r = o.callbacks[e]) || (r = o.callbacks[e] = []), r.push(n), function (t, e, n, i, o) {
            e._addEventListener ? e._addEventListener(n, i, o) : t._addEventListener.call(e, n, i, o);
          }(this, t, e, n, i);
        }
        stopListening(t, e, n) {
          const i = this[y];
          let o = t && T(t);
          const r = i && o ? i[o] : void 0,
            s = r && e ? r.callbacks[e] : void 0;
          if (!(!i || t && !r || e && !s)) if (n) {
            P(this, t, e, n);
            -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[e] : P(this, t, e, n));
          } else if (s) {
            for (; n = s.pop();) P(this, t, e, n);
            delete r.callbacks[e];
          } else if (r) {
            for (e in r.callbacks) this.stopListening(t, e);
            delete i[o];
          } else {
            for (o in i) this.stopListening(i[o].emitter);
            delete this[y];
          }
        }
        fire(t) {
          try {
            const n = t instanceof m ? t : new m(this, t),
              i = n.name;
            let o = N(this, i);
            for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              e[_key4 - 1] = arguments[_key4];
            }
            if (n.path.push(this), o) {
              const t = [n, ...e];
              o = Array.from(o);
              for (let e = 0; e < o.length && (o[e].callback.apply(this, t), n.off.called && (delete n.off.called, this._removeEventListener(i, o[e].callback)), !n.stop.called); e++);
            }
            const r = this[E];
            if (r) {
              const t = r.get(i),
                o = r.get("*");
              t && z(t, n, e), o && z(o, n, e);
            }
            return n.return;
          } catch (t) {
            b.rethrowUnexpectedError(t, this);
          }
        }
        delegate() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }
          return {
            to: (e, n) => {
              this[E] || (this[E] = new Map()), t.forEach(t => {
                const i = this[E].get(t);
                i ? i.set(e, n) : this[E].set(t, new Map([[e, n]]));
              });
            }
          };
        }
        stopDelegating(t, e) {
          if (this[E]) if (t) {
            if (e) {
              const n = this[E].get(t);
              n && n.delete(e);
            } else this[E].delete(t);
          } else this[E].clear();
        }
        _addEventListener(t, e, n) {
          !function (t, e) {
            const n = I(t);
            if (n[e]) return;
            let i = e,
              o = null;
            const r = [];
            for (; "" !== i && !n[i];) n[i] = M(), r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
            if ("" !== i) {
              for (const t of r) t.callbacks = n[i].callbacks.slice();
              n[i].childEvents.push(o);
            }
          }(this, t);
          const i = L(this, t),
            o = {
              callback: e,
              priority: f.get(n.priority)
            };
          for (const t of i) k(t, o);
        }
        _removeEventListener(t, e) {
          const n = L(this, t);
          for (const t of n) for (let n = 0; n < t.length; n++) t[n].callback == e && (t.splice(n, 1), n--);
        }
      };
    }
    function S(t, e) {
      t[x] || (t[x] = e || p());
    }
    function T(t) {
      return t[x];
    }
    function I(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }
    function M() {
      return {
        callbacks: [],
        childEvents: []
      };
    }
    function L(t, e) {
      const n = I(t)[e];
      if (!n) return [];
      let i = [n.callbacks];
      for (let e = 0; e < n.childEvents.length; e++) {
        const o = L(t, n.childEvents[e]);
        i = i.concat(o);
      }
      return i;
    }
    function N(t, e) {
      let n;
      return t._events && (n = t._events[e]) && n.callbacks.length ? n.callbacks : e.indexOf(":") > -1 ? N(t, e.substr(0, e.lastIndexOf(":"))) : null;
    }
    function z(t, e, n) {
      for (let [i, o] of t) {
        o ? "function" == typeof o && (o = o(e.name)) : o = e.name;
        const t = new m(e.source, o);
        t.path = [...e.path], i.fire(t, ...n);
      }
    }
    function P(t, e, n, i) {
      e._removeEventListener ? e._removeEventListener(n, i) : t._removeEventListener.call(e, n, i);
    }
    ["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      B[t] = D.prototype[t];
    });
    const V = function (t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      },
      R = Symbol("observableProperties"),
      F = Symbol("boundObservables"),
      O = Symbol("boundProperties"),
      j = Symbol("decoratedMethods"),
      H = Symbol("decoratedOriginal"),
      U = q(B());
    function q(t) {
      if (!t) return U;
      return class extends t {
        set(t, e) {
          if (V(t)) return void Object.keys(t).forEach(e => {
            this.set(e, t[e]);
          }, this);
          G(this);
          const n = this[R];
          if (t in this && !n.has(t)) throw new b("observable-set-cannot-override", this);
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            get: () => n.get(t),
            set(e) {
              const i = n.get(t);
              let o = this.fire(`set:${t}`, t, e, i);
              void 0 === o && (o = e), i === o && n.has(t) || (n.set(t, o), this.fire(`change:${t}`, t, o, i));
            }
          }), this[t] = e;
        }
        bind() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }
          if (!t.length || !K(t)) throw new b("observable-bind-wrong-properties", this);
          if (new Set(t).size !== t.length) throw new b("observable-bind-duplicate-properties", this);
          G(this);
          const e = this[O];
          t.forEach(t => {
            if (e.has(t)) throw new b("observable-bind-rebind", this);
          });
          const n = new Map();
          return t.forEach(t => {
            const i = {
              property: t,
              to: []
            };
            e.set(t, i), n.set(t, i);
          }), {
            to: W,
            toMany: $,
            _observable: this,
            _bindProperties: t,
            _to: [],
            _bindings: n
          };
        }
        unbind() {
          if (!this[R]) return;
          const e = this[O],
            n = this[F];
          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }
          if (t.length) {
            if (!K(t)) throw new b("observable-unbind-wrong-properties", this);
            t.forEach(t => {
              const i = e.get(t);
              i && (i.to.forEach(_ref => {
                let [t, e] = _ref;
                const o = n.get(t),
                  r = o[e];
                r.delete(i), r.size || delete o[e], Object.keys(o).length || (n.delete(t), this.stopListening(t, "change"));
              }), e.delete(t));
            });
          } else n.forEach((t, e) => {
            this.stopListening(e, "change");
          }), n.clear(), e.clear();
        }
        decorate(t) {
          G(this);
          const e = this[t];
          if (!e) throw new b("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: t
          });
          this.on(t, (t, n) => {
            t.return = e.apply(this, n);
          }), this[t] = function () {
            for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              e[_key8] = arguments[_key8];
            }
            return this.fire(t, e);
          }, this[t][H] = e, this[j] || (this[j] = []), this[j].push(t);
        }
        stopListening(t, e, n) {
          if (!t && this[j]) {
            for (const t of this[j]) this[t] = this[t][H];
            delete this[j];
          }
          super.stopListening(t, e, n);
        }
      };
    }
    function G(t) {
      t[R] || (Object.defineProperty(t, R, {
        value: new Map()
      }), Object.defineProperty(t, F, {
        value: new Map()
      }), Object.defineProperty(t, O, {
        value: new Map()
      }));
    }
    function W() {
      const e = function () {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }
          if (!t.length) throw new b("observable-bind-to-parse-error", null);
          const e = {
            to: []
          };
          let n;
          "function" == typeof t[t.length - 1] && (e.callback = t.pop());
          return t.forEach(t => {
            if ("string" == typeof t) n.properties.push(t);else {
              if ("object" != typeof t) throw new b("observable-bind-to-parse-error", null);
              n = {
                observable: t,
                properties: []
              }, e.to.push(n);
            }
          }), e;
        }(...arguments),
        n = Array.from(this._bindings.keys()),
        i = n.length;
      if (!e.callback && e.to.length > 1) throw new b("observable-bind-to-no-callback", this);
      if (i > 1 && e.callback) throw new b("observable-bind-to-extra-callback", this);
      var o;
      e.to.forEach(t => {
        if (t.properties.length && t.properties.length !== i) throw new b("observable-bind-to-properties-length", this);
        t.properties.length || (t.properties = this._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), o = this._observable, this._to.forEach(t => {
        const e = o[F];
        let n;
        e.get(t.observable) || o.listenTo(t.observable, "change", (i, r) => {
          n = e.get(t.observable)[r], n && n.forEach(t => {
            Y(o, t.property);
          });
        });
      }), function (t) {
        let e;
        t._bindings.forEach((n, i) => {
          t._to.forEach(o => {
            e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)], n.to.push([o.observable, e]), function (t, e, n, i) {
              const o = t[F],
                r = o.get(n),
                s = r || {};
              s[i] || (s[i] = new Set());
              s[i].add(e), r || o.set(n, s);
            }(t._observable, n, o.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(t => {
        Y(this._observable, t);
      });
    }
    function $(t, e, n) {
      if (this._bindings.size > 1) throw new b("observable-bind-to-many-not-one-binding", this);
      this.to(...function (t, e) {
        const n = t.map(t => [t, e]);
        return Array.prototype.concat.apply([], n);
      }(t, e), n);
    }
    function K(t) {
      return t.every(t => "string" == typeof t);
    }
    function Y(t, e) {
      const n = t[O].get(e);
      let i;
      n.callback ? i = n.callback.apply(t, n.to.map(t => t[0][t[1]])) : (i = n.to[0], i = i[0][i[1]]), Object.prototype.hasOwnProperty.call(t, e) ? t[e] = i : t.set(e, i);
    }
    ["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      q[t] = U.prototype[t];
    });
    class Q {
      constructor() {
        this._replacedElements = [];
      }
      replace(t, e) {
        this._replacedElements.push({
          element: t,
          newElement: e
        }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
      }
      restore() {
        this._replacedElements.forEach(_ref2 => {
          let {
            element: t,
            newElement: e
          } = _ref2;
          t.style.display = "", e && e.remove();
        }), this._replacedElements = [];
      }
    }
    function Z(t) {
      let e = 0;
      for (const n of t) e++;
      return e;
    }
    function J(t, e) {
      const n = Math.min(t.length, e.length);
      for (let i = 0; i < n; i++) if (t[i] != e[i]) return i;
      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }
    function X(t) {
      return !(!t || !t[Symbol.iterator]);
    }
    const tt = "object" == typeof globalThis && globalThis && globalThis.Object === Object && globalThis;
    var et = "object" == typeof self && self && self.Object === Object && self;
    const nt = tt || et || Function("return this")();
    const it = nt.Symbol;
    var ot = Object.prototype,
      rt = ot.hasOwnProperty,
      st = ot.toString,
      at = it ? it.toStringTag : void 0;
    const lt = function (t) {
      var e = rt.call(t, at),
        n = t[at];
      try {
        t[at] = void 0;
        var i = !0;
      } catch (t) {}
      var o = st.call(t);
      return i && (e ? t[at] = n : delete t[at]), o;
    };
    var ct = Object.prototype.toString;
    const dt = function (t) {
      return ct.call(t);
    };
    var ut = it ? it.toStringTag : void 0;
    const ht = function (t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : ut && ut in Object(t) ? lt(t) : dt(t);
    };
    const mt = Array.isArray;
    const gt = function (t) {
      return null != t && "object" == typeof t;
    };
    const pt = function (t) {
      return "string" == typeof t || !mt(t) && gt(t) && "[object String]" == ht(t);
    };
    function ft(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      const o = n && n.xmlns,
        r = o ? t.createElementNS(o, e) : t.createElement(e);
      for (const t in n) r.setAttribute(t, n[t]);
      !pt(i) && X(i) || (i = [i]);
      for (let e of i) pt(e) && (e = t.createTextNode(e)), r.appendChild(e);
      return r;
    }
    const kt = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    };
    const bt = kt(Object.getPrototypeOf, Object);
    var wt = Function.prototype,
      At = Object.prototype,
      Ct = wt.toString,
      _t = At.hasOwnProperty,
      vt = Ct.call(Object);
    const yt = function (t) {
      if (!gt(t) || "[object Object]" != ht(t)) return !1;
      var e = bt(t);
      if (null === e) return !0;
      var n = _t.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && Ct.call(n) == vt;
    };
    const xt = function () {
      this.__data__ = [], this.size = 0;
    };
    const Et = function (t, e) {
      return t === e || t != t && e != e;
    };
    const Dt = function (t, e) {
      for (var n = t.length; n--;) if (Et(t[n][0], e)) return n;
      return -1;
    };
    var Bt = Array.prototype.splice;
    const St = function (t) {
      var e = this.__data__,
        n = Dt(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : Bt.call(e, n, 1), --this.size, !0);
    };
    const Tt = function (t) {
      var e = this.__data__,
        n = Dt(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
    const It = function (t) {
      return Dt(this.__data__, t) > -1;
    };
    const Mt = function (t, e) {
      var n = this.__data__,
        i = Dt(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };
    function Lt(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    Lt.prototype.clear = xt, Lt.prototype.delete = St, Lt.prototype.get = Tt, Lt.prototype.has = It, Lt.prototype.set = Mt;
    const Nt = Lt;
    const zt = function () {
      this.__data__ = new Nt(), this.size = 0;
    };
    const Pt = function (t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    };
    const Vt = function (t) {
      return this.__data__.get(t);
    };
    const Rt = function (t) {
      return this.__data__.has(t);
    };
    const Ft = function (t) {
      if (!V(t)) return !1;
      var e = ht(t);
      return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
    };
    const Ot = nt["__core-js_shared__"];
    var jt = function () {
      var t = /[^.]+$/.exec(Ot && Ot.keys && Ot.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();
    const Ht = function (t) {
      return !!jt && jt in t;
    };
    var Ut = Function.prototype.toString;
    const qt = function (t) {
      if (null != t) {
        try {
          return Ut.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    };
    var Gt = /^\[object .+?Constructor\]$/,
      Wt = Function.prototype,
      $t = Object.prototype,
      Kt = Wt.toString,
      Yt = $t.hasOwnProperty,
      Qt = RegExp("^" + Kt.call(Yt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    const Zt = function (t) {
      return !(!V(t) || Ht(t)) && (Ft(t) ? Qt : Gt).test(qt(t));
    };
    const Jt = function (t, e) {
      return null == t ? void 0 : t[e];
    };
    const Xt = function (t, e) {
      var n = Jt(t, e);
      return Zt(n) ? n : void 0;
    };
    const te = Xt(nt, "Map");
    const ee = Xt(Object, "create");
    const ne = function () {
      this.__data__ = ee ? ee(null) : {}, this.size = 0;
    };
    const ie = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
    var oe = Object.prototype.hasOwnProperty;
    const re = function (t) {
      var e = this.__data__;
      if (ee) {
        var n = e[t];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }
      return oe.call(e, t) ? e[t] : void 0;
    };
    var se = Object.prototype.hasOwnProperty;
    const ae = function (t) {
      var e = this.__data__;
      return ee ? void 0 !== e[t] : se.call(e, t);
    };
    const le = function (t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = ee && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
    function ce(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    ce.prototype.clear = ne, ce.prototype.delete = ie, ce.prototype.get = re, ce.prototype.has = ae, ce.prototype.set = le;
    const de = ce;
    const ue = function () {
      this.size = 0, this.__data__ = {
        hash: new de(),
        map: new (te || Nt)(),
        string: new de()
      };
    };
    const he = function (t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
    const me = function (t, e) {
      var n = t.__data__;
      return he(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
    const ge = function (t) {
      var e = me(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };
    const pe = function (t) {
      return me(this, t).get(t);
    };
    const fe = function (t) {
      return me(this, t).has(t);
    };
    const ke = function (t, e) {
      var n = me(this, t),
        i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };
    function be(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }
    be.prototype.clear = ue, be.prototype.delete = ge, be.prototype.get = pe, be.prototype.has = fe, be.prototype.set = ke;
    const we = be;
    const Ae = function (t, e) {
      var n = this.__data__;
      if (n instanceof Nt) {
        var i = n.__data__;
        if (!te || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new we(i);
      }
      return n.set(t, e), this.size = n.size, this;
    };
    function Ce(t) {
      var e = this.__data__ = new Nt(t);
      this.size = e.size;
    }
    Ce.prototype.clear = zt, Ce.prototype.delete = Pt, Ce.prototype.get = Vt, Ce.prototype.has = Rt, Ce.prototype.set = Ae;
    const _e = Ce;
    const ve = function (t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t););
      return t;
    };
    const ye = function () {
      try {
        var t = Xt(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();
    const xe = function (t, e, n) {
      "__proto__" == e && ye ? ye(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
    var Ee = Object.prototype.hasOwnProperty;
    const De = function (t, e, n) {
      var i = t[e];
      Ee.call(t, e) && Et(i, n) && (void 0 !== n || e in t) || xe(t, e, n);
    };
    const Be = function (t, e, n, i) {
      var o = !n;
      n || (n = {});
      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
          l = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === l && (l = t[a]), o ? xe(n, a, l) : De(n, a, l);
      }
      return n;
    };
    const Se = function (t, e) {
      for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
      return i;
    };
    const Te = function (t) {
      return gt(t) && "[object Arguments]" == ht(t);
    };
    var Ie = Object.prototype,
      Me = Ie.hasOwnProperty,
      Le = Ie.propertyIsEnumerable;
    const Ne = Te(function () {
      return arguments;
    }()) ? Te : function (t) {
      return gt(t) && Me.call(t, "callee") && !Le.call(t, "callee");
    };
    const ze = function () {
      return !1;
    };
    var Pe = "object" == typeof exports && exports && !exports.nodeType && exports,
      Ve = Pe && "object" == typeof module && module && !module.nodeType && module,
      Re = Ve && Ve.exports === Pe ? nt.Buffer : void 0;
    const Fe = (Re ? Re.isBuffer : void 0) || ze;
    var Oe = /^(?:0|[1-9]\d*)$/;
    const je = function (t, e) {
      var n = typeof t;
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && Oe.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
    const He = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
    var Ue = {};
    Ue["[object Float32Array]"] = Ue["[object Float64Array]"] = Ue["[object Int8Array]"] = Ue["[object Int16Array]"] = Ue["[object Int32Array]"] = Ue["[object Uint8Array]"] = Ue["[object Uint8ClampedArray]"] = Ue["[object Uint16Array]"] = Ue["[object Uint32Array]"] = !0, Ue["[object Arguments]"] = Ue["[object Array]"] = Ue["[object ArrayBuffer]"] = Ue["[object Boolean]"] = Ue["[object DataView]"] = Ue["[object Date]"] = Ue["[object Error]"] = Ue["[object Function]"] = Ue["[object Map]"] = Ue["[object Number]"] = Ue["[object Object]"] = Ue["[object RegExp]"] = Ue["[object Set]"] = Ue["[object String]"] = Ue["[object WeakMap]"] = !1;
    const qe = function (t) {
      return gt(t) && He(t.length) && !!Ue[ht(t)];
    };
    const Ge = function (t) {
      return function (e) {
        return t(e);
      };
    };
    var We = "object" == typeof exports && exports && !exports.nodeType && exports,
      $e = We && "object" == typeof module && module && !module.nodeType && module,
      Ke = $e && $e.exports === We && tt.process;
    const Ye = function () {
      try {
        var t = $e && $e.require && $e.require("util").types;
        return t || Ke && Ke.binding && Ke.binding("util");
      } catch (t) {}
    }();
    var Qe = Ye && Ye.isTypedArray;
    const Ze = Qe ? Ge(Qe) : qe;
    var Je = Object.prototype.hasOwnProperty;
    const Xe = function (t, e) {
      var n = mt(t),
        i = !n && Ne(t),
        o = !n && !i && Fe(t),
        r = !n && !i && !o && Ze(t),
        s = n || i || o || r,
        a = s ? Se(t.length, String) : [],
        l = a.length;
      for (var c in t) !e && !Je.call(t, c) || s && ("length" == c || o && ("offset" == c || "parent" == c) || r && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || je(c, l)) || a.push(c);
      return a;
    };
    var tn = Object.prototype;
    const en = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || tn);
    };
    const nn = kt(Object.keys, Object);
    var on = Object.prototype.hasOwnProperty;
    const rn = function (t) {
      if (!en(t)) return nn(t);
      var e = [];
      for (var n in Object(t)) on.call(t, n) && "constructor" != n && e.push(n);
      return e;
    };
    const sn = function (t) {
      return null != t && He(t.length) && !Ft(t);
    };
    const an = function (t) {
      return sn(t) ? Xe(t) : rn(t);
    };
    const ln = function (t, e) {
      return t && Be(e, an(e), t);
    };
    const cn = function (t) {
      var e = [];
      if (null != t) for (var n in Object(t)) e.push(n);
      return e;
    };
    var dn = Object.prototype.hasOwnProperty;
    const un = function (t) {
      if (!V(t)) return cn(t);
      var e = en(t),
        n = [];
      for (var i in t) ("constructor" != i || !e && dn.call(t, i)) && n.push(i);
      return n;
    };
    const hn = function (t) {
      return sn(t) ? Xe(t, !0) : un(t);
    };
    const mn = function (t, e) {
      return t && Be(e, hn(e), t);
    };
    var gn = "object" == typeof exports && exports && !exports.nodeType && exports,
      pn = gn && "object" == typeof module && module && !module.nodeType && module,
      fn = pn && pn.exports === gn ? nt.Buffer : void 0,
      kn = fn ? fn.allocUnsafe : void 0;
    const bn = function (t, e) {
      if (e) return t.slice();
      var n = t.length,
        i = kn ? kn(n) : new t.constructor(n);
      return t.copy(i), i;
    };
    const wn = function (t, e) {
      var n = -1,
        i = t.length;
      for (e || (e = Array(i)); ++n < i;) e[n] = t[n];
      return e;
    };
    const An = function (t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = 0, r = []; ++n < i;) {
        var s = t[n];
        e(s, n, t) && (r[o++] = s);
      }
      return r;
    };
    const Cn = function () {
      return [];
    };
    var _n = Object.prototype.propertyIsEnumerable,
      vn = Object.getOwnPropertySymbols;
    const yn = vn ? function (t) {
      return null == t ? [] : (t = Object(t), An(vn(t), function (e) {
        return _n.call(t, e);
      }));
    } : Cn;
    const xn = function (t, e) {
      return Be(t, yn(t), e);
    };
    const En = function (t, e) {
      for (var n = -1, i = e.length, o = t.length; ++n < i;) t[o + n] = e[n];
      return t;
    };
    const Dn = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) En(e, yn(t)), t = bt(t);
      return e;
    } : Cn;
    const Bn = function (t, e) {
      return Be(t, Dn(t), e);
    };
    const Sn = function (t, e, n) {
      var i = e(t);
      return mt(t) ? i : En(i, n(t));
    };
    const Tn = function (t) {
      return Sn(t, an, yn);
    };
    const In = function (t) {
      return Sn(t, hn, Dn);
    };
    const Mn = Xt(nt, "DataView");
    const Ln = Xt(nt, "Promise");
    const Nn = Xt(nt, "Set");
    const zn = Xt(nt, "WeakMap");
    var Pn = "[object Map]",
      Vn = "[object Promise]",
      Rn = "[object Set]",
      Fn = "[object WeakMap]",
      On = "[object DataView]",
      jn = qt(Mn),
      Hn = qt(te),
      Un = qt(Ln),
      qn = qt(Nn),
      Gn = qt(zn),
      Wn = ht;
    (Mn && Wn(new Mn(new ArrayBuffer(1))) != On || te && Wn(new te()) != Pn || Ln && Wn(Ln.resolve()) != Vn || Nn && Wn(new Nn()) != Rn || zn && Wn(new zn()) != Fn) && (Wn = function (t) {
      var e = ht(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        i = n ? qt(n) : "";
      if (i) switch (i) {
        case jn:
          return On;
        case Hn:
          return Pn;
        case Un:
          return Vn;
        case qn:
          return Rn;
        case Gn:
          return Fn;
      }
      return e;
    });
    const $n = Wn;
    var Kn = Object.prototype.hasOwnProperty;
    const Yn = function (t) {
      var e = t.length,
        n = new t.constructor(e);
      return e && "string" == typeof t[0] && Kn.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    };
    const Qn = nt.Uint8Array;
    const Zn = function (t) {
      var e = new t.constructor(t.byteLength);
      return new Qn(e).set(new Qn(t)), e;
    };
    const Jn = function (t, e) {
      var n = e ? Zn(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    };
    var Xn = /\w*$/;
    const ti = function (t) {
      var e = new t.constructor(t.source, Xn.exec(t));
      return e.lastIndex = t.lastIndex, e;
    };
    var ei = it ? it.prototype : void 0,
      ni = ei ? ei.valueOf : void 0;
    const ii = function (t) {
      return ni ? Object(ni.call(t)) : {};
    };
    const oi = function (t, e) {
      var n = e ? Zn(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
    const ri = function (t, e, n) {
      var i = t.constructor;
      switch (e) {
        case "[object ArrayBuffer]":
          return Zn(t);
        case "[object Boolean]":
        case "[object Date]":
          return new i(+t);
        case "[object DataView]":
          return Jn(t, n);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return oi(t, n);
        case "[object Map]":
        case "[object Set]":
          return new i();
        case "[object Number]":
        case "[object String]":
          return new i(t);
        case "[object RegExp]":
          return ti(t);
        case "[object Symbol]":
          return ii(t);
      }
    };
    var si = Object.create;
    const ai = function () {
      function t() {}
      return function (e) {
        if (!V(e)) return {};
        if (si) return si(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();
    const li = function (t) {
      return "function" != typeof t.constructor || en(t) ? {} : ai(bt(t));
    };
    const ci = function (t) {
      return gt(t) && "[object Map]" == $n(t);
    };
    var di = Ye && Ye.isMap;
    const ui = di ? Ge(di) : ci;
    const hi = function (t) {
      return gt(t) && "[object Set]" == $n(t);
    };
    var mi = Ye && Ye.isSet;
    const gi = mi ? Ge(mi) : hi;
    var pi = "[object Arguments]",
      fi = "[object Function]",
      ki = "[object Object]",
      bi = {};
    bi[pi] = bi["[object Array]"] = bi["[object ArrayBuffer]"] = bi["[object DataView]"] = bi["[object Boolean]"] = bi["[object Date]"] = bi["[object Float32Array]"] = bi["[object Float64Array]"] = bi["[object Int8Array]"] = bi["[object Int16Array]"] = bi["[object Int32Array]"] = bi["[object Map]"] = bi["[object Number]"] = bi[ki] = bi["[object RegExp]"] = bi["[object Set]"] = bi["[object String]"] = bi["[object Symbol]"] = bi["[object Uint8Array]"] = bi["[object Uint8ClampedArray]"] = bi["[object Uint16Array]"] = bi["[object Uint32Array]"] = !0, bi["[object Error]"] = bi[fi] = bi["[object WeakMap]"] = !1;
    const wi = function t(e, n, i, o, r, s) {
      var a,
        l = 1 & n,
        c = 2 & n,
        d = 4 & n;
      if (i && (a = r ? i(e, o, r, s) : i(e)), void 0 !== a) return a;
      if (!V(e)) return e;
      var u = mt(e);
      if (u) {
        if (a = Yn(e), !l) return wn(e, a);
      } else {
        var h = $n(e),
          m = h == fi || "[object GeneratorFunction]" == h;
        if (Fe(e)) return bn(e, l);
        if (h == ki || h == pi || m && !r) {
          if (a = c || m ? {} : li(e), !l) return c ? Bn(e, mn(a, e)) : xn(e, ln(a, e));
        } else {
          if (!bi[h]) return r ? e : {};
          a = ri(e, h, l);
        }
      }
      s || (s = new _e());
      var g = s.get(e);
      if (g) return g;
      s.set(e, a), gi(e) ? e.forEach(function (o) {
        a.add(t(o, n, i, o, e, s));
      }) : ui(e) && e.forEach(function (o, r) {
        a.set(r, t(o, n, i, r, e, s));
      });
      var p = u ? void 0 : (d ? c ? In : Tn : c ? hn : an)(e);
      return ve(p || e, function (o, r) {
        p && (o = e[r = o]), De(a, r, t(o, n, i, r, e, s));
      }), a;
    };
    const Ai = function (t, e) {
      return wi(t, 5, e = "function" == typeof e ? e : void 0);
    };
    const Ci = function (t) {
      return gt(t) && 1 === t.nodeType && !yt(t);
    };
    class _i {
      constructor(t, e) {
        this._config = {}, e && this.define(vi(e)), t && this._setObjectToTarget(this._config, t);
      }
      set(t, e) {
        this._setToTarget(this._config, t, e);
      }
      define(t, e) {
        this._setToTarget(this._config, t, e, !0);
      }
      get(t) {
        return this._getFromSource(this._config, t);
      }
      *names() {
        for (const t of Object.keys(this._config)) yield t;
      }
      _setToTarget(t, e, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        if (yt(e)) return void this._setObjectToTarget(t, e, i);
        const o = e.split(".");
        e = o.pop();
        for (const e of o) yt(t[e]) || (t[e] = {}), t = t[e];
        if (yt(n)) return yt(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, i);
        i && void 0 !== t[e] || (t[e] = n);
      }
      _getFromSource(t, e) {
        const n = e.split(".");
        e = n.pop();
        for (const e of n) {
          if (!yt(t[e])) {
            t = null;
            break;
          }
          t = t[e];
        }
        return t ? vi(t[e]) : void 0;
      }
      _setObjectToTarget(t, e, n) {
        Object.keys(e).forEach(i => {
          this._setToTarget(t, i, e[i], n);
        });
      }
    }
    function vi(t) {
      return Ai(t, yi);
    }
    function yi(t) {
      return Ci(t) || "function" == typeof t ? t : void 0;
    }
    function xi(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }
      return !1;
    }
    function Ei(t) {
      const e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }
    const Di = Bi(B());
    function Bi(t) {
      if (!t) return Di;
      return class extends t {
        listenTo(t, e, n) {
          let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          if (xi(t) || Ei(t)) {
            const o = {
                capture: !!i.useCapture,
                passive: !!i.usePassive
              },
              r = this._getProxyEmitter(t, o) || new Si(t, o);
            this.listenTo(r, e, n, i);
          } else super.listenTo(t, e, n, i);
        }
        stopListening(t, e, n) {
          if (xi(t) || Ei(t)) {
            const i = this._getAllProxyEmitters(t);
            for (const t of i) this.stopListening(t, e, n);
          } else super.stopListening(t, e, n);
        }
        _getProxyEmitter(t, e) {
          return function (t, e) {
            const n = t[y];
            return n && n[e] ? n[e].emitter : null;
          }(this, Ti(t, e));
        }
        _getAllProxyEmitters(t) {
          return [{
            capture: !1,
            passive: !1
          }, {
            capture: !1,
            passive: !0
          }, {
            capture: !0,
            passive: !1
          }, {
            capture: !0,
            passive: !0
          }].map(e => this._getProxyEmitter(t, e)).filter(t => !!t);
        }
      };
    }
    ["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach(t => {
      Bi[t] = Di.prototype[t];
    });
    class Si extends B() {
      constructor(t, e) {
        super(), S(this, Ti(t, e)), this._domNode = t, this._options = e;
      }
      attach(t) {
        if (this._domListeners && this._domListeners[t]) return;
        const e = this._createDomListener(t);
        this._domNode.addEventListener(t, e, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = e;
      }
      detach(t) {
        let e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      }
      _addEventListener(t, e, n) {
        this.attach(t), B().prototype._addEventListener.call(this, t, e, n);
      }
      _removeEventListener(t, e) {
        B().prototype._removeEventListener.call(this, t, e), this.detach(t);
      }
      _createDomListener(t) {
        const e = e => {
          this.fire(t, e);
        };
        return e.removeListener = () => {
          this._domNode.removeEventListener(t, e, this._options), delete this._domListeners[t];
        }, e;
      }
    }
    function Ti(t, e) {
      let n = function (t) {
        return t["data-ck-expando"] || (t["data-ck-expando"] = p());
      }(t);
      for (const t of Object.keys(e).sort()) e[t] && (n += "-" + t);
      return n;
    }
    function Ii(t) {
      const e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }
    function Mi(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }
    function Li(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }
    function Ni(t) {
      return t && t.parentNode ? t.offsetParent === e.document.body ? null : t.offsetParent : null;
    }
    const zi = ["top", "right", "bottom", "left", "width", "height"];
    class Pi {
      constructor(t) {
        const e = Li(t);
        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), Fi(t) || e) {
          if (e) {
            const e = Pi.getDomRangeRects(t);
            Vi(this, Pi.getBoundingRect(e));
          } else Vi(this, t.getBoundingClientRect());
        } else if (Ei(t)) {
          const {
            innerWidth: e,
            innerHeight: n
          } = t;
          Vi(this, {
            top: 0,
            right: e,
            bottom: n,
            left: 0,
            width: e,
            height: n
          });
        } else Vi(this, t);
      }
      clone() {
        return new Pi(this);
      }
      moveTo(t, e) {
        return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
      }
      moveBy(t, e) {
        return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
      }
      getIntersection(t) {
        const e = {
          top: Math.max(this.top, t.top),
          right: Math.min(this.right, t.right),
          bottom: Math.min(this.bottom, t.bottom),
          left: Math.max(this.left, t.left),
          width: 0,
          height: 0
        };
        if (e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0) return null;
        {
          const t = new Pi(e);
          return t._source = this._source, t;
        }
      }
      getIntersectionArea(t) {
        const e = this.getIntersection(t);
        return e ? e.getArea() : 0;
      }
      getArea() {
        return this.width * this.height;
      }
      getVisible() {
        const t = this._source;
        let e = this.clone();
        if (Ri(t)) return e;
        let n,
          i = t,
          o = t.parentNode || t.commonAncestorContainer;
        for (; o && !Ri(o);) {
          const t = "visible" === ji(o);
          i instanceof HTMLElement && "absolute" === Oi(i) && (n = i);
          const r = Oi(o);
          if (t || n && ("relative" === r && t || "relative" !== r)) {
            i = o, o = o.parentNode;
            continue;
          }
          const s = new Pi(o),
            a = e.getIntersection(s);
          if (!a) return null;
          a.getArea() < e.getArea() && (e = a), i = o, o = o.parentNode;
        }
        return e;
      }
      isEqual(t) {
        for (const e of zi) if (this[e] !== t[e]) return !1;
        return !0;
      }
      contains(t) {
        const e = this.getIntersection(t);
        return !(!e || !e.isEqual(t));
      }
      toAbsoluteRect() {
        const {
            scrollX: t,
            scrollY: n
          } = e.window,
          i = this.clone().moveBy(t, n);
        if (Fi(i._source)) {
          const t = Ni(i._source);
          t && function (t, e) {
            const n = new Pi(e),
              i = Ii(e);
            let o = 0,
              r = 0;
            o -= n.left, r -= n.top, o += e.scrollLeft, r += e.scrollTop, o -= i.left, r -= i.top, t.moveBy(o, r);
          }(i, t);
        }
        return i;
      }
      excludeScrollbarsAndBorders() {
        const t = this._source;
        let e, n, i;
        if (Ei(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight, i = t.getComputedStyle(t.document.documentElement).direction;else {
          const o = Ii(t);
          e = t.offsetWidth - t.clientWidth - o.left - o.right, n = t.offsetHeight - t.clientHeight - o.top - o.bottom, i = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += o.left, this.top += o.top, this.right -= o.right, this.bottom -= o.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
        }
        return this.width -= e, "ltr" === i ? this.right -= e : this.left += e, this.height -= n, this.bottom -= n, this;
      }
      static getDomRangeRects(t) {
        const e = [],
          n = Array.from(t.getClientRects());
        if (n.length) for (const t of n) e.push(new Pi(t));else {
          let n = t.startContainer;
          Mi(n) && (n = n.parentNode);
          const i = new Pi(n.getBoundingClientRect());
          i.right = i.left, i.width = 0, e.push(i);
        }
        return e;
      }
      static getBoundingRect(t) {
        const e = {
          left: Number.POSITIVE_INFINITY,
          top: Number.POSITIVE_INFINITY,
          right: Number.NEGATIVE_INFINITY,
          bottom: Number.NEGATIVE_INFINITY,
          width: 0,
          height: 0
        };
        let n = 0;
        for (const i of t) n++, e.left = Math.min(e.left, i.left), e.top = Math.min(e.top, i.top), e.right = Math.max(e.right, i.right), e.bottom = Math.max(e.bottom, i.bottom);
        return 0 == n ? null : (e.width = e.right - e.left, e.height = e.bottom - e.top, new Pi(e));
      }
    }
    function Vi(t, e) {
      for (const n of zi) t[n] = e[n];
    }
    function Ri(t) {
      return !!Fi(t) && t === t.ownerDocument.body;
    }
    function Fi(t) {
      return null !== t && "object" == typeof t && 1 === t.nodeType && "function" == typeof t.getBoundingClientRect;
    }
    function Oi(t) {
      return t instanceof HTMLElement ? t.ownerDocument.defaultView.getComputedStyle(t).position : "static";
    }
    function ji(t) {
      return t instanceof HTMLElement ? t.ownerDocument.defaultView.getComputedStyle(t).overflow : "visible";
    }
    class Hi {
      constructor(t, e) {
        Hi._observerInstance || Hi._createObserver(), this._element = t, this._callback = e, Hi._addElementCallback(t, e), Hi._observerInstance.observe(t);
      }
      get element() {
        return this._element;
      }
      destroy() {
        Hi._deleteElementCallback(this._element, this._callback);
      }
      static _addElementCallback(t, e) {
        Hi._elementCallbacks || (Hi._elementCallbacks = new Map());
        let n = Hi._elementCallbacks.get(t);
        n || (n = new Set(), Hi._elementCallbacks.set(t, n)), n.add(e);
      }
      static _deleteElementCallback(t, e) {
        const n = Hi._getElementCallbacks(t);
        n && (n.delete(e), n.size || (Hi._elementCallbacks.delete(t), Hi._observerInstance.unobserve(t))), Hi._elementCallbacks && !Hi._elementCallbacks.size && (Hi._observerInstance = null, Hi._elementCallbacks = null);
      }
      static _getElementCallbacks(t) {
        return Hi._elementCallbacks ? Hi._elementCallbacks.get(t) : null;
      }
      static _createObserver() {
        Hi._observerInstance = new e.window.ResizeObserver(t => {
          for (const e of t) {
            const t = Hi._getElementCallbacks(e.target);
            if (t) for (const n of t) n(e);
          }
        });
      }
    }
    Hi._observerInstance = null, Hi._elementCallbacks = null;
    const Ui = Hi;
    function qi(t, e) {
      t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
    }
    function Gi(t) {
      return e => e + t;
    }
    function Wi(t) {
      let e = 0;
      for (; t.previousSibling;) t = t.previousSibling, e++;
      return e;
    }
    function $i(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }
    function Ki(t) {
      return t && t.nodeType === Node.COMMENT_NODE;
    }
    function Yi(t) {
      try {
        e.document.createAttribute(t);
      } catch (t) {
        return !1;
      }
      return !0;
    }
    function Qi(t) {
      return !!(t && t.getClientRects && t.getClientRects().length);
    }
    function Zi(_ref3) {
      let {
        element: t,
        target: n,
        positions: i,
        limiter: o,
        fitInViewport: r,
        viewportOffsetConfig: s
      } = _ref3;
      Ft(n) && (n = n()), Ft(o) && (o = o());
      const a = Ni(t),
        l = function (t) {
          t = Object.assign({
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }, t);
          const n = new Pi(e.window);
          return n.top += t.top, n.height -= t.top, n.bottom -= t.bottom, n.height -= t.bottom, n;
        }(s),
        c = new Pi(t),
        d = Ji(n, l);
      let u;
      if (!d || !l.getIntersection(d)) return null;
      const h = {
        targetRect: d,
        elementRect: c,
        positionedElementAncestor: a,
        viewportRect: l
      };
      if (o || r) {
        if (o) {
          const t = Ji(o, l);
          t && (h.limiterRect = t);
        }
        u = function (t, e) {
          const {
              elementRect: n
            } = e,
            i = n.getArea(),
            o = t.map(t => new Xi(t, e)).filter(t => !!t.name);
          let r = 0,
            s = null;
          for (const t of o) {
            const {
              limiterIntersectionArea: e,
              viewportIntersectionArea: n
            } = t;
            if (e === i) return t;
            const o = n ** 2 + e ** 2;
            o > r && (r = o, s = t);
          }
          return s;
        }(i, h);
      } else u = new Xi(i[0], h);
      return u;
    }
    function Ji(t, e) {
      const n = new Pi(t).getVisible();
      return n ? n.getIntersection(e) : null;
    }
    class Xi {
      constructor(t, e) {
        const n = t(e.targetRect, e.elementRect, e.viewportRect, e.limiterRect);
        if (!n) return;
        const {
          left: i,
          top: o,
          name: r,
          config: s
        } = n;
        this.name = r, this.config = s, this._positioningFunctionCoordinates = {
          left: i,
          top: o
        }, this._options = e;
      }
      get left() {
        return this._absoluteRect.left;
      }
      get top() {
        return this._absoluteRect.top;
      }
      get limiterIntersectionArea() {
        const t = this._options.limiterRect;
        return t ? t.getIntersectionArea(this._rect) : 0;
      }
      get viewportIntersectionArea() {
        return this._options.viewportRect.getIntersectionArea(this._rect);
      }
      get _rect() {
        return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top)), this._cachedRect;
      }
      get _absoluteRect() {
        return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = this._rect.toAbsoluteRect()), this._cachedAbsoluteRect;
      }
    }
    function to(t) {
      const e = t.parentNode;
      e && e.removeChild(t);
    }
    function eo(_ref4) {
      let {
        target: t,
        viewportOffset: e = 0,
        ancestorOffset: n = 0,
        alignToTop: i,
        forceScroll: o
      } = _ref4;
      const r = lo(t);
      let s = r,
        a = null;
      for (e = function (t) {
        if ("number" == typeof t) return {
          top: t,
          bottom: t,
          left: t,
          right: t
        };
        return t;
      }(e); s;) {
        let l;
        l = co(s == r ? t : a), io({
          parent: l,
          getRect: () => uo(t, s),
          alignToTop: i,
          ancestorOffset: n,
          forceScroll: o
        });
        const c = uo(t, s);
        if (no({
          window: s,
          rect: c,
          viewportOffset: e,
          alignToTop: i,
          forceScroll: o
        }), s.parent != s) {
          if (a = s.frameElement, s = s.parent, !a) return;
        } else s = null;
      }
    }
    function no(_ref5) {
      let {
        window: t,
        rect: e,
        alignToTop: n,
        forceScroll: i,
        viewportOffset: o
      } = _ref5;
      const r = e.clone().moveBy(0, o.bottom),
        s = e.clone().moveBy(0, -o.top),
        a = new Pi(t).excludeScrollbarsAndBorders(),
        l = n && i,
        c = [s, r].every(t => a.contains(t));
      let {
        scrollX: d,
        scrollY: u
      } = t;
      const h = d,
        m = u;
      l ? u -= a.top - e.top + o.top : c || (ro(s, a) ? u -= a.top - e.top + o.top : oo(r, a) && (u += n ? e.top - a.top - o.top : e.bottom - a.bottom + o.bottom)), c || (so(e, a) ? d -= a.left - e.left + o.left : ao(e, a) && (d += e.right - a.right + o.right)), d == h && u === m || t.scrollTo(d, u);
    }
    function io(_ref6) {
      let {
        parent: t,
        getRect: e,
        alignToTop: n,
        forceScroll: i,
        ancestorOffset: o = 0,
        limiterElement: r
      } = _ref6;
      const s = lo(t),
        a = n && i;
      let l, c, d;
      const u = r || s.document.body;
      for (; t != u;) c = e(), l = new Pi(t).excludeScrollbarsAndBorders(), d = l.contains(c), a ? t.scrollTop -= l.top - c.top + o : d || (ro(c, l) ? t.scrollTop -= l.top - c.top + o : oo(c, l) && (t.scrollTop += n ? c.top - l.top - o : c.bottom - l.bottom + o)), d || (so(c, l) ? t.scrollLeft -= l.left - c.left + o : ao(c, l) && (t.scrollLeft += c.right - l.right + o)), t = t.parentNode;
    }
    function oo(t, e) {
      return t.bottom > e.bottom;
    }
    function ro(t, e) {
      return t.top < e.top;
    }
    function so(t, e) {
      return t.left < e.left;
    }
    function ao(t, e) {
      return t.right > e.right;
    }
    function lo(t) {
      return Li(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }
    function co(t) {
      if (Li(t)) {
        let e = t.commonAncestorContainer;
        return Mi(e) && (e = e.parentNode), e;
      }
      return t.parentNode;
    }
    function uo(t, e) {
      const n = lo(t),
        i = new Pi(t);
      if (n === e) return i;
      {
        let t = n;
        for (; t != e;) {
          const e = t.frameElement,
            n = new Pi(e).excludeScrollbarsAndBorders();
          i.moveBy(n.left, n.top), t = t.parent;
        }
      }
      return i;
    }
    const ho = {
        ctrl: "⌃",
        cmd: "⌘",
        alt: "⌥",
        shift: "⇧"
      },
      mo = {
        ctrl: "Ctrl+",
        alt: "Alt+",
        shift: "Shift+"
      },
      go = {
        37: "←",
        38: "↑",
        39: "→",
        40: "↓",
        9: "⇥",
        33: "Page Up",
        34: "Page Down"
      },
      po = function () {
        const t = {
          pageup: 33,
          pagedown: 34,
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        };
        for (let e = 65; e <= 90; e++) {
          t[String.fromCharCode(e).toLowerCase()] = e;
        }
        for (let e = 48; e <= 57; e++) t[e - 48] = e;
        for (let e = 112; e <= 123; e++) t["f" + (e - 111)] = e;
        return Object.assign(t, {
          "'": 222,
          ",": 108,
          "-": 109,
          ".": 110,
          "/": 111,
          ";": 186,
          "=": 187,
          "[": 219,
          "\\": 220,
          "]": 221,
          "`": 223
        }), t;
      }(),
      fo = Object.fromEntries(Object.entries(po).map(_ref7 => {
        let [t, e] = _ref7;
        let n;
        return n = e in go ? go[e] : t.charAt(0).toUpperCase() + t.slice(1), [e, n];
      }));
    function ko(t) {
      let e;
      if ("string" == typeof t) {
        if (e = po[t.toLowerCase()], !e) throw new b("keyboard-unknown-key", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? po.alt : 0) + (t.ctrlKey ? po.ctrl : 0) + (t.shiftKey ? po.shift : 0) + (t.metaKey ? po.cmd : 0);
      return e;
    }
    function bo(t) {
      return "string" == typeof t && (t = function (t) {
        return t.split("+").map(t => t.trim());
      }(t)), t.map(t => "string" == typeof t ? function (t) {
        if (t.endsWith("!")) return ko(t.slice(0, -1));
        const e = ko(t);
        return (s.isMac || s.isiOS) && e == po.ctrl ? po.cmd : e;
      }(t) : t).reduce((t, e) => e + t, 0);
    }
    function wo(t) {
      let e = bo(t);
      return Object.entries(s.isMac || s.isiOS ? ho : mo).reduce((t, _ref8) => {
        let [n, i] = _ref8;
        return 0 != (e & po[n]) && (e &= ~po[n], t += i), t;
      }, "") + (e ? fo[e] : "");
    }
    function Ao(t, e) {
      const n = "ltr" === e;
      switch (t) {
        case po.arrowleft:
          return n ? "left" : "right";
        case po.arrowright:
          return n ? "right" : "left";
        case po.arrowup:
          return "up";
        case po.arrowdown:
          return "down";
      }
    }
    const Co = ["ar", "ara", "dv", "div", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
    function _o(t) {
      return Co.includes(t) ? "rtl" : "ltr";
    }
    function vo(t) {
      return Array.isArray(t) ? t : [t];
    }
    const yo = function (t, e, n) {
      (void 0 !== n && !Et(t[e], n) || void 0 === n && !(e in t)) && xe(t, e, n);
    };
    const xo = function (t) {
      return function (e, n, i) {
        for (var o = -1, r = Object(e), s = i(e), a = s.length; a--;) {
          var l = s[t ? a : ++o];
          if (!1 === n(r[l], l, r)) break;
        }
        return e;
      };
    }();
    const Eo = function (t) {
      return gt(t) && sn(t);
    };
    const Do = function (t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    };
    const Bo = function (t) {
      return Be(t, hn(t));
    };
    const So = function (t, e, n, i, o, r, s) {
      var a = Do(t, n),
        l = Do(e, n),
        c = s.get(l);
      if (c) yo(t, n, c);else {
        var d = r ? r(a, l, n + "", t, e, s) : void 0,
          u = void 0 === d;
        if (u) {
          var h = mt(l),
            m = !h && Fe(l),
            g = !h && !m && Ze(l);
          d = l, h || m || g ? mt(a) ? d = a : Eo(a) ? d = wn(a) : m ? (u = !1, d = bn(l, !0)) : g ? (u = !1, d = oi(l, !0)) : d = [] : yt(l) || Ne(l) ? (d = a, Ne(a) ? d = Bo(a) : V(a) && !Ft(a) || (d = li(l))) : u = !1;
        }
        u && (s.set(l, d), o(d, l, i, r, s), s.delete(l)), yo(t, n, d);
      }
    };
    const To = function t(e, n, i, o, r) {
      e !== n && xo(n, function (s, a) {
        if (r || (r = new _e()), V(s)) So(e, n, a, i, t, o, r);else {
          var l = o ? o(Do(e, a), s, a + "", e, n, r) : void 0;
          void 0 === l && (l = s), yo(e, a, l);
        }
      }, hn);
    };
    const Io = function (t) {
      return t;
    };
    const Mo = function (t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    };
    var Lo = Math.max;
    const No = function (t, e, n) {
      return e = Lo(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, o = -1, r = Lo(i.length - e, 0), s = Array(r); ++o < r;) s[o] = i[e + o];
        o = -1;
        for (var a = Array(e + 1); ++o < e;) a[o] = i[o];
        return a[e] = n(s), Mo(t, this, a);
      };
    };
    const zo = function (t) {
      return function () {
        return t;
      };
    };
    const Po = ye ? function (t, e) {
      return ye(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: zo(e),
        writable: !0
      });
    } : Io;
    var Vo = Date.now;
    const Ro = function (t) {
      var e = 0,
        n = 0;
      return function () {
        var i = Vo(),
          o = 16 - (i - n);
        if (n = i, o > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;
        return t.apply(void 0, arguments);
      };
    };
    const Fo = Ro(Po);
    const Oo = function (t, e) {
      return Fo(No(t, e, Io), t + "");
    };
    const jo = function (t, e, n) {
      if (!V(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? sn(n) && je(e, n.length) : "string" == i && e in n) && Et(n[e], t);
    };
    const Ho = function (t) {
      return Oo(function (e, n) {
        var i = -1,
          o = n.length,
          r = o > 1 ? n[o - 1] : void 0,
          s = o > 2 ? n[2] : void 0;
        for (r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && jo(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++i < o;) {
          var a = n[i];
          a && t(e, a, i, r);
        }
        return e;
      });
    };
    const Uo = Ho(function (t, e, n) {
      To(t, e, n);
    });
    function qo(t, n) {
      let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      let o = arguments.length > 3 ? arguments[3] : undefined;
      if ("number" != typeof i) throw new b("translation-service-quantity-not-a-number", null, {
        quantity: i
      });
      const r = o || e.window.CKEDITOR_TRANSLATIONS,
        s = function (t) {
          return Object.keys(t).length;
        }(r);
      1 === s && (t = Object.keys(r)[0]);
      const a = n.id || n.string;
      if (0 === s || !function (t, e, n) {
        return !!n[t] && !!n[t].dictionary[e];
      }(t, a, r)) return 1 !== i ? n.plural : n.string;
      const l = r[t].dictionary,
        c = r[t].getPluralForm || (t => 1 === t ? 0 : 1),
        d = l[a];
      if ("string" == typeof d) return d;
      return d[Number(c(i))];
    }
    e.window.CKEDITOR_TRANSLATIONS || (e.window.CKEDITOR_TRANSLATIONS = {});
    class Go {
      constructor() {
        let {
          uiLanguage: t = "en",
          contentLanguage: e,
          translations: n
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.uiLanguage = t, this.contentLanguage = e || this.uiLanguage, this.uiLanguageDirection = _o(this.uiLanguage), this.contentLanguageDirection = _o(this.contentLanguage), this.translations = function (t) {
          return Array.isArray(t) ? t.reduce((t, e) => Uo(t, e)) : t;
        }(n), this.t = (t, e) => this._t(t, e);
      }
      get language() {
        return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
      }
      _t(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        e = vo(e), "string" == typeof t && (t = {
          string: t
        });
        const n = !!t.plural ? e[0] : 1;
        return function (t, e) {
          return t.replace(/%(\d+)/g, (t, n) => n < e.length ? e[n] : t);
        }(qo(this.uiLanguage, t, n, this.translations), e);
      }
    }
    class Wo extends B() {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        const n = X(t);
        if (n || (e = t), this._items = [], this._itemMap = new Map(), this._idProperty = e.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], n) for (const e of t) this._items.push(e), this._itemMap.set(this._getItemIdBeforeAdding(e), e);
      }
      get length() {
        return this._items.length;
      }
      get first() {
        return this._items[0] || null;
      }
      get last() {
        return this._items[this.length - 1] || null;
      }
      add(t, e) {
        return this.addMany([t], e);
      }
      addMany(t, e) {
        if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new b("collection-add-item-invalid-index", this);
        let n = 0;
        for (const i of t) {
          const t = this._getItemIdBeforeAdding(i),
            o = e + n;
          this._items.splice(o, 0, i), this._itemMap.set(t, i), this.fire("add", i, o), n++;
        }
        return this.fire("change", {
          added: t,
          removed: [],
          index: e
        }), this;
      }
      get(t) {
        let e;
        if ("string" == typeof t) e = this._itemMap.get(t);else {
          if ("number" != typeof t) throw new b("collection-get-invalid-arg", this);
          e = this._items[t];
        }
        return e || null;
      }
      has(t) {
        if ("string" == typeof t) return this._itemMap.has(t);
        {
          const e = t[this._idProperty];
          return e && this._itemMap.has(e);
        }
      }
      getIndex(t) {
        let e;
        return e = "string" == typeof t ? this._itemMap.get(t) : t, e ? this._items.indexOf(e) : -1;
      }
      remove(t) {
        const [e, n] = this._remove(t);
        return this.fire("change", {
          added: [],
          removed: [e],
          index: n
        }), e;
      }
      map(t, e) {
        return this._items.map(t, e);
      }
      forEach(t, e) {
        this._items.forEach(t, e);
      }
      find(t, e) {
        return this._items.find(t, e);
      }
      filter(t, e) {
        return this._items.filter(t, e);
      }
      clear() {
        this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
        const t = Array.from(this._items);
        for (; this.length;) this._remove(0);
        this.fire("change", {
          added: [],
          removed: t,
          index: 0
        });
      }
      bindTo(t) {
        if (this._bindToCollection) throw new b("collection-bind-to-rebind", this);
        return this._bindToCollection = t, {
          as: t => {
            this._setUpBindToBinding(e => new t(e));
          },
          using: t => {
            "function" == typeof t ? this._setUpBindToBinding(t) : this._setUpBindToBinding(e => e[t]);
          }
        };
      }
      _setUpBindToBinding(t) {
        const e = this._bindToCollection,
          n = (n, i, o) => {
            const r = e._bindToCollection == this,
              s = e._bindToInternalToExternalMap.get(i);
            if (r && s) this._bindToExternalToInternalMap.set(i, s), this._bindToInternalToExternalMap.set(s, i);else {
              const n = t(i);
              if (!n) return void this._skippedIndexesFromExternal.push(o);
              let r = o;
              for (const t of this._skippedIndexesFromExternal) o > t && r--;
              for (const t of e._skippedIndexesFromExternal) r >= t && r++;
              this._bindToExternalToInternalMap.set(i, n), this._bindToInternalToExternalMap.set(n, i), this.add(n, r);
              for (let t = 0; t < e._skippedIndexesFromExternal.length; t++) r <= e._skippedIndexesFromExternal[t] && e._skippedIndexesFromExternal[t]++;
            }
          };
        for (const t of e) n(0, t, e.getIndex(t));
        this.listenTo(e, "add", n), this.listenTo(e, "remove", (t, e, n) => {
          const i = this._bindToExternalToInternalMap.get(e);
          i && this.remove(i), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((t, e) => (n < e && t.push(e - 1), n > e && t.push(e), t), []);
        });
      }
      _getItemIdBeforeAdding(t) {
        const e = this._idProperty;
        let n;
        if (e in t) {
          if (n = t[e], "string" != typeof n) throw new b("collection-add-invalid-id", this);
          if (this.get(n)) throw new b("collection-add-item-already-exists", this);
        } else t[e] = n = p();
        return n;
      }
      _remove(t) {
        let e,
          n,
          i,
          o = !1;
        const r = this._idProperty;
        if ("string" == typeof t ? (n = t, i = this._itemMap.get(n), o = !i, i && (e = this._items.indexOf(i))) : "number" == typeof t ? (e = t, i = this._items[e], o = !i, i && (n = i[r])) : (i = t, n = i[r], e = this._items.indexOf(i), o = -1 == e || !this._itemMap.get(n)), o) throw new b("collection-remove-404", this);
        this._items.splice(e, 1), this._itemMap.delete(n);
        const s = this._bindToInternalToExternalMap.get(i);
        return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, e), [i, e];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
    }
    function $o(t) {
      const e = t.next();
      return e.done ? null : e.value;
    }
    class Ko extends Bi(q()) {
      constructor() {
        super(), this._elements = new Set(), this._nextEventLoopTimeout = null, this.set("isFocused", !1), this.set("focusedElement", null);
      }
      add(t) {
        if (this._elements.has(t)) throw new b("focustracker-add-element-already-exist", this);
        this.listenTo(t, "focus", () => this._focus(t), {
          useCapture: !0
        }), this.listenTo(t, "blur", () => this._blur(), {
          useCapture: !0
        }), this._elements.add(t);
      }
      remove(t) {
        t === this.focusedElement && this._blur(), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
      }
      destroy() {
        this.stopListening();
      }
      _focus(t) {
        clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
      }
      _blur() {
        clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
          this.focusedElement = null, this.isFocused = !1;
        }, 0);
      }
    }
    class Yo {
      constructor() {
        this._listener = new (Bi())();
      }
      listenTo(t) {
        this._listener.listenTo(t, "keydown", (t, e) => {
          this._listener.fire("_keydown:" + ko(e), e);
        });
      }
      set(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = bo(t),
          o = n.priority;
        this._listener.listenTo(this._listener, "_keydown:" + i, (t, n) => {
          e(n, () => {
            n.preventDefault(), n.stopPropagation(), t.stop();
          }), t.return = !0;
        }, {
          priority: o
        });
      }
      press(t) {
        return !!this._listener.fire("_keydown:" + ko(t), t);
      }
      stopListening(t) {
        this._listener.stopListening(t);
      }
      destroy() {
        this.stopListening();
      }
    }
    function Qo(t) {
      return X(t) ? new Map(t) : function (t) {
        const e = new Map();
        for (const n in t) e.set(n, t[n]);
        return e;
      }(t);
    }
    function Zo(t, e) {
      let n;
      function i() {
        for (var _len10 = arguments.length, o = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          o[_key10] = arguments[_key10];
        }
        i.cancel(), n = setTimeout(() => t(...o), e);
      }
      return i.cancel = () => {
        clearTimeout(n);
      }, i;
    }
    function Jo(t, e) {
      return !!(n = t.charAt(e - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
      var n;
    }
    function Xo(t, e) {
      return !!(n = t.charAt(e)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
      var n;
    }
    const tr = function () {
      const t = /\p{Regional_Indicator}{2}/u.source,
        e = "(?:" + [/\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u, /\p{Emoji}\u{FE0F}?\u{20E3}/u, /\p{Emoji}\u{FE0F}/u, /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u].map(t => t.source).join("|") + ")";
      return new RegExp(`${t}|${e}(?:‍${e})*`, "ug");
    }();
    function er(t, e) {
      const n = String(t).matchAll(tr);
      return Array.from(n).some(t => t.index < e && e < t.index + t[0].length);
    }
    class nr extends Wo {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        super(t, {
          idProperty: "viewUid"
        }), this.on("add", (t, e, n) => {
          this._renderViewIntoCollectionParent(e, n);
        }), this.on("remove", (t, e) => {
          e.element && this._parentElement && e.element.remove();
        }), this._parentElement = null;
      }
      destroy() {
        this.map(t => t.destroy());
      }
      setParent(t) {
        this._parentElement = t;
        for (const t of this) this._renderViewIntoCollectionParent(t);
      }
      delegate() {
        for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          t[_key11] = arguments[_key11];
        }
        if (!t.length || !t.every(t => "string" == typeof t)) throw new b("ui-viewcollection-delegate-wrong-events", this);
        return {
          to: e => {
            for (const n of this) for (const i of t) n.delegate(i).to(e);
            this.on("add", (n, i) => {
              for (const n of t) i.delegate(n).to(e);
            }), this.on("remove", (n, i) => {
              for (const n of t) i.stopDelegating(n, e);
            });
          }
        };
      }
      _renderViewIntoCollectionParent(t, e) {
        t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
      }
      remove(t) {
        return super.remove(t);
      }
    }
    class ir extends B() {
      constructor(t) {
        super(), Object.assign(this, mr(hr(t))), this._isRendered = !1, this._revertData = null;
      }
      render() {
        const t = this._renderNode({
          intoFragment: !0
        });
        return this._isRendered = !0, t;
      }
      apply(t) {
        return this._revertData = {
          children: [],
          bindings: [],
          attributes: {}
        }, this._renderNode({
          node: t,
          intoFragment: !1,
          isApplying: !0,
          revertData: this._revertData
        }), t;
      }
      revert(t) {
        if (!this._revertData) throw new b("ui-template-revert-not-applied", [this, t]);
        this._revertTemplateFromNode(t, this._revertData);
      }
      *getViews() {
        yield* function* t(e) {
          if (e.children) for (const n of e.children) wr(n) ? yield n : Ar(n) && (yield* t(n));
        }(this);
      }
      static bind(t, e) {
        return {
          to: (n, i) => new rr({
            eventNameOrFunction: n,
            attribute: n,
            observable: t,
            emitter: e,
            callback: i
          }),
          if: (n, i, o) => new sr({
            observable: t,
            emitter: e,
            attribute: n,
            valueIfTrue: i,
            callback: o
          })
        };
      }
      static extend(t, e) {
        if (t._isRendered) throw new b("template-extend-render", [this, t]);
        kr(t, mr(hr(e)));
      }
      _renderNode(t) {
        let e;
        if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, e) throw new b("ui-template-wrong-syntax", this);
        return this.text ? this._renderText(t) : this._renderElement(t);
      }
      _renderElement(t) {
        let e = t.node;
        return e || (e = t.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
      }
      _renderText(t) {
        let e = t.node;
        return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), ar(this.text) ? this._bindToObservable({
          schema: this.text,
          updater: cr(e),
          data: t
        }) : e.textContent = this.text.join(""), e;
      }
      _renderAttributes(t) {
        if (!this.attributes) return;
        const e = t.node,
          n = t.revertData;
        for (const i in this.attributes) {
          const o = e.getAttribute(i),
            r = this.attributes[i];
          n && (n.attributes[i] = o);
          const s = _r(r) ? r[0].ns : null;
          if (ar(r)) {
            const a = _r(r) ? r[0].value : r;
            n && yr(i) && a.unshift(o), this._bindToObservable({
              schema: a,
              updater: dr(e, i, s),
              data: t
            });
          } else if ("style" == i && "string" != typeof r[0]) this._renderStyleAttribute(r[0], t);else {
            n && o && yr(i) && r.unshift(o);
            const t = r.map(t => t && t.value || t).reduce((t, e) => t.concat(e), []).reduce(pr, "");
            br(t) || e.setAttributeNS(s, i, t);
          }
        }
      }
      _renderStyleAttribute(t, e) {
        const n = e.node;
        for (const i in t) {
          const o = t[i];
          ar(o) ? this._bindToObservable({
            schema: [o],
            updater: ur(n, i),
            data: e
          }) : n.style[i] = o;
        }
      }
      _renderElementChildren(t) {
        const e = t.node,
          n = t.intoFragment ? document.createDocumentFragment() : e,
          i = t.isApplying;
        let o = 0;
        for (const r of this.children) if (Cr(r)) {
          if (!i) {
            r.setParent(e);
            for (const t of r) n.appendChild(t.element);
          }
        } else if (wr(r)) i || (r.isRendered || r.render(), n.appendChild(r.element));else if (xi(r)) n.appendChild(r);else if (i) {
          const e = t.revertData,
            i = vr();
          e.children.push(i), r._renderNode({
            intoFragment: !1,
            node: n.childNodes[o++],
            isApplying: !0,
            revertData: i
          });
        } else n.appendChild(r.render());
        t.intoFragment && e.appendChild(n);
      }
      _setUpListeners(t) {
        if (this.eventListeners) for (const e in this.eventListeners) {
          const n = this.eventListeners[e].map(n => {
            const [i, o] = e.split("@");
            return n.activateDomEventListener(i, o, t);
          });
          t.revertData && t.revertData.bindings.push(n);
        }
      }
      _bindToObservable(_ref9) {
        let {
          schema: t,
          updater: e,
          data: n
        } = _ref9;
        const i = n.revertData;
        lr(t, e, n);
        const o = t.filter(t => !br(t)).filter(t => t.observable).map(i => i.activateAttributeListener(t, e, n));
        i && i.bindings.push(o);
      }
      _revertTemplateFromNode(t, e) {
        for (const t of e.bindings) for (const e of t) e();
        if (e.text) return void (t.textContent = e.text);
        const n = t;
        for (const t in e.attributes) {
          const i = e.attributes[t];
          null === i ? n.removeAttribute(t) : n.setAttribute(t, i);
        }
        for (let t = 0; t < e.children.length; ++t) this._revertTemplateFromNode(n.childNodes[t], e.children[t]);
      }
    }
    class or {
      constructor(t) {
        this.attribute = t.attribute, this.observable = t.observable, this.emitter = t.emitter, this.callback = t.callback;
      }
      getValue(t) {
        const e = this.observable[this.attribute];
        return this.callback ? this.callback(e, t) : e;
      }
      activateAttributeListener(t, e, n) {
        const i = () => lr(t, e, n);
        return this.emitter.listenTo(this.observable, `change:${this.attribute}`, i), () => {
          this.emitter.stopListening(this.observable, `change:${this.attribute}`, i);
        };
      }
    }
    class rr extends or {
      constructor(t) {
        super(t), this.eventNameOrFunction = t.eventNameOrFunction;
      }
      activateDomEventListener(t, e, n) {
        const i = (t, n) => {
          e && !n.target.matches(e) || ("function" == typeof this.eventNameOrFunction ? this.eventNameOrFunction(n) : this.observable.fire(this.eventNameOrFunction, n));
        };
        return this.emitter.listenTo(n.node, t, i), () => {
          this.emitter.stopListening(n.node, t, i);
        };
      }
    }
    class sr extends or {
      constructor(t) {
        super(t), this.valueIfTrue = t.valueIfTrue;
      }
      getValue(t) {
        return !br(super.getValue(t)) && (this.valueIfTrue || !0);
      }
    }
    function ar(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(ar) : t instanceof or);
    }
    function lr(t, e, _ref10) {
      let {
        node: n
      } = _ref10;
      const i = function (t, e) {
        return t.map(t => t instanceof or ? t.getValue(e) : t);
      }(t, n);
      let o;
      o = 1 == t.length && t[0] instanceof sr ? i[0] : i.reduce(pr, ""), br(o) ? e.remove() : e.set(o);
    }
    function cr(t) {
      return {
        set(e) {
          t.textContent = e;
        },
        remove() {
          t.textContent = "";
        }
      };
    }
    function dr(t, e, n) {
      return {
        set(i) {
          t.setAttributeNS(n, e, i);
        },
        remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }
    function ur(t, e) {
      return {
        set(n) {
          t.style[e] = n;
        },
        remove() {
          t.style[e] = null;
        }
      };
    }
    function hr(t) {
      return Ai(t, t => {
        if (t && (t instanceof or || Ar(t) || wr(t) || Cr(t))) return t;
      });
    }
    function mr(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        t.text = vo(t.text);
      }(t), t.on && (t.eventListeners = function (t) {
        for (const e in t) gr(t, e);
        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (const e in t) t[e].value && (t[e].value = vo(t[e].value)), gr(t, e);
        }(t.attributes);
        const e = [];
        if (t.children) if (Cr(t.children)) e.push(t.children);else for (const n of t.children) Ar(n) || wr(n) || xi(n) ? e.push(n) : e.push(new ir(n));
        t.children = e;
      }
      return t;
    }
    function gr(t, e) {
      t[e] = vo(t[e]);
    }
    function pr(t, e) {
      return br(e) ? t : br(t) ? e : `${t} ${e}`;
    }
    function fr(t, e) {
      for (const n in e) t[n] ? t[n].push(...e[n]) : t[n] = e[n];
    }
    function kr(t, e) {
      if (e.attributes && (t.attributes || (t.attributes = {}), fr(t.attributes, e.attributes)), e.eventListeners && (t.eventListeners || (t.eventListeners = {}), fr(t.eventListeners, e.eventListeners)), e.text && t.text.push(...e.text), e.children && e.children.length) {
        if (t.children.length != e.children.length) throw new b("ui-template-extend-children-mismatch", t);
        let n = 0;
        for (const i of e.children) kr(t.children[n++], i);
      }
    }
    function br(t) {
      return !t && 0 !== t;
    }
    function wr(t) {
      return t instanceof Sr;
    }
    function Ar(t) {
      return t instanceof ir;
    }
    function Cr(t) {
      return t instanceof nr;
    }
    function _r(t) {
      return V(t[0]) && t[0].ns;
    }
    function vr() {
      return {
        children: [],
        bindings: [],
        attributes: {}
      };
    }
    function yr(t) {
      return "class" == t || "style" == t;
    }
    var xr = o(5072),
      Er = o.n(xr),
      Dr = o(601),
      Br = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Dr.A, Br);
    Dr.A.locals;
    class Sr extends Bi(q()) {
      constructor(t) {
        super(), this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new Wo(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (e, n) => {
          n.locale = t, n.t = t && t.t;
        }), this.decorate("render");
      }
      get bindTemplate() {
        return this._bindTemplate ? this._bindTemplate : this._bindTemplate = ir.bind(this, this);
      }
      createCollection(t) {
        const e = new nr(t);
        return this._viewCollections.add(e), e;
      }
      registerChild(t) {
        X(t) || (t = [t]);
        for (const e of t) this._unboundChildren.add(e);
      }
      deregisterChild(t) {
        X(t) || (t = [t]);
        for (const e of t) this._unboundChildren.remove(e);
      }
      setTemplate(t) {
        this.template = new ir(t);
      }
      extendTemplate(t) {
        ir.extend(this.template, t);
      }
      render() {
        if (this.isRendered) throw new b("ui-view-render-already-rendered", this);
        this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
      }
      destroy() {
        this.stopListening(), this._viewCollections.map(t => t.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
      }
    }
    function Tr(_ref11) {
      let {
        emitter: t,
        activator: e,
        callback: n,
        contextElements: i
      } = _ref11;
      t.listenTo(document, "mousedown", (t, o) => {
        if (!e()) return;
        const r = "function" == typeof o.composedPath ? o.composedPath() : [],
          s = "function" == typeof i ? i() : i;
        for (const t of s) if (t.contains(o.target) || r.includes(t)) return;
        n();
      });
    }
    function Ir(t) {
      return class extends t {
        disableCssTransitions() {
          this._isCssTransitionsDisabled = !0;
        }
        enableCssTransitions() {
          this._isCssTransitionsDisabled = !1;
        }
        constructor() {
          super(...arguments), this.set("_isCssTransitionsDisabled", !1), this.initializeCssTransitionDisablerMixin();
        }
        initializeCssTransitionDisablerMixin() {
          this.extendTemplate({
            attributes: {
              class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
            }
          });
        }
      };
    }
    function Mr(_ref12) {
      let {
        view: t
      } = _ref12;
      t.listenTo(t.element, "submit", (e, n) => {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }
    function Lr(_ref13) {
      let {
        keystrokeHandler: t,
        focusTracker: e,
        gridItems: n,
        numberOfColumns: i,
        uiLanguageDirection: o
      } = _ref13;
      const r = "number" == typeof i ? () => i : i;
      function s(t) {
        return i => {
          const o = n.find(t => t.element === e.focusedElement),
            r = n.getIndex(o),
            s = t(r, n);
          n.get(s).focus(), i.stopPropagation(), i.preventDefault();
        };
      }
      function a(t, e) {
        return t === e - 1 ? 0 : t + 1;
      }
      function l(t, e) {
        return 0 === t ? e - 1 : t - 1;
      }
      t.set("arrowright", s((t, e) => "rtl" === o ? l(t, e.length) : a(t, e.length))), t.set("arrowleft", s((t, e) => "rtl" === o ? a(t, e.length) : l(t, e.length))), t.set("arrowup", s((t, e) => {
        let n = t - r();
        return n < 0 && (n = t + r() * Math.floor(e.length / r()), n > e.length - 1 && (n -= r())), n;
      })), t.set("arrowdown", s((t, e) => {
        let n = t + r();
        return n > e.length - 1 && (n = t % r()), n;
      }));
    }
    class Nr extends q() {
      constructor(t) {
        super(), this._disableStack = new Set(), this.editor = t, this.set("isEnabled", !0);
      }
      forceDisabled(t) {
        this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", zr, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(t) {
        this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", zr), this.isEnabled = !0);
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !1;
      }
    }
    function zr(t) {
      t.return = !1, t.stop();
    }
    class Pr extends q() {
      constructor(t) {
        super(), this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._affectsData = !0, this._isEnabledBasedOnSelection = !0, this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
          this.refresh();
        }), this.listenTo(t, "change:isReadOnly", () => {
          this.refresh();
        }), this.on("set:isEnabled", e => {
          if (!this.affectsData) return;
          const n = t.model.document.selection,
            i = !("$graveyard" == n.getFirstPosition().root.rootName) && t.model.canEditAt(n);
          (t.isReadOnly || this._isEnabledBasedOnSelection && !i) && (e.return = !1, e.stop());
        }, {
          priority: "highest"
        }), this.on("execute", t => {
          this.isEnabled || t.stop();
        }, {
          priority: "high"
        });
      }
      get affectsData() {
        return this._affectsData;
      }
      set affectsData(t) {
        this._affectsData = t;
      }
      refresh() {
        this.isEnabled = !0;
      }
      forceDisabled(t) {
        this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", Vr, {
          priority: "highest"
        }), this.isEnabled = !1);
      }
      clearForceDisabled(t) {
        this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", Vr), this.refresh());
      }
      execute() {}
      destroy() {
        this.stopListening();
      }
    }
    function Vr(t) {
      t.return = !1, t.stop();
    }
    class Rr extends Pr {
      constructor() {
        super(...arguments), this._childCommandsDefinitions = [];
      }
      refresh() {}
      execute() {
        const e = this._getFirstEnabledCommand();
        for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          t[_key12] = arguments[_key12];
        }
        return !!e && e.execute(t);
      }
      registerChildCommand(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        k(this._childCommandsDefinitions, {
          command: t,
          priority: e.priority || "normal"
        }), t.on("change:isEnabled", () => this._checkEnabled()), this._checkEnabled();
      }
      _checkEnabled() {
        this.isEnabled = !!this._getFirstEnabledCommand();
      }
      _getFirstEnabledCommand() {
        const t = this._childCommandsDefinitions.find(_ref14 => {
          let {
            command: t
          } = _ref14;
          return t.isEnabled;
        });
        return t && t.command;
      }
    }
    class Fr extends B() {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        super(), this._plugins = new Map(), this._context = t, this._availablePlugins = new Map();
        for (const t of e) t.pluginName && this._availablePlugins.set(t.pluginName, t);
        this._contextPlugins = new Map();
        for (const [t, e] of n) this._contextPlugins.set(t, e), this._contextPlugins.set(e, t), t.pluginName && this._availablePlugins.set(t.pluginName, t);
      }
      *[Symbol.iterator]() {
        for (const t of this._plugins) "function" == typeof t[0] && (yield t);
      }
      get(t) {
        const e = this._plugins.get(t);
        if (!e) {
          let e = t;
          throw "function" == typeof t && (e = t.pluginName || t.name), new b("plugincollection-plugin-not-loaded", this._context, {
            plugin: e
          });
        }
        return e;
      }
      has(t) {
        return this._plugins.has(t);
      }
      init(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        const i = this,
          o = this._context;
        !function t(e) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
          e.forEach(e => {
            a(e) && (n.has(e) || (n.add(e), e.pluginName && !i._availablePlugins.has(e.pluginName) && i._availablePlugins.set(e.pluginName, e), e.requires && t(e.requires, n)));
          });
        }(t), u(t);
        const r = [...function t(e) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
          return e.map(t => a(t) ? t : i._availablePlugins.get(t)).reduce((e, i) => n.has(i) ? e : (n.add(i), i.requires && (u(i.requires, i), t(i.requires, n).forEach(t => e.add(t))), e.add(i)), new Set());
        }(t.filter(t => !c(t, e)))];
        !function (t, e) {
          for (const n of e) {
            if ("function" != typeof n) throw new b("plugincollection-replace-plugin-invalid-type", null, {
              pluginItem: n
            });
            const e = n.pluginName;
            if (!e) throw new b("plugincollection-replace-plugin-missing-name", null, {
              pluginItem: n
            });
            if (n.requires && n.requires.length) throw new b("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
              pluginName: e
            });
            const o = i._availablePlugins.get(e);
            if (!o) throw new b("plugincollection-plugin-for-replacing-not-exist", null, {
              pluginName: e
            });
            const r = t.indexOf(o);
            if (-1 === r) {
              if (i._contextPlugins.has(o)) return;
              throw new b("plugincollection-plugin-for-replacing-not-loaded", null, {
                pluginName: e
              });
            }
            if (o.requires && o.requires.length) throw new b("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
              pluginName: e
            });
            t.splice(r, 1, n), i._availablePlugins.set(e, n);
          }
        }(r, n);
        const s = function (t) {
          return t.map(t => {
            let e = i._contextPlugins.get(t);
            return e = e || new t(o), i._add(t, e), e;
          });
        }(r);
        return h(s, "init").then(() => h(s, "afterInit")).then(() => s);
        function a(t) {
          return "function" == typeof t;
        }
        function l(t) {
          return a(t) && !!t.isContextPlugin;
        }
        function c(t, e) {
          return e.some(e => e === t || d(t) === e || d(e) === t);
        }
        function d(t) {
          return a(t) ? t.pluginName || t.name : t;
        }
        function u(t) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          t.map(t => a(t) ? t : i._availablePlugins.get(t) || t).forEach(t => {
            !function (t, e) {
              if (a(t)) return;
              if (e) throw new b("plugincollection-soft-required", o, {
                missingPlugin: t,
                requiredBy: d(e)
              });
              throw new b("plugincollection-plugin-not-found", o, {
                plugin: t
              });
            }(t, n), function (t, e) {
              if (!l(e)) return;
              if (l(t)) return;
              throw new b("plugincollection-context-required", o, {
                plugin: d(t),
                requiredBy: d(e)
              });
            }(t, n), function (t, n) {
              if (!n) return;
              if (!c(t, e)) return;
              throw new b("plugincollection-required", o, {
                plugin: d(t),
                requiredBy: d(n)
              });
            }(t, n);
          });
        }
        function h(t, e) {
          return t.reduce((t, n) => n[e] ? i._contextPlugins.has(n) ? t : t.then(n[e].bind(n)) : t, Promise.resolve());
        }
      }
      destroy() {
        const t = [];
        for (const [, e] of this) "function" != typeof e.destroy || this._contextPlugins.has(e) || t.push(e.destroy());
        return Promise.all(t);
      }
      _add(t, e) {
        this._plugins.set(t, e);
        const n = t.pluginName;
        if (n) {
          if (this._plugins.has(n)) throw new b("plugincollection-plugin-name-conflict", null, {
            pluginName: n,
            plugin1: this._plugins.get(n).constructor,
            plugin2: t
          });
          this._plugins.set(n, e);
        }
      }
    }
    class Or {
      constructor(t) {
        this._contextOwner = null;
        const {
          translations: e,
          ...n
        } = t || {};
        this.config = new _i(n, this.constructor.defaultConfig);
        const i = this.constructor.builtinPlugins;
        this.config.define("plugins", i), this.plugins = new Fr(this, i);
        const o = this.config.get("language") || {};
        this.locale = new Go({
          uiLanguage: "string" == typeof o ? o : o.ui,
          contentLanguage: this.config.get("language.content"),
          translations: e
        }), this.t = this.locale.t, this.editors = new Wo();
      }
      initPlugins() {
        const t = this.config.get("plugins") || [],
          e = this.config.get("substitutePlugins") || [];
        for (const n of t.concat(e)) {
          if ("function" != typeof n) throw new b("context-initplugins-constructor-only", null, {
            Plugin: n
          });
          if (!0 !== n.isContextPlugin) throw new b("context-initplugins-invalid-plugin", null, {
            Plugin: n
          });
        }
        return this.plugins.init(t, [], e);
      }
      destroy() {
        return Promise.all(Array.from(this.editors, t => t.destroy())).then(() => this.plugins.destroy());
      }
      _addEditor(t, e) {
        if (this._contextOwner) throw new b("context-addeditor-private-context");
        this.editors.add(t), e && (this._contextOwner = t);
      }
      _removeEditor(t) {
        return this.editors.has(t) && this.editors.remove(t), this._contextOwner === t ? this.destroy() : Promise.resolve();
      }
      _getEditorConfig() {
        const t = {};
        for (const e of this.config.names()) ["plugins", "removePlugins", "extraPlugins"].includes(e) || (t[e] = this.config.get(e));
        return t;
      }
      static create(t) {
        return new Promise(e => {
          const n = new this(t);
          e(n.initPlugins().then(() => n));
        });
      }
    }
    class jr extends q() {
      constructor(t) {
        super(), this.context = t;
      }
      destroy() {
        this.stopListening();
      }
      static get isContextPlugin() {
        return !0;
      }
    }
    var Hr = o(1111),
      Ur = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Hr.A, Ur);
    Hr.A.locals;
    const qr = new WeakMap();
    let Gr = !1;
    function Wr(_ref15) {
      let {
        view: t,
        element: e,
        text: n,
        isDirectHost: i = !0,
        keepOnFocus: o = !1
      } = _ref15;
      const r = t.document;
      function s(n) {
        qr.get(r).set(e, {
          text: n,
          isDirectHost: i,
          keepOnFocus: o,
          hostElement: i ? e : null
        }), t.change(t => Qr(r, t));
      }
      qr.has(r) || (qr.set(r, new Map()), r.registerPostFixer(t => Qr(r, t)), r.on("change:isComposing", () => {
        t.change(t => Qr(r, t));
      }, {
        priority: "high"
      })), e.is("editableElement") && e.on("change:placeholder", (t, e, n) => {
        s(n);
      }), e.placeholder ? s(e.placeholder) : n && s(n), n && function () {
        Gr || w("enableplaceholder-deprecated-text-option");
        Gr = !0;
      }();
    }
    function $r(t, e) {
      return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
    }
    function Kr(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }
    function Yr(t, e) {
      if (!t.isAttached()) return !1;
      const n = Array.from(t.getChildren()).some(t => !t.is("uiElement"));
      if (n) return !1;
      const i = t.document,
        o = i.selection.anchor;
      return (!i.isComposing || !o || o.parent !== t) && (!!e || !i.isFocused || !!o && o.parent !== t);
    }
    function Qr(t, e) {
      const n = qr.get(t),
        i = [];
      let o = !1;
      for (const [t, r] of n) r.isDirectHost && (i.push(t), Zr(e, t, r) && (o = !0));
      for (const [t, r] of n) {
        if (r.isDirectHost) continue;
        const n = Jr(t);
        n && (i.includes(n) || (r.hostElement = n, Zr(e, t, r) && (o = !0)));
      }
      return o;
    }
    function Zr(t, e, n) {
      const {
        text: i,
        isDirectHost: o,
        hostElement: r
      } = n;
      let s = !1;
      r.getAttribute("data-placeholder") !== i && (t.setAttribute("data-placeholder", i, r), s = !0);
      return (o || 1 == e.childCount) && Yr(r, n.keepOnFocus) ? $r(t, r) && (s = !0) : Kr(t, r) && (s = !0), s;
    }
    function Jr(t) {
      if (t.childCount) {
        const e = t.getChild(0);
        if (e.is("element") && !e.is("uiElement") && !e.is("attributeElement")) return e;
      }
      return null;
    }
    class Xr {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    const ts = function (t) {
      return wi(t, 4);
    };
    class es extends B(Xr) {
      constructor(t) {
        super(), this.document = t, this.parent = null;
      }
      get index() {
        let t;
        if (!this.parent) return null;
        if (-1 == (t = this.parent.getChildIndex(this))) throw new b("view-node-not-found-in-parent", this);
        return t;
      }
      get nextSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t + 1) || null;
      }
      get previousSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t - 1) || null;
      }
      get root() {
        let t = this;
        for (; t.parent;) t = t.parent;
        return t;
      }
      isAttached() {
        return this.root.is("rootElement");
      }
      getPath() {
        const t = [];
        let e = this;
        for (; e.parent;) t.unshift(e.index), e = e.parent;
        return t;
      }
      getAncestors() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      getCommonAncestor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.getAncestors(e),
          i = t.getAncestors(e);
        let o = 0;
        for (; n[o] == i[o] && n[o];) o++;
        return 0 === o ? null : n[o - 1];
      }
      isBefore(t) {
        if (this == t) return !1;
        if (this.root !== t.root) return !1;
        const e = this.getPath(),
          n = t.getPath(),
          i = J(e, n);
        switch (i) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return e[i] < n[i];
        }
      }
      isAfter(t) {
        return this != t && this.root === t.root && !this.isBefore(t);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _fireChange(t, e) {
        this.fire(`change:${t}`, e), this.parent && this.parent._fireChange(t, e);
      }
      toJSON() {
        const t = ts(this);
        return delete t.parent, t;
      }
    }
    es.prototype.is = function (t) {
      return "node" === t || "view:node" === t;
    };
    class ns extends es {
      constructor(t, e) {
        super(t), this._textData = e;
      }
      get data() {
        return this._textData;
      }
      get _data() {
        return this.data;
      }
      set _data(t) {
        this._fireChange("text", this), this._textData = t;
      }
      isSimilar(t) {
        return t instanceof ns && (this === t || this.data === t.data);
      }
      _clone() {
        return new ns(this.document, this.data);
      }
    }
    ns.prototype.is = function (t) {
      return "$text" === t || "view:$text" === t || "text" === t || "view:text" === t || "node" === t || "view:node" === t;
    };
    class is extends Xr {
      constructor(t, e, n) {
        if (super(), this.textNode = t, e < 0 || e > t.data.length) throw new b("view-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.data.length) throw new b("view-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      get offsetSize() {
        return this.data.length;
      }
      get isPartial() {
        return this.data.length !== this.textNode.data.length;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      get document() {
        return this.textNode.document;
      }
      getAncestors() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = [];
        let n = t.includeSelf ? this.textNode : this.parent;
        for (; null !== n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
    }
    is.prototype.is = function (t) {
      return "$textProxy" === t || "view:$textProxy" === t || "textProxy" === t || "view:textProxy" === t;
    };
    class os {
      constructor() {
        this._patterns = [], this.add(...arguments);
      }
      add() {
        for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          t[_key13] = arguments[_key13];
        }
        for (let e of t) ("string" == typeof e || e instanceof RegExp) && (e = {
          name: e
        }), this._patterns.push(e);
      }
      match() {
        for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          t[_key14] = arguments[_key14];
        }
        for (const e of t) for (const t of this._patterns) {
          const n = rs(e, t);
          if (n) return {
            element: e,
            pattern: t,
            match: n
          };
        }
        return null;
      }
      matchAll() {
        const e = [];
        for (var _len15 = arguments.length, t = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
          t[_key15] = arguments[_key15];
        }
        for (const n of t) for (const t of this._patterns) {
          const i = rs(n, t);
          i && e.push({
            element: n,
            pattern: t,
            match: i
          });
        }
        return e.length > 0 ? e : null;
      }
      getElementName() {
        if (1 !== this._patterns.length) return null;
        const t = this._patterns[0],
          e = t.name;
        return "function" == typeof t || !e || e instanceof RegExp ? null : e;
      }
    }
    function rs(t, e) {
      if ("function" == typeof e) return e(t);
      const n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return !!e.match(t);
        return t === e;
      }(e.name, t.name), !n.name) || e.attributes && (n.attributes = function (t, e) {
        const n = new Set(e.getAttributeKeys());
        yt(t) ? (void 0 !== t.style && w("matcher-pattern-deprecated-attributes-style-key", t), void 0 !== t.class && w("matcher-pattern-deprecated-attributes-class-key", t)) : (n.delete("style"), n.delete("class"));
        return ss(t, n, t => e.getAttribute(t));
      }(e.attributes, t), !n.attributes) || e.classes && (n.classes = function (t, e) {
        return ss(t, e.getClassNames(), () => {});
      }(e.classes, t), !n.classes) || e.styles && (n.styles = function (t, e) {
        return ss(t, e.getStyleNames(!0), t => e.getStyle(t));
      }(e.styles, t), !n.styles) ? null : n;
    }
    function ss(t, e, n) {
      const i = function (t) {
          if (Array.isArray(t)) return t.map(t => yt(t) ? (void 0 !== t.key && void 0 !== t.value || w("matcher-pattern-missing-key-or-value", t), [t.key, t.value]) : [t, !0]);
          if (yt(t)) return Object.entries(t);
          return [[t, !0]];
        }(t),
        o = Array.from(e),
        r = [];
      if (i.forEach(_ref16 => {
        let [t, e] = _ref16;
        o.forEach(i => {
          (function (t, e) {
            return !0 === t || t === e || t instanceof RegExp && e.match(t);
          })(t, i) && function (t, e, n) {
            if (!0 === t) return !0;
            const i = n(e);
            return t === i || t instanceof RegExp && !!String(i).match(t);
          }(e, i, n) && r.push(i);
        });
      }), i.length && !(r.length < i.length)) return r;
    }
    const as = function (t) {
      return "symbol" == typeof t || gt(t) && "[object Symbol]" == ht(t);
    };
    var ls = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      cs = /^\w*$/;
    const ds = function (t, e) {
      if (mt(t)) return !1;
      var n = typeof t;
      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !as(t)) || cs.test(t) || !ls.test(t) || null != e && t in Object(e);
    };
    function us(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
      var n = function () {
        var i = arguments,
          o = e ? e.apply(this, i) : i[0],
          r = n.cache;
        if (r.has(o)) return r.get(o);
        var s = t.apply(this, i);
        return n.cache = r.set(o, s) || r, s;
      };
      return n.cache = new (us.Cache || we)(), n;
    }
    us.Cache = we;
    const hs = us;
    const ms = function (t) {
      var e = hs(t, function (t) {
          return 500 === n.size && n.clear(), t;
        }),
        n = e.cache;
      return e;
    };
    var gs = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      ps = /\\(\\)?/g,
      fs = ms(function (t) {
        var e = [];
        return 46 === t.charCodeAt(0) && e.push(""), t.replace(gs, function (t, n, i, o) {
          e.push(i ? o.replace(ps, "$1") : n || t);
        }), e;
      });
    const ks = fs;
    const bs = function (t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = Array(i); ++n < i;) o[n] = e(t[n], n, t);
      return o;
    };
    var ws = it ? it.prototype : void 0,
      As = ws ? ws.toString : void 0;
    const Cs = function t(e) {
      if ("string" == typeof e) return e;
      if (mt(e)) return bs(e, t) + "";
      if (as(e)) return As ? As.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
    };
    const _s = function (t) {
      return null == t ? "" : Cs(t);
    };
    const vs = function (t, e) {
      return mt(t) ? t : ds(t, e) ? [t] : ks(_s(t));
    };
    const ys = function (t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
    const xs = function (t) {
      if ("string" == typeof t || as(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
    };
    const Es = function (t, e) {
      for (var n = 0, i = (e = vs(e, t)).length; null != t && n < i;) t = t[xs(e[n++])];
      return n && n == i ? t : void 0;
    };
    const Ds = function (t, e, n) {
      var i = -1,
        o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;
      for (var r = Array(o); ++i < o;) r[i] = t[i + e];
      return r;
    };
    const Bs = function (t, e) {
      return e.length < 2 ? t : Es(t, Ds(e, 0, -1));
    };
    const Ss = function (t, e) {
      return e = vs(e, t), null == (t = Bs(t, e)) || delete t[xs(ys(e))];
    };
    const Ts = function (t, e) {
      return null == t || Ss(t, e);
    };
    const Is = function (t, e, n) {
      var i = null == t ? void 0 : Es(t, e);
      return void 0 === i ? n : i;
    };
    const Ms = function (t, e, n, i) {
      if (!V(t)) return t;
      for (var o = -1, r = (e = vs(e, t)).length, s = r - 1, a = t; null != a && ++o < r;) {
        var l = xs(e[o]),
          c = n;
        if ("__proto__" === l || "constructor" === l || "prototype" === l) return t;
        if (o != s) {
          var d = a[l];
          void 0 === (c = i ? i(d, l, a) : void 0) && (c = V(d) ? d : je(e[o + 1]) ? [] : {});
        }
        De(a, l, c), a = a[l];
      }
      return t;
    };
    const Ls = function (t, e, n) {
      return null == t ? t : Ms(t, e, n);
    };
    class Ns {
      constructor(t) {
        this._styles = {}, this._styleProcessor = t;
      }
      get isEmpty() {
        return !Object.entries(this._styles).length;
      }
      get size() {
        return this.isEmpty ? 0 : this.getStyleNames().length;
      }
      setTo(t) {
        this.clear();
        const e = function (t) {
          let e = null,
            n = 0,
            i = 0,
            o = null;
          const r = new Map();
          if ("" === t) return r;
          ";" != t.charAt(t.length - 1) && (t += ";");
          for (let s = 0; s < t.length; s++) {
            const a = t.charAt(s);
            if (null === e) switch (a) {
              case ":":
                o || (o = t.substr(n, s - n), i = s + 1);
                break;
              case '"':
              case "'":
                e = a;
                break;
              case ";":
                {
                  const e = t.substr(i, s - i);
                  o && r.set(o.trim(), e.trim()), o = null, n = s + 1;
                  break;
                }
            } else a === e && (e = null);
          }
          return r;
        }(t);
        for (const [t, n] of e) this._styleProcessor.toNormalizedForm(t, n, this._styles);
      }
      has(t) {
        if (this.isEmpty) return !1;
        const e = this._styleProcessor.getReducedForm(t, this._styles).find(_ref17 => {
          let [e] = _ref17;
          return e === t;
        });
        return Array.isArray(e);
      }
      set(t, e) {
        if (V(t)) for (const [e, n] of Object.entries(t)) this._styleProcessor.toNormalizedForm(e, n, this._styles);else this._styleProcessor.toNormalizedForm(t, e, this._styles);
      }
      remove(t) {
        const e = Ps(t);
        Ts(this._styles, e), delete this._styles[t], this._cleanEmptyObjectsOnPath(e);
      }
      getNormalized(t) {
        return this._styleProcessor.getNormalized(t, this._styles);
      }
      toString() {
        return this.isEmpty ? "" : this.getStylesEntries().map(t => t.join(":")).sort().join(";") + ";";
      }
      getAsString(t) {
        if (this.isEmpty) return;
        if (this._styles[t] && !V(this._styles[t])) return this._styles[t];
        const e = this._styleProcessor.getReducedForm(t, this._styles).find(_ref18 => {
          let [e] = _ref18;
          return e === t;
        });
        return Array.isArray(e) ? e[1] : void 0;
      }
      getStyleNames() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        if (this.isEmpty) return [];
        if (t) return this._styleProcessor.getStyleNames(this._styles);
        return this.getStylesEntries().map(_ref19 => {
          let [t] = _ref19;
          return t;
        });
      }
      clear() {
        this._styles = {};
      }
      getStylesEntries() {
        const t = [],
          e = Object.keys(this._styles);
        for (const n of e) t.push(...this._styleProcessor.getReducedForm(n, this._styles));
        return t;
      }
      _cleanEmptyObjectsOnPath(t) {
        const e = t.split(".");
        if (!(e.length > 1)) return;
        const n = e.splice(0, e.length - 1).join("."),
          i = Is(this._styles, n);
        if (!i) return;
        !Object.keys(i).length && this.remove(n);
      }
    }
    class zs {
      constructor() {
        this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
      }
      toNormalizedForm(t, e, n) {
        if (V(e)) Vs(n, Ps(t), e);else if (this._normalizers.has(t)) {
          const i = this._normalizers.get(t),
            {
              path: o,
              value: r
            } = i(e);
          Vs(n, o, r);
        } else Vs(n, t, e);
      }
      getNormalized(t, e) {
        if (!t) return Uo({}, e);
        if (void 0 !== e[t]) return e[t];
        if (this._extractors.has(t)) {
          const n = this._extractors.get(t);
          if ("string" == typeof n) return Is(e, n);
          const i = n(t, e);
          if (i) return i;
        }
        return Is(e, Ps(t));
      }
      getReducedForm(t, e) {
        const n = this.getNormalized(t, e);
        if (void 0 === n) return [];
        if (this._reducers.has(t)) {
          return this._reducers.get(t)(n);
        }
        return [[t, n]];
      }
      getStyleNames(t) {
        const e = Array.from(this._consumables.keys()).filter(e => {
            const n = this.getNormalized(e, t);
            return n && "object" == typeof n ? Object.keys(n).length : n;
          }),
          n = new Set([...e, ...Object.keys(t)]);
        return Array.from(n);
      }
      getRelatedStyles(t) {
        return this._consumables.get(t) || [];
      }
      setNormalizer(t, e) {
        this._normalizers.set(t, e);
      }
      setExtractor(t, e) {
        this._extractors.set(t, e);
      }
      setReducer(t, e) {
        this._reducers.set(t, e);
      }
      setStyleRelation(t, e) {
        this._mapStyleNames(t, e);
        for (const n of e) this._mapStyleNames(n, [t]);
      }
      _mapStyleNames(t, e) {
        this._consumables.has(t) || this._consumables.set(t, []), this._consumables.get(t).push(...e);
      }
    }
    function Ps(t) {
      return t.replace("-", ".");
    }
    function Vs(t, e, n) {
      let i = n;
      V(n) && (i = Uo({}, Is(t, e), n)), Ls(t, e, i);
    }
    class Rs extends es {
      constructor(t, e, n, i) {
        if (super(t), this._unsafeAttributesToRender = [], this._customProperties = new Map(), this.name = e, this._attrs = function (t) {
          const e = Qo(t);
          for (const [t, n] of e) null === n ? e.delete(t) : "string" != typeof n && e.set(t, String(n));
          return e;
        }(n), this._children = [], i && this._insertChild(0, i), this._classes = new Set(), this._attrs.has("class")) {
          const t = this._attrs.get("class");
          Fs(this._classes, t), this._attrs.delete("class");
        }
        this._styles = new Ns(this.document.stylesProcessor), this._attrs.has("style") && (this._styles.setTo(this._attrs.get("style")), this._attrs.delete("style"));
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this._children.length;
      }
      getChild(t) {
        return this._children[t];
      }
      getChildIndex(t) {
        return this._children.indexOf(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      *getAttributeKeys() {
        this._classes.size > 0 && (yield "class"), this._styles.isEmpty || (yield "style"), yield* this._attrs.keys();
      }
      *getAttributes() {
        yield* this._attrs.entries(), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.isEmpty || (yield ["style", this.getAttribute("style")]);
      }
      getAttribute(t) {
        if ("class" == t) return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
        if ("style" == t) {
          const t = this._styles.toString();
          return "" == t ? void 0 : t;
        }
        return this._attrs.get(t);
      }
      hasAttribute(t) {
        return "class" == t ? this._classes.size > 0 : "style" == t ? !this._styles.isEmpty : this._attrs.has(t);
      }
      isSimilar(t) {
        if (!(t instanceof Rs)) return !1;
        if (this === t) return !0;
        if (this.name != t.name) return !1;
        if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;
        for (const [e, n] of this._attrs) if (!t._attrs.has(e) || t._attrs.get(e) !== n) return !1;
        for (const e of this._classes) if (!t._classes.has(e)) return !1;
        for (const e of this._styles.getStyleNames()) if (!t._styles.has(e) || t._styles.getAsString(e) !== this._styles.getAsString(e)) return !1;
        return !0;
      }
      hasClass() {
        for (var _len16 = arguments.length, t = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          t[_key16] = arguments[_key16];
        }
        for (const e of t) if (!this._classes.has(e)) return !1;
        return !0;
      }
      getClassNames() {
        return this._classes.keys();
      }
      getStyle(t) {
        return this._styles.getAsString(t);
      }
      getNormalizedStyle(t) {
        return this._styles.getNormalized(t);
      }
      getStyleNames(t) {
        return this._styles.getStyleNames(t);
      }
      hasStyle() {
        for (var _len17 = arguments.length, t = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          t[_key17] = arguments[_key17];
        }
        for (const e of t) if (!this._styles.has(e)) return !1;
        return !0;
      }
      findAncestor() {
        for (var _len18 = arguments.length, t = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
          t[_key18] = arguments[_key18];
        }
        const e = new os(...t);
        let n = this.parent;
        for (; n && !n.is("documentFragment");) {
          if (e.match(n)) return n;
          n = n.parent;
        }
        return null;
      }
      getCustomProperty(t) {
        return this._customProperties.get(t);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      getIdentity() {
        const t = Array.from(this._classes).sort().join(","),
          e = this._styles.toString(),
          n = Array.from(this._attrs).map(t => `${t[0]}="${t[1]}"`).sort().join(" ");
        return this.name + ("" == t ? "" : ` class="${t}"`) + (e ? ` style="${e}"` : "") + ("" == n ? "" : ` ${n}`);
      }
      shouldRenderUnsafeAttribute(t) {
        return this._unsafeAttributesToRender.includes(t);
      }
      _clone() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const e = [];
        if (t) for (const n of this.getChildren()) e.push(n._clone(t));
        const n = new this.constructor(this.document, this.name, this._attrs, e);
        return n._classes = new Set(this._classes), n._styles.set(this._styles.getNormalized()), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._unsafeAttributesToRender = this._unsafeAttributesToRender, n;
      }
      _appendChild(t) {
        return this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        this._fireChange("children", this);
        let n = 0;
        const i = function (t, e) {
          if ("string" == typeof e) return [new ns(t, e)];
          X(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new ns(t, e) : e instanceof is ? new ns(t, e.data) : e);
        }(this.document, e);
        for (const e of i) null !== e.parent && e._remove(), e.parent = this, e.document = this.document, this._children.splice(t, 0, e), t++, n++;
        return n;
      }
      _removeChildren(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        this._fireChange("children", this);
        for (let n = t; n < t + e; n++) this._children[n].parent = null;
        return this._children.splice(t, e);
      }
      _setAttribute(t, e) {
        const n = String(e);
        this._fireChange("attributes", this), "class" == t ? Fs(this._classes, n) : "style" == t ? this._styles.setTo(n) : this._attrs.set(t, n);
      }
      _removeAttribute(t) {
        return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(t);
      }
      _addClass(t) {
        this._fireChange("attributes", this);
        for (const e of vo(t)) this._classes.add(e);
      }
      _removeClass(t) {
        this._fireChange("attributes", this);
        for (const e of vo(t)) this._classes.delete(e);
      }
      _setStyle(t, e) {
        this._fireChange("attributes", this), "string" != typeof t ? this._styles.set(t) : this._styles.set(t, e);
      }
      _removeStyle(t) {
        this._fireChange("attributes", this);
        for (const e of vo(t)) this._styles.remove(e);
      }
      _setCustomProperty(t, e) {
        this._customProperties.set(t, e);
      }
      _removeCustomProperty(t) {
        return this._customProperties.delete(t);
      }
    }
    function Fs(t, e) {
      const n = e.split(/\s+/);
      t.clear(), n.forEach(e => t.add(e));
    }
    Rs.prototype.is = function (t, e) {
      return e ? e === this.name && ("element" === t || "view:element" === t) : "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class Os extends Rs {
      constructor(t, e, n, i) {
        super(t, e, n, i), this.getFillerOffset = js;
      }
    }
    function js() {
      const t = [...this.getChildren()],
        e = t[this.childCount - 1];
      if (e && e.is("element", "br")) return this.childCount;
      for (const e of t) if (!e.is("uiElement")) return null;
      return this.childCount;
    }
    Os.prototype.is = function (t, e) {
      return e ? e === this.name && ("containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class Hs extends q(Os) {
      constructor(t, e, n, i) {
        super(t, e, n, i), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("placeholder", void 0), this.bind("isReadOnly").to(t), this.bind("isFocused").to(t, "isFocused", e => e && t.selection.editableElement == this), this.listenTo(t.selection, "change", () => {
          this.isFocused = t.isFocused && t.selection.editableElement == this;
        });
      }
      destroy() {
        this.stopListening();
      }
    }
    Hs.prototype.is = function (t, e) {
      return e ? e === this.name && ("editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    const Us = Symbol("rootName");
    class qs extends Hs {
      constructor(t, e) {
        super(t, e), this.rootName = "main";
      }
      get rootName() {
        return this.getCustomProperty(Us);
      }
      set rootName(t) {
        this._setCustomProperty(Us, t);
      }
      set _name(t) {
        this.name = t;
      }
    }
    qs.prototype.is = function (t, e) {
      return e ? e === this.name && ("rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class Gs {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!t.boundaries && !t.startPosition) throw new b("view-tree-walker-no-start-position", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new b("view-tree-walker-unknown-direction", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this._position = Ws._createAt(t.startPosition) : this._position = Ws._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(t) {
        let e, n;
        do {
          n = this.position, e = this.next();
        } while (!e.done && t(e.value));
        e.done || (this._position = n);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        let t = this.position.clone();
        const e = this.position,
          n = t.parent;
        if (null === n.parent && t.offset === n.childCount) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        let i;
        if (n instanceof ns) {
          if (t.isAtEnd) return this._position = Ws._createAfter(n), this._next();
          i = n.data[t.offset];
        } else i = n.getChild(t.offset);
        if (i instanceof Rs) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(t)) return {
              done: !0,
              value: void 0
            };
            t.offset++;
          } else t = new Ws(i, 0);
          return this._position = t, this._formatReturnValue("elementStart", i, e, t, 1);
        }
        if (i instanceof ns) {
          if (this.singleCharacters) return t = new Ws(i, 0), this._position = t, this._next();
          let n,
            o = i.data.length;
          return i == this._boundaryEndParent ? (o = this.boundaries.end.offset, n = new is(i, 0, o), t = Ws._createAfter(n)) : (n = new is(i, 0, i.data.length), t.offset++), this._position = t, this._formatReturnValue("text", n, e, t, o);
        }
        if ("string" == typeof i) {
          let i;
          if (this.singleCharacters) i = 1;else {
            i = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
          }
          const o = new is(n, t.offset, i);
          return t.offset += i, this._position = t, this._formatReturnValue("text", o, e, t, i);
        }
        return t = Ws._createAfter(n), this._position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
      }
      _previous() {
        let t = this.position.clone();
        const e = this.position,
          n = t.parent;
        if (null === n.parent && 0 === t.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        let i;
        if (n instanceof ns) {
          if (t.isAtStart) return this._position = Ws._createBefore(n), this._previous();
          i = n.data[t.offset - 1];
        } else i = n.getChild(t.offset - 1);
        if (i instanceof Rs) return this.shallow ? (t.offset--, this._position = t, this._formatReturnValue("elementStart", i, e, t, 1)) : (t = new Ws(i, i.childCount), this._position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, e, t));
        if (i instanceof ns) {
          if (this.singleCharacters) return t = new Ws(i, i.data.length), this._position = t, this._previous();
          let n,
            o = i.data.length;
          if (i == this._boundaryStartParent) {
            const e = this.boundaries.start.offset;
            n = new is(i, e, i.data.length - e), o = n.data.length, t = Ws._createBefore(n);
          } else n = new is(i, 0, i.data.length), t.offset--;
          return this._position = t, this._formatReturnValue("text", n, e, t, o);
        }
        if ("string" == typeof i) {
          let i;
          if (this.singleCharacters) i = 1;else {
            const e = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
            i = t.offset - e;
          }
          t.offset -= i;
          const o = new is(n, t.offset, i);
          return this._position = t, this._formatReturnValue("text", o, e, t, i);
        }
        return t = Ws._createBefore(n), this._position = t, this._formatReturnValue("elementStart", n, e, t, 1);
      }
      _formatReturnValue(t, e, n, i, o) {
        return e instanceof is && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Ws._createAfter(e.textNode) : (i = Ws._createAfter(e.textNode), this._position = i)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Ws._createBefore(e.textNode) : (i = Ws._createBefore(e.textNode), this._position = i))), {
          done: !1,
          value: {
            type: t,
            item: e,
            previousPosition: n,
            nextPosition: i,
            length: o
          }
        };
      }
    }
    class Ws extends Xr {
      constructor(t, e) {
        super(), this.parent = t, this.offset = e;
      }
      get nodeAfter() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
      }
      get nodeBefore() {
        return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
        return this.offset === t;
      }
      get root() {
        return this.parent.root;
      }
      get editableElement() {
        let t = this.parent;
        for (; !(t instanceof Hs);) {
          if (!t.parent) return null;
          t = t.parent;
        }
        return t;
      }
      getShiftedBy(t) {
        const e = Ws._createAt(this),
          n = e.offset + t;
        return e.offset = n < 0 ? 0 : n, e;
      }
      getLastMatchingPosition(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        e.startPosition = this;
        const n = new Gs(e);
        return n.skip(t), n.position;
      }
      getAncestors() {
        return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
          includeSelf: !0
        });
      }
      getCommonAncestor(t) {
        const e = this.getAncestors(),
          n = t.getAncestors();
        let i = 0;
        for (; e[i] == n[i] && e[i];) i++;
        return 0 === i ? null : e[i - 1];
      }
      isEqual(t) {
        return this.parent == t.parent && this.offset == t.offset;
      }
      isBefore(t) {
        return "before" == this.compareWith(t);
      }
      isAfter(t) {
        return "after" == this.compareWith(t);
      }
      compareWith(t) {
        if (this.root !== t.root) return "different";
        if (this.isEqual(t)) return "same";
        const e = this.parent.is("node") ? this.parent.getPath() : [],
          n = t.parent.is("node") ? t.parent.getPath() : [];
        e.push(this.offset), n.push(t.offset);
        const i = J(e, n);
        switch (i) {
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return e[i] < n[i] ? "before" : "after";
        }
      }
      getWalker() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return t.startPosition = this, new Gs(t);
      }
      clone() {
        return new Ws(this.parent, this.offset);
      }
      static _createAt(t, e) {
        if (t instanceof Ws) return new this(t.parent, t.offset);
        {
          const n = t;
          if ("end" == e) e = n.is("$text") ? n.data.length : n.childCount;else {
            if ("before" == e) return this._createBefore(n);
            if ("after" == e) return this._createAfter(n);
            if (0 !== e && !e) throw new b("view-createpositionat-offset-required", n);
          }
          return new Ws(n, e);
        }
      }
      static _createAfter(t) {
        if (t.is("$textProxy")) return new Ws(t.textNode, t.offsetInText + t.data.length);
        if (!t.parent) throw new b("view-position-after-root", t, {
          root: t
        });
        return new Ws(t.parent, t.index + 1);
      }
      static _createBefore(t) {
        if (t.is("$textProxy")) return new Ws(t.textNode, t.offsetInText);
        if (!t.parent) throw new b("view-position-before-root", t, {
          root: t
        });
        return new Ws(t.parent, t.index);
      }
    }
    Ws.prototype.is = function (t) {
      return "position" === t || "view:position" === t;
    };
    class $s extends Xr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        super(), this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }
      *[Symbol.iterator]() {
        yield* new Gs({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return this.start.parent === this.end.parent;
      }
      get root() {
        return this.start.root;
      }
      getEnlarged() {
        let t = this.start.getLastMatchingPosition(Ks, {
            direction: "backward"
          }),
          e = this.end.getLastMatchingPosition(Ks);
        return t.parent.is("$text") && t.isAtStart && (t = Ws._createBefore(t.parent)), e.parent.is("$text") && e.isAtEnd && (e = Ws._createAfter(e.parent)), new $s(t, e);
      }
      getTrimmed() {
        let t = this.start.getLastMatchingPosition(Ks);
        if (t.isAfter(this.end) || t.isEqual(this.end)) return new $s(t, t);
        let e = this.end.getLastMatchingPosition(Ks, {
          direction: "backward"
        });
        const n = t.nodeAfter,
          i = e.nodeBefore;
        return n && n.is("$text") && (t = new Ws(n, 0)), i && i.is("$text") && (e = new Ws(i, i.data.length)), new $s(t, e);
      }
      isEqual(t) {
        return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
      }
      containsPosition(t) {
        return t.isAfter(this.start) && t.isBefore(this.end);
      }
      containsRange(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        t.isCollapsed && (e = !1);
        const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
          i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
        return n && i;
      }
      getDifference(t) {
        const e = [];
        return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new $s(this.start, t.start)), this.containsPosition(t.end) && e.push(new $s(t.end, this.end))) : e.push(this.clone()), e;
      }
      getIntersection(t) {
        if (this.isIntersecting(t)) {
          let e = this.start,
            n = this.end;
          return this.containsPosition(t.start) && (e = t.start), this.containsPosition(t.end) && (n = t.end), new $s(e, n);
        }
        return null;
      }
      getWalker() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return t.boundaries = this, new Gs(t);
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        let t = this.start.nodeAfter,
          e = this.end.nodeBefore;
        return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (e = this.end.parent.previousSibling), t && t.is("element") && t === e ? t : null;
      }
      clone() {
        return new $s(this.start, this.end);
      }
      getItems() {
        var _this2 = this;
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          t.boundaries = _this2, t.ignoreElementEnd = !0;
          const e = new Gs(t);
          for (const t of e) yield t.item;
        }();
      }
      getPositions() {
        var _this3 = this;
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          t.boundaries = _this3;
          const e = new Gs(t);
          yield e.position;
          for (const t of e) yield t.nextPosition;
        }();
      }
      isIntersecting(t) {
        return this.start.isBefore(t.end) && this.end.isAfter(t.start);
      }
      static _createFromParentsAndOffsets(t, e, n, i) {
        return new this(new Ws(t, e), new Ws(n, i));
      }
      static _createFromPositionAndShift(t, e) {
        const n = t,
          i = t.getShiftedBy(e);
        return e > 0 ? new this(n, i) : new this(i, n);
      }
      static _createIn(t) {
        return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
      }
      static _createOn(t) {
        const e = t.is("$textProxy") ? t.offsetSize : 1;
        return this._createFromPositionAndShift(Ws._createBefore(t), e);
      }
    }
    function Ks(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }
    $s.prototype.is = function (t) {
      return "range" === t || "view:range" === t;
    };
    class Ys extends B(Xr) {
      constructor() {
        super(), this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", arguments.length && this.setTo(...arguments);
      }
      get isFake() {
        return this._isFake;
      }
      get fakeSelectionLabel() {
        return this._fakeSelectionLabel;
      }
      get anchor() {
        if (!this._ranges.length) return null;
        const t = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? t.end : t.start).clone();
      }
      get focus() {
        if (!this._ranges.length) return null;
        const t = this._ranges[this._ranges.length - 1];
        return (this._lastRangeBackward ? t.start : t.end).clone();
      }
      get isCollapsed() {
        return 1 === this.rangeCount && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      get editableElement() {
        return this.anchor ? this.anchor.editableElement : null;
      }
      *getRanges() {
        for (const t of this._ranges) yield t.clone();
      }
      getFirstRange() {
        let t = null;
        for (const e of this._ranges) t && !e.start.isBefore(t.start) || (t = e);
        return t ? t.clone() : null;
      }
      getLastRange() {
        let t = null;
        for (const e of this._ranges) t && !e.end.isAfter(t.end) || (t = e);
        return t ? t.clone() : null;
      }
      getFirstPosition() {
        const t = this.getFirstRange();
        return t ? t.start.clone() : null;
      }
      getLastPosition() {
        const t = this.getLastRange();
        return t ? t.end.clone() : null;
      }
      isEqual(t) {
        if (this.isFake != t.isFake) return !1;
        if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
        if (this.rangeCount != t.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
        for (const e of this._ranges) {
          let n = !1;
          for (const i of t._ranges) if (e.isEqual(i)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      isSimilar(t) {
        if (this.isBackward != t.isBackward) return !1;
        const e = Z(this.getRanges());
        if (e != Z(t.getRanges())) return !1;
        if (0 == e) return !0;
        for (let e of this.getRanges()) {
          e = e.getTrimmed();
          let n = !1;
          for (let i of t.getRanges()) if (i = i.getTrimmed(), e.start.isEqual(i.start) && e.end.isEqual(i.end)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      setTo() {
        for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
          t[_key19] = arguments[_key19];
        }
        let [e, n, i] = t;
        if ("object" == typeof n && (i = n, n = void 0), null === e) this._setRanges([]), this._setFakeOptions(i);else if (e instanceof Ys || e instanceof Qs) this._setRanges(e.getRanges(), e.isBackward), this._setFakeOptions({
          fake: e.isFake,
          label: e.fakeSelectionLabel
        });else if (e instanceof $s) this._setRanges([e], i && i.backward), this._setFakeOptions(i);else if (e instanceof Ws) this._setRanges([new $s(e)]), this._setFakeOptions(i);else if (e instanceof es) {
          const t = !!i && !!i.backward;
          let o;
          if (void 0 === n) throw new b("view-selection-setto-required-second-parameter", this);
          o = "in" == n ? $s._createIn(e) : "on" == n ? $s._createOn(e) : new $s(Ws._createAt(e, n)), this._setRanges([o], t), this._setFakeOptions(i);
        } else {
          if (!X(e)) throw new b("view-selection-setto-not-selectable", this);
          this._setRanges(e, i && i.backward), this._setFakeOptions(i);
        }
        this.fire("change");
      }
      setFocus(t, e) {
        if (null === this.anchor) throw new b("view-selection-setfocus-no-ranges", this);
        const n = Ws._createAt(t, e);
        if ("same" == n.compareWith(this.focus)) return;
        const i = this.anchor;
        this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new $s(n, i), !0) : this._addRange(new $s(i, n)), this.fire("change");
      }
      _setRanges(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        t = Array.from(t), this._ranges = [];
        for (const e of t) this._addRange(e);
        this._lastRangeBackward = !!e;
      }
      _setFakeOptions() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
      }
      _addRange(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        if (!(t instanceof $s)) throw new b("view-selection-add-range-not-range", this);
        this._pushRange(t), this._lastRangeBackward = !!e;
      }
      _pushRange(t) {
        for (const e of this._ranges) if (t.isIntersecting(e)) throw new b("view-selection-range-intersects", this, {
          addedRange: t,
          intersectingRange: e
        });
        this._ranges.push(new $s(t.start, t.end));
      }
    }
    Ys.prototype.is = function (t) {
      return "selection" === t || "view:selection" === t;
    };
    class Qs extends B(Xr) {
      constructor() {
        super(), this._selection = new Ys(), this._selection.delegate("change").to(this), arguments.length && this._selection.setTo(...arguments);
      }
      get isFake() {
        return this._selection.isFake;
      }
      get fakeSelectionLabel() {
        return this._selection.fakeSelectionLabel;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get editableElement() {
        return this._selection.editableElement;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      *getRanges() {
        yield* this._selection.getRanges();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      isEqual(t) {
        return this._selection.isEqual(t);
      }
      isSimilar(t) {
        return this._selection.isSimilar(t);
      }
      _setTo() {
        this._selection.setTo(...arguments);
      }
      _setFocus(t, e) {
        this._selection.setFocus(t, e);
      }
    }
    Qs.prototype.is = function (t) {
      return "selection" === t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
    };
    class Zs extends m {
      constructor(t, e, n) {
        super(t, e), this.startRange = n, this._eventPhase = "none", this._currentTarget = null;
      }
      get eventPhase() {
        return this._eventPhase;
      }
      get currentTarget() {
        return this._currentTarget;
      }
    }
    const Js = Symbol("bubbling contexts");
    function Xs(t) {
      return class extends t {
        fire(t) {
          try {
            const n = t instanceof m ? t : new m(this, t),
              i = ia(this);
            if (!i.size) return;
            for (var _len20 = arguments.length, e = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
              e[_key20 - 1] = arguments[_key20];
            }
            if (ta(n, "capturing", this), ea(i, "$capture", n, ...e)) return n.return;
            const o = n.startRange || this.selection.getFirstRange(),
              r = o ? o.getContainedElement() : null,
              s = !!r && Boolean(na(i, r));
            let a = r || function (t) {
              if (!t) return null;
              const e = t.start.parent,
                n = t.end.parent,
                i = e.getPath(),
                o = n.getPath();
              return i.length > o.length ? e : n;
            }(o);
            if (ta(n, "atTarget", a), !s) {
              if (ea(i, "$text", n, ...e)) return n.return;
              ta(n, "bubbling", a);
            }
            for (; a;) {
              if (a.is("rootElement")) {
                if (ea(i, "$root", n, ...e)) return n.return;
              } else if (a.is("element") && ea(i, a.name, n, ...e)) return n.return;
              if (ea(i, a, n, ...e)) return n.return;
              a = a.parent, ta(n, "bubbling", a);
            }
            return ta(n, "bubbling", this), ea(i, "$document", n, ...e), n.return;
          } catch (t) {
            b.rethrowUnexpectedError(t, this);
          }
        }
        _addEventListener(t, e, n) {
          const i = vo(n.context || "$document"),
            o = ia(this);
          for (const r of i) {
            let i = o.get(r);
            i || (i = new (B())(), o.set(r, i)), this.listenTo(i, t, e, n);
          }
        }
        _removeEventListener(t, e) {
          const n = ia(this);
          for (const i of n.values()) this.stopListening(i, t, e);
        }
      };
    }
    {
      const t = Xs(Object);
      ["fire", "_addEventListener", "_removeEventListener"].forEach(e => {
        Xs[e] = t.prototype[e];
      });
    }
    function ta(t, e, n) {
      t instanceof Zs && (t._eventPhase = e, t._currentTarget = n);
    }
    function ea(t, e, n) {
      const o = "string" == typeof e ? t.get(e) : na(t, e);
      for (var _len21 = arguments.length, i = new Array(_len21 > 3 ? _len21 - 3 : 0), _key21 = 3; _key21 < _len21; _key21++) {
        i[_key21 - 3] = arguments[_key21];
      }
      return !!o && (o.fire(n, ...i), n.stop.called);
    }
    function na(t, e) {
      for (const [n, i] of t) if ("function" == typeof n && n(e)) return i;
      return null;
    }
    function ia(t) {
      return t[Js] || (t[Js] = new Map()), t[Js];
    }
    class oa extends Xs(q()) {
      constructor(t) {
        super(), this._postFixers = new Set(), this.selection = new Qs(), this.roots = new Wo({
          idProperty: "rootName"
        }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1);
      }
      getRoot() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.roots.get(t);
      }
      registerPostFixer(t) {
        this._postFixers.add(t);
      }
      destroy() {
        this.roots.forEach(t => t.destroy()), this.stopListening();
      }
      _callPostFixers(t) {
        let e = !1;
        do {
          for (const n of this._postFixers) if (e = n(t), e) break;
        } while (e);
      }
    }
    class ra extends Rs {
      constructor(t, e, n, i) {
        super(t, e, n, i), this._priority = 10, this._id = null, this._clonesGroup = null, this.getFillerOffset = aa;
      }
      get priority() {
        return this._priority;
      }
      get id() {
        return this._id;
      }
      getElementsWithSameId() {
        if (null === this.id) throw new b("attribute-element-get-elements-with-same-id-no-id", this);
        return new Set(this._clonesGroup);
      }
      isSimilar(t) {
        return null !== this.id || null !== t.id ? this.id === t.id : super.isSimilar(t) && this.priority == t.priority;
      }
      _clone() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const e = super._clone(t);
        return e._priority = this._priority, e._id = this._id, e;
      }
    }
    ra.DEFAULT_PRIORITY = 10;
    const sa = ra;
    function aa() {
      if (la(this)) return null;
      let t = this.parent;
      for (; t && t.is("attributeElement");) {
        if (la(t) > 1) return null;
        t = t.parent;
      }
      return !t || la(t) > 1 ? null : this.childCount;
    }
    function la(t) {
      return Array.from(t.getChildren()).filter(t => !t.is("uiElement")).length;
    }
    ra.prototype.is = function (t, e) {
      return e ? e === this.name && ("attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t) : "attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class ca extends Rs {
      constructor(t, e, n, i) {
        super(t, e, n, i), this.getFillerOffset = da;
      }
      _insertChild(t, e) {
        if (e && (e instanceof es || Array.from(e).length > 0)) throw new b("view-emptyelement-cannot-add", [this, e]);
        return 0;
      }
    }
    function da() {
      return null;
    }
    ca.prototype.is = function (t, e) {
      return e ? e === this.name && ("emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t) : "emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class ua extends Rs {
      constructor(t, e, n, i) {
        super(t, e, n, i), this.getFillerOffset = ma;
      }
      _insertChild(t, e) {
        if (e && (e instanceof es || Array.from(e).length > 0)) throw new b("view-uielement-cannot-add", [this, e]);
        return 0;
      }
      render(t, e) {
        return this.toDomElement(t);
      }
      toDomElement(t) {
        const e = t.createElement(this.name);
        for (const t of this.getAttributeKeys()) e.setAttribute(t, this.getAttribute(t));
        return e;
      }
    }
    function ha(t) {
      t.document.on("arrowKey", (e, n) => function (t, e, n) {
        if (e.keyCode == po.arrowright) {
          const t = e.domTarget.ownerDocument.defaultView.getSelection(),
            i = 1 == t.rangeCount && t.getRangeAt(0).collapsed;
          if (i || e.shiftKey) {
            const e = t.focusNode,
              o = t.focusOffset,
              r = n.domPositionToView(e, o);
            if (null === r) return;
            let s = !1;
            const a = r.getLastMatchingPosition(t => (t.item.is("uiElement") && (s = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"))));
            if (s) {
              const e = n.viewPositionToDom(a);
              i ? t.collapse(e.parent, e.offset) : t.extend(e.parent, e.offset);
            }
          }
        }
      }(0, n, t.domConverter), {
        priority: "low"
      });
    }
    function ma() {
      return null;
    }
    ua.prototype.is = function (t, e) {
      return e ? e === this.name && ("uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t) : "uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class ga extends Rs {
      constructor(t, e, n, i) {
        super(t, e, n, i), this.getFillerOffset = pa;
      }
      _insertChild(t, e) {
        if (e && (e instanceof es || Array.from(e).length > 0)) throw new b("view-rawelement-cannot-add", [this, e]);
        return 0;
      }
      render(t, e) {}
    }
    function pa() {
      return null;
    }
    ga.prototype.is = function (t, e) {
      return e ? e === this.name && ("rawElement" === t || "view:rawElement" === t || "element" === t || "view:element" === t) : "rawElement" === t || "view:rawElement" === t || t === this.name || t === "view:" + this.name || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
    };
    class fa extends B(Xr) {
      constructor(t, e) {
        super(), this._children = [], this._customProperties = new Map(), this.document = t, e && this._insertChild(0, e);
      }
      [Symbol.iterator]() {
        return this._children[Symbol.iterator]();
      }
      get childCount() {
        return this._children.length;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get name() {}
      get getFillerOffset() {}
      getCustomProperty(t) {
        return this._customProperties.get(t);
      }
      *getCustomProperties() {
        yield* this._customProperties.entries();
      }
      _appendChild(t) {
        return this._insertChild(this.childCount, t);
      }
      getChild(t) {
        return this._children[t];
      }
      getChildIndex(t) {
        return this._children.indexOf(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      _insertChild(t, e) {
        this._fireChange("children", this);
        let n = 0;
        const i = function (t, e) {
          if ("string" == typeof e) return [new ns(t, e)];
          X(e) || (e = [e]);
          return Array.from(e).map(e => "string" == typeof e ? new ns(t, e) : e instanceof is ? new ns(t, e.data) : e);
        }(this.document, e);
        for (const e of i) null !== e.parent && e._remove(), e.parent = this, this._children.splice(t, 0, e), t++, n++;
        return n;
      }
      _removeChildren(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        this._fireChange("children", this);
        for (let n = t; n < t + e; n++) this._children[n].parent = null;
        return this._children.splice(t, e);
      }
      _fireChange(t, e) {
        this.fire("change:" + t, e);
      }
      _setCustomProperty(t, e) {
        this._customProperties.set(t, e);
      }
      _removeCustomProperty(t) {
        return this._customProperties.delete(t);
      }
    }
    fa.prototype.is = function (t) {
      return "documentFragment" === t || "view:documentFragment" === t;
    };
    class ka {
      constructor(t) {
        this._cloneGroups = new Map(), this._slotFactory = null, this.document = t;
      }
      setSelection() {
        this.document.selection._setTo(...arguments);
      }
      setSelectionFocus(t, e) {
        this.document.selection._setFocus(t, e);
      }
      createDocumentFragment(t) {
        return new fa(this.document, t);
      }
      createText(t) {
        return new ns(this.document, t);
      }
      createAttributeElement(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new sa(this.document, t, e);
        return "number" == typeof n.priority && (i._priority = n.priority), n.id && (i._id = n.id), n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createContainerElement(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        let o = null;
        yt(n) ? i = n : o = n;
        const r = new Os(this.document, t, e, o);
        return i.renderUnsafeAttributes && r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), r;
      }
      createEditableElement(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new Hs(this.document, t, e);
        return n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createEmptyElement(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = new ca(this.document, t, e);
        return n.renderUnsafeAttributes && i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes), i;
      }
      createUIElement(t, e, n) {
        const i = new ua(this.document, t, e);
        return n && (i.render = n), i;
      }
      createRawElement(t, e, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = new ga(this.document, t, e);
        return n && (o.render = n), i.renderUnsafeAttributes && o._unsafeAttributesToRender.push(...i.renderUnsafeAttributes), o;
      }
      setAttribute(t, e, n) {
        n._setAttribute(t, e);
      }
      removeAttribute(t, e) {
        e._removeAttribute(t);
      }
      addClass(t, e) {
        e._addClass(t);
      }
      removeClass(t, e) {
        e._removeClass(t);
      }
      setStyle(t, e, n) {
        yt(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
      }
      removeStyle(t, e) {
        e._removeStyle(t);
      }
      setCustomProperty(t, e, n) {
        n._setCustomProperty(t, e);
      }
      removeCustomProperty(t, e) {
        return e._removeCustomProperty(t);
      }
      breakAttributes(t) {
        return t instanceof Ws ? this._breakAttributes(t) : this._breakAttributesRange(t);
      }
      breakContainer(t) {
        const e = t.parent;
        if (!e.is("containerElement")) throw new b("view-writer-break-non-container-element", this.document);
        if (!e.parent) throw new b("view-writer-break-root", this.document);
        if (t.isAtStart) return Ws._createBefore(e);
        if (!t.isAtEnd) {
          const n = e._clone(!1);
          this.insert(Ws._createAfter(e), n);
          const i = new $s(t, Ws._createAt(e, "end")),
            o = new Ws(n, 0);
          this.move(i, o);
        }
        return Ws._createAfter(e);
      }
      mergeAttributes(t) {
        const e = t.offset,
          n = t.parent;
        if (n.is("$text")) return t;
        if (n.is("attributeElement") && 0 === n.childCount) {
          const t = n.parent,
            e = n.index;
          return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Ws(t, e));
        }
        const i = n.getChild(e - 1),
          o = n.getChild(e);
        if (!i || !o) return t;
        if (i.is("$text") && o.is("$text")) return _a(i, o);
        if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
          const t = i.childCount;
          return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Ws(i, t));
        }
        return t;
      }
      mergeContainers(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new b("view-writer-merge-containers-invalid-position", this.document);
        const i = e.getChild(e.childCount - 1),
          o = i instanceof ns ? Ws._createAt(i, "end") : Ws._createAt(e, "end");
        return this.move($s._createIn(n), Ws._createAt(e, "end")), this.remove($s._createOn(n)), o;
      }
      insert(t, e) {
        ya(e = X(e) ? [...e] : [e], this.document);
        const n = e.reduce((t, e) => {
          const n = t[t.length - 1],
            i = !e.is("uiElement");
          return n && n.breakAttributes == i ? n.nodes.push(e) : t.push({
            breakAttributes: i,
            nodes: [e]
          }), t;
        }, []);
        let i = null,
          o = t;
        for (const {
          nodes: t,
          breakAttributes: e
        } of n) {
          const n = this._insertNodes(o, t, e);
          i || (i = n.start), o = n.end;
        }
        return i ? new $s(i, o) : new $s(t);
      }
      remove(t) {
        const e = t instanceof $s ? t : $s._createOn(t);
        if (Ea(e, this.document), e.isCollapsed) return new fa(this.document);
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(e, !0),
          o = n.parent,
          r = i.offset - n.offset,
          s = o._removeChildren(n.offset, r);
        for (const t of s) this._removeFromClonedElementsGroup(t);
        const a = this.mergeAttributes(n);
        return e.start = a, e.end = a.clone(), new fa(this.document, s);
      }
      clear(t, e) {
        Ea(t, this.document);
        const n = t.getWalker({
          direction: "backward",
          ignoreElementEnd: !0
        });
        for (const i of n) {
          const n = i.item;
          let o;
          if (n.is("element") && e.isSimilar(n)) o = $s._createOn(n);else if (!i.nextPosition.isAfter(t.start) && n.is("$textProxy")) {
            const t = n.getAncestors().find(t => t.is("element") && e.isSimilar(t));
            t && (o = $s._createIn(t));
          }
          o && (o.end.isAfter(t.end) && (o.end = t.end), o.start.isBefore(t.start) && (o.start = t.start), this.remove(o));
        }
      }
      move(t, e) {
        let n;
        if (e.isAfter(t.end)) {
          const i = (e = this._breakAttributes(e, !0)).parent,
            o = i.childCount;
          t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += i.childCount - o;
        } else n = this.remove(t);
        return this.insert(e, n);
      }
      wrap(t, e) {
        if (!(e instanceof sa)) throw new b("view-writer-wrap-invalid-attribute", this.document);
        if (Ea(t, this.document), t.isCollapsed) {
          let i = t.start;
          i.parent.is("element") && (n = i.parent, !Array.from(n.getChildren()).some(t => !t.is("uiElement"))) && (i = i.getLastMatchingPosition(t => t.item.is("uiElement"))), i = this._wrapPosition(i, e);
          const o = this.document.selection;
          return o.isCollapsed && o.getFirstPosition().isEqual(t.start) && this.setSelection(i), new $s(i);
        }
        return this._wrapRange(t, e);
        var n;
      }
      unwrap(t, e) {
        if (!(e instanceof sa)) throw new b("view-writer-unwrap-invalid-attribute", this.document);
        if (Ea(t, this.document), t.isCollapsed) return t;
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(t, !0),
          o = n.parent,
          r = this._unwrapChildren(o, n.offset, i.offset, e),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new $s(s, a);
      }
      rename(t, e) {
        const n = new Os(this.document, t, e.getAttributes());
        return this.insert(Ws._createAfter(e), n), this.move($s._createIn(e), Ws._createAt(n, 0)), this.remove($s._createOn(e)), n;
      }
      clearClonedElementsGroup(t) {
        this._cloneGroups.delete(t);
      }
      createPositionAt(t, e) {
        return Ws._createAt(t, e);
      }
      createPositionAfter(t) {
        return Ws._createAfter(t);
      }
      createPositionBefore(t) {
        return Ws._createBefore(t);
      }
      createRange(t, e) {
        return new $s(t, e);
      }
      createRangeOn(t) {
        return $s._createOn(t);
      }
      createRangeIn(t) {
        return $s._createIn(t);
      }
      createSelection() {
        for (var _len22 = arguments.length, t = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
          t[_key22] = arguments[_key22];
        }
        return new Ys(...t);
      }
      createSlot() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "children";
        if (!this._slotFactory) throw new b("view-writer-invalid-create-slot-context", this.document);
        return this._slotFactory(this, t);
      }
      _registerSlotFactory(t) {
        this._slotFactory = t;
      }
      _clearSlotFactory() {
        this._slotFactory = null;
      }
      _insertNodes(t, e, n) {
        let i, o;
        if (i = n ? ba(t) : t.parent.is("$text") ? t.parent.parent : t.parent, !i) throw new b("view-writer-invalid-position-container", this.document);
        o = n ? this._breakAttributes(t, !0) : t.parent.is("$text") ? Ca(t) : t;
        const r = i._insertChild(o.offset, e);
        for (const t of e) this._addToClonedElementsGroup(t);
        const s = o.getShiftedBy(r),
          a = this.mergeAttributes(o);
        a.isEqual(o) || s.offset--;
        const l = this.mergeAttributes(s);
        return new $s(a, l);
      }
      _wrapChildren(t, e, n, i) {
        let o = e;
        const r = [];
        for (; o < n;) {
          const e = t.getChild(o),
            n = e.is("$text"),
            s = e.is("attributeElement");
          if (s && this._wrapAttributeElement(i, e)) r.push(new Ws(t, o));else if (n || !s || wa(i, e)) {
            const n = i._clone();
            e._remove(), n._appendChild(e), t._insertChild(o, n), this._addToClonedElementsGroup(n), r.push(new Ws(t, o));
          } else this._wrapChildren(e, 0, e.childCount, i);
          o++;
        }
        let s = 0;
        for (const t of r) {
          if (t.offset -= s, t.offset == e) continue;
          this.mergeAttributes(t).isEqual(t) || (s++, n--);
        }
        return $s._createFromParentsAndOffsets(t, e, t, n);
      }
      _unwrapChildren(t, e, n, i) {
        let o = e;
        const r = [];
        for (; o < n;) {
          const e = t.getChild(o);
          if (e.is("attributeElement")) {
            if (e.isSimilar(i)) {
              const i = e.getChildren(),
                s = e.childCount;
              e._remove(), t._insertChild(o, i), this._removeFromClonedElementsGroup(e), r.push(new Ws(t, o), new Ws(t, o + s)), o += s, n += s - 1;
              continue;
            }
            this._unwrapAttributeElement(i, e) ? (r.push(new Ws(t, o), new Ws(t, o + 1)), o++) : (this._unwrapChildren(e, 0, e.childCount, i), o++);
          } else o++;
        }
        let s = 0;
        for (const t of r) {
          if (t.offset -= s, t.offset == e || t.offset == n) continue;
          this.mergeAttributes(t).isEqual(t) || (s++, n--);
        }
        return $s._createFromParentsAndOffsets(t, e, t, n);
      }
      _wrapRange(t, e) {
        const {
            start: n,
            end: i
          } = this._breakAttributesRange(t, !0),
          o = n.parent,
          r = this._wrapChildren(o, n.offset, i.offset, e),
          s = this.mergeAttributes(r.start);
        s.isEqual(r.start) || r.end.offset--;
        const a = this.mergeAttributes(r.end);
        return new $s(s, a);
      }
      _wrapPosition(t, e) {
        if (e.isSimilar(t.parent)) return Aa(t.clone());
        t.parent.is("$text") && (t = Ca(t));
        const n = this.createAttributeElement("_wrapPosition-fake-element");
        n._priority = Number.POSITIVE_INFINITY, n.isSimilar = () => !1, t.parent._insertChild(t.offset, n);
        const i = new $s(t, t.getShiftedBy(1));
        this.wrap(i, e);
        const o = new Ws(n.parent, n.index);
        n._remove();
        const r = o.nodeBefore,
          s = o.nodeAfter;
        return r instanceof ns && s instanceof ns ? _a(r, s) : Aa(o);
      }
      _wrapAttributeElement(t, e) {
        if (!Da(t, e)) return !1;
        if (t.name !== e.name || t.priority !== e.priority) return !1;
        for (const n of t.getAttributeKeys()) if ("class" !== n && "style" !== n && e.hasAttribute(n) && e.getAttribute(n) !== t.getAttribute(n)) return !1;
        for (const n of t.getStyleNames()) if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) return !1;
        for (const n of t.getAttributeKeys()) "class" !== n && "style" !== n && (e.hasAttribute(n) || this.setAttribute(n, t.getAttribute(n), e));
        for (const n of t.getStyleNames()) e.hasStyle(n) || this.setStyle(n, t.getStyle(n), e);
        for (const n of t.getClassNames()) e.hasClass(n) || this.addClass(n, e);
        return !0;
      }
      _unwrapAttributeElement(t, e) {
        if (!Da(t, e)) return !1;
        if (t.name !== e.name || t.priority !== e.priority) return !1;
        for (const n of t.getAttributeKeys()) if ("class" !== n && "style" !== n && (!e.hasAttribute(n) || e.getAttribute(n) !== t.getAttribute(n))) return !1;
        if (!e.hasClass(...t.getClassNames())) return !1;
        for (const n of t.getStyleNames()) if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n)) return !1;
        for (const n of t.getAttributeKeys()) "class" !== n && "style" !== n && this.removeAttribute(n, e);
        return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
      }
      _breakAttributesRange(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = t.start,
          i = t.end;
        if (Ea(t, this.document), t.isCollapsed) {
          const n = this._breakAttributes(t.start, e);
          return new $s(n, n);
        }
        const o = this._breakAttributes(i, e),
          r = o.parent.childCount,
          s = this._breakAttributes(n, e);
        return o.offset += o.parent.childCount - r, new $s(s, o);
      }
      _breakAttributes(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = t.offset,
          i = t.parent;
        if (t.parent.is("emptyElement")) throw new b("view-writer-cannot-break-empty-element", this.document);
        if (t.parent.is("uiElement")) throw new b("view-writer-cannot-break-ui-element", this.document);
        if (t.parent.is("rawElement")) throw new b("view-writer-cannot-break-raw-element", this.document);
        if (!e && i.is("$text") && xa(i.parent)) return t.clone();
        if (xa(i)) return t.clone();
        if (i.is("$text")) return this._breakAttributes(Ca(t), e);
        if (n == i.childCount) {
          const t = new Ws(i.parent, i.index + 1);
          return this._breakAttributes(t, e);
        }
        if (0 === n) {
          const t = new Ws(i.parent, i.index);
          return this._breakAttributes(t, e);
        }
        {
          const t = i.index + 1,
            o = i._clone();
          i.parent._insertChild(t, o), this._addToClonedElementsGroup(o);
          const r = i.childCount - n,
            s = i._removeChildren(n, r);
          o._appendChild(s);
          const a = new Ws(i.parent, t);
          return this._breakAttributes(a, e);
        }
      }
      _addToClonedElementsGroup(t) {
        if (!t.root.is("rootElement")) return;
        if (t.is("element")) for (const e of t.getChildren()) this._addToClonedElementsGroup(e);
        const e = t.id;
        if (!e) return;
        let n = this._cloneGroups.get(e);
        n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
      }
      _removeFromClonedElementsGroup(t) {
        if (t.is("element")) for (const e of t.getChildren()) this._removeFromClonedElementsGroup(e);
        const e = t.id;
        if (!e) return;
        const n = this._cloneGroups.get(e);
        n && n.delete(t);
      }
    }
    function ba(t) {
      let e = t.parent;
      for (; !xa(e);) {
        if (!e) return;
        e = e.parent;
      }
      return e;
    }
    function wa(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }
    function Aa(t) {
      const e = t.nodeBefore;
      if (e && e.is("$text")) return new Ws(e, e.data.length);
      const n = t.nodeAfter;
      return n && n.is("$text") ? new Ws(n, 0) : t;
    }
    function Ca(t) {
      if (t.offset == t.parent.data.length) return new Ws(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new Ws(t.parent.parent, t.parent.index);
      const e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new ns(t.root.document, e)), new Ws(t.parent.parent, t.parent.index + 1);
    }
    function _a(t, e) {
      const n = t.data.length;
      return t._data += e.data, e._remove(), new Ws(t, n);
    }
    const va = [ns, sa, Os, ca, ga, ua];
    function ya(t, e) {
      for (const n of t) {
        if (!va.some(t => n instanceof t)) throw new b("view-writer-insert-invalid-node-type", e);
        n.is("$text") || ya(n.getChildren(), e);
      }
    }
    function xa(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }
    function Ea(t, e) {
      const n = ba(t.start),
        i = ba(t.end);
      if (!n || !i || n !== i) throw new b("view-writer-invalid-range-container", e);
    }
    function Da(t, e) {
      return null === t.id && null === e.id;
    }
    const Ba = t => t.createTextNode(" "),
      Sa = t => {
        const e = t.createElement("span");
        return e.dataset.ckeFiller = "true", e.innerText = " ", e;
      },
      Ta = t => {
        const e = t.createElement("br");
        return e.dataset.ckeFiller = "true", e;
      },
      Ia = "⁠".repeat(7);
    function Ma(t) {
      return "string" == typeof t ? t.substr(0, 7) === Ia : Mi(t) && t.data.substr(0, 7) === Ia;
    }
    function La(t) {
      return 7 == t.data.length && Ma(t);
    }
    function Na(t) {
      const e = "string" == typeof t ? t : t.data;
      return Ma(t) ? e.slice(7) : e;
    }
    function za(t, e) {
      if (e.keyCode == po.arrowleft) {
        const t = e.domTarget.ownerDocument.defaultView.getSelection();
        if (1 == t.rangeCount && t.getRangeAt(0).collapsed) {
          const e = t.getRangeAt(0).startContainer,
            n = t.getRangeAt(0).startOffset;
          Ma(e) && n <= 7 && t.collapse(e, 0);
        }
      }
    }
    var Pa = o(6531),
      Va = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Pa.A, Va);
    Pa.A.locals;
    class Ra extends q() {
      constructor(t, e) {
        super(), this.domDocuments = new Set(), this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this._inlineFiller = null, this._fakeSelectionContainer = null, this.domConverter = t, this.selection = e, this.set("isFocused", !1), this.set("isSelecting", !1), s.isBlink && !s.isAndroid && this.on("change:isSelecting", () => {
          this.isSelecting || this.render();
        }), this.set("isComposing", !1), this.on("change:isComposing", () => {
          this.isComposing || this.render();
        });
      }
      markToSync(t, e) {
        if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
          if (!this.domConverter.mapViewToDom(e)) return;
          if ("attributes" === t) this.markedAttributes.add(e);else {
            if ("children" !== t) {
              throw new b("view-renderer-unknown-type", this);
            }
            this.markedChildren.add(e);
          }
        }
      }
      render() {
        if (this.isComposing && !s.isAndroid) return;
        let t = null;
        const e = !(s.isBlink && !s.isAndroid) || !this.isSelecting;
        for (const t of this.markedChildren) this._updateChildrenMappings(t);
        e ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t = this.domConverter.domPositionToView(this._inlineFiller), t && t.parent.is("$text") && (t = Ws._createBefore(t.parent)));
        for (const t of this.markedAttributes) this._updateAttrs(t);
        for (const e of this.markedChildren) this._updateChildren(e, {
          inlineFillerPosition: t
        });
        for (const e of this.markedTexts) !this.markedChildren.has(e.parent) && this.domConverter.mapViewToDom(e.parent) && this._updateText(e, {
          inlineFillerPosition: t
        });
        if (e) if (t) {
          const e = this.domConverter.viewPositionToDom(t),
            n = e.parent.ownerDocument;
          Ma(e.parent) ? this._inlineFiller = e.parent : this._inlineFiller = Fa(n, e.parent, e.offset);
        } else this._inlineFiller = null;
        this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
      }
      _updateChildrenMappings(t) {
        const e = this.domConverter.mapViewToDom(t);
        if (!e) return;
        const n = Array.from(e.childNodes),
          i = Array.from(this.domConverter.viewChildrenToDom(t, {
            withChildren: !1
          })),
          o = this._diffNodeLists(n, i),
          r = this._findUpdateActions(o, n, i, Oa);
        if (-1 !== r.indexOf("update")) {
          const e = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          for (const o of r) if ("update" === o) {
            const o = e.equal + e.insert,
              r = e.equal + e.delete,
              s = t.getChild(o);
            !s || s.is("uiElement") || s.is("rawElement") || this._updateElementMappings(s, n[r]), to(i[o]), e.equal++;
          } else e[o]++;
        }
      }
      _updateElementMappings(t, e) {
        this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
      }
      _getInlineFillerPosition() {
        const t = this.selection.getFirstPosition();
        return t.parent.is("$text") ? Ws._createBefore(t.parent) : t;
      }
      _isSelectionInInlineFiller() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const t = this.selection.getFirstPosition(),
          e = this.domConverter.viewPositionToDom(t);
        return !!(e && Mi(e.parent) && Ma(e.parent));
      }
      _removeInlineFiller() {
        const t = this._inlineFiller;
        if (!Ma(t)) throw new b("view-renderer-filler-was-lost", this);
        La(t) ? t.remove() : t.data = t.data.substr(7), this._inlineFiller = null;
      }
      _needsInlineFillerAtSelection() {
        if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
        const t = this.selection.getFirstPosition(),
          e = t.parent,
          n = t.offset;
        if (!this.domConverter.mapViewToDom(e.root)) return !1;
        if (!e.is("element")) return !1;
        if (!function (t) {
          if ("false" == t.getAttribute("contenteditable")) return !1;
          const e = t.findAncestor(t => t.hasAttribute("contenteditable"));
          return !e || "true" == e.getAttribute("contenteditable");
        }(e)) return !1;
        const i = t.nodeBefore,
          o = t.nodeAfter;
        return !(i instanceof ns || o instanceof ns) && !!(n !== e.getFillerOffset() || i && i.is("element", "br")) && (!s.isAndroid || !i && !o);
      }
      _updateText(t, e) {
        const n = this.domConverter.findCorrespondingDomText(t);
        let i = this.domConverter.viewToDom(t).data;
        const o = e.inlineFillerPosition;
        o && o.parent == t.parent && o.offset == t.index && (i = Ia + i), Ua(n, i);
      }
      _updateAttrs(t) {
        const e = this.domConverter.mapViewToDom(t);
        if (!e) return;
        const n = Array.from(e.attributes).map(t => t.name),
          i = t.getAttributeKeys();
        for (const n of i) this.domConverter.setDomElementAttribute(e, n, t.getAttribute(n), t);
        for (const i of n) t.hasAttribute(i) || this.domConverter.removeDomElementAttribute(e, i);
      }
      _updateChildren(t, e) {
        const n = this.domConverter.mapViewToDom(t);
        if (!n) return;
        if (s.isAndroid) {
          let t = null;
          for (const e of Array.from(n.childNodes)) {
            if (t && Mi(t) && Mi(e)) {
              n.normalize();
              break;
            }
            t = e;
          }
        }
        const i = e.inlineFillerPosition,
          o = n.childNodes,
          r = Array.from(this.domConverter.viewChildrenToDom(t, {
            bind: !0
          }));
        i && i.parent === t && Fa(n.ownerDocument, r, i.offset);
        const a = this._diffNodeLists(o, r),
          l = this._findUpdateActions(a, o, r, ja);
        let c = 0;
        const d = new Set();
        for (const t of l) "delete" === t ? (d.add(o[c]), to(o[c])) : "equal" !== t && "update" !== t || c++;
        c = 0;
        for (const t of l) "insert" === t ? ($i(n, c, r[c]), c++) : "update" === t ? (Ua(o[c], r[c].data), c++) : "equal" === t && (this._markDescendantTextToSync(this.domConverter.domToView(r[c])), c++);
        for (const t of d) t.parentNode || this.domConverter.unbindDomElement(t);
      }
      _diffNodeLists(t, e) {
        return t = function (t, e) {
          const n = Array.from(t);
          if (0 == n.length || !e) return n;
          const i = n[n.length - 1];
          i == e && n.pop();
          return n;
        }(t, this._fakeSelectionContainer), u(t, e, Ha.bind(null, this.domConverter));
      }
      _findUpdateActions(t, e, n, i) {
        if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
        let o = [],
          r = [],
          s = [];
        const a = {
          equal: 0,
          insert: 0,
          delete: 0
        };
        for (const l of t) "insert" === l ? s.push(n[a.equal + a.insert]) : "delete" === l ? r.push(e[a.equal + a.delete]) : (o = o.concat(u(r, s, i).map(t => "equal" === t ? "update" : t)), o.push("equal"), r = [], s = []), a[l]++;
        return o.concat(u(r, s, i).map(t => "equal" === t ? "update" : t));
      }
      _markDescendantTextToSync(t) {
        if (t) if (t.is("$text")) this.markedTexts.add(t);else if (t.is("element")) for (const e of t.getChildren()) this._markDescendantTextToSync(e);
      }
      _updateSelection() {
        if (s.isBlink && !s.isAndroid && this.isSelecting && !this.markedChildren.size) return;
        if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
        const t = this.domConverter.mapViewToDom(this.selection.editableElement);
        this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(t)) : this.isComposing && s.isAndroid || this._updateDomSelection(t));
      }
      _updateFakeSelection(t) {
        const e = t.ownerDocument;
        this._fakeSelectionContainer || (this._fakeSelectionContainer = function (t) {
          const e = t.createElement("div");
          return e.className = "ck-fake-selection-container", Object.assign(e.style, {
            position: "fixed",
            top: 0,
            left: "-9999px",
            width: "42px"
          }), e.textContent = " ", e;
        }(e));
        const n = this._fakeSelectionContainer;
        if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(t)) return;
        n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
        const i = e.getSelection(),
          o = e.createRange();
        i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o);
      }
      _updateDomSelection(t) {
        const e = t.ownerDocument.defaultView.getSelection();
        if (!this._domSelectionNeedsUpdate(e)) return;
        const n = this.domConverter.viewPositionToDom(this.selection.anchor),
          i = this.domConverter.viewPositionToDom(this.selection.focus);
        e.setBaseAndExtent(n.parent, n.offset, i.parent, i.offset), s.isGecko && function (t, e) {
          let n = t.parent,
            i = t.offset;
          Mi(n) && La(n) && (i = Wi(n) + 1, n = n.parentNode);
          if (n.nodeType != Node.ELEMENT_NODE || i != n.childNodes.length - 1) return;
          const o = n.childNodes[i];
          o && "BR" == o.tagName && e.addRange(e.getRangeAt(0));
        }(i, e);
      }
      _domSelectionNeedsUpdate(t) {
        if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
        const e = t && this.domConverter.domSelectionToView(t);
        return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
      }
      _fakeSelectionNeedsUpdate(t) {
        const e = this._fakeSelectionContainer,
          n = t.ownerDocument.getSelection();
        return !e || e.parentElement !== t || n.anchorNode !== e && !e.contains(n.anchorNode) || e.textContent !== this.selection.fakeSelectionLabel;
      }
      _removeDomSelection() {
        for (const t of this.domDocuments) {
          const e = t.getSelection();
          if (e.rangeCount) {
            const n = t.activeElement,
              i = this.domConverter.mapDomToView(n);
            n && i && e.removeAllRanges();
          }
        }
      }
      _removeFakeSelection() {
        const t = this._fakeSelectionContainer;
        t && t.remove();
      }
      _updateFocus() {
        if (this.isFocused) {
          const t = this.selection.editableElement;
          t && this.domConverter.focus(t);
        }
      }
    }
    function Fa(t, e, n) {
      const i = e instanceof Array ? e : e.childNodes,
        o = i[n];
      if (Mi(o)) return o.data = Ia + o.data, o;
      {
        const o = t.createTextNode(Ia);
        return Array.isArray(e) ? i.splice(n, 0, o) : $i(e, n, o), o;
      }
    }
    function Oa(t, e) {
      return xi(t) && xi(e) && !Mi(t) && !Mi(e) && !Ki(t) && !Ki(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }
    function ja(t, e) {
      return xi(t) && xi(e) && Mi(t) && Mi(e);
    }
    function Ha(t, e, n) {
      return e === n || (Mi(e) && Mi(n) ? e.data === n.data : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)));
    }
    function Ua(t, e) {
      const n = t.data;
      if (n == e) return;
      const i = l(n, e);
      for (const e of i) "insert" === e.type ? t.insertData(e.index, e.values.join("")) : t.deleteData(e.index, e.howMany);
    }
    const qa = Ta(e.document),
      Ga = Ba(e.document),
      Wa = Sa(e.document),
      $a = "data-ck-unsafe-attribute-",
      Ka = "data-ck-unsafe-element";
    class Ya {
      constructor(t) {
        let {
          blockFillerMode: n,
          renderingMode: i = "editing"
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new os(), this._inlineObjectElementMatcher = new os(), this._elementsWithTemporaryCustomProperties = new Set(), this.document = t, this.renderingMode = i, this.blockFillerMode = n || ("editing" === i ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = "editing" === this.renderingMode ? e.document : e.document.implementation.createHTMLDocument("");
      }
      bindFakeSelection(t, e) {
        this._fakeSelectionMapping.set(t, new Ys(e));
      }
      fakeSelectionToView(t) {
        return this._fakeSelectionMapping.get(t);
      }
      bindElements(t, e) {
        this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
      }
      unbindDomElement(t) {
        const e = this._domToViewMapping.get(t);
        if (e) {
          this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);
          for (const e of Array.from(t.children)) this.unbindDomElement(e);
        }
      }
      bindDocumentFragments(t, e) {
        this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
      }
      shouldRenderAttribute(t, e, n) {
        return "data" === this.renderingMode || !(t = t.toLowerCase()).startsWith("on") && ("srcdoc" !== t || !e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === n && ("src" === t || "srcset" === t) || "source" === n && "srcset" === t || !e.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
      }
      setContentOf(t, e) {
        if ("data" === this.renderingMode) return void (t.innerHTML = e);
        const n = new DOMParser().parseFromString(e, "text/html"),
          i = n.createDocumentFragment(),
          o = n.body.childNodes;
        for (; o.length > 0;) i.appendChild(o[0]);
        const r = n.createTreeWalker(i, NodeFilter.SHOW_ELEMENT),
          s = [];
        let a;
        for (; a = r.nextNode();) s.push(a);
        for (const t of s) {
          for (const e of t.getAttributeNames()) this.setDomElementAttribute(t, e, t.getAttribute(e));
          const e = t.tagName.toLowerCase();
          this._shouldRenameElement(e) && (Xa(e), t.replaceWith(this._createReplacementDomElement(e, t)));
        }
        for (; t.firstChild;) t.firstChild.remove();
        t.append(i);
      }
      viewToDom(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (t.is("$text")) {
          const e = this._processDataFromViewText(t);
          return this._domDocument.createTextNode(e);
        }
        {
          const n = t;
          if (this.mapViewToDom(n)) {
            if (!n.getCustomProperty("editingPipeline:doNotReuseOnce")) return this.mapViewToDom(n);
            this._elementsWithTemporaryCustomProperties.add(n);
          }
          let i;
          if (n.is("documentFragment")) i = this._domDocument.createDocumentFragment(), e.bind && this.bindDocumentFragments(i, n);else {
            if (n.is("uiElement")) return i = "$comment" === n.name ? this._domDocument.createComment(n.getCustomProperty("$rawContent")) : n.render(this._domDocument, this), e.bind && this.bindElements(i, n), i;
            this._shouldRenameElement(n.name) ? (Xa(n.name), i = this._createReplacementDomElement(n.name)) : i = n.hasAttribute("xmlns") ? this._domDocument.createElementNS(n.getAttribute("xmlns"), n.name) : this._domDocument.createElement(n.name), n.is("rawElement") && n.render(i, this), e.bind && this.bindElements(i, n);
            for (const t of n.getAttributeKeys()) this.setDomElementAttribute(i, t, n.getAttribute(t), n);
          }
          if (!1 !== e.withChildren) for (const t of this.viewChildrenToDom(n, e)) i instanceof HTMLTemplateElement ? i.content.appendChild(t) : i.appendChild(t);
          return i;
        }
      }
      setDomElementAttribute(t, e, n, i) {
        const o = this.shouldRenderAttribute(e, n, t.tagName.toLowerCase()) || i && i.shouldRenderUnsafeAttribute(e);
        o || w("domconverter-unsafe-attribute-detected", {
          domElement: t,
          key: e,
          value: n
        }), Yi(e) ? (t.hasAttribute(e) && !o ? t.removeAttribute(e) : t.hasAttribute($a + e) && o && t.removeAttribute($a + e), t.setAttribute(o ? e : $a + e, n)) : w("domconverter-invalid-attribute-detected", {
          domElement: t,
          key: e,
          value: n
        });
      }
      removeDomElementAttribute(t, e) {
        e != Ka && (t.removeAttribute(e), t.removeAttribute($a + e));
      }
      viewChildrenToDom(t) {
        var _this4 = this;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function* () {
          const n = t.getFillerOffset && t.getFillerOffset();
          let i = 0;
          for (const o of t.getChildren()) {
            n === i && (yield _this4._getBlockFiller());
            const t = o.is("element") && !!o.getCustomProperty("dataPipeline:transparentRendering") && !$o(o.getAttributes());
            t && "data" == _this4.renderingMode ? yield* _this4.viewChildrenToDom(o, e) : (t && w("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
              viewElement: o
            }), yield _this4.viewToDom(o, e)), i++;
          }
          n === i && (yield _this4._getBlockFiller());
        }();
      }
      viewRangeToDom(t) {
        const e = this.viewPositionToDom(t.start),
          n = this.viewPositionToDom(t.end),
          i = this._domDocument.createRange();
        return i.setStart(e.parent, e.offset), i.setEnd(n.parent, n.offset), i;
      }
      viewPositionToDom(t) {
        const e = t.parent;
        if (e.is("$text")) {
          const n = this.findCorrespondingDomText(e);
          if (!n) return null;
          let i = t.offset;
          return Ma(n) && (i += 7), {
            parent: n,
            offset: i
          };
        }
        {
          let n, i, o;
          if (0 === t.offset) {
            if (n = this.mapViewToDom(e), !n) return null;
            o = n.childNodes[0];
          } else {
            const e = t.nodeBefore;
            if (i = e.is("$text") ? this.findCorrespondingDomText(e) : this.mapViewToDom(e), !i) return null;
            n = i.parentNode, o = i.nextSibling;
          }
          if (Mi(o) && Ma(o)) return {
            parent: o,
            offset: 7
          };
          return {
            parent: n,
            offset: i ? Wi(i) + 1 : 0
          };
        }
      }
      domToView(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = [],
          i = this._domToView(t, e, n),
          o = i.next().value;
        return o ? (i.next(), this._processDomInlineNodes(null, n, e), o.is("$text") && 0 == o.data.length ? null : o) : null;
      }
      domChildrenToView(t) {
        var _this5 = this;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return function* () {
          let i = [];
          i = t instanceof HTMLTemplateElement ? [...t.content.childNodes] : [...t.childNodes];
          for (let o = 0; o < i.length; o++) {
            const r = i[o],
              s = _this5._domToView(r, e, n),
              a = s.next().value;
            null !== a && (_this5._isBlockViewElement(a) && _this5._processDomInlineNodes(t, n, e), yield a, s.next());
          }
          _this5._processDomInlineNodes(t, n, e);
        }();
      }
      domSelectionToView(t) {
        if (function (t) {
          if (!s.isGecko) return !1;
          if (!t.rangeCount) return !1;
          const e = t.getRangeAt(0).startContainer;
          try {
            Object.prototype.toString.call(e);
          } catch (t) {
            return !0;
          }
          return !1;
        }(t)) return new Ys([]);
        if (1 === t.rangeCount) {
          let e = t.getRangeAt(0).startContainer;
          Mi(e) && (e = e.parentNode);
          const n = this.fakeSelectionToView(e);
          if (n) return n;
        }
        const e = this.isDomSelectionBackward(t),
          n = [];
        for (let e = 0; e < t.rangeCount; e++) {
          const i = t.getRangeAt(e),
            o = this.domRangeToView(i);
          o && n.push(o);
        }
        return new Ys(n, {
          backward: e
        });
      }
      domRangeToView(t) {
        const e = this.domPositionToView(t.startContainer, t.startOffset),
          n = this.domPositionToView(t.endContainer, t.endOffset);
        return e && n ? new $s(e, n) : null;
      }
      domPositionToView(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (this.isBlockFiller(t)) return this.domPositionToView(t.parentNode, Wi(t));
        const n = this.mapDomToView(t);
        if (n && (n.is("uiElement") || n.is("rawElement"))) return Ws._createBefore(n);
        if (Mi(t)) {
          if (La(t)) return this.domPositionToView(t.parentNode, Wi(t));
          const n = this.findCorrespondingViewText(t);
          let i = e;
          return n ? (Ma(t) && (i -= 7, i = i < 0 ? 0 : i), new Ws(n, i)) : null;
        }
        if (0 === e) {
          const e = this.mapDomToView(t);
          if (e) return new Ws(e, 0);
        } else {
          const n = t.childNodes[e - 1];
          if (Mi(n) && La(n) || n && this.isBlockFiller(n)) return this.domPositionToView(n.parentNode, Wi(n));
          const i = Mi(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
          if (i && i.parent) return new Ws(i.parent, i.index + 1);
        }
        return null;
      }
      mapDomToView(t) {
        return this.getHostViewElement(t) || this._domToViewMapping.get(t);
      }
      findCorrespondingViewText(t) {
        if (La(t)) return null;
        const e = this.getHostViewElement(t);
        if (e) return e;
        const n = t.previousSibling;
        if (n) {
          if (!this.isElement(n)) return null;
          const t = this.mapDomToView(n);
          if (t) {
            const e = t.nextSibling;
            return e instanceof ns ? e : null;
          }
        } else {
          const e = this.mapDomToView(t.parentNode);
          if (e) {
            const t = e.getChild(0);
            return t instanceof ns ? t : null;
          }
        }
        return null;
      }
      mapViewToDom(t) {
        return this._viewToDomMapping.get(t);
      }
      findCorrespondingDomText(t) {
        const e = t.previousSibling;
        return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
      }
      focus(t) {
        const n = this.mapViewToDom(t);
        if (n && n.ownerDocument.activeElement !== n) {
          const {
              scrollX: t,
              scrollY: i
            } = e.window,
            o = [];
          Za(n, t => {
            const {
              scrollLeft: e,
              scrollTop: n
            } = t;
            o.push([e, n]);
          }), n.focus(), Za(n, t => {
            const [e, n] = o.shift();
            t.scrollLeft = e, t.scrollTop = n;
          }), e.window.scrollTo(t, i);
        }
      }
      _clearDomSelection() {
        const t = this.mapViewToDom(this.document.selection.editableElement);
        if (!t) return;
        const e = t.ownerDocument.defaultView.getSelection(),
          n = this.domSelectionToView(e);
        n && n.rangeCount > 0 && e.removeAllRanges();
      }
      isElement(t) {
        return t && t.nodeType == Node.ELEMENT_NODE;
      }
      isDocumentFragment(t) {
        return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
      }
      isBlockFiller(t) {
        return "br" == this.blockFillerMode ? t.isEqualNode(qa) : !("BR" !== t.tagName || !Ja(t, this.blockElements) || 1 !== t.parentNode.childNodes.length) || t.isEqualNode(Wa) || function (t, e) {
          const n = t.isEqualNode(Ga);
          return n && Ja(t, e) && 1 === t.parentNode.childNodes.length;
        }(t, this.blockElements);
      }
      isDomSelectionBackward(t) {
        if (t.isCollapsed) return !1;
        const e = this._domDocument.createRange();
        try {
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
        } catch (t) {
          return !1;
        }
        const n = e.collapsed;
        return e.detach(), n;
      }
      getHostViewElement(t) {
        const e = function (t) {
          const e = [];
          let n = t;
          for (; n && n.nodeType != Node.DOCUMENT_NODE;) e.unshift(n), n = n.parentNode;
          return e;
        }(t);
        for (e.pop(); e.length;) {
          const t = e.pop(),
            n = this._domToViewMapping.get(t);
          if (n && (n.is("uiElement") || n.is("rawElement"))) return n;
        }
        return null;
      }
      isDomSelectionCorrect(t) {
        return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
      }
      registerRawContentMatcher(t) {
        this._rawContentElementMatcher.add(t);
      }
      registerInlineObjectMatcher(t) {
        this._inlineObjectElementMatcher.add(t);
      }
      _clearTemporaryCustomProperties() {
        for (const t of this._elementsWithTemporaryCustomProperties) t._removeCustomProperty("editingPipeline:doNotReuseOnce");
        this._elementsWithTemporaryCustomProperties.clear();
      }
      _getBlockFiller() {
        switch (this.blockFillerMode) {
          case "nbsp":
            return Ba(this._domDocument);
          case "markedNbsp":
            return Sa(this._domDocument);
          case "br":
            return Ta(this._domDocument);
        }
      }
      _isDomSelectionPositionCorrect(t, e) {
        if (Mi(t) && Ma(t) && e < 7) return !1;
        if (this.isElement(t) && Ma(t.childNodes[e])) return !1;
        const n = this.mapDomToView(t);
        return !n || !n.is("uiElement") && !n.is("rawElement");
      }
      *_domToView(t, e, n) {
        if (this.isBlockFiller(t)) return null;
        const i = this.getHostViewElement(t);
        if (i) return i;
        if (Ki(t) && e.skipComments) return null;
        if (Mi(t)) {
          if (La(t)) return null;
          {
            const e = t.data;
            if ("" === e) return null;
            const i = new ns(this.document, e);
            return n.push(i), i;
          }
        }
        {
          let i = this.mapDomToView(t);
          if (i) return this._isInlineObjectElement(i) && n.push(i), i;
          if (this.isDocumentFragment(t)) i = new fa(this.document), e.bind && this.bindDocumentFragments(t, i);else {
            i = this._createViewElement(t, e), e.bind && this.bindElements(t, i);
            const o = t.attributes;
            if (o) for (let t = o.length, e = 0; e < t; e++) i._setAttribute(o[e].name, o[e].value);
            if (this._isViewElementWithRawContent(i, e)) return i._setCustomProperty("$rawContent", t.innerHTML), this._isBlockViewElement(i) || n.push(i), i;
            if (Ki(t)) return i._setCustomProperty("$rawContent", t.data), i;
          }
          yield i;
          const o = [];
          if (!1 !== e.withChildren) for (const n of this.domChildrenToView(t, e, o)) i._appendChild(n);
          if (this._isInlineObjectElement(i)) n.push(i);else for (const t of o) n.push(t);
        }
      }
      _processDomInlineNodes(t, e, n) {
        if (!e.length) return;
        if (t && !this.isDocumentFragment(t) && !this._isBlockDomElement(t)) return;
        let i = !1;
        for (let t = 0; t < e.length; t++) {
          const o = e[t];
          if (!o.is("$text")) {
            i = !1;
            continue;
          }
          let r,
            s = !1;
          if (Qa(o, this.preElements)) r = Na(o.data);else {
            r = o.data.replace(/[ \n\t\r]{1,}/g, " "), s = /[^\S\u00A0]/.test(r.charAt(r.length - 1));
            const a = t > 0 ? e[t - 1] : null,
              l = t + 1 < e.length ? e[t + 1] : null,
              c = !a || a.is("element") && "br" == a.name || i,
              d = !l && !Ma(o.data);
            !1 !== n.withChildren && (c && (r = r.replace(/^ /, "")), d && (r = r.replace(/ $/, ""))), r = Na(r), r = r.replace(/ \u00A0/g, "  ");
            const u = l && l.is("element") && "br" != l.name,
              h = l && l.is("$text") && " " == l.data.charAt(0);
            (/[ \u00A0]\u00A0$/.test(r) || !l || u || h) && (r = r.replace(/\u00A0$/, " ")), (c || a && a.is("element") && "br" != a.name) && (r = r.replace(/^\u00A0/, " "));
          }
          0 == r.length && o.parent ? (o._remove(), e.splice(t, 1), t--) : (o._data = r, i = s);
        }
        e.length = 0;
      }
      _processDataFromViewText(t) {
        let e = t.data;
        if (t.getAncestors().some(t => this.preElements.includes(t.name))) return e;
        if (" " == e.charAt(0)) {
          const n = this._getTouchingInlineViewNode(t, !1);
          !(n && n.is("$textProxy") && this._nodeEndsWithSpace(n)) && n || (e = " " + e.substr(1));
        }
        if (" " == e.charAt(e.length - 1)) {
          const n = this._getTouchingInlineViewNode(t, !0),
            i = n && n.is("$textProxy") && " " == n.data.charAt(0);
          " " != e.charAt(e.length - 2) && n && !i || (e = e.substr(0, e.length - 1) + " ");
        }
        return e.replace(/ {2}/g, "  ");
      }
      _nodeEndsWithSpace(t) {
        if (t.getAncestors().some(t => this.preElements.includes(t.name))) return !1;
        const e = this._processDataFromViewText(t);
        return " " == e.charAt(e.length - 1);
      }
      _getTouchingInlineViewNode(t, e) {
        const n = new Gs({
          startPosition: e ? Ws._createAfter(t) : Ws._createBefore(t),
          direction: e ? "forward" : "backward"
        });
        for (const t of n) {
          if (t.item.is("element", "br")) return null;
          if (this._isInlineObjectElement(t.item)) return t.item;
          if (t.item.is("containerElement")) return null;
          if (t.item.is("$textProxy")) return t.item;
        }
        return null;
      }
      _isBlockDomElement(t) {
        return this.isElement(t) && this.blockElements.includes(t.tagName.toLowerCase());
      }
      _isBlockViewElement(t) {
        return t.is("element") && this.blockElements.includes(t.name);
      }
      _isInlineObjectElement(t) {
        return !!t.is("element") && ("br" == t.name || this.inlineObjectElements.includes(t.name) || !!this._inlineObjectElementMatcher.match(t));
      }
      _createViewElement(t, e) {
        if (Ki(t)) return new ua(this.document, "$comment");
        const n = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
        return new Rs(this.document, n);
      }
      _isViewElementWithRawContent(t, e) {
        return !1 !== e.withChildren && t.is("element") && !!this._rawContentElementMatcher.match(t);
      }
      _shouldRenameElement(t) {
        const e = t.toLowerCase();
        return "editing" === this.renderingMode && this.unsafeElements.includes(e);
      }
      _createReplacementDomElement(t, e) {
        const n = this._domDocument.createElement("span");
        if (n.setAttribute(Ka, t), e) {
          for (; e.firstChild;) n.appendChild(e.firstChild);
          for (const t of e.getAttributeNames()) n.setAttribute(t, e.getAttribute(t));
        }
        return n;
      }
    }
    function Qa(t, e) {
      return t.getAncestors().some(t => t.is("element") && e.includes(t.name));
    }
    function Za(t, e) {
      let n = t;
      for (; n;) e(n), n = n.parentElement;
    }
    function Ja(t, e) {
      const n = t.parentNode;
      return !!n && !!n.tagName && e.includes(n.tagName.toLowerCase());
    }
    function Xa(t) {
      "script" === t && w("domconverter-unsafe-script-element-detected"), "style" === t && w("domconverter-unsafe-style-element-detected");
    }
    class tl extends Bi() {
      constructor(t) {
        super(), this._isEnabled = !1, this.view = t, this.document = t.document;
      }
      get isEnabled() {
        return this._isEnabled;
      }
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      destroy() {
        this.disable(), this.stopListening();
      }
      checkShouldIgnoreEventFromTarget(t) {
        return t && 3 === t.nodeType && (t = t.parentNode), !(!t || 1 !== t.nodeType) && t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
      }
    }
    const el = Ho(function (t, e) {
      Be(e, hn(e), t);
    });
    class nl {
      constructor(t, e, n) {
        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, el(this, n);
      }
      get target() {
        return this.view.domConverter.mapDomToView(this.domTarget);
      }
      preventDefault() {
        this.domEvent.preventDefault();
      }
      stopPropagation() {
        this.domEvent.stopPropagation();
      }
    }
    class il extends tl {
      constructor() {
        super(...arguments), this.useCapture = !1;
      }
      observe(t) {
        ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(e => {
          this.listenTo(t, e, (t, e) => {
            this.isEnabled && !this.checkShouldIgnoreEventFromTarget(e.target) && this.onDomEvent(e);
          }, {
            useCapture: this.useCapture
          });
        });
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      fire(t, e, n) {
        this.isEnabled && this.document.fire(t, new nl(this.view, e, n));
      }
    }
    class ol extends il {
      constructor() {
        super(...arguments), this.domEventType = ["keydown", "keyup"];
      }
      onDomEvent(t) {
        const e = {
          keyCode: t.keyCode,
          altKey: t.altKey,
          ctrlKey: t.ctrlKey,
          shiftKey: t.shiftKey,
          metaKey: t.metaKey,
          get keystroke() {
            return ko(this);
          }
        };
        this.fire(t.type, t, e);
      }
    }
    const rl = function () {
      return nt.Date.now();
    };
    var sl = /\s/;
    const al = function (t) {
      for (var e = t.length; e-- && sl.test(t.charAt(e)););
      return e;
    };
    var ll = /^\s+/;
    const cl = function (t) {
      return t ? t.slice(0, al(t) + 1).replace(ll, "") : t;
    };
    var dl = /^[-+]0x[0-9a-f]+$/i,
      ul = /^0b[01]+$/i,
      hl = /^0o[0-7]+$/i,
      ml = parseInt;
    const gl = function (t) {
      if ("number" == typeof t) return t;
      if (as(t)) return NaN;
      if (V(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = V(e) ? e + "" : e;
      }
      if ("string" != typeof t) return 0 === t ? t : +t;
      t = cl(t);
      var n = ul.test(t);
      return n || hl.test(t) ? ml(t.slice(2), n ? 2 : 8) : dl.test(t) ? NaN : +t;
    };
    var pl = Math.max,
      fl = Math.min;
    const kl = function (t, e, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        c = 0,
        d = !1,
        u = !1,
        h = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      function m(e) {
        var n = i,
          r = o;
        return i = o = void 0, c = e, s = t.apply(r, n);
      }
      function g(t) {
        var n = t - l;
        return void 0 === l || n >= e || n < 0 || u && t - c >= r;
      }
      function p() {
        var t = rl();
        if (g(t)) return f(t);
        a = setTimeout(p, function (t) {
          var n = e - (t - l);
          return u ? fl(n, r - (t - c)) : n;
        }(t));
      }
      function f(t) {
        return a = void 0, h && i ? m(t) : (i = o = void 0, s);
      }
      function k() {
        var t = rl(),
          n = g(t);
        if (i = arguments, o = this, l = t, n) {
          if (void 0 === a) return function (t) {
            return c = t, a = setTimeout(p, e), d ? m(t) : s;
          }(l);
          if (u) return clearTimeout(a), a = setTimeout(p, e), m(l);
        }
        return void 0 === a && (a = setTimeout(p, e)), s;
      }
      return e = gl(e) || 0, V(n) && (d = !!n.leading, r = (u = "maxWait" in n) ? pl(gl(n.maxWait) || 0, e) : r, h = "trailing" in n ? !!n.trailing : h), k.cancel = function () {
        void 0 !== a && clearTimeout(a), c = 0, i = l = o = a = void 0;
      }, k.flush = function () {
        return void 0 === a ? s : f(rl());
      }, k;
    };
    class bl extends tl {
      constructor(t) {
        super(t), this._fireSelectionChangeDoneDebounced = kl(t => {
          this.document.fire("selectionChangeDone", t);
        }, 200);
      }
      observe() {
        const t = this.document;
        t.on("arrowKey", (e, n) => {
          t.selection.isFake && this.isEnabled && n.preventDefault();
        }, {
          context: "$capture"
        }), t.on("arrowKey", (e, n) => {
          t.selection.isFake && this.isEnabled && this._handleSelectionMove(n.keyCode);
        }, {
          priority: "lowest"
        });
      }
      stopObserving() {}
      destroy() {
        super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
      }
      _handleSelectionMove(t) {
        const e = this.document.selection,
          n = new Ys(e.getRanges(), {
            backward: e.isBackward,
            fake: !1
          });
        t != po.arrowleft && t != po.arrowup || n.setTo(n.getFirstPosition()), t != po.arrowright && t != po.arrowdown || n.setTo(n.getLastPosition());
        const i = {
          oldSelection: e,
          newSelection: n,
          domSelection: null
        };
        this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
      }
    }
    const wl = function (t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    };
    const Al = function (t) {
      return this.__data__.has(t);
    };
    function Cl(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.__data__ = new we(); ++e < n;) this.add(t[e]);
    }
    Cl.prototype.add = Cl.prototype.push = wl, Cl.prototype.has = Al;
    const _l = Cl;
    const vl = function (t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) if (e(t[n], n, t)) return !0;
      return !1;
    };
    const yl = function (t, e) {
      return t.has(e);
    };
    const xl = function (t, e, n, i, o, r) {
      var s = 1 & n,
        a = t.length,
        l = e.length;
      if (a != l && !(s && l > a)) return !1;
      var c = r.get(t),
        d = r.get(e);
      if (c && d) return c == e && d == t;
      var u = -1,
        h = !0,
        m = 2 & n ? new _l() : void 0;
      for (r.set(t, e), r.set(e, t); ++u < a;) {
        var g = t[u],
          p = e[u];
        if (i) var f = s ? i(p, g, u, e, t, r) : i(g, p, u, t, e, r);
        if (void 0 !== f) {
          if (f) continue;
          h = !1;
          break;
        }
        if (m) {
          if (!vl(e, function (t, e) {
            if (!yl(m, e) && (g === t || o(g, t, n, i, r))) return m.push(e);
          })) {
            h = !1;
            break;
          }
        } else if (g !== p && !o(g, p, n, i, r)) {
          h = !1;
          break;
        }
      }
      return r.delete(t), r.delete(e), h;
    };
    const El = function (t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t, i) {
        n[++e] = [i, t];
      }), n;
    };
    const Dl = function (t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    };
    var Bl = it ? it.prototype : void 0,
      Sl = Bl ? Bl.valueOf : void 0;
    const Tl = function (t, e, n, i, o, r, s) {
      switch (n) {
        case "[object DataView]":
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;
        case "[object ArrayBuffer]":
          return !(t.byteLength != e.byteLength || !r(new Qn(t), new Qn(e)));
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return Et(+t, +e);
        case "[object Error]":
          return t.name == e.name && t.message == e.message;
        case "[object RegExp]":
        case "[object String]":
          return t == e + "";
        case "[object Map]":
          var a = El;
        case "[object Set]":
          var l = 1 & i;
          if (a || (a = Dl), t.size != e.size && !l) return !1;
          var c = s.get(t);
          if (c) return c == e;
          i |= 2, s.set(t, e);
          var d = xl(a(t), a(e), i, o, r, s);
          return s.delete(t), d;
        case "[object Symbol]":
          if (Sl) return Sl.call(t) == Sl.call(e);
      }
      return !1;
    };
    var Il = Object.prototype.hasOwnProperty;
    const Ml = function (t, e, n, i, o, r) {
      var s = 1 & n,
        a = Tn(t),
        l = a.length;
      if (l != Tn(e).length && !s) return !1;
      for (var c = l; c--;) {
        var d = a[c];
        if (!(s ? d in e : Il.call(e, d))) return !1;
      }
      var u = r.get(t),
        h = r.get(e);
      if (u && h) return u == e && h == t;
      var m = !0;
      r.set(t, e), r.set(e, t);
      for (var g = s; ++c < l;) {
        var p = t[d = a[c]],
          f = e[d];
        if (i) var k = s ? i(f, p, d, e, t, r) : i(p, f, d, t, e, r);
        if (!(void 0 === k ? p === f || o(p, f, n, i, r) : k)) {
          m = !1;
          break;
        }
        g || (g = "constructor" == d);
      }
      if (m && !g) {
        var b = t.constructor,
          w = e.constructor;
        b == w || !("constructor" in t) || !("constructor" in e) || "function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w || (m = !1);
      }
      return r.delete(t), r.delete(e), m;
    };
    var Ll = "[object Arguments]",
      Nl = "[object Array]",
      zl = "[object Object]",
      Pl = Object.prototype.hasOwnProperty;
    const Vl = function (t, e, n, i, o, r) {
      var s = mt(t),
        a = mt(e),
        l = s ? Nl : $n(t),
        c = a ? Nl : $n(e),
        d = (l = l == Ll ? zl : l) == zl,
        u = (c = c == Ll ? zl : c) == zl,
        h = l == c;
      if (h && Fe(t)) {
        if (!Fe(e)) return !1;
        s = !0, d = !1;
      }
      if (h && !d) return r || (r = new _e()), s || Ze(t) ? xl(t, e, n, i, o, r) : Tl(t, e, l, n, i, o, r);
      if (!(1 & n)) {
        var m = d && Pl.call(t, "__wrapped__"),
          g = u && Pl.call(e, "__wrapped__");
        if (m || g) {
          var p = m ? t.value() : t,
            f = g ? e.value() : e;
          return r || (r = new _e()), o(p, f, n, i, r);
        }
      }
      return !!h && (r || (r = new _e()), Ml(t, e, n, i, o, r));
    };
    const Rl = function t(e, n, i, o, r) {
      return e === n || (null == e || null == n || !gt(e) && !gt(n) ? e != e && n != n : Vl(e, n, i, o, t, r));
    };
    const Fl = function (t, e, n) {
      var i = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === i ? Rl(t, e, void 0, n) : !!i;
    };
    class Ol extends tl {
      constructor(t) {
        super(t), this._config = {
          childList: !0,
          characterData: !0,
          subtree: !0
        }, this.domConverter = t.domConverter, this.renderer = t._renderer, this._domElements = new Set(), this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
      }
      flush() {
        this._onMutations(this._mutationObserver.takeRecords());
      }
      observe(t) {
        this._domElements.add(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
      }
      stopObserving(t) {
        if (this._domElements.delete(t), this.isEnabled) {
          this._mutationObserver.disconnect();
          for (const t of this._domElements) this._mutationObserver.observe(t, this._config);
        }
      }
      enable() {
        super.enable();
        for (const t of this._domElements) this._mutationObserver.observe(t, this._config);
      }
      disable() {
        super.disable(), this._mutationObserver.disconnect();
      }
      destroy() {
        super.destroy(), this._mutationObserver.disconnect();
      }
      _onMutations(t) {
        if (0 === t.length) return;
        const e = this.domConverter,
          n = new Set(),
          i = new Set();
        for (const n of t) {
          const t = e.mapDomToView(n.target);
          t && (t.is("uiElement") || t.is("rawElement") || "childList" !== n.type || this._isBogusBrMutation(n) || i.add(t));
        }
        for (const o of t) {
          const t = e.mapDomToView(o.target);
          if ((!t || !t.is("uiElement") && !t.is("rawElement")) && "characterData" === o.type) {
            const t = e.findCorrespondingViewText(o.target);
            t && !i.has(t.parent) ? n.add(t) : !t && Ma(o.target) && i.add(e.mapDomToView(o.target.parentNode));
          }
        }
        let o = !1;
        for (const t of n) o = !0, this.renderer.markToSync("text", t);
        for (const t of i) {
          const n = e.mapViewToDom(t),
            i = Array.from(t.getChildren()),
            r = Array.from(e.domChildrenToView(n, {
              withChildren: !1
            }));
          Fl(i, r, jl) || (o = !0, this.renderer.markToSync("children", t));
        }
        o && this.view.forceRender();
      }
      _isBogusBrMutation(t) {
        let e = null;
        return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
          withChildren: !1
        })), e && e.is("element", "br");
      }
    }
    function jl(t, e) {
      if (!Array.isArray(t)) return t === e || !(!t.is("$text") || !e.is("$text")) && t.data === e.data;
    }
    class Hl extends il {
      constructor(t) {
        super(t), this._isFocusChanging = !1, this.domEventType = ["focus", "blur"], this.useCapture = !0;
        const e = this.document;
        e.on("focus", () => {
          this._isFocusChanging = !0, this._renderTimeoutId = setTimeout(() => {
            this.flush(), t.change(() => {});
          }, 50);
        }), e.on("blur", (n, i) => {
          const o = e.selection.editableElement;
          null !== o && o !== i.target || (e.isFocused = !1, this._isFocusChanging = !1, t.change(() => {}));
        });
      }
      flush() {
        this._isFocusChanging && (this._isFocusChanging = !1, this.document.isFocused = !0);
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
      destroy() {
        this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
      }
    }
    class Ul extends tl {
      constructor(t) {
        super(t), this.mutationObserver = t.getObserver(Ol), this.focusObserver = t.getObserver(Hl), this.selection = this.document.selection, this.domConverter = t.domConverter, this._documents = new WeakSet(), this._fireSelectionChangeDoneDebounced = kl(t => {
          this.document.fire("selectionChangeDone", t);
        }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = kl(() => this.document.isSelecting = !1, 5e3), this._loopbackCounter = 0;
      }
      observe(t) {
        const e = t.ownerDocument,
          n = () => {
            this.document.isSelecting && (this._handleSelectionChange(null, e), this.document.isSelecting = !1, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
          };
        this.listenTo(t, "selectstart", () => {
          this.document.isSelecting = !0, this._documentIsSelectingInactivityTimeoutDebounced();
        }, {
          priority: "highest"
        }), this.listenTo(t, "keydown", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(t, "keyup", n, {
          priority: "highest",
          useCapture: !0
        }), this._documents.has(e) || (this.listenTo(e, "mouseup", n, {
          priority: "highest",
          useCapture: !0
        }), this.listenTo(e, "selectionchange", (t, n) => {
          this.document.isComposing && !s.isAndroid || (this._handleSelectionChange(n, e), this._documentIsSelectingInactivityTimeoutDebounced());
        }), this._documents.add(e));
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      destroy() {
        super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
      }
      _reportInfiniteLoop() {}
      _handleSelectionChange(t, e) {
        if (!this.isEnabled) return;
        const n = e.defaultView.getSelection();
        if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
        this.mutationObserver.flush();
        const i = this.domConverter.domSelectionToView(n);
        if (0 != i.rangeCount) {
          if (this.view.hasDomSelection = !0, this.focusObserver.flush(), !this.selection.isEqual(i) || !this.domConverter.isDomSelectionCorrect(n)) if (++this._loopbackCounter > 60) this._reportInfiniteLoop();else if (this.selection.isSimilar(i)) this.view.forceRender();else {
            const t = {
              oldSelection: this.selection,
              newSelection: i,
              domSelection: n
            };
            this.document.fire("selectionChange", t), this._fireSelectionChangeDoneDebounced(t);
          }
        } else this.view.hasDomSelection = !1;
      }
      _clearInfiniteLoop() {
        this._loopbackCounter = 0;
      }
    }
    class ql extends il {
      constructor(t) {
        super(t), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        const e = this.document;
        e.on("compositionstart", () => {
          e.isComposing = !0;
        }, {
          priority: "low"
        }), e.on("compositionend", () => {
          e.isComposing = !1;
        }, {
          priority: "low"
        });
      }
      onDomEvent(t) {
        this.fire(t.type, t, {
          data: t.data
        });
      }
    }
    class Gl {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._files = e.cacheFiles ? Wl(t) : null, this._native = t;
      }
      get files() {
        return this._files || (this._files = Wl(this._native)), this._files;
      }
      get types() {
        return this._native.types;
      }
      getData(t) {
        return this._native.getData(t);
      }
      setData(t, e) {
        this._native.setData(t, e);
      }
      set effectAllowed(t) {
        this._native.effectAllowed = t;
      }
      get effectAllowed() {
        return this._native.effectAllowed;
      }
      set dropEffect(t) {
        this._native.dropEffect = t;
      }
      get dropEffect() {
        return this._native.dropEffect;
      }
      setDragImage(t, e, n) {
        this._native.setDragImage(t, e, n);
      }
      get isCanceled() {
        return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
      }
    }
    function Wl(t) {
      const e = Array.from(t.files || []),
        n = Array.from(t.items || []);
      return e.length ? e : n.filter(t => "file" === t.kind).map(t => t.getAsFile());
    }
    class $l extends il {
      constructor() {
        super(...arguments), this.domEventType = "beforeinput";
      }
      onDomEvent(t) {
        const e = t.getTargetRanges(),
          n = this.view,
          i = n.document;
        let o = null,
          r = null,
          a = [];
        if (t.dataTransfer && (o = new Gl(t.dataTransfer)), null !== t.data ? r = t.data : o && (r = o.getData("text/plain")), i.selection.isFake) a = Array.from(i.selection.getRanges());else if (e.length) a = e.map(t => {
          const e = n.domConverter.domPositionToView(t.startContainer, t.startOffset),
            i = n.domConverter.domPositionToView(t.endContainer, t.endOffset);
          return e ? n.createRange(e, i) : i ? n.createRange(i) : void 0;
        }).filter(t => !!t);else if (s.isAndroid) {
          const e = t.target.ownerDocument.defaultView.getSelection();
          a = Array.from(n.domConverter.domSelectionToView(e).getRanges());
        }
        if (s.isAndroid && "insertCompositionText" == t.inputType && r && r.endsWith("\n")) this.fire(t.type, t, {
          inputType: "insertParagraph",
          targetRanges: [n.createRange(a[0].end)]
        });else {
          if ("insertText" == t.inputType && r && r.includes("\n")) {
            const e = r.split(/\n{1,2}/g);
            let n = a;
            for (let r = 0; r < e.length; r++) {
              const s = e[r];
              "" != s && (this.fire(t.type, t, {
                data: s,
                dataTransfer: o,
                targetRanges: n,
                inputType: t.inputType,
                isComposing: t.isComposing
              }), n = [i.selection.getFirstRange()]), r + 1 < e.length && (this.fire(t.type, t, {
                inputType: "insertParagraph",
                targetRanges: n
              }), n = [i.selection.getFirstRange()]);
            }
            return;
          }
          this.fire(t.type, t, {
            data: r,
            dataTransfer: o,
            targetRanges: a,
            inputType: t.inputType,
            isComposing: t.isComposing
          });
        }
      }
    }
    class Kl extends tl {
      constructor(t) {
        super(t), this.document.on("keydown", (t, e) => {
          if (this.isEnabled && ((n = e.keyCode) == po.arrowright || n == po.arrowleft || n == po.arrowup || n == po.arrowdown)) {
            const n = new Zs(this.document, "arrowKey", this.document.selection.getFirstRange());
            this.document.fire(n, e), n.stop.called && t.stop();
          }
          var n;
        });
      }
      observe() {}
      stopObserving() {}
    }
    class Yl extends tl {
      constructor(t) {
        super(t);
        const e = this.document;
        e.on("keydown", (t, n) => {
          if (!this.isEnabled || n.keyCode != po.tab || n.ctrlKey) return;
          const i = new Zs(e, "tab", e.selection.getFirstRange());
          e.fire(i, n), i.stop.called && t.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    const Ql = function (t) {
      return wi(t, 5);
    };
    class Zl extends q() {
      constructor(t) {
        super(), this.domRoots = new Map(), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this.document = new oa(t), this.domConverter = new Ya(this.document), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new Ra(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing"), this._writer = new ka(this.document), this.addObserver(Ol), this.addObserver(Hl), this.addObserver(Ul), this.addObserver(ol), this.addObserver(bl), this.addObserver(ql), this.addObserver(Kl), this.addObserver($l), this.addObserver(Yl), this.document.on("arrowKey", za, {
          priority: "low"
        }), ha(this), this.on("render", () => {
          this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), this.listenTo(this.document, "change:isFocused", () => {
          this._hasChangedSinceTheLastRendering = !0;
        }), s.isiOS && this.listenTo(this.document, "blur", (t, e) => {
          this.domConverter.mapDomToView(e.domEvent.relatedTarget) || this.domConverter._clearDomSelection();
        });
      }
      attachDomRoot(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
        const n = this.document.getRoot(e);
        n._name = t.tagName.toLowerCase();
        const i = {};
        for (const {
          name: e,
          value: o
        } of Array.from(t.attributes)) i[e] = o, "class" === e ? this._writer.addClass(o.split(" "), n) : this._writer.setAttribute(e, o, n);
        this._initialDomRootAttributes.set(t, i);
        const o = () => {
          this._writer.setAttribute("contenteditable", (!n.isReadOnly).toString(), n), n.isReadOnly ? this._writer.addClass("ck-read-only", n) : this._writer.removeClass("ck-read-only", n);
        };
        o(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", (t, e) => this._renderer.markToSync("children", e)), n.on("change:attributes", (t, e) => this._renderer.markToSync("attributes", e)), n.on("change:text", (t, e) => this._renderer.markToSync("text", e)), n.on("change:isReadOnly", () => this.change(o)), n.on("change", () => {
          this._hasChangedSinceTheLastRendering = !0;
        });
        for (const n of this._observers.values()) n.observe(t, e);
      }
      detachDomRoot(t) {
        const e = this.domRoots.get(t);
        Array.from(e.attributes).forEach(_ref20 => {
          let {
            name: t
          } = _ref20;
          return e.removeAttribute(t);
        });
        const n = this._initialDomRootAttributes.get(e);
        for (const t in n) e.setAttribute(t, n[t]);
        this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        for (const t of this._observers.values()) t.stopObserving(e);
      }
      getDomRoot() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.domRoots.get(t);
      }
      addObserver(t) {
        let e = this._observers.get(t);
        if (e) return e;
        e = new t(this), this._observers.set(t, e);
        for (const [t, n] of this.domRoots) e.observe(n, t);
        return e.enable(), e;
      }
      getObserver(t) {
        return this._observers.get(t);
      }
      disableObservers() {
        for (const t of this._observers.values()) t.disable();
      }
      enableObservers() {
        for (const t of this._observers.values()) t.enable();
      }
      scrollToTheSelection() {
        let {
          alignToTop: t,
          forceScroll: e,
          viewportOffset: n = 20,
          ancestorOffset: i = 20
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const o = this.document.selection.getFirstRange();
        if (!o) return;
        const r = Ql({
          alignToTop: t,
          forceScroll: e,
          viewportOffset: n,
          ancestorOffset: i
        });
        "number" == typeof n && (n = {
          top: n,
          bottom: n,
          left: n,
          right: n
        });
        const s = {
          target: this.domConverter.viewRangeToDom(o),
          viewportOffset: n,
          ancestorOffset: i,
          alignToTop: t,
          forceScroll: e
        };
        this.fire("scrollToTheSelection", s, r), eo(s);
      }
      focus() {
        if (!this.document.isFocused) {
          const t = this.document.selection.editableElement;
          t && (this.domConverter.focus(t), this.forceRender());
        }
      }
      change(t) {
        if (this.isRenderingInProgress || this._postFixersInProgress) throw new b("cannot-change-view-tree", this);
        try {
          if (this._ongoingChange) return t(this._writer);
          this._ongoingChange = !0;
          const e = t(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), e;
        } catch (t) {
          b.rethrowUnexpectedError(t, this);
        }
      }
      forceRender() {
        this._hasChangedSinceTheLastRendering = !0, this.getObserver(Hl).flush(), this.change(() => {});
      }
      destroy() {
        for (const t of this._observers.values()) t.destroy();
        this.document.destroy(), this.stopListening();
      }
      createPositionAt(t, e) {
        return Ws._createAt(t, e);
      }
      createPositionAfter(t) {
        return Ws._createAfter(t);
      }
      createPositionBefore(t) {
        return Ws._createBefore(t);
      }
      createRange(t, e) {
        return new $s(t, e);
      }
      createRangeOn(t) {
        return $s._createOn(t);
      }
      createRangeIn(t) {
        return $s._createIn(t);
      }
      createSelection() {
        for (var _len23 = arguments.length, t = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
          t[_key23] = arguments[_key23];
        }
        return new Ys(...t);
      }
      _disableRendering(t) {
        this._renderingDisabled = t, 0 == t && this.change(() => {});
      }
      _render() {
        this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
      }
    }
    class Jl {
      is() {
        throw new Error("is() method is abstract");
      }
    }
    class Xl extends Jl {
      constructor(t) {
        super(), this.parent = null, this._attrs = Qo(t);
      }
      get document() {
        return null;
      }
      get index() {
        let t;
        if (!this.parent) return null;
        if (null === (t = this.parent.getChildIndex(this))) throw new b("model-node-not-found-in-parent", this);
        return t;
      }
      get startOffset() {
        let t;
        if (!this.parent) return null;
        if (null === (t = this.parent.getChildStartOffset(this))) throw new b("model-node-not-found-in-parent", this);
        return t;
      }
      get offsetSize() {
        return 1;
      }
      get endOffset() {
        return this.parent ? this.startOffset + this.offsetSize : null;
      }
      get nextSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t + 1) || null;
      }
      get previousSibling() {
        const t = this.index;
        return null !== t && this.parent.getChild(t - 1) || null;
      }
      get root() {
        let t = this;
        for (; t.parent;) t = t.parent;
        return t;
      }
      isAttached() {
        return null !== this.parent && this.root.isAttached();
      }
      getPath() {
        const t = [];
        let e = this;
        for (; e.parent;) t.unshift(e.startOffset), e = e.parent;
        return t;
      }
      getAncestors() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      getCommonAncestor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.getAncestors(e),
          i = t.getAncestors(e);
        let o = 0;
        for (; n[o] == i[o] && n[o];) o++;
        return 0 === o ? null : n[o - 1];
      }
      isBefore(t) {
        if (this == t) return !1;
        if (this.root !== t.root) return !1;
        const e = this.getPath(),
          n = t.getPath(),
          i = J(e, n);
        switch (i) {
          case "prefix":
            return !0;
          case "extension":
            return !1;
          default:
            return e[i] < n[i];
        }
      }
      isAfter(t) {
        return this != t && this.root === t.root && !this.isBefore(t);
      }
      hasAttribute(t) {
        return this._attrs.has(t);
      }
      getAttribute(t) {
        return this._attrs.get(t);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      toJSON() {
        const t = {};
        return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce((t, e) => (t[e[0]] = e[1], t), {})), t;
      }
      _clone(t) {
        return new this.constructor(this._attrs);
      }
      _remove() {
        this.parent._removeChildren(this.index);
      }
      _setAttribute(t, e) {
        this._attrs.set(t, e);
      }
      _setAttributesTo(t) {
        this._attrs = Qo(t);
      }
      _removeAttribute(t) {
        return this._attrs.delete(t);
      }
      _clearAttributes() {
        this._attrs.clear();
      }
    }
    Xl.prototype.is = function (t) {
      return "node" === t || "model:node" === t;
    };
    class tc {
      constructor(t) {
        this._nodes = [], t && this._insertNodes(0, t);
      }
      [Symbol.iterator]() {
        return this._nodes[Symbol.iterator]();
      }
      get length() {
        return this._nodes.length;
      }
      get maxOffset() {
        return this._nodes.reduce((t, e) => t + e.offsetSize, 0);
      }
      getNode(t) {
        return this._nodes[t] || null;
      }
      getNodeIndex(t) {
        const e = this._nodes.indexOf(t);
        return -1 == e ? null : e;
      }
      getNodeStartOffset(t) {
        const e = this.getNodeIndex(t);
        return null === e ? null : this._nodes.slice(0, e).reduce((t, e) => t + e.offsetSize, 0);
      }
      indexToOffset(t) {
        if (t == this._nodes.length) return this.maxOffset;
        const e = this._nodes[t];
        if (!e) throw new b("model-nodelist-index-out-of-bounds", this);
        return this.getNodeStartOffset(e);
      }
      offsetToIndex(t) {
        let e = 0;
        for (const n of this._nodes) {
          if (t >= e && t < e + n.offsetSize) return this.getNodeIndex(n);
          e += n.offsetSize;
        }
        if (e != t) throw new b("model-nodelist-offset-out-of-bounds", this, {
          offset: t,
          nodeList: this
        });
        return this.length;
      }
      _insertNodes(t, e) {
        for (const t of e) if (!(t instanceof Xl)) throw new b("model-nodelist-insertnodes-not-node", this);
        this._nodes = function (t, e, n, i) {
          if (Math.max(e.length, t.length) > 1e4) return t.slice(0, n).concat(e).concat(t.slice(n + i, t.length));
          {
            const o = Array.from(t);
            return o.splice(n, i, ...e), o;
          }
        }(this._nodes, Array.from(e), t, 0);
      }
      _removeNodes(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return this._nodes.splice(t, e);
      }
      toJSON() {
        return this._nodes.map(t => t.toJSON());
      }
    }
    class ec extends Xl {
      constructor(t, e) {
        super(e), this._data = t || "";
      }
      get offsetSize() {
        return this.data.length;
      }
      get data() {
        return this._data;
      }
      toJSON() {
        const t = super.toJSON();
        return t.data = this.data, t;
      }
      _clone() {
        return new ec(this.data, this.getAttributes());
      }
      static fromJSON(t) {
        return new ec(t.data, t.attributes);
      }
    }
    ec.prototype.is = function (t) {
      return "$text" === t || "model:$text" === t || "text" === t || "model:text" === t || "node" === t || "model:node" === t;
    };
    class nc extends Jl {
      constructor(t, e, n) {
        if (super(), this.textNode = t, e < 0 || e > t.offsetSize) throw new b("model-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.offsetSize) throw new b("model-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      get startOffset() {
        return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
      }
      get offsetSize() {
        return this.data.length;
      }
      get endOffset() {
        return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
      }
      get isPartial() {
        return this.offsetSize !== this.textNode.offsetSize;
      }
      get parent() {
        return this.textNode.parent;
      }
      get root() {
        return this.textNode.root;
      }
      getPath() {
        const t = this.textNode.getPath();
        return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
      }
      getAncestors() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = [];
        let n = t.includeSelf ? this : this.parent;
        for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
        return e;
      }
      hasAttribute(t) {
        return this.textNode.hasAttribute(t);
      }
      getAttribute(t) {
        return this.textNode.getAttribute(t);
      }
      getAttributes() {
        return this.textNode.getAttributes();
      }
      getAttributeKeys() {
        return this.textNode.getAttributeKeys();
      }
    }
    nc.prototype.is = function (t) {
      return "$textProxy" === t || "model:$textProxy" === t || "textProxy" === t || "model:textProxy" === t;
    };
    class ic extends Xl {
      constructor(t, e, n) {
        super(e), this._children = new tc(), this.name = t, n && this._insertChild(0, n);
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      getChild(t) {
        return this._children.getNode(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(t) {
        return this._children.getNodeIndex(t);
      }
      getChildStartOffset(t) {
        return this._children.getNodeStartOffset(t);
      }
      offsetToIndex(t) {
        return this._children.offsetToIndex(t);
      }
      getNodeByPath(t) {
        let e = this;
        for (const n of t) e = e.getChild(e.offsetToIndex(n));
        return e;
      }
      findAncestor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = e.includeSelf ? this : this.parent;
        for (; n;) {
          if (n.name === t) return n;
          n = n.parent;
        }
        return null;
      }
      toJSON() {
        const t = super.toJSON();
        if (t.name = this.name, this._children.length > 0) {
          t.children = [];
          for (const e of this._children) t.children.push(e.toJSON());
        }
        return t;
      }
      _clone() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        const e = t ? Array.from(this._children).map(t => t._clone(!0)) : void 0;
        return new ic(this.name, this.getAttributes(), e);
      }
      _appendChild(t) {
        this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        const n = function (t) {
          if ("string" == typeof t) return [new ec(t)];
          X(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new ec(t) : t instanceof nc ? new ec(t.data, t.getAttributes()) : t);
        }(e);
        for (const t of n) null !== t.parent && t._remove(), t.parent = this;
        this._children._insertNodes(t, n);
      }
      _removeChildren(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        const n = this._children._removeNodes(t, e);
        for (const t of n) t.parent = null;
        return n;
      }
      static fromJSON(t) {
        let e;
        if (t.children) {
          e = [];
          for (const n of t.children) n.name ? e.push(ic.fromJSON(n)) : e.push(ec.fromJSON(n));
        }
        return new ic(t.name, t.attributes, e);
      }
    }
    ic.prototype.is = function (t, e) {
      return e ? e === this.name && ("element" === t || "model:element" === t) : "element" === t || "model:element" === t || "node" === t || "model:node" === t;
    };
    class oc {
      constructor(t) {
        if (!t || !t.boundaries && !t.startPosition) throw new b("model-tree-walker-no-start-position", null);
        const e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new b("model-tree-walker-unknown-direction", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this._position = t.startPosition.clone() : this._position = sc._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }
      [Symbol.iterator]() {
        return this;
      }
      get position() {
        return this._position;
      }
      skip(t) {
        let e, n, i, o;
        do {
          i = this.position, o = this._visitedParent, ({
            done: e,
            value: n
          } = this.next());
        } while (!e && t(n));
        e || (this._position = i, this._visitedParent = o);
      }
      next() {
        return "forward" == this.direction ? this._next() : this._previous();
      }
      _next() {
        const t = this.position,
          e = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && e.offset === n.maxOffset) return {
          done: !0,
          value: void 0
        };
        if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
          done: !0,
          value: void 0
        };
        const i = ac(e, n),
          o = i || lc(e, n, i);
        if (o instanceof ic) {
          if (this.shallow) {
            if (this.boundaries && this.boundaries.end.isBefore(e)) return {
              done: !0,
              value: void 0
            };
            e.offset++;
          } else e.path.push(0), this._visitedParent = o;
          return this._position = e, rc("elementStart", o, t, e, 1);
        }
        if (o instanceof ec) {
          let i;
          if (this.singleCharacters) i = 1;else {
            let t = o.endOffset;
            this._boundaryEndParent == n && this.boundaries.end.offset < t && (t = this.boundaries.end.offset), i = t - e.offset;
          }
          const r = e.offset - o.startOffset,
            s = new nc(o, r, i);
          return e.offset += i, this._position = e, rc("text", s, t, e, i);
        }
        return e.path.pop(), e.offset++, this._position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : rc("elementEnd", n, t, e);
      }
      _previous() {
        const t = this.position,
          e = this.position.clone(),
          n = this._visitedParent;
        if (null === n.parent && 0 === e.offset) return {
          done: !0,
          value: void 0
        };
        if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
          done: !0,
          value: void 0
        };
        const i = e.parent,
          o = ac(e, i),
          r = o || cc(e, i, o);
        if (r instanceof ic) return e.offset--, this.shallow ? (this._position = e, rc("elementStart", r, t, e, 1)) : (e.path.push(r.maxOffset), this._position = e, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : rc("elementEnd", r, t, e));
        if (r instanceof ec) {
          let i;
          if (this.singleCharacters) i = 1;else {
            let t = r.startOffset;
            this._boundaryStartParent == n && this.boundaries.start.offset > t && (t = this.boundaries.start.offset), i = e.offset - t;
          }
          const o = e.offset - r.startOffset,
            s = new nc(r, o - i, i);
          return e.offset -= i, this._position = e, rc("text", s, t, e, i);
        }
        return e.path.pop(), this._position = e, this._visitedParent = n.parent, rc("elementStart", n, t, e, 1);
      }
    }
    function rc(t, e, n, i, o) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: i,
          length: o
        }
      };
    }
    class sc extends Jl {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (super(), !t.is("element") && !t.is("documentFragment")) throw new b("model-position-root-invalid", t);
        if (!(e instanceof Array) || 0 === e.length) throw new b("model-position-path-incorrect-format", t, {
          path: e
        });
        t.is("rootElement") ? e = e.slice() : (e = [...t.getPath(), ...e], t = t.root), this.root = t, this.path = e, this.stickiness = n;
      }
      get offset() {
        return this.path[this.path.length - 1];
      }
      set offset(t) {
        this.path[this.path.length - 1] = t;
      }
      get parent() {
        let t = this.root;
        for (let e = 0; e < this.path.length - 1; e++) if (t = t.getChild(t.offsetToIndex(this.path[e])), !t) throw new b("model-position-path-incorrect", this, {
          position: this
        });
        if (t.is("$text")) throw new b("model-position-path-incorrect", this, {
          position: this
        });
        return t;
      }
      get index() {
        return this.parent.offsetToIndex(this.offset);
      }
      get textNode() {
        return ac(this, this.parent);
      }
      get nodeAfter() {
        const t = this.parent;
        return lc(this, t, ac(this, t));
      }
      get nodeBefore() {
        const t = this.parent;
        return cc(this, t, ac(this, t));
      }
      get isAtStart() {
        return 0 === this.offset;
      }
      get isAtEnd() {
        return this.offset == this.parent.maxOffset;
      }
      compareWith(t) {
        if (this.root != t.root) return "different";
        const e = J(this.path, t.path);
        switch (e) {
          case "same":
            return "same";
          case "prefix":
            return "before";
          case "extension":
            return "after";
          default:
            return this.path[e] < t.path[e] ? "before" : "after";
        }
      }
      getLastMatchingPosition(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        e.startPosition = this;
        const n = new oc(e);
        return n.skip(t), n.position;
      }
      getParentPath() {
        return this.path.slice(0, -1);
      }
      getAncestors() {
        const t = this.parent;
        return t.is("documentFragment") ? [t] : t.getAncestors({
          includeSelf: !0
        });
      }
      findAncestor(t) {
        const e = this.parent;
        return e.is("element") ? e.findAncestor(t, {
          includeSelf: !0
        }) : null;
      }
      getCommonPath(t) {
        if (this.root != t.root) return [];
        const e = J(this.path, t.path),
          n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
        return this.path.slice(0, n);
      }
      getCommonAncestor(t) {
        const e = this.getAncestors(),
          n = t.getAncestors();
        let i = 0;
        for (; e[i] == n[i] && e[i];) i++;
        return 0 === i ? null : e[i - 1];
      }
      getShiftedBy(t) {
        const e = this.clone(),
          n = e.offset + t;
        return e.offset = n < 0 ? 0 : n, e;
      }
      isAfter(t) {
        return "after" == this.compareWith(t);
      }
      isBefore(t) {
        return "before" == this.compareWith(t);
      }
      isEqual(t) {
        return "same" == this.compareWith(t);
      }
      isTouching(t) {
        if (this.root !== t.root) return !1;
        const e = Math.min(this.path.length, t.path.length);
        for (let n = 0; n < e; n++) {
          const e = this.path[n] - t.path[n];
          if (e < -1 || e > 1) return !1;
          if (1 === e) return dc(t, this, n);
          if (-1 === e) return dc(this, t, n);
        }
        return this.path.length === t.path.length || (this.path.length > t.path.length ? uc(this.path, e) : uc(t.path, e));
      }
      hasSameParentAs(t) {
        if (this.root !== t.root) return !1;
        return "same" == J(this.getParentPath(), t.getParentPath());
      }
      getTransformedByOperation(t) {
        let e;
        switch (t.type) {
          case "insert":
            e = this._getTransformedByInsertOperation(t);
            break;
          case "move":
          case "remove":
          case "reinsert":
            e = this._getTransformedByMoveOperation(t);
            break;
          case "split":
            e = this._getTransformedBySplitOperation(t);
            break;
          case "merge":
            e = this._getTransformedByMergeOperation(t);
            break;
          default:
            e = sc._createAt(this);
        }
        return e;
      }
      _getTransformedByInsertOperation(t) {
        return this._getTransformedByInsertion(t.position, t.howMany);
      }
      _getTransformedByMoveOperation(t) {
        return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
      }
      _getTransformedBySplitOperation(t) {
        const e = t.movedRange;
        return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
      }
      _getTransformedByMergeOperation(t) {
        const e = t.movedRange;
        let n;
        return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? sc._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
      }
      _getTransformedByDeletion(t, e) {
        const n = sc._createAt(this);
        if (this.root != t.root) return n;
        if ("same" == J(t.getParentPath(), this.getParentPath())) {
          if (t.offset < this.offset) {
            if (t.offset + e > this.offset) return null;
            n.offset -= e;
          }
        } else if ("prefix" == J(t.getParentPath(), this.getParentPath())) {
          const i = t.path.length - 1;
          if (t.offset <= this.path[i]) {
            if (t.offset + e > this.path[i]) return null;
            n.path[i] -= e;
          }
        }
        return n;
      }
      _getTransformedByInsertion(t, e) {
        const n = sc._createAt(this);
        if (this.root != t.root) return n;
        if ("same" == J(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == J(t.getParentPath(), this.getParentPath())) {
          const i = t.path.length - 1;
          t.offset <= this.path[i] && (n.path[i] += e);
        }
        return n;
      }
      _getTransformedByMove(t, e, n) {
        if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return sc._createAt(this);
        const i = this._getTransformedByDeletion(t, n);
        return null === i || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : i._getTransformedByInsertion(e, n);
      }
      _getCombined(t, e) {
        const n = t.path.length - 1,
          i = sc._createAt(e);
        return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - t.offset, i.path = [...i.path, ...this.path.slice(n + 1)], i;
      }
      toJSON() {
        return {
          root: this.root.toJSON(),
          path: Array.from(this.path),
          stickiness: this.stickiness
        };
      }
      clone() {
        return new this.constructor(this.root, this.path, this.stickiness);
      }
      static _createAt(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (t instanceof sc) return new sc(t.root, t.path, t.stickiness);
        {
          const i = t;
          if ("end" == e) e = i.maxOffset;else {
            if ("before" == e) return this._createBefore(i, n);
            if ("after" == e) return this._createAfter(i, n);
            if (0 !== e && !e) throw new b("model-createpositionat-offset-required", [this, t]);
          }
          if (!i.is("element") && !i.is("documentFragment")) throw new b("model-position-parent-incorrect", [this, t]);
          const o = i.getPath();
          return o.push(e), new this(i.root, o, n);
        }
      }
      static _createAfter(t, e) {
        if (!t.parent) throw new b("model-position-after-root", [this, t], {
          root: t
        });
        return this._createAt(t.parent, t.endOffset, e);
      }
      static _createBefore(t, e) {
        if (!t.parent) throw new b("model-position-before-root", t, {
          root: t
        });
        return this._createAt(t.parent, t.startOffset, e);
      }
      static fromJSON(t, e) {
        if ("$graveyard" === t.root) {
          const n = new sc(e.graveyard, t.path);
          return n.stickiness = t.stickiness, n;
        }
        if (!e.getRoot(t.root)) throw new b("model-position-fromjson-no-root", e, {
          rootName: t.root
        });
        return new sc(e.getRoot(t.root), t.path, t.stickiness);
      }
    }
    function ac(t, e) {
      const n = e.getChild(e.offsetToIndex(t.offset));
      return n && n.is("$text") && n.startOffset < t.offset ? n : null;
    }
    function lc(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset));
    }
    function cc(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset) - 1);
    }
    function dc(t, e, n) {
      return n + 1 !== t.path.length && !!uc(e.path, n + 1) && !!function (t, e) {
        let n = t.parent,
          i = t.path.length - 1,
          o = 0;
        for (; i >= e;) {
          if (t.path[i] + o !== n.maxOffset) return !1;
          o = 1, i--, n = n.parent;
        }
        return !0;
      }(t, n + 1);
    }
    function uc(t, e) {
      for (; e < t.length;) {
        if (0 !== t[e]) return !1;
        e++;
      }
      return !0;
    }
    sc.prototype.is = function (t) {
      return "position" === t || "model:position" === t;
    };
    class hc extends Jl {
      constructor(t, e) {
        super(), this.start = sc._createAt(t), this.end = e ? sc._createAt(e) : sc._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }
      *[Symbol.iterator]() {
        yield* new oc({
          boundaries: this,
          ignoreElementEnd: !0
        });
      }
      get isCollapsed() {
        return this.start.isEqual(this.end);
      }
      get isFlat() {
        return "same" == J(this.start.getParentPath(), this.end.getParentPath());
      }
      get root() {
        return this.start.root;
      }
      containsPosition(t) {
        return t.isAfter(this.start) && t.isBefore(this.end);
      }
      containsRange(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        t.isCollapsed && (e = !1);
        const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
          i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
        return n && i;
      }
      containsItem(t) {
        const e = sc._createBefore(t);
        return this.containsPosition(e) || this.start.isEqual(e);
      }
      isEqual(t) {
        return this.start.isEqual(t.start) && this.end.isEqual(t.end);
      }
      isIntersecting(t) {
        return this.start.isBefore(t.end) && this.end.isAfter(t.start);
      }
      getDifference(t) {
        const e = [];
        return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new hc(this.start, t.start)), this.containsPosition(t.end) && e.push(new hc(t.end, this.end))) : e.push(new hc(this.start, this.end)), e;
      }
      getIntersection(t) {
        if (this.isIntersecting(t)) {
          let e = this.start,
            n = this.end;
          return this.containsPosition(t.start) && (e = t.start), this.containsPosition(t.end) && (n = t.end), new hc(e, n);
        }
        return null;
      }
      getJoined(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        let n = this.isIntersecting(t);
        if (n || (n = this.start.isBefore(t.start) ? e ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : e ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !n) return null;
        let i = this.start,
          o = this.end;
        return t.start.isBefore(i) && (i = t.start), t.end.isAfter(o) && (o = t.end), new hc(i, o);
      }
      getMinimalFlatRanges() {
        const t = [],
          e = this.start.getCommonPath(this.end).length,
          n = sc._createAt(this.start);
        let i = n.parent;
        for (; n.path.length > e + 1;) {
          const e = i.maxOffset - n.offset;
          0 !== e && t.push(new hc(n, n.getShiftedBy(e))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
        }
        for (; n.path.length <= this.end.path.length;) {
          const e = this.end.path[n.path.length - 1],
            i = e - n.offset;
          0 !== i && t.push(new hc(n, n.getShiftedBy(i))), n.offset = e, n.path.push(0);
        }
        return t;
      }
      getWalker() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return t.boundaries = this, new oc(t);
      }
      getItems() {
        var _this6 = this;
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          t.boundaries = _this6, t.ignoreElementEnd = !0;
          const e = new oc(t);
          for (const t of e) yield t.item;
        }();
      }
      getPositions() {
        var _this7 = this;
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function* () {
          t.boundaries = _this7;
          const e = new oc(t);
          yield e.position;
          for (const t of e) yield t.nextPosition;
        }();
      }
      getTransformedByOperation(t) {
        switch (t.type) {
          case "insert":
            return this._getTransformedByInsertOperation(t);
          case "move":
          case "remove":
          case "reinsert":
            return this._getTransformedByMoveOperation(t);
          case "split":
            return [this._getTransformedBySplitOperation(t)];
          case "merge":
            return [this._getTransformedByMergeOperation(t)];
        }
        return [new hc(this.start, this.end)];
      }
      getTransformedByOperations(t) {
        const e = [new hc(this.start, this.end)];
        for (const n of t) for (let t = 0; t < e.length; t++) {
          const i = e[t].getTransformedByOperation(n);
          e.splice(t, 1, ...i), t += i.length - 1;
        }
        for (let t = 0; t < e.length; t++) {
          const n = e[t];
          for (let i = t + 1; i < e.length; i++) {
            const t = e[i];
            (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) && e.splice(i, 1);
          }
        }
        return e;
      }
      getCommonAncestor() {
        return this.start.getCommonAncestor(this.end);
      }
      getContainedElement() {
        if (this.isCollapsed) return null;
        const t = this.start.nodeAfter,
          e = this.end.nodeBefore;
        return t && t.is("element") && t === e ? t : null;
      }
      toJSON() {
        return {
          start: this.start.toJSON(),
          end: this.end.toJSON()
        };
      }
      clone() {
        return new this.constructor(this.start, this.end);
      }
      _getTransformedByInsertOperation(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return this._getTransformedByInsertion(t.position, t.howMany, e);
      }
      _getTransformedByMoveOperation(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = t.sourcePosition,
          i = t.howMany,
          o = t.targetPosition;
        return this._getTransformedByMove(n, o, i, e);
      }
      _getTransformedBySplitOperation(t) {
        const e = this.start._getTransformedBySplitOperation(t);
        let n = this.end._getTransformedBySplitOperation(t);
        return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new hc(e, n);
      }
      _getTransformedByMergeOperation(t) {
        if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new hc(this.start);
        let e = this.start._getTransformedByMergeOperation(t),
          n = this.end._getTransformedByMergeOperation(t);
        return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = sc._createAt(n), e.offset = 0) : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new hc(e, n)) : new hc(e, n);
      }
      _getTransformedByInsertion(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        if (n && this.containsPosition(t)) return [new hc(this.start, t), new hc(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
        {
          const n = new hc(this.start, this.end);
          return n.start = n.start._getTransformedByInsertion(t, e), n.end = n.end._getTransformedByInsertion(t, e), [n];
        }
      }
      _getTransformedByMove(t, e, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        if (this.isCollapsed) {
          const i = this.start._getTransformedByMove(t, e, n);
          return [new hc(i)];
        }
        const o = hc._createFromPositionAndShift(t, n),
          r = e._getTransformedByDeletion(t, n);
        if (this.containsPosition(e) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
          const i = this.start._getTransformedByMove(t, e, n),
            o = this.end._getTransformedByMove(t, e, n);
          return [new hc(i, o)];
        }
        let s;
        const a = this.getDifference(o);
        let l = null;
        const c = this.getIntersection(o);
        if (1 == a.length ? l = new hc(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (l = new hc(this.start, this.end._getTransformedByDeletion(t, n))), s = l ? l._getTransformedByInsertion(r, n, null !== c || i) : [], c) {
          const t = new hc(c.start._getCombined(o.start, r), c.end._getCombined(o.start, r));
          2 == s.length ? s.splice(1, 0, t) : s.push(t);
        }
        return s;
      }
      _getTransformedByDeletion(t, e) {
        let n = this.start._getTransformedByDeletion(t, e),
          i = this.end._getTransformedByDeletion(t, e);
        return null == n && null == i ? null : (null == n && (n = t), null == i && (i = t), new hc(n, i));
      }
      static _createFromPositionAndShift(t, e) {
        const n = t,
          i = t.getShiftedBy(e);
        return e > 0 ? new this(n, i) : new this(i, n);
      }
      static _createIn(t) {
        return new this(sc._createAt(t, 0), sc._createAt(t, t.maxOffset));
      }
      static _createOn(t) {
        return this._createFromPositionAndShift(sc._createBefore(t), t.offsetSize);
      }
      static _createFromRanges(t) {
        if (0 === t.length) throw new b("range-create-from-ranges-empty-array", null);
        if (1 == t.length) return t[0].clone();
        const e = t[0];
        t.sort((t, e) => t.start.isAfter(e.start) ? 1 : -1);
        const n = t.indexOf(e),
          i = new this(e.start, e.end);
        if (n > 0) for (let e = n - 1; t[e].end.isEqual(i.start); e++) i.start = sc._createAt(t[e].start);
        for (let e = n + 1; e < t.length && t[e].start.isEqual(i.end); e++) i.end = sc._createAt(t[e].end);
        return i;
      }
      static fromJSON(t, e) {
        return new this(sc.fromJSON(t.start, e), sc.fromJSON(t.end, e));
      }
    }
    hc.prototype.is = function (t) {
      return "range" === t || "model:range" === t;
    };
    class mc extends B() {
      constructor() {
        super(), this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._deferredBindingRemovals = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", (t, e) => {
          if (e.viewPosition) return;
          const n = this._modelToViewMapping.get(e.modelPosition.parent);
          if (!n) throw new b("mapping-model-position-view-parent-not-found", this, {
            modelPosition: e.modelPosition
          });
          e.viewPosition = this.findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", (t, e) => {
          if (e.modelPosition) return;
          const n = this.findMappedViewAncestor(e.viewPosition),
            i = this._viewToModelMapping.get(n),
            o = this._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);
          e.modelPosition = sc._createAt(i, o);
        }, {
          priority: "low"
        });
      }
      bindElements(t, e) {
        this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
      }
      unbindViewElement(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.toModelElement(t);
        if (this._elementToMarkerNames.has(t)) for (const e of this._elementToMarkerNames.get(t)) this._unboundMarkerNames.add(e);
        e.defer ? this._deferredBindingRemovals.set(t, t.root) : (this._viewToModelMapping.delete(t), this._modelToViewMapping.get(n) == t && this._modelToViewMapping.delete(n));
      }
      unbindModelElement(t) {
        const e = this.toViewElement(t);
        this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
      }
      bindElementToMarker(t, e) {
        const n = this._markerNameToElements.get(e) || new Set();
        n.add(t);
        const i = this._elementToMarkerNames.get(t) || new Set();
        i.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, i);
      }
      unbindElementFromMarkerName(t, e) {
        const n = this._markerNameToElements.get(e);
        n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));
        const i = this._elementToMarkerNames.get(t);
        i && (i.delete(e), 0 == i.size && this._elementToMarkerNames.delete(t));
      }
      flushUnboundMarkerNames() {
        const t = Array.from(this._unboundMarkerNames);
        return this._unboundMarkerNames.clear(), t;
      }
      flushDeferredBindings() {
        for (const [t, e] of this._deferredBindingRemovals) t.root == e && this.unbindViewElement(t);
        this._deferredBindingRemovals = new Map();
      }
      clearBindings() {
        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this._deferredBindingRemovals = new Map();
      }
      toModelElement(t) {
        return this._viewToModelMapping.get(t);
      }
      toViewElement(t) {
        return this._modelToViewMapping.get(t);
      }
      toModelRange(t) {
        return new hc(this.toModelPosition(t.start), this.toModelPosition(t.end));
      }
      toViewRange(t) {
        return new $s(this.toViewPosition(t.start), this.toViewPosition(t.end));
      }
      toModelPosition(t) {
        const e = {
          viewPosition: t,
          mapper: this
        };
        return this.fire("viewToModelPosition", e), e.modelPosition;
      }
      toViewPosition(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = {
          modelPosition: t,
          mapper: this,
          isPhantom: e.isPhantom
        };
        return this.fire("modelToViewPosition", n), n.viewPosition;
      }
      markerNameToElements(t) {
        const e = this._markerNameToElements.get(t);
        if (!e) return null;
        const n = new Set();
        for (const t of e) if (t.is("attributeElement")) for (const e of t.getElementsWithSameId()) n.add(e);else n.add(t);
        return n;
      }
      registerViewToModelLength(t, e) {
        this._viewToModelLengthCallbacks.set(t, e);
      }
      findMappedViewAncestor(t) {
        let e = t.parent;
        for (; !this._viewToModelMapping.has(e);) e = e.parent;
        return e;
      }
      _toModelOffset(t, e, n) {
        if (n != t) {
          return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
        }
        if (t.is("$text")) return e;
        let i = 0;
        for (let n = 0; n < e; n++) i += this.getModelLength(t.getChild(n));
        return i;
      }
      getModelLength(t) {
        if (this._viewToModelLengthCallbacks.get(t.name)) {
          return this._viewToModelLengthCallbacks.get(t.name)(t);
        }
        if (this._viewToModelMapping.has(t)) return 1;
        if (t.is("$text")) return t.data.length;
        if (t.is("uiElement")) return 0;
        {
          let e = 0;
          for (const n of t.getChildren()) e += this.getModelLength(n);
          return e;
        }
      }
      findPositionIn(t, e) {
        let n,
          i = 0,
          o = 0,
          r = 0;
        if (t.is("$text")) return new Ws(t, e);
        for (; o < e;) n = t.getChild(r), i = this.getModelLength(n), o += i, r++;
        return o == e ? this._moveViewPositionToTextNode(new Ws(t, r)) : this.findPositionIn(n, e - (o - i));
      }
      _moveViewPositionToTextNode(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        return e instanceof ns ? new Ws(e, e.data.length) : n instanceof ns ? new Ws(n, 0) : t;
      }
    }
    class gc {
      constructor() {
        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }
      add(t, e) {
        e = pc(e), t instanceof nc && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
      }
      consume(t, e) {
        return e = pc(e), t instanceof nc && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
      }
      test(t, e) {
        e = pc(e), t instanceof nc && (t = this._getSymbolForTextProxy(t));
        const n = this._consumable.get(t);
        if (void 0 === n) return null;
        const i = n.get(e);
        return void 0 === i ? null : i;
      }
      revert(t, e) {
        e = pc(e), t instanceof nc && (t = this._getSymbolForTextProxy(t));
        const n = this.test(t, e);
        return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
      }
      verifyAllConsumed(t) {
        const e = [];
        for (const [n, i] of this._consumable) for (const [o, r] of i) {
          const i = o.split(":")[0];
          r && t == i && e.push({
            event: o,
            item: n.name || n.description
          });
        }
        if (e.length) throw new b("conversion-model-consumable-not-consumed", null, {
          items: e
        });
      }
      _getSymbolForTextProxy(t) {
        let e = null;
        const n = this._textProxyRegistry.get(t.startOffset);
        if (n) {
          const i = n.get(t.endOffset);
          i && (e = i.get(t.parent));
        }
        return e || (e = this._addSymbolForTextProxy(t)), e;
      }
      _addSymbolForTextProxy(t) {
        const e = t.startOffset,
          n = t.endOffset,
          i = t.parent,
          o = Symbol("$textProxy:" + t.data);
        let r, s;
        return r = this._textProxyRegistry.get(e), r || (r = new Map(), this._textProxyRegistry.set(e, r)), s = r.get(n), s || (s = new Map(), r.set(n, s)), s.set(i, o), o;
      }
    }
    function pc(t) {
      const e = t.split(":");
      return "insert" == e[0] ? e[0] : "addMarker" == e[0] || "removeMarker" == e[0] ? t : e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }
    class fc extends B() {
      constructor(t) {
        super(), this._conversionApi = {
          dispatcher: this,
          ...t
        }, this._firedEventsMap = new WeakMap();
      }
      convertChanges(t, e, n) {
        const i = this._createConversionApi(n, t.getRefreshedItems());
        for (const e of t.getMarkersToRemove()) this._convertMarkerRemove(e.name, e.range, i);
        const o = this._reduceChanges(t.getChanges());
        for (const t of o) "insert" === t.type ? this._convertInsert(hc._createFromPositionAndShift(t.position, t.length), i) : "reinsert" === t.type ? this._convertReinsert(hc._createFromPositionAndShift(t.position, t.length), i) : "remove" === t.type ? this._convertRemove(t.position, t.length, t.name, i) : this._convertAttribute(t.range, t.attributeKey, t.attributeOldValue, t.attributeNewValue, i);
        i.mapper.flushDeferredBindings();
        for (const t of i.mapper.flushUnboundMarkerNames()) {
          const n = e.get(t).getRange();
          this._convertMarkerRemove(t, n, i), this._convertMarkerAdd(t, n, i);
        }
        for (const e of t.getMarkersToAdd()) this._convertMarkerAdd(e.name, e.range, i);
        i.consumable.verifyAllConsumed("insert");
      }
      convert(t, e, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = this._createConversionApi(n, void 0, i);
        this._convertInsert(t, o);
        for (const [t, n] of e) this._convertMarkerAdd(t, n, o);
        o.consumable.verifyAllConsumed("insert");
      }
      convertSelection(t, e, n) {
        const i = this._createConversionApi(n);
        this.fire("cleanSelection", {
          selection: t
        }, i);
        const o = t.getFirstPosition().root;
        if (!i.mapper.toViewElement(o)) return;
        const r = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
        if (this._addConsumablesForSelection(i.consumable, t, r), this.fire("selection", {
          selection: t
        }, i), t.isCollapsed) {
          for (const e of r) if (i.consumable.test(t, "addMarker:" + e.name)) {
            const n = e.getRange();
            if (!kc(t.getFirstPosition(), e, i.mapper)) continue;
            const o = {
              item: t,
              markerName: e.name,
              markerRange: n
            };
            this.fire(`addMarker:${e.name}`, o, i);
          }
          for (const e of t.getAttributeKeys()) if (i.consumable.test(t, "attribute:" + e)) {
            const n = {
              item: t,
              range: t.getFirstRange(),
              attributeKey: e,
              attributeOldValue: null,
              attributeNewValue: t.getAttribute(e)
            };
            this.fire(`attribute:${e}:$text`, n, i);
          }
        }
      }
      _convertInsert(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        n.doNotAddConsumables || this._addConsumablesForInsert(e.consumable, t);
        for (const n of Array.from(t.getWalker({
          shallow: !0
        })).map(bc)) this._testAndFire("insert", n, e);
      }
      _convertRemove(t, e, n, i) {
        this.fire(`remove:${n}`, {
          position: t,
          length: e
        }, i);
      }
      _convertAttribute(t, e, n, i, o) {
        this._addConsumablesForRange(o.consumable, t, `attribute:${e}`);
        for (const r of t) {
          const t = {
            item: r.item,
            range: hc._createFromPositionAndShift(r.previousPosition, r.length),
            attributeKey: e,
            attributeOldValue: n,
            attributeNewValue: i
          };
          this._testAndFire(`attribute:${e}`, t, o);
        }
      }
      _convertReinsert(t, e) {
        const n = Array.from(t.getWalker({
          shallow: !0
        }));
        this._addConsumablesForInsert(e.consumable, n);
        for (const t of n.map(bc)) this._testAndFire("insert", {
          ...t,
          reconversion: !0
        }, e);
      }
      _convertMarkerAdd(t, e, n) {
        if ("$graveyard" == e.root.rootName) return;
        const i = `addMarker:${t}`;
        if (n.consumable.add(e, i), this.fire(i, {
          markerName: t,
          markerRange: e
        }, n), n.consumable.consume(e, i)) {
          this._addConsumablesForRange(n.consumable, e, i);
          for (const o of e.getItems()) {
            if (!n.consumable.test(o, i)) continue;
            const r = {
              item: o,
              range: hc._createOn(o),
              markerName: t,
              markerRange: e
            };
            this.fire(i, r, n);
          }
        }
      }
      _convertMarkerRemove(t, e, n) {
        "$graveyard" != e.root.rootName && this.fire(`removeMarker:${t}`, {
          markerName: t,
          markerRange: e
        }, n);
      }
      _reduceChanges(t) {
        const e = {
          changes: t
        };
        return this.fire("reduceChanges", e), e.changes;
      }
      _addConsumablesForInsert(t, e) {
        for (const n of e) {
          const e = n.item;
          if (null === t.test(e, "insert")) {
            t.add(e, "insert");
            for (const n of e.getAttributeKeys()) t.add(e, "attribute:" + n);
          }
        }
        return t;
      }
      _addConsumablesForRange(t, e, n) {
        for (const i of e.getItems()) t.add(i, n);
        return t;
      }
      _addConsumablesForSelection(t, e, n) {
        t.add(e, "selection");
        for (const i of n) t.add(e, "addMarker:" + i.name);
        for (const n of e.getAttributeKeys()) t.add(e, "attribute:" + n);
        return t;
      }
      _testAndFire(t, e, n) {
        const i = function (t, e) {
            const n = e.item.is("element") ? e.item.name : "$text";
            return `${t}:${n}`;
          }(t, e),
          o = e.item.is("$textProxy") ? n.consumable._getSymbolForTextProxy(e.item) : e.item,
          r = this._firedEventsMap.get(n),
          s = r.get(o);
        if (s) {
          if (s.has(i)) return;
          s.add(i);
        } else r.set(o, new Set([i]));
        this.fire(i, e, n);
      }
      _testAndFireAddAttributes(t, e) {
        const n = {
          item: t,
          range: hc._createOn(t)
        };
        for (const t of n.item.getAttributeKeys()) n.attributeKey = t, n.attributeOldValue = null, n.attributeNewValue = n.item.getAttribute(t), this._testAndFire(`attribute:${t}`, n, e);
      }
      _createConversionApi(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = {
          ...this._conversionApi,
          consumable: new gc(),
          writer: t,
          options: n,
          convertItem: t => this._convertInsert(hc._createOn(t), i),
          convertChildren: t => this._convertInsert(hc._createIn(t), i, {
            doNotAddConsumables: !0
          }),
          convertAttributes: t => this._testAndFireAddAttributes(t, i),
          canReuseView: t => !e.has(i.mapper.toModelElement(t))
        };
        return this._firedEventsMap.set(i, new Map()), i;
      }
    }
    function kc(t, e, n) {
      const i = e.getRange(),
        o = Array.from(t.getAncestors());
      o.shift(), o.reverse();
      return !o.some(t => {
        if (i.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }
    function bc(t) {
      return {
        item: t.item,
        range: hc._createFromPositionAndShift(t.previousPosition, t.length)
      };
    }
    class wc extends B(Jl) {
      constructor() {
        super(), this._lastRangeBackward = !1, this._attrs = new Map(), this._ranges = [], arguments.length && this.setTo(...arguments);
      }
      get anchor() {
        if (this._ranges.length > 0) {
          const t = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? t.end : t.start;
        }
        return null;
      }
      get focus() {
        if (this._ranges.length > 0) {
          const t = this._ranges[this._ranges.length - 1];
          return this._lastRangeBackward ? t.start : t.end;
        }
        return null;
      }
      get isCollapsed() {
        return 1 === this._ranges.length && this._ranges[0].isCollapsed;
      }
      get rangeCount() {
        return this._ranges.length;
      }
      get isBackward() {
        return !this.isCollapsed && this._lastRangeBackward;
      }
      isEqual(t) {
        if (this.rangeCount != t.rangeCount) return !1;
        if (0 === this.rangeCount) return !0;
        if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
        for (const e of this._ranges) {
          let n = !1;
          for (const i of t._ranges) if (e.isEqual(i)) {
            n = !0;
            break;
          }
          if (!n) return !1;
        }
        return !0;
      }
      *getRanges() {
        for (const t of this._ranges) yield new hc(t.start, t.end);
      }
      getFirstRange() {
        let t = null;
        for (const e of this._ranges) t && !e.start.isBefore(t.start) || (t = e);
        return t ? new hc(t.start, t.end) : null;
      }
      getLastRange() {
        let t = null;
        for (const e of this._ranges) t && !e.end.isAfter(t.end) || (t = e);
        return t ? new hc(t.start, t.end) : null;
      }
      getFirstPosition() {
        const t = this.getFirstRange();
        return t ? t.start.clone() : null;
      }
      getLastPosition() {
        const t = this.getLastRange();
        return t ? t.end.clone() : null;
      }
      setTo() {
        for (var _len24 = arguments.length, t = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
          t[_key24] = arguments[_key24];
        }
        let [e, n, i] = t;
        if ("object" == typeof n && (i = n, n = void 0), null === e) this._setRanges([]);else if (e instanceof wc) this._setRanges(e.getRanges(), e.isBackward);else if (e && "function" == typeof e.getRanges) this._setRanges(e.getRanges(), e.isBackward);else if (e instanceof hc) this._setRanges([e], !!i && !!i.backward);else if (e instanceof sc) this._setRanges([new hc(e)]);else if (e instanceof Xl) {
          const t = !!i && !!i.backward;
          let o;
          if ("in" == n) o = hc._createIn(e);else if ("on" == n) o = hc._createOn(e);else {
            if (void 0 === n) throw new b("model-selection-setto-required-second-parameter", [this, e]);
            o = new hc(sc._createAt(e, n));
          }
          this._setRanges([o], t);
        } else {
          if (!X(e)) throw new b("model-selection-setto-not-selectable", [this, e]);
          this._setRanges(e, i && !!i.backward);
        }
      }
      _setRanges(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = Array.from(t),
          i = n.some(e => {
            if (!(e instanceof hc)) throw new b("model-selection-set-ranges-not-range", [this, t]);
            return this._ranges.every(t => !t.isEqual(e));
          });
        (n.length !== this._ranges.length || i) && (this._replaceAllRanges(n), this._lastRangeBackward = !!e, this.fire("change:range", {
          directChange: !0
        }));
      }
      setFocus(t, e) {
        if (null === this.anchor) throw new b("model-selection-setfocus-no-ranges", [this, t]);
        const n = sc._createAt(t, e);
        if ("same" == n.compareWith(this.focus)) return;
        const i = this.anchor;
        this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new hc(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new hc(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
          directChange: !0
        });
      }
      getAttribute(t) {
        return this._attrs.get(t);
      }
      getAttributes() {
        return this._attrs.entries();
      }
      getAttributeKeys() {
        return this._attrs.keys();
      }
      hasAttribute(t) {
        return this._attrs.has(t);
      }
      removeAttribute(t) {
        this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
          attributeKeys: [t],
          directChange: !0
        }));
      }
      setAttribute(t, e) {
        this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
          attributeKeys: [t],
          directChange: !0
        }));
      }
      getSelectedElement() {
        return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
      }
      *getSelectedBlocks() {
        const t = new WeakSet();
        for (const e of this.getRanges()) {
          const n = _c(e.start, t);
          yc(n, e) && (yield n);
          for (const n of e.getWalker()) {
            const i = n.item;
            "elementEnd" == n.type && Cc(i, t, e) && (yield i);
          }
          const i = _c(e.end, t);
          xc(i, e) && (yield i);
        }
      }
      containsEntireContent() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
        const e = sc._createAt(t, 0),
          n = sc._createAt(t, "end");
        return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
      }
      _pushRange(t) {
        this._checkRange(t), this._ranges.push(new hc(t.start, t.end));
      }
      _checkRange(t) {
        for (let e = 0; e < this._ranges.length; e++) if (t.isIntersecting(this._ranges[e])) throw new b("model-selection-range-intersects", [this, t], {
          addedRange: t,
          intersectingRange: this._ranges[e]
        });
      }
      _replaceAllRanges(t) {
        this._removeAllRanges();
        for (const e of t) this._pushRange(e);
      }
      _removeAllRanges() {
        for (; this._ranges.length > 0;) this._popRange();
      }
      _popRange() {
        this._ranges.pop();
      }
    }
    function Ac(t, e) {
      return !e.has(t) && (e.add(t), t.root.document.model.schema.isBlock(t) && !!t.parent);
    }
    function Cc(t, e, n) {
      return Ac(t, e) && vc(t, n);
    }
    function _c(t, e) {
      const n = t.parent.root.document.model.schema,
        i = t.parent.getAncestors({
          parentFirst: !0,
          includeSelf: !0
        });
      let o = !1;
      const r = i.find(t => !o && (o = n.isLimit(t), !o && Ac(t, e)));
      return i.forEach(t => e.add(t)), r;
    }
    function vc(t, e) {
      const n = function (t) {
        const e = t.root.document.model.schema;
        let n = t.parent;
        for (; n;) {
          if (e.isBlock(n)) return n;
          n = n.parent;
        }
      }(t);
      if (!n) return !0;
      return !e.containsRange(hc._createOn(n), !0);
    }
    function yc(t, e) {
      return !!t && (!(!e.isCollapsed && !t.isEmpty) || !e.start.isTouching(sc._createAt(t, t.maxOffset)) && vc(t, e));
    }
    function xc(t, e) {
      return !!t && (!(!e.isCollapsed && !t.isEmpty) || !e.end.isTouching(sc._createAt(t, 0)) && vc(t, e));
    }
    wc.prototype.is = function (t) {
      return "selection" === t || "model:selection" === t;
    };
    class Ec extends B(hc) {
      constructor(t, e) {
        super(t, e), Dc.call(this);
      }
      detach() {
        this.stopListening();
      }
      toRange() {
        return new hc(this.start, this.end);
      }
      static fromRange(t) {
        return new Ec(t.start, t.end);
      }
    }
    function Dc() {
      this.listenTo(this.root.document.model, "applyOperation", (t, e) => {
        const n = e[0];
        n.isDocumentOperation && Bc.call(this, n);
      }, {
        priority: "low"
      });
    }
    function Bc(t) {
      const e = this.getTransformedByOperation(t),
        n = hc._createFromRanges(e),
        i = !n.isEqual(this),
        o = function (t, e) {
          switch (e.type) {
            case "insert":
              return t.containsPosition(e.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
            case "split":
              return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
          }
          return !1;
        }(this, t);
      let r = null;
      if (i) {
        "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);
        const e = this.toRange();
        this.start = n.start, this.end = n.end, this.fire("change:range", e, {
          deletionPosition: r
        });
      } else o && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }
    Ec.prototype.is = function (t) {
      return "liveRange" === t || "model:liveRange" === t || "range" == t || "model:range" === t;
    };
    const Sc = "selection:";
    class Tc extends B(Jl) {
      constructor(t) {
        super(), this._selection = new Ic(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
      }
      get isCollapsed() {
        return this._selection.isCollapsed;
      }
      get anchor() {
        return this._selection.anchor;
      }
      get focus() {
        return this._selection.focus;
      }
      get rangeCount() {
        return this._selection.rangeCount;
      }
      get hasOwnRange() {
        return this._selection.hasOwnRange;
      }
      get isBackward() {
        return this._selection.isBackward;
      }
      get isGravityOverridden() {
        return this._selection.isGravityOverridden;
      }
      get markers() {
        return this._selection.markers;
      }
      get _ranges() {
        return this._selection._ranges;
      }
      getRanges() {
        return this._selection.getRanges();
      }
      getFirstPosition() {
        return this._selection.getFirstPosition();
      }
      getLastPosition() {
        return this._selection.getLastPosition();
      }
      getFirstRange() {
        return this._selection.getFirstRange();
      }
      getLastRange() {
        return this._selection.getLastRange();
      }
      getSelectedBlocks() {
        return this._selection.getSelectedBlocks();
      }
      getSelectedElement() {
        return this._selection.getSelectedElement();
      }
      containsEntireContent(t) {
        return this._selection.containsEntireContent(t);
      }
      destroy() {
        this._selection.destroy();
      }
      getAttributeKeys() {
        return this._selection.getAttributeKeys();
      }
      getAttributes() {
        return this._selection.getAttributes();
      }
      getAttribute(t) {
        return this._selection.getAttribute(t);
      }
      hasAttribute(t) {
        return this._selection.hasAttribute(t);
      }
      refresh() {
        this._selection.updateMarkers(), this._selection._updateAttributes(!1);
      }
      observeMarkers(t) {
        this._selection.observeMarkers(t);
      }
      _setFocus(t, e) {
        this._selection.setFocus(t, e);
      }
      _setTo() {
        this._selection.setTo(...arguments);
      }
      _setAttribute(t, e) {
        this._selection.setAttribute(t, e);
      }
      _removeAttribute(t) {
        this._selection.removeAttribute(t);
      }
      _getStoredAttributes() {
        return this._selection.getStoredAttributes();
      }
      _overrideGravity() {
        return this._selection.overrideGravity();
      }
      _restoreGravity(t) {
        this._selection.restoreGravity(t);
      }
      static _getStoreAttributeKey(t) {
        return Sc + t;
      }
      static _isStoreAttributeKey(t) {
        return t.startsWith(Sc);
      }
    }
    Tc.prototype.is = function (t) {
      return "selection" === t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
    };
    class Ic extends wc {
      constructor(t) {
        super(), this.markers = new Wo({
          idProperty: "name"
        }), this._attributePriority = new Map(), this._selectionRestorePosition = null, this._hasChangedRange = !1, this._overriddenGravityRegister = new Set(), this._observedMarkers = new Set(), this._model = t.model, this._document = t, this.listenTo(this._model, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type && (0 == this._ranges.length && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", {
            directChange: !1
          })));
        }, {
          priority: "lowest"
        }), this.on("change:range", () => {
          this._validateSelectionRanges(this.getRanges());
        }), this.listenTo(this._model.markers, "update", (t, e, n, i) => {
          this._updateMarker(e, i);
        }), this.listenTo(this._document, "change", (t, e) => {
          !function (t, e) {
            const n = t.document.differ;
            for (const i of n.getChanges()) {
              if ("insert" != i.type) continue;
              const n = i.position.parent;
              i.length === n.maxOffset && t.enqueueChange(e, t => {
                const e = Array.from(n.getAttributeKeys()).filter(t => t.startsWith(Sc));
                for (const i of e) t.removeAttribute(i, n);
              });
            }
          }(this._model, e);
        });
      }
      get isCollapsed() {
        return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
      }
      get anchor() {
        return super.anchor || this._document._getDefaultRange().start;
      }
      get focus() {
        return super.focus || this._document._getDefaultRange().end;
      }
      get rangeCount() {
        return this._ranges.length ? this._ranges.length : 1;
      }
      get hasOwnRange() {
        return this._ranges.length > 0;
      }
      get isGravityOverridden() {
        return !!this._overriddenGravityRegister.size;
      }
      destroy() {
        for (let t = 0; t < this._ranges.length; t++) this._ranges[t].detach();
        this.stopListening();
      }
      *getRanges() {
        this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
      }
      getFirstRange() {
        return super.getFirstRange() || this._document._getDefaultRange();
      }
      getLastRange() {
        return super.getLastRange() || this._document._getDefaultRange();
      }
      setTo() {
        super.setTo(...arguments), this._updateAttributes(!0), this.updateMarkers();
      }
      setFocus(t, e) {
        super.setFocus(t, e), this._updateAttributes(!0), this.updateMarkers();
      }
      setAttribute(t, e) {
        if (this._setAttribute(t, e)) {
          const e = [t];
          this.fire("change:attribute", {
            attributeKeys: e,
            directChange: !0
          });
        }
      }
      removeAttribute(t) {
        if (this._removeAttribute(t)) {
          const e = [t];
          this.fire("change:attribute", {
            attributeKeys: e,
            directChange: !0
          });
        }
      }
      overrideGravity() {
        const t = p();
        return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
      }
      restoreGravity(t) {
        if (!this._overriddenGravityRegister.has(t)) throw new b("document-selection-gravity-wrong-restore", this, {
          uid: t
        });
        this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
      }
      observeMarkers(t) {
        this._observedMarkers.add(t), this.updateMarkers();
      }
      _replaceAllRanges(t) {
        this._validateSelectionRanges(t), super._replaceAllRanges(t);
      }
      _popRange() {
        this._ranges.pop().detach();
      }
      _pushRange(t) {
        const e = this._prepareRange(t);
        e && this._ranges.push(e);
      }
      _validateSelectionRanges(t) {
        for (const e of t) if (!this._document._validateSelectionRange(e)) throw new b("document-selection-wrong-position", this, {
          range: e
        });
      }
      _prepareRange(t) {
        if (this._checkRange(t), t.root == this._document.graveyard) return;
        const e = Ec.fromRange(t);
        return e.on("change:range", (t, n, i) => {
          if (this._hasChangedRange = !0, e.root == this._document.graveyard) {
            this._selectionRestorePosition = i.deletionPosition;
            const t = this._ranges.indexOf(e);
            this._ranges.splice(t, 1), e.detach();
          }
        }), e;
      }
      updateMarkers() {
        if (!this._observedMarkers.size) return;
        const t = [];
        let e = !1;
        for (const e of this._model.markers) {
          const n = e.name.split(":", 1)[0];
          if (!this._observedMarkers.has(n)) continue;
          const i = e.getRange();
          for (const n of this.getRanges()) i.containsRange(n, !n.isCollapsed) && t.push(e);
        }
        const n = Array.from(this.markers);
        for (const n of t) this.markers.has(n) || (this.markers.add(n), e = !0);
        for (const n of Array.from(this.markers)) t.includes(n) || (this.markers.remove(n), e = !0);
        e && this.fire("change:marker", {
          oldMarkers: n,
          directChange: !1
        });
      }
      _updateMarker(t, e) {
        const n = t.name.split(":", 1)[0];
        if (!this._observedMarkers.has(n)) return;
        let i = !1;
        const o = Array.from(this.markers),
          r = this.markers.has(t);
        if (e) {
          let n = !1;
          for (const t of this.getRanges()) if (e.containsRange(t, !t.isCollapsed)) {
            n = !0;
            break;
          }
          n && !r ? (this.markers.add(t), i = !0) : !n && r && (this.markers.remove(t), i = !0);
        } else r && (this.markers.remove(t), i = !0);
        i && this.fire("change:marker", {
          oldMarkers: o,
          directChange: !1
        });
      }
      _updateAttributes(t) {
        const e = Qo(this._getSurroundingAttributes()),
          n = Qo(this.getAttributes());
        if (t) this._attributePriority = new Map(), this._attrs = new Map();else for (const [t, e] of this._attributePriority) "low" == e && (this._attrs.delete(t), this._attributePriority.delete(t));
        this._setAttributesTo(e);
        const i = [];
        for (const [t, e] of this.getAttributes()) n.has(t) && n.get(t) === e || i.push(t);
        for (const [t] of n) this.hasAttribute(t) || i.push(t);
        i.length > 0 && this.fire("change:attribute", {
          attributeKeys: i,
          directChange: !1
        });
      }
      _setAttribute(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        const i = n ? "normal" : "low";
        if ("low" == i && "normal" == this._attributePriority.get(t)) return !1;
        return super.getAttribute(t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, i), !0);
      }
      _removeAttribute(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        const n = e ? "normal" : "low";
        return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!super.hasAttribute(t) && (this._attrs.delete(t), !0));
      }
      _setAttributesTo(t) {
        const e = new Set();
        for (const [e, n] of this.getAttributes()) t.get(e) !== n && this._removeAttribute(e, !1);
        for (const [n, i] of t) {
          this._setAttribute(n, i, !1) && e.add(n);
        }
        return e;
      }
      *getStoredAttributes() {
        const t = this.getFirstPosition().parent;
        if (this.isCollapsed && t.isEmpty) for (const e of t.getAttributeKeys()) if (e.startsWith(Sc)) {
          const n = e.substr(10);
          yield [n, t.getAttribute(e)];
        }
      }
      _getSurroundingAttributes() {
        const t = this.getFirstPosition(),
          e = this._model.schema;
        if ("$graveyard" == t.root.rootName) return null;
        let n = null;
        if (this.isCollapsed) {
          const i = t.textNode ? t.textNode : t.nodeBefore,
            o = t.textNode ? t.textNode : t.nodeAfter;
          if (this.isGravityOverridden || (n = Mc(i, e)), n || (n = Mc(o, e)), !this.isGravityOverridden && !n) {
            let t = i;
            for (; t && !n;) t = t.previousSibling, n = Mc(t, e);
          }
          if (!n) {
            let t = o;
            for (; t && !n;) t = t.nextSibling, n = Mc(t, e);
          }
          n || (n = this.getStoredAttributes());
        } else {
          const t = this.getFirstRange();
          for (const i of t) {
            if (i.item.is("element") && e.isObject(i.item)) {
              n = Mc(i.item, e);
              break;
            }
            if ("text" == i.type) {
              n = i.item.getAttributes();
              break;
            }
          }
        }
        return n;
      }
      _fixGraveyardSelection(t) {
        const e = this._model.schema.getNearestSelectionRange(t);
        e && this._pushRange(e);
      }
    }
    function Mc(t, e) {
      if (!t) return null;
      if (t instanceof nc || t instanceof ec) return t.getAttributes();
      if (!e.isInline(t)) return null;
      if (!e.isObject(t)) return [];
      const n = [];
      for (const [i, o] of t.getAttributes()) e.checkAttribute("$text", i) && !1 !== e.getAttributeProperties(i).copyFromObject && n.push([i, o]);
      return n;
    }
    class Lc {
      constructor(t) {
        this._dispatchers = t;
      }
      add(t) {
        for (const e of this._dispatchers) t(e);
        return this;
      }
    }
    class Nc extends Lc {
      elementToElement(t) {
        return this.add(function (t) {
          const e = Oc(t.model),
            n = jc(t.view, "container");
          e.attributes.length && (e.children = !0);
          return i => {
            i.on(`insert:${e.name}`, Vc(n, Wc(e)), {
              priority: t.converterPriority || "normal"
            }), (e.children || e.attributes.length) && i.on("reduceChanges", Gc(e), {
              priority: "low"
            });
          };
        }(t));
      }
      elementToStructure(t) {
        return this.add(function (t) {
          const e = Oc(t.model),
            n = jc(t.view, "container");
          return e.children = !0, i => {
            if (i._conversionApi.schema.checkChild(e.name, "$text")) throw new b("conversion-element-to-structure-disallowed-text", i, {
              elementName: e.name
            });
            var o, r;
            i.on(`insert:${e.name}`, (o = n, r = Wc(e), (t, e, n) => {
              if (!r(e.item, n.consumable, {
                preflight: !0
              })) return;
              const i = new Map();
              n.writer._registerSlotFactory(function (t, e, n) {
                return (i, o) => {
                  const r = i.createContainerElement("$slot");
                  let s = null;
                  if ("children" === o) s = Array.from(t.getChildren());else {
                    if ("function" != typeof o) throw new b("conversion-slot-mode-unknown", n.dispatcher, {
                      modeOrFilter: o
                    });
                    s = Array.from(t.getChildren()).filter(t => o(t));
                  }
                  return e.set(r, s), r;
                };
              }(e.item, i, n));
              const s = o(e.item, n, e);
              if (n.writer._clearSlotFactory(), !s) return;
              !function (t, e, n) {
                const i = Array.from(e.values()).flat(),
                  o = new Set(i);
                if (o.size != i.length) throw new b("conversion-slot-filter-overlap", n.dispatcher, {
                  element: t
                });
                if (o.size != t.childCount) throw new b("conversion-slot-filter-incomplete", n.dispatcher, {
                  element: t
                });
              }(e.item, i, n), r(e.item, n.consumable);
              const a = n.mapper.toViewPosition(e.range.start);
              n.mapper.bindElements(e.item, s), n.writer.insert(a, s), n.convertAttributes(e.item), function (t, e, n, i) {
                n.mapper.on("modelToViewPosition", s, {
                  priority: "highest"
                });
                let o = null,
                  r = null;
                for ([o, r] of e) $c(t, r, n, i), n.writer.move(n.writer.createRangeIn(o), n.writer.createPositionBefore(o)), n.writer.remove(o);
                function s(t, e) {
                  const n = e.modelPosition.nodeAfter,
                    i = r.indexOf(n);
                  i < 0 || (e.viewPosition = e.mapper.findPositionIn(o, i));
                }
                n.mapper.off("modelToViewPosition", s);
              }(s, i, n, {
                reconversion: e.reconversion
              });
            }), {
              priority: t.converterPriority || "normal"
            }), i.on("reduceChanges", Gc(e), {
              priority: "low"
            });
          };
        }(t));
      }
      attributeToElement(t) {
        return this.add(function (t) {
          t = Ql(t);
          let e = t.model;
          "string" == typeof e && (e = {
            key: e
          });
          let n = `attribute:${e.key}`;
          e.name && (n += ":" + e.name);
          if (e.values) for (const n of e.values) t.view[n] = jc(t.view[n], "attribute");else t.view = jc(t.view, "attribute");
          const i = Hc(t);
          return e => {
            e.on(n, Pc(i), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      attributeToAttribute(t) {
        return this.add(function (t) {
          t = Ql(t);
          let e = t.model;
          "string" == typeof e && (e = {
            key: e
          });
          let n = `attribute:${e.key}`;
          e.name && (n += ":" + e.name);
          if (e.values) for (const n of e.values) t.view[n] = Uc(t.view[n]);else t.view = Uc(t.view);
          const i = Hc(t);
          return e => {
            var o;
            e.on(n, (o = i, (t, e, n) => {
              if (!n.consumable.test(e.item, t.name)) return;
              const i = o(e.attributeOldValue, n, e),
                r = o(e.attributeNewValue, n, e);
              if (!i && !r) return;
              n.consumable.consume(e.item, t.name);
              const s = n.mapper.toViewElement(e.item),
                a = n.writer;
              if (!s) throw new b("conversion-attribute-to-attribute-on-text", n.dispatcher, e);
              if (null !== e.attributeOldValue && i) if ("class" == i.key) {
                const t = "string" == typeof i.value ? i.value.split(/\s+/) : i.value;
                for (const e of t) a.removeClass(e, s);
              } else if ("style" == i.key) {
                if ("string" == typeof i.value) {
                  const t = new Ns(a.document.stylesProcessor);
                  t.setTo(i.value);
                  for (const [e] of t.getStylesEntries()) a.removeStyle(e, s);
                } else {
                  const t = Object.keys(i.value);
                  for (const e of t) a.removeStyle(e, s);
                }
              } else a.removeAttribute(i.key, s);
              if (null !== e.attributeNewValue && r) if ("class" == r.key) {
                const t = "string" == typeof r.value ? r.value.split(/\s+/) : r.value;
                for (const e of t) a.addClass(e, s);
              } else if ("style" == r.key) {
                if ("string" == typeof r.value) {
                  const t = new Ns(a.document.stylesProcessor);
                  t.setTo(r.value);
                  for (const [e, n] of t.getStylesEntries()) a.setStyle(e, n, s);
                } else {
                  const t = Object.keys(r.value);
                  for (const e of t) a.setStyle(e, r.value[e], s);
                }
              } else a.setAttribute(r.key, r.value, s);
            }), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToElement(t) {
        return this.add(function (t) {
          const e = jc(t.view, "ui");
          return n => {
            n.on(`addMarker:${t.model}`, Rc(e), {
              priority: t.converterPriority || "normal"
            }), n.on(`removeMarker:${t.model}`, (t, e, n) => {
              const i = n.mapper.markerNameToElements(e.markerName);
              if (i) {
                for (const t of i) n.mapper.unbindElementFromMarkerName(t, e.markerName), n.writer.clear(n.writer.createRangeOn(t), t);
                n.writer.clearClonedElementsGroup(e.markerName), t.stop();
              }
            }, {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToHighlight(t) {
        return this.add(function (t) {
          return e => {
            var n;
            e.on(`addMarker:${t.model}`, (n = t.view, (t, e, i) => {
              if (!e.item) return;
              if (!(e.item instanceof wc || e.item instanceof Tc || e.item.is("$textProxy"))) return;
              const o = qc(n, e, i);
              if (!o) return;
              if (!i.consumable.consume(e.item, t.name)) return;
              const r = i.writer,
                s = zc(r, o),
                a = r.document.selection;
              if (e.item instanceof wc || e.item instanceof Tc) r.wrap(a.getFirstRange(), s);else {
                const t = i.mapper.toViewRange(e.range),
                  n = r.wrap(t, s);
                for (const t of n.getItems()) if (t.is("attributeElement") && t.isSimilar(s)) {
                  i.mapper.bindElementToMarker(t, e.markerName);
                  break;
                }
              }
            }), {
              priority: t.converterPriority || "normal"
            }), e.on(`addMarker:${t.model}`, function (t) {
              return (e, n, i) => {
                if (!n.item) return;
                if (!(n.item instanceof ic)) return;
                const o = qc(t, n, i);
                if (!o) return;
                if (!i.consumable.test(n.item, e.name)) return;
                const r = i.mapper.toViewElement(n.item);
                if (r && r.getCustomProperty("addHighlight")) {
                  i.consumable.consume(n.item, e.name);
                  for (const t of hc._createIn(n.item)) i.consumable.consume(t.item, e.name);
                  r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                }
              };
            }(t.view), {
              priority: t.converterPriority || "normal"
            }), e.on(`removeMarker:${t.model}`, function (t) {
              return (e, n, i) => {
                if (n.markerRange.isCollapsed) return;
                const o = qc(t, n, i);
                if (!o) return;
                const r = zc(i.writer, o),
                  s = i.mapper.markerNameToElements(n.markerName);
                if (s) {
                  for (const t of s) if (i.mapper.unbindElementFromMarkerName(t, n.markerName), t.is("attributeElement")) i.writer.unwrap(i.writer.createRangeOn(t), r);else {
                    t.getCustomProperty("removeHighlight")(t, o.id, i.writer);
                  }
                  i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                }
              };
            }(t.view), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
      markerToData(t) {
        return this.add(function (t) {
          t = Ql(t);
          const e = t.model;
          let n = t.view;
          n || (n = n => ({
            group: e,
            name: n.substr(t.model.length + 1)
          }));
          return i => {
            var o;
            i.on(`addMarker:${e}`, (o = n, (t, e, n) => {
              const i = o(e.markerName, n);
              if (!i) return;
              const r = e.markerRange;
              n.consumable.consume(r, t.name) && (Fc(r, !1, n, e, i), Fc(r, !0, n, e, i), t.stop());
            }), {
              priority: t.converterPriority || "normal"
            }), i.on(`removeMarker:${e}`, function (t) {
              return (e, n, i) => {
                const o = t(n.markerName, i);
                if (!o) return;
                const r = i.mapper.markerNameToElements(n.markerName);
                if (r) {
                  for (const t of r) i.mapper.unbindElementFromMarkerName(t, n.markerName), t.is("containerElement") ? (s(`data-${o.group}-start-before`, t), s(`data-${o.group}-start-after`, t), s(`data-${o.group}-end-before`, t), s(`data-${o.group}-end-after`, t)) : i.writer.clear(i.writer.createRangeOn(t), t);
                  i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                }
                function s(t, e) {
                  if (e.hasAttribute(t)) {
                    const n = new Set(e.getAttribute(t).split(","));
                    n.delete(o.name), 0 == n.size ? i.writer.removeAttribute(t, e) : i.writer.setAttribute(t, Array.from(n).join(","), e);
                  }
                }
              };
            }(n), {
              priority: t.converterPriority || "normal"
            });
          };
        }(t));
      }
    }
    function zc(t, e) {
      const n = t.createAttributeElement("span", e.attributes);
      return e.classes && n._addClass(e.classes), "number" == typeof e.priority && (n._priority = e.priority), n._id = e.id, n;
    }
    function Pc(t) {
      return (e, n, i) => {
        if (!i.consumable.test(n.item, e.name)) return;
        const o = t(n.attributeOldValue, i, n),
          r = t(n.attributeNewValue, i, n);
        if (!o && !r) return;
        i.consumable.consume(n.item, e.name);
        const s = i.writer,
          a = s.document.selection;
        if (n.item instanceof wc || n.item instanceof Tc) s.wrap(a.getFirstRange(), r);else {
          let t = i.mapper.toViewRange(n.range);
          null !== n.attributeOldValue && o && (t = s.unwrap(t, o)), null !== n.attributeNewValue && r && s.wrap(t, r);
        }
      };
    }
    function Vc(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Yc;
      return (n, i, o) => {
        if (!e(i.item, o.consumable, {
          preflight: !0
        })) return;
        const r = t(i.item, o, i);
        if (!r) return;
        e(i.item, o.consumable);
        const s = o.mapper.toViewPosition(i.range.start);
        o.mapper.bindElements(i.item, r), o.writer.insert(s, r), o.convertAttributes(i.item), $c(r, i.item.getChildren(), o, {
          reconversion: i.reconversion
        });
      };
    }
    function Rc(t) {
      return (e, n, i) => {
        n.isOpening = !0;
        const o = t(n, i);
        n.isOpening = !1;
        const r = t(n, i);
        if (!o || !r) return;
        const s = n.markerRange;
        if (s.isCollapsed && !i.consumable.consume(s, e.name)) return;
        for (const t of s) if (!i.consumable.consume(t.item, e.name)) return;
        const a = i.mapper,
          l = i.writer;
        l.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, n.markerName), s.isCollapsed || (l.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, n.markerName)), e.stop();
      };
    }
    function Fc(t, e, n, i, o) {
      const r = e ? t.start : t.end,
        s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
        a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
      if (s || a) {
        let t, r;
        e && s || !e && !a ? (t = s, r = !0) : (t = a, r = !1);
        const l = n.mapper.toViewElement(t);
        if (l) return void function (t, e, n, i, o, r) {
          const s = `data-${r.group}-${e ? "start" : "end"}-${n ? "before" : "after"}`,
            a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
          a.unshift(r.name), i.writer.setAttribute(s, a.join(","), t), i.mapper.bindElementToMarker(t, o.markerName);
        }(l, e, r, n, i, o);
      }
      !function (t, e, n, i, o) {
        const r = `${o.group}-${e ? "start" : "end"}`,
          s = o.name ? {
            name: o.name
          } : null,
          a = n.writer.createUIElement(r, s);
        n.writer.insert(t, a), n.mapper.bindElementToMarker(a, i.markerName);
      }(n.mapper.toViewPosition(r), e, n, i, o);
    }
    function Oc(t) {
      return "string" == typeof t && (t = {
        name: t
      }), {
        name: t.name,
        attributes: t.attributes ? vo(t.attributes) : [],
        children: !!t.children
      };
    }
    function jc(t, e) {
      return "function" == typeof t ? t : (n, i) => function (t, e, n) {
        "string" == typeof t && (t = {
          name: t
        });
        let i;
        const o = e.writer,
          r = Object.assign({}, t.attributes);
        if ("container" == n) i = o.createContainerElement(t.name, r);else if ("attribute" == n) {
          const e = {
            priority: t.priority || sa.DEFAULT_PRIORITY
          };
          i = o.createAttributeElement(t.name, r, e);
        } else i = o.createUIElement(t.name, r);
        if (t.styles) {
          const e = Object.keys(t.styles);
          for (const n of e) o.setStyle(n, t.styles[n], i);
        }
        if (t.classes) {
          const e = t.classes;
          if ("string" == typeof e) o.addClass(e, i);else for (const t of e) o.addClass(t, i);
        }
        return i;
      }(t, i, e);
    }
    function Hc(t) {
      return t.model.values ? (e, n, i) => {
        const o = t.view[e];
        return o ? o(e, n, i) : null;
      } : t.view;
    }
    function Uc(t) {
      return "string" == typeof t ? e => ({
        key: t,
        value: e
      }) : "object" == typeof t ? t.value ? () => t : e => ({
        key: t.key,
        value: e
      }) : t;
    }
    function qc(t, e, n) {
      const i = "function" == typeof t ? t(e, n) : t;
      return i ? (i.priority || (i.priority = 10), i.id || (i.id = e.markerName), i) : null;
    }
    function Gc(t) {
      const e = function (t) {
        return (e, n) => {
          if (!e.is("element", t.name)) return !1;
          if ("attribute" == n.type) {
            if (t.attributes.includes(n.attributeKey)) return !0;
          } else if (t.children) return !0;
          return !1;
        };
      }(t);
      return (t, n) => {
        const i = [];
        n.reconvertedElements || (n.reconvertedElements = new Set());
        for (const t of n.changes) {
          const o = "attribute" == t.type ? t.range.start.nodeAfter : t.position.parent;
          if (o && e(o, t)) {
            if (!n.reconvertedElements.has(o)) {
              n.reconvertedElements.add(o);
              const t = sc._createBefore(o);
              let e = i.length;
              for (let n = i.length - 1; n >= 0; n--) {
                const o = i[n],
                  r = ("attribute" == o.type ? o.range.start : o.position).compareWith(t);
                if ("before" == r || "remove" == o.type && "same" == r) break;
                e = n;
              }
              i.splice(e, 0, {
                type: "remove",
                name: o.name,
                position: t,
                length: 1
              }, {
                type: "reinsert",
                name: o.name,
                position: t,
                length: 1
              });
            }
          } else i.push(t);
        }
        n.changes = i;
      };
    }
    function Wc(t) {
      return function (e, n) {
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const o = ["insert"];
        for (const n of t.attributes) e.hasAttribute(n) && o.push(`attribute:${n}`);
        return !!o.every(t => n.test(e, t)) && (i.preflight || o.forEach(t => n.consume(e, t)), !0);
      };
    }
    function $c(t, e, n, i) {
      for (const o of e) Kc(t.root, o, n, i) || n.convertItem(o);
    }
    function Kc(t, e, n, i) {
      const {
        writer: o,
        mapper: r
      } = n;
      if (!i.reconversion) return !1;
      const s = r.toViewElement(e);
      return !(!s || s.root == t) && !!n.canReuseView(s) && (o.move(o.createRangeOn(s), r.toViewPosition(sc._createBefore(e))), !0);
    }
    function Yc(t, e) {
      let {
        preflight: n
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return n ? e.test(t, "insert") : e.consume(t, "insert");
    }
    function Qc(t) {
      const {
        schema: e,
        document: n
      } = t.model;
      for (const i of n.getRoots()) if (i.isEmpty && !e.checkChild(i, "$text") && e.checkChild(i, "paragraph")) return t.insertElement("paragraph", i), !0;
      return !1;
    }
    function Zc(t, e, n) {
      const i = n.createContext(t);
      return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), e);
    }
    function Jc(t, e) {
      const n = e.createElement("paragraph");
      return e.insert(n, t), e.createPositionAt(n, 0);
    }
    class Xc extends Lc {
      elementToElement(t) {
        return this.add(td(t));
      }
      elementToAttribute(t) {
        return this.add(function (t) {
          t = Ql(t), id(t);
          const e = od(t, !1),
            n = ed(t.view),
            i = n ? `element:${n}` : "element";
          return n => {
            n.on(i, e, {
              priority: t.converterPriority || "low"
            });
          };
        }(t));
      }
      attributeToAttribute(t) {
        return this.add(function (t) {
          t = Ql(t);
          let e = null;
          ("string" == typeof t.view || t.view.key) && (e = function (t) {
            "string" == typeof t.view && (t.view = {
              key: t.view
            });
            const e = t.view.key,
              n = void 0 === t.view.value ? /[\s\S]*/ : t.view.value;
            let i;
            if ("class" == e || "style" == e) {
              const t = "class" == e ? "classes" : "styles";
              i = {
                [t]: n
              };
            } else i = {
              attributes: {
                [e]: n
              }
            };
            t.view.name && (i.name = t.view.name);
            return t.view = i, e;
          }(t));
          id(t, e);
          const n = od(t, !0);
          return e => {
            e.on("element", n, {
              priority: t.converterPriority || "low"
            });
          };
        }(t));
      }
      elementToMarker(t) {
        return this.add(function (t) {
          const e = function (t) {
            return (e, n) => {
              const i = "string" == typeof t ? t : t(e, n);
              return n.writer.createElement("$marker", {
                "data-name": i
              });
            };
          }(t.model);
          return td({
            ...t,
            model: e
          });
        }(t));
      }
      dataToMarker(t) {
        return this.add(function (t) {
          t = Ql(t), t.model || (t.model = e => e ? t.view + ":" + e : t.view);
          const e = {
              view: t.view,
              model: t.model
            },
            n = nd(rd(e, "start")),
            i = nd(rd(e, "end"));
          return o => {
            o.on(`element:${t.view}-start`, n, {
              priority: t.converterPriority || "normal"
            }), o.on(`element:${t.view}-end`, i, {
              priority: t.converterPriority || "normal"
            });
            const r = f.low,
              s = f.highest,
              a = f.get(t.converterPriority) / s;
            o.on("element", function (t) {
              return (e, n, i) => {
                const o = `data-${t.view}`;
                function r(e, o) {
                  for (const r of o) {
                    const o = t.model(r, i),
                      s = i.writer.createElement("$marker", {
                        "data-name": o
                      });
                    i.writer.insert(s, e), n.modelCursor.isEqual(e) ? n.modelCursor = n.modelCursor.getShiftedBy(1) : n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1), n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
                  }
                }
                (i.consumable.test(n.viewItem, {
                  attributes: o + "-end-after"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-start-after"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-end-before"
                }) || i.consumable.test(n.viewItem, {
                  attributes: o + "-start-before"
                })) && (n.modelRange || Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor)), i.consumable.consume(n.viewItem, {
                  attributes: o + "-end-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-end-after").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-start-after"
                }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-start-after").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-end-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-end-before").split(",")), i.consumable.consume(n.viewItem, {
                  attributes: o + "-start-before"
                }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-start-before").split(",")));
              };
            }(e), {
              priority: r + a
            });
          };
        }(t));
      }
    }
    function td(t) {
      const e = nd(t = Ql(t)),
        n = ed(t.view),
        i = n ? `element:${n}` : "element";
      return n => {
        n.on(i, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function ed(t) {
      return "string" == typeof t ? t : "object" == typeof t && "string" == typeof t.name ? t.name : null;
    }
    function nd(t) {
      const e = new os(t.view);
      return (n, i, o) => {
        const r = e.match(i.viewItem);
        if (!r) return;
        const s = r.match;
        if (s.name = !0, !o.consumable.test(i.viewItem, s)) return;
        const a = function (t, e, n) {
          return t instanceof Function ? t(e, n) : n.writer.createElement(t);
        }(t.model, i.viewItem, o);
        a && o.safeInsert(a, i.modelCursor) && (o.consumable.consume(i.viewItem, s), o.convertChildren(i.viewItem, a), o.updateConversionResult(a, i));
      };
    }
    function id(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      const n = null === e || (t => t.getAttribute(e)),
        i = "object" != typeof t.model ? t.model : t.model.key,
        o = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;
      t.model = {
        key: i,
        value: o
      };
    }
    function od(t, e) {
      const n = new os(t.view);
      return (i, o, r) => {
        if (!o.modelRange && e) return;
        const s = n.match(o.viewItem);
        if (!s) return;
        if (!function (t, e) {
          const n = "function" == typeof t ? t(e) : t;
          if ("object" == typeof n && !ed(n)) return !1;
          return !n.classes && !n.attributes && !n.styles;
        }(t.view, o.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(o.viewItem, s.match)) return;
        const a = t.model.key,
          l = "function" == typeof t.model.value ? t.model.value(o.viewItem, r) : t.model.value;
        if (null === l) return;
        o.modelRange || Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor));
        const c = function (t, e, n, i) {
          let o = !1;
          for (const r of Array.from(t.getItems({
            shallow: n
          }))) i.schema.checkAttribute(r, e.key) && (o = !0, r.hasAttribute(e.key) || i.writer.setAttribute(e.key, e.value, r));
          return o;
        }(o.modelRange, {
          key: a,
          value: l
        }, e, r);
        c && (r.consumable.test(o.viewItem, {
          name: !0
        }) && (s.match.name = !0), r.consumable.consume(o.viewItem, s.match));
      };
    }
    function rd(t, e) {
      return {
        view: `${t.view}-${e}`,
        model: (e, n) => {
          const i = e.getAttribute("name"),
            o = t.model(i, n);
          return n.writer.createElement("$marker", {
            "data-name": o
          });
        }
      };
    }
    function sd(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.selection,
          i = e.schema,
          o = [];
        let r = !1;
        for (const t of n.getRanges()) {
          const e = ad(t, i);
          e && !e.isEqual(t) ? (o.push(e), r = !0) : o.push(t);
        }
        r && t.setSelection(function (t) {
          const e = [...t],
            n = new Set();
          let i = 1;
          for (; i < e.length;) {
            const t = e[i],
              o = e.slice(0, i);
            for (const [r, s] of o.entries()) if (!n.has(r)) if (t.isEqual(s)) n.add(r);else if (t.isIntersecting(s)) {
              n.add(r), n.add(i);
              const o = t.getJoined(s);
              e.push(o);
            }
            i++;
          }
          return e.filter((t, e) => !n.has(e));
        }(o), {
          backward: n.isBackward
        });
        return !1;
      }(e, t));
    }
    function ad(t, e) {
      return t.isCollapsed ? function (t, e) {
        const n = t.start,
          i = e.getNearestSelectionRange(n);
        if (!i) {
          const t = n.getAncestors().reverse().find(t => e.isObject(t));
          return t ? hc._createOn(t) : null;
        }
        if (!i.isCollapsed) return i;
        const o = i.start;
        if (n.isEqual(o)) return null;
        return new hc(o);
      }(t, e) : function (t, e) {
        const {
            start: n,
            end: i
          } = t,
          o = e.checkChild(n, "$text"),
          r = e.checkChild(i, "$text"),
          s = e.getLimitElement(n),
          a = e.getLimitElement(i);
        if (s === a) {
          if (o && r) return null;
          if (function (t, e, n) {
            const i = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
              o = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return i || o;
          }(n, i, e)) {
            const t = n.nodeAfter && e.isSelectable(n.nodeAfter) ? null : e.getNearestSelectionRange(n, "forward"),
              o = i.nodeBefore && e.isSelectable(i.nodeBefore) ? null : e.getNearestSelectionRange(i, "backward"),
              r = t ? t.start : n,
              s = o ? o.end : i;
            return new hc(r, s);
          }
        }
        const l = s && !s.is("rootElement"),
          c = a && !a.is("rootElement");
        if (l || c) {
          const t = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
            o = l && (!t || !cd(n.nodeAfter, e)),
            r = c && (!t || !cd(i.nodeBefore, e));
          let d = n,
            u = i;
          return o && (d = sc._createBefore(ld(s, e))), r && (u = sc._createAfter(ld(a, e))), new hc(d, u);
        }
        return null;
      }(t, e);
    }
    function ld(t, e) {
      let n = t,
        i = n;
      for (; e.isLimit(i) && i.parent;) n = i, i = i.parent;
      return n;
    }
    function cd(t, e) {
      return t && e.isSelectable(t);
    }
    class dd extends q() {
      constructor(t, e) {
        super(), this.model = t, this.view = new Zl(e), this.mapper = new mc(), this.downcastDispatcher = new fc({
          mapper: this.mapper,
          schema: t.schema
        });
        const n = this.model.document,
          i = n.selection,
          o = this.model.markers;
        var r, a, l;
        this.listenTo(this.model, "_beforeChanges", () => {
          this.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", () => {
          this.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(n, "change", () => {
          this.view.change(t => {
            this.downcastDispatcher.convertChanges(n.differ, o, t), this.downcastDispatcher.convertSelection(i, o, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return (n, i) => {
            const o = i.newSelection,
              r = [];
            for (const t of o.getRanges()) r.push(e.toModelRange(t));
            const s = t.createSelection(r, {
              backward: o.isBackward
            });
            s.isEqual(t.document.selection) || t.change(t => {
              t.setSelection(s);
            });
          };
        }(this.model, this.mapper)), this.listenTo(this.view.document, "beforeinput", (r = this.mapper, a = this.model.schema, l = this.view, (t, e) => {
          if (!l.document.isComposing || s.isAndroid) for (let t = 0; t < e.targetRanges.length; t++) {
            const n = e.targetRanges[t],
              i = r.toModelRange(n),
              o = ad(i, a);
            o && !o.isEqual(i) && (e.targetRanges[t] = r.toViewRange(o));
          }
        }), {
          priority: "high"
        }), this.downcastDispatcher.on("insert:$text", (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const i = n.writer,
            o = n.mapper.toViewPosition(e.range.start),
            r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (t, e, n) => {
          n.convertAttributes(e.item), e.reconversion || !e.item.is("element") || e.item.isEmpty || n.convertChildren(e.item);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", (t, e, n) => {
          const i = n.mapper.toViewPosition(e.position),
            o = e.position.getShiftedBy(e.length),
            r = n.mapper.toViewPosition(o, {
              isPhantom: !0
            }),
            s = n.writer.createRange(i, r),
            a = n.writer.remove(s.getTrimmed());
          for (const t of n.writer.createRangeIn(a).getItems()) n.mapper.unbindViewElement(t, {
            defer: !0
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("cleanSelection", (t, e, n) => {
          const i = n.writer,
            o = i.document.selection;
          for (const t of o.getRanges()) t.isCollapsed && t.end.parent.isAttached() && n.writer.mergeAttributes(t.start);
          i.setSelection(null);
        }), this.downcastDispatcher.on("selection", (t, e, n) => {
          const i = e.selection;
          if (i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          const o = [];
          for (const t of i.getRanges()) o.push(n.mapper.toViewRange(t));
          n.writer.setSelection(o, {
            backward: i.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", (t, e, n) => {
          const i = e.selection;
          if (!i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          const o = n.writer,
            r = i.getFirstPosition(),
            s = n.mapper.toViewPosition(r),
            a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(t => {
          if ("$graveyard" == t.rootName) return null;
          const e = new qs(this.view.document, t.name);
          return e.rootName = t.rootName, this.mapper.bindElements(t, e), e;
        });
      }
      destroy() {
        this.view.destroy(), this.stopListening();
      }
      reconvertMarker(t) {
        const e = "string" == typeof t ? t : t.name,
          n = this.model.markers.get(e);
        if (!n) throw new b("editingcontroller-reconvertmarker-marker-not-exist", this, {
          markerName: e
        });
        this.model.change(() => {
          this.model.markers._refresh(n);
        });
      }
      reconvertItem(t) {
        this.model.change(() => {
          this.model.document.differ._refreshItem(t);
        });
      }
    }
    class ud {
      constructor() {
        this._consumables = new Map();
      }
      add(t, e) {
        let n;
        t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new md(t), this._consumables.set(t, n)), n.add(e));
      }
      test(t, e) {
        const n = this._consumables.get(t);
        return void 0 === n ? null : t.is("$text") || t.is("documentFragment") ? n : n.test(e);
      }
      consume(t, e) {
        return !!this.test(t, e) && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
      }
      revert(t, e) {
        const n = this._consumables.get(t);
        void 0 !== n && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
      }
      static consumablesFromElement(t) {
        const e = {
            element: t,
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
          n = t.getAttributeKeys();
        for (const t of n) "style" != t && "class" != t && e.attributes.push(t);
        const i = t.getClassNames();
        for (const t of i) e.classes.push(t);
        const o = t.getStyleNames();
        for (const t of o) e.styles.push(t);
        return e;
      }
      static createFrom(t, e) {
        if (e || (e = new ud()), t.is("$text")) return e.add(t), e;
        t.is("element") && e.add(t, ud.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);
        for (const n of t.getChildren()) e = ud.createFrom(n, e);
        return e;
      }
    }
    const hd = ["attributes", "classes", "styles"];
    class md {
      constructor(t) {
        this.element = t, this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }
      add(t) {
        t.name && (this._canConsumeName = !0);
        for (const e of hd) e in t && this._add(e, t[e]);
      }
      test(t) {
        if (t.name && !this._canConsumeName) return this._canConsumeName;
        for (const e of hd) if (e in t) {
          const n = this._test(e, t[e]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      consume(t) {
        t.name && (this._canConsumeName = !1);
        for (const e of hd) e in t && this._consume(e, t[e]);
      }
      revert(t) {
        t.name && (this._canConsumeName = !0);
        for (const e of hd) e in t && this._revert(e, t[e]);
      }
      _add(t, e) {
        const n = vo(e),
          i = this._consumables[t];
        for (const e of n) {
          if ("attributes" === t && ("class" === e || "style" === e)) throw new b("viewconsumable-invalid-attribute", this);
          if (i.set(e, !0), "styles" === t) for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) i.set(t, !0);
        }
      }
      _test(t, e) {
        const n = vo(e),
          i = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          const t = i.get(e);
          if (void 0 === t) return null;
          if (!t) return !1;
        } else {
          const t = "class" == e ? "classes" : "styles",
            n = this._test(t, [...this._consumables[t].keys()]);
          if (!0 !== n) return n;
        }
        return !0;
      }
      _consume(t, e) {
        const n = vo(e),
          i = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          if (i.set(e, !1), "styles" == t) for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) i.set(t, !1);
        } else {
          const t = "class" == e ? "classes" : "styles";
          this._consume(t, [...this._consumables[t].keys()]);
        }
      }
      _revert(t, e) {
        const n = vo(e),
          i = this._consumables[t];
        for (const e of n) if ("attributes" !== t || "class" !== e && "style" !== e) {
          !1 === i.get(e) && i.set(e, !0);
        } else {
          const t = "class" == e ? "classes" : "styles";
          this._revert(t, [...this._consumables[t].keys()]);
        }
      }
    }
    class gd extends q() {
      constructor() {
        super(), this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (t, e) => {
          e[0] = new pd(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", (t, e) => {
          e[0] = new pd(e[0]), e[1] = this.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }
      register(t, e) {
        if (this._sourceDefinitions[t]) throw new b("schema-cannot-register-item-twice", this, {
          itemName: t
        });
        this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
      }
      extend(t, e) {
        if (!this._sourceDefinitions[t]) throw new b("schema-cannot-extend-missing-item", this, {
          itemName: t
        });
        this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
      }
      getDefinitions() {
        return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
      }
      getDefinition(t) {
        let e;
        return e = "string" == typeof t ? t : "is" in t && (t.is("$text") || t.is("$textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
      }
      isRegistered(t) {
        return !!this.getDefinition(t);
      }
      isBlock(t) {
        const e = this.getDefinition(t);
        return !(!e || !e.isBlock);
      }
      isLimit(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isLimit && !e.isObject);
      }
      isObject(t) {
        const e = this.getDefinition(t);
        return !!e && !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
      }
      isInline(t) {
        const e = this.getDefinition(t);
        return !(!e || !e.isInline);
      }
      isSelectable(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isSelectable && !e.isObject);
      }
      isContent(t) {
        const e = this.getDefinition(t);
        return !!e && !(!e.isContent && !e.isObject);
      }
      checkChild(t, e) {
        return !!e && this._checkContextMatch(e, t);
      }
      checkAttribute(t, e) {
        const n = this.getDefinition(t.last);
        return !!n && n.allowAttributes.includes(e);
      }
      checkMerge(t, e) {
        if (t instanceof sc) {
          const e = t.nodeBefore,
            n = t.nodeAfter;
          if (!(e instanceof ic)) throw new b("schema-check-merge-no-element-before", this);
          if (!(n instanceof ic)) throw new b("schema-check-merge-no-element-after", this);
          return this.checkMerge(e, n);
        }
        for (const n of e.getChildren()) if (!this.checkChild(t, n)) return !1;
        return !0;
      }
      addChildCheck(t) {
        this.on("checkChild", (e, _ref21) => {
          let [n, i] = _ref21;
          if (!i) return;
          const o = t(n, i);
          "boolean" == typeof o && (e.stop(), e.return = o);
        }, {
          priority: "high"
        });
      }
      addAttributeCheck(t) {
        this.on("checkAttribute", (e, _ref22) => {
          let [n, i] = _ref22;
          const o = t(n, i);
          "boolean" == typeof o && (e.stop(), e.return = o);
        }, {
          priority: "high"
        });
      }
      setAttributeProperties(t, e) {
        this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
      }
      getAttributeProperties(t) {
        return this._attributeProperties[t] || {};
      }
      getLimitElement(t) {
        let e;
        if (t instanceof sc) e = t.parent;else {
          e = (t instanceof hc ? [t] : Array.from(t.getRanges())).reduce((t, e) => {
            const n = e.getCommonAncestor();
            return t ? t.getCommonAncestor(n, {
              includeSelf: !0
            }) : n;
          }, null);
        }
        for (; !this.isLimit(e) && e.parent;) e = e.parent;
        return e;
      }
      checkAttributeInSelection(t, e) {
        if (t.isCollapsed) {
          const n = [...t.getFirstPosition().getAncestors(), new ec("", t.getAttributes())];
          return this.checkAttribute(n, e);
        }
        {
          const n = t.getRanges();
          for (const t of n) for (const n of t) if (this.checkAttribute(n.item, e)) return !0;
        }
        return !1;
      }
      *getValidRanges(t, e) {
        t = function* (t) {
          for (const e of t) yield* e.getMinimalFlatRanges();
        }(t);
        for (const n of t) yield* this._getValidRangesForRange(n, e);
      }
      getNearestSelectionRange(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
        if ("$graveyard" == t.root.rootName) return null;
        if (this.checkChild(t, "$text")) return new hc(t);
        let n, i;
        const o = t.getAncestors().reverse().find(t => this.isLimit(t)) || t.root;
        "both" != e && "backward" != e || (n = new oc({
          boundaries: hc._createIn(o),
          startPosition: t,
          direction: "backward"
        })), "both" != e && "forward" != e || (i = new oc({
          boundaries: hc._createIn(o),
          startPosition: t
        }));
        for (const t of function* (t, e) {
          let n = !1;
          for (; !n;) {
            if (n = !0, t) {
              const e = t.next();
              e.done || (n = !1, yield {
                walker: t,
                value: e.value
              });
            }
            if (e) {
              const t = e.next();
              t.done || (n = !1, yield {
                walker: e,
                value: t.value
              });
            }
          }
        }(n, i)) {
          const e = t.walker == n ? "elementEnd" : "elementStart",
            i = t.value;
          if (i.type == e && this.isObject(i.item)) return hc._createOn(i.item);
          if (this.checkChild(i.nextPosition, "$text")) return new hc(i.nextPosition);
        }
        return null;
      }
      findAllowedParent(t, e) {
        let n = t.parent;
        for (; n;) {
          if (this.checkChild(n, e)) return n;
          if (this.isLimit(n)) return null;
          n = n.parent;
        }
        return null;
      }
      setAllowedAttributes(t, e, n) {
        const i = n.model;
        for (const [o, r] of Object.entries(e)) i.schema.checkAttribute(t, o) && n.setAttribute(o, r, t);
      }
      removeDisallowedAttributes(t, e) {
        for (const n of t) if (n.is("$text")) Bd(this, n, e);else {
          const t = hc._createIn(n).getPositions();
          for (const n of t) {
            Bd(this, n.nodeBefore || n.parent, e);
          }
        }
      }
      getAttributesWithProperty(t, e, n) {
        const i = {};
        for (const [o, r] of t.getAttributes()) {
          const t = this.getAttributeProperties(o);
          void 0 !== t[e] && (void 0 !== n && n !== t[e] || (i[o] = r));
        }
        return i;
      }
      createContext(t) {
        return new pd(t);
      }
      _clearCache() {
        this._compiledDefinitions = null;
      }
      _compile() {
        const t = {},
          e = this._sourceDefinitions,
          n = Object.keys(e);
        for (const i of n) t[i] = fd(e[i], i);
        for (const e of n) kd(t, e);
        for (const e of n) bd(t, e);
        for (const e of n) wd(t, e);
        for (const e of n) Ad(t, e), Cd(t, e);
        for (const e of n) _d(t, e), vd(t, e), yd(t, e);
        this._compiledDefinitions = t;
      }
      _checkContextMatch(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
        const i = e.getItem(n);
        if (t.allowIn.includes(i.name)) {
          if (0 == n) return !0;
          {
            const t = this.getDefinition(i);
            return this._checkContextMatch(t, e, n - 1);
          }
        }
        return !1;
      }
      *_getValidRangesForRange(t, e) {
        let n = t.start,
          i = t.start;
        for (const o of t.getItems({
          shallow: !0
        })) o.is("element") && (yield* this._getValidRangesForRange(hc._createIn(o), e)), this.checkAttribute(o, e) || (n.isEqual(i) || (yield new hc(n, i)), n = sc._createAfter(o)), i = sc._createAfter(o);
        n.isEqual(i) || (yield new hc(n, i));
      }
      findOptimalInsertionRange(t, e) {
        const n = t.getSelectedElement();
        if (n && this.isObject(n) && !this.isInline(n)) return "before" == e || "after" == e ? new hc(sc._createAt(n, e)) : hc._createOn(n);
        const i = $o(t.getSelectedBlocks());
        if (!i) return new hc(t.focus);
        if (i.isEmpty) return new hc(sc._createAt(i, 0));
        const o = sc._createAfter(i);
        return t.focus.isTouching(o) ? new hc(o) : new hc(sc._createBefore(i));
      }
    }
    class pd {
      constructor(t) {
        if (t instanceof pd) return t;
        let e;
        e = "string" == typeof t ? [t] : Array.isArray(t) ? t : t.getAncestors({
          includeSelf: !0
        }), this._items = e.map(Dd);
      }
      get length() {
        return this._items.length;
      }
      get last() {
        return this._items[this._items.length - 1];
      }
      [Symbol.iterator]() {
        return this._items[Symbol.iterator]();
      }
      push(t) {
        const e = new pd([t]);
        return e._items = [...this._items, ...e._items], e;
      }
      getItem(t) {
        return this._items[t];
      }
      *getNames() {
        yield* this._items.map(t => t.name);
      }
      endsWith(t) {
        return Array.from(this.getNames()).join(" ").endsWith(t);
      }
      startsWith(t) {
        return Array.from(this.getNames()).join(" ").startsWith(t);
      }
    }
    function fd(t, e) {
      const n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        allowChildren: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        for (const n of t) {
          const t = Object.keys(n).filter(t => t.startsWith("is"));
          for (const i of t) e[i] = !!n[i];
        }
      }(t, n), xd(t, n, "allowIn"), xd(t, n, "allowContentOf"), xd(t, n, "allowWhere"), xd(t, n, "allowAttributes"), xd(t, n, "allowAttributesOf"), xd(t, n, "allowChildren"), xd(t, n, "inheritTypesFrom"), function (t, e) {
        for (const n of t) {
          const t = n.inheritAllFrom;
          t && (e.allowContentOf.push(t), e.allowWhere.push(t), e.allowAttributesOf.push(t), e.inheritTypesFrom.push(t));
        }
      }(t, n), n;
    }
    function kd(t, e) {
      const n = t[e];
      for (const i of n.allowChildren) {
        const n = t[i];
        n && n.allowIn.push(e);
      }
      n.allowChildren.length = 0;
    }
    function bd(t, e) {
      for (const n of t[e].allowContentOf) if (t[n]) {
        Ed(t, n).forEach(t => {
          t.allowIn.push(e);
        });
      }
      delete t[e].allowContentOf;
    }
    function wd(t, e) {
      for (const n of t[e].allowWhere) {
        const i = t[n];
        if (i) {
          const n = i.allowIn;
          t[e].allowIn.push(...n);
        }
      }
      delete t[e].allowWhere;
    }
    function Ad(t, e) {
      for (const n of t[e].allowAttributesOf) {
        const i = t[n];
        if (i) {
          const n = i.allowAttributes;
          t[e].allowAttributes.push(...n);
        }
      }
      delete t[e].allowAttributesOf;
    }
    function Cd(t, e) {
      const n = t[e];
      for (const e of n.inheritTypesFrom) {
        const i = t[e];
        if (i) {
          const t = Object.keys(i).filter(t => t.startsWith("is"));
          for (const e of t) e in n || (n[e] = i[e]);
        }
      }
      delete n.inheritTypesFrom;
    }
    function _d(t, e) {
      const n = t[e],
        i = n.allowIn.filter(e => t[e]);
      n.allowIn = Array.from(new Set(i));
    }
    function vd(t, e) {
      const n = t[e];
      for (const i of n.allowIn) {
        t[i].allowChildren.push(e);
      }
    }
    function yd(t, e) {
      const n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }
    function xd(t, e, n) {
      for (const i of t) {
        const t = i[n];
        "string" == typeof t ? e[n].push(t) : Array.isArray(t) && e[n].push(...t);
      }
    }
    function Ed(t, e) {
      const n = t[e];
      return (i = t, Object.keys(i).map(t => i[t])).filter(t => t.allowIn.includes(n.name));
      var i;
    }
    function Dd(t) {
      return "string" == typeof t || t.is("documentFragment") ? {
        name: "string" == typeof t ? t : "$documentFragment",
        *getAttributeKeys() {},
        getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        *getAttributeKeys() {
          yield* t.getAttributeKeys();
        },
        getAttribute: e => t.getAttribute(e)
      };
    }
    function Bd(t, e, n) {
      for (const i of e.getAttributeKeys()) t.checkAttribute(e, i) || n.removeAttribute(i, e);
    }
    class Sd extends B() {
      constructor(t) {
        super(), this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this._emptyElementsToKeep = new Set(), this.conversionApi = {
          ...t,
          consumable: null,
          writer: null,
          store: null,
          convertItem: (t, e) => this._convertItem(t, e),
          convertChildren: (t, e) => this._convertChildren(t, e),
          safeInsert: (t, e) => this._safeInsert(t, e),
          updateConversionResult: (t, e) => this._updateConversionResult(t, e),
          splitToAllowedParent: (t, e) => this._splitToAllowedParent(t, e),
          getSplitParts: t => this._getSplitParts(t),
          keepEmptyElement: t => this._keepEmptyElement(t)
        };
      }
      convert(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
        this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
          let n;
          for (const i of new pd(t)) {
            const t = {};
            for (const e of i.getAttributeKeys()) t[e] = i.getAttribute(e);
            const o = e.createElement(i.name, t);
            n && e.insert(o, n), n = sc._createAt(o, 0);
          }
          return n;
        }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = ud.createFrom(t), this.conversionApi.store = {};
        const {
            modelRange: i
          } = this._convertItem(t, this._modelCursor),
          o = e.createDocumentFragment();
        if (i) {
          this._removeEmptyElements();
          for (const t of Array.from(this._modelCursor.parent.getChildren())) e.append(t, o);
          o.markers = function (t, e) {
            const n = new Set(),
              i = new Map(),
              o = hc._createIn(t).getItems();
            for (const t of o) t.is("element", "$marker") && n.add(t);
            for (const t of n) {
              const n = t.getAttribute("data-name"),
                o = e.createPositionBefore(t);
              i.has(n) ? i.get(n).end = o.clone() : i.set(n, new hc(o.clone())), e.remove(t);
            }
            return i;
          }(o, e);
        }
        return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
      }
      _convertItem(t, e) {
        const n = {
          viewItem: t,
          modelCursor: e,
          modelRange: null
        };
        if (t.is("element") ? this.fire(`element:${t.name}`, n, this.conversionApi) : t.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof hc)) throw new b("view-conversion-dispatcher-incorrect-result", this);
        return {
          modelRange: n.modelRange,
          modelCursor: n.modelCursor
        };
      }
      _convertChildren(t, e) {
        let n = e.is("position") ? e : sc._createAt(e, 0);
        const i = new hc(n);
        for (const e of Array.from(t.getChildren())) {
          const t = this._convertItem(e, n);
          t.modelRange instanceof hc && (i.end = t.modelRange.end, n = t.modelCursor);
        }
        return {
          modelRange: i,
          modelCursor: n
        };
      }
      _safeInsert(t, e) {
        const n = this._splitToAllowedParent(t, e);
        return !!n && (this.conversionApi.writer.insert(t, n.position), !0);
      }
      _updateConversionResult(t, e) {
        const n = this._getSplitParts(t),
          i = this.conversionApi.writer;
        e.modelRange || (e.modelRange = i.createRange(i.createPositionBefore(t), i.createPositionAfter(n[n.length - 1])));
        const o = this._cursorParents.get(t);
        e.modelCursor = o ? i.createPositionAt(o, 0) : e.modelRange.end;
      }
      _splitToAllowedParent(t, e) {
        const {
          schema: n,
          writer: i
        } = this.conversionApi;
        let o = n.findAllowedParent(e, t);
        if (o) {
          if (o === e.parent) return {
            position: e
          };
          this._modelCursor.parent.getAncestors().includes(o) && (o = null);
        }
        if (!o) return Zc(e, t, n) ? {
          position: Jc(e, i)
        } : null;
        const r = this.conversionApi.writer.split(e, o),
          s = [];
        for (const t of r.range.getWalker()) if ("elementEnd" == t.type) s.push(t.item);else {
          const e = s.pop(),
            n = t.item;
          this._registerSplitPair(e, n);
        }
        const a = r.range.end.parent;
        return this._cursorParents.set(t, a), {
          position: r.position,
          cursorParent: a
        };
      }
      _registerSplitPair(t, e) {
        this._splitParts.has(t) || this._splitParts.set(t, [t]);
        const n = this._splitParts.get(t);
        this._splitParts.set(e, n), n.push(e);
      }
      _getSplitParts(t) {
        let e;
        return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t], e;
      }
      _keepEmptyElement(t) {
        this._emptyElementsToKeep.add(t);
      }
      _removeEmptyElements() {
        let t = !1;
        for (const e of this._splitParts.keys()) e.isEmpty && !this._emptyElementsToKeep.has(e) && (this.conversionApi.writer.remove(e), this._splitParts.delete(e), t = !0);
        t && this._removeEmptyElements();
      }
    }
    class Td {
      getHtml(t) {
        const n = e.document.implementation.createHTMLDocument("").createElement("div");
        return n.appendChild(t), n.innerHTML;
      }
    }
    class Id {
      constructor(t) {
        this.skipComments = !0, this.domParser = new DOMParser(), this.domConverter = new Ya(t, {
          renderingMode: "data"
        }), this.htmlWriter = new Td();
      }
      toData(t) {
        const e = this.domConverter.viewToDom(t);
        return this.htmlWriter.getHtml(e);
      }
      toView(t) {
        const e = this._toDom(t);
        return this.domConverter.domToView(e, {
          skipComments: this.skipComments
        });
      }
      registerRawContentMatcher(t) {
        this.domConverter.registerRawContentMatcher(t);
      }
      useFillerType(t) {
        this.domConverter.blockFillerMode = "marked" == t ? "markedNbsp" : "nbsp";
      }
      _toDom(t) {
        t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (t = `<body>${t}</body>`);
        const e = this.domParser.parseFromString(t, "text/html"),
          n = e.createDocumentFragment(),
          i = e.body.childNodes;
        for (; i.length > 0;) n.appendChild(i[0]);
        return n;
      }
    }
    class Md extends B() {
      constructor(t, e) {
        super(), this.model = t, this.mapper = new mc(), this.downcastDispatcher = new fc({
          mapper: this.mapper,
          schema: t.schema
        }), this.downcastDispatcher.on("insert:$text", (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const i = n.writer,
            o = n.mapper.toViewPosition(e.range.start),
            r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("insert", (t, e, n) => {
          n.convertAttributes(e.item), e.reconversion || !e.item.is("element") || e.item.isEmpty || n.convertChildren(e.item);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new Sd({
          schema: t.schema
        }), this.viewDocument = new oa(e), this.stylesProcessor = e, this.htmlProcessor = new Id(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new ka(this.viewDocument), this.upcastDispatcher.on("text", (t, e, _ref23) => {
          let {
            schema: n,
            consumable: i,
            writer: o
          } = _ref23;
          let r = e.modelCursor;
          if (!i.test(e.viewItem)) return;
          if (!n.checkChild(r, "$text")) {
            if (!Zc(r, "$text", n)) return;
            if (0 == e.viewItem.data.trim().length) return;
            const t = r.nodeBefore;
            r = Jc(r, o), t && t.is("element", "$marker") && (o.move(o.createRangeOn(t), r), r = o.createPositionAfter(t));
          }
          i.consume(e.viewItem);
          const s = o.createText(e.viewItem.data);
          o.insert(s, r), e.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize)), e.modelCursor = e.modelRange.end;
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", (t, e, n) => {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            const {
              modelRange: t,
              modelCursor: i
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = t, e.modelCursor = i;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", (t, e, n) => {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            const {
              modelRange: t,
              modelCursor: i
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = t, e.modelCursor = i;
          }
        }, {
          priority: "lowest"
        }), q().prototype.decorate.call(this, "init"), q().prototype.decorate.call(this, "set"), q().prototype.decorate.call(this, "get"), q().prototype.decorate.call(this, "toView"), q().prototype.decorate.call(this, "toModel"), this.on("init", () => {
          this.fire("ready");
        }, {
          priority: "lowest"
        }), this.on("ready", () => {
          this.model.enqueueChange({
            isUndoable: !1
          }, Qc);
        }, {
          priority: "lowest"
        });
      }
      get() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          rootName: e = "main",
          trim: n = "empty"
        } = t;
        if (!this._checkIfRootsExists([e])) throw new b("datacontroller-get-non-existent-root", this);
        const i = this.model.document.getRoot(e);
        return i.isAttached() || w("datacontroller-get-detached-root", this), "empty" !== n || this.model.hasContent(i, {
          ignoreWhitespaces: !0
        }) ? this.stringify(i, t) : "";
      }
      stringify(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.toView(t, e);
        return this.processor.toData(n);
      }
      toView(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.viewDocument,
          i = this._viewWriter;
        this.mapper.clearBindings();
        const o = hc._createIn(t),
          r = new fa(n);
        this.mapper.bindElements(t, r);
        const s = t.is("documentFragment") ? t.markers : function (t) {
          const e = [],
            n = t.root.document;
          if (!n) return new Map();
          const i = hc._createIn(t);
          for (const t of n.model.markers) {
            const n = t.getRange(),
              o = n.isCollapsed,
              r = n.start.isEqual(i.start) || n.end.isEqual(i.end);
            if (o && r) e.push([t.name, n]);else {
              const o = i.getIntersection(n);
              o && e.push([t.name, o]);
            }
          }
          return e.sort((_ref24, _ref25) => {
            let [t, e] = _ref24;
            let [n, i] = _ref25;
            if ("after" !== e.end.compareWith(i.start)) return 1;
            if ("before" !== e.start.compareWith(i.end)) return -1;
            switch (e.start.compareWith(i.start)) {
              case "before":
                return 1;
              case "after":
                return -1;
              default:
                switch (e.end.compareWith(i.end)) {
                  case "before":
                    return 1;
                  case "after":
                    return -1;
                  default:
                    return n.localeCompare(t);
                }
            }
          }), new Map(e);
        }(t);
        return this.downcastDispatcher.convert(o, s, i, e), r;
      }
      init(t) {
        if (this.model.document.version) throw new b("datacontroller-init-document-not-empty", this);
        let e = {};
        if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new b("datacontroller-init-non-existent-root", this);
        return this.model.enqueueChange({
          isUndoable: !1
        }, t => {
          for (const n of Object.keys(e)) {
            const i = this.model.document.getRoot(n);
            t.insert(this.parse(e[n], i), i, 0);
          }
        }), Promise.resolve();
      }
      set(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let n = {};
        if ("string" == typeof t ? n.main = t : n = t, !this._checkIfRootsExists(Object.keys(n))) throw new b("datacontroller-set-non-existent-root", this);
        this.model.enqueueChange(e.batchType || {}, t => {
          t.setSelection(null), t.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
          for (const e of Object.keys(n)) {
            const i = this.model.document.getRoot(e);
            t.remove(t.createRangeIn(i)), t.insert(this.parse(n[e], i), i, 0);
          }
        });
      }
      parse(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        const n = this.processor.toView(t);
        return this.toModel(n, e);
      }
      toModel(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        return this.model.change(n => this.upcastDispatcher.convert(t, n, e));
      }
      addStyleProcessorRules(t) {
        t(this.stylesProcessor);
      }
      registerRawContentMatcher(t) {
        this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
      }
      destroy() {
        this.stopListening();
      }
      _checkIfRootsExists(t) {
        for (const e of t) if (!this.model.document.getRoot(e)) return !1;
        return !0;
      }
    }
    class Ld {
      constructor(t, e) {
        this._helpers = new Map(), this._downcast = vo(t), this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = vo(e), this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }
      addAlias(t, e) {
        const n = this._downcast.includes(e);
        if (!this._upcast.includes(e) && !n) throw new b("conversion-add-alias-dispatcher-not-registered", this);
        this._createConversionHelpers({
          name: t,
          dispatchers: [e],
          isDowncast: n
        });
      }
      for(t) {
        if (!this._helpers.has(t)) throw new b("conversion-for-unknown-group", this);
        return this._helpers.get(t);
      }
      elementToElement(t) {
        this.for("downcast").elementToElement(t);
        for (const {
          model: e,
          view: n
        } of Nd(t)) this.for("upcast").elementToElement({
          model: e,
          view: n,
          converterPriority: t.converterPriority
        });
      }
      attributeToElement(t) {
        this.for("downcast").attributeToElement(t);
        for (const {
          model: e,
          view: n
        } of Nd(t)) this.for("upcast").elementToAttribute({
          view: n,
          model: e,
          converterPriority: t.converterPriority
        });
      }
      attributeToAttribute(t) {
        this.for("downcast").attributeToAttribute(t);
        for (const {
          model: e,
          view: n
        } of Nd(t)) this.for("upcast").attributeToAttribute({
          view: n,
          model: e
        });
      }
      _createConversionHelpers(_ref26) {
        let {
          name: t,
          dispatchers: e,
          isDowncast: n
        } = _ref26;
        if (this._helpers.has(t)) throw new b("conversion-group-exists", this);
        const i = n ? new Nc(e) : new Xc(e);
        this._helpers.set(t, i);
      }
    }
    function* Nd(t) {
      if (t.model.values) for (const e of t.model.values) {
        const n = {
            key: t.model.key,
            value: e
          },
          i = t.view[e],
          o = t.upcastAlso ? t.upcastAlso[e] : void 0;
        yield* zd(n, i, o);
      } else yield* zd(t.model, t.view, t.upcastAlso);
    }
    function* zd(t, e, n) {
      if (yield {
        model: t,
        view: e
      }, n) for (const e of vo(n)) yield {
        model: t,
        view: e
      };
    }
    class Pd {
      constructor(t) {
        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }
      _validate() {}
      toJSON() {
        const t = Object.assign({}, this);
        return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
      }
      static get className() {
        return "Operation";
      }
      static fromJSON(t, e) {
        return new this(t.baseVersion);
      }
    }
    function Vd(t, e) {
      const n = Od(e),
        i = n.reduce((t, e) => t + e.offsetSize, 0),
        o = t.parent;
      Hd(t);
      const r = t.index;
      return o._insertChild(r, n), jd(o, r + n.length), jd(o, r), new hc(t, t.getShiftedBy(i));
    }
    function Rd(t) {
      if (!t.isFlat) throw new b("operation-utils-remove-range-not-flat", this);
      const e = t.start.parent;
      Hd(t.start), Hd(t.end);
      const n = e._removeChildren(t.start.index, t.end.index - t.start.index);
      return jd(e, t.start.index), n;
    }
    function Fd(t, e) {
      if (!t.isFlat) throw new b("operation-utils-move-range-not-flat", this);
      const n = Rd(t);
      return Vd(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }
    function Od(t) {
      const e = [];
      !function t(n) {
        if ("string" == typeof n) e.push(new ec(n));else if (n instanceof nc) e.push(new ec(n.data, n.getAttributes()));else if (n instanceof Xl) e.push(n);else if (X(n)) for (const e of n) t(e);else {}
      }(t);
      for (let t = 1; t < e.length; t++) {
        const n = e[t],
          i = e[t - 1];
        n instanceof ec && i instanceof ec && Ud(n, i) && (e.splice(t - 1, 2, new ec(i.data + n.data, i.getAttributes())), t--);
      }
      return e;
    }
    function jd(t, e) {
      const n = t.getChild(e - 1),
        i = t.getChild(e);
      if (n && i && n.is("$text") && i.is("$text") && Ud(n, i)) {
        const o = new ec(n.data + i.data, n.getAttributes());
        t._removeChildren(e - 1, 2), t._insertChild(e - 1, o);
      }
    }
    function Hd(t) {
      const e = t.textNode,
        n = t.parent;
      if (e) {
        const i = t.offset - e.startOffset,
          o = e.index;
        n._removeChildren(o, 1);
        const r = new ec(e.data.substr(0, i), e.getAttributes()),
          s = new ec(e.data.substr(i), e.getAttributes());
        n._insertChild(o, [r, s]);
      }
    }
    function Ud(t, e) {
      const n = t.getAttributes(),
        i = e.getAttributes();
      for (const t of n) {
        if (t[1] !== e.getAttribute(t[0])) return !1;
        i.next();
      }
      return i.next().done;
    }
    class qd extends Pd {
      constructor(t, e, n, i) {
        super(i), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = e, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNone";
      }
      get type() {
        return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
      }
      get affectedSelectable() {
        return [hc._createFromPositionAndShift(this.sourcePosition, this.howMany), hc._createFromPositionAndShift(this.targetPosition, 0)];
      }
      clone() {
        return new qd(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
      }
      getMovedRangeStart() {
        return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
      }
      getReversed() {
        const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
        return new qd(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
      }
      _validate() {
        const t = this.sourcePosition.parent,
          e = this.targetPosition.parent,
          n = this.sourcePosition.offset,
          i = this.targetPosition.offset;
        if (n + this.howMany > t.maxOffset) throw new b("move-operation-nodes-do-not-exist", this);
        if (t === e && n < i && i < n + this.howMany) throw new b("move-operation-range-into-itself", this);
        if (this.sourcePosition.root == this.targetPosition.root && "prefix" == J(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
          const t = this.sourcePosition.path.length - 1;
          if (this.targetPosition.path[t] >= n && this.targetPosition.path[t] < n + this.howMany) throw new b("move-operation-node-into-itself", this);
        }
      }
      _execute() {
        Fd(hc._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
      }
      static get className() {
        return "MoveOperation";
      }
      static fromJSON(t, e) {
        const n = sc.fromJSON(t.sourcePosition, e),
          i = sc.fromJSON(t.targetPosition, e);
        return new this(n, t.howMany, i, t.baseVersion);
      }
    }
    class Gd extends Pd {
      constructor(t, e, n) {
        super(n), this.position = t.clone(), this.position.stickiness = "toNone", this.nodes = new tc(Od(e)), this.shouldReceiveAttributes = !1;
      }
      get type() {
        return "insert";
      }
      get howMany() {
        return this.nodes.maxOffset;
      }
      get affectedSelectable() {
        return this.position.clone();
      }
      clone() {
        const t = new tc([...this.nodes].map(t => t._clone(!0))),
          e = new Gd(this.position, t, this.baseVersion);
        return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
      }
      getReversed() {
        const t = this.position.root.document.graveyard,
          e = new sc(t, [0]);
        return new qd(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
      }
      _validate() {
        const t = this.position.parent;
        if (!t || t.maxOffset < this.position.offset) throw new b("insert-operation-position-invalid", this);
      }
      _execute() {
        const t = this.nodes;
        this.nodes = new tc([...t].map(t => t._clone(!0))), Vd(this.position, t);
      }
      toJSON() {
        const t = super.toJSON();
        return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
      }
      static get className() {
        return "InsertOperation";
      }
      static fromJSON(t, e) {
        const n = [];
        for (const e of t.nodes) e.name ? n.push(ic.fromJSON(e)) : n.push(ec.fromJSON(e));
        const i = new Gd(sc.fromJSON(t.position, e), n, t.baseVersion);
        return i.shouldReceiveAttributes = t.shouldReceiveAttributes, i;
      }
    }
    class Wd extends Pd {
      constructor(t, e, n, i, o) {
        super(o), this.splitPosition = t.clone(), this.splitPosition.stickiness = "toNext", this.howMany = e, this.insertionPosition = n, this.graveyardPosition = i ? i.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
      }
      get type() {
        return "split";
      }
      get moveTargetPosition() {
        const t = this.insertionPosition.path.slice();
        return t.push(0), new sc(this.insertionPosition.root, t);
      }
      get movedRange() {
        const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new hc(this.splitPosition, t);
      }
      get affectedSelectable() {
        const t = [hc._createFromPositionAndShift(this.splitPosition, 0), hc._createFromPositionAndShift(this.insertionPosition, 0)];
        return this.graveyardPosition && t.push(hc._createFromPositionAndShift(this.graveyardPosition, 0)), t;
      }
      clone() {
        return new Wd(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const t = this.splitPosition.root.document.graveyard,
          e = new sc(t, [0]);
        return new $d(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
      }
      _validate() {
        const t = this.splitPosition.parent,
          e = this.splitPosition.offset;
        if (!t || t.maxOffset < e) throw new b("split-operation-position-invalid", this);
        if (!t.parent) throw new b("split-operation-split-in-root", this);
        if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new b("split-operation-how-many-invalid", this);
        if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new b("split-operation-graveyard-position-invalid", this);
      }
      _execute() {
        const t = this.splitPosition.parent;
        if (this.graveyardPosition) Fd(hc._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
          const e = t._clone();
          Vd(this.insertionPosition, e);
        }
        Fd(new hc(sc._createAt(t, this.splitPosition.offset), sc._createAt(t, t.maxOffset)), this.moveTargetPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
      }
      static get className() {
        return "SplitOperation";
      }
      static getInsertionPosition(t) {
        const e = t.path.slice(0, -1);
        return e[e.length - 1]++, new sc(t.root, e, "toPrevious");
      }
      static fromJSON(t, e) {
        const n = sc.fromJSON(t.splitPosition, e),
          i = sc.fromJSON(t.insertionPosition, e),
          o = t.graveyardPosition ? sc.fromJSON(t.graveyardPosition, e) : null;
        return new this(n, t.howMany, i, o, t.baseVersion);
      }
    }
    class $d extends Pd {
      constructor(t, e, n, i, o) {
        super(o), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = e, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = i.clone();
      }
      get type() {
        return "merge";
      }
      get deletionPosition() {
        return new sc(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
      }
      get movedRange() {
        const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
        return new hc(this.sourcePosition, t);
      }
      get affectedSelectable() {
        const t = this.sourcePosition.parent;
        return [hc._createOn(t), hc._createFromPositionAndShift(this.targetPosition, 0), hc._createFromPositionAndShift(this.graveyardPosition, 0)];
      }
      clone() {
        return new $d(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
      }
      getReversed() {
        const t = this.targetPosition._getTransformedByMergeOperation(this),
          e = this.sourcePosition.path.slice(0, -1),
          n = new sc(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);
        return new Wd(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
      }
      _validate() {
        const t = this.sourcePosition.parent,
          e = this.targetPosition.parent;
        if (!t.parent) throw new b("merge-operation-source-position-invalid", this);
        if (!e.parent) throw new b("merge-operation-target-position-invalid", this);
        if (this.howMany != t.maxOffset) throw new b("merge-operation-how-many-invalid", this);
      }
      _execute() {
        const t = this.sourcePosition.parent;
        Fd(hc._createIn(t), this.targetPosition), Fd(hc._createOn(t), this.graveyardPosition);
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
      }
      static get className() {
        return "MergeOperation";
      }
      static fromJSON(t, e) {
        const n = sc.fromJSON(t.sourcePosition, e),
          i = sc.fromJSON(t.targetPosition, e),
          o = sc.fromJSON(t.graveyardPosition, e);
        return new this(n, t.howMany, i, o, t.baseVersion);
      }
    }
    class Kd extends Pd {
      constructor(t, e, n, i, o, r) {
        super(r), this.name = t, this.oldRange = e ? e.clone() : null, this.newRange = n ? n.clone() : null, this.affectsData = o, this._markers = i;
      }
      get type() {
        return "marker";
      }
      get affectedSelectable() {
        const t = [];
        return this.oldRange && t.push(this.oldRange.clone()), this.newRange && (this.oldRange ? t.push(...this.newRange.getDifference(this.oldRange)) : t.push(this.newRange.clone())), t;
      }
      clone() {
        return new Kd(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
      }
      getReversed() {
        return new Kd(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
      }
      _execute() {
        this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
      }
      toJSON() {
        const t = super.toJSON();
        return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
      }
      static get className() {
        return "MarkerOperation";
      }
      static fromJSON(t, e) {
        return new Kd(t.name, t.oldRange ? hc.fromJSON(t.oldRange, e) : null, t.newRange ? hc.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
      }
    }
    const Yd = function (t, e) {
      return Rl(t, e);
    };
    class Qd extends Pd {
      constructor(t, e, n, i, o) {
        super(o), this.range = t.clone(), this.key = e, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === i ? null : i;
      }
      get type() {
        return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
      }
      get affectedSelectable() {
        return this.range.clone();
      }
      clone() {
        return new Qd(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new Qd(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      toJSON() {
        const t = super.toJSON();
        return t.range = this.range.toJSON(), t;
      }
      _validate() {
        if (!this.range.isFlat) throw new b("attribute-operation-range-not-flat", this);
        for (const t of this.range.getItems({
          shallow: !0
        })) {
          if (null !== this.oldValue && !Yd(t.getAttribute(this.key), this.oldValue)) throw new b("attribute-operation-wrong-old-value", this, {
            item: t,
            key: this.key,
            value: this.oldValue
          });
          if (null === this.oldValue && null !== this.newValue && t.hasAttribute(this.key)) throw new b("attribute-operation-attribute-exists", this, {
            node: t,
            key: this.key
          });
        }
      }
      _execute() {
        Yd(this.oldValue, this.newValue) || function (t, e, n) {
          Hd(t.start), Hd(t.end);
          for (const i of t.getItems({
            shallow: !0
          })) {
            const t = i.is("$textProxy") ? i.textNode : i;
            null !== n ? t._setAttribute(e, n) : t._removeAttribute(e), jd(t.parent, t.index);
          }
          jd(t.end.parent, t.end.index);
        }(this.range, this.key, this.newValue);
      }
      static get className() {
        return "AttributeOperation";
      }
      static fromJSON(t, e) {
        return new Qd(hc.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
      }
    }
    class Zd extends Pd {
      get type() {
        return "noop";
      }
      get affectedSelectable() {
        return null;
      }
      clone() {
        return new Zd(this.baseVersion);
      }
      getReversed() {
        return new Zd(this.baseVersion + 1);
      }
      _execute() {}
      static get className() {
        return "NoOperation";
      }
    }
    class Jd extends Pd {
      constructor(t, e, n, i) {
        super(i), this.position = t, this.position.stickiness = "toNext", this.oldName = e, this.newName = n;
      }
      get type() {
        return "rename";
      }
      get affectedSelectable() {
        return this.position.nodeAfter;
      }
      clone() {
        return new Jd(this.position.clone(), this.oldName, this.newName, this.baseVersion);
      }
      getReversed() {
        return new Jd(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
      }
      _validate() {
        const t = this.position.nodeAfter;
        if (!(t instanceof ic)) throw new b("rename-operation-wrong-position", this);
        if (t.name !== this.oldName) throw new b("rename-operation-wrong-name", this);
      }
      _execute() {
        this.position.nodeAfter.name = this.newName;
      }
      toJSON() {
        const t = super.toJSON();
        return t.position = this.position.toJSON(), t;
      }
      static get className() {
        return "RenameOperation";
      }
      static fromJSON(t, e) {
        return new Jd(sc.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
      }
    }
    class Xd extends Pd {
      constructor(t, e, n, i, o) {
        super(o), this.root = t, this.key = e, this.oldValue = void 0 === n ? null : n, this.newValue = void 0 === i ? null : i;
      }
      get type() {
        return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
      }
      get affectedSelectable() {
        return this.root;
      }
      clone() {
        return new Xd(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
      }
      getReversed() {
        return new Xd(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
      }
      _validate() {
        if (this.root != this.root.root || this.root.is("documentFragment")) throw new b("rootattribute-operation-not-a-root", this, {
          root: this.root,
          key: this.key
        });
        if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new b("rootattribute-operation-wrong-old-value", this, {
          root: this.root,
          key: this.key
        });
        if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new b("rootattribute-operation-attribute-exists", this, {
          root: this.root,
          key: this.key
        });
      }
      _execute() {
        null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
      }
      toJSON() {
        const t = super.toJSON();
        return t.root = this.root.toJSON(), t;
      }
      static get className() {
        return "RootAttributeOperation";
      }
      static fromJSON(t, e) {
        if (!e.getRoot(t.root)) throw new b("rootattribute-operation-fromjson-no-root", this, {
          rootName: t.root
        });
        return new Xd(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
      }
    }
    class tu extends Pd {
      constructor(t, e, n, i, o) {
        if (super(o), this.rootName = t, this.elementName = e, this.isAdd = n, this._document = i, !this._document.getRoot(this.rootName)) {
          this._document.createRoot(this.elementName, this.rootName)._isAttached = !1;
        }
      }
      get type() {
        return this.isAdd ? "addRoot" : "detachRoot";
      }
      get affectedSelectable() {
        return this._document.getRoot(this.rootName);
      }
      clone() {
        return new tu(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
      }
      getReversed() {
        return new tu(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
      }
      _execute() {
        this._document.getRoot(this.rootName)._isAttached = this.isAdd;
      }
      toJSON() {
        const t = super.toJSON();
        return delete t._document, t;
      }
      static get className() {
        return "RootOperation";
      }
      static fromJSON(t, e) {
        return new tu(t.rootName, t.elementName, t.isAdd, e, t.baseVersion);
      }
    }
    const eu = {};
    eu[Qd.className] = Qd, eu[Gd.className] = Gd, eu[Kd.className] = Kd, eu[qd.className] = qd, eu[Zd.className] = Zd, eu[Pd.className] = Pd, eu[Jd.className] = Jd, eu[Xd.className] = Xd, eu[tu.className] = tu, eu[Wd.className] = Wd, eu[$d.className] = $d;
    class nu {
      static fromJSON(t, e) {
        return eu[t.__className].fromJSON(t, e);
      }
    }
    const iu = new Map();
    function ou(t, e, n) {
      let i = iu.get(t);
      i || (i = new Map(), iu.set(t, i)), i.set(e, n);
    }
    function ru(t) {
      return [t];
    }
    function su(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const i = function (t, e) {
        const n = iu.get(t);
        return n && n.has(e) ? n.get(e) : ru;
      }(t.constructor, e.constructor);
      try {
        return i(t = t.clone(), e, n);
      } catch (t) {
        throw t;
      }
    }
    function au(t, e, n) {
      t = t.slice(), e = e.slice();
      const i = new lu(n.document, n.useRelations, n.forceWeakRemove);
      i.setOriginalOperations(t), i.setOriginalOperations(e);
      const o = i.originalOperations;
      if (0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
      const r = new WeakMap();
      for (const e of t) r.set(e, 0);
      const s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      let a = 0;
      for (; a < t.length;) {
        const n = t[a],
          o = r.get(n);
        if (o == e.length) {
          a++;
          continue;
        }
        const s = e[o],
          l = su(n, s, i.getContext(n, s, !0)),
          c = su(s, n, i.getContext(s, n, !1));
        i.updateRelation(n, s), i.setOriginalOperations(l, n), i.setOriginalOperations(c, s);
        for (const t of l) r.set(t, o + c.length);
        t.splice(a, 1, ...l), e.splice(o, 1, ...c);
      }
      if (n.padWithNoOps) {
        const n = t.length - s.originalOperationsACount,
          i = e.length - s.originalOperationsBCount;
        du(t, i - n), du(e, n - i);
      }
      return cu(t, s.nextBaseVersionB), cu(e, s.nextBaseVersionA), {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
    }
    class lu {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
      }
      setOriginalOperations(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const n = e ? this.originalOperations.get(e) : null;
        for (const e of t) this.originalOperations.set(e, n || e);
      }
      updateRelation(t, e) {
        if (t instanceof qd) e instanceof $d ? t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter") : e instanceof qd && (t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter"));else if (t instanceof Wd) {
          if (e instanceof $d) t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");else if (e instanceof qd) if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");else {
            const n = hc._createFromPositionAndShift(e.sourcePosition, e.howMany);
            if (t.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(t.splitPosition)) {
              const i = n.end.offset - t.splitPosition.offset,
                o = t.splitPosition.offset - n.start.offset;
              this._setRelation(t, e, {
                howMany: i,
                offset: o
              });
            }
          }
        } else if (t instanceof $d) e instanceof $d ? (t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement")) : e instanceof Wd ? t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource") : e instanceof qd && e.howMany > 0 && (t.sourcePosition.isEqual(e.sourcePosition.getShiftedBy(e.howMany)) && this._setRelation(t, e, "mergeSourceAffected"), t.targetPosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeTargetWasBefore"));else if (t instanceof Kd) {
          const n = t.newRange;
          if (!n) return;
          if (e instanceof qd) {
            const i = hc._createFromPositionAndShift(e.sourcePosition, e.howMany),
              o = i.containsPosition(n.start) || i.start.isEqual(n.start),
              r = i.containsPosition(n.end) || i.end.isEqual(n.end);
            !o && !r || i.containsRange(n) || this._setRelation(t, e, {
              side: o ? "left" : "right",
              path: o ? n.start.path.slice() : n.end.path.slice()
            });
          } else if (e instanceof $d) {
            const i = n.start.isEqual(e.targetPosition),
              o = n.start.isEqual(e.deletionPosition),
              r = n.end.isEqual(e.deletionPosition),
              s = n.end.isEqual(e.sourcePosition);
            (i || o || r || s) && this._setRelation(t, e, {
              wasInLeftElement: i,
              wasStartBeforeMergedElement: o,
              wasEndBeforeMergedElement: r,
              wasInRightElement: s
            });
          }
        }
      }
      getContext(t, e, n) {
        return {
          aIsStrong: n,
          aWasUndone: this._wasUndone(t),
          bWasUndone: this._wasUndone(e),
          abRelation: this._useRelations ? this._getRelation(t, e) : null,
          baRelation: this._useRelations ? this._getRelation(e, t) : null,
          forceWeakRemove: this._forceWeakRemove
        };
      }
      _wasUndone(t) {
        const e = this.originalOperations.get(t);
        return e.wasUndone || this._history.isUndoneOperation(e);
      }
      _getRelation(t, e) {
        const n = this.originalOperations.get(e),
          i = this._history.getUndoneOperation(n);
        if (!i) return null;
        const o = this.originalOperations.get(t),
          r = this._relations.get(o);
        return r && r.get(i) || null;
      }
      _setRelation(t, e, n) {
        const i = this.originalOperations.get(t),
          o = this.originalOperations.get(e);
        let r = this._relations.get(i);
        r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
      }
    }
    function cu(t, e) {
      for (const n of t) n.baseVersion = e++;
    }
    function du(t, e) {
      for (let n = 0; n < e; n++) t.push(new Zd(0));
    }
    function uu(t, e, n) {
      const i = t.nodes.getNode(0).getAttribute(e);
      if (i == n) return null;
      const o = new hc(t.position, t.position.getShiftedBy(t.howMany));
      return new Qd(o, e, i, n, 0);
    }
    function hu(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }
    function mu(t, e) {
      const n = [];
      for (let i = 0; i < t.length; i++) {
        const o = t[i],
          r = new qd(o.start, o.end.offset - o.start.offset, e, 0);
        n.push(r);
        for (let e = i + 1; e < t.length; e++) t[e] = t[e]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
        e = e._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
      }
      return n;
    }
    ou(Qd, Qd, (t, e, n) => {
      if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
        const i = t.range.getDifference(e.range).map(e => new Qd(e, t.key, t.oldValue, t.newValue, 0)),
          o = t.range.getIntersection(e.range);
        return o && n.aIsStrong && i.push(new Qd(o, e.key, e.newValue, t.newValue, 0)), 0 == i.length ? [new Zd(0)] : i;
      }
      return [t];
    }), ou(Qd, Gd, (t, e) => {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        const n = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(e => new Qd(e, t.key, t.oldValue, t.newValue, t.baseVersion));
        if (e.shouldReceiveAttributes) {
          const i = uu(e, t.key, t.oldValue);
          i && n.unshift(i);
        }
        return n;
      }
      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), ou(Qd, $d, (t, e) => {
      const n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(hc._createFromPositionAndShift(e.graveyardPosition, 1));
      const i = t.range._getTransformedByMergeOperation(e);
      return i.isCollapsed || n.push(i), n.map(e => new Qd(e, t.key, t.oldValue, t.newValue, t.baseVersion));
    }), ou(Qd, qd, (t, e) => {
      const n = function (t, e) {
        const n = hc._createFromPositionAndShift(e.sourcePosition, e.howMany);
        let i = null,
          o = [];
        n.containsRange(t, !0) ? i = t : t.start.hasSameParentAs(n.start) ? (o = t.getDifference(n), i = t.getIntersection(n)) : o = [t];
        const r = [];
        for (let t of o) {
          t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
          const n = e.getMovedRangeStart(),
            i = t.start.hasSameParentAs(n),
            o = t._getTransformedByInsertion(n, e.howMany, i);
          r.push(...o);
        }
        i && r.push(i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e);
      return n.map(e => new Qd(e, t.key, t.oldValue, t.newValue, t.baseVersion));
    }), ou(Qd, Wd, (t, e) => {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];
      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        const n = t.clone();
        return n.range = new hc(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, n];
      }
      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), ou(Gd, Qd, (t, e) => {
      const n = [t];
      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        const i = uu(t, e.key, e.newValue);
        i && n.push(i);
      }
      return n;
    }), ou(Gd, Gd, (t, e, n) => (t.position.isEqual(e.position) && n.aIsStrong || (t.position = t.position._getTransformedByInsertOperation(e)), [t])), ou(Gd, qd, (t, e) => (t.position = t.position._getTransformedByMoveOperation(e), [t])), ou(Gd, Wd, (t, e) => (t.position = t.position._getTransformedBySplitOperation(e), [t])), ou(Gd, $d, (t, e) => (t.position = t.position._getTransformedByMergeOperation(e), [t])), ou(Kd, Gd, (t, e) => (t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t])), ou(Kd, Kd, (t, e, n) => {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new Zd(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }
      return [t];
    }), ou(Kd, $d, (t, e) => (t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t])), ou(Kd, qd, (t, e, n) => {
      if (t.oldRange && (t.oldRange = hc._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          const i = hc._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.end = i.end, t.newRange.start.path = n.abRelation.path, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = i.start, t.newRange.end.path = n.abRelation.path, [t];
        }
        t.newRange = hc._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }
      return [t];
    }), ou(Kd, Wd, (t, e, n) => {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          const i = t.newRange._getTransformedBySplitOperation(e);
          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = sc._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = sc._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = sc._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = sc._createAt(e.insertionPosition) : t.newRange.end = i.end, [t];
        }
        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }
      return [t];
    }), ou($d, Gd, (t, e) => (t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t])), ou($d, $d, (t, e, n) => {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          const n = e.graveyardPosition.path.slice();
          return n.push(0), t.sourcePosition = new sc(e.graveyardPosition.root, n), t.howMany = 0, [t];
        }
        return [new Zd(0)];
      }
      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        const i = "$graveyard" == t.targetPosition.root.rootName,
          o = "$graveyard" == e.targetPosition.root.rootName;
        if (o && !i || !(i && !o) && n.aIsStrong) {
          const n = e.targetPosition._getTransformedByMergeOperation(e),
            i = t.targetPosition._getTransformedByMergeOperation(e);
          return [new qd(n, t.howMany, i, 0)];
        }
        return [new Zd(0)];
      }
      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), ou($d, qd, (t, e, n) => {
      const i = hc._createFromPositionAndShift(e.sourcePosition, e.howMany);
      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition) ? [new Zd(0)] : (e.sourcePosition.getShiftedBy(e.howMany).isEqual(t.sourcePosition) ? t.sourcePosition.stickiness = "toNone" : e.targetPosition.isEqual(t.sourcePosition) && "mergeSourceAffected" == n.abRelation ? t.sourcePosition.stickiness = "toNext" : e.sourcePosition.isEqual(t.targetPosition) ? (t.targetPosition.stickiness = "toNone", t.howMany -= e.howMany) : e.targetPosition.isEqual(t.targetPosition) && "mergeTargetWasBefore" == n.abRelation ? (t.targetPosition.stickiness = "toPrevious", t.howMany += e.howMany) : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany)), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.sourcePosition.stickiness = "toPrevious", t.targetPosition.stickiness = "toNext", t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), ou($d, Wd, (t, e, n) => {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        const i = 0 != e.howMany,
          o = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
        if (i || o || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }
      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), ou(qd, Gd, (t, e) => {
      const n = hc._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];
      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), ou(qd, qd, (t, e, n) => {
      const i = hc._createFromPositionAndShift(t.sourcePosition, t.howMany),
        o = hc._createFromPositionAndShift(e.sourcePosition, e.howMany);
      let r,
        s = n.aIsStrong,
        a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), hu(t, e) && hu(e, t)) return [e.getReversed()];
      if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), mu([i], r);
      if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), mu([i], r);
      const l = J(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == l || "extension" == l) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), mu([i], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      const c = [],
        d = i.getDifference(o);
      for (const t of d) {
        t.start = t.start._getTransformedByDeletion(e.sourcePosition, e.howMany), t.end = t.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
        const n = "same" == J(t.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
          i = t._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, n);
        c.push(...i);
      }
      const u = i.getIntersection(o);
      return null !== u && s && (u.start = u.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), u.end = u.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === c.length ? c.push(u) : 1 == c.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? c.unshift(u) : c.push(u) : c.splice(1, 0, u)), 0 === c.length ? [new Zd(t.baseVersion)] : mu(c, r);
    }), ou(qd, Wd, (t, e, n) => {
      let i = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = t.targetPosition._getTransformedBySplitOperation(e));
      const o = hc._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (o.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = i, [t];
      if (o.start.hasSameParentAs(e.splitPosition) && o.containsPosition(e.splitPosition)) {
        let t = new hc(e.splitPosition, o.end);
        t = t._getTransformedBySplitOperation(e);
        return mu([new hc(o.start, e.splitPosition), t], i);
      }
      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (i = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (i = t.targetPosition);
      const r = [o._getTransformedBySplitOperation(e)];
      if (e.graveyardPosition) {
        const i = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);
        t.howMany > 1 && i && !n.aWasUndone && r.push(hc._createFromPositionAndShift(e.insertionPosition, 1));
      }
      return mu(r, i);
    }), ou(qd, $d, (t, e, n) => {
      const i = hc._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new Zd(0)];
      } else if (!n.aWasUndone) {
        const n = [];
        let i = e.graveyardPosition.clone(),
          o = e.targetPosition._getTransformedByMergeOperation(e);
        t.howMany > 1 && (n.push(new qd(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), i = i._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), o = o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));
        const r = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
          s = new qd(i, 1, r, 0),
          a = s.getMovedRangeStart().path.slice();
        a.push(0);
        const l = new sc(s.targetPosition.root, a);
        o = o._getTransformedByMove(i, r, 1);
        const c = new qd(o, e.howMany, l, 0);
        return n.push(s), n.push(c), n;
      }
      const o = hc._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);
      return t.sourcePosition = o.start, t.howMany = o.end.offset - o.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), ou(Jd, Gd, (t, e) => (t.position = t.position._getTransformedByInsertOperation(e), [t])), ou(Jd, $d, (t, e) => t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t])), ou(Jd, qd, (t, e) => (t.position = t.position._getTransformedByMoveOperation(e), [t])), ou(Jd, Jd, (t, e, n) => {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new Zd(0)];
        t.oldName = e.newName;
      }
      return [t];
    }), ou(Jd, Wd, (t, e) => {
      if ("same" == J(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        const e = new Jd(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
        return [t, e];
      }
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), ou(Xd, Xd, (t, e, n) => {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new Zd(0)];
        t.oldValue = e.newValue;
      }
      return [t];
    }), ou(tu, tu, (t, e) => t.rootName === e.rootName && t.isAdd === e.isAdd ? [new Zd(0)] : [t]), ou(Wd, Gd, (t, e) => (t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e), [t])), ou(Wd, $d, (t, e, n) => {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        const n = e.graveyardPosition.path.slice();
        n.push(0);
        const i = new sc(e.graveyardPosition.root, n),
          o = Wd.getInsertionPosition(new sc(e.graveyardPosition.root, n)),
          r = new Wd(i, 0, o, null, 0);
        return t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), t.graveyardPosition = r.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [r, t];
      }
      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), ou(Wd, qd, (t, e, n) => {
      const i = hc._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (t.graveyardPosition) {
        const o = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);
        if (!n.bWasUndone && o) {
          const n = t.splitPosition._getTransformedByMoveOperation(e),
            i = t.graveyardPosition._getTransformedByMoveOperation(e),
            o = i.path.slice();
          o.push(0);
          const r = new sc(i.root, o);
          return [new qd(n, t.howMany, r, 0)];
        }
        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }
      const o = t.splitPosition.isEqual(e.targetPosition);
      if (o && ("insertAtSource" == n.baRelation || "splitBefore" == n.abRelation)) return t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), [t];
      if (o && n.abRelation && n.abRelation.howMany) {
        const {
          howMany: e,
          offset: i
        } = n.abRelation;
        return t.howMany += e, t.splitPosition = t.splitPosition.getShiftedBy(i), [t];
      }
      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.splitPosition)) {
        const n = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
        return t.howMany -= n, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), [t];
      }
      return e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), [t];
    }), ou(Wd, Wd, (t, e, n) => {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new Zd(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new Zd(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        const i = "$graveyard" == t.splitPosition.root.rootName,
          o = "$graveyard" == e.splitPosition.root.rootName;
        if (o && !i || !(i && !o) && n.aIsStrong) {
          const n = [];
          return e.howMany && n.push(new qd(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && n.push(new qd(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), n;
        }
        return [new Zd(0)];
      }
      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];
      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        const n = e.insertionPosition.path.slice();
        n.push(0);
        const i = new sc(e.insertionPosition.root, n);
        return [t, new qd(t.insertionPosition, 1, i, 0)];
      }
      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = Wd.getInsertionPosition(t.splitPosition), [t];
    });
    class gu extends B(sc) {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        if (super(t, e, n), !this.root.is("rootElement")) throw new b("model-liveposition-root-not-rootelement", t);
        pu.call(this);
      }
      detach() {
        this.stopListening();
      }
      toPosition() {
        return new sc(this.root, this.path.slice(), this.stickiness);
      }
      static fromPosition(t, e) {
        return new this(t.root, t.path.slice(), e || t.stickiness);
      }
    }
    function pu() {
      this.listenTo(this.root.document.model, "applyOperation", (t, e) => {
        const n = e[0];
        n.isDocumentOperation && fu.call(this, n);
      }, {
        priority: "low"
      });
    }
    function fu(t) {
      const e = this.getTransformedByOperation(t);
      if (!this.isEqual(e)) {
        const t = this.toPosition();
        this.path = e.path, this.root = e.root, this.fire("change", t);
      }
    }
    gu.prototype.is = function (t) {
      return "livePosition" === t || "model:livePosition" === t || "position" == t || "model:position" === t;
    };
    class ku {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        "string" == typeof t && (t = "transparent" === t ? {
          isUndoable: !1
        } : {}, w("batch-constructor-deprecated-string-type"));
        const {
          isUndoable: e = !0,
          isLocal: n = !0,
          isUndo: i = !1,
          isTyping: o = !1
        } = t;
        this.operations = [], this.isUndoable = e, this.isLocal = n, this.isUndo = i, this.isTyping = o;
      }
      get type() {
        return w("batch-type-deprecated"), "default";
      }
      get baseVersion() {
        for (const t of this.operations) if (null !== t.baseVersion) return t.baseVersion;
        return null;
      }
      addOperation(t) {
        return t.batch = this, this.operations.push(t), t;
      }
    }
    class bu {
      constructor(t) {
        this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changedRoots = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = new Set(), this._markerCollection = t;
      }
      get isEmpty() {
        return 0 == this._changesInElement.size && 0 == this._changedMarkers.size && 0 == this._changedRoots.size;
      }
      bufferOperation(t) {
        const e = t;
        switch (e.type) {
          case "insert":
            if (this._isInInsertedElement(e.position.parent)) return;
            this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);
            break;
          case "addAttribute":
          case "removeAttribute":
          case "changeAttribute":
            for (const t of e.range.getItems({
              shallow: !0
            })) this._isInInsertedElement(t.parent) || this._markAttribute(t);
            break;
          case "remove":
          case "move":
          case "reinsert":
            {
              if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition)) return;
              const t = this._isInInsertedElement(e.sourcePosition.parent),
                n = this._isInInsertedElement(e.targetPosition.parent);
              t || this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany), n || this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
              break;
            }
          case "rename":
            {
              if (this._isInInsertedElement(e.position.parent)) return;
              this._markRemove(e.position.parent, e.position.offset, 1), this._markInsert(e.position.parent, e.position.offset, 1);
              const t = hc._createFromPositionAndShift(e.position, 1);
              for (const e of this._markerCollection.getMarkersIntersectingRange(t)) {
                const t = e.getData();
                this.bufferMarkerChange(e.name, t, t);
              }
              break;
            }
          case "split":
            {
              const t = e.splitPosition.parent;
              this._isInInsertedElement(t) || this._markRemove(t, e.splitPosition.offset, e.howMany), this._isInInsertedElement(e.insertionPosition.parent) || this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1), e.graveyardPosition && this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
              break;
            }
          case "merge":
            {
              const t = e.sourcePosition.parent;
              this._isInInsertedElement(t.parent) || this._markRemove(t.parent, t.startOffset, 1);
              const n = e.graveyardPosition.parent;
              this._markInsert(n, e.graveyardPosition.offset, 1);
              const i = e.targetPosition.parent;
              this._isInInsertedElement(i) || this._markInsert(i, e.targetPosition.offset, t.maxOffset);
              break;
            }
          case "detachRoot":
          case "addRoot":
            {
              const t = e.affectedSelectable;
              if (!t._isLoaded) return;
              if (t.isAttached() == e.isAdd) return;
              this._bufferRootStateChange(e.rootName, e.isAdd);
              break;
            }
          case "addRootAttribute":
          case "removeRootAttribute":
          case "changeRootAttribute":
            {
              if (!e.root._isLoaded) return;
              const t = e.root.rootName;
              this._bufferRootAttributeChange(t, e.key, e.oldValue, e.newValue);
              break;
            }
        }
        this._cachedChanges = null;
      }
      bufferMarkerChange(t, e, n) {
        e.range && e.range.root.is("rootElement") && !e.range.root._isLoaded && (e.range = null), n.range && n.range.root.is("rootElement") && !n.range.root._isLoaded && (n.range = null);
        let i = this._changedMarkers.get(t);
        i ? i.newMarkerData = n : (i = {
          newMarkerData: n,
          oldMarkerData: e
        }, this._changedMarkers.set(t, i)), null == i.oldMarkerData.range && null == n.range && this._changedMarkers.delete(t);
      }
      getMarkersToRemove() {
        const t = [];
        for (const [e, n] of this._changedMarkers) null != n.oldMarkerData.range && t.push({
          name: e,
          range: n.oldMarkerData.range
        });
        return t;
      }
      getMarkersToAdd() {
        const t = [];
        for (const [e, n] of this._changedMarkers) null != n.newMarkerData.range && t.push({
          name: e,
          range: n.newMarkerData.range
        });
        return t;
      }
      getChangedMarkers() {
        return Array.from(this._changedMarkers).map(_ref27 => {
          let [t, e] = _ref27;
          return {
            name: t,
            data: {
              oldRange: e.oldMarkerData.range,
              newRange: e.newMarkerData.range
            }
          };
        });
      }
      hasDataChanges() {
        if (this.getChanges().length) return !0;
        if (this._changedRoots.size > 0) return !0;
        for (const {
          newMarkerData: t,
          oldMarkerData: e
        } of this._changedMarkers.values()) {
          if (t.affectsData !== e.affectsData) return !0;
          if (t.affectsData) {
            const n = t.range && !e.range,
              i = !t.range && e.range,
              o = t.range && e.range && !t.range.isEqual(e.range);
            if (n || i || o) return !0;
          }
        }
        return !1;
      }
      getChanges() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
        let e = [];
        for (const t of this._changesInElement.keys()) {
          const n = this._changesInElement.get(t).sort((t, e) => t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1),
            i = this._elementSnapshots.get(t),
            o = wu(t.getChildren()),
            r = Au(i.length, n);
          let s = 0,
            a = 0;
          for (const n of r) if ("i" === n) e.push(this._getInsertDiff(t, s, o[s])), s++;else if ("r" === n) e.push(this._getRemoveDiff(t, s, i[a])), a++;else if ("a" === n) {
            const n = o[s].attributes,
              r = i[a].attributes;
            let l;
            if ("$text" == o[s].name) l = new hc(sc._createAt(t, s), sc._createAt(t, s + 1));else {
              const e = t.offsetToIndex(s);
              l = new hc(sc._createAt(t, s), sc._createAt(t.getChild(e), 0));
            }
            e.push(...this._getAttributesDiff(l, r, n)), s++, a++;
          } else s++, a++;
        }
        e.sort((t, e) => t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1);
        for (let t = 1, n = 0; t < e.length; t++) {
          const i = e[n],
            o = e[t],
            r = "remove" == i.type && "remove" == o.type && "$text" == i.name && "$text" == o.name && i.position.isEqual(o.position),
            s = "insert" == i.type && "insert" == o.type && "$text" == i.name && "$text" == o.name && i.position.parent == o.position.parent && i.position.offset + i.length == o.position.offset,
            a = "attribute" == i.type && "attribute" == o.type && i.position.parent == o.position.parent && i.range.isFlat && o.range.isFlat && i.position.offset + i.length == o.position.offset && i.attributeKey == o.attributeKey && i.attributeOldValue == o.attributeOldValue && i.attributeNewValue == o.attributeNewValue;
          r || s || a ? (i.length++, a && (i.range.end = i.range.end.getShiftedBy(1)), e[t] = null) : n = t;
        }
        e = e.filter(t => t);
        for (const t of e) delete t.changeCount, "attribute" == t.type && (delete t.position, delete t.length);
        return this._changeCount = 0, this._cachedChangesWithGraveyard = e, this._cachedChanges = e.filter(Cu), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
      }
      getChangedRoots() {
        return Array.from(this._changedRoots.values()).map(t => {
          const e = {
            ...t
          };
          return void 0 !== e.state && delete e.attributes, e;
        });
      }
      getRefreshedItems() {
        return new Set(this._refreshedItems);
      }
      reset() {
        this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems = new Set(), this._cachedChanges = null;
      }
      _bufferRootStateChange(t, e) {
        if (!this._changedRoots.has(t)) return void this._changedRoots.set(t, {
          name: t,
          state: e ? "attached" : "detached"
        });
        const n = this._changedRoots.get(t);
        void 0 !== n.state ? (delete n.state, void 0 === n.attributes && this._changedRoots.delete(t)) : n.state = e ? "attached" : "detached";
      }
      _bufferRootAttributeChange(t, e, n, i) {
        const o = this._changedRoots.get(t) || {
            name: t
          },
          r = o.attributes || {};
        if (r[e]) {
          const t = r[e];
          i === t.oldValue ? delete r[e] : t.newValue = i;
        } else r[e] = {
          oldValue: n,
          newValue: i
        };
        0 === Object.entries(r).length ? (delete o.attributes, void 0 === o.state && this._changedRoots.delete(t)) : (o.attributes = r, this._changedRoots.set(t, o));
      }
      _refreshItem(t) {
        if (this._isInInsertedElement(t.parent)) return;
        this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize), this._refreshedItems.add(t);
        const e = hc._createOn(t);
        for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
          const e = t.getData();
          this.bufferMarkerChange(t.name, e, e);
        }
        this._cachedChanges = null;
      }
      _bufferRootLoad(t) {
        if (t.isAttached()) {
          this._bufferRootStateChange(t.rootName, !0), this._markInsert(t, 0, t.maxOffset);
          for (const e of t.getAttributeKeys()) this._bufferRootAttributeChange(t.rootName, e, null, t.getAttribute(e));
          for (const e of this._markerCollection) if (e.getRange().root == t) {
            const t = e.getData();
            this.bufferMarkerChange(e.name, {
              ...t,
              range: null
            }, t);
          }
        }
      }
      _markInsert(t, e, n) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const i = {
          type: "insert",
          offset: e,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(t, i);
      }
      _markRemove(t, e, n) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const i = {
          type: "remove",
          offset: e,
          howMany: n,
          count: this._changeCount++
        };
        this._markChange(t, i), this._removeAllNestedChanges(t, e, n);
      }
      _markAttribute(t) {
        if (t.root.is("rootElement") && !t.root._isLoaded) return;
        const e = {
          type: "attribute",
          offset: t.startOffset,
          howMany: t.offsetSize,
          count: this._changeCount++
        };
        this._markChange(t.parent, e);
      }
      _markChange(t, e) {
        this._makeSnapshot(t);
        const n = this._getChangesForElement(t);
        this._handleChange(e, n), n.push(e);
        for (let t = 0; t < n.length; t++) n[t].howMany < 1 && (n.splice(t, 1), t--);
      }
      _getChangesForElement(t) {
        let e;
        return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
      }
      _makeSnapshot(t) {
        this._elementSnapshots.has(t) || this._elementSnapshots.set(t, wu(t.getChildren()));
      }
      _handleChange(t, e) {
        t.nodesToHandle = t.howMany;
        for (const n of e) {
          const i = t.offset + t.howMany,
            o = n.offset + n.howMany;
          if ("insert" == t.type && ("insert" == n.type && (t.offset <= n.offset ? n.offset += t.howMany : t.offset < o && (n.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == n.type && t.offset < n.offset && (n.offset += t.howMany), "attribute" == n.type)) if (t.offset <= n.offset) n.offset += t.howMany;else if (t.offset < o) {
            const o = n.howMany;
            n.howMany = t.offset - n.offset, e.unshift({
              type: "attribute",
              offset: i,
              howMany: o - n.howMany,
              count: this._changeCount++
            });
          }
          if ("remove" == t.type) {
            if ("insert" == n.type) if (i <= n.offset) n.offset -= t.howMany;else if (i <= o) {
              if (t.offset < n.offset) {
                const e = i - n.offset;
                n.offset = t.offset, n.howMany -= e, t.nodesToHandle -= e;
              } else n.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
            } else if (t.offset <= n.offset) t.nodesToHandle -= n.howMany, n.howMany = 0;else if (t.offset < o) {
              const e = o - t.offset;
              n.howMany -= e, t.nodesToHandle -= e;
            }
            if ("remove" == n.type && (i <= n.offset ? n.offset -= t.howMany : t.offset < n.offset && (t.nodesToHandle += n.howMany, n.howMany = 0)), "attribute" == n.type) if (i <= n.offset) n.offset -= t.howMany;else if (t.offset < n.offset) {
              const e = i - n.offset;
              n.offset = t.offset, n.howMany -= e;
            } else if (t.offset < o) if (i <= o) {
              const i = n.howMany;
              n.howMany = t.offset - n.offset;
              const o = i - n.howMany - t.nodesToHandle;
              e.unshift({
                type: "attribute",
                offset: t.offset,
                howMany: o,
                count: this._changeCount++
              });
            } else n.howMany -= o - t.offset;
          }
          if ("attribute" == t.type) {
            if ("insert" == n.type) if (t.offset < n.offset && i > n.offset) {
              if (i > o) {
                const t = {
                  type: "attribute",
                  offset: o,
                  howMany: i - o,
                  count: this._changeCount++
                };
                this._handleChange(t, e), e.push(t);
              }
              t.nodesToHandle = n.offset - t.offset, t.howMany = t.nodesToHandle;
            } else t.offset >= n.offset && t.offset < o && (i > o ? (t.nodesToHandle = i - o, t.offset = o) : t.nodesToHandle = 0);
            if ("remove" == n.type && t.offset < n.offset && i > n.offset) {
              const o = {
                type: "attribute",
                offset: n.offset,
                howMany: i - n.offset,
                count: this._changeCount++
              };
              this._handleChange(o, e), e.push(o), t.nodesToHandle = n.offset - t.offset, t.howMany = t.nodesToHandle;
            }
            "attribute" == n.type && (t.offset >= n.offset && i <= o ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= n.offset && i >= o && (n.howMany = 0));
          }
        }
        t.howMany = t.nodesToHandle, delete t.nodesToHandle;
      }
      _getInsertDiff(t, e, n) {
        return {
          type: "insert",
          position: sc._createAt(t, e),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getRemoveDiff(t, e, n) {
        return {
          type: "remove",
          position: sc._createAt(t, e),
          name: n.name,
          attributes: new Map(n.attributes),
          length: 1,
          changeCount: this._changeCount++,
          _element: n.element
        };
      }
      _getAttributesDiff(t, e, n) {
        const i = [];
        n = new Map(n);
        for (const [o, r] of e) {
          const e = n.has(o) ? n.get(o) : null;
          e !== r && i.push({
            type: "attribute",
            position: t.start,
            range: t.clone(),
            length: 1,
            attributeKey: o,
            attributeOldValue: r,
            attributeNewValue: e,
            changeCount: this._changeCount++
          }), n.delete(o);
        }
        for (const [e, o] of n) i.push({
          type: "attribute",
          position: t.start,
          range: t.clone(),
          length: 1,
          attributeKey: e,
          attributeOldValue: null,
          attributeNewValue: o,
          changeCount: this._changeCount++
        });
        return i;
      }
      _isInInsertedElement(t) {
        const e = t.parent;
        if (!e) return !1;
        const n = this._changesInElement.get(e),
          i = t.startOffset;
        if (n) for (const t of n) if ("insert" == t.type && i >= t.offset && i < t.offset + t.howMany) return !0;
        return this._isInInsertedElement(e);
      }
      _removeAllNestedChanges(t, e, n) {
        const i = new hc(sc._createAt(t, e), sc._createAt(t, e + n));
        for (const t of i.getItems({
          shallow: !0
        })) t.is("element") && (this._elementSnapshots.delete(t), this._changesInElement.delete(t), this._removeAllNestedChanges(t, 0, t.maxOffset));
      }
    }
    function wu(t) {
      const e = [];
      for (const n of t) if (n.is("$text")) for (let t = 0; t < n.data.length; t++) e.push({
        name: "$text",
        attributes: new Map(n.getAttributes())
      });else e.push({
        name: n.name,
        attributes: new Map(n.getAttributes()),
        element: n
      });
      return e;
    }
    function Au(t, e) {
      const n = [];
      let i = 0,
        o = 0;
      for (const t of e) {
        if (t.offset > i) {
          for (let e = 0; e < t.offset - i; e++) n.push("e");
          o += t.offset - i;
        }
        if ("insert" == t.type) {
          for (let e = 0; e < t.howMany; e++) n.push("i");
          i = t.offset + t.howMany;
        } else if ("remove" == t.type) {
          for (let e = 0; e < t.howMany; e++) n.push("r");
          i = t.offset, o += t.howMany;
        } else n.push(..."a".repeat(t.howMany).split("")), i = t.offset + t.howMany, o += t.howMany;
      }
      if (o < t) for (let e = 0; e < t - o - i; e++) n.push("e");
      return n;
    }
    function Cu(t) {
      const e = "position" in t && "$graveyard" == t.position.root.rootName,
        n = "range" in t && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }
    class _u {
      constructor() {
        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set(), this._baseVersionToOperationIndex = new Map(), this._version = 0, this._gaps = new Map();
      }
      get version() {
        return this._version;
      }
      set version(t) {
        this._operations.length && t > this._version + 1 && this._gaps.set(this._version, t), this._version = t;
      }
      get lastOperation() {
        return this._operations[this._operations.length - 1];
      }
      addOperation(t) {
        if (t.baseVersion !== this.version) throw new b("model-document-history-addoperation-incorrect-version", this, {
          operation: t,
          historyVersion: this.version
        });
        this._operations.push(t), this._version++, this._baseVersionToOperationIndex.set(t.baseVersion, this._operations.length - 1);
      }
      getOperations(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.version;
        if (!this._operations.length) return [];
        const n = this._operations[0];
        void 0 === t && (t = n.baseVersion);
        let i = e - 1;
        for (const [e, n] of this._gaps) t > e && t < n && (t = n), i > e && i < n && (i = e - 1);
        if (i < n.baseVersion || t > this.lastOperation.baseVersion) return [];
        let o = this._baseVersionToOperationIndex.get(t);
        void 0 === o && (o = 0);
        let r = this._baseVersionToOperationIndex.get(i);
        return void 0 === r && (r = this._operations.length - 1), this._operations.slice(o, r + 1);
      }
      getOperation(t) {
        const e = this._baseVersionToOperationIndex.get(t);
        if (void 0 !== e) return this._operations[e];
      }
      setOperationAsUndone(t, e) {
        this._undoPairs.set(e, t), this._undoneOperations.add(t);
      }
      isUndoingOperation(t) {
        return this._undoPairs.has(t);
      }
      isUndoneOperation(t) {
        return this._undoneOperations.has(t);
      }
      getUndoneOperation(t) {
        return this._undoPairs.get(t);
      }
      reset() {
        this._version = 0, this._undoPairs = new Map(), this._operations = [], this._undoneOperations = new Set(), this._gaps = new Map(), this._baseVersionToOperationIndex = new Map();
      }
    }
    class vu extends ic {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
        super(e), this._isAttached = !0, this._isLoaded = !0, this._document = t, this.rootName = n;
      }
      get document() {
        return this._document;
      }
      isAttached() {
        return this._isAttached;
      }
      toJSON() {
        return this.rootName;
      }
    }
    vu.prototype.is = function (t, e) {
      return e ? e === this.name && ("rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t) : "rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t || "node" === t || "model:node" === t;
    };
    const yu = "$graveyard";
    class xu extends B() {
      constructor(t) {
        super(), this.model = t, this.history = new _u(), this.selection = new Tc(this), this.roots = new Wo({
          idProperty: "rootName"
        }), this.differ = new bu(t.markers), this.isReadOnly = !1, this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", yu), this.listenTo(t, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && this.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", (t, e) => {
          const n = e[0];
          n.isDocumentOperation && this.history.addOperation(n);
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", () => {
          this._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", (t, e, n, i, o) => {
          const r = {
            ...e.getData(),
            range: i
          };
          this.differ.bufferMarkerChange(e.name, o, r), null === n && e.on("change", (t, n) => {
            const i = e.getData();
            this.differ.bufferMarkerChange(e.name, {
              ...i,
              range: n
            }, i);
          });
        }), this.registerPostFixer(t => {
          let e = !1;
          for (const n of this.roots) n.isAttached() || n.isEmpty || (t.remove(t.createRangeIn(n)), e = !0);
          for (const n of this.model.markers) n.getRange().root.isAttached() || (t.removeMarker(n), e = !0);
          return e;
        });
      }
      get version() {
        return this.history.version;
      }
      set version(t) {
        this.history.version = t;
      }
      get graveyard() {
        return this.getRoot(yu);
      }
      createRoot() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
        if (this.roots.get(e)) throw new b("model-document-createroot-name-exists", this, {
          name: e
        });
        const n = new vu(this, t, e);
        return this.roots.add(n), n;
      }
      destroy() {
        this.selection.destroy(), this.stopListening();
      }
      getRoot() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this.roots.get(t);
      }
      getRootNames() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        return this.getRoots(t).map(t => t.rootName);
      }
      getRoots() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        return this.roots.filter(e => e != this.graveyard && (t || e.isAttached()) && e._isLoaded);
      }
      registerPostFixer(t) {
        this._postFixers.add(t);
      }
      toJSON() {
        const t = ts(this);
        return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
      }
      _handleChangeBlock(t) {
        this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
      }
      _hasDocumentChangedFromTheLastChangeBlock() {
        return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
      }
      _getDefaultRoot() {
        const t = this.getRoots();
        return t.length ? t[0] : this.graveyard;
      }
      _getDefaultRange() {
        const t = this._getDefaultRoot(),
          e = this.model,
          n = e.schema,
          i = e.createPositionFromPath(t, [0]);
        return n.getNearestSelectionRange(i) || e.createRange(i);
      }
      _validateSelectionRange(t) {
        return Eu(t.start) && Eu(t.end);
      }
      _callPostFixers(t) {
        let e = !1;
        do {
          for (const n of this._postFixers) if (this.selection.refresh(), e = n(t), e) break;
        } while (e);
      }
    }
    function Eu(t) {
      const e = t.textNode;
      if (e) {
        const n = e.data,
          i = t.offset - e.startOffset;
        return !Jo(n, i) && !Xo(n, i);
      }
      return !0;
    }
    class Du extends B() {
      constructor() {
        super(...arguments), this._markers = new Map();
      }
      [Symbol.iterator]() {
        return this._markers.values();
      }
      has(t) {
        const e = t instanceof Bu ? t.name : t;
        return this._markers.has(e);
      }
      get(t) {
        return this._markers.get(t) || null;
      }
      _set(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        const o = t instanceof Bu ? t.name : t;
        if (o.includes(",")) throw new b("markercollection-incorrect-marker-name", this);
        const r = this._markers.get(o);
        if (r) {
          const t = r.getData(),
            s = r.getRange();
          let a = !1;
          return s.isEqual(e) || (r._attachLiveRange(Ec.fromRange(e)), a = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, a = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, a = !0), a && this.fire(`update:${o}`, r, s, e, t), r;
        }
        const s = Ec.fromRange(e),
          a = new Bu(o, s, n, i);
        return this._markers.set(o, a), this.fire(`update:${o}`, a, null, e, {
          ...a.getData(),
          range: null
        }), a;
      }
      _remove(t) {
        const e = t instanceof Bu ? t.name : t,
          n = this._markers.get(e);
        return !!n && (this._markers.delete(e), this.fire(`update:${e}`, n, n.getRange(), null, n.getData()), this._destroyMarker(n), !0);
      }
      _refresh(t) {
        const e = t instanceof Bu ? t.name : t,
          n = this._markers.get(e);
        if (!n) throw new b("markercollection-refresh-marker-not-exists", this);
        const i = n.getRange();
        this.fire(`update:${e}`, n, i, i, n.getData());
      }
      *getMarkersAtPosition(t) {
        for (const e of this) e.getRange().containsPosition(t) && (yield e);
      }
      *getMarkersIntersectingRange(t) {
        for (const e of this) null !== e.getRange().getIntersection(t) && (yield e);
      }
      destroy() {
        for (const t of this._markers.values()) this._destroyMarker(t);
        this._markers = null, this.stopListening();
      }
      *getMarkersGroup(t) {
        for (const e of this._markers.values()) e.name.startsWith(t + ":") && (yield e);
      }
      _destroyMarker(t) {
        t.stopListening(), t._detachLiveRange();
      }
    }
    class Bu extends B(Jl) {
      constructor(t, e, n, i) {
        super(), this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = i;
      }
      get managedUsingOperations() {
        if (!this._liveRange) throw new b("marker-destroyed", this);
        return this._managedUsingOperations;
      }
      get affectsData() {
        if (!this._liveRange) throw new b("marker-destroyed", this);
        return this._affectsData;
      }
      getData() {
        return {
          range: this.getRange(),
          affectsData: this.affectsData,
          managedUsingOperations: this.managedUsingOperations
        };
      }
      getStart() {
        if (!this._liveRange) throw new b("marker-destroyed", this);
        return this._liveRange.start.clone();
      }
      getEnd() {
        if (!this._liveRange) throw new b("marker-destroyed", this);
        return this._liveRange.end.clone();
      }
      getRange() {
        if (!this._liveRange) throw new b("marker-destroyed", this);
        return this._liveRange.toRange();
      }
      _attachLiveRange(t) {
        return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
      }
      _detachLiveRange() {
        this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
      }
    }
    Bu.prototype.is = function (t) {
      return "marker" === t || "model:marker" === t;
    };
    class Su extends Pd {
      constructor(t, e) {
        super(null), this.sourcePosition = t.clone(), this.howMany = e;
      }
      get type() {
        return "detach";
      }
      get affectedSelectable() {
        return null;
      }
      toJSON() {
        const t = super.toJSON();
        return t.sourcePosition = this.sourcePosition.toJSON(), t;
      }
      _validate() {
        if (this.sourcePosition.root.document) throw new b("detach-operation-on-document-node", this);
      }
      _execute() {
        Rd(hc._createFromPositionAndShift(this.sourcePosition, this.howMany));
      }
      static get className() {
        return "DetachOperation";
      }
    }
    class Tu extends Jl {
      constructor(t) {
        super(), this.markers = new Map(), this._children = new tc(), t && this._insertChild(0, t);
      }
      [Symbol.iterator]() {
        return this.getChildren();
      }
      get childCount() {
        return this._children.length;
      }
      get maxOffset() {
        return this._children.maxOffset;
      }
      get isEmpty() {
        return 0 === this.childCount;
      }
      get nextSibling() {
        return null;
      }
      get previousSibling() {
        return null;
      }
      get root() {
        return this;
      }
      get parent() {
        return null;
      }
      get document() {
        return null;
      }
      isAttached() {
        return !1;
      }
      getAncestors() {
        return [];
      }
      getChild(t) {
        return this._children.getNode(t);
      }
      getChildren() {
        return this._children[Symbol.iterator]();
      }
      getChildIndex(t) {
        return this._children.getNodeIndex(t);
      }
      getChildStartOffset(t) {
        return this._children.getNodeStartOffset(t);
      }
      getPath() {
        return [];
      }
      getNodeByPath(t) {
        let e = this;
        for (const n of t) e = e.getChild(e.offsetToIndex(n));
        return e;
      }
      offsetToIndex(t) {
        return this._children.offsetToIndex(t);
      }
      toJSON() {
        const t = [];
        for (const e of this._children) t.push(e.toJSON());
        return t;
      }
      static fromJSON(t) {
        const e = [];
        for (const n of t) n.name ? e.push(ic.fromJSON(n)) : e.push(ec.fromJSON(n));
        return new Tu(e);
      }
      _appendChild(t) {
        this._insertChild(this.childCount, t);
      }
      _insertChild(t, e) {
        const n = function (t) {
          if ("string" == typeof t) return [new ec(t)];
          X(t) || (t = [t]);
          return Array.from(t).map(t => "string" == typeof t ? new ec(t) : t instanceof nc ? new ec(t.data, t.getAttributes()) : t);
        }(e);
        for (const t of n) null !== t.parent && t._remove(), t.parent = this;
        this._children._insertNodes(t, n);
      }
      _removeChildren(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        const n = this._children._removeNodes(t, e);
        for (const t of n) t.parent = null;
        return n;
      }
    }
    Tu.prototype.is = function (t) {
      return "documentFragment" === t || "model:documentFragment" === t;
    };
    class Iu {
      constructor(t, e) {
        this.model = t, this.batch = e;
      }
      createText(t, e) {
        return new ec(t, e);
      }
      createElement(t, e) {
        return new ic(t, e);
      }
      createDocumentFragment() {
        return new Tu();
      }
      cloneElement(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        return t._clone(e);
      }
      insert(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (this._assertWriterUsedCorrectly(), t instanceof ec && "" == t.data) return;
        const i = sc._createAt(e, n);
        if (t.parent) {
          if (Pu(t.root, i.root)) return void this.move(hc._createOn(t), i);
          if (t.root.document) throw new b("model-writer-insert-forbidden-move", this);
          this.remove(t);
        }
        const o = i.root.document ? i.root.document.version : null,
          r = new Gd(i, t, o);
        if (t instanceof ec && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof Tu) for (const [e, n] of t.markers) {
          const t = sc._createAt(n.root, 0),
            o = {
              range: new hc(n.start._getCombined(t, i), n.end._getCombined(t, i)),
              usingOperation: !0,
              affectsData: !0
            };
          this.model.markers.has(e) ? this.updateMarker(e, o) : this.addMarker(e, o);
        }
      }
      insertText(t, e, n, i) {
        e instanceof Tu || e instanceof ic || e instanceof sc ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, i);
      }
      insertElement(t, e, n, i) {
        e instanceof Tu || e instanceof ic || e instanceof sc ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, i);
      }
      append(t, e) {
        this.insert(t, e, "end");
      }
      appendText(t, e, n) {
        e instanceof Tu || e instanceof ic ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
      }
      appendElement(t, e, n) {
        e instanceof Tu || e instanceof ic ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
      }
      setAttribute(t, e, n) {
        if (this._assertWriterUsedCorrectly(), n instanceof hc) {
          const i = n.getMinimalFlatRanges();
          for (const n of i) Mu(this, t, e, n);
        } else Lu(this, t, e, n);
      }
      setAttributes(t, e) {
        for (const [n, i] of Qo(t)) this.setAttribute(n, i, e);
      }
      removeAttribute(t, e) {
        if (this._assertWriterUsedCorrectly(), e instanceof hc) {
          const n = e.getMinimalFlatRanges();
          for (const e of n) Mu(this, t, null, e);
        } else Lu(this, t, null, e);
      }
      clearAttributes(t) {
        this._assertWriterUsedCorrectly();
        const e = t => {
          for (const e of t.getAttributeKeys()) this.removeAttribute(e, t);
        };
        if (t instanceof hc) for (const n of t.getItems()) e(n);else e(t);
      }
      move(t, e, n) {
        if (this._assertWriterUsedCorrectly(), !(t instanceof hc)) throw new b("writer-move-invalid-range", this);
        if (!t.isFlat) throw new b("writer-move-range-not-flat", this);
        const i = sc._createAt(e, n);
        if (i.isEqual(t.start)) return;
        if (this._addOperationForAffectedMarkers("move", t), !Pu(t.root, i.root)) throw new b("writer-move-different-document", this);
        const o = t.root.document ? t.root.document.version : null,
          r = new qd(t.start, t.end.offset - t.start.offset, i, o);
        this.batch.addOperation(r), this.model.applyOperation(r);
      }
      remove(t) {
        this._assertWriterUsedCorrectly();
        const e = (t instanceof hc ? t : hc._createOn(t)).getMinimalFlatRanges().reverse();
        for (const t of e) this._addOperationForAffectedMarkers("move", t), zu(t.start, t.end.offset - t.start.offset, this.batch, this.model);
      }
      merge(t) {
        this._assertWriterUsedCorrectly();
        const e = t.nodeBefore,
          n = t.nodeAfter;
        if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof ic)) throw new b("writer-merge-no-element-before", this);
        if (!(n instanceof ic)) throw new b("writer-merge-no-element-after", this);
        t.root.document ? this._merge(t) : this._mergeDetached(t);
      }
      createPositionFromPath(t, e, n) {
        return this.model.createPositionFromPath(t, e, n);
      }
      createPositionAt(t, e) {
        return this.model.createPositionAt(t, e);
      }
      createPositionAfter(t) {
        return this.model.createPositionAfter(t);
      }
      createPositionBefore(t) {
        return this.model.createPositionBefore(t);
      }
      createRange(t, e) {
        return this.model.createRange(t, e);
      }
      createRangeIn(t) {
        return this.model.createRangeIn(t);
      }
      createRangeOn(t) {
        return this.model.createRangeOn(t);
      }
      createSelection() {
        return this.model.createSelection(...arguments);
      }
      _mergeDetached(t) {
        const e = t.nodeBefore,
          n = t.nodeAfter;
        this.move(hc._createIn(n), sc._createAt(e, "end")), this.remove(n);
      }
      _merge(t) {
        const e = sc._createAt(t.nodeBefore, "end"),
          n = sc._createAt(t.nodeAfter, 0),
          i = t.root.document.graveyard,
          o = new sc(i, [0]),
          r = t.root.document.version,
          s = new $d(n, t.nodeAfter.maxOffset, e, o, r);
        this.batch.addOperation(s), this.model.applyOperation(s);
      }
      rename(t, e) {
        if (this._assertWriterUsedCorrectly(), !(t instanceof ic)) throw new b("writer-rename-not-element-instance", this);
        const n = t.root.document ? t.root.document.version : null,
          i = new Jd(sc._createBefore(t), t.name, e, n);
        this.batch.addOperation(i), this.model.applyOperation(i);
      }
      split(t, e) {
        this._assertWriterUsedCorrectly();
        let n,
          i,
          o = t.parent;
        if (!o.parent) throw new b("writer-split-element-no-parent", this);
        if (e || (e = o.parent), !t.parent.getAncestors({
          includeSelf: !0
        }).includes(e)) throw new b("writer-split-invalid-limit-element", this);
        do {
          const e = o.root.document ? o.root.document.version : null,
            r = o.maxOffset - t.offset,
            s = Wd.getInsertionPosition(t),
            a = new Wd(t, r, s, null, e);
          this.batch.addOperation(a), this.model.applyOperation(a), n || i || (n = o, i = t.parent.nextSibling), o = (t = this.createPositionAfter(t.parent)).parent;
        } while (o !== e);
        return {
          position: t,
          range: new hc(sc._createAt(n, "end"), sc._createAt(i, 0))
        };
      }
      wrap(t, e) {
        if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new b("writer-wrap-range-not-flat", this);
        const n = e instanceof ic ? e : new ic(e);
        if (n.childCount > 0) throw new b("writer-wrap-element-not-empty", this);
        if (null !== n.parent) throw new b("writer-wrap-element-attached", this);
        this.insert(n, t.start);
        const i = new hc(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
        this.move(i, sc._createAt(n, 0));
      }
      unwrap(t) {
        if (this._assertWriterUsedCorrectly(), null === t.parent) throw new b("writer-unwrap-element-no-parent", this);
        this.move(hc._createIn(t), this.createPositionAfter(t)), this.remove(t);
      }
      addMarker(t, e) {
        if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new b("writer-addmarker-no-usingoperation", this);
        const n = e.usingOperation,
          i = e.range,
          o = void 0 !== e.affectsData && e.affectsData;
        if (this.model.markers.has(t)) throw new b("writer-addmarker-marker-exists", this);
        if (!i) throw new b("writer-addmarker-no-range", this);
        return n ? (Nu(this, t, null, i, o), this.model.markers.get(t)) : this.model.markers._set(t, i, n, o);
      }
      updateMarker(t, e) {
        this._assertWriterUsedCorrectly();
        const n = "string" == typeof t ? t : t.name,
          i = this.model.markers.get(n);
        if (!i) throw new b("writer-updatemarker-marker-not-exists", this);
        if (!e) return w("writer-updatemarker-reconvert-using-editingcontroller", {
          markerName: n
        }), void this.model.markers._refresh(i);
        const o = "boolean" == typeof e.usingOperation,
          r = "boolean" == typeof e.affectsData,
          s = r ? e.affectsData : i.affectsData;
        if (!o && !e.range && !r) throw new b("writer-updatemarker-wrong-options", this);
        const a = i.getRange(),
          l = e.range ? e.range : a;
        o && e.usingOperation !== i.managedUsingOperations ? e.usingOperation ? Nu(this, n, null, l, s) : (Nu(this, n, a, null, s), this.model.markers._set(n, l, void 0, s)) : i.managedUsingOperations ? Nu(this, n, a, l, s) : this.model.markers._set(n, l, void 0, s);
      }
      removeMarker(t) {
        this._assertWriterUsedCorrectly();
        const e = "string" == typeof t ? t : t.name;
        if (!this.model.markers.has(e)) throw new b("writer-removemarker-no-marker", this);
        const n = this.model.markers.get(e);
        if (!n.managedUsingOperations) return void this.model.markers._remove(e);
        Nu(this, e, n.getRange(), null, n.affectsData);
      }
      addRoot(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
        this._assertWriterUsedCorrectly();
        const n = this.model.document.getRoot(t);
        if (n && n.isAttached()) throw new b("writer-addroot-root-exists", this);
        const i = this.model.document,
          o = new tu(t, e, !0, i, i.version);
        return this.batch.addOperation(o), this.model.applyOperation(o), this.model.document.getRoot(t);
      }
      detachRoot(t) {
        this._assertWriterUsedCorrectly();
        const e = "string" == typeof t ? this.model.document.getRoot(t) : t;
        if (!e || !e.isAttached()) throw new b("writer-detachroot-no-root", this);
        for (const t of this.model.markers) t.getRange().root === e && this.removeMarker(t);
        for (const t of e.getAttributeKeys()) this.removeAttribute(t, e);
        this.remove(this.createRangeIn(e));
        const n = this.model.document,
          i = new tu(e.rootName, e.name, !1, n, n.version);
        this.batch.addOperation(i), this.model.applyOperation(i);
      }
      setSelection() {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...arguments);
      }
      setSelectionFocus(t, e) {
        this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
      }
      setSelectionAttribute(t, e) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else for (const [e, n] of Qo(t)) this._setSelectionAttribute(e, n);
      }
      removeSelectionAttribute(t) {
        if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else for (const e of t) this._removeSelectionAttribute(e);
      }
      overrideSelectionGravity() {
        return this.model.document.selection._overrideGravity();
      }
      restoreSelectionGravity(t) {
        this.model.document.selection._restoreGravity(t);
      }
      _setSelectionAttribute(t, e) {
        const n = this.model.document.selection;
        if (n.isCollapsed && n.anchor.parent.isEmpty) {
          const i = Tc._getStoreAttributeKey(t);
          this.setAttribute(i, e, n.anchor.parent);
        }
        n._setAttribute(t, e);
      }
      _removeSelectionAttribute(t) {
        const e = this.model.document.selection;
        if (e.isCollapsed && e.anchor.parent.isEmpty) {
          const n = Tc._getStoreAttributeKey(t);
          this.removeAttribute(n, e.anchor.parent);
        }
        e._removeAttribute(t);
      }
      _assertWriterUsedCorrectly() {
        if (this.model._currentWriter !== this) throw new b("writer-incorrect-use", this);
      }
      _addOperationForAffectedMarkers(t, e) {
        for (const n of this.model.markers) {
          if (!n.managedUsingOperations) continue;
          const i = n.getRange();
          let o = !1;
          if ("move" === t) {
            const t = e;
            o = t.containsPosition(i.start) || t.start.isEqual(i.start) || t.containsPosition(i.end) || t.end.isEqual(i.end);
          } else {
            const t = e,
              n = t.nodeBefore,
              r = t.nodeAfter,
              s = i.start.parent == n && i.start.isAtEnd,
              a = i.end.parent == r && 0 == i.end.offset,
              l = i.end.nodeAfter == r,
              c = i.start.nodeAfter == r;
            o = s || a || l || c;
          }
          o && this.updateMarker(n.name, {
            range: i
          });
        }
      }
    }
    function Mu(t, e, n, i) {
      const o = t.model,
        r = o.document;
      let s,
        a,
        l,
        c = i.start;
      for (const t of i.getWalker({
        shallow: !0
      })) l = t.item.getAttribute(e), s && a != l && (a != n && d(), c = s), s = t.nextPosition, a = l;
      function d() {
        const i = new hc(c, s),
          l = i.root.document ? r.version : null,
          d = new Qd(i, e, a, n, l);
        t.batch.addOperation(d), o.applyOperation(d);
      }
      s instanceof sc && s != c && a != n && d();
    }
    function Lu(t, e, n, i) {
      const o = t.model,
        r = o.document,
        s = i.getAttribute(e);
      let a, l;
      if (s != n) {
        if (i.root === i) {
          const t = i.document ? r.version : null;
          l = new Xd(i, e, s, n, t);
        } else {
          a = new hc(sc._createBefore(i), t.createPositionAfter(i));
          const o = a.root.document ? r.version : null;
          l = new Qd(a, e, s, n, o);
        }
        t.batch.addOperation(l), o.applyOperation(l);
      }
    }
    function Nu(t, e, n, i, o) {
      const r = t.model,
        s = r.document,
        a = new Kd(e, n, i, r.markers, !!o, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }
    function zu(t, e, n, i) {
      let o;
      if (t.root.document) {
        const n = i.document,
          r = new sc(n.graveyard, [0]);
        o = new qd(t, e, r, n.version);
      } else o = new Su(t, e);
      n.addOperation(o), i.applyOperation(o);
    }
    function Pu(t, e) {
      return t === e || t instanceof vu && e instanceof vu;
    }
    function Vu(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) return;
      const i = e.getFirstRange();
      if ("$graveyard" == i.root.rootName) return;
      const o = t.schema;
      t.change(t => {
        if (!n.doNotResetEntireContent && function (t, e) {
          const n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          const i = e.getFirstRange();
          if (i.start.parent == i.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(o, e)) return void function (t, e) {
          const n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), ju(t, t.createPositionAt(n, 0), e);
        }(t, e);
        const r = {};
        if (!n.doNotAutoparagraph) {
          const t = e.getSelectedElement();
          t && Object.assign(r, o.getAttributesWithProperty(t, "copyOnReplace", !0));
        }
        const [s, a] = function (t) {
          const e = t.root.document.model,
            n = t.start;
          let i = t.end;
          if (e.hasContent(t, {
            ignoreMarkers: !0
          })) {
            const n = function (t) {
              const e = t.parent,
                n = e.root.document.model.schema,
                i = e.getAncestors({
                  parentFirst: !0,
                  includeSelf: !0
                });
              for (const t of i) {
                if (n.isLimit(t)) return null;
                if (n.isBlock(t)) return t;
              }
            }(i);
            if (n && i.isTouching(e.createPositionAt(n, 0))) {
              const n = e.createSelection(t);
              e.modifySelection(n, {
                direction: "backward"
              });
              const o = n.getLastPosition(),
                r = e.createRange(o, i);
              e.hasContent(r, {
                ignoreMarkers: !0
              }) || (i = o);
            }
          }
          return [gu.fromPosition(n, "toPrevious"), gu.fromPosition(i, "toNext")];
        }(i);
        s.isTouching(a) || t.remove(t.createRange(s, a)), n.leaveUnmerged || (!function (t, e, n) {
          const i = t.model;
          if (!Ou(t.model.schema, e, n)) return;
          const [o, r] = function (t, e) {
            const n = t.getAncestors(),
              i = e.getAncestors();
            let o = 0;
            for (; n[o] && n[o] == i[o];) o++;
            return [n[o], i[o]];
          }(e, n);
          if (!o || !r) return;
          !i.hasContent(o, {
            ignoreMarkers: !0
          }) && i.hasContent(r, {
            ignoreMarkers: !0
          }) ? Fu(t, e, n, o.parent) : Ru(t, e, n, o.parent);
        }(t, s, a), o.removeDisallowedAttributes(s.parent.getChildren(), t)), Hu(t, e, s), !n.doNotAutoparagraph && function (t, e) {
          const n = t.checkChild(e, "$text"),
            i = t.checkChild(e, "paragraph");
          return !n && i;
        }(o, s) && ju(t, s, e, r), s.detach(), a.detach();
      });
    }
    function Ru(t, e, n, i) {
      const o = e.parent,
        r = n.parent;
      if (o != i && r != i) {
        for (e = t.createPositionAfter(o), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(r, e), t.merge(e); n.parent.isEmpty;) {
          const e = n.parent;
          n = t.createPositionBefore(e), t.remove(e);
        }
        Ou(t.model.schema, e, n) && Ru(t, e, n, i);
      }
    }
    function Fu(t, e, n, i) {
      const o = e.parent,
        r = n.parent;
      if (o != i && r != i) {
        for (e = t.createPositionAfter(o), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(o, n); e.parent.isEmpty;) {
          const n = e.parent;
          e = t.createPositionBefore(n), t.remove(n);
        }
        n = t.createPositionBefore(r), function (t, e) {
          const n = e.nodeBefore,
            i = e.nodeAfter;
          n.name != i.name && t.rename(n, i.name);
          t.clearAttributes(n), t.setAttributes(Object.fromEntries(i.getAttributes()), n), t.merge(e);
        }(t, n), Ou(t.model.schema, e, n) && Fu(t, e, n, i);
      }
    }
    function Ou(t, e, n) {
      const i = e.parent,
        o = n.parent;
      return i != o && !t.isLimit(i) && !t.isLimit(o) && function (t, e, n) {
        const i = new hc(t, e);
        for (const t of i.getWalker()) if (n.isLimit(t.item)) return !1;
        return !0;
      }(e, n, t);
    }
    function ju(t, e, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const o = t.createElement("paragraph");
      t.model.schema.setAllowedAttributes(o, i, t), t.insert(o, e), Hu(t, n, t.createPositionAt(o, 0));
    }
    function Hu(t, e, n) {
      e instanceof Tc ? t.setSelection(n) : e.setTo(n);
    }
    function Uu(t, e) {
      const n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(t => e.createRangeOn(t)).filter(e => (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end))).forEach(t => {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(t => {
        let n = t;
        for (; n.parent && n.isEmpty;) {
          const t = e.createRangeOn(n);
          n = n.parent, e.remove(t);
        }
      });
    }
    class qu {
      constructor(t, e, n) {
        this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null, this._nodeToSelect = null, this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._documentFragment = e.createDocumentFragment(), this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0);
      }
      handleNodes(t) {
        for (const e of Array.from(t)) this._handleNode(e);
        this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
      }
      _updateLastNodeFromAutoParagraph(t) {
        const e = this.writer.createPositionAfter(this._lastNode),
          n = this.writer.createPositionAfter(t);
        if (n.isAfter(e)) {
          if (this._lastNode = t, this.position.parent != t || !this.position.isAtEnd) throw new b("insertcontent-invalid-insertion-position", this);
          this.position = n, this._setAffectedBoundaries(this.position);
        }
      }
      getSelectionRange() {
        return this._nodeToSelect ? hc._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
      }
      getAffectedRange() {
        return this._affectedStart ? new hc(this._affectedStart, this._affectedEnd) : null;
      }
      destroy() {
        this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
      }
      _handleNode(t) {
        if (this.schema.isObject(t)) return void this._handleObject(t);
        let e = this._checkAndAutoParagraphToAllowedPosition(t);
        e || (e = this._checkAndSplitToAllowedPosition(t), e) ? (this._appendToFragment(t), this._firstNode || (this._firstNode = t), this._lastNode = t) : this._handleDisallowedNode(t);
      }
      _insertPartialFragment() {
        if (this._documentFragment.isEmpty) return;
        const t = gu.fromPosition(this.position, "toNext");
        this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t.toPosition(), t.detach();
      }
      _handleObject(t) {
        this._checkAndSplitToAllowedPosition(t) ? this._appendToFragment(t) : this._tryAutoparagraphing(t);
      }
      _handleDisallowedNode(t) {
        t.is("element") ? this.handleNodes(t.getChildren()) : this._tryAutoparagraphing(t);
      }
      _appendToFragment(t) {
        if (!this.schema.checkChild(this.position, t)) throw new b("insertcontent-wrong-position", this, {
          node: t,
          position: this.position
        });
        this.writer.insert(t, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = t : this._nodeToSelect = null, this._filterAttributesOf.push(t);
      }
      _setAffectedBoundaries(t) {
        this._affectedStart || (this._affectedStart = gu.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = gu.fromPosition(t, "toNext"));
      }
      _mergeOnLeft() {
        const t = this._firstNode;
        if (!(t instanceof ic)) return;
        if (!this._canMergeLeft(t)) return;
        const e = gu._createBefore(t);
        e.stickiness = "toNext";
        const n = gu.fromPosition(this.position, "toNext");
        this._affectedStart.isEqual(e) && (this._affectedStart.detach(), this._affectedStart = gu._createAt(e.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = gu._createAt(e.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
      }
      _mergeOnRight() {
        const t = this._lastNode;
        if (!(t instanceof ic)) return;
        if (!this._canMergeRight(t)) return;
        const e = gu._createAfter(t);
        if (e.stickiness = "toNext", !this.position.isEqual(e)) throw new b("insertcontent-invalid-insertion-position", this);
        this.position = sc._createAt(e.nodeBefore, "end");
        const n = gu.fromPosition(this.position, "toPrevious");
        this._affectedEnd.isEqual(e) && (this._affectedEnd.detach(), this._affectedEnd = gu._createAt(e.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = gu._createAt(e.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
      }
      _canMergeLeft(t) {
        const e = t.previousSibling;
        return e instanceof ic && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t);
      }
      _canMergeRight(t) {
        const e = t.nextSibling;
        return e instanceof ic && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e);
      }
      _tryAutoparagraphing(t) {
        const e = this.writer.createElement("paragraph");
        this._getAllowedIn(this.position.parent, e) && this.schema.checkChild(e, t) && (e._appendChild(t), this._handleNode(e));
      }
      _checkAndAutoParagraphToAllowedPosition(t) {
        if (this.schema.checkChild(this.position.parent, t)) return !0;
        if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) return !1;
        this._insertPartialFragment();
        const e = this.writer.createElement("paragraph");
        return this.writer.insert(e, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e, this.position = this.writer.createPositionAt(e, 0), !0;
      }
      _checkAndSplitToAllowedPosition(t) {
        const e = this._getAllowedIn(this.position.parent, t);
        if (!e) return !1;
        for (e != this.position.parent && this._insertPartialFragment(); e != this.position.parent;) if (this.position.isAtStart) {
          const t = this.position.parent;
          this.position = this.writer.createPositionBefore(t), t.isEmpty && t.parent === e && this.writer.remove(t);
        } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
          const t = this.writer.createPositionAfter(this.position.parent);
          this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = t, this.canMergeWith.add(this.position.nodeAfter);
        }
        return !0;
      }
      _getAllowedIn(t, e) {
        return this.schema.checkChild(t, e) ? t : this.schema.isLimit(t) ? null : this._getAllowedIn(t.parent, e);
      }
    }
    function Gu(t, e, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!t.schema.isObject(e)) throw new b("insertobject-element-not-an-object", t, {
        object: e
      });
      const o = n || t.document.selection;
      let r = o;
      i.findOptimalPosition && t.schema.isBlock(e) && (r = t.createSelection(t.schema.findOptimalInsertionRange(o, i.findOptimalPosition)));
      const s = $o(o.getSelectedBlocks()),
        a = {};
      return s && Object.assign(a, t.schema.getAttributesWithProperty(s, "copyOnReplace", !0)), t.change(n => {
        r.isCollapsed || t.deleteContent(r, {
          doNotAutoparagraph: !0
        });
        let o = e;
        const s = r.anchor.parent;
        !t.schema.checkChild(s, e) && t.schema.checkChild(s, "paragraph") && t.schema.checkChild("paragraph", e) && (o = n.createElement("paragraph"), n.insert(e, o)), t.schema.setAllowedAttributes(o, a, n);
        const l = t.insertContent(o, r);
        return l.isCollapsed || i.setSelection && function (t, e, n, i) {
          const o = t.model;
          if ("on" == n) return void t.setSelection(e, "on");
          if ("after" != n) throw new b("insertobject-invalid-place-parameter-value", o);
          let r = e.nextSibling;
          if (o.schema.isInline(e)) return void t.setSelection(e, "after");
          const s = r && o.schema.checkChild(r, "$text");
          !s && o.schema.checkChild(e.parent, "paragraph") && (r = t.createElement("paragraph"), o.schema.setAllowedAttributes(r, i, t), o.insertContent(r, t.createPositionAfter(e)));
          r && t.setSelection(r, 0);
        }(n, e, i.setSelection, a), l;
      });
    }
    function Wu(t, e) {
      const {
          isForward: n,
          walker: i,
          unit: o,
          schema: r,
          treatEmojiAsSingleUnit: s
        } = t,
        {
          type: a,
          item: l,
          nextPosition: c
        } = e;
      if ("text" == a) return "word" === t.unit ? function (t, e) {
        let n = t.position.textNode;
        n || (n = e ? t.position.nodeAfter : t.position.nodeBefore);
        for (; n && n.is("$text");) {
          const i = t.position.offset - n.startOffset;
          if (Yu(n, i, e)) n = e ? t.position.nodeAfter : t.position.nodeBefore;else {
            if (Ku(n.data, i, e)) break;
            t.next();
          }
        }
        return t.position;
      }(i, n) : function (t, e, n) {
        const i = t.position.textNode;
        if (i) {
          const o = i.data;
          let r = t.position.offset - i.startOffset;
          for (; Jo(o, r) || "character" == e && Xo(o, r) || n && er(o, r);) t.next(), r = t.position.offset - i.startOffset;
        }
        return t.position;
      }(i, o, s);
      if (a == (n ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(l)) return sc._createAt(l, n ? "after" : "before");
        if (r.checkChild(c, "$text")) return c;
      } else {
        if (r.isLimit(l)) return void i.skip(() => !0);
        if (r.checkChild(c, "$text")) return c;
      }
    }
    function $u(t, e) {
      const n = t.root,
        i = sc._createAt(n, e ? "end" : 0);
      return e ? new hc(t, i) : new hc(i, t);
    }
    function Ku(t, e, n) {
      const i = e + (n ? 0 : -1);
      return ' ,.?!:;"-()'.includes(t.charAt(i));
    }
    function Yu(t, e, n) {
      return e === (n ? t.offsetSize : 0);
    }
    class Qu extends q() {
      constructor() {
        super(), this.markers = new Du(), this.document = new xu(this), this.schema = new gd(), this._pendingChanges = [], this._currentWriter = null, ["deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(t => this.decorate(t)), this.on("applyOperation", (t, e) => {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$container", {
          allowIn: ["$root", "$container"]
        }), this.schema.register("$block", {
          allowIn: ["$root", "$container"],
          isBlock: !0
        }), this.schema.register("$blockObject", {
          allowWhere: "$block",
          isBlock: !0,
          isObject: !0
        }), this.schema.register("$inlineObject", {
          allowWhere: "$text",
          allowAttributesOf: "$text",
          isInline: !0,
          isObject: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0,
          isContent: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$documentFragment", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$marker"), this.schema.addChildCheck((t, e) => {
          if ("$marker" === e.name) return !0;
        }), sd(this), this.document.registerPostFixer(Qc), this.on("insertContent", (t, _ref28) => {
          let [e, n] = _ref28;
          t.return = function (t, e, n) {
            return t.change(i => {
              const o = n || t.document.selection;
              o.isCollapsed || t.deleteContent(o, {
                doNotAutoparagraph: !0
              });
              const r = new qu(t, i, o.anchor),
                s = [];
              let a;
              if (e.is("documentFragment")) {
                if (e.markers.size) {
                  const t = [];
                  for (const [n, i] of e.markers) {
                    const {
                        start: e,
                        end: o
                      } = i,
                      r = e.isEqual(o);
                    t.push({
                      position: e,
                      name: n,
                      isCollapsed: r
                    }, {
                      position: o,
                      name: n,
                      isCollapsed: r
                    });
                  }
                  t.sort((_ref29, _ref30) => {
                    let {
                      position: t
                    } = _ref29;
                    let {
                      position: e
                    } = _ref30;
                    return t.isBefore(e) ? 1 : -1;
                  });
                  for (const {
                    position: n,
                    name: o,
                    isCollapsed: r
                  } of t) {
                    let t = null,
                      a = null;
                    const l = n.parent === e && n.isAtStart,
                      c = n.parent === e && n.isAtEnd;
                    l || c ? r && (a = l ? "start" : "end") : (t = i.createElement("$marker"), i.insert(t, n)), s.push({
                      name: o,
                      element: t,
                      collapsed: a
                    });
                  }
                }
                a = e.getChildren();
              } else a = [e];
              r.handleNodes(a);
              let l = r.getSelectionRange();
              if (e.is("documentFragment") && s.length) {
                const t = l ? Ec.fromRange(l) : null,
                  e = {};
                for (let t = s.length - 1; t >= 0; t--) {
                  const {
                      name: n,
                      element: o,
                      collapsed: a
                    } = s[t],
                    l = !e[n];
                  if (l && (e[n] = []), o) {
                    const t = i.createPositionAt(o, "before");
                    e[n].push(t), i.remove(o);
                  } else {
                    const t = r.getAffectedRange();
                    if (!t) {
                      a && e[n].push(r.position);
                      continue;
                    }
                    a ? e[n].push(t[a]) : e[n].push(l ? t.start : t.end);
                  }
                }
                for (const [t, [n, o]] of Object.entries(e)) n && o && n.root === o.root && n.root.document && !i.model.markers.has(t) && i.addMarker(t, {
                  usingOperation: !0,
                  affectsData: !0,
                  range: new hc(n, o)
                });
                t && (l = t.toRange(), t.detach());
              }
              l && (o instanceof Tc ? i.setSelection(l) : o.setTo(l));
              const c = r.getAffectedRange() || t.createRange(o.anchor);
              return r.destroy(), c;
            });
          }(this, e, n);
        }), this.on("insertObject", (t, _ref31) => {
          let [e, n, i] = _ref31;
          t.return = Gu(this, e, n, i);
        }), this.on("canEditAt", t => {
          const e = !this.document.isReadOnly;
          t.return = e, e || t.stop();
        });
      }
      change(t) {
        try {
          return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
            batch: new ku(),
            callback: t
          }), this._runPendingChanges()[0]) : t(this._currentWriter);
        } catch (t) {
          b.rethrowUnexpectedError(t, this);
        }
      }
      enqueueChange(t, e) {
        try {
          t ? "function" == typeof t ? (e = t, t = new ku()) : t instanceof ku || (t = new ku(t)) : t = new ku(), this._pendingChanges.push({
            batch: t,
            callback: e
          }), 1 == this._pendingChanges.length && this._runPendingChanges();
        } catch (t) {
          b.rethrowUnexpectedError(t, this);
        }
      }
      applyOperation(t) {
        t._execute();
      }
      insertContent(t, e, n) {
        const o = Zu(e, n);
        for (var _len25 = arguments.length, i = new Array(_len25 > 3 ? _len25 - 3 : 0), _key25 = 3; _key25 < _len25; _key25++) {
          i[_key25 - 3] = arguments[_key25];
        }
        return this.fire("insertContent", [t, o, n, ...i]);
      }
      insertObject(t, e, n, i) {
        const r = Zu(e, n);
        for (var _len26 = arguments.length, o = new Array(_len26 > 4 ? _len26 - 4 : 0), _key26 = 4; _key26 < _len26; _key26++) {
          o[_key26 - 4] = arguments[_key26];
        }
        return this.fire("insertObject", [t, r, i, i, ...o]);
      }
      deleteContent(t, e) {
        Vu(this, t, e);
      }
      modifySelection(t, e) {
        !function (t, e) {
          let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          const i = t.schema,
            o = "backward" != n.direction,
            r = n.unit ? n.unit : "character",
            s = !!n.treatEmojiAsSingleUnit,
            a = e.focus,
            l = new oc({
              boundaries: $u(a, o),
              singleCharacters: !0,
              direction: o ? "forward" : "backward"
            }),
            c = {
              walker: l,
              schema: i,
              isForward: o,
              unit: r,
              treatEmojiAsSingleUnit: s
            };
          let d;
          for (; d = l.next();) {
            if (d.done) return;
            const n = Wu(c, d.value);
            if (n) return void (e instanceof Tc ? t.change(t => {
              t.setSelectionFocus(n);
            }) : e.setFocus(n));
          }
        }(this, t, e);
      }
      getSelectedContent(t) {
        return function (t, e) {
          return t.change(t => {
            const n = t.createDocumentFragment(),
              i = e.getFirstRange();
            if (!i || i.isCollapsed) return n;
            const o = i.start.root,
              r = i.start.getCommonPath(i.end),
              s = o.getNodeByPath(r);
            let a;
            a = i.start.parent == i.end.parent ? i : t.createRange(t.createPositionAt(s, i.start.path[r.length]), t.createPositionAt(s, i.end.path[r.length] + 1));
            const l = a.end.offset - a.start.offset;
            for (const e of a.getItems({
              shallow: !0
            })) e.is("$textProxy") ? t.appendText(e.data, e.getAttributes(), n) : t.append(t.cloneElement(e, !0), n);
            if (a != i) {
              const e = i._getTransformedByMove(a.start, t.createPositionAt(n, 0), l)[0],
                o = t.createRange(t.createPositionAt(n, 0), e.start);
              Uu(t.createRange(e.end, t.createPositionAt(n, "end")), t), Uu(o, t);
            }
            return n;
          });
        }(this, t);
      }
      hasContent(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = t instanceof hc ? t : hc._createIn(t);
        if (n.isCollapsed) return !1;
        const {
          ignoreWhitespaces: i = !1,
          ignoreMarkers: o = !1
        } = e;
        if (!o) for (const t of this.markers.getMarkersIntersectingRange(n)) if (t.affectsData) return !0;
        for (const t of n.getItems()) if (this.schema.isContent(t)) {
          if (!t.is("$textProxy")) return !0;
          if (!i) return !0;
          if (-1 !== t.data.search(/\S/)) return !0;
        }
        return !1;
      }
      canEditAt(t) {
        const e = Zu(t);
        return this.fire("canEditAt", [e]);
      }
      createPositionFromPath(t, e, n) {
        return new sc(t, e, n);
      }
      createPositionAt(t, e) {
        return sc._createAt(t, e);
      }
      createPositionAfter(t) {
        return sc._createAfter(t);
      }
      createPositionBefore(t) {
        return sc._createBefore(t);
      }
      createRange(t, e) {
        return new hc(t, e);
      }
      createRangeIn(t) {
        return hc._createIn(t);
      }
      createRangeOn(t) {
        return hc._createOn(t);
      }
      createSelection() {
        for (var _len27 = arguments.length, t = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
          t[_key27] = arguments[_key27];
        }
        return new wc(...t);
      }
      createBatch(t) {
        return new ku(t);
      }
      createOperationFromJSON(t) {
        return nu.fromJSON(t, this.document);
      }
      destroy() {
        this.document.destroy(), this.stopListening();
      }
      _runPendingChanges() {
        const t = [];
        this.fire("_beforeChanges");
        try {
          for (; this._pendingChanges.length;) {
            const e = this._pendingChanges[0].batch;
            this._currentWriter = new Iu(this, e);
            const n = this._pendingChanges[0].callback(this._currentWriter);
            t.push(n), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }
        } finally {
          this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
        }
        return t;
      }
    }
    function Zu(t, e) {
      if (t) return t instanceof wc || t instanceof Tc ? t : t instanceof Xl ? e || 0 === e ? new wc(t, e) : t.is("rootElement") ? new wc(t, "in") : new wc(t, "on") : new wc(t);
    }
    class Ju extends il {
      constructor() {
        super(...arguments), this.domEventType = "click";
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class Xu extends il {
      constructor() {
        super(...arguments), this.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class th {
      constructor(t) {
        this.document = t;
      }
      createDocumentFragment(t) {
        return new fa(this.document, t);
      }
      createElement(t, e, n) {
        return new Rs(this.document, t, e, n);
      }
      createText(t) {
        return new ns(this.document, t);
      }
      clone(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return t._clone(e);
      }
      appendChild(t, e) {
        return e._appendChild(t);
      }
      insertChild(t, e, n) {
        return n._insertChild(t, e);
      }
      removeChildren(t, e, n) {
        return n._removeChildren(t, e);
      }
      remove(t) {
        const e = t.parent;
        return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
      }
      replace(t, e) {
        const n = t.parent;
        if (n) {
          const i = n.getChildIndex(t);
          return this.removeChildren(i, 1, n), this.insertChild(i, e, n), !0;
        }
        return !1;
      }
      unwrapElement(t) {
        const e = t.parent;
        if (e) {
          const n = e.getChildIndex(t);
          this.remove(t), this.insertChild(n, t.getChildren(), e);
        }
      }
      rename(t, e) {
        const n = new Rs(this.document, t, e.getAttributes(), e.getChildren());
        return this.replace(e, n) ? n : null;
      }
      setAttribute(t, e, n) {
        n._setAttribute(t, e);
      }
      removeAttribute(t, e) {
        e._removeAttribute(t);
      }
      addClass(t, e) {
        e._addClass(t);
      }
      removeClass(t, e) {
        e._removeClass(t);
      }
      setStyle(t, e, n) {
        yt(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
      }
      removeStyle(t, e) {
        e._removeStyle(t);
      }
      setCustomProperty(t, e, n) {
        n._setCustomProperty(t, e);
      }
      removeCustomProperty(t, e) {
        return e._removeCustomProperty(t);
      }
      createPositionAt(t, e) {
        return Ws._createAt(t, e);
      }
      createPositionAfter(t) {
        return Ws._createAfter(t);
      }
      createPositionBefore(t) {
        return Ws._createBefore(t);
      }
      createRange(t, e) {
        return new $s(t, e);
      }
      createRangeOn(t) {
        return $s._createOn(t);
      }
      createRangeIn(t) {
        return $s._createIn(t);
      }
      createSelection() {
        for (var _len28 = arguments.length, t = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
          t[_key28] = arguments[_key28];
        }
        return new Ys(...t);
      }
    }
    const eh = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
      nh = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
      ih = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
      oh = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
      rh = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
      sh = /\w+\((?:[^()]|\([^()]*\))*\)|\S+/gi,
      ah = new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "activeborder", "activecaption", "appworkspace", "background", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "captiontext", "graytext", "highlight", "highlighttext", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infobackground", "infotext", "menu", "menutext", "scrollbar", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "window", "windowframe", "windowtext", "rebeccapurple", "currentcolor", "transparent"]);
    function lh(t) {
      return t.startsWith("#") ? eh.test(t) : t.startsWith("rgb") ? nh.test(t) || ih.test(t) : t.startsWith("hsl") ? oh.test(t) || rh.test(t) : ah.has(t.toLowerCase());
    }
    const ch = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"];
    function dh(t) {
      return ch.includes(t);
    }
    const uh = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
    function hh(t) {
      return uh.test(t);
    }
    const mh = /^[+-]?[0-9]*([.][0-9]+)?%$/;
    function gh(t) {
      return mh.test(t);
    }
    const ph = ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"];
    function fh(t) {
      return ph.includes(t);
    }
    const kh = ["center", "top", "bottom", "left", "right"];
    function bh(t) {
      return kh.includes(t);
    }
    const wh = ["fixed", "scroll", "local"];
    function Ah(t) {
      return wh.includes(t);
    }
    const Ch = /^url\(/;
    function _h(t) {
      return Ch.test(t);
    }
    function vh() {
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      if ("" === t) return {
        top: void 0,
        right: void 0,
        bottom: void 0,
        left: void 0
      };
      const e = Dh(t),
        n = e[0],
        i = e[2] || n,
        o = e[1] || n;
      return {
        top: n,
        bottom: i,
        right: o,
        left: e[3] || o
      };
    }
    function yh(t) {
      return e => {
        const {
            top: n,
            right: i,
            bottom: o,
            left: r
          } = e,
          s = [];
        return [n, i, r, o].every(t => !!t) ? s.push([t, xh(e)]) : (n && s.push([t + "-top", n]), i && s.push([t + "-right", i]), o && s.push([t + "-bottom", o]), r && s.push([t + "-left", r])), s;
      };
    }
    function xh(_ref32) {
      let {
        top: t,
        right: e,
        bottom: n,
        left: i
      } = _ref32;
      const o = [];
      return i !== e ? o.push(t, e, n, i) : n !== t ? o.push(t, e, n) : e !== t ? o.push(t, e) : o.push(t), o.join(" ");
    }
    function Eh(t) {
      return e => ({
        path: t,
        value: vh(e)
      });
    }
    function Dh(t) {
      const e = t.matchAll(sh);
      return Array.from(e).map(t => t[0]);
    }
    function Bh(t) {
      t.setNormalizer("background", t => {
        const e = {},
          n = Dh(t);
        for (const t of n) fh(t) ? (e.repeat = e.repeat || [], e.repeat.push(t)) : bh(t) ? (e.position = e.position || [], e.position.push(t)) : Ah(t) ? e.attachment = t : lh(t) ? e.color = t : _h(t) && (e.image = t);
        return {
          path: "background",
          value: e
        };
      }), t.setNormalizer("background-color", t => ({
        path: "background.color",
        value: t
      })), t.setReducer("background", t => {
        const e = [];
        return e.push(["background-color", t.color]), e;
      }), t.setStyleRelation("background", ["background-color"]);
    }
    function Sh(t) {
      t.setNormalizer("border", t => {
        const {
          color: e,
          style: n,
          width: i
        } = Ph(t);
        return {
          path: "border",
          value: {
            color: vh(e),
            style: vh(n),
            width: vh(i)
          }
        };
      }), t.setNormalizer("border-top", Th("top")), t.setNormalizer("border-right", Th("right")), t.setNormalizer("border-bottom", Th("bottom")), t.setNormalizer("border-left", Th("left")), t.setNormalizer("border-color", Ih("color")), t.setNormalizer("border-width", Ih("width")), t.setNormalizer("border-style", Ih("style")), t.setNormalizer("border-top-color", Lh("color", "top")), t.setNormalizer("border-top-style", Lh("style", "top")), t.setNormalizer("border-top-width", Lh("width", "top")), t.setNormalizer("border-right-color", Lh("color", "right")), t.setNormalizer("border-right-style", Lh("style", "right")), t.setNormalizer("border-right-width", Lh("width", "right")), t.setNormalizer("border-bottom-color", Lh("color", "bottom")), t.setNormalizer("border-bottom-style", Lh("style", "bottom")), t.setNormalizer("border-bottom-width", Lh("width", "bottom")), t.setNormalizer("border-left-color", Lh("color", "left")), t.setNormalizer("border-left-style", Lh("style", "left")), t.setNormalizer("border-left-width", Lh("width", "left")), t.setExtractor("border-top", Nh("top")), t.setExtractor("border-right", Nh("right")), t.setExtractor("border-bottom", Nh("bottom")), t.setExtractor("border-left", Nh("left")), t.setExtractor("border-top-color", "border.color.top"), t.setExtractor("border-right-color", "border.color.right"), t.setExtractor("border-bottom-color", "border.color.bottom"), t.setExtractor("border-left-color", "border.color.left"), t.setExtractor("border-top-width", "border.width.top"), t.setExtractor("border-right-width", "border.width.right"), t.setExtractor("border-bottom-width", "border.width.bottom"), t.setExtractor("border-left-width", "border.width.left"), t.setExtractor("border-top-style", "border.style.top"), t.setExtractor("border-right-style", "border.style.right"), t.setExtractor("border-bottom-style", "border.style.bottom"), t.setExtractor("border-left-style", "border.style.left"), t.setReducer("border-color", yh("border-color")), t.setReducer("border-style", yh("border-style")), t.setReducer("border-width", yh("border-width")), t.setReducer("border-top", Vh("top")), t.setReducer("border-right", Vh("right")), t.setReducer("border-bottom", Vh("bottom")), t.setReducer("border-left", Vh("left")), t.setReducer("border", function () {
        return e => {
          const n = zh(e, "top"),
            i = zh(e, "right"),
            o = zh(e, "bottom"),
            r = zh(e, "left"),
            s = [n, i, o, r],
            a = {
              width: t(s, "width"),
              style: t(s, "style"),
              color: t(s, "color")
            },
            l = Rh(a, "all");
          if (l.length) return l;
          const c = Object.entries(a).reduce((t, _ref33) => {
            let [e, n] = _ref33;
            return n && (t.push([`border-${e}`, n]), s.forEach(t => delete t[e])), t;
          }, []);
          return [...c, ...Rh(n, "top"), ...Rh(i, "right"), ...Rh(o, "bottom"), ...Rh(r, "left")];
        };
        function t(t, e) {
          return t.map(t => t[e]).reduce((t, e) => t == e ? t : null);
        }
      }()), t.setStyleRelation("border", ["border-color", "border-style", "border-width", "border-top", "border-right", "border-bottom", "border-left", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), t.setStyleRelation("border-color", ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"]), t.setStyleRelation("border-style", ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"]), t.setStyleRelation("border-width", ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]), t.setStyleRelation("border-top", ["border-top-color", "border-top-style", "border-top-width"]), t.setStyleRelation("border-right", ["border-right-color", "border-right-style", "border-right-width"]), t.setStyleRelation("border-bottom", ["border-bottom-color", "border-bottom-style", "border-bottom-width"]), t.setStyleRelation("border-left", ["border-left-color", "border-left-style", "border-left-width"]);
    }
    function Th(t) {
      return e => {
        const {
            color: n,
            style: i,
            width: o
          } = Ph(e),
          r = {};
        return void 0 !== n && (r.color = {
          [t]: n
        }), void 0 !== i && (r.style = {
          [t]: i
        }), void 0 !== o && (r.width = {
          [t]: o
        }), {
          path: "border",
          value: r
        };
      };
    }
    function Ih(t) {
      return e => ({
        path: "border",
        value: Mh(e, t)
      });
    }
    function Mh(t, e) {
      return {
        [e]: vh(t)
      };
    }
    function Lh(t, e) {
      return n => ({
        path: "border",
        value: {
          [t]: {
            [e]: n
          }
        }
      });
    }
    function Nh(t) {
      return (e, n) => {
        if (n.border) return zh(n.border, t);
      };
    }
    function zh(t, e) {
      const n = {};
      return t.width && t.width[e] && (n.width = t.width[e]), t.style && t.style[e] && (n.style = t.style[e]), t.color && t.color[e] && (n.color = t.color[e]), n;
    }
    function Ph(t) {
      const e = {},
        n = Dh(t);
      for (const t of n) hh(t) || /thin|medium|thick/.test(t) ? e.width = t : dh(t) ? e.style = t : e.color = t;
      return e;
    }
    function Vh(t) {
      return e => Rh(e, t);
    }
    function Rh(t, e) {
      const n = [];
      if (t && t.width && n.push("width"), t && t.style && n.push("style"), t && t.color && n.push("color"), 3 == n.length) {
        const i = n.map(e => t[e]).join(" ");
        return ["all" == e ? ["border", i] : [`border-${e}`, i]];
      }
      return "all" == e ? [] : n.map(n => [`border-${e}-${n}`, t[n]]);
    }
    function Fh(t) {
      t.setNormalizer("margin", Eh("margin")), t.setNormalizer("margin-top", t => ({
        path: "margin.top",
        value: t
      })), t.setNormalizer("margin-right", t => ({
        path: "margin.right",
        value: t
      })), t.setNormalizer("margin-bottom", t => ({
        path: "margin.bottom",
        value: t
      })), t.setNormalizer("margin-left", t => ({
        path: "margin.left",
        value: t
      })), t.setReducer("margin", yh("margin")), t.setStyleRelation("margin", ["margin-top", "margin-right", "margin-bottom", "margin-left"]);
    }
    function Oh(t) {
      t.setNormalizer("padding", Eh("padding")), t.setNormalizer("padding-top", t => ({
        path: "padding.top",
        value: t
      })), t.setNormalizer("padding-right", t => ({
        path: "padding.right",
        value: t
      })), t.setNormalizer("padding-bottom", t => ({
        path: "padding.bottom",
        value: t
      })), t.setNormalizer("padding-left", t => ({
        path: "padding.left",
        value: t
      })), t.setReducer("padding", yh("padding")), t.setStyleRelation("padding", ["padding-top", "padding-right", "padding-bottom", "padding-left"]);
    }
    class jh {
      constructor() {
        this._commands = new Map();
      }
      add(t, e) {
        this._commands.set(t, e);
      }
      get(t) {
        return this._commands.get(t);
      }
      execute(t) {
        const n = this.get(t);
        if (!n) throw new b("commandcollection-command-not-found", this, {
          commandName: t
        });
        for (var _len29 = arguments.length, e = new Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
          e[_key29 - 1] = arguments[_key29];
        }
        return n.execute(...e);
      }
      *names() {
        yield* this._commands.keys();
      }
      *commands() {
        yield* this._commands.values();
      }
      [Symbol.iterator]() {
        return this._commands[Symbol.iterator]();
      }
      destroy() {
        for (const t of this.commands()) t.destroy();
      }
    }
    class Hh extends Yo {
      constructor(t) {
        super(), this.editor = t;
      }
      set(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if ("string" == typeof e) {
          const t = e;
          e = (e, n) => {
            this.editor.execute(t), n();
          };
        }
        super.set(t, e, n);
      }
    }
    const Uh = "contentEditing",
      qh = "common";
    class Gh {
      constructor(t) {
        this.keystrokeInfos = new Map(), this._editor = t;
        const e = t.config.get("menuBar.isVisible"),
          n = t.locale.t;
        this.addKeystrokeInfoCategory({
          id: Uh,
          label: n("Content editing keystrokes"),
          description: n("These keyboard shortcuts allow for quick access to content editing features.")
        });
        const i = [{
          label: n("Close contextual balloons, dropdowns, and dialogs"),
          keystroke: "Esc"
        }, {
          label: n("Open the accessibility help dialog"),
          keystroke: "Alt+0"
        }, {
          label: n("Move focus between form fields (inputs, buttons, etc.)"),
          keystroke: [["Tab"], ["Shift+Tab"]]
        }, {
          label: n("Move focus to the toolbar, navigate between toolbars"),
          keystroke: "Alt+F10",
          mayRequireFn: !0
        }, {
          label: n("Navigate through the toolbar or menu bar"),
          keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
        }, {
          label: n("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
          keystroke: [["Enter"], ["Space"]]
        }];
        e && i.push({
          label: n("Move focus to the menu bar, navigate between menu bars"),
          keystroke: "Alt+F9",
          mayRequireFn: !0
        }), this.addKeystrokeInfoCategory({
          id: "navigation",
          label: n("User interface and content navigation keystrokes"),
          description: n("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
          groups: [{
            id: "common",
            keystrokes: i
          }]
        });
      }
      addKeystrokeInfoCategory(_ref34) {
        let {
          id: t,
          label: e,
          description: n,
          groups: i
        } = _ref34;
        this.keystrokeInfos.set(t, {
          id: t,
          label: e,
          description: n,
          groups: new Map()
        }), this.addKeystrokeInfoGroup({
          categoryId: t,
          id: qh
        }), i && i.forEach(e => {
          this.addKeystrokeInfoGroup({
            categoryId: t,
            ...e
          });
        });
      }
      addKeystrokeInfoGroup(_ref35) {
        let {
          categoryId: t = Uh,
          id: e,
          label: n,
          keystrokes: i
        } = _ref35;
        const o = this.keystrokeInfos.get(t);
        if (!o) throw new b("accessibility-unknown-keystroke-info-category", this._editor, {
          groupId: e,
          categoryId: t
        });
        o.groups.set(e, {
          id: e,
          label: n,
          keystrokes: i || []
        });
      }
      addKeystrokeInfos(_ref36) {
        let {
          categoryId: t = Uh,
          groupId: e = qh,
          keystrokes: n
        } = _ref36;
        if (!this.keystrokeInfos.has(t)) throw new b("accessibility-unknown-keystroke-info-category", this._editor, {
          categoryId: t,
          keystrokes: n
        });
        const i = this.keystrokeInfos.get(t);
        if (!i.groups.has(e)) throw new b("accessibility-unknown-keystroke-info-group", this._editor, {
          groupId: e,
          categoryId: t,
          keystrokes: n
        });
        i.groups.get(e).keystrokes.push(...n);
      }
    }
    class Wh extends q() {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        const e = this.constructor,
          {
            translations: n,
            ...i
          } = e.defaultConfig || {},
          {
            translations: o = n,
            ...r
          } = t,
          s = t.language || i.language;
        this._context = t.context || new Or({
          language: s,
          translations: o
        }), this._context._addEditor(this, !t.context);
        const a = Array.from(e.builtinPlugins || []);
        this.config = new _i(r, i), this.config.define("plugins", a), this.config.define(this._context._getEditorConfig()), this.plugins = new Fr(this, a, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = new Set(), this.commands = new jh(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", {
          priority: "high"
        }), this.once("destroy", () => this.state = "destroyed", {
          priority: "high"
        }), this.model = new Qu(), this.on("change:isReadOnly", () => {
          this.model.document.isReadOnly = this.isReadOnly;
        });
        const l = new zs();
        this.data = new Md(this.model, l), this.editing = new dd(this.model, l), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Ld([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Hh(this), this.keystrokes.listenTo(this.editing.view.document), this.accessibility = new Gh(this);
      }
      get isReadOnly() {
        return this._readOnlyLocks.size > 0;
      }
      set isReadOnly(t) {
        throw new b("editor-isreadonly-has-no-setter");
      }
      enableReadOnlyMode(t) {
        if ("string" != typeof t && "symbol" != typeof t) throw new b("editor-read-only-lock-id-invalid", null, {
          lockId: t
        });
        this._readOnlyLocks.has(t) || (this._readOnlyLocks.add(t), 1 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
      }
      disableReadOnlyMode(t) {
        if ("string" != typeof t && "symbol" != typeof t) throw new b("editor-read-only-lock-id-invalid", null, {
          lockId: t
        });
        this._readOnlyLocks.has(t) && (this._readOnlyLocks.delete(t), 0 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
      }
      setData(t) {
        this.data.set(t);
      }
      getData(t) {
        return this.data.get(t);
      }
      initPlugins() {
        const t = this.config,
          e = t.get("plugins"),
          n = t.get("removePlugins") || [],
          i = t.get("extraPlugins") || [],
          o = t.get("substitutePlugins") || [];
        return this.plugins.init(e.concat(i), n, o);
      }
      destroy() {
        let t = Promise.resolve();
        return "initializing" == this.state && (t = new Promise(t => this.once("ready", t))), t.then(() => {
          this.fire("destroy"), this.stopListening(), this.commands.destroy();
        }).then(() => this.plugins.destroy()).then(() => {
          this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
        }).then(() => this._context._removeEditor(this));
      }
      execute(t) {
        try {
          for (var _len30 = arguments.length, e = new Array(_len30 > 1 ? _len30 - 1 : 0), _key30 = 1; _key30 < _len30; _key30++) {
            e[_key30 - 1] = arguments[_key30];
          }
          return this.commands.execute(t, ...e);
        } catch (t) {
          b.rethrowUnexpectedError(t, this);
        }
      }
      focus() {
        this.editing.view.focus();
      }
      static create() {
        throw new Error("This is an abstract method.");
      }
    }
    function $h(t) {
      return class extends t {
        updateSourceElement(t) {
          if (!this.sourceElement) throw new b("editor-missing-sourceelement", this);
          const e = this.config.get("updateSourceElementOnDestroy"),
            n = this.sourceElement instanceof HTMLTextAreaElement;
          if (!e && !n) return void qi(this.sourceElement, "");
          const i = "string" == typeof t ? t : this.data.get();
          qi(this.sourceElement, i);
        }
      };
    }
    $h.updateSourceElement = $h(Object).prototype.updateSourceElement;
    class Kh extends jr {
      static get pluginName() {
        return "PendingActions";
      }
      init() {
        this.set("hasAny", !1), this._actions = new Wo({
          idProperty: "_id"
        }), this._actions.delegate("add", "remove").to(this);
      }
      add(t) {
        if ("string" != typeof t) throw new b("pendingactions-add-invalid-message", this);
        const e = new (q())();
        return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
      }
      remove(t) {
        this._actions.remove(t), this.hasAny = !!this._actions.length;
      }
      get first() {
        return this._actions.get(0);
      }
      [Symbol.iterator]() {
        return this._actions[Symbol.iterator]();
      }
    }
    const Yh = {
      bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
      cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
      caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
      check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
      cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
      colorPalette: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.209 18.717A8.5 8.5 0 1 1 18.686 9.6h-.008l.002.12a3 3 0 0 1-2.866 2.997h-.268l-.046-.002v.002h-4.791a2 2 0 1 0 0 4 1 1 0 1 1-.128 1.992 8.665 8.665 0 0 1-.372.008Zm-3.918-7.01a1.25 1.25 0 1 0-2.415-.648 1.25 1.25 0 0 0 2.415.647ZM5.723 8.18a1.25 1.25 0 1 0 .647-2.414 1.25 1.25 0 0 0-.647 2.414ZM9.76 6.155a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Zm4.028 1.759a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Z"/></svg>',
      eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
      history: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1z"/><path d="M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052z"/><path d="M11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z"/></svg>',
      image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.66 9.118a.693.693 0 0 1 .956.032l3.65 3.411 2.422-2.238a.695.695 0 0 1 .945 0L17.5 13.6V2.5h-15v11.1l4.16-4.482ZM17.8 1c.652 0 1.2.47 1.2 1.1v14.362c0 .64-.532 1.038-1.184 1.038H2.184C1.532 17.5 1 17.103 1 16.462V2.1C1 1.47 1.537 1 2.2 1h15.6Zm-5.655 6a2.128 2.128 0 0 1 .157-2.364A2.133 2.133 0 1 1 12.145 7Z"/></svg>',
      imageUpload: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h9.494a2.97 2.97 0 0 1-.414-.287 2.998 2.998 0 0 1-1.055-2.03 3.003 3.003 0 0 1 .693-2.185l.383-.455-.02.018-3.65-3.41a.695.695 0 0 0-.957-.034L1.5 13.6V2.5h15v5.535a2.97 2.97 0 0 1 1.412.932l.088.105V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.146 2.146 0 0 0-2.049 1.992 2.14 2.14 0 0 0 1.28 2.096 2.13 2.13 0 0 0 2.644-3.11 2.134 2.134 0 0 0-1.875-.978Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/><path d="M15.522 19.1a.79.79 0 0 0 .79-.79v-5.373l2.059 2.455a.79.79 0 1 0 1.211-1.015l-3.352-3.995a.79.79 0 0 0-.995-.179.784.784 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017l1.936-2.306v5.185c0 .436.353.79.79.79Z"/></svg>',
      imageAssetManager: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1c-.662 0-1.2.47-1.2 1.1v14.248c0 .64.533 1.152 1.185 1.152h6.623v-7.236L6.617 9.15a.694.694 0 0 0-.957-.033L1.602 13.55V2.553l14.798.003V9.7H18V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.723 2.805a2.094 2.094 0 0 0-1.621.832 2.127 2.127 0 0 0 1.136 3.357 2.13 2.13 0 0 0 2.611-1.506 2.133 2.133 0 0 0-.76-2.244 2.13 2.13 0 0 0-1.366-.44Z"/><path clip-rule="evenodd" d="M19.898 12.369v6.187a.844.844 0 0 1-.844.844h-8.719a.844.844 0 0 1-.843-.844v-7.312a.844.844 0 0 1 .843-.844h2.531a.843.843 0 0 1 .597.248l.838.852h4.75c.223 0 .441.114.6.272a.844.844 0 0 1 .247.597Zm-1.52.654-4.377.02-1.1-1.143H11v6h7.4l-.023-4.877Z"/></svg>',
      imageUrl: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.538 1 0 1.47 0 2.1v14.363c0 .64.534 1.037 1.186 1.037h7.029a5.401 5.401 0 0 1 .615-4.338l.762-1.232-2.975-2.78a.696.696 0 0 0-.957-.033L1.5 13.6V2.5h15v6.023c.449.131.887.32 1.307.573l.058.033c.046.028.09.057.135.086V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.713 2.803a2.15 2.15 0 0 0-1.611.834 2.118 2.118 0 0 0-.438 1.158 2.14 2.14 0 0 0 1.277 2.096 2.132 2.132 0 0 0 2.645-3.11 2.13 2.13 0 0 0-1.873-.978Z"/><path d="M16.63 10.294a3.003 3.003 0 0 0-4.142.887l-.117.177a.647.647 0 0 0-.096.492.664.664 0 0 0 .278.418.7.7 0 0 0 .944-.234 1.741 1.741 0 0 1 2.478-.463 1.869 1.869 0 0 1 .476 2.55.637.637 0 0 0-.071.5.646.646 0 0 0 .309.396.627.627 0 0 0 .869-.19l.027-.041a3.226 3.226 0 0 0-.956-4.492Zm-6.061 3.78-.044.066a3.228 3.228 0 0 0 .82 4.403 3.005 3.005 0 0 0 4.275-.798l.13-.197a.626.626 0 0 0 .092-.475.638.638 0 0 0-.268-.402.713.713 0 0 0-.99.26l-.018.029a1.741 1.741 0 0 1-2.477.461 1.87 1.87 0 0 1-.475-2.55l.029-.047a.647.647 0 0 0 .086-.485.66.66 0 0 0-.275-.408l-.04-.027a.609.609 0 0 0-.845.17Z"/><path d="M15.312 13.925c.24-.36.154-.838-.19-1.067-.346-.23-.82-.124-1.059.236l-1.268 1.907c-.239.36-.153.838.192 1.067.345.23.818.123 1.057-.236l1.268-1.907Z"/></svg>',
      lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
      textAlternative: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.035 1C2.446 1 2 1.54 2 2.098V10.5h1.5v-8h13v8H18V2.098C18 1.539 17.48 1 16.9 1H3.035Zm10.453 2.61a1.885 1.885 0 0 0-1.442.736 1.89 1.89 0 0 0 1.011 2.976 1.903 1.903 0 0 0 2.253-1.114 1.887 1.887 0 0 0-1.822-2.598ZM7.463 8.163a.611.611 0 0 0-.432.154L5.071 10.5h5.119L7.88 8.348a.628.628 0 0 0-.417-.185Zm6.236 1.059a.62.62 0 0 0-.42.164L12.07 10.5h2.969l-.92-1.113a.618.618 0 0 0-.42-.165ZM.91 11.5a.91.91 0 0 0-.91.912v6.877c0 .505.405.91.91.91h18.178a.91.91 0 0 0 .912-.91v-6.877a.908.908 0 0 0-.912-.912H.91ZM3.668 13h1.947l2.135 5.7H5.898l-.28-.946H3.601l-.278.945H1.516L3.668 13Zm4.947 0h1.801v4.3h2.7v1.4h-4.5V13h-.001Zm4.5 0h5.4v1.4h-1.798v4.3h-1.701v-4.3h-1.9V13h-.001Zm-8.517 1.457-.614 2.059h1.262l-.648-2.059Z"/></svg>',
      loupe: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.68 13.74h-.001l4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474ZM13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/></svg>',
      previousArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>',
      nextArrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>',
      importExport: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>',
      paragraph: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>',
      plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>',
      text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>',
      alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
      alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
      alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
      alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
      alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
      alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
      objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
      objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectSizeCustom: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:v="https://vecta.io/nano" viewBox="0 0 20 20"><path d="M.95 1.43a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h.75v6.3H.95a.95.95 0 0 0-.95.95v3.1a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-.65h1.932l1.539-1.5H5v-.95a.95.95 0 0 0-.95-.95H3.2v-6.3h.85A.95.95 0 0 0 5 5.48v-.55h10v.55a.95.95 0 0 0 .95.95h3.1a.95.95 0 0 0 .95-.95v-3.1a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95v1.05H5V2.38a.95.95 0 0 0-.95-.95H.95zm.55 3.5v-2h2v2h-2zm0 9.3v2h2v-2h-2zm15-11.3v2h2v-2h-2z"/><path d="M8.139 20.004v-2.388l7.045-7.048 2.391 2.391-7.046 7.046h-2.39zm11.421-9.101a.64.64 0 0 1-.138.206l-1.165 1.168-2.391-2.391 1.167-1.163a.63.63 0 0 1 .206-.138.635.635 0 0 1 .243-.049.63.63 0 0 1 .449.187l1.491 1.488c.059.059.108.129.138.206s.049.16.049.243a.6.6 0 0 1-.049.243z"/></svg>',
      objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
      objectSizeLarge: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M13 5.5H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM13 7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 2 7h11Z"/></svg>',
      objectSizeSmall: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M7 9.5H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2ZM7 11a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4A.5.5 0 0 1 2 11h5Z"/></svg>',
      objectSizeMedium: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 16.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1ZM1 15v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 13v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 11v1H0v-1h1Zm19 0v1h-1v-1h1ZM1 9v1H0V9h1Zm19 0v1h-1V9h1ZM1 7v1H0V7h1Zm19 0v1h-1V7h1ZM1 5v1H0V5h1Zm19 0v1h-1V5h1Zm0-2v1h-1V3h1ZM1 3v1H0V3h1Zm13.5-1.5v1h-1v-1h1Zm2 0v1h-1v-1h1Zm2 0v1h-1v-1h1Zm-8 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm-2 0v1h-1v-1h1Zm8 0v1h-1v-1h1Zm-10 0v1h-1v-1h1Z"/><path d="M10 7.5H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2ZM10 9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 2 9h8Z"/></svg>',
      pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
      pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
      quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
      threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
      dragIndicator: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>',
      redo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>',
      undo: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
      bulletedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>',
      numberedList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      todoList: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m2.315 14.705 2.224-2.24a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .949L2.865 16.07a.682.682 0 0 1-.112.089.647.647 0 0 1-.852-.051L.688 14.886a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.717.722zm5.185.045a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75zM2.329 5.745l2.21-2.226a.689.689 0 0 1 .963 0 .664.664 0 0 1 0 .95L2.865 7.125a.685.685 0 0 1-.496.196.644.644 0 0 1-.468-.187L.688 5.912a.635.635 0 0 1 0-.903.647.647 0 0 1 .91 0l.73.736zM7.5 5.75A.75.75 0 0 1 8.25 5h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
      codeBlock: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
      browseFiles: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',
      heading1: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 9v10h-2v-8h-2V9h4zM4 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11H4v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v4.5z"/></svg>',
      heading2: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm16.076 8.343V18.5h-6.252c.067-.626.27-1.22.61-1.78.338-.561 1.006-1.305 2.005-2.232.804-.749 1.297-1.257 1.479-1.523.245-.368.368-.732.368-1.092 0-.398-.107-.703-.32-.917-.214-.214-.51-.32-.886-.32-.372 0-.669.111-.889.336-.22.224-.347.596-.38 1.117l-1.778-.178c.106-.982.438-1.686.997-2.114.558-.427 1.257-.64 2.095-.64.918 0 1.64.247 2.164.742.525.495.787 1.11.787 1.847 0 .419-.075.818-.225 1.197-.15.378-.388.775-.714 1.19-.216.275-.605.67-1.168 1.187-.563.516-.92.859-1.07 1.028a3.11 3.11 0 0 0-.365.495h3.542z"/></svg>',
      heading3: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm9.989 7.53 1.726-.209c.055.44.203.777.445 1.01.24.232.533.349.876.349.368 0 .678-.14.93-.42.251-.279.377-.655.377-1.13 0-.448-.12-.803-.362-1.066a1.153 1.153 0 0 0-.882-.393c-.228 0-.501.044-.819.133l.197-1.453c.482.012.85-.092 1.105-.315.253-.222.38-.517.38-.885 0-.313-.093-.563-.279-.75-.186-.185-.434-.278-.743-.278a1.07 1.07 0 0 0-.78.317c-.216.212-.347.52-.394.927l-1.644-.28c.114-.562.287-1.012.517-1.348.231-.337.553-.601.965-.794a3.24 3.24 0 0 1 1.387-.289c.876 0 1.579.28 2.108.838.436.457.653.973.653 1.549 0 .817-.446 1.468-1.339 1.955.533.114.96.37 1.28.768.319.398.478.878.478 1.441 0 .817-.298 1.513-.895 2.088-.596.576-1.339.864-2.228.864-.842 0-1.54-.243-2.094-.727-.555-.485-.876-1.118-.965-1.901z"/></svg>',
      heading4: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm13.55 10v-1.873h-3.81v-1.561l4.037-5.91h1.498v5.904h1.156v1.567h-1.156V18.5H17.05zm0-3.44v-3.18l-2.14 3.18h2.14z"/></svg>',
      heading5: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm9.578 7.607 1.777-.184c.05.402.201.72.45.955a1.223 1.223 0 0 0 1.81-.101c.258-.303.387-.759.387-1.368 0-.572-.128-1-.384-1.286-.256-.285-.59-.428-1-.428-.512 0-.971.226-1.377.679l-1.448-.21.915-4.843h4.716v1.67H15.56l-.28 1.58a2.697 2.697 0 0 1 1.219-.298 2.68 2.68 0 0 1 2.012.863c.55.576.825 1.323.825 2.241a3.36 3.36 0 0 1-.666 2.05c-.605.821-1.445 1.232-2.52 1.232-.86 0-1.56-.23-2.101-.692-.542-.461-.866-1.081-.971-1.86z"/></svg>',
      heading6: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm15.595 2.973-1.726.19c-.043-.355-.153-.617-.33-.787-.178-.169-.409-.253-.692-.253-.377 0-.695.169-.956.507-.26.339-.424 1.043-.492 2.114.445-.525.997-.787 1.657-.787.745 0 1.383.284 1.914.85.531.568.797 1.3.797 2.197 0 .952-.28 1.716-.838 2.291-.559.576-1.276.864-2.152.864-.94 0-1.712-.365-2.317-1.095-.605-.73-.908-1.927-.908-3.59 0-1.705.316-2.935.946-3.688.63-.753 1.45-1.13 2.457-1.13.706 0 1.291.198 1.755.594.463.395.758.97.885 1.723zm-4.043 3.891c0 .58.133 1.028.4 1.343.266.315.57.473.914.473.33 0 .605-.13.825-.388.22-.258.33-.68.33-1.27 0-.604-.118-1.047-.355-1.329a1.115 1.115 0 0 0-.89-.422c-.342 0-.632.134-.869.403s-.355.666-.355 1.19z"/></svg>',
      horizontalLine: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>',
      html: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2h14zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5l-.001-1.001zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965l-.014-.014zM2 10H1v5h1v-2h2v2h1v-5H4v2H2v-2zm7 0H6v1h1v4h1v-4h1v-1zm8 0h-1v5h3v-1h-2v-4zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5zM10 7v1H4V7h6zm3-2v1H4V5h9zm-3-2v1H4V3h6z"/></svg>',
      indent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
      outdent: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>',
      table: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.5v3h4v-3H3Zm0 4v3h4v-3H3Zm0 4v3h4v-3H3Zm5 3h4v-3H8v3Zm5 0h4v-3h-4v3Zm4-4v-3h-4v3h4Zm0-4v-3h-4v3h4Zm1.5 8A1.5 1.5 0 0 1 17 18H3a1.5 1.5 0 0 1-1.5-1.5V3c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13.5Zm-6.5-4v-3H8v3h4Zm0-4v-3H8v3h4Z"/></svg>'
    };
    var Qh = o(4606),
      Zh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Qh.A, Zh);
    Qh.A.locals;
    class Jh extends Sr {
      constructor(t) {
        super(t), this.set("text", void 0), this.set("for", void 0), this.id = `ck-editor__label_${p()}`;
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: this.id,
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });
      }
    }
    class Xh extends Sr {
      constructor(t, e) {
        super(t);
        const n = t.t,
          i = new Jh();
        i.text = n("Help Contents. To close this dialog press ESC."), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-accessibility-help-dialog__content"],
            "aria-labelledby": i.id,
            role: "document",
            tabindex: -1
          },
          children: [ft(document, "p", {}, n("Below, you can find a list of keyboard shortcuts that can be used in the editor.")), ...this._createCategories(Array.from(e.values())), i]
        });
      }
      focus() {
        this.element.focus();
      }
      _createCategories(t) {
        return t.map(t => {
          const e = [ft(document, "h3", {}, t.label), ...Array.from(t.groups.values()).map(t => this._createGroup(t)).flat()];
          return t.description && e.splice(1, 0, ft(document, "p", {}, t.description)), ft(document, "section", {}, e);
        });
      }
      _createGroup(t) {
        const e = t.keystrokes.sort((t, e) => t.label.localeCompare(e.label)).map(t => this._createGroupRow(t)).flat(),
          n = [ft(document, "dl", {}, e)];
        return t.label && n.unshift(ft(document, "h4", {}, t.label)), n;
      }
      _createGroupRow(t) {
        const e = this.locale.t,
          n = ft(document, "dt"),
          i = ft(document, "dd"),
          o = function (t) {
            if ("string" == typeof t) return [[t]];
            if ("string" == typeof t[0]) return [t];
            return t;
          }(t.keystroke),
          r = [];
        for (const t of o) r.push(t.map(tm).join(""));
        return n.innerHTML = t.label, i.innerHTML = r.join(", ") + (t.mayRequireFn && s.isMac ? ` ${e("(may require <kbd>Fn</kbd>)")}` : ""), [n, i];
      }
    }
    function tm(t) {
      return wo(t).split("+").map(t => `<kbd>${t}</kbd>`).join("+");
    }
    const em = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6.628a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/><path d="M8.5 9.125a.3.3 0 0 0-.253-.296L5.11 8.327a.75.75 0 1 1 .388-1.449l4.04.716c.267.072.624.08.893.009l4.066-.724a.75.75 0 1 1 .388 1.45l-3.132.5a.3.3 0 0 0-.253.296v1.357a.3.3 0 0 0 .018.102l1.615 4.438a.75.75 0 0 1-1.41.513l-1.35-3.71a.3.3 0 0 0-.281-.197h-.209a.3.3 0 0 0-.282.198l-1.35 3.711a.75.75 0 0 1-1.41-.513l1.64-4.509a.3.3 0 0 0 .019-.103V9.125Z"/><path clip-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/></svg>';
    var nm = o(9550),
      im = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(nm.A, im);
    nm.A.locals;
    class om extends Nr {
      constructor() {
        super(...arguments), this.contentView = null;
      }
      static get requires() {
        return [Kp];
      }
      static get pluginName() {
        return "AccessibilityHelp";
      }
      init() {
        const t = this.editor,
          e = t.locale.t;
        t.ui.componentFactory.add("accessibilityHelp", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0,
            withText: !1,
            label: e("Accessibility help")
          }), t;
        }), t.ui.componentFactory.add("menuBar:accessibilityHelp", () => {
          const t = this._createButton(Uk);
          return t.label = e("Accessibility"), t;
        }), t.keystrokes.set("Alt+0", (t, e) => {
          this._showDialog(), e();
        }), this._setupRootLabels();
      }
      _createButton(t) {
        const e = new t(this.editor.locale);
        return e.set({
          keystroke: "Alt+0",
          icon: em
        }), e.on("execute", () => this._showDialog()), e;
      }
      _setupRootLabels() {
        const t = this.editor,
          e = t.editing.view,
          n = t.t;
        function i(t, e) {
          const i = `${e.getAttribute("aria-label")}. ${n("Press %0 for help.", [wo("Alt+0")])}`;
          t.setAttribute("aria-label", i, e);
        }
        t.ui.on("ready", () => {
          e.change(t => {
            for (const n of e.document.roots) i(t, n);
          }), t.on("addRoot", (n, o) => {
            const r = t.editing.view.document.getRoot(o.rootName);
            e.change(t => i(t, r));
          }, {
            priority: "low"
          });
        });
      }
      _showDialog() {
        const t = this.editor,
          e = t.plugins.get("Dialog"),
          n = t.locale.t;
        this.contentView || (this.contentView = new Xh(t.locale, t.accessibility.keystrokeInfos)), e.show({
          id: "accessibilityHelp",
          className: "ck-accessibility-help-dialog",
          title: n("Accessibility help"),
          icon: em,
          hasCloseButton: !0,
          content: this.contentView
        });
      }
    }
    class rm extends nr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        super(e), this.locale = t;
      }
      get bodyCollectionContainer() {
        return this._bodyCollectionContainer;
      }
      attachToDom() {
        this._bodyCollectionContainer = new ir({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
            dir: this.locale.uiLanguageDirection
          },
          children: this
        }).render();
        let t = document.querySelector(".ck-body-wrapper");
        t || (t = ft(document, "div", {
          class: "ck-body-wrapper"
        }), document.body.appendChild(t)), t.appendChild(this._bodyCollectionContainer);
      }
      detachFromDom() {
        super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
        const t = document.querySelector(".ck-body-wrapper");
        t && 0 == t.childElementCount && t.remove();
      }
    }
    var sm = o(4106),
      am = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(sm.A, am);
    sm.A.locals;
    class lm extends Sr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", !0), this.set("isVisible", !0), this.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon", t.if("isVisible", "ck-hidden", t => !t), "ck-reset_all-excluded", t.if("isColorInherited", "ck-icon_inherit-color")],
            viewBox: t.to("viewBox")
          }
        });
      }
      render() {
        super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
          this._updateXMLContent(), this._colorFillPaths();
        }), this.on("change:fillColor", () => {
          this._colorFillPaths();
        });
      }
      _updateXMLContent() {
        if (this.content) {
          const t = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
            e = t.getAttribute("viewBox");
          e && (this.viewBox = e);
          for (const {
            name: e,
            value: n
          } of Array.from(t.attributes)) lm.presentationalAttributeNames.includes(e) && this.element.setAttribute(e, n);
          for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
          for (; t.childNodes.length > 0;) this.element.appendChild(t.childNodes[0]);
        }
      }
      _colorFillPaths() {
        this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(t => {
          t.style.fill = this.fillColor;
        });
      }
    }
    lm.presentationalAttributeNames = ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"];
    const cm = lm;
    class dm extends Sr {
      constructor() {
        super(), this.set({
          style: void 0,
          text: void 0,
          id: void 0
        });
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__label"],
            style: t.to("style"),
            id: t.to("id")
          },
          children: [{
            text: t.to("text")
          }]
        });
      }
    }
    var um = o(8948),
      hm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(um.A, hm);
    um.A.locals;
    class mm extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new dm();
        super(t), this._focusDelayed = null;
        const n = this.bindTemplate,
          i = p();
        this.set("ariaLabel", void 0), this.set("ariaLabelledBy", `ck-editor__aria-label_${i}`), this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke", void 0), this.set("label", void 0), this.set("role", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.set("withKeystroke", !1), this.children = this.createCollection(), this.labelView = this._setupLabelView(e), this.iconView = new cm(), this.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
        const o = {
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", n.to("class"), n.if("isEnabled", "ck-disabled", t => !t), n.if("isVisible", "ck-hidden", t => !t), n.to("isOn", t => t ? "ck-on" : "ck-off"), n.if("withText", "ck-button_with-text"), n.if("withKeystroke", "ck-button_with-keystroke")],
            role: n.to("role"),
            type: n.to("type", t => t || "button"),
            tabindex: n.to("tabindex"),
            "aria-checked": n.to("ariaChecked"),
            "aria-label": n.to("ariaLabel"),
            "aria-labelledby": n.to("ariaLabelledBy"),
            "aria-disabled": n.if("isEnabled", !0, t => !t),
            "aria-pressed": n.to("isOn", t => !!this.isToggleable && String(!!t)),
            "data-cke-tooltip-text": n.to("_tooltipString"),
            "data-cke-tooltip-position": n.to("tooltipPosition")
          },
          children: this.children,
          on: {
            click: n.to(t => {
              this.isEnabled ? this.fire("execute") : t.preventDefault();
            })
          }
        };
        s.isSafari && (this._focusDelayed || (this._focusDelayed = Zo(() => this.focus(), 0)), o.on.mousedown = n.to(() => {
          this._focusDelayed();
        }), o.on.mouseup = n.to(() => {
          this._focusDelayed.cancel();
        })), this.setTemplate(o);
      }
      render() {
        super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
      }
      focus() {
        this.element.focus();
      }
      destroy() {
        this._focusDelayed && this._focusDelayed.cancel(), super.destroy();
      }
      _setupLabelView(t) {
        return t.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), t;
      }
      _createKeystrokeView() {
        const t = new Sr();
        return t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__keystroke"]
          },
          children: [{
            text: this.bindTemplate.to("keystroke", t => wo(t))
          }]
        }), t;
      }
      _getTooltipString(t, e, n) {
        return t ? "string" == typeof t ? t : (n && (n = wo(n)), t instanceof Function ? t(e, n) : `${e}${n ? ` (${n})` : ""}`) : "";
      }
    }
    var gm = o(9624),
      pm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(gm.A, pm);
    gm.A.locals;
    class fm extends mm {
      constructor(t) {
        super(t), this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
      }
      render() {
        super.render(), this.children.add(this.toggleSwitchView);
      }
      _createToggleView() {
        const t = new Sr();
        return t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__toggle"]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle__inner"]
            }
          }]
        }), t;
      }
    }
    class km extends mm {
      constructor(t) {
        super(t), this.buttonView = this, this._fileInputView = new bm(t), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.on("execute", () => {
          this._fileInputView.open();
        }), this.extendTemplate({
          attributes: {
            class: "ck-file-dialog-button"
          }
        });
      }
      render() {
        super.render(), this.children.add(this._fileInputView);
      }
    }
    class bm extends Sr {
      constructor(t) {
        super(t), this.set("acceptedType", void 0), this.set("allowMultipleFiles", !1);
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(() => {
              this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
            })
          }
        });
      }
      open() {
        this.element.click();
      }
    }
    const wm = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
    var Am = o(1750),
      Cm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Am.A, Cm);
    Am.A.locals;
    class _m extends Sr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("isCollapsed", !1), this.set("label", ""), this.buttonView = this._createButtonView(), this.children = this.createCollection(), this.set("_collapsibleAriaLabelUid", void 0), e && this.children.addMany(e), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-collapsible", n.if("isCollapsed", "ck-collapsible_collapsed")]
          },
          children: [this.buttonView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-collapsible__children"],
              role: "region",
              hidden: n.if("isCollapsed", "hidden"),
              "aria-labelledby": n.to("_collapsibleAriaLabelUid")
            },
            children: this.children
          }]
        });
      }
      render() {
        super.render(), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
      }
      focus() {
        this.buttonView.focus();
      }
      _createButtonView() {
        const t = new mm(this.locale),
          e = t.bindTemplate;
        return t.set({
          withText: !0,
          icon: wm
        }), t.extendTemplate({
          attributes: {
            "aria-expanded": e.to("isOn", t => String(t))
          }
        }), t.bind("label").to(this), t.bind("isOn").to(this, "isCollapsed", t => !t), t.on("execute", () => {
          this.isCollapsed = !this.isCollapsed;
        }), t;
      }
    }
    function vm(t, e) {
      const n = t.t,
        i = {
          Black: n("Black"),
          "Dim grey": n("Dim grey"),
          Grey: n("Grey"),
          "Light grey": n("Light grey"),
          White: n("White"),
          Red: n("Red"),
          Orange: n("Orange"),
          Yellow: n("Yellow"),
          "Light green": n("Light green"),
          Green: n("Green"),
          Aquamarine: n("Aquamarine"),
          Turquoise: n("Turquoise"),
          "Light blue": n("Light blue"),
          Blue: n("Blue"),
          Purple: n("Purple")
        };
      return e.map(t => {
        const e = i[t.label];
        return e && e != t.label && (t.label = e), t;
      });
    }
    function ym(t) {
      return t.map(xm).filter(t => !!t);
    }
    function xm(t) {
      return "string" == typeof t ? {
        model: t,
        label: t,
        hasBorder: !1,
        view: {
          name: "span",
          styles: {
            color: t
          }
        }
      } : {
        model: t.color,
        label: t.label || t.color,
        hasBorder: void 0 !== t.hasBorder && t.hasBorder,
        view: {
          name: "span",
          styles: {
            color: `${t.color}`
          }
        }
      };
    }
    class Em extends mm {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("color", void 0), this.set("hasBorder", !1), this.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>', this.extendTemplate({
          attributes: {
            style: {
              backgroundColor: e.to("color", t => s.isMediaForcedColors ? null : t)
            },
            class: ["ck", "ck-color-grid__tile", e.if("hasBorder", "ck-color-selector__color-tile_bordered")]
          }
        });
      }
      render() {
        super.render(), this.iconView.fillColor = "hsl(0, 0%, 100%)";
      }
    }
    var Dm = o(7962),
      Bm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Dm.A, Bm);
    Dm.A.locals;
    class Sm extends Sr {
      constructor(t, e) {
        super(t);
        const n = e && e.colorDefinitions ? e.colorDefinitions : [];
        this.columns = e && e.columns ? e.columns : 5;
        const i = {
          gridTemplateColumns: `repeat( ${this.columns}, 1fr)`
        };
        this.set("selectedColor", void 0), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.items.on("add", (t, e) => {
          e.isOn = e.color === this.selectedColor;
        }), n.forEach(t => {
          const e = new Em();
          e.set({
            color: t.color,
            label: t.label,
            tooltip: !0,
            hasBorder: t.options.hasBorder
          }), e.on("execute", () => {
            this.fire("execute", {
              value: t.color,
              hasBorder: t.options.hasBorder,
              label: t.label
            });
          }), this.items.add(e);
        }), this.setTemplate({
          tag: "div",
          children: this.items,
          attributes: {
            class: ["ck", "ck-color-grid"],
            style: i
          }
        }), this.on("change:selectedColor", (t, e, n) => {
          for (const t of this.items) t.isOn = t.color === n;
        });
      }
      focus() {
        this.items.length && this.items.first.focus();
      }
      focusLast() {
        this.items.length && this.items.last.focus();
      }
      render() {
        super.render();
        for (const t of this.items) this.focusTracker.add(t.element);
        this.items.on("add", (t, e) => {
          this.focusTracker.add(e.element);
        }), this.items.on("remove", (t, e) => {
          this.focusTracker.remove(e.element);
        }), this.keystrokes.listenTo(this.element), Lr({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.items,
          numberOfColumns: this.columns,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
    }
    var Tm = o(8156);
    const Im = function (t) {
      var e,
        n,
        i = [],
        o = 1;
      if ("string" == typeof t) {
        if (Tm[t]) i = Tm[t].slice(), n = "rgb";else if ("transparent" === t) o = 0, n = "rgb", i = [0, 0, 0];else if (/^#[A-Fa-f0-9]+$/.test(t)) {
          var r = t.slice(1);
          o = 1, (l = r.length) <= 4 ? (i = [parseInt(r[0] + r[0], 16), parseInt(r[1] + r[1], 16), parseInt(r[2] + r[2], 16)], 4 === l && (o = parseInt(r[3] + r[3], 16) / 255)) : (i = [parseInt(r[0] + r[1], 16), parseInt(r[2] + r[3], 16), parseInt(r[4] + r[5], 16)], 8 === l && (o = parseInt(r[6] + r[7], 16) / 255)), i[0] || (i[0] = 0), i[1] || (i[1] = 0), i[2] || (i[2] = 0), n = "rgb";
        } else if (e = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(t)) {
          var s = e[1],
            a = "rgb" === s;
          n = r = s.replace(/a$/, "");
          var l = "cmyk" === r ? 4 : "gray" === r ? 1 : 3;
          i = e[2].trim().split(/\s*[,\/]\s*|\s+/).map(function (t, e) {
            if (/%$/.test(t)) return e === l ? parseFloat(t) / 100 : "rgb" === r ? 255 * parseFloat(t) / 100 : parseFloat(t);
            if ("h" === r[e]) {
              if (/deg$/.test(t)) return parseFloat(t);
              if (void 0 !== Mm[t]) return Mm[t];
            }
            return parseFloat(t);
          }), s === r && i.push(1), o = a || void 0 === i[l] ? 1 : i[l], i = i.slice(0, l);
        } else t.length > 10 && /[0-9](?:\s|\/)/.test(t) && (i = t.match(/([0-9]+)/g).map(function (t) {
          return parseFloat(t);
        }), n = t.match(/([a-z])/gi).join("").toLowerCase());
      } else isNaN(t) ? Array.isArray(t) || t.length ? (i = [t[0], t[1], t[2]], n = "rgb", o = 4 === t.length ? t[3] : 1) : t instanceof Object && (null != t.r || null != t.red || null != t.R ? (n = "rgb", i = [t.r || t.red || t.R || 0, t.g || t.green || t.G || 0, t.b || t.blue || t.B || 0]) : (n = "hsl", i = [t.h || t.hue || t.H || 0, t.s || t.saturation || t.S || 0, t.l || t.lightness || t.L || t.b || t.brightness]), o = t.a || t.alpha || t.opacity || 1, null != t.opacity && (o /= 100)) : (n = "rgb", i = [t >>> 16, (65280 & t) >>> 8, 255 & t]);
      return {
        space: n,
        values: i,
        alpha: o
      };
    };
    var Mm = {
      red: 0,
      orange: 60,
      yellow: 120,
      green: 180,
      blue: 240,
      purple: 300
    };
    var Lm = o(734),
      Nm = o.t(Lm, 2);
    function zm(t, e) {
      if (!t) return "";
      const n = Pm(t);
      if (!n) return "";
      if (n.space === e) return t;
      if (i = n, !Object.keys(Nm).includes(i.space)) return "";
      var i;
      const o = Nm[n.space][e];
      if (!o) return "";
      return function (t, e) {
        switch (e) {
          case "hex":
            return `#${t}`;
          case "rgb":
            return `rgb( ${t[0]}, ${t[1]}, ${t[2]} )`;
          case "hsl":
            return `hsl( ${t[0]}, ${t[1]}%, ${t[2]}% )`;
          case "hwb":
            return `hwb( ${t[0]}, ${t[1]}, ${t[2]} )`;
          case "lab":
            return `lab( ${t[0]}% ${t[1]} ${t[2]} )`;
          case "lch":
            return `lch( ${t[0]}% ${t[1]} ${t[2]} )`;
          default:
            return "";
        }
      }(o("hex" === n.space ? n.hexValue : n.values), e);
    }
    function Pm(t) {
      if (t.startsWith("#")) {
        const e = Im(t);
        return {
          space: "hex",
          values: e.values,
          hexValue: t,
          alpha: e.alpha
        };
      }
      const e = Im(t);
      return e.space ? e : null;
    }
    var Vm = o(6365),
      Rm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Vm.A, Rm);
    Vm.A.locals;
    class Fm extends Sr {
      constructor(t, e) {
        super(t);
        const n = `ck-labeled-field-view-${p()}`,
          i = `ck-labeled-field-view-status-${p()}`;
        this.fieldView = e(this, n, i), this.set("label", void 0), this.set("isEnabled", !0), this.set("isEmpty", !0), this.set("isFocused", !1), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(n), this.statusView = this._createStatusView(i), this.fieldWrapperChildren = this.createCollection([this.fieldView, this.labelView]), this.bind("_statusText").to(this, "errorText", this, "infoText", (t, e) => t || e);
        const o = this.bindTemplate;
        this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", o.to("class"), o.if("isEnabled", "ck-disabled", t => !t), o.if("isEmpty", "ck-labeled-field-view_empty"), o.if("isFocused", "ck-labeled-field-view_focused"), o.if("placeholder", "ck-labeled-field-view_placeholder"), o.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: this.fieldWrapperChildren
          }, this.statusView]
        });
      }
      _createLabelView(t) {
        const e = new Jh(this.locale);
        return e.for = t, e.bind("text").to(this, "label"), e;
      }
      _createStatusView(t) {
        const e = new Sr(this.locale),
          n = this.bindTemplate;
        return e.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", t => !t)],
            id: t,
            role: n.if("errorText", "alert")
          },
          children: [{
            text: n.to("_statusText")
          }]
        }), e;
      }
      focus(t) {
        this.fieldView.focus(t);
      }
    }
    class Om extends Sr {
      constructor(t) {
        var _this8;
        (super(t), _this8 = this), this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("tabIndex", void 0), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById", void 0), this.set("ariaLabel", void 0), this.focusTracker = new Ko(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", !0);
        const e = this.bindTemplate;
        this.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck", "ck-input", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            tabindex: e.to("tabIndex"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById"),
            "aria-label": e.to("ariaLabel")
          },
          on: {
            input: e.to(function () {
              for (var _len31 = arguments.length, t = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
                t[_key31] = arguments[_key31];
              }
              _this8.fire("input", ...t), _this8._updateIsEmpty();
            }),
            change: e.to(this._updateIsEmpty.bind(this))
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (t, e, n) => {
          this._setDomElementValue(n), this._updateIsEmpty();
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      select() {
        this.element.select();
      }
      focus() {
        this.element.focus();
      }
      reset() {
        this.value = this.element.value = "", this._updateIsEmpty();
      }
      _updateIsEmpty() {
        this.isEmpty = !this.element.value;
      }
      _setDomElementValue(t) {
        this.element.value = t || 0 === t ? t : "";
      }
    }
    var jm = o(1546),
      Hm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(jm.A, Hm);
    jm.A.locals;
    class Um extends Om {
      constructor(t) {
        super(t), this.set("inputMode", "text");
        const e = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            inputmode: e.to("inputMode")
          }
        });
      }
    }
    class qm extends Um {
      constructor(t) {
        super(t), this.extendTemplate({
          attributes: {
            type: "text",
            class: ["ck-input-text"]
          }
        });
      }
    }
    class Gm extends Um {
      constructor(t) {
        let {
          min: e,
          max: n,
          step: i
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t);
        const o = this.bindTemplate;
        this.set("min", e), this.set("max", n), this.set("step", i), this.extendTemplate({
          attributes: {
            type: "number",
            class: ["ck-input-number"],
            min: o.to("min"),
            max: o.to("max"),
            step: o.to("step")
          }
        });
      }
    }
    var Wm = o(8368),
      $m = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Wm.A, $m);
    Wm.A.locals;
    class Km extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", t => `ck-dropdown__panel_${t}`), e.if("isVisible", "ck-dropdown__panel-visible")],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: e.to(t => {
              "input" !== t.target.tagName.toLocaleLowerCase() && t.preventDefault();
            })
          }
        });
      }
      focus() {
        if (this.children.length) {
          const t = this.children.first;
          "function" == typeof t.focus ? t.focus() : w("ui-dropdown-panel-focus-child-missing-focus", {
            childView: this.children.first,
            dropdownPanel: this
          });
        }
      }
      focusLast() {
        if (this.children.length) {
          const t = this.children.last;
          "function" == typeof t.focusLast ? t.focusLast() : t.focus();
        }
      }
    }
    var Ym = o(426),
      Qm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Ym.A, Qm);
    Ym.A.locals;
    class Zm extends Sr {
      constructor(t, e, n) {
        super(t);
        const i = this.bindTemplate;
        this.buttonView = e, this.panelView = n, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Yo(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", t => !t)],
            id: i.to("id"),
            "aria-describedby": i.to("ariaDescribedById")
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"],
            "data-cke-tooltip-disabled": i.to("isOpen")
          }
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
          this.isOpen = !this.isOpen;
        }), this.on("change:isOpen", (t, e, n) => {
          if (n) if ("auto" === this.panelPosition) {
            const t = Zm._getOptimalPosition({
              element: this.panelView.element,
              target: this.buttonView.element,
              fitInViewport: !0,
              positions: this._panelPositions
            });
            this.panelView.position = t ? t.name : this._panelPositions[0].name;
          } else this.panelView.position = this.panelPosition;
        }), this.keystrokes.listenTo(this.element);
        const t = (t, e) => {
          this.isOpen && (this.isOpen = !1, e());
        };
        this.keystrokes.set("arrowdown", (t, e) => {
          this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, e());
        }), this.keystrokes.set("arrowright", (t, e) => {
          this.isOpen && e();
        }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          south: t,
          north: e,
          southEast: n,
          southWest: i,
          northEast: o,
          northWest: r,
          southMiddleEast: s,
          southMiddleWest: a,
          northMiddleEast: l,
          northMiddleWest: c
        } = Zm.defaultPanelPositions;
        return "rtl" !== this.locale.uiLanguageDirection ? [n, i, s, a, t, o, r, l, c, e] : [i, n, a, s, t, r, o, c, l, e];
      }
    }
    Zm.defaultPanelPositions = {
      south: (t, e) => ({
        top: t.bottom,
        left: t.left - (e.width - t.width) / 2,
        name: "s"
      }),
      southEast: t => ({
        top: t.bottom,
        left: t.left,
        name: "se"
      }),
      southWest: (t, e) => ({
        top: t.bottom,
        left: t.left - e.width + t.width,
        name: "sw"
      }),
      southMiddleEast: (t, e) => ({
        top: t.bottom,
        left: t.left - (e.width - t.width) / 4,
        name: "sme"
      }),
      southMiddleWest: (t, e) => ({
        top: t.bottom,
        left: t.left - 3 * (e.width - t.width) / 4,
        name: "smw"
      }),
      north: (t, e) => ({
        top: t.top - e.height,
        left: t.left - (e.width - t.width) / 2,
        name: "n"
      }),
      northEast: (t, e) => ({
        top: t.top - e.height,
        left: t.left,
        name: "ne"
      }),
      northWest: (t, e) => ({
        top: t.top - e.height,
        left: t.left - e.width + t.width,
        name: "nw"
      }),
      northMiddleEast: (t, e) => ({
        top: t.top - e.height,
        left: t.left - (e.width - t.width) / 4,
        name: "nme"
      }),
      northMiddleWest: (t, e) => ({
        top: t.top - e.height,
        left: t.left - 3 * (e.width - t.width) / 4,
        name: "nmw"
      })
    }, Zm._getOptimalPosition = Zi;
    const Jm = Zm;
    class Xm extends mm {
      constructor(t) {
        super(t), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", t => String(t))
          }
        }), this.delegate("execute").to(this, "open");
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const t = new cm();
        return t.content = wm, t.extendTemplate({
          attributes: {
            class: "ck-dropdown__arrow"
          }
        }), t;
      }
    }
    class tg extends B() {
      constructor(t) {
        if (super(), this.focusables = t.focusables, this.focusTracker = t.focusTracker, this.keystrokeHandler = t.keystrokeHandler, this.actions = t.actions, t.actions && t.keystrokeHandler) for (const e in t.actions) {
          let n = t.actions[e];
          "string" == typeof n && (n = [n]);
          for (const i of n) t.keystrokeHandler.set(i, (t, n) => {
            this[e](), n();
          });
        }
        this.on("forwardCycle", () => this.focusFirst(), {
          priority: "low"
        }), this.on("backwardCycle", () => this.focusLast(), {
          priority: "low"
        });
      }
      get first() {
        return this.focusables.find(eg) || null;
      }
      get last() {
        return this.focusables.filter(eg).slice(-1)[0] || null;
      }
      get next() {
        return this._getDomFocusableItem(1);
      }
      get previous() {
        return this._getDomFocusableItem(-1);
      }
      get current() {
        let t = null;
        return null === this.focusTracker.focusedElement ? null : (this.focusables.find((e, n) => {
          const i = e.element === this.focusTracker.focusedElement;
          return i && (t = n), i;
        }), t);
      }
      focusFirst() {
        this._focus(this.first, 1);
      }
      focusLast() {
        this._focus(this.last, -1);
      }
      focusNext() {
        const t = this.next;
        t && this.focusables.getIndex(t) === this.current || t === this.first ? this.fire("forwardCycle") : this._focus(t, 1);
      }
      focusPrevious() {
        const t = this.previous;
        t && this.focusables.getIndex(t) === this.current || t === this.last ? this.fire("backwardCycle") : this._focus(t, -1);
      }
      _focus(t, e) {
        t && this.focusTracker.focusedElement !== t.element && t.focus(e);
      }
      _getDomFocusableItem(t) {
        const e = this.focusables.length;
        if (!e) return null;
        const n = this.current;
        if (null === n) return this[1 === t ? "first" : "last"];
        let i = this.focusables.get(n),
          o = (n + e + t) % e;
        do {
          const n = this.focusables.get(o);
          if (eg(n)) {
            i = n;
            break;
          }
          o = (o + e + t) % e;
        } while (o !== n);
        return i;
      }
    }
    function eg(t) {
      return ng(t) && Qi(t.element);
    }
    function ng(t) {
      return !(!("focus" in t) || "function" != typeof t.focus);
    }
    class ig extends Sr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
      }
    }
    class og extends Sr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
      }
    }
    function rg(t) {
      if (Array.isArray(t)) return {
        items: t,
        removeItems: []
      };
      const e = {
        items: [],
        removeItems: []
      };
      return t ? {
        ...e,
        ...t
      } : e;
    }
    var sg = o(66),
      ag = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(sg.A, ag);
    sg.A.locals;
    const lg = {
      alignLeft: Yh.alignLeft,
      bold: Yh.bold,
      importExport: Yh.importExport,
      paragraph: Yh.paragraph,
      plus: Yh.plus,
      text: Yh.text,
      threeVerticalDots: Yh.threeVerticalDots,
      pilcrow: Yh.pilcrow,
      dragIndicator: Yh.dragIndicator
    };
    class cg extends Sr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate,
          i = this.t;
        this.options = e || {}, this.set("ariaLabel", i("Editor toolbar")), this.set("maxWidth", "auto"), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.set("class", void 0), this.set("isCompact", !1), this.itemsView = new dg(t), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
        const o = "rtl" === t.uiLanguageDirection;
        this._focusCycler = new tg({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: [o ? "arrowright" : "arrowleft", "arrowup"],
            focusNext: [o ? "arrowleft" : "arrowright", "arrowdown"]
          }
        });
        const r = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
        var s;
        this.options.shouldGroupWhenFull && this.options.isFloating && r.push("ck-toolbar_floating"), this.setTemplate({
          tag: "div",
          attributes: {
            class: r,
            role: "toolbar",
            "aria-label": n.to("ariaLabel"),
            style: {
              maxWidth: n.to("maxWidth")
            },
            tabindex: -1
          },
          children: this.children,
          on: {
            mousedown: (s = this, s.bindTemplate.to(t => {
              t.target === s.element && t.preventDefault();
            }))
          }
        }), this._behavior = this.options.shouldGroupWhenFull ? new hg(this) : new ug(this);
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
        for (const t of this.items) this.focusTracker.add(t.element);
        this.items.on("add", (t, e) => {
          this.focusTracker.add(e.element);
        }), this.items.on("remove", (t, e) => {
          this.focusTracker.remove(e.element);
        }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
      }
      destroy() {
        return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      fillFromConfig(t, e, n) {
        this.items.addMany(this._buildItemsFromConfig(t, e, n));
      }
      _buildItemsFromConfig(t, e, n) {
        const i = rg(t),
          o = n || i.removeItems;
        return this._cleanItemsConfiguration(i.items, e, o).map(t => V(t) ? this._createNestedToolbarDropdown(t, e, o) : "|" === t ? new ig() : "-" === t ? new og() : e.create(t)).filter(t => !!t);
      }
      _cleanItemsConfiguration(t, e, n) {
        const i = t.filter((t, i, o) => "|" === t || -1 === n.indexOf(t) && ("-" === t ? !this.options.shouldGroupWhenFull || (w("toolbarview-line-break-ignored-when-grouping-items", o), !1) : !(!V(t) && !e.has(t)) || (w("toolbarview-item-unavailable", {
          item: t
        }), !1)));
        return this._cleanSeparatorsAndLineBreaks(i);
      }
      _cleanSeparatorsAndLineBreaks(t) {
        const e = t => "-" !== t && "|" !== t,
          n = t.length,
          i = t.findIndex(e);
        if (-1 === i) return [];
        const o = n - t.slice().reverse().findIndex(e);
        return t.slice(i, o).filter((t, n, i) => {
          if (e(t)) return !0;
          return !(n > 0 && i[n - 1] === t);
        });
      }
      _createNestedToolbarDropdown(t, e, n) {
        let {
          label: i,
          icon: o,
          items: r,
          tooltip: s = !0,
          withText: a = !1
        } = t;
        if (r = this._cleanItemsConfiguration(r, e, n), !r.length) return null;
        const l = Eg(this.locale);
        return i || w("toolbarview-nested-toolbar-dropdown-missing-label", t), l.class = "ck-toolbar__nested-toolbar-dropdown", l.buttonView.set({
          label: i,
          tooltip: s,
          withText: !!a
        }), !1 !== o ? l.buttonView.icon = lg[o] || o || Yh.threeVerticalDots : l.buttonView.withText = !0, Dg(l, () => l.toolbarView._buildItemsFromConfig(r, e, n)), l;
      }
    }
    class dg extends Sr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: this.children
        });
      }
    }
    class ug {
      constructor(t) {
        const e = t.bindTemplate;
        t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using(t => t), t.focusables.bindTo(t.items).using(t => ng(t) ? t : null), t.extendTemplate({
          attributes: {
            class: [e.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }
      render() {}
      destroy() {}
    }
    class hg {
      constructor(t) {
        this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, this.view = t, this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), t.itemsView.children.bindTo(this.ungroupedItems).using(t => t), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), t.children.on("change", this._updateFocusCyclableItems.bind(this)), t.items.on("change", (t, e) => {
          const n = e.index,
            i = Array.from(e.added);
          for (const t of e.removed) n >= this.ungroupedItems.length ? this.groupedItems.remove(t) : this.ungroupedItems.remove(t);
          for (let t = n; t < n + i.length; t++) {
            const e = i[t - n];
            t > this.ungroupedItems.length ? this.groupedItems.add(e, t - this.ungroupedItems.length) : this.ungroupedItems.add(e, t);
          }
          this._updateGrouping();
        }), t.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }
      render(t) {
        this.viewElement = t.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t);
      }
      destroy() {
        this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
      }
      _updateGrouping() {
        if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
        if (!Qi(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
        const t = this.groupedItems.length;
        let e;
        for (; this._areItemsOverflowing;) this._groupLastItem(), e = !0;
        if (!e && this.groupedItems.length) {
          for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
          this._areItemsOverflowing && this._groupLastItem();
        }
        this.groupedItems.length !== t && this.view.fire("groupedItemsUpdate");
      }
      get _areItemsOverflowing() {
        if (!this.ungroupedItems.length) return !1;
        const t = this.viewElement,
          n = this.viewLocale.uiLanguageDirection,
          i = new Pi(t.lastChild),
          o = new Pi(t);
        if (!this.cachedPadding) {
          const i = e.window.getComputedStyle(t),
            o = "ltr" === n ? "paddingRight" : "paddingLeft";
          this.cachedPadding = Number.parseInt(i[o]);
        }
        return "ltr" === n ? i.right > o.right - this.cachedPadding : i.left < o.left + this.cachedPadding;
      }
      _enableGroupingOnResize() {
        let t;
        this.resizeObserver = new Ui(this.viewElement, e => {
          t && t === e.contentRect.width && !this.shouldUpdateGroupingOnNextResize || (this.shouldUpdateGroupingOnNextResize = !1, this._updateGrouping(), t = e.contentRect.width);
        }), this._updateGrouping();
      }
      _enableGroupingOnMaxWidthChange(t) {
        t.on("change:maxWidth", () => {
          this._updateGrouping();
        });
      }
      _groupLastItem() {
        this.groupedItems.length || (this.viewChildren.add(new ig()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
      }
      _ungroupFirstItem() {
        this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
      }
      _createGroupedItemsDropdown() {
        const t = this.viewLocale,
          e = t.t,
          n = Eg(t);
        return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se", Dg(n, this.groupedItems), n.buttonView.set({
          label: e("Show more items"),
          tooltip: !0,
          tooltipPosition: "rtl" === t.uiLanguageDirection ? "se" : "sw",
          icon: Yh.threeVerticalDots
        }), n;
      }
      _updateFocusCyclableItems() {
        this.viewFocusables.clear(), this.ungroupedItems.map(t => {
          ng(t) && this.viewFocusables.add(t);
        }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
      }
    }
    class mg extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !0), this.children = this.createCollection(), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item", e.if("isVisible", "ck-hidden", t => !t)],
            role: "presentation"
          },
          children: this.children
        });
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
    }
    class gg extends Sr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
      }
    }
    class pg extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Jh();
        super(t);
        const n = this.bindTemplate,
          i = new bg(t);
        this.set({
          label: "",
          isVisible: !0
        }), this.labelView = e, this.labelView.bind("text").to(this, "label"), this.children = this.createCollection(), this.children.addMany([this.labelView, i]), i.set({
          role: "group",
          ariaLabelledBy: e.id
        }), i.focusTracker.destroy(), i.keystrokes.destroy(), this.items = i.items, this.setTemplate({
          tag: "li",
          attributes: {
            role: "presentation",
            class: ["ck", "ck-list__group", n.if("isVisible", "ck-hidden", t => !t)]
          },
          children: this.children
        });
      }
      focus() {
        if (this.items) {
          const t = this.items.find(t => !(t instanceof gg));
          t && t.focus();
        }
      }
    }
    var fg = o(6048),
      kg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(fg.A, kg);
    fg.A.locals;
    class bg extends Sr {
      constructor(t) {
        super(t), this._listItemGroupToChangeListeners = new WeakMap();
        const e = this.bindTemplate;
        this.focusables = new nr(), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusCycler = new tg({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", void 0), this.set("role", void 0), this.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"],
            role: e.to("role"),
            "aria-label": e.to("ariaLabel"),
            "aria-labelledby": e.to("ariaLabelledBy")
          },
          children: this.items
        });
      }
      render() {
        super.render();
        for (const t of this.items) t instanceof pg ? this._registerFocusableItemsGroup(t) : t instanceof mg && this._registerFocusableListItem(t);
        this.items.on("change", (t, e) => {
          for (const t of e.removed) t instanceof pg ? this._deregisterFocusableItemsGroup(t) : t instanceof mg && this._deregisterFocusableListItem(t);
          for (const t of Array.from(e.added).reverse()) t instanceof pg ? this._registerFocusableItemsGroup(t, e.index) : this._registerFocusableListItem(t, e.index);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      _registerFocusableListItem(t, e) {
        this.focusTracker.add(t.element), this.focusables.add(t, e);
      }
      _deregisterFocusableListItem(t) {
        this.focusTracker.remove(t.element), this.focusables.remove(t);
      }
      _getOnGroupItemsChangeCallback(t) {
        return (e, n) => {
          for (const t of n.removed) this._deregisterFocusableListItem(t);
          for (const e of Array.from(n.added).reverse()) this._registerFocusableListItem(e, this.items.getIndex(t) + n.index);
        };
      }
      _registerFocusableItemsGroup(t, e) {
        Array.from(t.items).forEach((t, n) => {
          const i = void 0 !== e ? e + n : void 0;
          this._registerFocusableListItem(t, i);
        });
        const n = this._getOnGroupItemsChangeCallback(t);
        this._listItemGroupToChangeListeners.set(t, n), t.items.on("change", n);
      }
      _deregisterFocusableItemsGroup(t) {
        for (const e of t.items) this._deregisterFocusableListItem(e);
        t.items.off("change", this._listItemGroupToChangeListeners.get(t)), this._listItemGroupToChangeListeners.delete(t);
      }
    }
    var wg = o(7133),
      Ag = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(wg.A, Ag);
    wg.A.locals;
    class Cg extends Sr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isToggleable", !1), this.set("isVisible", !0), this.set("keystroke", void 0), this.set("withKeystroke", !1), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.actionView = this._createActionView(e), this.arrowView = this._createArrowView(), this.keystrokes = new Yo(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", n.to("class"), n.if("isVisible", "ck-hidden", t => !t), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (t, e) => {
          this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), e());
        }), this.keystrokes.set("arrowleft", (t, e) => {
          this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), e());
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this.actionView.focus();
      }
      _createActionView(t) {
        const e = t || new mm();
        return t || e.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), e.extendTemplate({
          attributes: {
            class: "ck-splitbutton__action"
          }
        }), e.delegate("execute").to(this), e;
      }
      _createArrowView() {
        const t = new mm(),
          e = t.bindTemplate;
        return t.icon = wm, t.extendTemplate({
          attributes: {
            class: ["ck-splitbutton__arrow"],
            "data-cke-tooltip-disabled": e.to("isOn"),
            "aria-haspopup": !0,
            "aria-expanded": e.to("isOn", t => String(t))
          }
        }), t.bind("isEnabled").to(this), t.bind("label").to(this), t.bind("tooltip").to(this), t.delegate("execute").to(this, "open"), t;
      }
    }
    var _g = o(7475),
      vg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(_g.A, vg);
    _g.A.locals;
    var yg = o(2454),
      xg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(yg.A, xg);
    yg.A.locals;
    function Eg(t) {
      let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Xm;
      const i = "function" == typeof n ? new n(t) : n,
        o = new Km(t),
        r = new Jm(t, i, o);
      return i.bind("isEnabled").to(r), i instanceof Cg ? i.arrowView.bind("isOn").to(r, "isOpen") : i.bind("isOn").to(r, "isOpen"), function (t) {
        (function (t) {
          t.on("render", () => {
            Tr({
              emitter: t,
              activator: () => t.isOpen,
              callback: () => {
                t.isOpen = !1;
              },
              contextElements: () => [t.element, ...t.focusTracker._elements]
            });
          });
        })(t), function (t) {
          t.on("execute", e => {
            e.source instanceof fm || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.focusTracker.on("change:isFocused", (e, n, i) => {
            t.isOpen && !i && (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", (e, n) => {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", (e, n) => {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t), function (t) {
          t.on("change:isOpen", (n, i, o) => {
            if (o) return;
            const r = t.panelView.element;
            r && r.contains(e.document.activeElement) && t.buttonView.focus();
          });
        }(t), function (t) {
          t.on("change:isOpen", (e, n, i) => {
            i && t.panelView.focus();
          }, {
            priority: "low"
          });
        }(t);
      }(r), r;
    }
    function Dg(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      t.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      }), t.isOpen ? Bg(t, e, n) : t.once("change:isOpen", () => Bg(t, e, n), {
        priority: "highest"
      }), n.enableActiveItemFocusOnDropdownOpen && Ig(t, () => t.toolbarView.items.find(t => t.isOn));
    }
    function Bg(t, e, n) {
      const i = t.locale,
        o = i.t,
        r = t.toolbarView = new cg(i),
        s = "function" == typeof e ? e() : e;
      r.ariaLabel = n.ariaLabel || o("Dropdown toolbar"), n.maxWidth && (r.maxWidth = n.maxWidth), n.class && (r.class = n.class), n.isCompact && (r.isCompact = n.isCompact), n.isVertical && (r.isVertical = !0), s instanceof nr ? r.items.bindTo(s).using(t => t) : r.items.addMany(s), t.panelView.children.add(r), r.items.delegate("execute").to(t);
    }
    function Sg(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      t.isOpen ? Tg(t, e, n) : t.once("change:isOpen", () => Tg(t, e, n), {
        priority: "highest"
      }), Ig(t, () => t.listView.items.find(t => t instanceof mg && t.children.first.isOn));
    }
    function Tg(t, e, n) {
      const i = t.locale,
        o = t.listView = new bg(i),
        r = "function" == typeof e ? e() : e;
      o.ariaLabel = n.ariaLabel, o.role = n.role, Mg(t, o.items, r, i), t.panelView.children.add(o), o.items.delegate("execute").to(t);
    }
    function Ig(t, e) {
      t.on("change:isOpen", () => {
        if (!t.isOpen) return;
        const n = e();
        n && ("function" == typeof n.focus ? n.focus() : w("ui-dropdown-focus-child-on-open-child-missing-focus", {
          view: n
        }));
      }, {
        priority: f.low - 10
      });
    }
    function Mg(t, e, n, i) {
      e.bindTo(n).using(e => {
        if ("separator" === e.type) return new gg(i);
        if ("group" === e.type) {
          const n = new pg(i);
          return n.set({
            label: e.label
          }), Mg(t, n.items, e.items, i), n.items.delegate("execute").to(t), n;
        }
        if ("button" === e.type || "switchbutton" === e.type) {
          const t = new mg(i);
          let n;
          return "button" === e.type ? (n = new mm(i), n.bind("ariaChecked").to(n, "isOn")) : n = new fm(i), n.bind(...Object.keys(e.model)).to(e.model), n.delegate("execute").to(t), t.children.add(n), t;
        }
        return null;
      });
    }
    const Lg = (t, e, n) => {
        const i = new qm(t.locale);
        return i.set({
          id: e,
          ariaDescribedById: n
        }), i.bind("isReadOnly").to(t, "isEnabled", t => !t), i.bind("hasError").to(t, "errorText", t => !!t), i.on("input", () => {
          t.errorText = null;
        }), t.bind("isEmpty", "isFocused", "placeholder").to(i), i;
      },
      Ng = (t, e, n) => {
        const i = new Gm(t.locale);
        return i.set({
          id: e,
          ariaDescribedById: n,
          inputMode: "numeric"
        }), i.bind("isReadOnly").to(t, "isEnabled", t => !t), i.bind("hasError").to(t, "errorText", t => !!t), i.on("input", () => {
          t.errorText = null;
        }), t.bind("isEmpty", "isFocused", "placeholder").to(i), i;
      },
      zg = (t, e, n) => {
        const i = Eg(t.locale);
        return i.set({
          id: e,
          ariaDescribedById: n
        }), i.bind("isEnabled").to(t), i;
      },
      Pg = function (t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return t > n ? n : t < e ? e : t;
      },
      Vg = function (t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.pow(10, e);
        return Math.round(n * t) / n;
      };
    Math.PI;
    const Rg = t => ("#" === t[0] && (t = t.substring(1)), t.length < 6 ? {
        r: parseInt(t[0] + t[0], 16),
        g: parseInt(t[1] + t[1], 16),
        b: parseInt(t[2] + t[2], 16),
        a: 4 === t.length ? Vg(parseInt(t[3] + t[3], 16) / 255, 2) : 1
      } : {
        r: parseInt(t.substring(0, 2), 16),
        g: parseInt(t.substring(2, 4), 16),
        b: parseInt(t.substring(4, 6), 16),
        a: 8 === t.length ? Vg(parseInt(t.substring(6, 8), 16) / 255, 2) : 1
      }),
      Fg = _ref37 => {
        let {
          h: t,
          s: e,
          v: n,
          a: i
        } = _ref37;
        const o = (200 - e) * n / 100;
        return {
          h: Vg(t),
          s: Vg(o > 0 && o < 200 ? e * n / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
          l: Vg(o / 2),
          a: Vg(i, 2)
        };
      },
      Og = t => {
        const {
          h: e,
          s: n,
          l: i
        } = Fg(t);
        return `hsl(${e}, ${n}%, ${i}%)`;
      },
      jg = _ref38 => {
        let {
          h: t,
          s: e,
          v: n,
          a: i
        } = _ref38;
        t = t / 360 * 6, e /= 100, n /= 100;
        const o = Math.floor(t),
          r = n * (1 - e),
          s = n * (1 - (t - o) * e),
          a = n * (1 - (1 - t + o) * e),
          l = o % 6;
        return {
          r: Vg(255 * [n, s, r, r, a, n][l]),
          g: Vg(255 * [a, n, n, s, r, r][l]),
          b: Vg(255 * [r, r, a, n, n, s][l]),
          a: Vg(i, 2)
        };
      },
      Hg = t => {
        const e = t.toString(16);
        return e.length < 2 ? "0" + e : e;
      },
      Ug = _ref39 => {
        let {
          r: t,
          g: e,
          b: n,
          a: i
        } = _ref39;
        const o = i < 1 ? Hg(Vg(255 * i)) : "";
        return "#" + Hg(t) + Hg(e) + Hg(n) + o;
      },
      qg = _ref40 => {
        let {
          r: t,
          g: e,
          b: n,
          a: i
        } = _ref40;
        const o = Math.max(t, e, n),
          r = o - Math.min(t, e, n),
          s = r ? o === t ? (e - n) / r : o === e ? 2 + (n - t) / r : 4 + (t - e) / r : 0;
        return {
          h: Vg(60 * (s < 0 ? s + 6 : s)),
          s: Vg(o ? r / o * 100 : 0),
          v: Vg(o / 255 * 100),
          a: i
        };
      },
      Gg = (t, e) => {
        if (t === e) return !0;
        for (const n in t) if (t[n] !== e[n]) return !1;
        return !0;
      },
      Wg = {},
      $g = t => {
        let e = Wg[t];
        return e || (e = document.createElement("template"), e.innerHTML = t, Wg[t] = e), e;
      },
      Kg = (t, e, n) => {
        t.dispatchEvent(new CustomEvent(e, {
          bubbles: !0,
          detail: n
        }));
      };
    let Yg = !1;
    const Qg = t => "touches" in t,
      Zg = (t, e) => {
        const n = Qg(e) ? e.touches[0] : e,
          i = t.el.getBoundingClientRect();
        Kg(t.el, "move", t.getMove({
          x: Pg((n.pageX - (i.left + window.pageXOffset)) / i.width),
          y: Pg((n.pageY - (i.top + window.pageYOffset)) / i.height)
        }));
      };
    class Jg {
      constructor(t, e, n, i) {
        const o = $g(`<div role="slider" tabindex="0" part="${e}" ${n}><div part="${e}-pointer"></div></div>`);
        t.appendChild(o.content.cloneNode(!0));
        const r = t.querySelector(`[part=${e}]`);
        r.addEventListener("mousedown", this), r.addEventListener("touchstart", this), r.addEventListener("keydown", this), this.el = r, this.xy = i, this.nodes = [r.firstChild, r];
      }
      set dragging(t) {
        const e = t ? document.addEventListener : document.removeEventListener;
        e(Yg ? "touchmove" : "mousemove", this), e(Yg ? "touchend" : "mouseup", this);
      }
      handleEvent(t) {
        switch (t.type) {
          case "mousedown":
          case "touchstart":
            if (t.preventDefault(), !(t => !(Yg && !Qg(t) || (Yg || (Yg = Qg(t)), 0)))(t) || !Yg && 0 != t.button) return;
            this.el.focus(), Zg(this, t), this.dragging = !0;
            break;
          case "mousemove":
          case "touchmove":
            t.preventDefault(), Zg(this, t);
            break;
          case "mouseup":
          case "touchend":
            this.dragging = !1;
            break;
          case "keydown":
            ((t, e) => {
              const n = e.keyCode;
              n > 40 || t.xy && n < 37 || n < 33 || (e.preventDefault(), Kg(t.el, "move", t.getMove({
                x: 39 === n ? .01 : 37 === n ? -.01 : 34 === n ? .05 : 33 === n ? -.05 : 35 === n ? 1 : 36 === n ? -1 : 0,
                y: 40 === n ? .01 : 38 === n ? -.01 : 0
              }, !0)));
            })(this, t);
        }
      }
      style(t) {
        t.forEach((t, e) => {
          for (const n in t) this.nodes[e].style.setProperty(n, t[n]);
        });
      }
    }
    class Xg extends Jg {
      constructor(t) {
        super(t, "hue", 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', !1);
      }
      update(_ref41) {
        let {
          h: t
        } = _ref41;
        this.h = t, this.style([{
          left: t / 360 * 100 + "%",
          color: Og({
            h: t,
            s: 100,
            v: 100,
            a: 1
          })
        }]), this.el.setAttribute("aria-valuenow", `${Vg(t)}`);
      }
      getMove(t, e) {
        return {
          h: e ? Pg(this.h + 360 * t.x, 0, 360) : 360 * t.x
        };
      }
    }
    class tp extends Jg {
      constructor(t) {
        super(t, "saturation", 'aria-label="Color"', !0);
      }
      update(t) {
        this.hsva = t, this.style([{
          top: 100 - t.v + "%",
          left: `${t.s}%`,
          color: Og(t)
        }, {
          "background-color": Og({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
          })
        }]), this.el.setAttribute("aria-valuetext", `Saturation ${Vg(t.s)}%, Brightness ${Vg(t.v)}%`);
      }
      getMove(t, e) {
        return {
          s: e ? Pg(this.hsva.s + 100 * t.x, 0, 100) : 100 * t.x,
          v: e ? Pg(this.hsva.v - 100 * t.y, 0, 100) : Math.round(100 - 100 * t.y)
        };
      }
    }
    const ep = Symbol("same"),
      np = Symbol("color"),
      ip = Symbol("hsva"),
      op = Symbol("update"),
      rp = Symbol("parts"),
      sp = Symbol("css"),
      ap = Symbol("sliders");
    class lp extends HTMLElement {
      static get observedAttributes() {
        return ["color"];
      }
      get [sp]() {
        return [':host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}', "[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}", "[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}"];
      }
      get [ap]() {
        return [tp, Xg];
      }
      get color() {
        return this[np];
      }
      set color(t) {
        if (!this[ep](t)) {
          const e = this.colorModel.toHsva(t);
          this[op](e), this[np] = t;
        }
      }
      constructor() {
        super();
        const t = $g(`<style>${this[sp].join("")}</style>`),
          e = this.attachShadow({
            mode: "open"
          });
        e.appendChild(t.content.cloneNode(!0)), e.addEventListener("move", this), this[rp] = this[ap].map(t => new t(e));
      }
      connectedCallback() {
        if (this.hasOwnProperty("color")) {
          const t = this.color;
          delete this.color, this.color = t;
        } else this.color || (this.color = this.colorModel.defaultColor);
      }
      attributeChangedCallback(t, e, n) {
        const i = this.colorModel.fromAttr(n);
        this[ep](i) || (this.color = i);
      }
      handleEvent(t) {
        const e = this[ip],
          n = {
            ...e,
            ...t.detail
          };
        let i;
        this[op](n), Gg(n, e) || this[ep](i = this.colorModel.fromHsva(n)) || (this[np] = i, Kg(this, "color-changed", {
          value: i
        }));
      }
      [ep](t) {
        return this.color && this.colorModel.equal(t, this.color);
      }
      [op](t) {
        this[ip] = t, this[rp].forEach(e => e.update(t));
      }
    }
    const cp = {
      defaultColor: "#000",
      toHsva: t => qg(Rg(t)),
      fromHsva: _ref42 => {
        let {
          h: t,
          s: e,
          v: n
        } = _ref42;
        return Ug(jg({
          h: t,
          s: e,
          v: n,
          a: 1
        }));
      },
      equal: (t, e) => t.toLowerCase() === e.toLowerCase() || Gg(Rg(t), Rg(e)),
      fromAttr: t => t
    };
    class dp extends lp {
      get colorModel() {
        return cp;
      }
    }
    var up = o(3086),
      hp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(up.A, hp);
    up.A.locals;
    class mp extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this.set({
          color: "",
          _hexColor: ""
        }), this.hexInputRow = this._createInputRow();
        const n = this.createCollection();
        e.hideInput || n.add(this.hexInputRow), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker"],
            tabindex: -1
          },
          children: n
        }), this._config = e, this._debounceColorPickerEvent = kl(t => {
          this.set("color", t), this.fire("colorSelected", {
            color: this.color
          });
        }, 150, {
          leading: !0
        }), this.on("set:color", (t, e, n) => {
          t.return = zm(n, this._config.format || "hsl");
        }), this.on("change:color", () => {
          this._hexColor = gp(this.color);
        }), this.on("change:_hexColor", () => {
          document.activeElement !== this.picker && this.picker.setAttribute("color", this._hexColor), gp(this.color) != gp(this._hexColor) && (this.color = this._hexColor);
        });
      }
      render() {
        var t, n;
        if (super.render(), t = "hex-color-picker", n = dp, void 0 === customElements.get(t) && customElements.define(t, n), this.picker = e.document.createElement("hex-color-picker"), this.picker.setAttribute("class", "hex-color-picker"), this.picker.setAttribute("tabindex", "-1"), this._createSlidersView(), this.element) {
          this.hexInputRow.element ? this.element.insertBefore(this.picker, this.hexInputRow.element) : this.element.appendChild(this.picker);
          const t = document.createElement("style");
          t.textContent = '[role="slider"]:focus [part$="pointer"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}', this.picker.shadowRoot.appendChild(t);
        }
        this.picker.addEventListener("color-changed", t => {
          const e = t.detail.value;
          this._debounceColorPickerEvent(e);
        });
      }
      focus() {
        if (!this._config.hideInput && (s.isGecko || s.isiOS || s.isSafari)) {
          this.hexInputRow.children.get(1).focus();
        }
        this.slidersView.first.focus();
      }
      _createSlidersView() {
        const t = [...this.picker.shadowRoot.children].filter(t => "slider" === t.getAttribute("role")).map(t => new pp(t));
        this.slidersView = this.createCollection(), t.forEach(t => {
          this.slidersView.add(t);
        });
      }
      _createInputRow() {
        const t = this._createColorInput();
        return new kp(this.locale, t);
      }
      _createColorInput() {
        const t = new Fm(this.locale, Lg),
          {
            t: e
          } = this.locale;
        return t.set({
          label: e("HEX"),
          class: "color-picker-hex-input"
        }), t.fieldView.bind("value").to(this, "_hexColor", e => t.isFocused ? t.fieldView.value : e.startsWith("#") ? e.substring(1) : e), t.fieldView.on("input", () => {
          const e = t.fieldView.element.value;
          if (e) {
            const t = bp(e);
            t && this._debounceColorPickerEvent(t);
          }
        }), t;
      }
      isValid() {
        const {
          t
        } = this.locale;
        return this.resetValidationStatus(), !!this.hexInputRow.getParsedColor() || (this.hexInputRow.inputView.errorText = t('Please enter a valid color (e.g. "ff0000").'), !1);
      }
      resetValidationStatus() {
        this.hexInputRow.inputView.errorText = null;
      }
    }
    function gp(t) {
      let e = function (t) {
        if (!t) return "";
        const e = Pm(t);
        return e ? "hex" === e.space ? e.hexValue : zm(t, "hex") : "#000";
      }(t);
      return e || (e = "#000"), 4 === e.length && (e = "#" + [e[1], e[1], e[2], e[2], e[3], e[3]].join("")), e.toLowerCase();
    }
    class pp extends Sr {
      constructor(t) {
        super(), this.element = t;
      }
      focus() {
        this.element.focus();
      }
    }
    class fp extends Sr {
      constructor(t) {
        super(t), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker__hash-view"]
          },
          children: "#"
        });
      }
    }
    class kp extends Sr {
      constructor(t, e) {
        super(t), this.inputView = e, this.children = this.createCollection([new fp(), this.inputView]), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-picker__row"]
          },
          children: this.children
        });
      }
      getParsedColor() {
        return bp(this.inputView.fieldView.element.value);
      }
    }
    function bp(t) {
      if (!t) return null;
      const e = t.trim().replace(/^#/, "");
      return [3, 4, 6, 8].includes(e.length) && /^(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})$/.test(e) ? `#${e}` : null;
    }
    class wp extends q(Wo) {
      constructor(t) {
        super(t), this.set("isEmpty", !0), this.on("change", () => {
          this.set("isEmpty", 0 === this.length);
        });
      }
      add(t, e) {
        return this.find(e => e.color === t.color) ? this : super.add(t, e);
      }
      hasColor(t) {
        return !!this.find(e => e.color === t);
      }
    }
    const {
      eraser: Ap,
      colorPalette: Cp
    } = Yh;
    class _p extends Sr {
      constructor(t, _ref43) {
        let {
          colors: e,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          focusTracker: a,
          focusables: l
        } = _ref43;
        super(t);
        const c = this.bindTemplate;
        this.set("isVisible", !0), this.focusTracker = a, this.items = this.createCollection(), this.colorDefinitions = e, this.columns = n, this.documentColors = new wp(), this.documentColorsCount = r, this._focusables = l, this._removeButtonLabel = i, this._colorPickerLabel = s, this._documentColorsLabel = o, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-color-grids-fragment", c.if("isVisible", "ck-hidden", t => !t)]
          },
          children: this.items
        }), this.removeColorButtonView = this._createRemoveColorButton(), this.items.add(this.removeColorButtonView);
      }
      updateDocumentColors(t, e) {
        const n = t.document,
          i = this.documentColorsCount;
        this.documentColors.clear();
        for (const o of n.getRoots()) {
          const n = t.createRangeIn(o);
          for (const t of n.getItems()) if (t.is("$textProxy") && t.hasAttribute(e) && (this._addColorToDocumentColors(t.getAttribute(e)), this.documentColors.length >= i)) return;
        }
      }
      updateSelectedColors() {
        const t = this.documentColorsGrid,
          e = this.staticColorsGrid,
          n = this.selectedColor;
        e.selectedColor = n, t && (t.selectedColor = n);
      }
      render() {
        if (super.render(), this.staticColorsGrid = this._createStaticColorsGrid(), this.items.add(this.staticColorsGrid), this.documentColorsCount) {
          const t = ir.bind(this.documentColors, this.documentColors),
            e = new Jh(this.locale);
          e.text = this._documentColorsLabel, e.extendTemplate({
            attributes: {
              class: ["ck", "ck-color-grid__label", t.if("isEmpty", "ck-hidden")]
            }
          }), this.items.add(e), this.documentColorsGrid = this._createDocumentColorsGrid(), this.items.add(this.documentColorsGrid);
        }
        this._createColorPickerButton(), this._addColorSelectorElementsToFocusTracker();
      }
      focus() {
        this.removeColorButtonView.focus();
      }
      destroy() {
        super.destroy();
      }
      addColorPickerButton() {
        this.colorPickerButtonView && (this.items.add(this.colorPickerButtonView), this.focusTracker.add(this.colorPickerButtonView.element), this._focusables.add(this.colorPickerButtonView));
      }
      _addColorSelectorElementsToFocusTracker() {
        this.focusTracker.add(this.removeColorButtonView.element), this._focusables.add(this.removeColorButtonView), this.staticColorsGrid && (this.focusTracker.add(this.staticColorsGrid.element), this._focusables.add(this.staticColorsGrid)), this.documentColorsGrid && (this.focusTracker.add(this.documentColorsGrid.element), this._focusables.add(this.documentColorsGrid));
      }
      _createColorPickerButton() {
        this.colorPickerButtonView = new mm(), this.colorPickerButtonView.set({
          label: this._colorPickerLabel,
          withText: !0,
          icon: Cp,
          class: "ck-color-selector__color-picker"
        }), this.colorPickerButtonView.on("execute", () => {
          this.fire("colorPicker:show");
        });
      }
      _createRemoveColorButton() {
        const t = new mm();
        return t.set({
          withText: !0,
          icon: Ap,
          label: this._removeButtonLabel
        }), t.class = "ck-color-selector__remove-color", t.on("execute", () => {
          this.fire("execute", {
            value: null,
            source: "removeColorButton"
          });
        }), t.render(), t;
      }
      _createStaticColorsGrid() {
        const t = new Sm(this.locale, {
          colorDefinitions: this.colorDefinitions,
          columns: this.columns
        });
        return t.on("execute", (t, e) => {
          this.fire("execute", {
            value: e.value,
            source: "staticColorsGrid"
          });
        }), t;
      }
      _createDocumentColorsGrid() {
        const t = ir.bind(this.documentColors, this.documentColors),
          e = new Sm(this.locale, {
            columns: this.columns
          });
        return e.extendTemplate({
          attributes: {
            class: t.if("isEmpty", "ck-hidden")
          }
        }), e.items.bindTo(this.documentColors).using(t => {
          const e = new Em();
          return e.set({
            color: t.color,
            hasBorder: t.options && t.options.hasBorder
          }), t.label && e.set({
            label: t.label,
            tooltip: !0
          }), e.on("execute", () => {
            this.fire("execute", {
              value: t.color,
              source: "documentColorsGrid"
            });
          }), e;
        }), this.documentColors.on("change:isEmpty", (t, n, i) => {
          i && (e.selectedColor = null);
        }), e;
      }
      _addColorToDocumentColors(t) {
        const e = this.colorDefinitions.find(e => e.color === t);
        e ? this.documentColors.add(Object.assign({}, e)) : this.documentColors.add({
          color: t,
          label: t,
          options: {
            hasBorder: !1
          }
        });
      }
    }
    class vp extends Sr {
      constructor(t, _ref44) {
        let {
          focusTracker: e,
          focusables: n,
          keystrokes: i,
          colorPickerViewConfig: o
        } = _ref44;
        super(t), this.items = this.createCollection(), this.focusTracker = e, this.keystrokes = i, this.set("isVisible", !1), this.set("selectedColor", void 0), this._focusables = n, this._colorPickerViewConfig = o;
        const r = this.bindTemplate,
          {
            saveButtonView: s,
            cancelButtonView: a
          } = this._createActionButtons();
        this.saveButtonView = s, this.cancelButtonView = a, this.actionBarView = this._createActionBarView({
          saveButtonView: s,
          cancelButtonView: a
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-color-picker-fragment", r.if("isVisible", "ck-hidden", t => !t)]
          },
          children: this.items
        });
      }
      render() {
        super.render();
        const t = new mp(this.locale, {
          ...this._colorPickerViewConfig
        });
        this.colorPickerView = t, this.colorPickerView.render(), this.selectedColor && (t.color = this.selectedColor), this.listenTo(this, "change:selectedColor", (e, n, i) => {
          t.color = i;
        }), this.items.add(this.colorPickerView), this.items.add(this.actionBarView), this._addColorPickersElementsToFocusTracker(), this._stopPropagationOnArrowsKeys(), this._executeOnEnterPress(), this._executeUponColorChange();
      }
      destroy() {
        super.destroy();
      }
      focus() {
        this.colorPickerView.focus();
      }
      resetValidationStatus() {
        this.colorPickerView.resetValidationStatus();
      }
      _executeOnEnterPress() {
        this.keystrokes.set("enter", t => {
          this.isVisible && this.focusTracker.focusedElement !== this.cancelButtonView.element && this.colorPickerView.isValid() && (this.fire("execute", {
            value: this.selectedColor
          }), t.stopPropagation(), t.preventDefault());
        });
      }
      _stopPropagationOnArrowsKeys() {
        const t = t => t.stopPropagation();
        this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      _addColorPickersElementsToFocusTracker() {
        for (const t of this.colorPickerView.slidersView) this.focusTracker.add(t.element), this._focusables.add(t);
        const t = this.colorPickerView.hexInputRow.children.get(1);
        t.element && (this.focusTracker.add(t.element), this._focusables.add(t)), this.focusTracker.add(this.saveButtonView.element), this._focusables.add(this.saveButtonView), this.focusTracker.add(this.cancelButtonView.element), this._focusables.add(this.cancelButtonView);
      }
      _createActionBarView(_ref45) {
        let {
          saveButtonView: t,
          cancelButtonView: e
        } = _ref45;
        const n = new Sr(),
          i = this.createCollection();
        return i.add(t), i.add(e), n.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-selector_action-bar"]
          },
          children: i
        }), n;
      }
      _createActionButtons() {
        const t = this.locale,
          e = t.t,
          n = new mm(t),
          i = new mm(t);
        return n.set({
          icon: Yh.check,
          class: "ck-button-save",
          type: "button",
          withText: !1,
          label: e("Accept")
        }), i.set({
          icon: Yh.cancel,
          class: "ck-button-cancel",
          type: "button",
          withText: !1,
          label: e("Cancel")
        }), n.on("execute", () => {
          this.colorPickerView.isValid() && this.fire("execute", {
            source: "colorPickerSaveButton",
            value: this.selectedColor
          });
        }), i.on("execute", () => {
          this.fire("colorPicker:cancel");
        }), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      _executeUponColorChange() {
        this.colorPickerView.on("colorSelected", (t, e) => {
          this.fire("execute", {
            value: e.color,
            source: "colorPicker"
          }), this.set("selectedColor", e.color);
        });
      }
    }
    var yp = o(2922),
      xp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(yp.A, xp);
    yp.A.locals;
    class Ep extends Sr {
      constructor(t, _ref46) {
        let {
          colors: e,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          colorPickerViewConfig: a
        } = _ref46;
        super(t), this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusables = new nr(), this._colorPickerViewConfig = a, this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.colorGridsFragmentView = new _p(t, {
          colors: e,
          columns: n,
          removeButtonLabel: i,
          documentColorsLabel: o,
          documentColorsCount: r,
          colorPickerLabel: s,
          focusTracker: this.focusTracker,
          focusables: this._focusables
        }), this.colorPickerFragmentView = new vp(t, {
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokes: this.keystrokes,
          colorPickerViewConfig: a
        }), this.set("_isColorGridsFragmentVisible", !0), this.set("_isColorPickerFragmentVisible", !1), this.set("selectedColor", void 0), this.colorGridsFragmentView.bind("isVisible").to(this, "_isColorGridsFragmentVisible"), this.colorPickerFragmentView.bind("isVisible").to(this, "_isColorPickerFragmentVisible"), this.on("change:selectedColor", (t, e, n) => {
          this.colorGridsFragmentView.set("selectedColor", n), this.colorPickerFragmentView.set("selectedColor", n);
        }), this.colorGridsFragmentView.on("change:selectedColor", (t, e, n) => {
          this.set("selectedColor", n);
        }), this.colorPickerFragmentView.on("change:selectedColor", (t, e, n) => {
          this.set("selectedColor", n);
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-selector"]
          },
          children: this.items
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      appendUI() {
        this._appendColorGridsFragment(), this._colorPickerViewConfig && this._appendColorPickerFragment();
      }
      showColorPickerFragment() {
        this.colorPickerFragmentView.colorPickerView && !this._isColorPickerFragmentVisible && (this._isColorPickerFragmentVisible = !0, this.colorPickerFragmentView.focus(), this.colorPickerFragmentView.resetValidationStatus(), this._isColorGridsFragmentVisible = !1);
      }
      showColorGridsFragment() {
        this._isColorGridsFragmentVisible || (this._isColorGridsFragmentVisible = !0, this.colorGridsFragmentView.focus(), this._isColorPickerFragmentVisible = !1);
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
      updateDocumentColors(t, e) {
        this.colorGridsFragmentView.updateDocumentColors(t, e);
      }
      updateSelectedColors() {
        this.colorGridsFragmentView.updateSelectedColors();
      }
      _appendColorGridsFragment() {
        this.items.length || (this.items.add(this.colorGridsFragmentView), this.colorGridsFragmentView.delegate("execute").to(this), this.colorGridsFragmentView.delegate("colorPicker:show").to(this));
      }
      _appendColorPickerFragment() {
        2 !== this.items.length && (this.items.add(this.colorPickerFragmentView), this.colorGridsFragmentView.colorPickerButtonView && this.colorGridsFragmentView.colorPickerButtonView.on("execute", () => {
          this.showColorPickerFragment();
        }), this.colorGridsFragmentView.addColorPickerButton(), this.colorPickerFragmentView.delegate("execute").to(this), this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this));
      }
    }
    class Dp {
      constructor(t) {
        this._components = new Map(), this.editor = t;
      }
      *names() {
        for (const t of this._components.values()) yield t.originalName;
      }
      add(t, e) {
        this._components.set(Bp(t), {
          callback: e,
          originalName: t
        });
      }
      create(t) {
        if (!this.has(t)) throw new b("componentfactory-item-missing", this, {
          name: t
        });
        return this._components.get(Bp(t)).callback(this.editor.locale);
      }
      has(t) {
        return this._components.has(Bp(t));
      }
    }
    function Bp(t) {
      return String(t).toLowerCase();
    }
    var Sp = o(4866),
      Tp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Sp.A, Tp);
    Sp.A.locals;
    class Ip extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t);
        const n = this.bindTemplate;
        this.set("label", e.label || ""), this.set("class", e.class || null), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-form__header", n.to("class")]
          },
          children: this.children
        }), e.icon && (this.iconView = new cm(), this.iconView.content = e.icon, this.children.add(this.iconView));
        const i = new Sr(t);
        i.setTemplate({
          tag: "h2",
          attributes: {
            class: ["ck", "ck-form__header__label"],
            role: "presentation"
          },
          children: [{
            text: n.to("label")
          }]
        }), this.children.add(i);
      }
    }
    var Mp = o(8091),
      Lp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Mp.A, Lp);
    Mp.A.locals;
    class Np extends Sr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.keystrokes = new Yo(), this._focusTracker = new Ko(), this._focusables = new nr(), this.focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this._focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__actions"]
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element);
      }
      setButtons(t) {
        for (const e of t) {
          const t = new mm(this.locale);
          let n;
          for (n in t.on("execute", () => e.onExecute()), e.onCreate && e.onCreate(t), e) "onExecute" != n && "onCreate" != n && t.set(n, e[n]);
          this.children.add(t);
        }
        this._updateFocusCyclableItems();
      }
      focus(t) {
        -1 === t ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      _updateFocusCyclableItems() {
        Array.from(this.children).forEach(t => {
          this._focusables.add(t), this._focusTracker.add(t.element);
        });
      }
    }
    class zp extends Sr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog__content"]
          },
          children: this.children
        });
      }
      reset() {
        for (; this.children.length;) this.children.remove(0);
      }
    }
    var Pp = o(880),
      Vp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Pp.A, Vp);
    Pp.A.locals;
    const Rp = "screen-center",
      Fp = "editor-center",
      Op = "editor-top-side",
      jp = "editor-top-center",
      Hp = "editor-bottom-center",
      Up = "editor-above-center",
      qp = "editor-below-center",
      Gp = Gi("px");
    class Wp extends function (t) {
      return class extends t {
        constructor() {
          super(...arguments), this._onDragBound = this._onDrag.bind(this), this._onDragEndBound = this._onDragEnd.bind(this), this._lastDraggingCoordinates = {
            x: 0,
            y: 0
          }, this.on("render", () => {
            this._attachListeners();
          }), this.set("isDragging", !1);
        }
        _attachListeners() {
          this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
        }
        _attachDragListeners() {
          this.listenTo(e.document, "mouseup", this._onDragEndBound), this.listenTo(e.document, "touchend", this._onDragEndBound), this.listenTo(e.document, "mousemove", this._onDragBound), this.listenTo(e.document, "touchmove", this._onDragBound);
        }
        _detachDragListeners() {
          this.stopListening(e.document, "mouseup", this._onDragEndBound), this.stopListening(e.document, "touchend", this._onDragEndBound), this.stopListening(e.document, "mousemove", this._onDragBound), this.stopListening(e.document, "touchmove", this._onDragBound);
        }
        _onDragStart(t, e) {
          if (!this._isHandleElementPressed(e)) return;
          this._attachDragListeners();
          let n = 0,
            i = 0;
          e instanceof MouseEvent ? (n = e.clientX, i = e.clientY) : (n = e.touches[0].clientX, i = e.touches[0].clientY), this._lastDraggingCoordinates = {
            x: n,
            y: i
          }, this.isDragging = !0;
        }
        _onDrag(t, e) {
          if (!this.isDragging) return void this._detachDragListeners();
          let n = 0,
            i = 0;
          e instanceof MouseEvent ? (n = e.clientX, i = e.clientY) : (n = e.touches[0].clientX, i = e.touches[0].clientY), e.preventDefault(), this.fire("drag", {
            deltaX: Math.round(n - this._lastDraggingCoordinates.x),
            deltaY: Math.round(i - this._lastDraggingCoordinates.y)
          }), this._lastDraggingCoordinates = {
            x: n,
            y: i
          };
        }
        _onDragEnd() {
          this._detachDragListeners(), this.isDragging = !1;
        }
        _isHandleElementPressed(t) {
          return !!this.dragHandleElement && (this.dragHandleElement === t.target || t.target instanceof HTMLElement && this.dragHandleElement.contains(t.target));
        }
      };
    }(Sr) {
      constructor(t, _ref47) {
        let {
          getCurrentDomRoot: e,
          getViewportOffset: n
        } = _ref47;
        super(t), this.wasMoved = !1;
        const i = this.bindTemplate,
          o = t.t;
        this.set("className", ""), this.set("ariaLabel", o("Editor dialog")), this.set("isModal", !1), this.set("position", Rp), this.set("_isVisible", !1), this.set("_isTransparent", !1), this.set("_top", 0), this.set("_left", 0), this._getCurrentDomRoot = e, this._getViewportOffset = n, this.decorate("moveTo"), this.parts = this.createCollection(), this.keystrokes = new Yo(), this.focusTracker = new Ko(), this._focusables = new nr(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dialog-overlay", i.if("isModal", "ck-dialog-overlay__transparent", t => !t), i.if("_isVisible", "ck-hidden", t => !t)],
            tabindex: "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              tabindex: "-1",
              class: ["ck", "ck-dialog", i.to("className")],
              role: "dialog",
              "aria-label": i.to("ariaLabel"),
              style: {
                top: i.to("_top", t => Gp(t)),
                left: i.to("_left", t => Gp(t)),
                visibility: i.if("_isTransparent", "hidden")
              }
            },
            children: this.parts
          }]
        });
      }
      render() {
        super.render(), this.keystrokes.set("Esc", (t, e) => {
          this.fire("close", {
            source: "escKeyPress"
          }), e();
        }), this.on("drag", (t, _ref48) => {
          let {
            deltaX: e,
            deltaY: n
          } = _ref48;
          this.wasMoved = !0, this.moveBy(e, n);
        }), this.listenTo(e.window, "resize", () => {
          this._isVisible && !this.wasMoved && this.updatePosition();
        }), this.listenTo(e.document, "scroll", () => {
          this._isVisible && !this.wasMoved && this.updatePosition();
        }), this.on("change:_isVisible", (t, e, n) => {
          n && (this._isTransparent = !0, setTimeout(() => {
            this.updatePosition(), this._isTransparent = !1, this.focus();
          }, 10));
        }), this.keystrokes.listenTo(this.element);
      }
      get dragHandleElement() {
        return this.headerView ? this.headerView.element : null;
      }
      setupParts(_ref49) {
        let {
          icon: t,
          title: e,
          hasCloseButton: n = !0,
          content: i,
          actionButtons: o
        } = _ref49;
        e && (this.headerView = new Ip(this.locale, {
          icon: t
        }), n && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = e, this.ariaLabel = e, this.parts.add(this.headerView, 0)), i && (i instanceof Sr && (i = [i]), this.contentView = new zp(this.locale), this.contentView.children.addMany(i), this.parts.add(this.contentView)), o && (this.actionsView = new Np(this.locale), this.actionsView.setButtons(o), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      moveTo(t, e) {
        const n = this._getViewportRect(),
          i = this._getDialogRect();
        t + i.width > n.right && (t = n.right - i.width), t < n.left && (t = n.left), e < n.top && (e = n.top), this._moveTo(t, e);
      }
      _moveTo(t, e) {
        this._left = t, this._top = e;
      }
      moveBy(t, e) {
        this.moveTo(this._left + t, this._top + e);
      }
      _moveOffScreen() {
        this._moveTo(-9999, -9999);
      }
      updatePosition() {
        if (!this.element || !this.element.parentNode) return;
        const t = this._getViewportRect();
        let e,
          n = this.position;
        this._getCurrentDomRoot() ? e = this._getVisibleDomRootRect(t) : n = Rp;
        const i = Wp.defaultOffset,
          o = this._getDialogRect();
        switch (n) {
          case Op:
            if (e) {
              const t = "ltr" === this.locale.contentLanguageDirection ? e.right - o.width - i : e.left + i;
              this.moveTo(t, e.top + i);
            } else this._moveOffScreen();
            break;
          case Fp:
            e ? this.moveTo(Math.round(e.left + e.width / 2 - o.width / 2), Math.round(e.top + e.height / 2 - o.height / 2)) : this._moveOffScreen();
            break;
          case Rp:
            this.moveTo(Math.round((t.width - o.width) / 2), Math.round((t.height - o.height) / 2));
            break;
          case jp:
            e ? this.moveTo(Math.round(e.left + e.width / 2 - o.width / 2), e.top + i) : this._moveOffScreen();
            break;
          case Hp:
            e ? this.moveTo(Math.round(e.left + e.width / 2 - o.width / 2), e.bottom - o.height - i) : this._moveOffScreen();
            break;
          case Up:
            e ? this.moveTo(Math.round(e.left + e.width / 2 - o.width / 2), e.top - o.height - i) : this._moveOffScreen();
            break;
          case qp:
            e ? this.moveTo(Math.round(e.left + e.width / 2 - o.width / 2), e.bottom + i) : this._moveOffScreen();
        }
      }
      _getVisibleDomRootRect(t) {
        let e = new Pi(this._getCurrentDomRoot()).getVisible();
        return e ? (e = t.getIntersection(e), e || null) : null;
      }
      _getDialogRect() {
        return new Pi(this.element.firstElementChild);
      }
      _getViewportRect() {
        return function (t) {
          t = Object.assign({
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }, t);
          const n = new Pi(e.window);
          return n.top += t.top, n.height -= t.top, n.bottom -= t.bottom, n.height -= t.bottom, n.left += t.left, n.right -= t.right, n.width -= t.left + t.right, n;
        }(this._getViewportOffset());
      }
      _updateFocusCyclableItems() {
        const t = [];
        if (this.contentView) for (const e of this.contentView.children) ng(e) && t.push(e);
        this.actionsView && t.push(this.actionsView), this.closeButtonView && t.push(this.closeButtonView), t.forEach(t => {
          var e;
          this._focusables.add(t), this.focusTracker.add(t.element), ng(e = t) && "focusCycler" in e && e.focusCycler instanceof tg && (this.listenTo(t.focusCycler, "forwardCycle", t => {
            this._focusCycler.focusNext(), this._focusCycler.next !== this._focusCycler.focusables.get(this._focusCycler.current) && t.stop();
          }), this.listenTo(t.focusCycler, "backwardCycle", t => {
            this._focusCycler.focusPrevious(), this._focusCycler.previous !== this._focusCycler.focusables.get(this._focusCycler.current) && t.stop();
          }));
        });
      }
      _createCloseButton() {
        const t = new mm(this.locale),
          e = this.locale.t;
        return t.set({
          label: e("Close"),
          tooltip: !0,
          icon: Yh.cancel
        }), t.on("execute", () => this.fire("close", {
          source: "closeButton"
        })), t;
      }
    }
    Wp.defaultOffset = 15;
    const $p = Wp;
    class Kp extends Nr {
      static get pluginName() {
        return "Dialog";
      }
      constructor(t) {
        super(t);
        const e = t.t;
        this._initShowHideListeners(), this._initFocusToggler(), this._initMultiRootIntegration(), this.set("id", null), t.accessibility.addKeystrokeInfos({
          categoryId: "navigation",
          keystrokes: [{
            label: e("Move focus in and out of an active dialog window"),
            keystroke: "Ctrl+F6",
            mayRequireFn: !0
          }]
        });
      }
      _initShowHideListeners() {
        this.on("show", (t, e) => {
          this._show(e);
        }), this.on("show", (t, e) => {
          e.onShow && e.onShow(this);
        }, {
          priority: "low"
        }), this.on("hide", () => {
          Kp._visibleDialogPlugin && Kp._visibleDialogPlugin._hide();
        }), this.on("hide", () => {
          this._onHide && (this._onHide(this), this._onHide = void 0);
        }, {
          priority: "low"
        });
      }
      _initFocusToggler() {
        const t = this.editor;
        t.keystrokes.set("Ctrl+F6", (e, n) => {
          this.isOpen && !this.view.isModal && (this.view.focusTracker.isFocused ? t.editing.view.focus() : this.view.focus(), n());
        });
      }
      _initMultiRootIntegration() {
        const t = this.editor.model;
        t.document.on("change:data", () => {
          if (!this.view) return;
          const e = t.document.differ.getChangedRoots();
          for (const t of e) t.state && this.view.updatePosition();
        });
      }
      show(t) {
        this.hide(), this.fire(`show:${t.id}`, t);
      }
      _show(_ref50) {
        let {
          id: t,
          icon: e,
          title: n,
          hasCloseButton: i = !0,
          content: o,
          actionButtons: r,
          className: s,
          isModal: a,
          position: l,
          onHide: c
        } = _ref50;
        const d = this.editor;
        this.view = new $p(d.locale, {
          getCurrentDomRoot: () => d.editing.view.getDomRoot(d.model.document.selection.anchor.root.rootName),
          getViewportOffset: () => d.ui.viewportOffset
        });
        const u = this.view;
        u.on("close", () => {
          this.hide();
        }), d.ui.view.body.add(u), d.ui.focusTracker.add(u.element), d.keystrokes.listenTo(u.element), l || (l = a ? Rp : Fp), u.set({
          position: l,
          _isVisible: !0,
          className: s,
          isModal: a
        }), u.setupParts({
          icon: e,
          title: n,
          hasCloseButton: i,
          content: o,
          actionButtons: r
        }), this.id = t, c && (this._onHide = c), this.isOpen = !0, Kp._visibleDialogPlugin = this;
      }
      hide() {
        Kp._visibleDialogPlugin && Kp._visibleDialogPlugin.fire(`hide:${Kp._visibleDialogPlugin.id}`);
      }
      _hide() {
        if (!this.view) return;
        const t = this.editor,
          e = this.view;
        e.contentView && e.contentView.reset(), t.ui.view.body.remove(e), t.ui.focusTracker.remove(e.element), t.keystrokes.stopListening(e.element), e.destroy(), t.editing.view.focus(), this.id = null, this.isOpen = !1, Kp._visibleDialogPlugin = null;
      }
    }
    var Yp = o(5615),
      Qp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Yp.A, Qp);
    Yp.A.locals;
    const Zp = Gi("px"),
      Jp = e.document.body,
      Xp = {
        top: -99999,
        left: -99999,
        name: "arrowless",
        config: {
          withArrow: !1
        }
      };
    class tf extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this.content = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", t => `ck-balloon-panel_${t}`), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", Zp),
              left: e.to("left", Zp)
            }
          },
          children: this.content
        });
      }
      show() {
        this.isVisible = !0;
      }
      hide() {
        this.isVisible = !1;
      }
      attachTo(t) {
        this.show();
        const e = tf.defaultPositions,
          n = Object.assign({}, {
            element: this.element,
            positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast, e.viewportStickyNorth],
            limiter: Jp,
            fitInViewport: !0
          }, t),
          i = tf._getOptimalPosition(n) || Xp,
          o = parseInt(i.left),
          r = parseInt(i.top),
          s = i.name,
          a = i.config || {},
          {
            withArrow: l = !0
          } = a;
        this.top = r, this.left = o, this.position = s, this.withArrow = l;
      }
      pin(t) {
        this.unpin(), this._pinWhenIsVisibleCallback = () => {
          this.isVisible ? this._startPinning(t) : this._stopPinning();
        }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
      }
      unpin() {
        this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
      }
      _startPinning(t) {
        this.attachTo(t);
        const n = nf(t.target),
          i = t.limiter ? nf(t.limiter) : Jp;
        this.listenTo(e.document, "scroll", (e, o) => {
          const r = o.target,
            s = n && r.contains(n),
            a = i && r.contains(i);
          !s && !a && n && i || this.attachTo(t);
        }, {
          useCapture: !0
        }), this.listenTo(e.window, "resize", () => {
          this.attachTo(t);
        });
      }
      _stopPinning() {
        this.stopListening(e.document, "scroll"), this.stopListening(e.window, "resize");
      }
    }
    tf.arrowSideOffset = 25, tf.arrowHeightOffset = 10, tf.stickyVerticalOffset = 20, tf._getOptimalPosition = Zi, tf.defaultPositions = of();
    const ef = tf;
    function nf(t) {
      return Ci(t) ? t : Li(t) ? t.commonAncestorContainer : "function" == typeof t ? nf(t()) : null;
    }
    function of() {
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        sideOffset: e = tf.arrowSideOffset,
        heightOffset: n = tf.arrowHeightOffset,
        stickyVerticalOffset: i = tf.stickyVerticalOffset,
        config: o
      } = t;
      return {
        northWestArrowSouthWest: (t, n) => ({
          top: r(t, n),
          left: t.left - e,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthMiddleWest: (t, n) => ({
          top: r(t, n),
          left: t.left - .25 * n.width - e,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouth: (t, e) => ({
          top: r(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthMiddleEast: (t, n) => ({
          top: r(t, n),
          left: t.left - .75 * n.width + e,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northWestArrowSouthEast: (t, n) => ({
          top: r(t, n),
          left: t.left - n.width + e,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthWest: (t, n) => ({
          top: r(t, n),
          left: t.left + t.width / 2 - e,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthMiddleWest: (t, n) => ({
          top: r(t, n),
          left: t.left + t.width / 2 - .25 * n.width - e,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northArrowSouth: (t, e) => ({
          top: r(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthMiddleEast: (t, n) => ({
          top: r(t, n),
          left: t.left + t.width / 2 - .75 * n.width + e,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northArrowSouthEast: (t, n) => ({
          top: r(t, n),
          left: t.left + t.width / 2 - n.width + e,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthWest: (t, n) => ({
          top: r(t, n),
          left: t.right - e,
          name: "arrow_sw",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthMiddleWest: (t, n) => ({
          top: r(t, n),
          left: t.right - .25 * n.width - e,
          name: "arrow_smw",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouth: (t, e) => ({
          top: r(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthMiddleEast: (t, n) => ({
          top: r(t, n),
          left: t.right - .75 * n.width + e,
          name: "arrow_sme",
          ...(o && {
            config: o
          })
        }),
        northEastArrowSouthEast: (t, n) => ({
          top: r(t, n),
          left: t.right - n.width + e,
          name: "arrow_se",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthWest: t => ({
          top: s(t),
          left: t.left - e,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthMiddleWest: (t, n) => ({
          top: s(t),
          left: t.left - .25 * n.width - e,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorth: (t, e) => ({
          top: s(t),
          left: t.left - e.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthMiddleEast: (t, n) => ({
          top: s(t),
          left: t.left - .75 * n.width + e,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southWestArrowNorthEast: (t, n) => ({
          top: s(t),
          left: t.left - n.width + e,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthWest: t => ({
          top: s(t),
          left: t.left + t.width / 2 - e,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthMiddleWest: (t, n) => ({
          top: s(t),
          left: t.left + t.width / 2 - .25 * n.width - e,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southArrowNorth: (t, e) => ({
          top: s(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthMiddleEast: (t, n) => ({
          top: s(t),
          left: t.left + t.width / 2 - .75 * n.width + e,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southArrowNorthEast: (t, n) => ({
          top: s(t),
          left: t.left + t.width / 2 - n.width + e,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthWest: t => ({
          top: s(t),
          left: t.right - e,
          name: "arrow_nw",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthMiddleWest: (t, n) => ({
          top: s(t),
          left: t.right - .25 * n.width - e,
          name: "arrow_nmw",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorth: (t, e) => ({
          top: s(t),
          left: t.right - e.width / 2,
          name: "arrow_n",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthMiddleEast: (t, n) => ({
          top: s(t),
          left: t.right - .75 * n.width + e,
          name: "arrow_nme",
          ...(o && {
            config: o
          })
        }),
        southEastArrowNorthEast: (t, n) => ({
          top: s(t),
          left: t.right - n.width + e,
          name: "arrow_ne",
          ...(o && {
            config: o
          })
        }),
        westArrowEast: (t, e) => ({
          top: t.top + t.height / 2 - e.height / 2,
          left: t.left - e.width - n,
          name: "arrow_e",
          ...(o && {
            config: o
          })
        }),
        eastArrowWest: (t, e) => ({
          top: t.top + t.height / 2 - e.height / 2,
          left: t.right + n,
          name: "arrow_w",
          ...(o && {
            config: o
          })
        }),
        viewportStickyNorth: (t, e, n, r) => {
          const s = r || n;
          return t.getIntersection(s) ? s.height - t.height > i ? null : {
            top: s.top + i,
            left: t.left + t.width / 2 - e.width / 2,
            name: "arrowless",
            config: {
              withArrow: !1,
              ...o
            }
          } : null;
        }
      };
      function r(t, e) {
        return t.top - e.height - n;
      }
      function s(t) {
        return t.bottom + n;
      }
    }
    var rf = o(4650),
      sf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(rf.A, sf);
    rf.A.locals;
    const af = "ck-tooltip";
    class lf extends Bi() {
      constructor(t) {
        if (super(), this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver = null, this._mutationObserver = null, lf._editors.add(t), lf._instance) return lf._instance;
        lf._instance = this, this.tooltipTextView = new Sr(t.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip__text"]
          },
          children: [{
            text: this.tooltipTextView.bindTemplate.to("text")
          }]
        }), this.balloonPanelView = new ef(t.locale), this.balloonPanelView.class = af, this.balloonPanelView.content.add(this.tooltipTextView), this._mutationObserver = function (t) {
          const e = new MutationObserver(() => {
            t();
          });
          return {
            attach(t) {
              e.observe(t, {
                attributes: !0,
                attributeFilter: ["data-cke-tooltip-text", "data-cke-tooltip-position"]
              });
            },
            detach() {
              e.disconnect();
            }
          };
        }(() => {
          this._updateTooltipPosition();
        }), this._pinTooltipDebounced = kl(this._pinTooltip, 600), this._unpinTooltipDebounced = kl(this._unpinTooltip, 400), this.listenTo(e.document, "keydown", this._onKeyDown.bind(this), {
          useCapture: !0
        }), this.listenTo(e.document, "mouseenter", this._onEnterOrFocus.bind(this), {
          useCapture: !0
        }), this.listenTo(e.document, "mouseleave", this._onLeaveOrBlur.bind(this), {
          useCapture: !0
        }), this.listenTo(e.document, "focus", this._onEnterOrFocus.bind(this), {
          useCapture: !0
        }), this.listenTo(e.document, "blur", this._onLeaveOrBlur.bind(this), {
          useCapture: !0
        }), this.listenTo(e.document, "scroll", this._onScroll.bind(this), {
          useCapture: !0
        }), this._watchdogExcluded = !0;
      }
      destroy(t) {
        const e = t.ui.view && t.ui.view.body;
        lf._editors.delete(t), this.stopListening(t.ui), e && e.has(this.balloonPanelView) && e.remove(this.balloonPanelView), lf._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), lf._instance = null);
      }
      static getPositioningFunctions(t) {
        const e = lf.defaultBalloonPositions;
        return {
          s: [e.southArrowNorth, e.southArrowNorthEast, e.southArrowNorthWest],
          n: [e.northArrowSouth],
          e: [e.eastArrowWest],
          w: [e.westArrowEast],
          sw: [e.southArrowNorthEast],
          se: [e.southArrowNorthWest]
        }[t];
      }
      _onKeyDown(t, e) {
        "Escape" === e.key && this._currentElementWithTooltip && (this._unpinTooltip(), e.stopPropagation());
      }
      _onEnterOrFocus(t, _ref51) {
        let {
          target: e
        } = _ref51;
        const n = df(e);
        n ? n !== this._currentElementWithTooltip && (this._unpinTooltip(), this._pinTooltipDebounced(n, uf(n))) : "focus" === t.name && this._unpinTooltip();
      }
      _onLeaveOrBlur(t, _ref52) {
        let {
          target: e,
          relatedTarget: n
        } = _ref52;
        if ("mouseleave" === t.name) {
          if (!Ci(e)) return;
          const t = this.balloonPanelView.element,
            i = t && (t === n || t.contains(n)),
            o = !i && e === t;
          if (i) return void this._unpinTooltipDebounced.cancel();
          if (!o && this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
          const r = df(e),
            s = df(n);
          (o || r && r !== s) && this._unpinTooltipDebounced();
        } else {
          if (this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
          this._unpinTooltipDebounced();
        }
      }
      _onScroll(t, _ref53) {
        let {
          target: e
        } = _ref53;
        this._currentElementWithTooltip && (e.contains(this.balloonPanelView.element) && e.contains(this._currentElementWithTooltip) || this._unpinTooltip());
      }
      _pinTooltip(t, _ref54) {
        let {
          text: e,
          position: n,
          cssClass: i
        } = _ref54;
        this._unpinTooltip();
        const o = $o(lf._editors.values()).ui.view.body;
        o.has(this.balloonPanelView) || o.add(this.balloonPanelView), this.tooltipTextView.text = e, this.balloonPanelView.pin({
          target: t,
          positions: lf.getPositioningFunctions(n)
        }), this._resizeObserver = new Ui(t, () => {
          Qi(t) || this._unpinTooltip();
        }), this._mutationObserver.attach(t), this.balloonPanelView.class = [af, i].filter(t => t).join(" ");
        for (const t of lf._editors) this.listenTo(t.ui, "update", this._updateTooltipPosition.bind(this), {
          priority: "low"
        });
        this._currentElementWithTooltip = t, this._currentTooltipPosition = n;
      }
      _unpinTooltip() {
        this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
        for (const t of lf._editors) this.stopListening(t.ui, "update");
        this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._resizeObserver && this._resizeObserver.destroy(), this._mutationObserver.detach();
      }
      _updateTooltipPosition() {
        if (!this._currentElementWithTooltip) return;
        const t = uf(this._currentElementWithTooltip);
        Qi(this._currentElementWithTooltip) && t.text ? this.balloonPanelView.pin({
          target: this._currentElementWithTooltip,
          positions: lf.getPositioningFunctions(t.position)
        }) : this._unpinTooltip();
      }
    }
    lf.defaultBalloonPositions = of({
      heightOffset: 5,
      sideOffset: 13
    }), lf._editors = new Set(), lf._instance = null;
    const cf = lf;
    function df(t) {
      return Ci(t) ? t.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
    }
    function uf(t) {
      return {
        text: t.dataset.ckeTooltipText,
        position: t.dataset.ckeTooltipPosition || "s",
        cssClass: t.dataset.ckeTooltipClass || ""
      };
    }
    const hf = function (t, e, n) {
      var i = !0,
        o = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return V(n) && (i = "leading" in n ? !!n.leading : i, o = "trailing" in n ? !!n.trailing : o), kl(t, e, {
        leading: i,
        maxWait: e,
        trailing: o
      });
    };
    class mf extends Bi() {
      constructor(t) {
        super(), this.editor = t, this._balloonView = null, this._lastFocusedEditableElement = null, this._showBalloonThrottled = hf(this._showBalloon.bind(this), 50, {
          leading: !0
        }), t.on("ready", this._handleEditorReady.bind(this));
      }
      destroy() {
        const t = this._balloonView;
        t && (t.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
      }
      _handleEditorReady() {
        const t = this.editor;
        (!!t.config.get("ui.poweredBy.forceVisible") || "VALID" !== function (t) {
          function e(t) {
            return t.length >= 40 && t.length <= 255 ? "VALID" : "INVALID";
          }
          if (!t) return "INVALID";
          let n = "";
          try {
            n = atob(t);
          } catch (t) {
            return "INVALID";
          }
          const i = n.split("-"),
            o = i[0],
            r = i[1];
          if (!r) return e(t);
          try {
            atob(r);
          } catch (n) {
            try {
              if (atob(o), !atob(o).length) return e(t);
            } catch (n) {
              return e(t);
            }
          }
          if (o.length < 40 || o.length > 255) return "INVALID";
          let s = "";
          try {
            atob(o), s = atob(r);
          } catch (t) {
            return "INVALID";
          }
          if (8 !== s.length) return "INVALID";
          const a = Number(s.substring(0, 4)),
            l = Number(s.substring(4, 6)) - 1,
            c = Number(s.substring(6, 8)),
            d = new Date(a, l, c);
          return d < v || isNaN(Number(d)) ? "INVALID" : "VALID";
        }(t.config.get("licenseKey"))) && t.ui.view && (t.ui.focusTracker.on("change:isFocused", (t, e, n) => {
          this._updateLastFocusedEditableElement(), n ? this._showBalloon() : this._hideBalloon();
        }), t.ui.focusTracker.on("change:focusedElement", (t, e, n) => {
          this._updateLastFocusedEditableElement(), n && this._showBalloon();
        }), t.ui.on("update", () => {
          this._showBalloonThrottled();
        }));
      }
      _createBalloonView() {
        const t = this.editor,
          e = this._balloonView = new ef(),
          n = ff(t),
          i = new gf(t.locale, n.label);
        e.content.add(i), e.set({
          class: "ck-powered-by-balloon"
        }), t.ui.view.body.add(e), t.ui.focusTracker.add(e.element), this._balloonView = e;
      }
      _showBalloon() {
        if (!this._lastFocusedEditableElement) return;
        const t = function (t, e) {
          const n = ff(t),
            i = "right" === n.side ? function (t, e) {
              return pf(t, e, (t, n) => t.left + t.width - n.width - e.horizontalOffset);
            }(e, n) : function (t, e) {
              return pf(t, e, t => t.left + e.horizontalOffset);
            }(e, n);
          return {
            target: e,
            positions: [i]
          };
        }(this.editor, this._lastFocusedEditableElement);
        t && (this._balloonView || this._createBalloonView(), this._balloonView.pin(t));
      }
      _hideBalloon() {
        this._balloonView && this._balloonView.unpin();
      }
      _updateLastFocusedEditableElement() {
        const t = this.editor,
          e = t.ui.focusTracker.isFocused,
          n = t.ui.focusTracker.focusedElement;
        if (!e || !n) return void (this._lastFocusedEditableElement = null);
        const i = Array.from(t.ui.getEditableElementsNames()).map(e => t.ui.getEditableElement(e));
        i.includes(n) ? this._lastFocusedEditableElement = n : this._lastFocusedEditableElement = i[0];
      }
    }
    class gf extends Sr {
      constructor(t, e) {
        super(t);
        const n = new cm(),
          i = this.bindTemplate;
        n.set({
          content: '<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>\n',
          isColorInherited: !1
        }), n.extendTemplate({
          attributes: {
            style: {
              width: "53px",
              height: "10px"
            }
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-powered-by"],
            "aria-hidden": !0
          },
          children: [{
            tag: "a",
            attributes: {
              href: "https://ckeditor.com/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
              target: "_blank",
              tabindex: "-1"
            },
            children: [...(e ? [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-powered-by__label"]
              },
              children: [e]
            }] : []), n],
            on: {
              dragstart: i.to(t => t.preventDefault())
            }
          }]
        });
      }
    }
    function pf(t, e, n) {
      return (i, o) => {
        const r = new Pi(t);
        if (r.width < 350 || r.height < 50) return null;
        let s;
        s = "inside" === e.position ? r.bottom - o.height : r.bottom - o.height / 2, s -= e.verticalOffset;
        const a = n(r, o),
          l = i.clone().moveTo(a, s).getIntersection(o.clone().moveTo(a, s)).getVisible();
        return !l || l.getArea() < o.getArea() ? null : {
          top: s,
          left: a,
          name: `position_${e.position}-side_${e.side}`,
          config: {
            withArrow: !1
          }
        };
      };
    }
    function ff(t) {
      const e = t.config.get("ui.poweredBy"),
        n = e && e.position || "border";
      return {
        position: n,
        label: "Powered by",
        verticalOffset: "inside" === n ? 5 : 0,
        horizontalOffset: 5,
        side: "ltr" === t.locale.contentLanguageDirection ? "right" : "left",
        ...e
      };
    }
    var kf = o(1710),
      bf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(kf.A, bf);
    kf.A.locals;
    const wf = {
      POLITE: "polite",
      ASSERTIVE: "assertive"
    };
    class Af {
      constructor(t) {
        this.editor = t, t.once("ready", () => {
          for (const t of Object.values(wf)) this.announce("", t);
        });
      }
      announce(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : wf.POLITE;
        const n = this.editor;
        if (!n.ui.view) return;
        this.view || (this.view = new Cf(n.locale), n.ui.view.body.add(this.view));
        const {
          politeness: i,
          isUnsafeHTML: o
        } = "string" == typeof e ? {
          politeness: e
        } : e;
        let r = this.view.regionViews.find(t => t.politeness === i);
        r || (r = new _f(n, i), this.view.regionViews.add(r)), r.announce({
          announcement: t,
          isUnsafeHTML: o
        });
      }
    }
    class Cf extends Sr {
      constructor(t) {
        super(t), this.regionViews = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-aria-live-announcer"]
          },
          children: this.regionViews
        });
      }
    }
    class _f extends Sr {
      constructor(t, e) {
        super(t.locale), this.setTemplate({
          tag: "div",
          attributes: {
            role: "region",
            "aria-live": e,
            "aria-relevant": "additions"
          },
          children: [{
            tag: "ul",
            attributes: {
              class: ["ck", "ck-aria-live-region-list"]
            }
          }]
        }), t.on("destroy", () => {
          null !== this._pruneAnnouncementsInterval && (clearInterval(this._pruneAnnouncementsInterval), this._pruneAnnouncementsInterval = null);
        }), this.politeness = e, this._domConverter = t.data.htmlProcessor.domConverter, this._pruneAnnouncementsInterval = setInterval(() => {
          this.element && this._listElement.firstChild && this._listElement.firstChild.remove();
        }, 5e3);
      }
      announce(_ref55) {
        let {
          announcement: t,
          isUnsafeHTML: e
        } = _ref55;
        if (!t.trim().length) return;
        const n = document.createElement("li");
        e ? this._domConverter.setContentOf(n, t) : n.innerText = t, this._listElement.appendChild(n);
      }
      get _listElement() {
        return this.element.querySelector("ul");
      }
    }
    class vf extends q() {
      constructor(t) {
        super(), this.isReady = !1, this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
        const e = t.editing.view;
        this.editor = t, this.componentFactory = new Dp(t), this.focusTracker = new Ko(), this.tooltipManager = new cf(t), this.poweredBy = new mf(t), this.ariaLiveAnnouncer = new Af(t), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.once("ready", () => {
          this.isReady = !0;
        }), this.listenTo(e.document, "layoutChanged", this.update.bind(this)), this.listenTo(e, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this)), this._initFocusTracking();
      }
      get element() {
        return null;
      }
      update() {
        this.fire("update");
      }
      destroy() {
        this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy();
        for (const t of this._editableElementsMap.values()) t.ckeditorInstance = null, this.editor.keystrokes.stopListening(t);
        this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [];
      }
      setEditableElement(t, e) {
        this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor), this.focusTracker.add(e);
        const n = () => {
          this.editor.editing.view.getDomRoot(t) || this.editor.keystrokes.listenTo(e);
        };
        this.isReady ? n() : this.once("ready", n);
      }
      removeEditableElement(t) {
        const e = this._editableElementsMap.get(t);
        e && (this._editableElementsMap.delete(t), this.editor.keystrokes.stopListening(e), this.focusTracker.remove(e), e.ckeditorInstance = null);
      }
      getEditableElement() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
        return this._editableElementsMap.get(t);
      }
      getEditableElementsNames() {
        return this._editableElementsMap.keys();
      }
      addToolbar(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        t.isRendered ? (this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element)) : t.once("render", () => {
          this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element);
        }), this._focusableToolbarDefinitions.push({
          toolbarView: t,
          options: e
        });
      }
      get _editableElements() {
        return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
          editorUI: this
        }), this._editableElementsMap;
      }
      _readViewportOffsetFromConfig() {
        const t = this.editor,
          e = t.config.get("ui.viewportOffset");
        if (e) return e;
        const n = t.config.get("toolbar.viewportTopOffset");
        return n ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
          top: n
        }) : {
          top: 0
        };
      }
      _initFocusTracking() {
        const t = this.editor,
          e = t.editing.view;
        let n, i;
        t.keystrokes.set("Alt+F10", (t, o) => {
          const r = this.focusTracker.focusedElement;
          Array.from(this._editableElementsMap.values()).includes(r) && !Array.from(e.domRoots.values()).includes(r) && (n = r);
          const s = this._getCurrentFocusedToolbarDefinition();
          s && i || (i = this._getFocusableCandidateToolbarDefinitions());
          for (let t = 0; t < i.length; t++) {
            const t = i.shift();
            if (i.push(t), t !== s && this._focusFocusableCandidateToolbar(t)) {
              s && s.options.afterBlur && s.options.afterBlur();
              break;
            }
          }
          o();
        }), t.keystrokes.set("Esc", (e, i) => {
          const o = this._getCurrentFocusedToolbarDefinition();
          o && (n ? (n.focus(), n = null) : t.editing.view.focus(), o.options.afterBlur && o.options.afterBlur(), i());
        });
      }
      _getFocusableCandidateToolbarDefinitions() {
        const t = [];
        for (const e of this._focusableToolbarDefinitions) {
          const {
            toolbarView: n,
            options: i
          } = e;
          (Qi(n.element) || i.beforeFocus) && t.push(e);
        }
        return t.sort((t, e) => yf(t) - yf(e)), t;
      }
      _getCurrentFocusedToolbarDefinition() {
        for (const t of this._focusableToolbarDefinitions) if (t.toolbarView.element && t.toolbarView.element.contains(this.focusTracker.focusedElement)) return t;
        return null;
      }
      _focusFocusableCandidateToolbar(t) {
        const {
          toolbarView: e,
          options: {
            beforeFocus: n
          }
        } = t;
        return n && n(), !!Qi(e.element) && (e.focus(), !0);
      }
      _handleScrollToTheSelection(t, e) {
        const n = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          ...this.viewportOffset
        };
        e.viewportOffset.top += n.top, e.viewportOffset.bottom += n.bottom, e.viewportOffset.left += n.left, e.viewportOffset.right += n.right;
      }
    }
    function yf(t) {
      const {
        toolbarView: e,
        options: n
      } = t;
      let i = 10;
      return Qi(e.element) && i--, n.isContextual && i--, i;
    }
    var xf = o(178),
      Ef = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(xf.A, Ef);
    xf.A.locals;
    class Df extends Sr {
      constructor(t) {
        super(t), this.body = new rm(t);
      }
      render() {
        super.render(), this.body.attachToDom();
      }
      destroy() {
        return this.body.detachFromDom(), super.destroy();
      }
    }
    class Bf extends Df {
      constructor(t) {
        super(t), this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": this._voiceLabelView.id
          },
          children: [this._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: this.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: this.main
          }]
        });
      }
      _createVoiceLabel() {
        const t = this.t,
          e = new Jh();
        return e.text = t("Rich Text Editor"), e.extendTemplate({
          attributes: {
            class: "ck-voice-label"
          }
        }), e;
      }
    }
    class Sf extends Sr {
      constructor(t, e, n) {
        super(t), this.name = null, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        }), this.set("isFocused", !1), this._editableElement = n, this._hasExternalElement = !!this._editableElement, this._editingView = e;
      }
      render() {
        super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
      }
      destroy() {
        this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
      }
      get hasExternalElement() {
        return this._hasExternalElement;
      }
      _updateIsFocusedClasses() {
        const t = this._editingView;
        function e(e) {
          t.change(n => {
            const i = t.document.getRoot(e.name);
            n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", i);
          });
        }
        t.isRenderingInProgress ? function n(i) {
          t.once("change:isRenderingInProgress", (t, o, r) => {
            r ? n(i) : e(i);
          });
        }(this) : e(this);
      }
    }
    class Tf extends Sf {
      constructor(t, e, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super(t, e, n);
        const o = t.t;
        this.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        }), this._generateLabel = i.label || (() => o("Editor editing area: %0", this.name));
      }
      render() {
        super.render();
        const t = this._editingView;
        t.change(e => {
          const n = t.document.getRoot(this.name);
          e.setAttribute("aria-label", this._generateLabel(this), n);
        });
      }
    }
    class If extends jr {
      static get pluginName() {
        return "Notification";
      }
      init() {
        this.on("show:warning", (t, e) => {
          window.alert(e.message);
        }, {
          priority: "lowest"
        });
      }
      showSuccess(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: t,
          type: "success",
          namespace: e.namespace,
          title: e.title
        });
      }
      showInfo(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: t,
          type: "info",
          namespace: e.namespace,
          title: e.title
        });
      }
      showWarning(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._showNotification({
          message: t,
          type: "warning",
          namespace: e.namespace,
          title: e.title
        });
      }
      _showNotification(t) {
        const e = t.namespace ? `show:${t.type}:${t.namespace}` : `show:${t.type}`;
        this.fire(e, {
          message: t.message,
          type: t.type,
          title: t.title || ""
        });
      }
    }
    class Mf extends q() {
      constructor(t, e) {
        super(), e && el(this, e), t && this.set(t);
      }
    }
    var Lf = o(9938),
      Nf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Lf.A, Nf);
    Lf.A.locals;
    var zf = o(3579),
      Pf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(zf.A, Pf);
    zf.A.locals;
    const Vf = Gi("px");
    class Rf extends Nr {
      static get pluginName() {
        return "ContextualBalloon";
      }
      constructor(t) {
        super(t), this._viewToStack = new Map(), this._idToStack = new Map(), this._view = null, this._rotatorView = null, this._fakePanelsView = null, this.positionLimiter = () => {
          const t = this.editor.editing.view,
            e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, this.set("visibleView", null), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1);
      }
      destroy() {
        super.destroy(), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
      }
      get view() {
        return this._view || this._createPanelView(), this._view;
      }
      hasView(t) {
        return Array.from(this._viewToStack.keys()).includes(t);
      }
      add(t) {
        if (this._view || this._createPanelView(), this.hasView(t.view)) throw new b("contextualballoon-add-view-exist", [this, t]);
        const e = t.stackId || "main";
        if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));
        const n = this._idToStack.get(e);
        t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
      }
      remove(t) {
        if (!this.hasView(t)) throw new b("contextualballoon-remove-view-not-exist", [this, t]);
        const e = this._viewToStack.get(t);
        this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
      }
      updatePosition(t) {
        t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
      }
      showStack(t) {
        this.visibleStack = t;
        const e = this._idToStack.get(t);
        if (!e) throw new b("contextualballoon-showstack-stack-not-exist", this);
        this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
      }
      _createPanelView() {
        this._view = new ef(this.editor.locale), this.editor.ui.view.body.add(this._view), this.editor.ui.focusTracker.add(this._view.element), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
      }
      get _visibleStack() {
        return this._viewToStack.get(this.visibleView);
      }
      _getStackId(t) {
        return Array.from(this._idToStack.entries()).find(e => e[1] === t)[0];
      }
      _showNextStack() {
        const t = Array.from(this._idToStack.values());
        let e = t.indexOf(this._visibleStack) + 1;
        t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
      }
      _showPrevStack() {
        const t = Array.from(this._idToStack.values());
        let e = t.indexOf(this._visibleStack) - 1;
        t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
      }
      _createRotatorView() {
        const t = new Ff(this.editor.locale),
          e = this.editor.locale.t;
        return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e) => !e && t > 1), t.on("change:isNavigationVisible", () => this.updatePosition(), {
          priority: "low"
        }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (t, n) => {
          if (n < 2) return "";
          const i = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
          return e("%0 of %1", [i, n]);
        }), t.buttonNextView.on("execute", () => {
          t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
        }), t.buttonPrevView.on("execute", () => {
          t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
        }), t;
      }
      _createFakePanelsView() {
        const t = new Of(this.editor.locale, this.view);
        return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e) => !e && t >= 2 ? Math.min(t - 1, 2) : 0), t.listenTo(this.view, "change:top", () => t.updatePosition()), t.listenTo(this.view, "change:left", () => t.updatePosition()), this.editor.ui.view.body.add(t), t;
      }
      _showView(_ref56) {
        let {
          view: t,
          balloonClassName: e = "",
          withArrow: n = !0,
          singleViewMode: i = !1
        } = _ref56;
        this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
      }
      _getBalloonPosition() {
        let t = Array.from(this._visibleStack.values()).pop().position;
        return t && (t.limiter || (t = Object.assign({}, t, {
          limiter: this.positionLimiter
        })), t = Object.assign({}, t, {
          viewportOffsetConfig: this.editor.ui.viewportOffset
        })), t;
      }
    }
    class Ff extends Sr {
      constructor(t) {
        super(t);
        const e = t.t,
          n = this.bindTemplate;
        this.set("isNavigationVisible", !0), this.focusTracker = new Ko(), this.buttonPrevView = this._createButtonView(e("Previous"), Yh.previousArrow), this.buttonNextView = this._createButtonView(e("Next"), Yh.nextArrow), this.content = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", t => t ? "" : "ck-hidden")]
            },
            children: [this.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, this.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: this.content
          }]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy();
      }
      showView(t) {
        this.hideView(), this.content.add(t);
      }
      hideView() {
        this.content.clear();
      }
      _createButtonView(t, e) {
        const n = new mm(this.locale);
        return n.set({
          label: t,
          icon: e,
          tooltip: !0
        }), n;
      }
    }
    class Of extends Sr {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = e, this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", t => t ? "" : "ck-hidden")],
            style: {
              top: n.to("top", Vf),
              left: n.to("left", Vf),
              width: n.to("width", Vf),
              height: n.to("height", Vf)
            }
          },
          children: this.content
        }), this.on("change:numberOfPanels", (t, e, n, i) => {
          n > i ? this._addPanels(n - i) : this._removePanels(i - n), this.updatePosition();
        });
      }
      _addPanels(t) {
        for (; t--;) {
          const t = new Sr();
          t.setTemplate({
            tag: "div"
          }), this.content.add(t), this.registerChild(t);
        }
      }
      _removePanels(t) {
        for (; t--;) {
          const t = this.content.last;
          this.content.remove(t), this.deregisterChild(t), t.destroy();
        }
      }
      updatePosition() {
        if (this.numberOfPanels) {
          const {
              top: t,
              left: e
            } = this._balloonPanelView,
            {
              width: n,
              height: i
            } = new Pi(this._balloonPanelView.element);
          Object.assign(this, {
            top: t,
            left: e,
            width: n,
            height: i
          });
        }
      }
    }
    var jf = o(7289),
      Hf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(jf.A, Hf);
    jf.A.locals;
    const Uf = Gi("px");
    class qf extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheBottomOfLimiter", !1), this.set("_stickyTopOffset", null), this.set("_stickyBottomOffset", null), this.content = this.createCollection(), this._contentPanelPlaceholder = new ir({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", t => t ? "block" : "none"),
              height: e.to("isSticky", t => t ? Uf(this._contentPanelRect.height) : null)
            }
          }
        }).render(), this.contentPanelElement = new ir({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", t => t ? Uf(this._contentPanelPlaceholder.getBoundingClientRect().width) : null),
              top: e.to("_stickyTopOffset", t => t ? Uf(t) : t),
              bottom: e.to("_stickyBottomOffset", t => t ? Uf(t) : t),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: this.content
        }).render(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [this._contentPanelPlaceholder, this.contentPanelElement]
        });
      }
      render() {
        super.render(), this.checkIfShouldBeSticky(), this.listenTo(e.document, "scroll", () => {
          this.checkIfShouldBeSticky();
        }, {
          useCapture: !0
        }), this.listenTo(this, "change:isActive", () => {
          this.checkIfShouldBeSticky();
        });
      }
      checkIfShouldBeSticky() {
        if (!this.limiterElement || !this.isActive) return void this._unstick();
        const t = new Pi(this.limiterElement);
        let n = t.getVisible();
        if (n) {
          const t = new Pi(e.window);
          t.top += this.viewportTopOffset, t.height -= this.viewportTopOffset, n = n.getIntersection(t);
        }
        if (n && t.top < n.top) {
          const e = n.top;
          if (e + this._contentPanelRect.height + this.limiterBottomOffset > n.bottom) {
            const e = Math.max(t.bottom - n.bottom, 0) + this.limiterBottomOffset;
            t.bottom - e > t.top + this._contentPanelRect.height ? this._stickToBottomOfLimiter(e) : this._unstick();
          } else this._contentPanelRect.height + this.limiterBottomOffset < t.height ? this._stickToTopOfAncestors(e) : this._unstick();
        } else this._unstick();
      }
      _stickToTopOfAncestors(t) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = t, this._stickyBottomOffset = null, this._marginLeft = Uf(-e.window.scrollX);
      }
      _stickToBottomOfLimiter(t) {
        this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = t, this._marginLeft = Uf(-e.window.scrollX);
      }
      _unstick() {
        this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
      }
      get _contentPanelRect() {
        return new Pi(this.contentPanelElement);
      }
    }
    class Gf extends Fm {
      constructor(t, e) {
        const n = t.t,
          i = Object.assign({}, {
            showResetButton: !0,
            showIcon: !0,
            creator: Lg
          }, e);
        super(t, i.creator), this.label = e.label, this._viewConfig = i, this._viewConfig.showIcon && (this.iconView = new cm(), this.iconView.content = Yh.loupe, this.fieldWrapperChildren.add(this.iconView, 0), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-icon"
          }
        })), this._viewConfig.showResetButton && (this.resetButtonView = new mm(t), this.resetButtonView.set({
          label: n("Clear"),
          icon: Yh.cancel,
          class: "ck-search__reset",
          isVisible: !1,
          tooltip: !0
        }), this.resetButtonView.on("execute", () => {
          this.reset(), this.focus(), this.fire("reset");
        }), this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", t => !t), this.fieldWrapperChildren.add(this.resetButtonView), this.extendTemplate({
          attributes: {
            class: "ck-search__query_with-reset"
          }
        }));
      }
      reset() {
        this.fieldView.reset(), this._viewConfig.showResetButton && (this.resetButtonView.isVisible = !1);
      }
    }
    class Wf extends Sr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set({
          isVisible: !1,
          primaryText: "",
          secondaryText: ""
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__info", t.if("isVisible", "ck-hidden", t => !t)],
            tabindex: -1
          },
          children: [{
            tag: "span",
            children: [{
              text: [t.to("primaryText")]
            }]
          }, {
            tag: "span",
            children: [{
              text: [t.to("secondaryText")]
            }]
          }]
        });
      }
      focus() {
        this.element.focus();
      }
    }
    class $f extends Sr {
      constructor(t) {
        super(t), this.children = this.createCollection(), this.focusTracker = new Ko(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search__results"],
            tabindex: -1
          },
          children: this.children
        }), this._focusCycler = new tg({
          focusables: this.children,
          focusTracker: this.focusTracker
        });
      }
      render() {
        super.render();
        for (const t of this.children) this.focusTracker.add(t.element);
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      focusFirst() {
        this._focusCycler.focusFirst();
      }
      focusLast() {
        this._focusCycler.focusLast();
      }
    }
    var Kf = /[\\^$.*+?()[\]{}|]/g,
      Yf = RegExp(Kf.source);
    const Qf = function (t) {
      return (t = _s(t)) && Yf.test(t) ? t.replace(Kf, "\\$&") : t;
    };
    var Zf = o(5540),
      Jf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Zf.A, Jf);
    Zf.A.locals;
    class Xf extends Sr {
      constructor(t, e) {
        super(t), this._config = e, this.filteredView = e.filteredView, this.queryView = this._createSearchTextQueryView(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.resultsView = new $f(t), this.children = this.createCollection(), this.focusableChildren = this.createCollection([this.queryView, this.resultsView]), this.set("isEnabled", !0), this.set("resultsCount", 0), this.set("totalItemsCount", 0), e.infoView && e.infoView.instance ? this.infoView = e.infoView.instance : (this.infoView = new Wf(), this._enableDefaultInfoViewBehavior(), this.on("render", () => {
          this.search("");
        })), this.resultsView.children.addMany([this.infoView, this.filteredView]), this.focusCycler = new tg({
          focusables: this.focusableChildren,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.on("search", (t, _ref57) => {
          let {
            resultsCount: e,
            totalItemsCount: n
          } = _ref57;
          this.resultsCount = e, this.totalItemsCount = n;
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-search", e.class || null],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), this.children.addMany([this.queryView, this.resultsView]);
        const t = t => t.stopPropagation();
        for (const t of this.focusableChildren) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      focus() {
        this.queryView.focus();
      }
      reset() {
        this.queryView.reset(), this.search("");
      }
      search(t) {
        const e = t ? new RegExp(Qf(t), "ig") : null,
          n = this.filteredView.filter(e);
        this.fire("search", {
          query: t,
          ...n
        });
      }
      _createSearchTextQueryView() {
        const t = new Gf(this.locale, this._config.queryView);
        return this.listenTo(t.fieldView, "input", () => {
          this.search(t.fieldView.element.value);
        }), t.on("reset", () => this.reset()), t.bind("isEnabled").to(this), t;
      }
      _enableDefaultInfoViewBehavior() {
        const t = this.locale.t,
          e = this.infoView;
        function n(t, _ref58) {
          let {
            query: e,
            resultsCount: n,
            totalItemsCount: i
          } = _ref58;
          return "function" == typeof t ? t(e, n, i) : t;
        }
        this.on("search", (i, o) => {
          if (o.resultsCount) e.set({
            isVisible: !1
          });else {
            const i = this._config.infoView && this._config.infoView.text;
            let r, s;
            o.totalItemsCount ? i && i.notFound ? (r = i.notFound.primary, s = i.notFound.secondary) : (r = t("No results found"), s = "") : i && i.noSearchableItems ? (r = i.noSearchableItems.primary, s = i.noSearchableItems.secondary) : (r = t("No searchable items"), s = ""), e.set({
              primaryText: n(r, o),
              secondaryText: n(s, o),
              isVisible: !0
            });
          }
        });
      }
    }
    var tk = o(2688),
      ek = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(tk.A, ek);
    tk.A.locals;
    class nk extends Xf {
      constructor(t, n) {
        super(t, n), this._config = n;
        const i = Gi("px");
        this.extendTemplate({
          attributes: {
            class: ["ck-autocomplete"]
          }
        });
        const o = this.resultsView.bindTemplate;
        this.resultsView.set("isVisible", !1), this.resultsView.set("_position", "s"), this.resultsView.set("_width", 0), this.resultsView.extendTemplate({
          attributes: {
            class: [o.if("isVisible", "ck-hidden", t => !t), o.to("_position", t => `ck-search__results_${t}`)],
            style: {
              width: o.to("_width", i)
            }
          }
        }), this.focusTracker.on("change:isFocused", (t, e, i) => {
          this._updateResultsVisibility(), i ? this.resultsView.element.scrollTop = 0 : n.resetOnBlur && this.queryView.reset();
        }), this.on("search", () => {
          this._updateResultsVisibility(), this._updateResultsViewWidthAndPosition();
        }), this.keystrokes.set("esc", (t, e) => {
          this.resultsView.isVisible && (this.queryView.focus(), this.resultsView.isVisible = !1, e());
        }), this.listenTo(e.document, "scroll", () => {
          this._updateResultsViewWidthAndPosition();
        }), this.on("change:isEnabled", () => {
          this._updateResultsVisibility();
        }), this.filteredView.on("execute", (t, _ref59) => {
          let {
            value: e
          } = _ref59;
          this.focus(), this.reset(), this.queryView.fieldView.value = this.queryView.fieldView.element.value = e, this.resultsView.isVisible = !1;
        }), this.resultsView.on("change:isVisible", () => {
          this._updateResultsViewWidthAndPosition();
        });
      }
      _updateResultsViewWidthAndPosition() {
        if (!this.resultsView.isVisible) return;
        this.resultsView._width = new Pi(this.queryView.fieldView.element).width;
        const t = nk._getOptimalPosition({
          element: this.resultsView.element,
          target: this.queryView.element,
          fitInViewport: !0,
          positions: nk.defaultResultsPositions
        });
        this.resultsView._position = t ? t.name : "s";
      }
      _updateResultsVisibility() {
        const t = void 0 === this._config.queryMinChars ? 0 : this._config.queryMinChars,
          e = this.queryView.fieldView.element.value.length;
        this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && e >= t;
      }
    }
    nk.defaultResultsPositions = [t => ({
      top: t.bottom,
      left: t.left,
      name: "s"
    }), (t, e) => ({
      top: t.top - e.height,
      left: t.left,
      name: "n"
    })], nk._getOptimalPosition = Zi;
    const ik = function (t) {
      return function (e) {
        return null == t ? void 0 : t[e];
      };
    };
    ik({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    });
    var ok = /[&<>"']/g;
    RegExp(ok.source);
    var rk = o(1998),
      sk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(rk.A, sk);
    rk.A.locals;
    var ak = o(5706),
      lk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(ak.A, lk);
    ak.A.locals;
    Gi("px");
    var ck = o(9939),
      dk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(ck.A, dk);
    ck.A.locals, Gi("px");
    Gi("px");
    var uk = o(5667),
      hk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(uk.A, hk);
    uk.A.locals;
    class mk extends mm {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set({
          withText: !0,
          role: "menuitem"
        }), this.arrowView = this._createArrowView(), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__button"],
            "aria-haspopup": !0,
            "aria-expanded": this.bindTemplate.to("isOn", t => String(t)),
            "data-cke-tooltip-disabled": e.to("isOn")
          },
          on: {
            mouseenter: e.to("mouseenter")
          }
        });
      }
      render() {
        super.render(), this.children.add(this.arrowView);
      }
      _createArrowView() {
        const t = new cm();
        return t.content = wm, t.extendTemplate({
          attributes: {
            class: "ck-menu-bar__menu__button__arrow"
          }
        }), t;
      }
    }
    var gk = o(1214),
      pk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(gk.A, pk);
    gk.A.locals;
    class fk extends mg {
      constructor(t, e) {
        super(t);
        const n = this.bindTemplate;
        this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item"]
          },
          on: {
            mouseenter: n.to("mouseenter")
          }
        }), this.delegate("mouseenter").to(e);
      }
    }
    const kk = {
        toggleMenusAndFocusItemsOnHover(t) {
          t.on("menu:mouseenter", e => {
            if (t.isOpen) {
              for (const n of t.menus) {
                const t = e.path[0],
                  i = t instanceof fk && t.children.first === n;
                n.isOpen = (e.path.includes(n) || i) && n.isEnabled;
              }
              e.source.focus();
            }
          });
        },
        focusCycleMenusOnArrows(t) {
          const e = "rtl" === t.locale.uiLanguageDirection;
          function n(e, n) {
            const i = t.children.getIndex(e),
              o = e.isOpen,
              r = t.children.length,
              s = t.children.get((i + r + n) % r);
            e.isOpen = !1, o && (s.isOpen = !0), s.buttonView.focus();
          }
          t.on("menu:arrowright", t => {
            n(t.source, e ? -1 : 1);
          }), t.on("menu:arrowleft", t => {
            n(t.source, e ? 1 : -1);
          });
        },
        closeMenusWhenTheBarCloses(t) {
          t.on("change:isOpen", () => {
            t.isOpen || t.menus.forEach(t => {
              t.isOpen = !1;
            });
          });
        },
        closeMenuWhenAnotherOnTheSameLevelOpens(t) {
          t.on("menu:change:isOpen", (e, n, i) => {
            i && t.menus.filter(t => e.source.parentMenuView === t.parentMenuView && e.source !== t && t.isOpen).forEach(t => {
              t.isOpen = !1;
            });
          });
        },
        closeOnClickOutside(t) {
          Tr({
            emitter: t,
            activator: () => t.isOpen,
            callback: () => t.close(),
            contextElements: () => t.children.map(t => t.element)
          });
        }
      },
      bk = {
        openAndFocusPanelOnArrowDownKey(t) {
          t.keystrokes.set("arrowdown", (e, n) => {
            t.focusTracker.focusedElement === t.buttonView.element && (t.isOpen || (t.isOpen = !0), t.panelView.focus(), n());
          });
        },
        openOnArrowRightKey(t) {
          const e = "rtl" === t.locale.uiLanguageDirection ? "arrowleft" : "arrowright";
          t.keystrokes.set(e, (e, n) => {
            t.focusTracker.focusedElement === t.buttonView.element && t.isEnabled && (t.isOpen || (t.isOpen = !0), t.panelView.focus(), n());
          });
        },
        openOnButtonClick(t) {
          t.buttonView.on("execute", () => {
            t.isOpen = !0, t.panelView.focus();
          });
        },
        toggleOnButtonClick(t) {
          t.buttonView.on("execute", () => {
            t.isOpen = !t.isOpen, t.isOpen && t.panelView.focus();
          });
        },
        closeOnArrowLeftKey(t) {
          const e = "rtl" === t.locale.uiLanguageDirection ? "arrowright" : "arrowleft";
          t.keystrokes.set(e, (e, n) => {
            t.isOpen && (t.isOpen = !1, t.focus(), n());
          });
        },
        closeOnEscKey(t) {
          t.keystrokes.set("esc", (e, n) => {
            t.isOpen && (t.isOpen = !1, t.focus(), n());
          });
        },
        closeOnParentClose(t) {
          t.parentMenuView.on("change:isOpen", (e, n, i) => {
            i || e.source !== t.parentMenuView || (t.isOpen = !1);
          });
        }
      },
      wk = {
        southEast: t => ({
          top: t.bottom,
          left: t.left,
          name: "se"
        }),
        southWest: (t, e) => ({
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        }),
        northEast: (t, e) => ({
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        }),
        northWest: (t, e) => ({
          top: t.top - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        }),
        eastSouth: t => ({
          top: t.top,
          left: t.right - 5,
          name: "es"
        }),
        eastNorth: (t, e) => ({
          top: t.top - e.height,
          left: t.right - 5,
          name: "en"
        }),
        westSouth: (t, e) => ({
          top: t.top,
          left: t.left - e.width + 5,
          name: "ws"
        }),
        westNorth: (t, e) => ({
          top: t.top - e.height,
          left: t.left - e.width + 5,
          name: "wn"
        })
      },
      Ak = [{
        menuId: "file",
        label: "File",
        groups: [{
          groupId: "export",
          items: ["menuBar:exportPdf", "menuBar:exportWord"]
        }, {
          groupId: "import",
          items: ["menuBar:importWord"]
        }, {
          groupId: "revisionHistory",
          items: ["menuBar:revisionHistory"]
        }]
      }, {
        menuId: "edit",
        label: "Edit",
        groups: [{
          groupId: "undo",
          items: ["menuBar:undo", "menuBar:redo"]
        }, {
          groupId: "selectAll",
          items: ["menuBar:selectAll"]
        }, {
          groupId: "findAndReplace",
          items: ["menuBar:findAndReplace"]
        }]
      }, {
        menuId: "view",
        label: "View",
        groups: [{
          groupId: "sourceEditing",
          items: ["menuBar:sourceEditing"]
        }, {
          groupId: "showBlocks",
          items: ["menuBar:showBlocks"]
        }, {
          groupId: "restrictedEditingException",
          items: ["menuBar:restrictedEditingException"]
        }]
      }, {
        menuId: "insert",
        label: "Insert",
        groups: [{
          groupId: "insertMainWidgets",
          items: ["menuBar:uploadImage", "menuBar:ckbox", "menuBar:ckfinder", "menuBar:insertTable"]
        }, {
          groupId: "insertInline",
          items: ["menuBar:link", "menuBar:comment"]
        }, {
          groupId: "insertMinorWidgets",
          items: ["menuBar:insertTemplate", "menuBar:blockQuote", "menuBar:codeBlock", "menuBar:htmlEmbed"]
        }, {
          groupId: "insertStructureWidgets",
          items: ["menuBar:horizontalLine", "menuBar:pageBreak", "menuBar:tableOfContents"]
        }, {
          groupId: "restrictedEditing",
          items: ["menuBar:restrictedEditing"]
        }]
      }, {
        menuId: "format",
        label: "Format",
        groups: [{
          groupId: "textAndFont",
          items: [{
            menuId: "text",
            label: "Text",
            groups: [{
              groupId: "basicStyles",
              items: ["menuBar:bold", "menuBar:italic", "menuBar:underline", "menuBar:strikethrough", "menuBar:superscript", "menuBar:subscript", "menuBar:code"]
            }, {
              groupId: "textPartLanguage",
              items: ["menuBar:textPartLanguage"]
            }]
          }, {
            menuId: "font",
            label: "Font",
            groups: [{
              groupId: "fontProperties",
              items: ["menuBar:fontSize", "menuBar:fontFamily"]
            }, {
              groupId: "fontColors",
              items: ["menuBar:fontColor", "menuBar:fontBackgroundColor"]
            }, {
              groupId: "highlight",
              items: ["menuBar:highlight"]
            }]
          }, "menuBar:heading"]
        }, {
          groupId: "list",
          items: ["menuBar:bulletedList", "menuBar:numberedList", "menuBar:todoList"]
        }, {
          groupId: "indent",
          items: ["menuBar:alignment", "menuBar:indent", "menuBar:outdent"]
        }, {
          groupId: "caseChange",
          items: ["menuBar:caseChange"]
        }, {
          groupId: "removeFormat",
          items: ["menuBar:removeFormat"]
        }]
      }, {
        menuId: "tools",
        label: "Tools",
        groups: [{
          groupId: "aiTools",
          items: ["menuBar:aiAssistant", "menuBar:aiCommands"]
        }, {
          groupId: "tools",
          items: ["menuBar:trackChanges", "menuBar:commentsArchive"]
        }]
      }, {
        menuId: "help",
        label: "Help",
        groups: [{
          groupId: "help",
          items: ["menuBar:accessibilityHelp"]
        }]
      }];
    function Ck(_ref60) {
      let {
        normalizedConfig: t,
        locale: e,
        componentFactory: n
      } = _ref60;
      const i = Ql(t);
      return function (t, e) {
        const n = e.removeItems,
          i = [];
        e.items = e.items.filter(_ref61 => {
          let {
            menuId: t
          } = _ref61;
          return !n.includes(t) || (i.push(t), !1);
        }), xk(e.items, t => {
          t.groups = t.groups.filter(_ref62 => {
            let {
              groupId: t
            } = _ref62;
            return !n.includes(t) || (i.push(t), !1);
          });
          for (const e of t.groups) e.items = e.items.filter(t => {
            const e = Tk(t);
            return !n.includes(e) || (i.push(e), !1);
          });
        });
        for (const e of n) i.includes(e) || w("menu-bar-item-could-not-be-removed", {
          menuBarConfig: t,
          itemName: e
        });
      }(t, i), function (t, e) {
        const n = e.addItems,
          i = [];
        for (const t of n) {
          const n = Bk(t.position),
            o = Sk(t.position);
          if (Ek(t)) {
            if (o) {
              const r = e.items.findIndex(t => t.menuId === o);
              if (-1 != r) "before" === n ? (e.items.splice(r, 0, t.menu), i.push(t)) : "after" === n && (e.items.splice(r + 1, 0, t.menu), i.push(t));else {
                _k(e, t.menu, o, n) && i.push(t);
              }
            } else "start" === n ? (e.items.unshift(t.menu), i.push(t)) : "end" === n && (e.items.push(t.menu), i.push(t));
          } else if (Dk(t)) xk(e.items, e => {
            if (e.menuId === o) "start" === n ? (e.groups.unshift(t.group), i.push(t)) : "end" === n && (e.groups.push(t.group), i.push(t));else {
              const r = e.groups.findIndex(t => t.groupId === o);
              -1 !== r && ("before" === n ? (e.groups.splice(r, 0, t.group), i.push(t)) : "after" === n && (e.groups.splice(r + 1, 0, t.group), i.push(t)));
            }
          });else {
            _k(e, t.item, o, n) && i.push(t);
          }
        }
        for (const e of n) i.includes(e) || w("menu-bar-item-could-not-be-added", {
          menuBarConfig: t,
          addedItemConfig: e
        });
      }(t, i), function (t, e, n) {
        xk(e.items, i => {
          for (const o of i.groups) o.items = o.items.filter(o => {
            const r = "string" == typeof o && !n.has(o);
            return r && !e.isUsingDefaultConfig && w("menu-bar-item-unavailable", {
              menuBarConfig: t,
              parentMenuConfig: Ql(i),
              componentName: o
            }), !r;
          });
        });
      }(t, i, n), vk(t, i), function (t, e) {
        const n = e.t,
          i = {
            File: n({
              string: "File",
              id: "MENU_BAR_MENU_FILE"
            }),
            Edit: n({
              string: "Edit",
              id: "MENU_BAR_MENU_EDIT"
            }),
            View: n({
              string: "View",
              id: "MENU_BAR_MENU_VIEW"
            }),
            Insert: n({
              string: "Insert",
              id: "MENU_BAR_MENU_INSERT"
            }),
            Format: n({
              string: "Format",
              id: "MENU_BAR_MENU_FORMAT"
            }),
            Tools: n({
              string: "Tools",
              id: "MENU_BAR_MENU_TOOLS"
            }),
            Help: n({
              string: "Help",
              id: "MENU_BAR_MENU_HELP"
            }),
            Text: n({
              string: "Text",
              id: "MENU_BAR_MENU_TEXT"
            }),
            Font: n({
              string: "Font",
              id: "MENU_BAR_MENU_FONT"
            })
          };
        xk(t.items, t => {
          t.label in i && (t.label = i[t.label]);
        });
      }(i, e), i;
    }
    function _k(t, e, n, i) {
      let o = !1;
      return xk(t.items, t => {
        for (const {
          groupId: r,
          items: s
        } of t.groups) {
          if (o) return;
          if (r === n) "start" === i ? (s.unshift(e), o = !0) : "end" === i && (s.push(e), o = !0);else {
            const t = s.findIndex(t => Tk(t) === n);
            -1 !== t && ("before" === i ? (s.splice(t, 0, e), o = !0) : "after" === i && (s.splice(t + 1, 0, e), o = !0));
          }
        }
      }), o;
    }
    function vk(t, e) {
      const n = e.isUsingDefaultConfig;
      let i = !1;
      e.items = e.items.filter(e => !!e.groups.length || (yk(t, e, n), !1)), e.items.length ? (xk(e.items, e => {
        e.groups = e.groups.filter(t => !!t.items.length || (i = !0, !1));
        for (const o of e.groups) o.items = o.items.filter(e => !(Ik(e) && !e.groups.length) || (yk(t, e, n), i = !0, !1));
      }), i && vk(t, e)) : yk(t, t, n);
    }
    function yk(t, e, n) {
      n || w("menu-bar-menu-empty", {
        menuBarConfig: t,
        emptyMenuConfig: e
      });
    }
    function xk(t, e) {
      if (Array.isArray(t)) for (const e of t) n(e);
      function n(t) {
        e(t);
        for (const e of t.groups) for (const t of e.items) Ik(t) && n(t);
      }
    }
    function Ek(t) {
      return "object" == typeof t && "menu" in t;
    }
    function Dk(t) {
      return "object" == typeof t && "group" in t;
    }
    function Bk(t) {
      return t.startsWith("start") ? "start" : t.startsWith("end") ? "end" : t.startsWith("after") ? "after" : "before";
    }
    function Sk(t) {
      const e = t.match(/^[^:]+:(.+)/);
      return e ? e[1] : null;
    }
    function Tk(t) {
      return "string" == typeof t ? t : t.menuId;
    }
    function Ik(t) {
      return "object" == typeof t && "menuId" in t;
    }
    function Mk(t, e) {
      const n = e.element;
      t.ui.focusTracker.add(n), t.keystrokes.listenTo(n);
      const i = function (t) {
        let e;
        return e = "items" in t && t.items ? {
          items: t.items,
          removeItems: [],
          addItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !1,
          ...t
        } : {
          items: Ql(Ak),
          addItems: [],
          removeItems: [],
          isVisible: !0,
          isUsingDefaultConfig: !0,
          ...t
        }, e;
      }(t.config.get("menuBar") || {});
      e.fillFromConfig(i, t.ui.componentFactory), t.keystrokes.set("Esc", (e, i) => {
        n.contains(t.ui.focusTracker.focusedElement) && (t.editing.view.focus(), i());
      }), t.keystrokes.set("Alt+F9", (i, o) => {
        n.contains(t.ui.focusTracker.focusedElement) || (e.focus(), o());
      });
    }
    var Lk = o(4873),
      Nk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Lk.A, Nk);
    Lk.A.locals;
    class zk extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-menu-bar__menu__panel", e.to("position", t => `ck-menu-bar__menu__panel_position_${t}`), e.if("isVisible", "ck-hidden", t => !t)],
            tabindex: "-1"
          },
          children: this.children,
          on: {
            selectstart: e.to(t => {
              "input" !== t.target.tagName.toLocaleLowerCase() && t.preventDefault();
            })
          }
        });
      }
      focus() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        this.children.length && (1 === t ? this.children.first.focus() : this.children.last.focus());
      }
    }
    var Pk = o(55),
      Vk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Pk.A, Vk);
    Pk.A.locals;
    class Rk extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.buttonView = new mk(t), this.buttonView.delegate("mouseenter").to(this), this.buttonView.bind("isOn", "isEnabled").to(this, "isOpen", "isEnabled"), this.panelView = new zk(t), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Yo(), this.focusTracker = new Ko(), this.set("isOpen", !1), this.set("isEnabled", !0), this.set("panelPosition", "w"), this.set("class", void 0), this.set("parentMenuView", null), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar__menu", e.to("class"), e.if("isEnabled", "ck-disabled", t => !t), e.if("parentMenuView", "ck-menu-bar__menu_top-level", t => !t)]
          },
          children: [this.buttonView, this.panelView]
        });
      }
      render() {
        super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), bk.closeOnEscKey(this), this._repositionPanelOnOpen();
      }
      _attachBehaviors() {
        this.parentMenuView ? (bk.openOnButtonClick(this), bk.openOnArrowRightKey(this), bk.closeOnArrowLeftKey(this), bk.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), bk.openAndFocusPanelOnArrowDownKey(this), bk.toggleOnButtonClick(this));
      }
      _propagateArrowKeystrokeEvents() {
        this.keystrokes.set("arrowright", (t, e) => {
          this.fire("arrowright"), e();
        }), this.keystrokes.set("arrowleft", (t, e) => {
          this.fire("arrowleft"), e();
        });
      }
      _repositionPanelOnOpen() {
        this.on("change:isOpen", (t, e, n) => {
          if (!n) return;
          const i = Rk._getOptimalPosition({
            element: this.panelView.element,
            target: this.buttonView.element,
            fitInViewport: !0,
            positions: this._panelPositions
          });
          this.panelView.position = i ? i.name : this._panelPositions[0].name;
        });
      }
      focus() {
        this.buttonView.focus();
      }
      get _panelPositions() {
        const {
          southEast: t,
          southWest: e,
          northEast: n,
          northWest: i,
          westSouth: o,
          eastSouth: r,
          westNorth: s,
          eastNorth: a
        } = wk;
        return "ltr" === this.locale.uiLanguageDirection ? this.parentMenuView ? [r, a, o, s] : [t, e, n, i] : this.parentMenuView ? [o, s, r, a] : [e, t, i, n];
      }
    }
    Rk._getOptimalPosition = Zi;
    const Fk = Rk;
    class Ok extends bg {
      constructor(t) {
        super(t), this.role = "menu";
      }
    }
    var jk = o(5078),
      Hk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(jk.A, Hk);
    jk.A.locals;
    class Uk extends mm {
      constructor(t) {
        super(t), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    class qk extends km {
      constructor(t) {
        super(t), this.set({
          withText: !0,
          withKeystroke: !0,
          tooltip: !1,
          role: "menuitem"
        }), this.extendTemplate({
          attributes: {
            class: ["ck-menu-bar__menu__item__button"]
          }
        });
      }
    }
    var Gk = o(4782),
      Wk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Gk.A, Wk);
    Gk.A.locals;
    const $k = ["mouseenter", "arrowleft", "arrowright", "change:isOpen"];
    class Kk extends Sr {
      constructor(t) {
        super(t), this.menus = [];
        const e = t.t;
        this.set("isOpen", !1), this._setupIsOpenUpdater(), this.children = this.createCollection(), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-menu-bar"],
            "aria-label": e("Editor menu bar"),
            role: "menubar"
          },
          children: this.children
        });
      }
      fillFromConfig(t, e) {
        const n = Ck({
          normalizedConfig: t,
          locale: this.locale,
          componentFactory: e
        }).items.map(t => this._createMenu({
          componentFactory: e,
          menuDefinition: t
        }));
        this.children.addMany(n);
      }
      render() {
        super.render(), kk.toggleMenusAndFocusItemsOnHover(this), kk.closeMenusWhenTheBarCloses(this), kk.closeMenuWhenAnotherOnTheSameLevelOpens(this), kk.focusCycleMenusOnArrows(this), kk.closeOnClickOutside(this);
      }
      focus() {
        this.children.first && this.children.first.focus();
      }
      close() {
        for (const t of this.children) t.isOpen = !1;
      }
      registerMenu(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        e ? (t.delegate(...$k).to(e), t.parentMenuView = e) : t.delegate(...$k).to(this, t => "menu:" + t), t._attachBehaviors(), this.menus.push(t);
      }
      _createMenu(_ref63) {
        let {
          componentFactory: t,
          menuDefinition: e,
          parentMenuView: n
        } = _ref63;
        const i = this.locale,
          o = new Fk(i);
        return this.registerMenu(o, n), o.buttonView.set({
          label: e.label
        }), o.once("change:isOpen", () => {
          const n = new Ok(i);
          n.ariaLabel = e.label, o.panelView.children.add(n), n.items.addMany(this._createMenuItems({
            menuDefinition: e,
            parentMenuView: o,
            componentFactory: t
          }));
        }), o;
      }
      _createMenuItems(_ref64) {
        let {
          menuDefinition: t,
          parentMenuView: e,
          componentFactory: n
        } = _ref64;
        const i = this.locale,
          o = [];
        for (const r of t.groups) {
          for (const t of r.items) {
            const r = new fk(i, e);
            if (V(t)) r.children.add(this._createMenu({
              componentFactory: n,
              menuDefinition: t,
              parentMenuView: e
            }));else {
              const i = this._createMenuItemContentFromFactory({
                componentName: t,
                componentFactory: n,
                parentMenuView: e
              });
              if (!i) continue;
              r.children.add(i);
            }
            o.push(r);
          }
          r !== t.groups[t.groups.length - 1] && o.push(new gg(i));
        }
        return o;
      }
      _createMenuItemContentFromFactory(_ref65) {
        let {
          componentName: t,
          parentMenuView: e,
          componentFactory: n
        } = _ref65;
        const i = n.create(t);
        return i instanceof Fk || i instanceof Uk || i instanceof qk ? (this._registerMenuTree(i, e), i.on("execute", () => {
          this.close();
        }), i) : (w("menu-bar-component-unsupported", {
          componentName: t,
          componentView: i
        }), null);
      }
      _registerMenuTree(t, e) {
        if (!(t instanceof Fk)) return void t.delegate("mouseenter").to(e);
        this.registerMenu(t, e);
        const n = t.panelView.children.filter(t => t instanceof Ok)[0];
        if (!n) return void t.delegate("mouseenter").to(e);
        const i = n.items.filter(t => t instanceof mg);
        for (const e of i) this._registerMenuTree(e.children.get(0), t);
      }
      _setupIsOpenUpdater() {
        let t;
        this.on("menu:change:isOpen", (e, n, i) => {
          clearTimeout(t), i ? this.isOpen = !0 : t = setTimeout(() => {
            this.isOpen = Array.from(this.children).some(t => t.isOpen);
          }, 0);
        });
      }
    }
    class Yk extends vf {
      constructor(t, e) {
        super(t), this.view = e, this._toolbarConfig = rg(t.config.get("toolbar")), this._elementReplacer = new Q(), this.listenTo(t.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
      }
      get element() {
        return this.view.element;
      }
      init(t) {
        const e = this.editor,
          n = this.view,
          i = e.editing.view,
          o = n.editable,
          r = i.document.getRoot();
        o.name = r.rootName, n.render();
        const s = o.element;
        this.setEditableElement(o.name, s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), n.menuBarView && Mk(e, n.menuBarView), this._initDialogPluginIntegration(), this.fire("ready");
      }
      destroy() {
        super.destroy();
        const t = this.view,
          e = this.editor.editing.view;
        this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy();
      }
      _initToolbar() {
        const t = this.view;
        t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", _ref66 => {
          let {
            top: t
          } = _ref66;
          return t || 0;
        }), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t.toolbar);
      }
      _initPlaceholder() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document.getRoot(),
          i = t.sourceElement;
        let o;
        const r = t.config.get("placeholder");
        r && (o = "string" == typeof r ? r : r[this.view.editable.name]), !o && i && "textarea" === i.tagName.toLowerCase() && (o = i.getAttribute("placeholder")), o && (n.placeholder = o), Wr({
          view: e,
          element: n,
          isDirectHost: !1,
          keepOnFocus: !0
        });
      }
      _handleScrollToTheSelectionWithStickyPanel(t, e, n) {
        const i = this.view.stickyPanel;
        if (i.isSticky) {
          const t = new Pi(i.element).height;
          e.viewportOffset.top += t;
        } else {
          const t = () => {
            this.editor.editing.view.scrollToTheSelection(n);
          };
          this.listenTo(i, "change:isSticky", t), setTimeout(() => {
            this.stopListening(i, "change:isSticky", t);
          }, 20);
        }
      }
      _initDialogPluginIntegration() {
        if (!this.editor.plugins.has("Dialog")) return;
        const t = this.view.stickyPanel,
          e = this.editor.plugins.get("Dialog");
        e.on("show", () => {
          const n = e.view;
          n.on("moveTo", (e, i) => {
            if (!t.isSticky || n.wasMoved) return;
            const o = new Pi(t.contentPanelElement);
            i[1] < o.bottom + $p.defaultOffset && (i[1] = o.bottom + $p.defaultOffset);
          }, {
            priority: "high"
          });
        }, {
          priority: "low"
        });
      }
    }
    var Qk = o(9881),
      Zk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Qk.A, Zk);
    Qk.A.locals;
    class Jk extends Bf {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super(t), this.stickyPanel = new qf(t), this.toolbar = new cg(t, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        }), n.useMenuBar && (this.menuBarView = new Kk(t)), this.editable = new Tf(t, e);
      }
      render() {
        super.render(), this.menuBarView ? this.stickyPanel.content.addMany([this.menuBarView, this.toolbar]) : this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
      }
    }
    class Xk {
      constructor(t) {
        if (this.crashes = [], this.state = "initializing", this._now = Date.now, this.crashes = [], this._crashNumberLimit = "number" == typeof t.crashNumberLimit ? t.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = "number" == typeof t.minimumNonErrorTimePeriod ? t.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = t => {
          const e = "error" in t ? t.error : t.reason;
          e instanceof Error && this._handleError(e, t);
        }, this._listeners = {}, !this._restart) throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
      }
      destroy() {
        this._stopErrorHandling(), this._listeners = {};
      }
      on(t, e) {
        this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e);
      }
      off(t, e) {
        this._listeners[t] = this._listeners[t].filter(t => t !== e);
      }
      _fire(t) {
        const n = this._listeners[t] || [];
        for (var _len32 = arguments.length, e = new Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
          e[_key32 - 1] = arguments[_key32];
        }
        for (const t of n) t.apply(this, [null, ...e]);
      }
      _startErrorHandling() {
        window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _stopErrorHandling() {
        window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
      }
      _handleError(t, e) {
        if (this._shouldReactToError(t)) {
          this.crashes.push({
            message: t.message,
            stack: t.stack,
            filename: e instanceof ErrorEvent ? e.filename : void 0,
            lineno: e instanceof ErrorEvent ? e.lineno : void 0,
            colno: e instanceof ErrorEvent ? e.colno : void 0,
            date: this._now()
          });
          const n = this._shouldRestart();
          this.state = "crashed", this._fire("stateChange"), this._fire("error", {
            error: t,
            causesRestart: n
          }), n ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
        }
      }
      _shouldReactToError(t) {
        return t.is && t.is("CKEditorError") && void 0 !== t.context && null !== t.context && "ready" === this.state && this._isErrorComingFromThisItem(t);
      }
      _shouldRestart() {
        if (this.crashes.length <= this._crashNumberLimit) return !0;
        return (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
      }
    }
    function tb(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      const n = [t],
        i = new Set();
      let o = 0;
      for (; n.length > o;) {
        const t = n[o++];
        if (!i.has(t) && eb(t) && !e.has(t)) if (i.add(t), Symbol.iterator in t) try {
          for (const e of t) n.push(e);
        } catch (t) {} else for (const e in t) "defaultValue" !== e && n.push(t[e]);
      }
      return i;
    }
    function eb(t) {
      const e = Object.prototype.toString.call(t),
        n = typeof t;
      return !("number" === n || "boolean" === n || "string" === n || "symbol" === n || "function" === n || "[object Date]" === e || "[object RegExp]" === e || "[object Module]" === e || null == t || t._watchdogExcluded || t instanceof EventTarget || t instanceof Event);
    }
    function nb(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
      if (t === e && "object" == typeof (i = t) && null !== i) return !0;
      var i;
      const o = tb(t, n),
        r = tb(e, n);
      for (const t of o) if (r.has(t)) return !0;
      return !1;
    }
    class ib extends Xk {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this._editor = null, this._lifecyclePromise = null, this._initUsingData = !0, this._editables = {}, this._throttledSave = hf(this._save.bind(this), "number" == typeof e.saveInterval ? e.saveInterval : 5e3), t && (this._creator = (e, n) => t.create(e, n)), this._destructor = t => t.destroy();
      }
      get editor() {
        return this._editor;
      }
      get _item() {
        return this._editor;
      }
      setCreator(t) {
        this._creator = t;
      }
      setDestructor(t) {
        this._destructor = t;
      }
      _restart() {
        return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch(t => {
          console.error("An error happened during the editor destroying.", t);
        }).then(() => {
          const t = {},
            e = [],
            n = this._config.rootsAttributes || {},
            i = {};
          for (const [o, r] of Object.entries(this._data.roots)) r.isLoaded ? (t[o] = "", i[o] = n[o] || {}) : e.push(o);
          const o = {
            ...this._config,
            extraPlugins: this._config.extraPlugins || [],
            lazyRoots: e,
            rootsAttributes: i,
            _watchdogInitialData: this._data
          };
          return delete o.initialData, o.extraPlugins.push(ob), this._initUsingData ? this.create(t, o, o.context) : Ci(this._elementOrData) ? this.create(this._elementOrData, o, o.context) : this.create(this._editables, o, o.context);
        }).then(() => {
          this._fire("restart");
        });
      }
      create() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._elementOrData;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._config;
        let n = arguments.length > 2 ? arguments[2] : undefined;
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (super._startErrorHandling(), this._elementOrData = t, this._initUsingData = "string" == typeof t || Object.keys(t).length > 0 && "string" == typeof Object.values(t)[0], this._config = this._cloneEditorConfiguration(e) || {}, this._config.context = n, this._creator(t, this._config))).then(t => {
          this._editor = t, t.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = t.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
        }).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      destroy() {
        return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy())).finally(() => {
          this._lifecyclePromise = null;
        }), this._lifecyclePromise;
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling(), this._throttledSave.cancel();
          const t = this._editor;
          return this._editor = null, t.model.document.off("change:data", this._throttledSave), this._destructor(t);
        });
      }
      _save() {
        const t = this._editor.model.document.version;
        try {
          this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t;
        } catch (t) {
          console.error(t, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
        }
      }
      _setExcludedProperties(t) {
        this._excludedProps = t;
      }
      _getData() {
        const t = this._editor,
          e = t.model.document.roots.filter(t => t.isAttached() && "$graveyard" != t.rootName),
          {
            plugins: n
          } = t,
          i = n.has("CommentsRepository") && n.get("CommentsRepository"),
          o = n.has("TrackChanges") && n.get("TrackChanges"),
          r = {
            roots: {},
            markers: {},
            commentThreads: JSON.stringify([]),
            suggestions: JSON.stringify([])
          };
        e.forEach(t => {
          r.roots[t.rootName] = {
            content: JSON.stringify(Array.from(t.getChildren())),
            attributes: JSON.stringify(Array.from(t.getAttributes())),
            isLoaded: t._isLoaded
          };
        });
        for (const e of t.model.markers) e._affectsData && (r.markers[e.name] = {
          rangeJSON: e.getRange().toJSON(),
          usingOperation: e._managedUsingOperations,
          affectsData: e._affectsData
        });
        return i && (r.commentThreads = JSON.stringify(i.getCommentThreads({
          toJSON: !0,
          skipNotAttached: !0
        }))), o && (r.suggestions = JSON.stringify(o.getSuggestions({
          toJSON: !0,
          skipNotAttached: !0
        }))), r;
      }
      _getEditables() {
        const t = {};
        for (const e of this.editor.model.document.getRootNames()) {
          const n = this.editor.ui.getEditableElement(e);
          n && (t[e] = n);
        }
        return t;
      }
      _isErrorComingFromThisItem(t) {
        return nb(this._editor, t.context, this._excludedProps);
      }
      _cloneEditorConfiguration(t) {
        return Ai(t, (t, e) => Ci(t) || "context" === e ? t : void 0);
      }
    }
    class ob {
      constructor(t) {
        this.editor = t, this._data = t.config.get("_watchdogInitialData");
      }
      init() {
        this.editor.data.on("init", t => {
          t.stop(), this.editor.model.enqueueChange({
            isUndoable: !1
          }, t => {
            this._restoreCollaborationData(), this._restoreEditorData(t);
          }), this.editor.data.fire("ready");
        }, {
          priority: 999
        });
      }
      _createNode(t, e) {
        if ("name" in e) {
          const n = t.createElement(e.name, e.attributes);
          if (e.children) for (const i of e.children) n._appendChild(this._createNode(t, i));
          return n;
        }
        return t.createText(e.data, e.attributes);
      }
      _restoreEditorData(t) {
        const e = this.editor;
        Object.entries(this._data.roots).forEach(_ref67 => {
          let [n, {
            content: i,
            attributes: o
          }] = _ref67;
          const r = JSON.parse(i),
            s = JSON.parse(o),
            a = e.model.document.getRoot(n);
          for (const [e, n] of s) t.setAttribute(e, n, a);
          for (const e of r) {
            const n = this._createNode(t, e);
            t.insert(n, a, "end");
          }
        }), Object.entries(this._data.markers).forEach(_ref68 => {
          let [n, i] = _ref68;
          const {
              document: o
            } = e.model,
            {
              rangeJSON: {
                start: r,
                end: s
              },
              ...a
            } = i,
            l = o.getRoot(r.root),
            c = t.createPositionFromPath(l, r.path, r.stickiness),
            d = t.createPositionFromPath(l, s.path, s.stickiness),
            u = t.createRange(c, d);
          t.addMarker(n, {
            range: u,
            ...a
          });
        });
      }
      _restoreCollaborationData() {
        const t = JSON.parse(this._data.commentThreads),
          e = JSON.parse(this._data.suggestions);
        t.forEach(t => {
          const e = this.editor.config.get("collaboration.channelId"),
            n = this.editor.plugins.get("CommentsRepository");
          if (n.hasCommentThread(t.threadId)) {
            n.getCommentThread(t.threadId).remove();
          }
          n.addCommentThread({
            channelId: e,
            ...t
          });
        }), e.forEach(t => {
          const e = this.editor.plugins.get("TrackChangesEditing");
          if (e.hasSuggestion(t.id)) {
            e.getSuggestion(t.id).attributes = t.attributes;
          } else e.addSuggestionData(t);
        });
      }
    }
    const rb = Symbol("MainQueueId");
    class sb {
      constructor() {
        this._onEmptyCallbacks = [], this._queues = new Map(), this._activeActions = 0;
      }
      onEmpty(t) {
        this._onEmptyCallbacks.push(t);
      }
      enqueue(t, e) {
        const n = t === rb;
        this._activeActions++, this._queues.get(t) || this._queues.set(t, Promise.resolve());
        const i = (n ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(rb), this._queues.get(t)])).then(e),
          o = i.catch(() => {});
        return this._queues.set(t, o), i.finally(() => {
          this._activeActions--, this._queues.get(t) === o && 0 === this._activeActions && this._onEmptyCallbacks.forEach(t => t());
        });
      }
    }
    function ab(t) {
      return Array.isArray(t) ? t : [t];
    }
    class lb extends $h(Wh) {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!db(t) && void 0 !== e.initialData) throw new b("editor-create-initial-data", null);
        super(e), this.config.define("menuBar.isVisible", !1), void 0 === this.config.get("initialData") && this.config.set("initialData", function (t) {
          return db(t) ? (e = t, e instanceof HTMLTextAreaElement ? e.value : e.innerHTML) : t;
          var e;
        }(t)), db(t) && (this.sourceElement = t), this.model.document.createRoot();
        const n = !this.config.get("toolbar.shouldNotGroupWhenFull"),
          i = this.config.get("menuBar"),
          o = new Jk(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: n,
            useMenuBar: i.isVisible
          });
        this.ui = new Yk(this, o), function (t) {
          if (!Ft(t.updateSourceElement)) throw new b("attachtoform-missing-elementapi-interface", t);
          const e = t.sourceElement;
          if (function (t) {
            return !!t && "textarea" === t.tagName.toLowerCase();
          }(e) && e.form) {
            let n;
            const i = e.form,
              o = () => t.updateSourceElement();
            Ft(i.submit) && (n = i.submit, i.submit = () => {
              o(), n.apply(i);
            }), i.addEventListener("submit", o), t.on("destroy", () => {
              i.removeEventListener("submit", o), n && (i.submit = n);
            });
          }
        }(this);
      }
      destroy() {
        return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
      }
      static create(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(n => {
          const i = new this(t, e);
          n(i.initPlugins().then(() => i.ui.init(db(t) ? t : null)).then(() => i.data.init(i.config.get("initialData"))).then(() => i.fire("ready")).then(() => i));
        });
      }
    }
    lb.Context = Or, lb.EditorWatchdog = ib, lb.ContextWatchdog = class extends Xk {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(e), this._watchdogs = new Map(), this._context = null, this._contextProps = new Set(), this._actionQueues = new sb(), this._watchdogConfig = e, this._creator = e => t.create(e), this._destructor = t => t.destroy(), this._actionQueues.onEmpty(() => {
          "initializing" === this.state && (this.state = "ready", this._fire("stateChange"));
        });
      }
      setCreator(t) {
        this._creator = t;
      }
      setDestructor(t) {
        this._destructor = t;
      }
      get context() {
        return this._context;
      }
      create() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return this._actionQueues.enqueue(rb, () => (this._contextConfig = t, this._create()));
      }
      getItem(t) {
        return this._getWatchdog(t)._item;
      }
      getItemState(t) {
        return this._getWatchdog(t).state;
      }
      add(t) {
        const e = ab(t);
        return Promise.all(e.map(t => this._actionQueues.enqueue(t.id, () => {
          if ("destroyed" === this.state) throw new Error("Cannot add items to destroyed watchdog.");
          if (!this._context) throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
          let e;
          if (this._watchdogs.has(t.id)) throw new Error(`Item with the given id is already added: '${t.id}'.`);
          if ("editor" === t.type) return e = new ib(null, this._watchdogConfig), e.setCreator(t.creator), e._setExcludedProperties(this._contextProps), t.destructor && e.setDestructor(t.destructor), this._watchdogs.set(t.id, e), e.on("error", (n, _ref69) => {
            let {
              error: i,
              causesRestart: o
            } = _ref69;
            this._fire("itemError", {
              itemId: t.id,
              error: i
            }), o && this._actionQueues.enqueue(t.id, () => new Promise(n => {
              const i = () => {
                e.off("restart", i), this._fire("itemRestart", {
                  itemId: t.id
                }), n();
              };
              e.on("restart", i);
            }));
          }), e.create(t.sourceElementOrData, t.config, this._context);
          throw new Error(`Not supported item type: '${t.type}'.`);
        })));
      }
      remove(t) {
        const e = ab(t);
        return Promise.all(e.map(t => this._actionQueues.enqueue(t, () => {
          const e = this._getWatchdog(t);
          return this._watchdogs.delete(t), e.destroy();
        })));
      }
      destroy() {
        return this._actionQueues.enqueue(rb, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
      }
      _restart() {
        return this._actionQueues.enqueue(rb, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch(t => {
          console.error("An error happened during destroying the context or items.", t);
        }).then(() => this._create()).then(() => this._fire("restart"))));
      }
      _create() {
        return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then(t => (this._context = t, this._contextProps = tb(this._context), Promise.all(Array.from(this._watchdogs.values()).map(t => (t._setExcludedProperties(this._contextProps), t.create(void 0, void 0, this._context))))));
      }
      _destroy() {
        return Promise.resolve().then(() => {
          this._stopErrorHandling();
          const t = this._context;
          return this._context = null, this._contextProps = new Set(), Promise.all(Array.from(this._watchdogs.values()).map(t => t.destroy())).then(() => this._destructor(t));
        });
      }
      _getWatchdog(t) {
        const e = this._watchdogs.get(t);
        if (!e) throw new Error(`Item with the given id was not registered: ${t}.`);
        return e;
      }
      _isErrorComingFromThisItem(t) {
        for (const e of this._watchdogs.values()) if (e._isErrorComingFromThisItem(t)) return !1;
        return nb(this._context, t.context);
      }
    };
    const cb = lb;
    function db(t) {
      return Ci(t);
    }
    class ub extends il {
      constructor(t) {
        super(t), this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"];
        const e = this.document;
        function n(t) {
          return (n, i) => {
            i.preventDefault();
            const o = i.dropRange ? [i.dropRange] : null,
              r = new m(e, t);
            e.fire(r, {
              dataTransfer: i.dataTransfer,
              method: n.name,
              targetRanges: o,
              target: i.target,
              domEvent: i.domEvent
            }), r.stop.called && i.stopPropagation();
          };
        }
        this.listenTo(e, "paste", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(e, "drop", n("clipboardInput"), {
          priority: "low"
        }), this.listenTo(e, "dragover", n("dragging"), {
          priority: "low"
        });
      }
      onDomEvent(t) {
        const e = "clipboardData" in t ? t.clipboardData : t.dataTransfer,
          n = "drop" == t.type || "paste" == t.type,
          i = {
            dataTransfer: new Gl(e, {
              cacheFiles: n
            })
          };
        "drop" != t.type && "dragover" != t.type || (i.dropRange = function (t, e) {
          const n = e.target.ownerDocument,
            i = e.clientX,
            o = e.clientY;
          let r;
          n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
          if (r) return t.domConverter.domRangeToView(r);
          return null;
        }(this.view, t)), this.fire(t.type, t, i);
      }
    }
    const hb = ["figcaption", "li"],
      mb = ["ol", "ul"];
    function gb(t) {
      if (t.is("$text") || t.is("$textProxy")) return t.data;
      if (t.is("element", "img") && t.hasAttribute("alt")) return t.getAttribute("alt");
      if (t.is("element", "br")) return "\n";
      let e = "",
        n = null;
      for (const i of t.getChildren()) e += pb(i, n) + gb(i), n = i;
      return e;
    }
    function pb(t, e) {
      return e ? t.is("element", "li") && !t.isEmpty && t.getChild(0).is("containerElement") || mb.includes(t.name) && mb.includes(e.name) ? "\n\n" : t.is("containerElement") || e.is("containerElement") ? hb.includes(t.name) || hb.includes(e.name) ? "\n" : "\n\n" : "" : "";
    }
    const fb = function (t, e) {
      return t && xo(t, e, an);
    };
    const kb = function (t, e, n, i) {
      var o = n.length,
        r = o,
        s = !i;
      if (null == t) return !r;
      for (t = Object(t); o--;) {
        var a = n[o];
        if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t)) return !1;
      }
      for (; ++o < r;) {
        var l = (a = n[o])[0],
          c = t[l],
          d = a[1];
        if (s && a[2]) {
          if (void 0 === c && !(l in t)) return !1;
        } else {
          var u = new _e();
          if (i) var h = i(c, d, l, t, e, u);
          if (!(void 0 === h ? Rl(d, c, 3, i, u) : h)) return !1;
        }
      }
      return !0;
    };
    const bb = function (t) {
      return t == t && !V(t);
    };
    const wb = function (t) {
      for (var e = an(t), n = e.length; n--;) {
        var i = e[n],
          o = t[i];
        e[n] = [i, o, bb(o)];
      }
      return e;
    };
    const Ab = function (t, e) {
      return function (n) {
        return null != n && n[t] === e && (void 0 !== e || t in Object(n));
      };
    };
    const Cb = function (t) {
      var e = wb(t);
      return 1 == e.length && e[0][2] ? Ab(e[0][0], e[0][1]) : function (n) {
        return n === t || kb(n, t, e);
      };
    };
    const _b = function (t, e) {
      return null != t && e in Object(t);
    };
    const vb = function (t, e, n) {
      for (var i = -1, o = (e = vs(e, t)).length, r = !1; ++i < o;) {
        var s = xs(e[i]);
        if (!(r = null != t && n(t, s))) break;
        t = t[s];
      }
      return r || ++i != o ? r : !!(o = null == t ? 0 : t.length) && He(o) && je(s, o) && (mt(t) || Ne(t));
    };
    const yb = function (t, e) {
      return null != t && vb(t, e, _b);
    };
    const xb = function (t, e) {
      return ds(t) && bb(e) ? Ab(xs(t), e) : function (n) {
        var i = Is(n, t);
        return void 0 === i && i === e ? yb(n, t) : Rl(e, i, 3);
      };
    };
    const Eb = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    };
    const Db = function (t) {
      return function (e) {
        return Es(e, t);
      };
    };
    const Bb = function (t) {
      return ds(t) ? Eb(xs(t)) : Db(t);
    };
    const Sb = function (t) {
      return "function" == typeof t ? t : null == t ? Io : "object" == typeof t ? mt(t) ? xb(t[0], t[1]) : Cb(t) : Bb(t);
    };
    const Tb = function (t, e) {
      var n = {};
      return e = Sb(e, 3), fb(t, function (t, i, o) {
        xe(n, i, e(t, i, o));
      }), n;
    };
    class Ib extends Nr {
      constructor() {
        super(...arguments), this._markersToCopy = new Map();
      }
      static get pluginName() {
        return "ClipboardMarkersUtils";
      }
      _registerMarkerToCopy(t, e) {
        this._markersToCopy.set(t, e);
      }
      _copySelectedFragmentWithMarkers(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t => t.model.getSelectedContent(t.model.document.selection);
        return this.editor.model.change(i => {
          const o = i.model.document.selection;
          i.setSelection(e);
          const r = this._insertFakeMarkersIntoSelection(i, i.model.document.selection, t),
            s = n(i),
            a = this._removeFakeMarkersInsideElement(i, s);
          for (const [t, e] of Object.entries(r)) {
            a[t] || (a[t] = i.createRangeIn(s));
            for (const t of e) i.remove(t);
          }
          s.markers.clear();
          for (const [t, e] of Object.entries(a)) s.markers.set(t, e);
          return i.setSelection(o), s;
        });
      }
      _pasteMarkersIntoTransformedElement(t, e) {
        const n = this._getPasteMarkersFromRangeMap(t);
        return this.editor.model.change(t => {
          const i = this._insertFakeMarkersElements(t, n),
            o = e(t),
            r = this._removeFakeMarkersInsideElement(t, o);
          for (const e of Object.values(i).flat()) t.remove(e);
          for (const [e, n] of Object.entries(r)) t.model.markers.has(e) || t.addMarker(e, {
            usingOperation: !0,
            affectsData: !0,
            range: n
          });
          return o;
        });
      }
      _pasteFragmentWithMarkers(t) {
        const e = this._getPasteMarkersFromRangeMap(t.markers);
        t.markers.clear();
        for (const n of e) t.markers.set(n.name, n.range);
        return this.editor.model.insertContent(t);
      }
      _forceMarkersCopy(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          allowedActions: "all",
          copyPartiallySelected: !0,
          duplicateOnPaste: !0
        };
        const i = this._markersToCopy.get(t);
        this._markersToCopy.set(t, n), e(), i ? this._markersToCopy.set(t, i) : this._markersToCopy.delete(t);
      }
      _isMarkerCopyable(t, e) {
        const n = this._getMarkerClipboardConfig(t);
        if (!n) return !1;
        if (!e) return !0;
        const {
          allowedActions: i
        } = n;
        return "all" === i || i.includes(e);
      }
      _hasMarkerConfiguration(t) {
        return !!this._getMarkerClipboardConfig(t);
      }
      _getMarkerClipboardConfig(t) {
        const [e] = t.split(":");
        return this._markersToCopy.get(e) || null;
      }
      _insertFakeMarkersIntoSelection(t, e, n) {
        const i = this._getCopyableMarkersFromSelection(t, e, n);
        return this._insertFakeMarkersElements(t, i);
      }
      _getCopyableMarkersFromSelection(t, e, n) {
        const i = Array.from(e.getRanges()),
          o = new Set(i.flatMap(e => Array.from(t.model.markers.getMarkersIntersectingRange(e))));
        return Array.from(o).filter(t => {
          if (!this._isMarkerCopyable(t.name, n)) return !1;
          const {
            copyPartiallySelected: e
          } = this._getMarkerClipboardConfig(t.name);
          if (!e) {
            const e = t.getRange();
            return i.some(t => t.containsRange(e, !0));
          }
          return !0;
        }).map(t => ({
          name: "dragstart" === n ? this._getUniqueMarkerName(t.name) : t.name,
          range: t.getRange()
        }));
      }
      _getPasteMarkersFromRangeMap(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const {
          model: n
        } = this.editor;
        return (t instanceof Map ? Array.from(t.entries()) : Object.entries(t)).flatMap(_ref70 => {
          let [t, i] = _ref70;
          if (!this._hasMarkerConfiguration(t)) return [{
            name: t,
            range: i
          }];
          if (this._isMarkerCopyable(t, e)) {
            const e = this._getMarkerClipboardConfig(t),
              o = n.markers.has(t) && "$graveyard" === n.markers.get(t).getRange().root.rootName;
            return (e.duplicateOnPaste || o) && (t = this._getUniqueMarkerName(t)), [{
              name: t,
              range: i
            }];
          }
          return [];
        });
      }
      _insertFakeMarkersElements(t, e) {
        const n = {},
          i = e.flatMap(t => {
            const {
              start: e,
              end: n
            } = t.range;
            return [{
              position: e,
              marker: t,
              type: "start"
            }, {
              position: n,
              marker: t,
              type: "end"
            }];
          }).sort((_ref71, _ref72) => {
            let {
              position: t
            } = _ref71;
            let {
              position: e
            } = _ref72;
            return t.isBefore(e) ? 1 : -1;
          });
        for (const {
          position: e,
          marker: o,
          type: r
        } of i) {
          const i = t.createElement("$marker", {
            "data-name": o.name,
            "data-type": r
          });
          n[o.name] || (n[o.name] = []), n[o.name].push(i), t.insert(i, e);
        }
        return n;
      }
      _removeFakeMarkersInsideElement(t, e) {
        const n = this._getAllFakeMarkersFromElement(t, e).reduce((e, n) => {
          const i = n.markerElement && t.createPositionBefore(n.markerElement);
          let o = e[n.name],
            r = !1;
          if (o && o.start && o.end) {
            this._getMarkerClipboardConfig(n.name).duplicateOnPaste ? e[this._getUniqueMarkerName(n.name)] = e[n.name] : r = !0, o = null;
          }
          return r || (e[n.name] = {
            ...o,
            [n.type]: i
          }), n.markerElement && t.remove(n.markerElement), e;
        }, {});
        return Tb(n, n => new hc(n.start || t.createPositionFromPath(e, [0]), n.end || t.createPositionAt(e, "end")));
      }
      _getAllFakeMarkersFromElement(t, e) {
        const n = Array.from(t.createRangeIn(e)).flatMap(_ref73 => {
            let {
              item: t
            } = _ref73;
            if (!t.is("element", "$marker")) return [];
            const e = t.getAttribute("data-name"),
              n = t.getAttribute("data-type");
            return [{
              markerElement: t,
              name: e,
              type: n
            }];
          }),
          i = [],
          o = [];
        for (const t of n) {
          if ("end" === t.type) {
            n.some(e => e.name === t.name && "start" === e.type) || i.push({
              markerElement: null,
              name: t.name,
              type: "start"
            });
          }
          if ("start" === t.type) {
            n.some(e => e.name === t.name && "end" === e.type) || o.unshift({
              markerElement: null,
              name: t.name,
              type: "end"
            });
          }
        }
        return [...i, ...n, ...o];
      }
      _getUniqueMarkerName(t) {
        const e = t.split(":"),
          n = p().substring(1, 6);
        return 3 === e.length ? `${e.slice(0, 2).join(":")}:${n}` : `${e.join(":")}:${n}`;
      }
    }
    class Mb extends Nr {
      static get pluginName() {
        return "ClipboardPipeline";
      }
      static get requires() {
        return [Ib];
      }
      init() {
        this.editor.editing.view.addObserver(ub), this._setupPasteDrop(), this._setupCopyCut();
      }
      _fireOutputTransformationEvent(t, e, n) {
        const i = this.editor.plugins.get("ClipboardMarkersUtils");
        this.editor.model.enqueueChange({
          isUndoable: "cut" === n
        }, () => {
          const o = i._copySelectedFragmentWithMarkers(n, e);
          this.fire("outputTransformation", {
            dataTransfer: t,
            content: o,
            method: n
          });
        });
      }
      _setupPasteDrop() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = n.document,
          o = this.editor.plugins.get("ClipboardMarkersUtils");
        this.listenTo(i, "clipboardInput", (e, n) => {
          "paste" != n.method || t.model.canEditAt(t.model.document.selection) || e.stop();
        }, {
          priority: "highest"
        }), this.listenTo(i, "clipboardInput", (t, e) => {
          const i = e.dataTransfer;
          let o;
          if (e.content) o = e.content;else {
            let t = "";
            i.getData("text/html") ? t = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, e) => 1 == e.length ? " " : e).replace(/<!--[\s\S]*?-->/g, "");
            }(i.getData("text/html")) : i.getData("text/plain") && (((r = (r = i.getData("text/plain")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || r.includes("<br>")) && (r = `<p>${r}</p>`), t = r), o = this.editor.data.htmlProcessor.toView(t);
          }
          var r;
          const s = new m(this, "inputTransformation");
          this.fire(s, {
            content: o,
            dataTransfer: i,
            targetRanges: e.targetRanges,
            method: e.method
          }), s.stop.called && t.stop(), n.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.listenTo(this, "inputTransformation", (t, n) => {
          if (n.content.isEmpty) return;
          const i = this.editor.data.toModel(n.content, "$clipboardHolder");
          0 != i.childCount && (t.stop(), e.change(() => {
            this.fire("contentInsertion", {
              content: i,
              method: n.method,
              dataTransfer: n.dataTransfer,
              targetRanges: n.targetRanges
            });
          }));
        }, {
          priority: "low"
        }), this.listenTo(this, "contentInsertion", (t, e) => {
          e.resultRange = o._pasteFragmentWithMarkers(e.content);
        }, {
          priority: "low"
        });
      }
      _setupCopyCut() {
        const t = this.editor,
          e = t.model.document,
          n = t.editing.view.document,
          i = (t, n) => {
            const i = n.dataTransfer;
            n.preventDefault(), this._fireOutputTransformationEvent(i, e.selection, t.name);
          };
        this.listenTo(n, "copy", i, {
          priority: "low"
        }), this.listenTo(n, "cut", (e, n) => {
          t.model.canEditAt(t.model.document.selection) ? i(e, n) : n.preventDefault();
        }, {
          priority: "low"
        }), this.listenTo(this, "outputTransformation", (e, i) => {
          const o = t.data.toView(i.content);
          n.fire("clipboardOutput", {
            dataTransfer: i.dataTransfer,
            content: o,
            method: i.method
          });
        }, {
          priority: "low"
        }), this.listenTo(n, "clipboardOutput", (n, i) => {
          i.content.isEmpty || (i.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", gb(i.content))), "cut" == i.method && t.model.deleteContent(e.selection);
        }, {
          priority: "low"
        });
      }
    }
    class Lb {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
        this._batch = null, this.model = t, this._size = 0, this.limit = e, this._isLocked = !1, this._changeCallback = (t, e) => {
          e.isLocal && e.isUndoable && e !== this._batch && this._reset(!0);
        }, this._selectionChangeCallback = () => {
          this._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }
      get batch() {
        return this._batch || (this._batch = this.model.createBatch({
          isTyping: !0
        })), this._batch;
      }
      get size() {
        return this._size;
      }
      input(t) {
        this._size += t, this._size >= this.limit && this._reset(!0);
      }
      get isLocked() {
        return this._isLocked;
      }
      lock() {
        this._isLocked = !0;
      }
      unlock() {
        this._isLocked = !1;
      }
      destroy() {
        this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
      }
      _reset() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this.isLocked && !t || (this._batch = null, this._size = 0);
      }
    }
    class Nb extends Pr {
      constructor(t, e) {
        super(t), this._buffer = new Lb(t.model, e), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      destroy() {
        super.destroy(), this._buffer.destroy();
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document,
          i = t.text || "",
          o = i.length;
        let r = n.selection;
        if (t.selection ? r = t.selection : t.range && (r = e.createSelection(t.range)), !e.canEditAt(r)) return;
        const s = t.resultRange;
        e.enqueueChange(this._buffer.batch, t => {
          this._buffer.lock();
          const a = Array.from(n.selection.getAttributes());
          e.deleteContent(r), i && e.insertContent(t.createText(i, a), r), s ? t.setSelection(s) : r.is("documentSelection") || t.setSelection(r), this._buffer.unlock(), this._buffer.input(o);
        });
      }
    }
    const zb = ["insertText", "insertReplacementText"];
    class Pb extends tl {
      constructor(t) {
        super(t), this.focusObserver = t.getObserver(Hl), s.isAndroid && zb.push("insertCompositionText");
        const e = t.document;
        e.on("beforeinput", (n, i) => {
          if (!this.isEnabled) return;
          const {
            data: o,
            targetRanges: r,
            inputType: s,
            domEvent: a
          } = i;
          if (!zb.includes(s)) return;
          this.focusObserver.flush();
          const l = new m(e, "insertText");
          e.fire(l, new nl(t, a, {
            text: o,
            selection: t.createSelection(r)
          })), l.stop.called && n.stop();
        }), e.on("compositionend", (n, _ref74) => {
          let {
            data: i,
            domEvent: o
          } = _ref74;
          this.isEnabled && !s.isAndroid && i && e.fire("insertText", new nl(t, o, {
            text: i,
            selection: e.selection
          }));
        }, {
          priority: "lowest"
        });
      }
      observe() {}
      stopObserving() {}
    }
    class Vb extends Nr {
      static get pluginName() {
        return "Input";
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = e.document.selection;
        n.addObserver(Pb);
        const o = new Nb(t, t.config.get("typing.undoStep") || 20);
        t.commands.add("insertText", o), t.commands.add("input", o), this.listenTo(n.document, "insertText", (i, o) => {
          n.document.isComposing || o.preventDefault();
          const {
              text: r,
              selection: a,
              resultRange: l
            } = o,
            c = Array.from(a.getRanges()).map(e => t.editing.mapper.toModelRange(e));
          let d = r;
          if (s.isAndroid) {
            const t = Array.from(c[0].getItems()).reduce((t, e) => t + (e.is("$textProxy") ? e.data : ""), "");
            t && (t.length <= d.length ? d.startsWith(t) && (d = d.substring(t.length), c[0].start = c[0].start.getShiftedBy(t.length)) : t.startsWith(d) && (c[0].start = c[0].start.getShiftedBy(d.length), d = ""));
          }
          const u = {
            text: d,
            selection: e.createSelection(c)
          };
          l && (u.resultRange = t.editing.mapper.toModelRange(l)), t.execute("insertText", u), n.scrollToTheSelection();
        }), s.isAndroid ? this.listenTo(n.document, "keydown", (t, r) => {
          !i.isCollapsed && 229 == r.keyCode && n.document.isComposing && Rb(e, o);
        }) : this.listenTo(n.document, "compositionstart", () => {
          i.isCollapsed || Rb(e, o);
        });
      }
    }
    function Rb(t, e) {
      if (!e.isEnabled) return;
      const n = e.buffer;
      n.lock(), t.enqueueChange(n.batch, () => {
        t.deleteContent(t.document.selection);
      }), n.unlock();
    }
    class Fb extends Pr {
      constructor(t, e) {
        super(t), this.direction = e, this._buffer = new Lb(t.model, t.config.get("typing.undoStep")), this._isEnabledBasedOnSelection = !1;
      }
      get buffer() {
        return this._buffer;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document;
        e.enqueueChange(this._buffer.batch, i => {
          this._buffer.lock();
          const o = i.createSelection(t.selection || n.selection);
          if (!e.canEditAt(o)) return;
          const r = t.sequence || 1,
            s = o.isCollapsed;
          if (o.isCollapsed && e.modifySelection(o, {
            direction: this.direction,
            unit: t.unit,
            treatEmojiAsSingleUnit: !0
          }), this._shouldEntireContentBeReplacedWithParagraph(r)) return void this._replaceEntireContentWithParagraph(i);
          if (this._shouldReplaceFirstBlockWithParagraph(o, r)) return void this.editor.execute("paragraph", {
            selection: o
          });
          if (o.isCollapsed) return;
          let a = 0;
          o.getFirstRange().getMinimalFlatRanges().forEach(t => {
            a += Z(t.getWalker({
              singleCharacters: !0,
              ignoreElementEnd: !0,
              shallow: !0
            }));
          }), e.deleteContent(o, {
            doNotResetEntireContent: s,
            direction: this.direction
          }), this._buffer.input(a), i.setSelection(o), this._buffer.unlock();
        });
      }
      _shouldEntireContentBeReplacedWithParagraph(t) {
        if (t > 1) return !1;
        const e = this.editor.model,
          n = e.document.selection,
          i = e.schema.getLimitElement(n);
        if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
        if (!e.schema.checkChild(i, "paragraph")) return !1;
        const o = i.getChild(0);
        return !o || !o.is("element", "paragraph");
      }
      _replaceEntireContentWithParagraph(t) {
        const e = this.editor.model,
          n = e.document.selection,
          i = e.schema.getLimitElement(n),
          o = t.createElement("paragraph");
        t.remove(t.createRangeIn(i)), t.insert(o, i), t.setSelection(o, 0);
      }
      _shouldReplaceFirstBlockWithParagraph(t, e) {
        const n = this.editor.model;
        if (e > 1 || "backward" != this.direction) return !1;
        if (!t.isCollapsed) return !1;
        const i = t.getFirstPosition(),
          o = n.schema.getLimitElement(i),
          r = o.getChild(0);
        return i.parent == r && !!t.containsEntireContent(r) && !!n.schema.checkChild(o, "paragraph") && "paragraph" != r.name;
      }
    }
    const Ob = "word",
      jb = "selection",
      Hb = "backward",
      Ub = "forward",
      qb = {
        deleteContent: {
          unit: jb,
          direction: Hb
        },
        deleteContentBackward: {
          unit: "codePoint",
          direction: Hb
        },
        deleteWordBackward: {
          unit: Ob,
          direction: Hb
        },
        deleteHardLineBackward: {
          unit: jb,
          direction: Hb
        },
        deleteSoftLineBackward: {
          unit: jb,
          direction: Hb
        },
        deleteContentForward: {
          unit: "character",
          direction: Ub
        },
        deleteWordForward: {
          unit: Ob,
          direction: Ub
        },
        deleteHardLineForward: {
          unit: jb,
          direction: Ub
        },
        deleteSoftLineForward: {
          unit: jb,
          direction: Ub
        }
      };
    class Gb extends tl {
      constructor(t) {
        super(t);
        const e = t.document;
        let n = 0;
        e.on("keydown", () => {
          n++;
        }), e.on("keyup", () => {
          n = 0;
        }), e.on("beforeinput", (i, o) => {
          if (!this.isEnabled) return;
          const {
              targetRanges: r,
              domEvent: a,
              inputType: l
            } = o,
            c = qb[l];
          if (!c) return;
          const d = {
            direction: c.direction,
            unit: c.unit,
            sequence: n
          };
          d.unit == jb && (d.selectionToRemove = t.createSelection(r[0])), "deleteContentBackward" === l && (s.isAndroid && (d.sequence = 1), function (t) {
            if (1 != t.length || t[0].isCollapsed) return !1;
            const e = t[0].getWalker({
              direction: "backward",
              singleCharacters: !0,
              ignoreElementEnd: !0
            });
            let n = 0;
            for (const {
              nextPosition: t,
              item: i
            } of e) {
              if (t.parent.is("$text")) {
                const e = t.parent.data,
                  i = t.offset;
                if (Jo(e, i) || Xo(e, i) || er(e, i)) continue;
                n++;
              } else (i.is("containerElement") || i.is("emptyElement")) && n++;
              if (n > 1) return !0;
            }
            return !1;
          }(r) && (d.unit = jb, d.selectionToRemove = t.createSelection(r)));
          const u = new Zs(e, "delete", r[0]);
          e.fire(u, new nl(t, a, d)), u.stop.called && i.stop();
        }), s.isBlink && function (t) {
          const e = t.view,
            n = e.document;
          let i = null,
            o = !1;
          function r(t) {
            return t == po.backspace || t == po.delete;
          }
          function s(t) {
            return t == po.backspace ? Hb : Ub;
          }
          n.on("keydown", (t, _ref75) => {
            let {
              keyCode: e
            } = _ref75;
            i = e, o = !1;
          }), n.on("keyup", (a, _ref76) => {
            let {
              keyCode: l,
              domEvent: c
            } = _ref76;
            const d = n.selection,
              u = t.isEnabled && l == i && r(l) && !d.isCollapsed && !o;
            if (i = null, u) {
              const t = d.getFirstRange(),
                i = new Zs(n, "delete", t),
                o = {
                  unit: jb,
                  direction: s(l),
                  selectionToRemove: d
                };
              n.fire(i, new nl(e, c, o));
            }
          }), n.on("beforeinput", (t, _ref77) => {
            let {
              inputType: e
            } = _ref77;
            const n = qb[e];
            r(i) && n && n.direction == s(i) && (o = !0);
          }, {
            priority: "high"
          }), n.on("beforeinput", (t, _ref78) => {
            let {
              inputType: e,
              data: n
            } = _ref78;
            i == po.delete && "insertText" == e && "" == n && t.stop();
          }, {
            priority: "high"
          });
        }(this);
      }
      observe() {}
      stopObserving() {}
    }
    class Wb extends Nr {
      static get pluginName() {
        return "Delete";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          i = t.model.document;
        e.addObserver(Gb), this._undoOnBackspace = !1;
        const o = new Fb(t, "forward");
        t.commands.add("deleteForward", o), t.commands.add("forwardDelete", o), t.commands.add("delete", new Fb(t, "backward")), this.listenTo(n, "delete", (i, o) => {
          n.isComposing || o.preventDefault();
          const {
              direction: r,
              sequence: s,
              selectionToRemove: a,
              unit: l
            } = o,
            c = "forward" === r ? "deleteForward" : "delete",
            d = {
              sequence: s
            };
          if ("selection" == l) {
            const e = Array.from(a.getRanges()).map(e => t.editing.mapper.toModelRange(e));
            d.selection = t.model.createSelection(e);
          } else d.unit = l;
          t.execute(c, d), e.scrollToTheSelection();
        }, {
          priority: "low"
        }), this.editor.plugins.has("UndoEditing") && (this.listenTo(n, "delete", (e, n) => {
          this._undoOnBackspace && "backward" == n.direction && 1 == n.sequence && "codePoint" == n.unit && (this._undoOnBackspace = !1, t.execute("undo"), n.preventDefault(), e.stop());
        }, {
          context: "$capture"
        }), this.listenTo(i, "change", () => {
          this._undoOnBackspace = !1;
        }));
      }
      requestUndoOnBackspace() {
        this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
      }
    }
    class $b extends Nr {
      static get requires() {
        return [Vb, Wb];
      }
      static get pluginName() {
        return "Typing";
      }
    }
    function Kb(t, e) {
      let n = t.start;
      return {
        text: Array.from(t.getWalker({
          ignoreElementEnd: !1
        })).reduce((t, _ref79) => {
          let {
            item: i
          } = _ref79;
          return i.is("$text") || i.is("$textProxy") ? t + i.data : (n = e.createPositionAfter(i), "");
        }, ""),
        range: e.createRange(n, t.end)
      };
    }
    class Yb extends q() {
      constructor(t, e) {
        super(), this.model = t, this.testCallback = e, this._hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", () => {
          this.isEnabled ? this._startListening() : (this.stopListening(t.document.selection), this.stopListening(t.document));
        }), this._startListening();
      }
      get hasMatch() {
        return this._hasMatch;
      }
      _startListening() {
        const t = this.model.document;
        this.listenTo(t.selection, "change:range", (e, _ref80) => {
          let {
            directChange: n
          } = _ref80;
          n && (t.selection.isCollapsed ? this._evaluateTextBeforeSelection("selection") : this.hasMatch && (this.fire("unmatched"), this._hasMatch = !1));
        }), this.listenTo(t, "change:data", (t, e) => {
          !e.isUndo && e.isLocal && this._evaluateTextBeforeSelection("data", {
            batch: e
          });
        });
      }
      _evaluateTextBeforeSelection(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.model,
          i = n.document.selection,
          o = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus),
          {
            text: r,
            range: s
          } = Kb(o, n),
          a = this.testCallback(r);
        if (!a && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!a, a) {
          const n = Object.assign(e, {
            text: r,
            range: s
          });
          "object" == typeof a && Object.assign(n, a), this.fire(`matched:${t}`, n);
        }
      }
    }
    class Qb extends Nr {
      static get pluginName() {
        return "TwoStepCaretMovement";
      }
      constructor(t) {
        super(t), this._isNextGravityRestorationSkipped = !1, this.attributes = new Set(), this._overrideUid = null;
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = t.locale,
          o = e.document.selection;
        this.listenTo(n.document, "arrowKey", (t, e) => {
          if (!o.isCollapsed) return;
          if (e.shiftKey || e.altKey || e.ctrlKey) return;
          const n = e.keyCode == po.arrowright,
            r = e.keyCode == po.arrowleft;
          if (!n && !r) return;
          const s = i.contentLanguageDirection;
          let a = !1;
          a = "ltr" === s && n || "rtl" === s && r ? this._handleForwardMovement(e) : this._handleBackwardMovement(e), !0 === a && t.stop();
        }, {
          context: "$text",
          priority: "highest"
        }), this.listenTo(o, "change:range", (t, e) => {
          this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = !1 : this._isGravityOverridden && (!e.directChange && nw(o.getFirstPosition(), this.attributes) || this._restoreGravity());
        }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
      }
      registerAttribute(t) {
        this.attributes.add(t);
      }
      _handleForwardMovement(t) {
        const e = this.attributes,
          n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition();
        return !this._isGravityOverridden && (!o.isAtStart || !Zb(i, e)) && !!nw(o, e) && (tw(t), Zb(i, e) && nw(o, e, !0) ? Xb(n, e) : this._overrideGravity(), !0);
      }
      _handleBackwardMovement(t) {
        const e = this.attributes,
          n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition();
        return this._isGravityOverridden ? (tw(t), this._restoreGravity(), nw(o, e, !0) ? Xb(n, e) : Jb(n, e, o), !0) : o.isAtStart ? !!Zb(i, e) && (tw(t), Jb(n, e, o), !0) : !Zb(i, e) && nw(o, e, !0) ? (tw(t), Jb(n, e, o), !0) : !!ew(o, e) && (o.isAtEnd && !Zb(i, e) && nw(o, e) ? (tw(t), Jb(n, e, o), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1));
      }
      _enableClickingAfterNode() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          i = t.editing.view.document;
        t.editing.view.addObserver(Xu);
        let o = !1;
        this.listenTo(i, "mousedown", () => {
          o = !0;
        }), this.listenTo(i, "selectionChange", () => {
          const t = this.attributes;
          if (!o) return;
          if (o = !1, !n.isCollapsed) return;
          if (!Zb(n, t)) return;
          const i = n.getFirstPosition();
          nw(i, t) && (i.isAtStart || nw(i, t, !0) ? Xb(e, t) : this._isGravityOverridden || this._overrideGravity());
        });
      }
      _enableInsertContentSelectionAttributesFixer() {
        const t = this.editor.model,
          e = t.document.selection,
          n = this.attributes;
        this.listenTo(t, "insertContent", () => {
          const i = e.getFirstPosition();
          Zb(e, n) && nw(i, n) && Xb(t, n);
        }, {
          priority: "low"
        });
      }
      _handleDeleteContentAfterNode() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          i = t.editing.view;
        let o = !1,
          r = !1;
        this.listenTo(i.document, "delete", (t, e) => {
          o = "backward" === e.direction;
        }, {
          priority: "high"
        }), this.listenTo(e, "deleteContent", () => {
          if (!o) return;
          const t = n.getFirstPosition();
          r = Zb(n, this.attributes) && !ew(t, this.attributes);
        }, {
          priority: "high"
        }), this.listenTo(e, "deleteContent", () => {
          o && (o = !1, r || t.model.enqueueChange(() => {
            const t = n.getFirstPosition();
            Zb(n, this.attributes) && nw(t, this.attributes) && (t.isAtStart || nw(t, this.attributes, !0) ? Xb(e, this.attributes) : this._isGravityOverridden || this._overrideGravity());
          }));
        }, {
          priority: "low"
        });
      }
      get _isGravityOverridden() {
        return !!this._overrideUid;
      }
      _overrideGravity() {
        this._overrideUid = this.editor.model.change(t => t.overrideSelectionGravity());
      }
      _restoreGravity() {
        this.editor.model.change(t => {
          t.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
        });
      }
    }
    function Zb(t, e) {
      for (const n of e) if (t.hasAttribute(n)) return !0;
      return !1;
    }
    function Jb(t, e, n) {
      const i = n.nodeBefore;
      t.change(n => {
        if (i) {
          const e = [],
            o = t.schema.isObject(i) && t.schema.isInline(i);
          for (const [n, r] of i.getAttributes()) !t.schema.checkAttribute("$text", n) || o && !1 === t.schema.getAttributeProperties(n).copyFromObject || e.push([n, r]);
          n.setSelectionAttribute(e);
        } else n.removeSelectionAttribute(e);
      });
    }
    function Xb(t, e) {
      t.change(t => {
        t.removeSelectionAttribute(e);
      });
    }
    function tw(t) {
      t.preventDefault();
    }
    function ew(t, e) {
      return nw(t.getShiftedBy(-1), e);
    }
    function nw(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      const {
        nodeBefore: i,
        nodeAfter: o
      } = t;
      for (const t of e) {
        const e = i ? i.getAttribute(t) : void 0,
          r = o ? o.getAttribute(t) : void 0;
        if ((!n || void 0 !== e && void 0 !== r) && r !== e) return !0;
      }
      return !1;
    }
    const iw = {
        copyright: {
          from: "(c)",
          to: "©"
        },
        registeredTrademark: {
          from: "(r)",
          to: "®"
        },
        trademark: {
          from: "(tm)",
          to: "™"
        },
        oneHalf: {
          from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
          to: [null, "½", null]
        },
        oneThird: {
          from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
          to: [null, "⅓", null]
        },
        twoThirds: {
          from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
          to: [null, "⅔", null]
        },
        oneForth: {
          from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
          to: [null, "¼", null]
        },
        threeQuarters: {
          from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
          to: [null, "¾", null]
        },
        lessThanOrEqual: {
          from: "<=",
          to: "≤"
        },
        greaterThanOrEqual: {
          from: ">=",
          to: "≥"
        },
        notEqual: {
          from: "!=",
          to: "≠"
        },
        arrowLeft: {
          from: "<-",
          to: "←"
        },
        arrowRight: {
          from: "->",
          to: "→"
        },
        horizontalEllipsis: {
          from: "...",
          to: "…"
        },
        enDash: {
          from: /(^| )(--)( )$/,
          to: [null, "–", null]
        },
        emDash: {
          from: /(^| )(---)( )$/,
          to: [null, "—", null]
        },
        quotesPrimary: {
          from: cw('"'),
          to: [null, "“", null, "”"]
        },
        quotesSecondary: {
          from: cw("'"),
          to: [null, "‘", null, "’"]
        },
        quotesPrimaryEnGb: {
          from: cw("'"),
          to: [null, "‘", null, "’"]
        },
        quotesSecondaryEnGb: {
          from: cw('"'),
          to: [null, "“", null, "”"]
        },
        quotesPrimaryPl: {
          from: cw('"'),
          to: [null, "„", null, "”"]
        },
        quotesSecondaryPl: {
          from: cw("'"),
          to: [null, "‚", null, "’"]
        }
      },
      ow = {
        symbols: ["copyright", "registeredTrademark", "trademark"],
        mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
        typography: ["horizontalEllipsis", "enDash", "emDash"],
        quotes: ["quotesPrimary", "quotesSecondary"]
      },
      rw = ["symbols", "mathematical", "typography", "quotes"];
    function sw(t) {
      return "string" == typeof t ? new RegExp(`(${Qf(t)})$`) : t;
    }
    function aw(t) {
      return "string" == typeof t ? () => [t] : t instanceof Array ? () => t : t;
    }
    function lw(t) {
      return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
    }
    function cw(t) {
      return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`);
    }
    function dw(t, e, n, i) {
      return i.createRange(uw(t, e, n, !0, i), uw(t, e, n, !1, i));
    }
    function uw(t, e, n, i, o) {
      let r = t.textNode || (i ? t.nodeBefore : t.nodeAfter),
        s = null;
      for (; r && r.getAttribute(e) == n;) s = r, r = i ? r.previousSibling : r.nextSibling;
      return s ? o.createPositionAt(s, i ? "before" : "after") : t;
    }
    function hw(t, e, n, i) {
      const o = t.editing.view,
        r = new Set();
      o.document.registerPostFixer(o => {
        const s = t.model.document.selection;
        let a = !1;
        if (s.hasAttribute(e)) {
          const l = dw(s.getFirstPosition(), e, s.getAttribute(e), t.model),
            c = t.editing.mapper.toViewRange(l);
          for (const t of c.getItems()) t.is("element", n) && !t.hasClass(i) && (o.addClass(i, t), r.add(t), a = !0);
        }
        return a;
      }), t.conversion.for("editingDowncast").add(t => {
        function e() {
          o.change(t => {
            for (const e of r.values()) t.removeClass(i, e), r.delete(e);
          });
        }
        t.on("insert", e, {
          priority: "highest"
        }), t.on("remove", e, {
          priority: "highest"
        }), t.on("attribute", e, {
          priority: "highest"
        }), t.on("selection", e, {
          priority: "highest"
        });
      });
    }
    function* mw(t, e) {
      for (const n of e) n && t.getAttributeProperties(n[0]).copyOnEnter && (yield n);
    }
    class gw extends Pr {
      execute() {
        this.editor.model.change(t => {
          this.enterBlock(t), this.fire("afterExecute", {
            writer: t
          });
        });
      }
      enterBlock(t) {
        const e = this.editor.model,
          n = e.document.selection,
          i = e.schema,
          o = n.isCollapsed,
          r = n.getFirstRange(),
          s = r.start.parent,
          a = r.end.parent;
        if (i.isLimit(s) || i.isLimit(a)) return o || s != a || e.deleteContent(n), !1;
        if (o) {
          const e = mw(t.model.schema, n.getAttributes());
          return pw(t, r.start), t.setSelectionAttribute(e), !0;
        }
        {
          const i = !(r.start.isAtStart && r.end.isAtEnd),
            o = s == a;
          if (e.deleteContent(n, {
            leaveUnmerged: i
          }), i) {
            if (o) return pw(t, n.focus), !0;
            t.setSelection(a, 0);
          }
        }
        return !1;
      }
    }
    function pw(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }
    const fw = {
      insertParagraph: {
        isSoft: !1
      },
      insertLineBreak: {
        isSoft: !0
      }
    };
    class kw extends tl {
      constructor(t) {
        super(t);
        const e = this.document;
        let n = !1;
        e.on("keydown", (t, e) => {
          n = e.shiftKey;
        }), e.on("beforeinput", (i, o) => {
          if (!this.isEnabled) return;
          let r = o.inputType;
          s.isSafari && n && "insertParagraph" == r && (r = "insertLineBreak");
          const a = o.domEvent,
            l = fw[r];
          if (!l) return;
          const c = new Zs(e, "enter", o.targetRanges[0]);
          e.fire(c, new nl(t, a, {
            isSoft: l.isSoft
          })), c.stop.called && i.stop();
        });
      }
      observe() {}
      stopObserving() {}
    }
    class bw extends Nr {
      static get pluginName() {
        return "Enter";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          i = this.editor.t;
        e.addObserver(kw), t.commands.add("enter", new gw(t)), this.listenTo(n, "enter", (i, o) => {
          n.isComposing || o.preventDefault(), o.isSoft || (t.execute("enter"), e.scrollToTheSelection());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: i("Insert a hard break (a new paragraph)"),
            keystroke: "Enter"
          }]
        });
      }
    }
    class ww extends Pr {
      execute() {
        const t = this.editor.model,
          e = t.document;
        t.change(n => {
          !function (t, e, n) {
            const i = n.isCollapsed,
              o = n.getFirstRange(),
              r = o.start.parent,
              s = o.end.parent,
              a = r == s;
            if (i) {
              const i = mw(t.schema, n.getAttributes());
              Aw(t, e, o.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(i);
            } else {
              const i = !(o.start.isAtStart && o.end.isAtEnd);
              t.deleteContent(n, {
                leaveUnmerged: i
              }), a ? Aw(t, e, n.focus) : i && e.setSelection(s, 0);
            }
          }(t, n, e.selection), this.fire("afterExecute", {
            writer: n
          });
        });
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.isEnabled = function (t, e) {
          if (e.rangeCount > 1) return !1;
          const n = e.anchor;
          if (!n || !t.checkChild(n, "softBreak")) return !1;
          const i = e.getFirstRange(),
            o = i.start.parent,
            r = i.end.parent;
          if ((Cw(o, t) || Cw(r, t)) && o !== r) return !1;
          return !0;
        }(t.schema, e.selection);
      }
    }
    function Aw(t, e, n) {
      const i = e.createElement("softBreak");
      t.insertContent(i, n), e.setSelection(i, "after");
    }
    function Cw(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || Cw(t.parent, e));
    }
    class _w extends Nr {
      static get pluginName() {
        return "ShiftEnter";
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.conversion,
          i = t.editing.view,
          o = i.document,
          r = this.editor.t;
        e.register("softBreak", {
          allowWhere: "$text",
          isInline: !0
        }), n.for("upcast").elementToElement({
          model: "softBreak",
          view: "br"
        }), n.for("downcast").elementToElement({
          model: "softBreak",
          view: (t, _ref81) => {
            let {
              writer: e
            } = _ref81;
            return e.createEmptyElement("br");
          }
        }), i.addObserver(kw), t.commands.add("shiftEnter", new ww(t)), this.listenTo(o, "enter", (e, n) => {
          o.isComposing || n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), i.scrollToTheSelection());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: r("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
            keystroke: "Shift+Enter"
          }]
        });
      }
    }
    class vw extends B() {
      constructor() {
        super(...arguments), this._stack = [];
      }
      add(t, e) {
        const n = this._stack,
          i = n[0];
        this._insertDescriptor(t);
        const o = n[0];
        i === o || yw(i, o) || this.fire("change:top", {
          oldDescriptor: i,
          newDescriptor: o,
          writer: e
        });
      }
      remove(t, e) {
        const n = this._stack,
          i = n[0];
        this._removeDescriptor(t);
        const o = n[0];
        i === o || yw(i, o) || this.fire("change:top", {
          oldDescriptor: i,
          newDescriptor: o,
          writer: e
        });
      }
      _insertDescriptor(t) {
        const e = this._stack,
          n = e.findIndex(e => e.id === t.id);
        if (yw(t, e[n])) return;
        n > -1 && e.splice(n, 1);
        let i = 0;
        for (; e[i] && xw(e[i], t);) i++;
        e.splice(i, 0, t);
      }
      _removeDescriptor(t) {
        const e = this._stack,
          n = e.findIndex(e => e.id === t);
        n > -1 && e.splice(n, 1);
      }
    }
    function yw(t, e) {
      return t && e && t.priority == e.priority && Ew(t.classes) == Ew(e.classes);
    }
    function xw(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && Ew(t.classes) > Ew(e.classes);
    }
    function Ew(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }
    const Dw = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
      Bw = "ck-widget_selected";
    function Sw(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }
    function Tw(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!t.is("containerElement")) throw new b("widget-to-widget-wrong-element-type", null, {
        element: t
      });
      return e.setAttribute("contenteditable", "false", t), e.addClass("ck-widget", t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = Pw, e.setCustomProperty("widgetLabel", [], t), n.label && function (t, e) {
        const n = t.getCustomProperty("widgetLabel");
        n.push(e);
      }(t, n.label), n.hasSelectionHandle && function (t, e) {
        const n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (t) {
          const e = this.toDomElement(t),
            n = new cm();
          return n.set("content", Dw), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handle"], t);
      }(t, e), Lw(t, e), t;
    }
    function Iw(t, e, n) {
      if (e.classes && n.addClass(vo(e.classes), t), e.attributes) for (const i in e.attributes) n.setAttribute(i, e.attributes[i], t);
    }
    function Mw(t, e, n) {
      if (e.classes && n.removeClass(vo(e.classes), t), e.attributes) for (const i in e.attributes) n.removeAttribute(i, t);
    }
    function Lw(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Iw;
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Mw;
      const o = new vw();
      o.on("change:top", (e, o) => {
        o.oldDescriptor && i(t, o.oldDescriptor, o.writer), o.newDescriptor && n(t, o.newDescriptor, o.writer);
      });
      e.setCustomProperty("addHighlight", (t, e, n) => o.add(e, n), t), e.setCustomProperty("removeHighlight", (t, e, n) => o.remove(e, n), t);
    }
    function Nw(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), e.setAttribute("role", "textbox", t), e.setAttribute("tabindex", "-1", t), n.label && e.setAttribute("aria-label", n.label, t), e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", (n, i, o) => {
        e.setAttribute("contenteditable", o ? "false" : "true", t);
      }), t.on("change:isFocused", (n, i, o) => {
        o ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), Lw(t, e), t;
    }
    function zw(t, e) {
      const n = t.getSelectedElement();
      if (n) {
        const i = Ow(t);
        if (i) return e.createRange(e.createPositionAt(n, i));
      }
      return e.schema.findOptimalInsertionRange(t);
    }
    function Pw() {
      return null;
    }
    function Vw(t) {
      const e = t => {
          const {
            width: e,
            paddingLeft: n,
            paddingRight: i
          } = t.ownerDocument.defaultView.getComputedStyle(t);
          return parseFloat(e) - (parseFloat(n) || 0) - (parseFloat(i) || 0);
        },
        n = t.parentElement;
      if (!n) return 0;
      let i = e(n);
      let o = 0,
        r = n;
      for (; isNaN(i);) {
        if (r = r.parentElement, ++o > 5) return 0;
        i = e(r);
      }
      return i;
    }
    const Rw = "widget-type-around";
    function Fw(t, e, n) {
      return !!t && Sw(t) && !n.isInline(e);
    }
    function Ow(t) {
      return t.getAttribute(Rw);
    }
    var jw = o(6779),
      Hw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(jw.A, Hw);
    jw.A.locals;
    const Uw = ["before", "after"],
      qw = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
      Gw = "ck-widget__type-around_disabled";
    class Ww extends Nr {
      constructor() {
        super(...arguments), this._currentFakeCaretModelElement = null;
      }
      static get pluginName() {
        return "WidgetTypeAround";
      }
      static get requires() {
        return [bw, Wb];
      }
      init() {
        const t = this.editor,
          e = t.editing.view;
        this.on("change:isEnabled", (n, i, o) => {
          e.change(t => {
            for (const n of e.document.roots) o ? t.removeClass(Gw, n) : t.addClass(Gw, n);
          }), o || t.model.change(t => {
            t.removeSelectionAttribute(Rw);
          });
        }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
      }
      destroy() {
        super.destroy(), this._currentFakeCaretModelElement = null;
      }
      _insertParagraph(t, e) {
        const n = this.editor,
          i = n.editing.view,
          o = n.model.schema.getAttributesWithProperty(t, "copyOnReplace", !0);
        n.execute("insertParagraph", {
          position: n.model.createPositionAt(t, e),
          attributes: o
        }), i.focus(), i.scrollToTheSelection();
      }
      _listenToIfEnabled(t, e, n, i) {
        var _this9 = this;
        this.listenTo(t, e, function () {
          _this9.isEnabled && n(...arguments);
        }, i);
      }
      _insertParagraphAccordingToFakeCaretPosition() {
        const t = this.editor.model.document.selection,
          e = Ow(t);
        if (!e) return !1;
        const n = t.getSelectedElement();
        return this._insertParagraph(n, e), !0;
      }
      _enableTypeAroundUIInjection() {
        const t = this.editor,
          e = t.model.schema,
          n = t.locale.t,
          i = {
            before: n("Insert paragraph before block"),
            after: n("Insert paragraph after block")
          };
        t.editing.downcastDispatcher.on("insert", (t, o, r) => {
          const s = r.mapper.toViewElement(o.item);
          if (s && Fw(s, o.item, e)) {
            !function (t, e, n) {
              const i = t.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__type-around"
              }, function (t) {
                const n = this.toDomElement(t);
                return function (t, e) {
                  for (const n of Uw) {
                    const i = new ir({
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-widget__type-around__button", `ck-widget__type-around__button_${n}`],
                        title: e[n],
                        "aria-hidden": "true"
                      },
                      children: [t.ownerDocument.importNode(qw, !0)]
                    });
                    t.appendChild(i.render());
                  }
                }(n, e), function (t) {
                  const e = new ir({
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-widget__type-around__fake-caret"]
                    }
                  });
                  t.appendChild(e.render());
                }(n), n;
              });
              t.insert(t.createPositionAt(n, "end"), i);
            }(r.writer, i, s);
            s.getCustomProperty("widgetLabel").push(() => this.isEnabled ? n("Press Enter to type after or press Shift + Enter to type before the widget") : "");
          }
        }, {
          priority: "low"
        });
      }
      _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          i = e.schema,
          o = t.editing.view;
        function r(t) {
          return `ck-widget_type-around_show-fake-caret_${t}`;
        }
        this._listenToIfEnabled(o.document, "arrowKey", (t, e) => {
          this._handleArrowKeyPress(t, e);
        }, {
          context: [Sw, "$text"],
          priority: "high"
        }), this._listenToIfEnabled(n, "change:range", (e, n) => {
          n.directChange && t.model.change(t => {
            t.removeSelectionAttribute(Rw);
          });
        }), this._listenToIfEnabled(e.document, "change:data", () => {
          const e = n.getSelectedElement();
          if (e) {
            if (Fw(t.editing.mapper.toViewElement(e), e, i)) return;
          }
          t.model.change(t => {
            t.removeSelectionAttribute(Rw);
          });
        }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", (t, e, n) => {
          const o = n.writer;
          if (this._currentFakeCaretModelElement) {
            const t = n.mapper.toViewElement(this._currentFakeCaretModelElement);
            t && (o.removeClass(Uw.map(r), t), this._currentFakeCaretModelElement = null);
          }
          const s = e.selection.getSelectedElement();
          if (!s) return;
          const a = n.mapper.toViewElement(s);
          if (!Fw(a, s, i)) return;
          const l = Ow(e.selection);
          l && (o.addClass(r(l), a), this._currentFakeCaretModelElement = s);
        }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", (e, n, i) => {
          i || t.model.change(t => {
            t.removeSelectionAttribute(Rw);
          });
        });
      }
      _handleArrowKeyPress(t, e) {
        const n = this.editor,
          i = n.model,
          o = i.document.selection,
          r = i.schema,
          s = n.editing.view,
          a = function (t, e) {
            const n = Ao(t, e);
            return "down" === n || "right" === n;
          }(e.keyCode, n.locale.contentLanguageDirection),
          l = s.document.selection.getSelectedElement();
        let c;
        Fw(l, n.editing.mapper.toModelElement(l), r) ? c = this._handleArrowKeyPressOnSelectedWidget(a) : o.isCollapsed ? c = this._handleArrowKeyPressWhenSelectionNextToAWidget(a) : e.shiftKey || (c = this._handleArrowKeyPressWhenNonCollapsedSelection(a)), c && (e.preventDefault(), t.stop());
      }
      _handleArrowKeyPressOnSelectedWidget(t) {
        const e = this.editor.model,
          n = Ow(e.document.selection);
        return e.change(e => {
          if (!n) return e.setSelectionAttribute(Rw, t ? "after" : "before"), !0;
          if (!(n === (t ? "after" : "before"))) return e.removeSelectionAttribute(Rw), !0;
          return !1;
        });
      }
      _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
        const e = this.editor,
          n = e.model,
          i = n.schema,
          o = e.plugins.get("Widget"),
          r = o._getObjectElementNextToSelection(t);
        return !!Fw(e.editing.mapper.toViewElement(r), r, i) && (n.change(e => {
          o._setSelectionOverElement(r), e.setSelectionAttribute(Rw, t ? "before" : "after");
        }), !0);
      }
      _handleArrowKeyPressWhenNonCollapsedSelection(t) {
        const e = this.editor,
          n = e.model,
          i = n.schema,
          o = e.editing.mapper,
          r = n.document.selection,
          s = t ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
        return !!Fw(o.toViewElement(s), s, i) && (n.change(e => {
          e.setSelection(s, "on"), e.setSelectionAttribute(Rw, t ? "after" : "before");
        }), !0);
      }
      _enableInsertingParagraphsOnButtonClick() {
        const t = this.editor,
          e = t.editing.view;
        this._listenToIfEnabled(e.document, "mousedown", (n, i) => {
          const o = i.domTarget.closest(".ck-widget__type-around__button");
          if (!o) return;
          const r = function (t) {
              return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }(o),
            s = function (t, e) {
              const n = t.closest(".ck-widget");
              return e.mapDomToView(n);
            }(o, e.domConverter),
            a = t.editing.mapper.toModelElement(s);
          this._insertParagraph(a, r), i.preventDefault(), n.stop();
        });
      }
      _enableInsertingParagraphsOnEnterKeypress() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.editing.view;
        this._listenToIfEnabled(n.document, "enter", (n, i) => {
          if ("atTarget" != n.eventPhase) return;
          const o = e.getSelectedElement(),
            r = t.editing.mapper.toViewElement(o),
            s = t.model.schema;
          let a;
          this._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : Fw(r, o, s) && (this._insertParagraph(o, i.isSoft ? "before" : "after"), a = !0), a && (i.preventDefault(), n.stop());
        }, {
          context: Sw
        });
      }
      _enableInsertingParagraphsOnTypingKeystroke() {
        const t = this.editor.editing.view.document;
        this._listenToIfEnabled(t, "insertText", (e, n) => {
          this._insertParagraphAccordingToFakeCaretPosition() && (n.selection = t.selection);
        }, {
          priority: "high"
        }), s.isAndroid ? this._listenToIfEnabled(t, "keydown", (t, e) => {
          229 == e.keyCode && this._insertParagraphAccordingToFakeCaretPosition();
        }) : this._listenToIfEnabled(t, "compositionstart", () => {
          this._insertParagraphAccordingToFakeCaretPosition();
        }, {
          priority: "high"
        });
      }
      _enableDeleteIntegration() {
        const t = this.editor,
          e = t.editing.view,
          n = t.model,
          i = n.schema;
        this._listenToIfEnabled(e.document, "delete", (e, o) => {
          if ("atTarget" != e.eventPhase) return;
          const r = Ow(n.document.selection);
          if (!r) return;
          const s = o.direction,
            a = n.document.selection.getSelectedElement(),
            l = "forward" == s;
          if ("before" === r === l) t.execute("delete", {
            selection: n.createSelection(a, "on")
          });else {
            const e = i.getNearestSelectionRange(n.createPositionAt(a, r), s);
            if (e) if (e.isCollapsed) {
              const o = n.createSelection(e.start);
              if (n.modifySelection(o, {
                direction: s
              }), o.focus.isEqual(e.start)) {
                const t = function (t, e) {
                  let n = e;
                  for (const i of e.getAncestors({
                    parentFirst: !0
                  })) {
                    if (i.childCount > 1 || t.isLimit(i)) break;
                    n = i;
                  }
                  return n;
                }(i, e.start.parent);
                n.deleteContent(n.createSelection(t, "on"), {
                  doNotAutoparagraph: !0
                });
              } else n.change(n => {
                n.setSelection(e), t.execute(l ? "deleteForward" : "delete");
              });
            } else n.change(n => {
              n.setSelection(e), t.execute(l ? "deleteForward" : "delete");
            });
          }
          o.preventDefault(), e.stop();
        }, {
          context: Sw
        });
      }
      _enableInsertContentIntegration() {
        const t = this.editor,
          e = this.editor.model,
          n = e.document.selection;
        this._listenToIfEnabled(t.model, "insertContent", (t, _ref82) => {
          let [i, o] = _ref82;
          if (o && !o.is("documentSelection")) return;
          const r = Ow(n);
          return r ? (t.stop(), e.change(t => {
            const o = n.getSelectedElement(),
              s = e.createPositionAt(o, r),
              a = t.createSelection(s),
              l = e.insertContent(i, a);
            return t.setSelection(a), l;
          })) : void 0;
        }, {
          priority: "high"
        });
      }
      _enableInsertObjectIntegration() {
        const t = this.editor,
          e = this.editor.model.document.selection;
        this._listenToIfEnabled(t.model, "insertObject", (t, n) => {
          const [, i, o = {}] = n;
          if (i && !i.is("documentSelection")) return;
          const r = Ow(e);
          r && (o.findOptimalPosition = r, n[3] = o);
        }, {
          priority: "high"
        });
      }
      _enableDeleteContentIntegration() {
        const t = this.editor,
          e = this.editor.model.document.selection;
        this._listenToIfEnabled(t.model, "deleteContent", (t, _ref83) => {
          let [n] = _ref83;
          if (n && !n.is("documentSelection")) return;
          Ow(e) && t.stop();
        }, {
          priority: "high"
        });
      }
    }
    function $w(t) {
      const e = t.model;
      return (n, i) => {
        const o = i.keyCode == po.arrowup,
          r = i.keyCode == po.arrowdown,
          s = i.shiftKey,
          a = e.document.selection;
        if (!o && !r) return;
        const l = r;
        if (s && function (t, e) {
          return !t.isCollapsed && t.isBackward == e;
        }(a, l)) return;
        const c = function (t, e, n) {
          const i = t.model;
          if (n) {
            const t = e.isCollapsed ? e.focus : e.getLastPosition(),
              n = Kw(i, t, "forward");
            if (!n) return null;
            const o = i.createRange(t, n),
              r = Yw(i.schema, o, "backward");
            return r ? i.createRange(t, r) : null;
          }
          {
            const t = e.isCollapsed ? e.focus : e.getFirstPosition(),
              n = Kw(i, t, "backward");
            if (!n) return null;
            const o = i.createRange(n, t),
              r = Yw(i.schema, o, "forward");
            return r ? i.createRange(r, t) : null;
          }
        }(t, a, l);
        if (c) {
          if (c.isCollapsed) {
            if (a.isCollapsed) return;
            if (s) return;
          }
          (c.isCollapsed || function (t, e, n) {
            const i = t.model,
              o = t.view.domConverter;
            if (n) {
              const t = i.createSelection(e.start);
              i.modifySelection(t), t.focus.isAtEnd || e.start.isEqual(t.focus) || (e = i.createRange(t.focus, e.end));
            }
            const r = t.mapper.toViewRange(e),
              s = o.viewRangeToDom(r),
              a = Pi.getDomRangeRects(s);
            let l;
            for (const t of a) if (void 0 !== l) {
              if (Math.round(t.top) >= l) return !1;
              l = Math.max(l, Math.round(t.bottom));
            } else l = Math.round(t.bottom);
            return !0;
          }(t, c, l)) && (e.change(t => {
            const n = l ? c.end : c.start;
            if (s) {
              const i = e.createSelection(a.anchor);
              i.setFocus(n), t.setSelection(i);
            } else t.setSelection(n);
          }), n.stop(), i.preventDefault(), i.stopPropagation());
        }
      };
    }
    function Kw(t, e, n) {
      const i = t.schema,
        o = t.createRangeIn(e.root),
        r = "forward" == n ? "elementStart" : "elementEnd";
      for (const {
        previousPosition: t,
        item: s,
        type: a
      } of o.getWalker({
        startPosition: e,
        direction: n
      })) {
        if (i.isLimit(s) && !i.isInline(s)) return t;
        if (a == r && i.isBlock(s)) return null;
      }
      return null;
    }
    function Yw(t, e, n) {
      const i = "backward" == n ? e.end : e.start;
      if (t.checkChild(i, "$text")) return i;
      for (const {
        nextPosition: i
      } of e.getWalker({
        direction: n
      })) if (t.checkChild(i, "$text")) return i;
      return null;
    }
    var Qw = o(1216),
      Zw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Qw.A, Zw);
    Qw.A.locals;
    class Jw extends Nr {
      constructor() {
        super(...arguments), this._previouslySelected = new Set();
      }
      static get pluginName() {
        return "Widget";
      }
      static get requires() {
        return [Ww, Wb];
      }
      init() {
        var _this10 = this;
        const t = this.editor,
          e = t.editing.view,
          n = e.document,
          i = t.t;
        this.editor.editing.downcastDispatcher.on("selection", (e, n, i) => {
          const o = i.writer,
            r = n.selection;
          if (r.isCollapsed) return;
          const s = r.getSelectedElement();
          if (!s) return;
          const a = t.editing.mapper.toViewElement(s);
          var l;
          Sw(a) && i.consumable.consume(r, "selection") && o.setSelection(o.createRangeOn(a), {
            fake: !0,
            label: (l = a, l.getCustomProperty("widgetLabel").reduce((t, e) => "function" == typeof e ? t ? t + ". " + e() : e() : t ? t + ". " + e : e, ""))
          });
        }), this.editor.editing.downcastDispatcher.on("selection", (t, e, n) => {
          this._clearPreviouslySelectedWidgets(n.writer);
          const i = n.writer,
            o = i.document.selection;
          let r = null;
          for (const t of o.getRanges()) for (const e of t) {
            const t = e.item;
            Sw(t) && !Xw(t, r) && (i.addClass(Bw, t), this._previouslySelected.add(t), r = t);
          }
        }, {
          priority: "low"
        }), e.addObserver(Xu), this.listenTo(n, "mousedown", function () {
          return _this10._onMousedown(...arguments);
        }), this.listenTo(n, "arrowKey", function () {
          _this10._handleSelectionChangeOnArrowKeyPress(...arguments);
        }, {
          context: [Sw, "$text"]
        }), this.listenTo(n, "arrowKey", function () {
          _this10._preventDefaultOnArrowKeyPress(...arguments);
        }, {
          context: "$root"
        }), this.listenTo(n, "arrowKey", $w(this.editor.editing), {
          context: "$text"
        }), this.listenTo(n, "delete", (t, e) => {
          this._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
        }, {
          context: "$root"
        }), this.listenTo(n, "tab", (t, e) => {
          "atTarget" == t.eventPhase && (e.shiftKey || this._selectFirstNestedEditable() && (e.preventDefault(), t.stop()));
        }, {
          context: Sw,
          priority: "low"
        }), this.listenTo(n, "tab", (t, e) => {
          e.shiftKey && this._selectAncestorWidget() && (e.preventDefault(), t.stop());
        }, {
          priority: "low"
        }), this.listenTo(n, "keydown", (t, e) => {
          e.keystroke == po.esc && this._selectAncestorWidget() && (e.preventDefault(), t.stop());
        }, {
          priority: "low"
        }), t.accessibility.addKeystrokeInfoGroup({
          id: "widget",
          label: i("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
          keystrokes: [{
            label: i("Insert a new paragraph directly after a widget"),
            keystroke: "Enter"
          }, {
            label: i("Insert a new paragraph directly before a widget"),
            keystroke: "Shift+Enter"
          }, {
            label: i("Move the caret to allow typing directly before a widget"),
            keystroke: [["arrowup"], ["arrowleft"]]
          }, {
            label: i("Move the caret to allow typing directly after a widget"),
            keystroke: [["arrowdown"], ["arrowright"]]
          }]
        });
      }
      _onMousedown(t, e) {
        const n = this.editor,
          i = n.editing.view,
          o = i.document;
        let r = e.target;
        if (e.domEvent.detail >= 3) return void (this._selectBlockContent(r) && e.preventDefault());
        if (function (t) {
          let e = t;
          for (; e;) {
            if (e.is("editableElement") && !e.is("rootElement")) return !0;
            if (Sw(e)) return !1;
            e = e.parent;
          }
          return !1;
        }(r)) return;
        if (!Sw(r) && (r = r.findAncestor(Sw), !r)) return;
        s.isAndroid && e.preventDefault(), o.isFocused || i.focus();
        const a = n.editing.mapper.toModelElement(r);
        this._setSelectionOverElement(a);
      }
      _selectBlockContent(t) {
        const e = this.editor,
          n = e.model,
          i = e.editing.mapper,
          o = n.schema,
          r = i.findMappedViewAncestor(this.editor.editing.view.createPositionAt(t, 0)),
          s = function (t, e) {
            for (const n of t.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            })) {
              if (e.checkChild(n, "$text")) return n;
              if (e.isLimit(n) && !e.isObject(n)) break;
            }
            return null;
          }(i.toModelElement(r), n.schema);
        return !!s && (n.change(t => {
          const e = o.isLimit(s) ? null : function (t, e) {
              const n = new oc({
                startPosition: t
              });
              for (const {
                item: t
              } of n) {
                if (e.isLimit(t) || !t.is("element")) return null;
                if (e.checkChild(t, "$text")) return t;
              }
              return null;
            }(t.createPositionAfter(s), o),
            n = t.createPositionAt(s, 0),
            i = e ? t.createPositionAt(e, 0) : t.createPositionAt(s, "end");
          t.setSelection(t.createRange(n, i));
        }), !0);
      }
      _handleSelectionChangeOnArrowKeyPress(t, e) {
        const n = e.keyCode,
          i = this.editor.model,
          o = i.schema,
          r = i.document.selection,
          s = r.getSelectedElement(),
          a = Ao(n, this.editor.locale.contentLanguageDirection),
          l = "down" == a || "right" == a,
          c = "up" == a || "down" == a;
        if (s && o.isObject(s)) {
          const n = l ? r.getLastPosition() : r.getFirstPosition(),
            s = o.getNearestSelectionRange(n, l ? "forward" : "backward");
          return void (s && (i.change(t => {
            t.setSelection(s);
          }), e.preventDefault(), t.stop()));
        }
        if (!r.isCollapsed && !e.shiftKey) {
          const n = r.getFirstPosition(),
            s = r.getLastPosition(),
            a = n.nodeAfter,
            c = s.nodeBefore;
          return void ((a && o.isObject(a) || c && o.isObject(c)) && (i.change(t => {
            t.setSelection(l ? s : n);
          }), e.preventDefault(), t.stop()));
        }
        if (!r.isCollapsed) return;
        const d = this._getObjectElementNextToSelection(l);
        if (d && o.isObject(d)) {
          if (o.isInline(d) && c) return;
          this._setSelectionOverElement(d), e.preventDefault(), t.stop();
        }
      }
      _preventDefaultOnArrowKeyPress(t, e) {
        const n = this.editor.model,
          i = n.schema,
          o = n.document.selection.getSelectedElement();
        o && i.isObject(o) && (e.preventDefault(), t.stop());
      }
      _handleDelete(t) {
        const e = this.editor.model.document.selection;
        if (!this.editor.model.canEditAt(e)) return;
        if (!e.isCollapsed) return;
        const n = this._getObjectElementNextToSelection(t);
        return n ? (this.editor.model.change(t => {
          let i = e.anchor.parent;
          for (; i.isEmpty;) {
            const e = i;
            i = e.parent, t.remove(e);
          }
          this._setSelectionOverElement(n);
        }), !0) : void 0;
      }
      _setSelectionOverElement(t) {
        this.editor.model.change(e => {
          e.setSelection(e.createRangeOn(t));
        });
      }
      _getObjectElementNextToSelection(t) {
        const e = this.editor.model,
          n = e.schema,
          i = e.document.selection,
          o = e.createSelection(i);
        if (e.modifySelection(o, {
          direction: t ? "forward" : "backward"
        }), o.isEqual(i)) return null;
        const r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
        return r && n.isObject(r) ? r : null;
      }
      _clearPreviouslySelectedWidgets(t) {
        for (const e of this._previouslySelected) t.removeClass(Bw, e);
        this._previouslySelected.clear();
      }
      _selectFirstNestedEditable() {
        const t = this.editor,
          e = this.editor.editing.view.document;
        for (const n of e.selection.getFirstRange().getItems()) if (n.is("editableElement")) {
          const e = t.editing.mapper.toModelElement(n);
          if (!e) continue;
          const i = t.model.createPositionAt(e, 0),
            o = t.model.schema.getNearestSelectionRange(i, "forward");
          return t.model.change(t => {
            t.setSelection(o);
          }), !0;
        }
        return !1;
      }
      _selectAncestorWidget() {
        const t = this.editor,
          e = t.editing.mapper,
          n = t.editing.view.document.selection.getFirstPosition().parent,
          i = (n.is("$text") ? n.parent : n).findAncestor(Sw);
        if (!i) return !1;
        const o = e.toModelElement(i);
        return !!o && (t.model.change(t => {
          t.setSelection(o, "on");
        }), !0);
      }
    }
    function Xw(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }
    class tA extends Nr {
      constructor() {
        super(...arguments), this._toolbarDefinitions = new Map();
      }
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "WidgetToolbarRepository";
      }
      init() {
        const t = this.editor;
        if (t.plugins.has("BalloonToolbar")) {
          const e = t.plugins.get("BalloonToolbar");
          this.listenTo(e, "show", e => {
            (function (t) {
              const e = t.getSelectedElement();
              return !(!e || !Sw(e));
            })(t.editing.view.document.selection) && e.stop();
          }, {
            priority: "high"
          });
        }
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(t.ui, "update", () => {
          this._updateToolbarsVisibility();
        }), this.listenTo(t.ui.focusTracker, "change:isFocused", () => {
          this._updateToolbarsVisibility();
        }, {
          priority: "low"
        });
      }
      destroy() {
        super.destroy();
        for (const t of this._toolbarDefinitions.values()) t.view.destroy();
      }
      register(t, _ref84) {
        let {
          ariaLabel: e,
          items: n,
          getRelatedElement: i,
          balloonClassName: o = "ck-toolbar-container"
        } = _ref84;
        if (!n.length) return void w("widget-toolbar-no-items", {
          toolbarId: t
        });
        const r = this.editor,
          s = r.t,
          a = new cg(r.locale);
        if (a.ariaLabel = e || s("Widget toolbar"), this._toolbarDefinitions.has(t)) throw new b("widget-toolbar-duplicated", this, {
          toolbarId: t
        });
        const l = {
          view: a,
          getRelatedElement: i,
          balloonClassName: o,
          itemsConfig: n,
          initialized: !1
        };
        r.ui.addToolbar(a, {
          isContextual: !0,
          beforeFocus: () => {
            const t = i(r.editing.view.document.selection);
            t && this._showToolbar(l, t);
          },
          afterBlur: () => {
            this._hideToolbar(l);
          }
        }), this._toolbarDefinitions.set(t, l);
      }
      _updateToolbarsVisibility() {
        let t = 0,
          e = null,
          n = null;
        for (const i of this._toolbarDefinitions.values()) {
          const o = i.getRelatedElement(this.editor.editing.view.document.selection);
          if (this.isEnabled && o) {
            if (this.editor.ui.focusTracker.isFocused) {
              const r = o.getAncestors().length;
              r > t && (t = r, e = o, n = i);
            } else this._isToolbarVisible(i) && this._hideToolbar(i);
          } else this._isToolbarInBalloon(i) && this._hideToolbar(i);
        }
        n && this._showToolbar(n, e);
      }
      _hideToolbar(t) {
        this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
      }
      _showToolbar(t, e) {
        this._isToolbarVisible(t) ? eA(this.editor, e) : this._isToolbarInBalloon(t) || (t.initialized || (t.initialized = !0, t.view.fillFromConfig(t.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({
          view: t.view,
          position: nA(this.editor, e),
          balloonClassName: t.balloonClassName
        }), this.listenTo(this._balloon, "change:visibleView", () => {
          for (const t of this._toolbarDefinitions.values()) if (this._isToolbarVisible(t)) {
            const e = t.getRelatedElement(this.editor.editing.view.document.selection);
            eA(this.editor, e);
          }
        }));
      }
      _isToolbarVisible(t) {
        return this._balloon.visibleView === t.view;
      }
      _isToolbarInBalloon(t) {
        return this._balloon.hasView(t.view);
      }
    }
    function eA(t, e) {
      const n = t.plugins.get("ContextualBalloon"),
        i = nA(t, e);
      n.updatePosition(i);
    }
    function nA(t, e) {
      const n = t.editing.view,
        i = ef.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast, i.viewportStickyNorth]
      };
    }
    class iA extends q() {
      constructor(t) {
        super(), this.set("activeHandlePosition", null), this.set("proposedWidthPercents", null), this.set("proposedWidth", null), this.set("proposedHeight", null), this.set("proposedHandleHostWidth", null), this.set("proposedHandleHostHeight", null), this._options = t, this._referenceCoordinates = null;
      }
      get originalWidth() {
        return this._originalWidth;
      }
      get originalHeight() {
        return this._originalHeight;
      }
      get originalWidthPercents() {
        return this._originalWidthPercents;
      }
      get aspectRatio() {
        return this._aspectRatio;
      }
      begin(t, e, n) {
        const i = new Pi(e);
        this.activeHandlePosition = function (t) {
          const e = ["top-left", "top-right", "bottom-right", "bottom-left"];
          for (const n of e) if (t.classList.contains(oA(n))) return n;
        }(t), this._referenceCoordinates = function (t, e) {
          const n = new Pi(t),
            i = e.split("-"),
            o = {
              x: "right" == i[1] ? n.right : n.left,
              y: "bottom" == i[0] ? n.bottom : n.top
            };
          return o.x += t.ownerDocument.defaultView.scrollX, o.y += t.ownerDocument.defaultView.scrollY, o;
        }(e, function (t) {
          const e = t.split("-"),
            n = {
              top: "bottom",
              bottom: "top",
              left: "right",
              right: "left"
            };
          return `${n[e[0]]}-${n[e[1]]}`;
        }(this.activeHandlePosition)), this._originalWidth = i.width, this._originalHeight = i.height, this._aspectRatio = i.width / i.height;
        const o = n.style.width;
        o && o.match(/^\d+(\.\d*)?%$/) ? this._originalWidthPercents = parseFloat(o) : this._originalWidthPercents = function (t) {
          let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Pi(t);
          const n = Vw(t);
          return n ? e.width / n * 100 : 0;
        }(n, i);
      }
      update(t) {
        this.proposedWidth = t.width, this.proposedHeight = t.height, this.proposedWidthPercents = t.widthPercents, this.proposedHandleHostWidth = t.handleHostWidth, this.proposedHandleHostHeight = t.handleHostHeight;
      }
    }
    function oA(t) {
      return `ck-widget__resizer__handle-${t}`;
    }
    class rA extends Sr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-size-view", t.to("_viewPosition", t => t ? `ck-orientation-${t}` : "")],
            style: {
              display: t.if("_isVisible", "none", t => !t)
            }
          },
          children: [{
            text: t.to("_label")
          }]
        });
      }
      _bindToState(t, e) {
        this.bind("_isVisible").to(e, "proposedWidth", e, "proposedHeight", (t, e) => null !== t && null !== e), this.bind("_label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", (e, n, i) => "px" === t.unit ? `${e}×${n}` : `${i}%`), this.bind("_viewPosition").to(e, "activeHandlePosition", e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", (t, e, n) => e < 50 || n < 50 ? "above-center" : t);
      }
      _dismiss() {
        this.unbind(), this._isVisible = !1;
      }
    }
    class sA extends q() {
      constructor(t) {
        super(), this._viewResizerWrapper = null, this._options = t, this.set("isEnabled", !0), this.set("isSelected", !1), this.bind("isVisible").to(this, "isEnabled", this, "isSelected", (t, e) => t && e), this.decorate("begin"), this.decorate("cancel"), this.decorate("commit"), this.decorate("updateSize"), this.on("commit", t => {
          this.state.proposedWidth || this.state.proposedWidthPercents || (this._cleanup(), t.stop());
        }, {
          priority: "high"
        });
      }
      get state() {
        return this._state;
      }
      show() {
        this._options.editor.editing.view.change(t => {
          t.removeClass("ck-hidden", this._viewResizerWrapper);
        });
      }
      hide() {
        this._options.editor.editing.view.change(t => {
          t.addClass("ck-hidden", this._viewResizerWrapper);
        });
      }
      attach() {
        const t = this,
          e = this._options.viewElement;
        this._options.editor.editing.view.change(n => {
          const i = n.createUIElement("div", {
            class: "ck ck-reset_all ck-widget__resizer"
          }, function (e) {
            const n = this.toDomElement(e);
            return t._appendHandles(n), t._appendSizeUI(n), n;
          });
          n.insert(n.createPositionAt(e, "end"), i), n.addClass("ck-widget_with-resizer", e), this._viewResizerWrapper = i, this.isVisible || this.hide();
        }), this.on("change:isVisible", () => {
          this.isVisible ? (this.show(), this.redraw()) : this.hide();
        });
      }
      begin(t) {
        this._state = new iA(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(t, this._getHandleHost(), this._getResizeHost());
      }
      updateSize(t) {
        const e = this._proposeNewSize(t);
        this._options.editor.editing.view.change(t => {
          const n = this._options.unit || "%",
            i = ("%" === n ? e.widthPercents : e.width) + n;
          t.setStyle("width", i, this._options.viewElement);
        });
        const n = this._getHandleHost(),
          i = new Pi(n),
          o = Math.round(i.width),
          r = Math.round(i.height),
          s = new Pi(n);
        e.width = Math.round(s.width), e.height = Math.round(s.height), this.redraw(i), this.state.update({
          ...e,
          handleHostWidth: o,
          handleHostHeight: r
        });
      }
      commit() {
        const t = this._options.unit || "%",
          e = ("%" === t ? this.state.proposedWidthPercents : this.state.proposedWidth) + t;
        this._options.editor.editing.view.change(() => {
          this._cleanup(), this._options.onCommit(e);
        });
      }
      cancel() {
        this._cleanup();
      }
      destroy() {
        this.cancel();
      }
      redraw(t) {
        const e = this._domResizerWrapper;
        if (!((n = e) && n.ownerDocument && n.ownerDocument.contains(n))) return;
        var n;
        const i = e.parentElement,
          o = this._getHandleHost(),
          r = this._viewResizerWrapper,
          s = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];
        let a;
        if (i.isSameNode(o)) {
          const e = t || new Pi(o);
          a = [e.width + "px", e.height + "px", void 0, void 0];
        } else a = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];
        "same" !== J(s, a) && this._options.editor.editing.view.change(t => {
          t.setStyle({
            width: a[0],
            height: a[1],
            left: a[2],
            top: a[3]
          }, r);
        });
      }
      containsHandle(t) {
        return this._domResizerWrapper.contains(t);
      }
      static isResizeHandle(t) {
        return t.classList.contains("ck-widget__resizer__handle");
      }
      _cleanup() {
        this._sizeView._dismiss();
        this._options.editor.editing.view.change(t => {
          t.setStyle("width", this._initialViewWidth, this._options.viewElement);
        });
      }
      _proposeNewSize(t) {
        const e = this.state,
          n = {
            x: (i = t).pageX,
            y: i.pageY
          };
        var i;
        const o = !this._options.isCentered || this._options.isCentered(this),
          r = {
            x: e._referenceCoordinates.x - (n.x + e.originalWidth),
            y: n.y - e.originalHeight - e._referenceCoordinates.y
          };
        o && e.activeHandlePosition.endsWith("-right") && (r.x = n.x - (e._referenceCoordinates.x + e.originalWidth)), o && (r.x *= 2);
        let s = Math.abs(e.originalWidth + r.x),
          a = Math.abs(e.originalHeight + r.y);
        return "width" == (s / e.aspectRatio > a ? "width" : "height") ? a = s / e.aspectRatio : s = a * e.aspectRatio, {
          width: Math.round(s),
          height: Math.round(a),
          widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * s * 100) / 100, 100)
        };
      }
      _getResizeHost() {
        const t = this._domResizerWrapper.parentElement;
        return this._options.getResizeHost(t);
      }
      _getHandleHost() {
        const t = this._domResizerWrapper.parentElement;
        return this._options.getHandleHost(t);
      }
      get _domResizerWrapper() {
        return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
      }
      _appendHandles(t) {
        const e = ["top-left", "top-right", "bottom-right", "bottom-left"];
        for (const n of e) t.appendChild(new ir({
          tag: "div",
          attributes: {
            class: `ck-widget__resizer__handle ${aA(n)}`
          }
        }).render());
      }
      _appendSizeUI(t) {
        this._sizeView = new rA(), this._sizeView.render(), t.appendChild(this._sizeView.element);
      }
    }
    function aA(t) {
      return `ck-widget__resizer__handle-${t}`;
    }
    var lA = o(2060),
      cA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(lA.A, cA);
    lA.A.locals;
    class dA extends Nr {
      constructor() {
        super(...arguments), this._resizers = new Map();
      }
      static get pluginName() {
        return "WidgetResize";
      }
      init() {
        const t = this.editor.editing,
          n = e.window.document;
        this.set("selectedResizer", null), this.set("_activeResizer", null), t.view.addObserver(Xu), this._observer = new (Bi())(), this.listenTo(t.view.document, "mousedown", this._mouseDownListener.bind(this), {
          priority: "high"
        }), this._observer.listenTo(n, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(n, "mouseup", this._mouseUpListener.bind(this)), this._redrawSelectedResizerThrottled = hf(() => this.redrawSelectedResizer(), 200), this.editor.ui.on("update", this._redrawSelectedResizerThrottled), this.editor.model.document.on("change", () => {
          for (const [t, e] of this._resizers) t.isAttached() || (this._resizers.delete(t), e.destroy());
        }, {
          priority: "lowest"
        }), this._observer.listenTo(e.window, "resize", this._redrawSelectedResizerThrottled);
        const i = this.editor.editing.view.document.selection;
        i.on("change", () => {
          const t = i.getSelectedElement(),
            e = this.getResizerByViewElement(t) || null;
          e ? this.select(e) : this.deselect();
        });
      }
      redrawSelectedResizer() {
        this.selectedResizer && this.selectedResizer.isVisible && this.selectedResizer.redraw();
      }
      destroy() {
        super.destroy(), this._observer.stopListening();
        for (const t of this._resizers.values()) t.destroy();
        this._redrawSelectedResizerThrottled.cancel();
      }
      select(t) {
        this.deselect(), this.selectedResizer = t, this.selectedResizer.isSelected = !0;
      }
      deselect() {
        this.selectedResizer && (this.selectedResizer.isSelected = !1), this.selectedResizer = null;
      }
      attachTo(t) {
        const e = new sA(t),
          n = this.editor.plugins;
        if (e.attach(), n.has("WidgetToolbarRepository")) {
          const t = n.get("WidgetToolbarRepository");
          e.on("begin", () => {
            t.forceDisabled("resize");
          }, {
            priority: "lowest"
          }), e.on("cancel", () => {
            t.clearForceDisabled("resize");
          }, {
            priority: "highest"
          }), e.on("commit", () => {
            t.clearForceDisabled("resize");
          }, {
            priority: "highest"
          });
        }
        this._resizers.set(t.viewElement, e);
        const i = this.editor.editing.view.document.selection.getSelectedElement();
        return this.getResizerByViewElement(i) == e && this.select(e), e;
      }
      getResizerByViewElement(t) {
        return this._resizers.get(t);
      }
      _getResizerByHandle(t) {
        for (const e of this._resizers.values()) if (e.containsHandle(t)) return e;
      }
      _mouseDownListener(t, e) {
        const n = e.domTarget;
        sA.isResizeHandle(n) && (this._activeResizer = this._getResizerByHandle(n) || null, this._activeResizer && (this._activeResizer.begin(n), t.stop(), e.preventDefault()));
      }
      _mouseMoveListener(t, e) {
        this._activeResizer && this._activeResizer.updateSize(e);
      }
      _mouseUpListener() {
        this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
      }
    }
    const uA = Gi("px");
    class hA extends Sr {
      constructor() {
        super();
        const t = this.bindTemplate;
        this.set({
          isVisible: !1,
          left: null,
          top: null,
          width: null
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-clipboard-drop-target-line", t.if("isVisible", "ck-hidden", t => !t)],
            style: {
              left: t.to("left", t => uA(t)),
              top: t.to("top", t => uA(t)),
              width: t.to("width", t => uA(t))
            }
          }
        });
      }
    }
    class mA extends Nr {
      constructor() {
        super(...arguments), this.removeDropMarkerDelayed = Zo(() => this.removeDropMarker(), 40), this._updateDropMarkerThrottled = hf(t => this._updateDropMarker(t), 40), this._reconvertMarkerThrottled = hf(() => {
          this.editor.model.markers.has("drop-target") && this.editor.editing.reconvertMarker("drop-target");
        }, 0), this._dropTargetLineView = new hA(), this._domEmitter = new (Bi())(), this._scrollables = new Map();
      }
      static get pluginName() {
        return "DragDropTarget";
      }
      init() {
        this._setupDropMarker();
      }
      destroy() {
        this._domEmitter.stopListening();
        for (const {
          resizeObserver: t
        } of this._scrollables.values()) t.destroy();
        return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), super.destroy();
      }
      updateDropMarker(t, e, n, i, o, r) {
        this.removeDropMarkerDelayed.cancel();
        const s = gA(this.editor, t, e, n, i, o, r);
        if (s) return r && r.containsRange(s) ? this.removeDropMarker() : void this._updateDropMarkerThrottled(s);
      }
      getFinalDropRange(t, e, n, i, o, r) {
        const s = gA(this.editor, t, e, n, i, o, r);
        return this.removeDropMarker(), s;
      }
      removeDropMarker() {
        const t = this.editor.model;
        this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, t.markers.has("drop-target") && t.change(t => {
          t.removeMarker("drop-target");
        });
      }
      _setupDropMarker() {
        const t = this.editor;
        t.ui.view.body.add(this._dropTargetLineView), t.conversion.for("editingDowncast").markerToHighlight({
          model: "drop-target",
          view: {
            classes: ["ck-clipboard-drop-target-range"]
          }
        }), t.conversion.for("editingDowncast").markerToElement({
          model: "drop-target",
          view: (e, _ref85) => {
            let {
              writer: n
            } = _ref85;
            if (t.model.schema.checkChild(e.markerRange.start, "$text")) return this._dropTargetLineView.isVisible = !1, this._createDropTargetPosition(n);
            e.markerRange.isCollapsed ? this._updateDropTargetLine(e.markerRange) : this._dropTargetLineView.isVisible = !1;
          }
        });
      }
      _updateDropMarker(t) {
        const e = this.editor,
          n = e.model.markers;
        e.model.change(e => {
          n.has("drop-target") ? n.get("drop-target").getRange().isEqual(t) || e.updateMarker("drop-target", {
            range: t
          }) : e.addMarker("drop-target", {
            range: t,
            usingOperation: !1,
            affectsData: !1
          });
        });
      }
      _createDropTargetPosition(t) {
        return t.createUIElement("span", {
          class: "ck ck-clipboard-drop-target-position"
        }, function (t) {
          const e = this.toDomElement(t);
          return e.append("⁠", t.createElement("span"), "⁠"), e;
        });
      }
      _updateDropTargetLine(t) {
        const n = this.editor.editing,
          i = t.start.nodeBefore,
          o = t.start.nodeAfter,
          r = t.start.parent,
          s = i ? n.mapper.toViewElement(i) : null,
          a = s ? n.view.domConverter.mapViewToDom(s) : null,
          l = o ? n.mapper.toViewElement(o) : null,
          c = l ? n.view.domConverter.mapViewToDom(l) : null,
          d = n.mapper.toViewElement(r);
        if (!d) return;
        const u = n.view.domConverter.mapViewToDom(d),
          h = this._getScrollableRect(d),
          {
            scrollX: m,
            scrollY: g
          } = e.window,
          p = a ? new Pi(a) : null,
          f = c ? new Pi(c) : null,
          k = new Pi(u).excludeScrollbarsAndBorders(),
          b = p ? p.bottom : k.top,
          w = f ? f.top : k.bottom,
          A = e.window.getComputedStyle(u),
          C = b <= w ? (b + w) / 2 : w;
        if (h.top < C && C < h.bottom) {
          const t = k.left + parseFloat(A.paddingLeft),
            e = k.right - parseFloat(A.paddingRight),
            n = Math.max(t + m, h.left),
            i = Math.min(e + m, h.right);
          this._dropTargetLineView.set({
            isVisible: !0,
            left: n,
            top: C + g,
            width: i - n
          });
        } else this._dropTargetLineView.isVisible = !1;
      }
      _getScrollableRect(t) {
        const n = t.root.rootName;
        let i;
        if (this._scrollables.has(n)) i = this._scrollables.get(n).domElement;else {
          i = function (t) {
            let n = t;
            do {
              n = n.parentElement;
              const t = e.window.getComputedStyle(n).overflowY;
              if ("auto" == t || "scroll" == t) break;
            } while ("BODY" != n.tagName);
            return n;
          }(this.editor.editing.view.domConverter.mapViewToDom(t)), this._domEmitter.listenTo(i, "scroll", this._reconvertMarkerThrottled, {
            usePassive: !0
          });
          const o = new Ui(i, this._reconvertMarkerThrottled);
          this._scrollables.set(n, {
            domElement: i,
            resizeObserver: o
          });
        }
        return new Pi(i).excludeScrollbarsAndBorders();
      }
    }
    function gA(t, e, n, i, o, r, s) {
      const a = t.model,
        l = t.editing.mapper;
      let c = bA(t, e);
      for (; c;) {
        if (!r) if (a.schema.checkChild(c, "$text")) {
          if (n) {
            const e = n[0].start,
              r = l.toModelPosition(e);
            if (!s || Array.from(s.getItems()).every(t => a.schema.checkChild(r, t))) {
              if (a.schema.checkChild(r, "$text")) return a.createRange(r);
              if (e) return fA(t, bA(t, e.parent), i, o);
            }
          }
        } else if (a.schema.isInline(c)) return fA(t, c, i, o);
        if (a.schema.isBlock(c)) return fA(t, c, i, o);
        if (a.schema.checkChild(c, "$block")) {
          const e = Array.from(c.getChildren()).filter(e => e.is("element") && !pA(t, e));
          let n = 0,
            r = e.length;
          if (0 == r) return a.createRange(a.createPositionAt(c, "end"));
          for (; n < r - 1;) {
            const s = Math.floor((n + r) / 2);
            "before" == kA(t, e[s], i, o) ? r = s : n = s;
          }
          return fA(t, e[n], i, o);
        }
        c = c.parent;
      }
      return null;
    }
    function pA(t, n) {
      const i = t.editing.mapper,
        o = t.editing.view.domConverter,
        r = i.toViewElement(n);
      if (!r) return !0;
      const s = o.mapViewToDom(r);
      return "none" != e.window.getComputedStyle(s).float;
    }
    function fA(t, e, n, i) {
      const o = t.model;
      return o.createRange(o.createPositionAt(e, kA(t, e, n, i)));
    }
    function kA(t, e, n, i) {
      const o = t.editing.mapper,
        r = t.editing.view.domConverter,
        s = o.toViewElement(e),
        a = r.mapViewToDom(s),
        l = new Pi(a);
      return t.model.schema.isInline(e) ? n < (l.left + l.right) / 2 ? "before" : "after" : i < (l.top + l.bottom) / 2 ? "before" : "after";
    }
    function bA(t, e) {
      const n = t.editing.mapper,
        i = t.editing.view,
        o = n.toModelElement(e);
      if (o) return o;
      const r = i.createPositionBefore(e),
        s = n.findMappedViewAncestor(r);
      return n.toModelElement(s);
    }
    class wA extends Nr {
      constructor() {
        super(...arguments), this._isBlockDragging = !1, this._domEmitter = new (Bi())();
      }
      static get pluginName() {
        return "DragDropBlockToolbar";
      }
      init() {
        const t = this.editor;
        if (this.listenTo(t, "change:isReadOnly", (t, e, n) => {
          n ? (this.forceDisabled("readOnlyMode"), this._isBlockDragging = !1) : this.clearForceDisabled("readOnlyMode");
        }), s.isAndroid && this.forceDisabled("noAndroidSupport"), t.plugins.has("BlockToolbar")) {
          const n = t.plugins.get("BlockToolbar").buttonView.element;
          this._domEmitter.listenTo(n, "dragstart", (t, e) => this._handleBlockDragStart(e)), this._domEmitter.listenTo(e.document, "dragover", (t, e) => this._handleBlockDragging(e)), this._domEmitter.listenTo(e.document, "drop", (t, e) => this._handleBlockDragging(e)), this._domEmitter.listenTo(e.document, "dragend", () => this._handleBlockDragEnd(), {
            useCapture: !0
          }), this.isEnabled && n.setAttribute("draggable", "true"), this.on("change:isEnabled", (t, e, i) => {
            n.setAttribute("draggable", i ? "true" : "false");
          });
        }
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
      _handleBlockDragStart(t) {
        if (!this.isEnabled) return;
        const e = this.editor.model,
          n = e.document.selection,
          i = this.editor.editing.view,
          o = Array.from(n.getSelectedBlocks()),
          r = e.createRange(e.createPositionBefore(o[0]), e.createPositionAfter(o[o.length - 1]));
        e.change(t => t.setSelection(r)), this._isBlockDragging = !0, i.focus(), i.getObserver(ub).onDomEvent(t);
      }
      _handleBlockDragging(t) {
        if (!this.isEnabled || !this._isBlockDragging) return;
        const e = t.clientX + ("ltr" == this.editor.locale.contentLanguageDirection ? 100 : -100),
          n = t.clientY,
          i = document.elementFromPoint(e, n),
          o = this.editor.editing.view;
        i && i.closest(".ck-editor__editable") && o.getObserver(ub).onDomEvent({
          ...t,
          type: t.type,
          dataTransfer: t.dataTransfer,
          target: i,
          clientX: e,
          clientY: n,
          preventDefault: () => t.preventDefault(),
          stopPropagation: () => t.stopPropagation()
        });
      }
      _handleBlockDragEnd() {
        this._isBlockDragging = !1;
      }
    }
    var AA = o(9262),
      CA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(AA.A, CA);
    AA.A.locals;
    class _A extends Nr {
      constructor() {
        super(...arguments), this._clearDraggableAttributesDelayed = Zo(() => this._clearDraggableAttributes(), 40), this._blockMode = !1, this._domEmitter = new (Bi())();
      }
      static get pluginName() {
        return "DragDrop";
      }
      static get requires() {
        return [Mb, Jw, mA, wA];
      }
      init() {
        const t = this.editor,
          e = t.editing.view;
        this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, e.addObserver(ub), e.addObserver(Xu), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", (t, e, n) => {
          n ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
        }), this.on("change:isEnabled", (t, e, n) => {
          n || this._finalizeDragging(!1);
        }), s.isAndroid && this.forceDisabled("noAndroidSupport");
      }
      destroy() {
        return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
      }
      _setupDragging() {
        const t = this.editor,
          n = t.model,
          i = t.editing.view,
          o = i.document,
          r = t.plugins.get(mA);
        this.listenTo(o, "dragstart", (t, e) => {
          if (e.target && e.target.is("editableElement")) return void e.preventDefault();
          if (this._prepareDraggedRange(e.target), !this._draggedRange) return void e.preventDefault();
          this._draggingUid = p(), e.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", e.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
          const i = n.createSelection(this._draggedRange.toRange());
          this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(e.dataTransfer, i, "dragstart");
          const {
              dataTransfer: o,
              domTarget: r,
              domEvent: s
            } = e,
            {
              clientX: a
            } = s;
          this._updatePreview({
            dataTransfer: o,
            domTarget: r,
            clientX: a
          }), e.stopPropagation(), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
        }, {
          priority: "low"
        }), this.listenTo(o, "dragend", (t, e) => {
          this._finalizeDragging(!e.dataTransfer.isCanceled && "move" == e.dataTransfer.dropEffect);
        }, {
          priority: "low"
        }), this._domEmitter.listenTo(e.document, "dragend", () => {
          this._blockMode = !1;
        }, {
          useCapture: !0
        }), this.listenTo(o, "dragenter", () => {
          this.isEnabled && i.focus();
        }), this.listenTo(o, "dragleave", () => {
          r.removeDropMarkerDelayed();
        }), this.listenTo(o, "dragging", (t, e) => {
          if (!this.isEnabled) return void (e.dataTransfer.dropEffect = "none");
          const {
            clientX: n,
            clientY: i
          } = e.domEvent;
          r.updateDropMarker(e.target, e.targetRanges, n, i, this._blockMode, this._draggedRange), this._draggedRange || (e.dataTransfer.dropEffect = "copy"), s.isGecko || ("copy" == e.dataTransfer.effectAllowed ? e.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(e.dataTransfer.effectAllowed) && (e.dataTransfer.dropEffect = "move")), t.stop();
        }, {
          priority: "low"
        });
      }
      _setupClipboardInputIntegration() {
        const t = this.editor,
          e = t.editing.view.document,
          n = t.plugins.get(mA);
        this.listenTo(e, "clipboardInput", (e, i) => {
          if ("drop" != i.method) return;
          const {
              clientX: o,
              clientY: r
            } = i.domEvent,
            s = n.getFinalDropRange(i.target, i.targetRanges, o, r, this._blockMode, this._draggedRange);
          if (!s) return this._finalizeDragging(!1), void e.stop();
          this._draggedRange && this._draggingUid != i.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
          if ("move" == vA(i.dataTransfer) && this._draggedRange && this._draggedRange.containsRange(s, !0)) return this._finalizeDragging(!1), void e.stop();
          i.targetRanges = [t.editing.mapper.toViewRange(s)];
        }, {
          priority: "high"
        });
      }
      _setupContentInsertionIntegration() {
        const t = this.editor.plugins.get(Mb);
        t.on("contentInsertion", (t, e) => {
          if (!this.isEnabled || "drop" !== e.method) return;
          const n = e.targetRanges.map(t => this.editor.editing.mapper.toModelRange(t));
          this.editor.model.change(t => t.setSelection(n));
        }, {
          priority: "high"
        }), t.on("contentInsertion", (t, e) => {
          if (!this.isEnabled || "drop" !== e.method) return;
          const n = "move" == vA(e.dataTransfer),
            i = !e.resultRange || !e.resultRange.isCollapsed;
          this._finalizeDragging(i && n);
        }, {
          priority: "lowest"
        });
      }
      _setupDraggableAttributeHandling() {
        const t = this.editor,
          e = t.editing.view,
          n = e.document;
        this.listenTo(n, "mousedown", (i, o) => {
          if (s.isAndroid || !o) return;
          this._clearDraggableAttributesDelayed.cancel();
          let r = yA(o.target);
          if (s.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
            const t = n.selection.getSelectedElement();
            t && Sw(t) || (r = n.selection.editableElement);
          }
          r && (e.change(t => {
            t.setAttribute("draggable", "true", r);
          }), this._draggableElement = t.editing.mapper.toModelElement(r));
        }), this.listenTo(n, "mouseup", () => {
          s.isAndroid || this._clearDraggableAttributesDelayed();
        });
      }
      _clearDraggableAttributes() {
        const t = this.editor.editing;
        t.view.change(e => {
          this._draggableElement && "$graveyard" != this._draggableElement.root.rootName && e.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
        });
      }
      _finalizeDragging(t) {
        const e = this.editor,
          n = e.model;
        if (e.plugins.get(mA).removeDropMarker(), this._clearDraggableAttributes(), e.plugins.has("WidgetToolbarRepository")) {
          e.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop");
        }
        this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (t && this.isEnabled && n.change(t => {
          const e = n.createSelection(this._draggedRange);
          n.deleteContent(e, {
            doNotAutoparagraph: !0
          });
          const i = e.getFirstPosition().parent;
          i.isEmpty && !n.schema.checkChild(i, "$text") && n.schema.checkChild(i, "paragraph") && t.insertElement("paragraph", i, 0);
        }), this._draggedRange.detach(), this._draggedRange = null);
      }
      _prepareDraggedRange(t) {
        const e = this.editor,
          n = e.model,
          i = n.document.selection,
          o = t ? yA(t) : null;
        if (o) {
          const t = e.editing.mapper.toModelElement(o);
          if (this._draggedRange = Ec.fromRange(n.createRangeOn(t)), this._blockMode = n.schema.isBlock(t), e.plugins.has("WidgetToolbarRepository")) {
            e.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
          }
          return;
        }
        if (i.isCollapsed && !i.getFirstPosition().parent.isEmpty) return;
        const r = Array.from(i.getSelectedBlocks()),
          s = i.getFirstRange();
        if (0 == r.length) return void (this._draggedRange = Ec.fromRange(s));
        const a = xA(n, r);
        if (r.length > 1) this._draggedRange = Ec.fromRange(a), this._blockMode = !0;else if (1 == r.length) {
          const t = s.start.isTouching(a.start) && s.end.isTouching(a.end);
          this._draggedRange = Ec.fromRange(t ? a : s), this._blockMode = t;
        }
        n.change(t => t.setSelection(this._draggedRange.toRange()));
      }
      _updatePreview(_ref86) {
        let {
          dataTransfer: t,
          domTarget: n,
          clientX: i
        } = _ref86;
        const o = this.editor.editing.view,
          r = o.document.selection.editableElement,
          a = o.domConverter.mapViewToDom(r),
          l = e.window.getComputedStyle(a);
        this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = ft(e.document, "div", {
          style: "position: fixed; left: -999999px;"
        }), e.document.body.appendChild(this._previewContainer));
        const c = new Pi(a);
        if (a.contains(n)) return;
        const d = parseFloat(l.paddingLeft),
          u = ft(e.document, "div");
        u.className = "ck ck-content", u.style.width = l.width, u.style.paddingLeft = `${c.left - i + d}px`, s.isiOS && (u.style.backgroundColor = "white"), u.innerHTML = t.getData("text/html"), t.setDragImage(u, 0, 0), this._previewContainer.appendChild(u);
      }
    }
    function vA(t) {
      return s.isGecko ? t.dropEffect : ["all", "copyMove"].includes(t.effectAllowed) ? "move" : "copy";
    }
    function yA(t) {
      if (t.is("editableElement")) return null;
      if (t.hasClass("ck-widget__selection-handle")) return t.findAncestor(Sw);
      if (Sw(t)) return t;
      const e = t.findAncestor(t => Sw(t) || t.is("editableElement"));
      return Sw(e) ? e : null;
    }
    function xA(t, e) {
      const n = e[0],
        i = e[e.length - 1],
        o = n.getCommonAncestor(i),
        r = t.createPositionBefore(n),
        s = t.createPositionAfter(i);
      if (o && o.is("element") && !t.schema.isLimit(o)) {
        const e = t.createRangeOn(o),
          n = r.isTouching(e.start),
          i = s.isTouching(e.end);
        if (n && i) return xA(t, [o]);
      }
      return t.createRange(r, s);
    }
    class EA extends Nr {
      static get pluginName() {
        return "PastePlainText";
      }
      static get requires() {
        return [Mb];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = n.document,
          o = e.document.selection;
        let r = !1;
        n.addObserver(ub), this.listenTo(i, "keydown", (t, e) => {
          r = e.shiftKey;
        }), t.plugins.get(Mb).on("contentInsertion", (t, n) => {
          (r || function (t, e) {
            if (t.childCount > 1) return !1;
            const n = t.getChild(0);
            if (e.isObject(n)) return !1;
            return 0 == Array.from(n.getAttributeKeys()).length;
          }(n.content, e.schema)) && e.change(t => {
            const i = Array.from(o.getAttributes()).filter(_ref87 => {
              let [t] = _ref87;
              return e.schema.getAttributeProperties(t).isFormatting;
            });
            o.isCollapsed || e.deleteContent(o, {
              doNotAutoparagraph: !0
            }), i.push(...o.getAttributes());
            const r = t.createRangeIn(n.content);
            for (const e of r.getItems()) e.is("$textProxy") && t.setAttributes(i, e);
          });
        });
      }
    }
    class DA extends Nr {
      static get pluginName() {
        return "Clipboard";
      }
      static get requires() {
        return [Ib, Mb, _A, EA];
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Copy selected content"),
            keystroke: "CTRL+C"
          }, {
            label: e("Paste content"),
            keystroke: "CTRL+V"
          }, {
            label: e("Paste content as plain text"),
            keystroke: "CTRL+SHIFT+V"
          }]
        });
      }
    }
    class BA extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      execute() {
        const t = this.editor.model,
          e = t.document.selection;
        let n = t.schema.getLimitElement(e);
        if (e.containsEntireContent(n) || !SA(t.schema, n)) do {
          if (n = n.parent, !n) return;
        } while (!SA(t.schema, n));
        t.change(t => {
          t.setSelection(n, "in");
        });
      }
    }
    function SA(t, e) {
      return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
    }
    const TA = bo("Ctrl+A");
    class IA extends Nr {
      static get pluginName() {
        return "SelectAllEditing";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = t.editing.view.document;
        t.commands.add("selectAll", new BA(t)), this.listenTo(n, "keydown", (e, n) => {
          ko(n) === TA && (t.execute("selectAll"), n.preventDefault());
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Select all"),
            keystroke: "CTRL+A"
          }]
        });
      }
    }
    class MA extends Nr {
      static get pluginName() {
        return "SelectAllUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add("selectAll", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0
          }), t;
        }), t.ui.componentFactory.add("menuBar:selectAll", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("selectAll"),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Select all"),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
          keystroke: "Ctrl+A"
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          e.execute("selectAll"), e.editing.view.focus();
        }), o;
      }
    }
    class LA extends Nr {
      static get requires() {
        return [IA, MA];
      }
      static get pluginName() {
        return "SelectAll";
      }
    }
    class NA extends Pr {
      constructor(t) {
        super(t), this._stack = [], this._createdBatches = new WeakSet(), this.refresh(), this._isEnabledBasedOnSelection = !1, this.listenTo(t.data, "set", (t, e) => {
          e[1] = {
            ...e[1]
          };
          const n = e[1];
          n.batchType || (n.batchType = {
            isUndoable: !1
          });
        }, {
          priority: "high"
        }), this.listenTo(t.data, "set", (t, e) => {
          e[1].batchType.isUndoable || this.clearStack();
        });
      }
      refresh() {
        this.isEnabled = this._stack.length > 0;
      }
      get createdBatches() {
        return this._createdBatches;
      }
      addBatch(t) {
        const e = this.editor.model.document.selection,
          n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
        this._stack.push({
          batch: t,
          selection: n
        }), this.refresh();
      }
      clearStack() {
        this._stack = [], this.refresh();
      }
      _restoreSelection(t, e, n) {
        const i = this.editor.model,
          o = i.document,
          r = [],
          s = t.map(t => t.getTransformedByOperations(n)),
          a = s.flat();
        for (const t of s) {
          const e = t.filter(t => t.root != o.graveyard).filter(t => !PA(t, a));
          e.length && (zA(e), r.push(e[0]));
        }
        r.length && i.change(t => {
          t.setSelection(r, {
            backward: e
          });
        });
      }
      _undo(t, e) {
        const n = this.editor.model,
          i = n.document;
        this._createdBatches.add(e);
        const o = t.operations.slice().filter(t => t.isDocumentOperation);
        o.reverse();
        for (const t of o) {
          const o = t.baseVersion + 1,
            r = Array.from(i.history.getOperations(o)),
            s = au([t.getReversed()], r, {
              useRelations: !0,
              document: this.editor.model.document,
              padWithNoOps: !1,
              forceWeakRemove: !0
            }).operationsA;
          for (let o of s) {
            const r = o.affectedSelectable;
            r && !n.canEditAt(r) && (o = new Zd(o.baseVersion)), e.addOperation(o), n.applyOperation(o), i.history.setOperationAsUndone(t, o);
          }
        }
      }
    }
    function zA(t) {
      t.sort((t, e) => t.start.isBefore(e.start) ? -1 : 1);
      for (let e = 1; e < t.length; e++) {
        const n = t[e - 1].getJoined(t[e], !0);
        n && (e--, t.splice(e, 2, n));
      }
    }
    function PA(t, e) {
      return e.some(e => e !== t && e.containsRange(t, !0));
    }
    class VA extends NA {
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        const e = t ? this._stack.findIndex(e => e.batch == t) : this._stack.length - 1,
          n = this._stack.splice(e, 1)[0],
          i = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(i, () => {
          this._undo(n.batch, i);
          const t = this.editor.model.document.history.getOperations(n.batch.baseVersion);
          this._restoreSelection(n.selection.ranges, n.selection.isBackward, t);
        }), this.fire("revert", n.batch, i), this.refresh();
      }
    }
    class RA extends NA {
      execute() {
        const t = this._stack.pop(),
          e = this.editor.model.createBatch({
            isUndo: !0
          });
        this.editor.model.enqueueChange(e, () => {
          const n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
            i = this.editor.model.document.history.getOperations(n);
          this._restoreSelection(t.selection.ranges, t.selection.isBackward, i), this._undo(t.batch, e);
        }), this.refresh();
      }
    }
    class FA extends Nr {
      constructor() {
        super(...arguments), this._batchRegistry = new WeakSet();
      }
      static get pluginName() {
        return "UndoEditing";
      }
      init() {
        const t = this.editor,
          e = t.t;
        this._undoCommand = new VA(t), this._redoCommand = new RA(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", (t, e) => {
          const n = e[0];
          if (!n.isDocumentOperation) return;
          const i = n.batch,
            o = this._redoCommand.createdBatches.has(i),
            r = this._undoCommand.createdBatches.has(i);
          this._batchRegistry.has(i) || (this._batchRegistry.add(i), i.isUndoable && (o ? this._undoCommand.addBatch(i) : r || (this._undoCommand.addBatch(i), this._redoCommand.clearStack())));
        }, {
          priority: "highest"
        }), this.listenTo(this._undoCommand, "revert", (t, e, n) => {
          this._redoCommand.addBatch(n);
        }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo"), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Undo"),
            keystroke: "CTRL+Z"
          }, {
            label: e("Redo"),
            keystroke: [["CTRL+Y"], ["CTRL+SHIFT+Z"]]
          }]
        });
      }
    }
    class OA extends Nr {
      static get pluginName() {
        return "UndoUI";
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = t.t,
          i = "ltr" == e.uiLanguageDirection ? Yh.undo : Yh.redo,
          o = "ltr" == e.uiLanguageDirection ? Yh.redo : Yh.undo;
        this._addButtonsToFactory("undo", n("Undo"), "CTRL+Z", i), this._addButtonsToFactory("redo", n("Redo"), "CTRL+Y", o);
      }
      _addButtonsToFactory(t, e, n, i) {
        const o = this.editor;
        o.ui.componentFactory.add(t, () => {
          const o = this._createButton(mm, t, e, n, i);
          return o.set({
            tooltip: !0
          }), o;
        }), o.ui.componentFactory.add("menuBar:" + t, () => this._createButton(Uk, t, e, n, i));
      }
      _createButton(t, e, n, i, o) {
        const r = this.editor,
          s = r.locale,
          a = r.commands.get(e),
          l = new t(s);
        return l.set({
          label: n,
          icon: o,
          keystroke: i
        }), l.bind("isEnabled").to(a, "isEnabled"), this.listenTo(l, "execute", () => {
          r.execute(e), r.editing.view.focus();
        }), l;
      }
    }
    class jA extends Nr {
      static get requires() {
        return [FA, OA];
      }
      static get pluginName() {
        return "Undo";
      }
    }
    function HA(t, e, n, i) {
      let o,
        r = null;
      "function" == typeof i ? o = i : (r = t.commands.get(i), o = () => {
        t.execute(i);
      }), t.model.document.on("change:data", (s, a) => {
        if (r && !r.isEnabled || !e.isEnabled) return;
        const l = $o(t.model.document.selection.getRanges());
        if (!l.isCollapsed) return;
        if (a.isUndo || !a.isLocal) return;
        const c = Array.from(t.model.document.differ.getChanges()),
          d = c[0];
        if (1 != c.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
        const u = d.position.parent;
        if (u.is("element", "codeBlock")) return;
        if (u.is("element", "listItem") && "function" != typeof i && !["numberedList", "bulletedList", "todoList"].includes(i)) return;
        if (r && !0 === r.value) return;
        const h = u.getChild(0),
          m = t.model.createRangeOn(h);
        if (!m.containsRange(l) && !l.end.isEqual(m.end)) return;
        const g = n.exec(h.data.substr(0, l.end.offset));
        g && t.model.enqueueChange(e => {
          const n = e.createPositionAt(u, 0),
            i = e.createPositionAt(u, g[0].length),
            r = new Ec(n, i);
          if (!1 !== o({
            match: g
          })) {
            e.remove(r);
            const n = t.model.document.selection.getFirstRange(),
              i = e.createRangeIn(u);
            !u.isEmpty || i.isEqual(n) || i.containsRange(n, !0) || e.remove(u);
          }
          r.detach(), t.model.enqueueChange(() => {
            t.plugins.get("Delete").requestUndoOnBackspace();
          });
        });
      });
    }
    function UA(t, e, n, i) {
      let o, r;
      n instanceof RegExp ? o = n : r = n, r = r || (t => {
        let e;
        const n = [],
          i = [];
        for (; null !== (e = o.exec(t)) && !(e && e.length < 4);) {
          let {
            index: t,
            1: o,
            2: r,
            3: s
          } = e;
          const a = o + r + s;
          t += e[0].length - a.length;
          const l = [t, t + o.length],
            c = [t + o.length + r.length, t + o.length + r.length + s.length];
          n.push(l), n.push(c), i.push([t + o.length, t + o.length + r.length]);
        }
        return {
          remove: n,
          format: i
        };
      }), t.model.document.on("change:data", (n, o) => {
        if (o.isUndo || !o.isLocal || !e.isEnabled) return;
        const s = t.model,
          a = s.document.selection;
        if (!a.isCollapsed) return;
        const l = Array.from(s.document.differ.getChanges()),
          c = l[0];
        if (1 != l.length || "insert" !== c.type || "$text" != c.name || 1 != c.length) return;
        const d = a.focus,
          u = d.parent,
          {
            text: h,
            range: m
          } = function (t, e) {
            let n = t.start;
            const i = Array.from(t.getItems()).reduce((t, i) => !i.is("$text") && !i.is("$textProxy") || i.getAttribute("code") ? (n = e.createPositionAfter(i), "") : t + i.data, "");
            return {
              text: i,
              range: e.createRange(n, t.end)
            };
          }(s.createRange(s.createPositionAt(u, 0), d), s),
          g = r(h),
          p = qA(m.start, g.format, s),
          f = qA(m.start, g.remove, s);
        p.length && f.length && s.enqueueChange(e => {
          if (!1 !== i(e, p)) {
            for (const t of f.reverse()) e.remove(t);
            s.enqueueChange(() => {
              t.plugins.get("Delete").requestUndoOnBackspace();
            });
          }
        });
      });
    }
    function qA(t, e, n) {
      return e.filter(t => void 0 !== t[0] && void 0 !== t[1]).map(e => n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1])));
    }
    function GA(t, e) {
      return (n, i) => {
        if (!t.commands.get(e).isEnabled) return !1;
        const o = t.model.schema.getValidRanges(i, e);
        for (const t of o) n.setAttribute(e, !0, t);
        n.removeSelectionAttribute(e);
      };
    }
    class WA extends Pr {
      constructor(t, e) {
        super(t), this.attributeKey = e;
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document.selection,
          i = void 0 === t.forceValue ? !this.value : t.forceValue;
        e.change(t => {
          if (n.isCollapsed) i ? t.setSelectionAttribute(this.attributeKey, !0) : t.removeSelectionAttribute(this.attributeKey);else {
            const o = e.schema.getValidRanges(n.getRanges(), this.attributeKey);
            for (const e of o) i ? t.setAttribute(this.attributeKey, i, e) : t.removeAttribute(this.attributeKey, e);
          }
        });
      }
      _getValueFromFirstAllowedNode() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection;
        if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
        for (const t of n.getRanges()) for (const n of t.getItems()) if (e.checkAttribute(n, this.attributeKey)) return n.hasAttribute(this.attributeKey);
        return !1;
      }
    }
    const $A = "bold";
    class KA extends Nr {
      static get pluginName() {
        return "BoldEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: $A
        }), t.model.schema.setAttributeProperties($A, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: $A,
          view: "strong",
          upcastAlso: ["b", t => {
            const e = t.getStyle("font-weight");
            return e && ("bold" == e || Number(e) >= 600) ? {
              name: !0,
              styles: ["font-weight"]
            } : null;
          }]
        }), t.commands.add($A, new WA(t, $A)), t.keystrokes.set("CTRL+B", $A), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Bold text"),
            keystroke: "CTRL+B"
          }]
        });
      }
    }
    function YA(_ref88) {
      let {
        editor: t,
        commandName: e,
        plugin: n,
        icon: i,
        label: o,
        keystroke: r
      } = _ref88;
      return s => {
        const a = t.commands.get(e),
          l = new s(t.locale);
        return l.set({
          label: o,
          icon: i,
          keystroke: r,
          isToggleable: !0
        }), l.bind("isEnabled").to(a, "isEnabled"), n.listenTo(l, "execute", () => {
          t.execute(e), t.editing.view.focus();
        }), l;
      };
    }
    const QA = "bold";
    class ZA extends Nr {
      static get pluginName() {
        return "BoldUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = t.commands.get(QA),
          i = YA({
            editor: t,
            commandName: QA,
            plugin: this,
            icon: Yh.bold,
            label: e("Bold"),
            keystroke: "CTRL+B"
          });
        t.ui.componentFactory.add(QA, () => {
          const t = i(mm);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(n, "value"), t;
        }), t.ui.componentFactory.add("menuBar:" + QA, () => i(Uk));
      }
    }
    const JA = "code";
    class XA extends Nr {
      static get pluginName() {
        return "CodeEditing";
      }
      static get requires() {
        return [Qb];
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: JA
        }), t.model.schema.setAttributeProperties(JA, {
          isFormatting: !0,
          copyOnEnter: !1
        }), t.conversion.attributeToElement({
          model: JA,
          view: "code",
          upcastAlso: {
            styles: {
              "word-wrap": "break-word"
            }
          }
        }), t.commands.add(JA, new WA(t, JA)), t.plugins.get(Qb).registerAttribute(JA), hw(t, JA, "code", "ck-code_selected"), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Move out of an inline code style"),
            keystroke: [["arrowleft", "arrowleft"], ["arrowright", "arrowright"]]
          }]
        });
      }
    }
    var tC = o(9248),
      eC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(tC.A, eC);
    tC.A.locals;
    const nC = "code";
    class iC extends Nr {
      static get pluginName() {
        return "CodeUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = YA({
            editor: t,
            commandName: nC,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 5.7 5.2 3.9v1.3l-5.6 4c-.1.2-.3.2-.5.2-.3-.1-.6-.7-.6-1l.3-.4 4.7-3.5L11.5 7l-.2-.2c-.1-.3-.1-.6 0-.8.2-.2.5-.4.8-.4a.8.8 0 0 1 .4.1zm-5.2 0L2 9.6v1.3l5.6 4c.1.2.3.2.5.2.3-.1.7-.7.6-1 0-.1 0-.3-.2-.4l-5-3.5L8.2 7l.2-.2c.1-.3.1-.6 0-.8-.2-.2-.5-.4-.8-.4a.8.8 0 0 0-.3.1z"/></svg>',
            label: e("Code")
          });
        t.ui.componentFactory.add(nC, () => {
          const e = n(mm),
            i = t.commands.get(nC);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(i, "value"), e;
        }), t.ui.componentFactory.add("menuBar:" + nC, () => n(Uk));
      }
    }
    const oC = "italic";
    class rC extends Nr {
      static get pluginName() {
        return "ItalicEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: oC
        }), t.model.schema.setAttributeProperties(oC, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: oC,
          view: "i",
          upcastAlso: ["em", {
            styles: {
              "font-style": "italic"
            }
          }]
        }), t.commands.add(oC, new WA(t, oC)), t.keystrokes.set("CTRL+I", oC), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Italic text"),
            keystroke: "CTRL+I"
          }]
        });
      }
    }
    const sC = "italic";
    class aC extends Nr {
      static get pluginName() {
        return "ItalicUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get(sC),
          n = t.locale.t,
          i = YA({
            editor: t,
            commandName: sC,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
            keystroke: "CTRL+I",
            label: n("Italic")
          });
        t.ui.componentFactory.add(sC, () => {
          const t = i(mm);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(e, "value"), t;
        }), t.ui.componentFactory.add("menuBar:" + sC, () => i(Uk));
      }
    }
    const lC = "strikethrough";
    class cC extends Nr {
      static get pluginName() {
        return "StrikethroughEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: lC
        }), t.model.schema.setAttributeProperties(lC, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: lC,
          view: "s",
          upcastAlso: ["del", "strike", {
            styles: {
              "text-decoration": "line-through"
            }
          }]
        }), t.commands.add(lC, new WA(t, lC)), t.keystrokes.set("CTRL+SHIFT+X", "strikethrough"), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Strikethrough text"),
            keystroke: "CTRL+SHIFT+X"
          }]
        });
      }
    }
    const dC = "strikethrough";
    class uC extends Nr {
      static get pluginName() {
        return "StrikethroughUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = YA({
            editor: t,
            commandName: dC,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6zM6.8 9 6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z"/><path d="M3 10.5V9h14v1.5z"/></svg>',
            keystroke: "CTRL+SHIFT+X",
            label: e("Strikethrough")
          });
        t.ui.componentFactory.add(dC, () => {
          const e = n(mm),
            i = t.commands.get(dC);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(i, "value"), e;
        }), t.ui.componentFactory.add("menuBar:" + dC, () => n(Uk));
      }
    }
    const hC = "subscript";
    class mC extends Nr {
      static get pluginName() {
        return "SubscriptEditing";
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: hC
        }), t.model.schema.setAttributeProperties(hC, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: hC,
          view: "sub",
          upcastAlso: [{
            styles: {
              "vertical-align": "sub"
            }
          }]
        }), t.commands.add(hC, new WA(t, hC));
      }
    }
    const gC = "subscript";
    class pC extends Nr {
      static get pluginName() {
        return "SubscriptUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = YA({
            editor: t,
            commandName: gC,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.03 10.349 3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82zm8.147 7.829h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309z"/></svg>',
            label: e("Subscript")
          });
        t.ui.componentFactory.add(gC, () => {
          const e = n(mm),
            i = t.commands.get(gC);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(i, "value"), e;
        }), t.ui.componentFactory.add("menuBar:" + gC, () => n(Uk));
      }
    }
    const fC = "superscript";
    class kC extends Nr {
      static get pluginName() {
        return "SuperscriptEditing";
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: fC
        }), t.model.schema.setAttributeProperties(fC, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: fC,
          view: "sup",
          upcastAlso: [{
            styles: {
              "vertical-align": "super"
            }
          }]
        }), t.commands.add(fC, new WA(t, fC));
      }
    }
    const bC = "superscript";
    class wC extends Nr {
      static get pluginName() {
        return "SuperscriptUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = YA({
            editor: t,
            commandName: bC,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"/></svg>',
            label: e("Superscript")
          });
        t.ui.componentFactory.add(bC, () => {
          const e = n(mm),
            i = t.commands.get(bC);
          return e.set({
            tooltip: !0
          }), e.bind("isOn").to(i, "value"), e;
        }), t.ui.componentFactory.add("menuBar:" + bC, () => n(Uk));
      }
    }
    const AC = "underline";
    class CC extends Nr {
      static get pluginName() {
        return "UnderlineEditing";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.model.schema.extend("$text", {
          allowAttributes: AC
        }), t.model.schema.setAttributeProperties(AC, {
          isFormatting: !0,
          copyOnEnter: !0
        }), t.conversion.attributeToElement({
          model: AC,
          view: "u",
          upcastAlso: {
            styles: {
              "text-decoration": "underline"
            }
          }
        }), t.commands.add(AC, new WA(t, AC)), t.keystrokes.set("CTRL+U", "underline"), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Underline text"),
            keystroke: "CTRL+U"
          }]
        });
      }
    }
    const _C = "underline";
    class vC extends Nr {
      static get pluginName() {
        return "UnderlineUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get(_C),
          n = t.locale.t,
          i = YA({
            editor: t,
            commandName: _C,
            plugin: this,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>',
            label: n("Underline"),
            keystroke: "CTRL+U"
          });
        t.ui.componentFactory.add(_C, () => {
          const t = i(mm);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(e, "value"), t;
        }), t.ui.componentFactory.add("menuBar:" + _C, () => i(Uk));
      }
    }
    const yC = ["left", "right", "center", "justify"];
    function xC(t) {
      return yC.includes(t);
    }
    function EC(t, e) {
      return "rtl" == e.contentLanguageDirection ? "right" === t : "left" === t;
    }
    function DC(t) {
      const e = t.map(t => {
          let e;
          return e = "string" == typeof t ? {
            name: t
          } : t, e;
        }).filter(t => {
          const e = yC.includes(t.name);
          return e || w("alignment-config-name-not-recognized", {
            option: t
          }), e;
        }),
        n = e.filter(t => Boolean(t.className)).length;
      if (n && n < e.length) throw new b("alignment-config-classnames-are-missing", {
        configuredOptions: t
      });
      return e.forEach((e, n, i) => {
        const o = i.slice(n + 1);
        if (o.some(t => t.name == e.name)) throw new b("alignment-config-name-already-defined", {
          option: e,
          configuredOptions: t
        });
        if (e.className) {
          if (o.some(t => t.className == e.className)) throw new b("alignment-config-classname-already-defined", {
            option: e,
            configuredOptions: t
          });
        }
      }), e;
    }
    const BC = "alignment";
    class SC extends Pr {
      refresh() {
        const t = this.editor.locale,
          e = $o(this.editor.model.document.selection.getSelectedBlocks());
        this.isEnabled = Boolean(e) && this._canBeAligned(e), this.isEnabled && e.hasAttribute("alignment") ? this.value = e.getAttribute("alignment") : this.value = "rtl" === t.contentLanguageDirection ? "right" : "left";
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor,
          n = e.locale,
          i = e.model,
          o = i.document,
          r = t.value;
        i.change(t => {
          const e = Array.from(o.selection.getSelectedBlocks()).filter(t => this._canBeAligned(t)),
            i = e[0].getAttribute("alignment");
          EC(r, n) || i === r || !r ? function (t, e) {
            for (const n of t) e.removeAttribute(BC, n);
          }(e, t) : function (t, e, n) {
            for (const i of t) e.setAttribute(BC, n, i);
          }(e, t, r);
        });
      }
      _canBeAligned(t) {
        return this.editor.model.schema.checkAttribute(t, BC);
      }
    }
    class TC extends Nr {
      static get pluginName() {
        return "AlignmentEditing";
      }
      constructor(t) {
        super(t), t.config.define("alignment", {
          options: yC.map(t => ({
            name: t
          }))
        });
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = t.model.schema,
          i = DC(t.config.get("alignment.options")).filter(t => xC(t.name) && !EC(t.name, e)),
          o = i.some(t => !!t.className);
        n.extend("$block", {
          allowAttributes: "alignment"
        }), t.model.schema.setAttributeProperties("alignment", {
          isFormatting: !0
        }), o ? t.conversion.attributeToAttribute(function (t) {
          const e = {};
          for (const n of t) e[n.name] = {
            key: "class",
            value: n.className
          };
          const n = {
            model: {
              key: "alignment",
              values: t.map(t => t.name)
            },
            view: e
          };
          return n;
        }(i)) : t.conversion.for("downcast").attributeToAttribute(function (t) {
          const e = {};
          for (const {
            name: n
          } of t) e[n] = {
            key: "style",
            value: {
              "text-align": n
            }
          };
          const n = {
            model: {
              key: "alignment",
              values: t.map(t => t.name)
            },
            view: e
          };
          return n;
        }(i));
        const r = function (t) {
          const e = [];
          for (const {
            name: n
          } of t) e.push({
            view: {
              key: "style",
              value: {
                "text-align": n
              }
            },
            model: {
              key: "alignment",
              value: n
            }
          });
          return e;
        }(i);
        for (const e of r) t.conversion.for("upcast").attributeToAttribute(e);
        const s = function (t) {
          const e = [];
          for (const {
            name: n
          } of t) e.push({
            view: {
              key: "align",
              value: n
            },
            model: {
              key: "alignment",
              value: n
            }
          });
          return e;
        }(i);
        for (const e of s) t.conversion.for("upcast").attributeToAttribute(e);
        t.commands.add("alignment", new SC(t));
      }
    }
    const IC = new Map([["left", Yh.alignLeft], ["right", Yh.alignRight], ["center", Yh.alignCenter], ["justify", Yh.alignJustify]]);
    class MC extends Nr {
      get localizedOptionTitles() {
        const t = this.editor.t;
        return {
          left: t("Align left"),
          right: t("Align right"),
          center: t("Align center"),
          justify: t("Justify")
        };
      }
      static get pluginName() {
        return "AlignmentUI";
      }
      init() {
        const t = DC(this.editor.config.get("alignment.options"));
        t.map(t => t.name).filter(xC).forEach(t => this._addButton(t)), this._addToolbarDropdown(t), this._addMenuBarMenu(t);
      }
      _addButton(t) {
        this.editor.ui.componentFactory.add(`alignment:${t}`, e => this._createButton(e, t));
      }
      _createButton(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const i = this.editor,
          o = i.commands.get("alignment"),
          r = new mm(t);
        return r.set({
          label: this.localizedOptionTitles[e],
          icon: IC.get(e),
          tooltip: !0,
          isToggleable: !0,
          ...n
        }), r.bind("isEnabled").to(o), r.bind("isOn").to(o, "value", t => t === e), this.listenTo(r, "execute", () => {
          i.execute("alignment", {
            value: e
          }), i.editing.view.focus();
        }), r;
      }
      _addToolbarDropdown(t) {
        const e = this.editor;
        e.ui.componentFactory.add("alignment", n => {
          const i = Eg(n),
            o = "rtl" === n.uiLanguageDirection ? "w" : "e",
            r = n.t;
          Dg(i, () => t.map(t => this._createButton(n, t.name, {
            tooltipPosition: o
          })), {
            enableActiveItemFocusOnDropdownOpen: !0,
            isVertical: !0,
            ariaLabel: r("Text alignment toolbar")
          }), i.buttonView.set({
            label: r("Text alignment"),
            tooltip: !0
          }), i.extendTemplate({
            attributes: {
              class: "ck-alignment-dropdown"
            }
          });
          const s = "rtl" === n.contentLanguageDirection ? IC.get("right") : IC.get("left"),
            a = e.commands.get("alignment");
          return i.buttonView.bind("icon").to(a, "value", t => IC.get(t) || s), i.bind("isEnabled").to(a, "isEnabled"), this.listenTo(i, "execute", () => {
            e.editing.view.focus();
          }), i;
        });
      }
      _addMenuBarMenu(t) {
        const e = this.editor;
        e.ui.componentFactory.add("menuBar:alignment", n => {
          const i = e.commands.get("alignment"),
            o = n.t,
            r = new Fk(n),
            s = new Ok(n);
          r.bind("isEnabled").to(i), s.set({
            ariaLabel: o("Text alignment"),
            role: "menu"
          }), r.buttonView.set({
            label: o("Text alignment")
          });
          for (const o of t) {
            const t = new fk(n, r),
              a = new Uk(n);
            a.extendTemplate({
              attributes: {
                "aria-checked": a.bindTemplate.to("isOn")
              }
            }), a.delegate("execute").to(r), a.set({
              label: this.localizedOptionTitles[o.name],
              icon: IC.get(o.name)
            }), a.on("execute", () => {
              e.execute("alignment", {
                value: o.name
              }), e.editing.view.focus();
            }), a.bind("isOn").to(i, "value", t => t === o.name), a.bind("isEnabled").to(i, "isEnabled"), t.children.add(a), s.items.add(t);
          }
          return r.panelView.children.add(s), r;
        });
      }
    }
    class LC extends Pr {
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.schema,
          i = e.document.selection,
          o = Array.from(i.getSelectedBlocks()),
          r = void 0 === t.forceValue ? !this.value : t.forceValue;
        e.change(t => {
          if (r) {
            const e = o.filter(t => NC(t) || PC(n, t));
            this._applyQuote(t, e);
          } else this._removeQuote(t, o.filter(NC));
        });
      }
      _getValue() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        return !(!t || !NC(t));
      }
      _checkEnabled() {
        if (this.value) return !0;
        const t = this.editor.model.document.selection,
          e = this.editor.model.schema,
          n = $o(t.getSelectedBlocks());
        return !!n && PC(e, n);
      }
      _removeQuote(t, e) {
        zC(t, e).reverse().forEach(e => {
          if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);
          if (e.start.isAtStart) {
            const n = t.createPositionBefore(e.start.parent);
            return void t.move(e, n);
          }
          e.end.isAtEnd || t.split(e.end);
          const n = t.createPositionAfter(e.end.parent);
          t.move(e, n);
        });
      }
      _applyQuote(t, e) {
        const n = [];
        zC(t, e).reverse().forEach(e => {
          let i = NC(e.start);
          i || (i = t.createElement("blockQuote"), t.wrap(e, i)), n.push(i);
        }), n.reverse().reduce((e, n) => e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n);
      }
    }
    function NC(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }
    function zC(t, e) {
      let n,
        i = 0;
      const o = [];
      for (; i < e.length;) {
        const r = e[i],
          s = e[i + 1];
        n || (n = t.createPositionBefore(r)), s && r.nextSibling == s || (o.push(t.createRange(n, t.createPositionAfter(r))), n = null), i++;
      }
      return o;
    }
    function PC(t, e) {
      const n = t.checkChild(e.parent, "blockQuote"),
        i = t.checkChild(["$root", "blockQuote"], e);
      return n && i;
    }
    class VC extends Nr {
      static get pluginName() {
        return "BlockQuoteEditing";
      }
      static get requires() {
        return [bw, Wb];
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        t.commands.add("blockQuote", new LC(t)), e.register("blockQuote", {
          inheritAllFrom: "$container"
        }), t.conversion.elementToElement({
          model: "blockQuote",
          view: "blockquote"
        }), t.model.document.registerPostFixer(n => {
          const i = t.model.document.differ.getChanges();
          for (const t of i) if ("insert" == t.type) {
            const i = t.position.nodeAfter;
            if (!i) continue;
            if (i.is("element", "blockQuote") && i.isEmpty) return n.remove(i), !0;
            if (i.is("element", "blockQuote") && !e.checkChild(t.position, i)) return n.unwrap(i), !0;
            if (i.is("element")) {
              const t = n.createRangeIn(i);
              for (const i of t.getItems()) if (i.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(i), i)) return n.unwrap(i), !0;
            }
          } else if ("remove" == t.type) {
            const e = t.position.parent;
            if (e.is("element", "blockQuote") && e.isEmpty) return n.remove(e), !0;
          }
          return !1;
        });
        const n = this.editor.editing.view.document,
          i = t.model.document.selection,
          o = t.commands.get("blockQuote");
        this.listenTo(n, "enter", (e, n) => {
          if (!i.isCollapsed || !o.value) return;
          i.getLastPosition().parent.isEmpty && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
        }, {
          context: "blockquote"
        }), this.listenTo(n, "delete", (e, n) => {
          if ("backward" != n.direction || !i.isCollapsed || !o.value) return;
          const r = i.getLastPosition().parent;
          r.isEmpty && !r.previousSibling && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
        }, {
          context: "blockquote"
        });
      }
    }
    var RC = o(1501),
      FC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(RC.A, FC);
    RC.A.locals;
    class OC extends Nr {
      static get pluginName() {
        return "BlockQuoteUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get("blockQuote");
        t.ui.componentFactory.add("blockQuote", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0
          }), t.bind("isOn").to(e, "value"), t;
        }), t.ui.componentFactory.add("menuBar:blockQuote", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("blockQuote"),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Block quote"),
          icon: Yh.quote,
          isToggleable: !0
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          e.execute("blockQuote"), e.editing.view.focus();
        }), o;
      }
    }
    function jC(t) {
      const e = t.t,
        n = t.config.get("codeBlock.languages");
      for (const t of n) "Plain text" === t.label && (t.label = e("Plain text")), void 0 === t.class && (t.class = `language-${t.language}`);
      return n;
    }
    function HC(t, e, n) {
      const i = {};
      for (const o of t) if ("class" === e) {
        i[o[e].split(" ").shift()] = o[n];
      } else i[o[e]] = o[n];
      return i;
    }
    function UC(t) {
      return t.data.match(/^(\s*)/)[0];
    }
    function qC(t) {
      const e = t.document.selection,
        n = [];
      if (e.isCollapsed) return [e.anchor];
      const i = e.getFirstRange().getWalker({
        ignoreElementEnd: !0,
        direction: "backward"
      });
      for (const {
        item: e
      } of i) {
        if (!e.is("$textProxy")) continue;
        const {
          parent: i,
          startOffset: o
        } = e.textNode;
        if (!i.is("element", "codeBlock")) continue;
        const r = UC(e.textNode),
          s = t.createPositionAt(i, o + r.length);
        n.push(s);
      }
      return n;
    }
    function GC(t) {
      const e = $o(t.getSelectedBlocks());
      return !!e && e.is("element", "codeBlock");
    }
    function WC(t, e) {
      return !e.is("rootElement") && !t.isLimit(e) && t.checkChild(e.parent, "codeBlock");
    }
    function $C(t, e, n, i) {
      const o = HC(e, "language", "label"),
        r = n.getAttribute("language");
      if (r in o) {
        const e = o[r];
        return t("enter" === i ? "Entering %0 code snippet" : "Leaving %0 code snippet", e);
      }
      return t("enter" === i ? "Entering code snippet" : "Leaving code snippet");
    }
    class KC extends Pr {
      constructor(t) {
        super(t), this._lastLanguage = null;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor,
          n = e.model,
          i = n.document.selection,
          o = jC(e)[0],
          r = Array.from(i.getSelectedBlocks()),
          s = null == t.forceValue ? !this.value : t.forceValue,
          a = function (t, e, n) {
            if (t.language) return t.language;
            if (t.usePreviousLanguageChoice && e) return e;
            return n;
          }(t, this._lastLanguage, o.language);
        n.change(t => {
          s ? this._applyCodeBlock(t, r, a) : this._removeCodeBlock(t, r);
        });
      }
      _getValue() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        return !!!(!t || !t.is("element", "codeBlock")) && t.getAttribute("language");
      }
      _checkEnabled() {
        if (this.value) return !0;
        const t = this.editor.model.document.selection,
          e = this.editor.model.schema,
          n = $o(t.getSelectedBlocks());
        return !!n && WC(e, n);
      }
      _applyCodeBlock(t, e, n) {
        this._lastLanguage = n;
        const i = this.editor.model.schema,
          o = e.filter(t => WC(i, t));
        for (const e of o) t.rename(e, "codeBlock"), t.setAttribute("language", n, e), i.removeDisallowedAttributes([e], t), Array.from(e.getChildren()).filter(t => !i.checkChild(e, t)).forEach(e => t.remove(e));
        o.reverse().forEach((e, n) => {
          const i = o[n + 1];
          e.previousSibling === i && (t.appendElement("softBreak", i), t.merge(t.createPositionBefore(e)));
        });
      }
      _removeCodeBlock(t, e) {
        const n = e.filter(t => t.is("element", "codeBlock"));
        for (const e of n) {
          const n = t.createRangeOn(e);
          for (const e of Array.from(n.getItems()).reverse()) if (e.is("element", "softBreak") && e.parent.is("element", "codeBlock")) {
            const {
                position: n
              } = t.split(t.createPositionBefore(e)),
              i = n.nodeAfter;
            t.rename(i, "paragraph"), t.removeAttribute("language", i), t.remove(e);
          }
          t.rename(e, "paragraph"), t.removeAttribute("language", e);
        }
      }
    }
    class YC extends Pr {
      constructor(t) {
        super(t), this._indentSequence = t.config.get("codeBlock.indentSequence");
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        const t = this.editor.model;
        t.change(e => {
          const n = qC(t);
          for (const i of n) {
            const n = e.createText(this._indentSequence);
            t.insertContent(n, i);
          }
        });
      }
      _checkEnabled() {
        return !!this._indentSequence && GC(this.editor.model.document.selection);
      }
    }
    class QC extends Pr {
      constructor(t) {
        super(t), this._indentSequence = t.config.get("codeBlock.indentSequence");
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        const t = this.editor.model;
        t.change(() => {
          const e = qC(t);
          for (const n of e) {
            const e = ZC(t, n, this._indentSequence);
            e && t.deleteContent(t.createSelection(e));
          }
        });
      }
      _checkEnabled() {
        if (!this._indentSequence) return !1;
        const t = this.editor.model;
        return !!GC(t.document.selection) && qC(t).some(e => ZC(t, e, this._indentSequence));
      }
    }
    function ZC(t, e, n) {
      const i = function (t) {
        let e = t.parent.getChild(t.index);
        e && !e.is("element", "softBreak") || (e = t.nodeBefore);
        if (!e || e.is("element", "softBreak")) return null;
        return e;
      }(e);
      if (!i) return null;
      const o = UC(i),
        r = o.lastIndexOf(n);
      if (r + n.length !== o.length) return null;
      if (-1 === r) return null;
      const {
        parent: s,
        startOffset: a
      } = i;
      return t.createRange(t.createPositionAt(s, a + r), t.createPositionAt(s, a + r + n.length));
    }
    function JC(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      const i = HC(e, "language", "class"),
        o = HC(e, "language", "label");
      return (e, r, s) => {
        const {
          writer: a,
          mapper: l,
          consumable: c
        } = s;
        if (!c.consume(r.item, "insert")) return;
        const d = r.item.getAttribute("language"),
          u = l.toViewPosition(t.createPositionBefore(r.item)),
          h = {};
        n && (h["data-language"] = o[d], h.spellcheck = "false");
        const m = i[d] ? {
            class: i[d]
          } : void 0,
          g = a.createContainerElement("code", m),
          p = a.createContainerElement("pre", h, g);
        a.insert(u, p), l.bindElements(r.item, g);
      };
    }
    const XC = "paragraph";
    class t_ extends Nr {
      static get pluginName() {
        return "CodeBlockEditing";
      }
      static get requires() {
        return [_w];
      }
      constructor(t) {
        super(t), t.config.define("codeBlock", {
          languages: [{
            language: "plaintext",
            label: "Plain text"
          }, {
            language: "c",
            label: "C"
          }, {
            language: "cs",
            label: "C#"
          }, {
            language: "cpp",
            label: "C++"
          }, {
            language: "css",
            label: "CSS"
          }, {
            language: "diff",
            label: "Diff"
          }, {
            language: "html",
            label: "HTML"
          }, {
            language: "java",
            label: "Java"
          }, {
            language: "javascript",
            label: "JavaScript"
          }, {
            language: "php",
            label: "PHP"
          }, {
            language: "python",
            label: "Python"
          }, {
            language: "ruby",
            label: "Ruby"
          }, {
            language: "typescript",
            label: "TypeScript"
          }, {
            language: "xml",
            label: "XML"
          }],
          indentSequence: "\t"
        });
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.model,
          i = t.editing.view,
          o = t.plugins.has("ListEditing") ? t.plugins.get("ListEditing") : null,
          r = jC(t);
        t.commands.add("codeBlock", new KC(t)), t.commands.add("indentCodeBlock", new YC(t)), t.commands.add("outdentCodeBlock", new QC(t)), this.listenTo(i.document, "tab", (e, n) => {
          const i = n.shiftKey ? "outdentCodeBlock" : "indentCodeBlock";
          t.commands.get(i).isEnabled && (t.execute(i), n.stopPropagation(), n.preventDefault(), e.stop());
        }, {
          context: "pre"
        }), e.register("codeBlock", {
          allowWhere: "$block",
          allowChildren: "$text",
          isBlock: !0,
          allowAttributes: ["language"]
        }), e.addAttributeCheck((t, e) => !!(t.endsWith("codeBlock") && o && o.getListAttributeNames().includes(e)) || !t.endsWith("codeBlock $text") && void 0), t.model.schema.addChildCheck((t, e) => {
          if (t.endsWith("codeBlock") && e.isObject) return !1;
        }), t.editing.downcastDispatcher.on("insert:codeBlock", JC(n, r, !0)), t.data.downcastDispatcher.on("insert:codeBlock", JC(n, r)), t.data.downcastDispatcher.on("insert:softBreak", function (t) {
          return (e, n, i) => {
            if ("codeBlock" !== n.item.parent.name) return;
            const {
              writer: o,
              mapper: r,
              consumable: s
            } = i;
            if (!s.consume(n.item, "insert")) return;
            const a = r.toViewPosition(t.createPositionBefore(n.item));
            o.insert(a, o.createText("\n"));
          };
        }(n), {
          priority: "high"
        }), t.data.upcastDispatcher.on("element:code", function (t, e) {
          const n = HC(e, "class", "language"),
            i = e[0].language;
          return (t, e, o) => {
            const r = e.viewItem,
              s = r.parent;
            if (!s || !s.is("element", "pre")) return;
            if (e.modelCursor.findAncestor("codeBlock")) return;
            const {
              consumable: a,
              writer: l
            } = o;
            if (!a.test(r, {
              name: !0
            })) return;
            const c = l.createElement("codeBlock"),
              d = [...r.getClassNames()];
            d.length || d.push("");
            for (const t of d) {
              const e = n[t];
              if (e) {
                l.setAttribute("language", e, c);
                break;
              }
            }
            c.hasAttribute("language") || l.setAttribute("language", i, c), o.convertChildren(r, c), o.safeInsert(c, e.modelCursor) && (a.consume(r, {
              name: !0
            }), o.updateConversionResult(c, e));
          };
        }(0, r)), t.data.upcastDispatcher.on("text", (t, e, _ref89) => {
          let {
            consumable: n,
            writer: i
          } = _ref89;
          let o = e.modelCursor;
          if (!n.test(e.viewItem)) return;
          if (!o.findAncestor("codeBlock")) return;
          n.consume(e.viewItem);
          const r = e.viewItem.data.split("\n").map(t => i.createText(t)),
            s = r[r.length - 1];
          for (const t of r) if (i.insert(t, o), o = o.getShiftedBy(t.offsetSize), t !== s) {
            const t = i.createElement("softBreak");
            i.insert(t, o), o = i.createPositionAfter(t);
          }
          e.modelRange = i.createRange(e.modelCursor, o), e.modelCursor = o;
        }), t.data.upcastDispatcher.on("element:pre", (t, e, _ref90) => {
          let {
            consumable: n
          } = _ref90;
          const i = e.viewItem;
          if (i.findAncestor("pre")) return;
          const o = Array.from(i.getChildren()),
            r = o.find(t => t.is("element", "code"));
          if (r) for (const t of o) t !== r && t.is("$text") && n.consume(t, {
            name: !0
          });
        }, {
          priority: "high"
        }), this.listenTo(t.editing.view.document, "clipboardInput", (e, i) => {
          let o = n.createRange(n.document.selection.anchor);
          if (i.targetRanges && (o = t.editing.mapper.toModelRange(i.targetRanges[0])), !o.start.parent.is("element", "codeBlock")) return;
          const r = i.dataTransfer.getData("text/plain"),
            s = new th(t.editing.view.document);
          i.content = function (t, e) {
            const n = t.createDocumentFragment(),
              i = e.split("\n"),
              o = i.reduce((e, n, o) => (e.push(n), o < i.length - 1 && e.push(t.createElement("br")), e), []);
            return t.appendChild(o, n), n;
          }(s, r);
        }), this.listenTo(n, "getSelectedContent", (t, _ref91) => {
          let [i] = _ref91;
          const o = i.anchor;
          !i.isCollapsed && o.parent.is("element", "codeBlock") && o.hasSameParentAs(i.focus) && n.change(n => {
            const r = t.return;
            if (o.parent.is("element") && (r.childCount > 1 || i.containsEntireContent(o.parent))) {
              const e = n.createElement("codeBlock", o.parent.getAttributes());
              n.append(r, e);
              const i = n.createDocumentFragment();
              return n.append(e, i), void (t.return = i);
            }
            const s = r.getChild(0);
            e.checkAttribute(s, "code") && n.setAttribute("code", !0, s);
          });
        });
      }
      afterInit() {
        const t = this.editor,
          e = t.commands,
          n = e.get("indent"),
          i = e.get("outdent");
        n && n.registerChildCommand(e.get("indentCodeBlock"), {
          priority: "highest"
        }), i && i.registerChildCommand(e.get("outdentCodeBlock")), this.listenTo(t.editing.view.document, "enter", (e, n) => {
          t.model.document.selection.getLastPosition().parent.is("element", "codeBlock") && (function (t, e) {
            const n = t.model,
              i = n.document,
              o = t.editing.view,
              r = i.selection.getLastPosition(),
              s = r.nodeAfter;
            if (e || !i.selection.isCollapsed || !r.isAtStart) return !1;
            if (!n_(s)) return !1;
            return t.model.change(e => {
              t.execute("enter");
              const n = i.selection.anchor.parent.previousSibling;
              e.rename(n, XC), e.setSelection(n, "in"), t.model.schema.removeDisallowedAttributes([n], e), e.remove(s);
            }), o.scrollToTheSelection(), !0;
          }(t, n.isSoft) || function (t, e) {
            const n = t.model,
              i = n.document,
              o = t.editing.view,
              r = i.selection.getLastPosition(),
              s = r.nodeBefore;
            let a;
            if (e || !i.selection.isCollapsed || !r.isAtEnd || !s || !s.previousSibling) return !1;
            if (n_(s) && n_(s.previousSibling)) a = n.createRange(n.createPositionBefore(s.previousSibling), n.createPositionAfter(s));else if (e_(s) && n_(s.previousSibling) && n_(s.previousSibling.previousSibling)) a = n.createRange(n.createPositionBefore(s.previousSibling.previousSibling), n.createPositionAfter(s));else {
              if (!(e_(s) && n_(s.previousSibling) && e_(s.previousSibling.previousSibling) && s.previousSibling.previousSibling && n_(s.previousSibling.previousSibling.previousSibling))) return !1;
              a = n.createRange(n.createPositionBefore(s.previousSibling.previousSibling.previousSibling), n.createPositionAfter(s));
            }
            return t.model.change(e => {
              e.remove(a), t.execute("enter");
              const n = i.selection.anchor.parent;
              e.rename(n, XC), t.model.schema.removeDisallowedAttributes([n], e);
            }), o.scrollToTheSelection(), !0;
          }(t, n.isSoft) || function (t) {
            const e = t.model,
              n = e.document,
              i = n.selection.getLastPosition(),
              o = i.nodeBefore || i.textNode;
            let r;
            o && o.is("$text") && (r = UC(o));
            t.model.change(e => {
              t.execute("shiftEnter"), r && e.insertText(r, n.selection.anchor);
            });
          }(t), n.preventDefault(), e.stop());
        }, {
          context: "pre"
        }), this._initAriaAnnouncements();
      }
      _initAriaAnnouncements() {
        const {
            model: t,
            ui: e,
            t: n
          } = this.editor,
          i = jC(this.editor);
        let o = null;
        t.document.selection.on("change:range", () => {
          const r = t.document.selection.focus.parent;
          e && o !== r && r.is("element") && (o && o.is("element", "codeBlock") && e.ariaLiveAnnouncer.announce($C(n, i, o, "leave")), r.is("element", "codeBlock") && e.ariaLiveAnnouncer.announce($C(n, i, r, "enter")), o = r);
        });
      }
    }
    function e_(t) {
      return t && t.is("$text") && !t.data.match(/\S/);
    }
    function n_(t) {
      return t && t.is("element", "softBreak");
    }
    var i_ = o(2291),
      o_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(i_.A, o_);
    i_.A.locals;
    class r_ extends Nr {
      static get pluginName() {
        return "CodeBlockUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = t.ui.componentFactory,
          i = jC(t),
          o = this._getLanguageListItemDefinitions(i),
          r = t.commands.get("codeBlock");
        n.add("codeBlock", n => {
          const i = Eg(n, Cg),
            s = i.buttonView,
            a = e("Insert code block");
          return s.set({
            label: a,
            tooltip: !0,
            icon: Yh.codeBlock,
            isToggleable: !0
          }), s.bind("isOn").to(r, "value", t => !!t), s.on("execute", () => {
            t.execute("codeBlock", {
              usePreviousLanguageChoice: !0
            }), t.editing.view.focus();
          }), i.on("execute", e => {
            t.execute("codeBlock", {
              language: e.source._codeBlockLanguage,
              forceValue: !0
            }), t.editing.view.focus();
          }), i.class = "ck-code-block-dropdown", i.bind("isEnabled").to(r), Sg(i, o, {
            role: "menu",
            ariaLabel: a
          }), i;
        }), n.add("menuBar:codeBlock", n => {
          const i = new Fk(n);
          i.buttonView.set({
            label: e("Code block"),
            icon: Yh.codeBlock
          }), i.bind("isEnabled").to(r);
          const s = new Ok(n);
          s.set({
            ariaLabel: e("Insert code block")
          });
          for (const e of o) {
            const o = new fk(n, i),
              a = new Uk(n);
            a.bind(...Object.keys(e.model)).to(e.model), a.bind("ariaChecked").to(a, "isOn"), a.delegate("execute").to(i), a.on("execute", () => {
              t.execute("codeBlock", {
                language: e.model._codeBlockLanguage,
                forceValue: r.value != e.model._codeBlockLanguage
              }), t.editing.view.focus();
            }), o.children.add(a), s.items.add(o);
          }
          return i.panelView.children.add(s), i;
        });
      }
      _getLanguageListItemDefinitions(t) {
        const e = this.editor.commands.get("codeBlock"),
          n = new Wo();
        for (const i of t) {
          const t = {
            type: "button",
            model: new Mf({
              _codeBlockLanguage: i.language,
              label: i.label,
              role: "menuitemradio",
              withText: !0
            })
          };
          t.model.bind("isOn").to(e, "value", e => e === t.model._codeBlockLanguage), n.add(t);
        }
        return n;
      }
    }
    const s_ = {
        autoRefresh: !0
      },
      a_ = 36e5;
    class l_ extends q() {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (super(), !t) throw new b("token-missing-token-url", this);
        e.initValue && this._validateTokenValue(e.initValue), this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : () => {
          return e = t, new Promise((t, n) => {
            const i = new XMLHttpRequest();
            i.open("GET", e), i.addEventListener("load", () => {
              const e = i.status,
                o = i.response;
              return e < 200 || e > 299 ? n(new b("token-cannot-download-new-token", null)) : t(o);
            }), i.addEventListener("error", () => n(new Error("Network Error"))), i.addEventListener("abort", () => n(new Error("Abort"))), i.send();
          });
          var e;
        }, this._options = {
          ...s_,
          ...e
        };
      }
      init() {
        return new Promise((t, e) => {
          this.value ? (this._options.autoRefresh && this._registerRefreshTokenTimeout(), t(this)) : this.refreshToken().then(t).catch(e);
        });
      }
      refreshToken() {
        return this._refresh().then(t => (this._validateTokenValue(t), this.set("value", t), this._options.autoRefresh && this._registerRefreshTokenTimeout(), this));
      }
      destroy() {
        clearTimeout(this._tokenRefreshTimeout);
      }
      _validateTokenValue(t) {
        const e = "string" == typeof t,
          n = !/^".*"$/.test(t),
          i = e && 3 === t.split(".").length;
        if (!n || !i) throw new b("token-not-in-jwt-format", this);
      }
      _registerRefreshTokenTimeout() {
        const t = this._getTokenRefreshTimeoutTime();
        clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(() => {
          this.refreshToken();
        }, t);
      }
      _getTokenRefreshTimeoutTime() {
        try {
          const [, t] = this.value.split("."),
            {
              exp: e
            } = JSON.parse(atob(t));
          if (!e) return a_;
          return Math.floor((1e3 * e - Date.now()) / 2);
        } catch (t) {
          return a_;
        }
      }
      static create(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new l_(t, e).init();
      }
    }
    const c_ = /^data:(\S*?);base64,/;
    class d_ extends B() {
      constructor(t, e, n) {
        if (super(), !t) throw new b("fileuploader-missing-file", null);
        if (!e) throw new b("fileuploader-missing-token", null);
        if (!n) throw new b("fileuploader-missing-api-address", null);
        this.file = function (t) {
          if ("string" != typeof t) return !1;
          const e = t.match(c_);
          return !(!e || !e.length);
        }(t) ? function (t) {
          let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;
          try {
            const n = t.match(c_)[1],
              i = atob(t.replace(c_, "")),
              o = [];
            for (let t = 0; t < i.length; t += e) {
              const n = i.slice(t, t + e),
                r = new Array(n.length);
              for (let t = 0; t < n.length; t++) r[t] = n.charCodeAt(t);
              o.push(new Uint8Array(r));
            }
            return new Blob(o, {
              type: n
            });
          } catch (t) {
            throw new b("fileuploader-decoding-image-data-error", null);
          }
        }(t) : t, this._token = e, this._apiAddress = n;
      }
      onProgress(t) {
        return this.on("progress", (e, n) => t(n)), this;
      }
      onError(t) {
        return this.once("error", (e, n) => t(n)), this;
      }
      abort() {
        this.xhr.abort();
      }
      send() {
        return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
      }
      _prepareRequest() {
        const t = new XMLHttpRequest();
        t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
      }
      _attachXHRListeners() {
        const t = this.xhr,
          e = t => () => this.fire("error", t);
        t.addEventListener("error", e("Network Error")), t.addEventListener("abort", e("Abort")), t.upload && t.upload.addEventListener("progress", t => {
          t.lengthComputable && this.fire("progress", {
            total: t.total,
            uploaded: t.loaded
          });
        }), t.addEventListener("load", () => {
          const e = t.status,
            n = t.response;
          if (e < 200 || e > 299) return this.fire("error", n.message || n.error);
        });
      }
      _sendRequest() {
        const t = new FormData(),
          e = this.xhr;
        return t.append("file", this.file), new Promise((n, i) => {
          e.addEventListener("load", () => {
            const t = e.status,
              o = e.response;
            return t < 200 || t > 299 ? o.message ? i(new b("fileuploader-uploading-data-failed", this, {
              message: o.message
            })) : i(o.error) : n(o);
          }), e.addEventListener("error", () => i(new Error("Network Error"))), e.addEventListener("abort", () => i(new Error("Abort"))), e.send(t);
        });
      }
    }
    class u_ {
      constructor(t, e) {
        if (!t) throw new b("uploadgateway-missing-token", null);
        if (!e) throw new b("uploadgateway-missing-api-address", null);
        this._token = t, this._apiAddress = e;
      }
      upload(t) {
        return new d_(t, this._token, this._apiAddress);
      }
    }
    class h_ extends jr {
      static get pluginName() {
        return "CloudServicesCore";
      }
      createToken(t, e) {
        return new l_(t, e);
      }
      createUploadGateway(t, e) {
        return new u_(t, e);
      }
    }
    var m_ = o(871),
      g_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(m_.A, g_);
    m_.A.locals;
    var p_ = o(9388),
      f_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(p_.A, f_);
    p_.A.locals;
    class k_ extends Sr {
      constructor(t) {
        super(t);
        const e = t.t;
        this.children = this.createCollection(), this.set("matchCount", 0), this.set("highlightOffset", 0), this.set("isDirty", !1), this.set("_areCommandsEnabled", {}), this.set("_resultsCounterText", ""), this.set("_matchCase", !1), this.set("_wholeWordsOnly", !1), this.bind("_searchResultsFound").to(this, "matchCount", this, "isDirty", (t, e) => t > 0 && !e), this._findInputView = this._createInputField(e("Find in text…")), this._findPrevButtonView = this._createButton({
          label: e("Previous result"),
          class: "ck-button-prev",
          icon: Yh.previousArrow,
          keystroke: "Shift+F3",
          tooltip: !0
        }), this._findNextButtonView = this._createButton({
          label: e("Next result"),
          class: "ck-button-next",
          icon: Yh.previousArrow,
          keystroke: "F3",
          tooltip: !0
        }), this._replaceInputView = this._createInputField(e("Replace with…"), "ck-labeled-field-replace"), this._inputsDivView = this._createInputsDiv(), this._matchCaseSwitchView = this._createMatchCaseSwitch(), this._wholeWordsOnlySwitchView = this._createWholeWordsOnlySwitch(), this._advancedOptionsCollapsibleView = this._createAdvancedOptionsCollapsible(), this._replaceAllButtonView = this._createButton({
          label: e("Replace all"),
          class: "ck-button-replaceall",
          withText: !0
        }), this._replaceButtonView = this._createButton({
          label: e("Replace"),
          class: "ck-button-replace",
          withText: !0
        }), this._findButtonView = this._createButton({
          label: e("Find"),
          class: "ck-button-find ck-button-action",
          withText: !0
        }), this._actionButtonsDivView = this._createActionButtonsDiv(), this._focusTracker = new Ko(), this._keystrokes = new Yo(), this._focusables = new nr(), this.focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this._focusTracker,
          keystrokeHandler: this._keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.children.addMany([this._inputsDivView, this._advancedOptionsCollapsibleView, this._actionButtonsDivView]), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-find-and-replace-form"],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), Mr({
          view: this
        }), this._initFocusCycling(), this._initKeystrokeHandling();
      }
      destroy() {
        super.destroy(), this._focusTracker.destroy(), this._keystrokes.destroy();
      }
      focus(t) {
        -1 === t ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      reset() {
        this._findInputView.errorText = null, this.isDirty = !0;
      }
      get _textToFind() {
        return this._findInputView.fieldView.element.value;
      }
      get _textToReplace() {
        return this._replaceInputView.fieldView.element.value;
      }
      _createInputsDiv() {
        const t = this.locale,
          e = t.t,
          n = new Sr(t);
        return this._findInputView.fieldView.on("input", () => {
          this.isDirty = !0;
        }), this._findPrevButtonView.delegate("execute").to(this, "findPrevious"), this._findNextButtonView.delegate("execute").to(this, "findNext"), this._findPrevButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", _ref92 => {
          let {
            findPrevious: t
          } = _ref92;
          return t;
        }), this._findNextButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", _ref93 => {
          let {
            findNext: t
          } = _ref93;
          return t;
        }), this._injectFindResultsCounter(), this._replaceInputView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", (_ref94, e) => {
          let {
            replace: t
          } = _ref94;
          return t && e;
        }), this._replaceInputView.bind("infoText").to(this._replaceInputView, "isEnabled", this._replaceInputView, "isFocused", (t, n) => t || !n ? "" : e("Tip: Find some text first in order to replace it.")), n.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-find-and-replace-form__inputs"]
          },
          children: [this._findInputView, this._findPrevButtonView, this._findNextButtonView, this._replaceInputView]
        }), n;
      }
      _onFindButtonExecute() {
        if (!this._textToFind) {
          const t = this.t;
          return void (this._findInputView.errorText = t("Text to find must not be empty."));
        }
        this.isDirty = !1, this.fire("findNext", {
          searchText: this._textToFind,
          matchCase: this._matchCase,
          wholeWords: this._wholeWordsOnly
        });
      }
      _injectFindResultsCounter() {
        const t = this.locale,
          e = t.t,
          n = this.bindTemplate,
          i = new Sr(this.locale);
        this.bind("_resultsCounterText").to(this, "highlightOffset", this, "matchCount", (t, n) => e("%0 of %1", [t, n])), i.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-results-counter", n.if("isDirty", "ck-hidden")]
          },
          children: [{
            text: n.to("_resultsCounterText")
          }]
        });
        const o = () => {
          const e = this._findInputView.fieldView.element;
          if (!e || !Qi(e)) return;
          const n = new Pi(i.element).width,
            o = "ltr" === t.uiLanguageDirection ? "paddingRight" : "paddingLeft";
          e.style[o] = n ? `calc( 2 * var(--ck-spacing-standard) + ${n}px )` : "";
        };
        this.on("change:_resultsCounterText", o, {
          priority: "low"
        }), this.on("change:isDirty", o, {
          priority: "low"
        }), this._findInputView.template.children[0].children.push(i);
      }
      _createAdvancedOptionsCollapsible() {
        const t = this.locale.t,
          e = new _m(this.locale, [this._matchCaseSwitchView, this._wholeWordsOnlySwitchView]);
        return e.set({
          label: t("Advanced options"),
          isCollapsed: !0
        }), e;
      }
      _createActionButtonsDiv() {
        const t = new Sr(this.locale);
        return this._replaceButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", (_ref95, e) => {
          let {
            replace: t
          } = _ref95;
          return t && e;
        }), this._replaceAllButtonView.bind("isEnabled").to(this, "_areCommandsEnabled", this, "_searchResultsFound", (_ref96, e) => {
          let {
            replaceAll: t
          } = _ref96;
          return t && e;
        }), this._replaceButtonView.on("execute", () => {
          this.fire("replace", {
            searchText: this._textToFind,
            replaceText: this._textToReplace
          });
        }), this._replaceAllButtonView.on("execute", () => {
          this.fire("replaceAll", {
            searchText: this._textToFind,
            replaceText: this._textToReplace
          }), this.focus();
        }), this._findButtonView.on("execute", this._onFindButtonExecute.bind(this)), t.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-find-and-replace-form__actions"]
          },
          children: [this._replaceAllButtonView, this._replaceButtonView, this._findButtonView]
        }), t;
      }
      _createMatchCaseSwitch() {
        const t = this.locale.t,
          e = new fm(this.locale);
        return e.set({
          label: t("Match case"),
          withText: !0
        }), e.bind("isOn").to(this, "_matchCase"), e.on("execute", () => {
          this._matchCase = !this._matchCase, this.isDirty = !0;
        }), e;
      }
      _createWholeWordsOnlySwitch() {
        const t = this.locale.t,
          e = new fm(this.locale);
        return e.set({
          label: t("Whole words only"),
          withText: !0
        }), e.bind("isOn").to(this, "_wholeWordsOnly"), e.on("execute", () => {
          this._wholeWordsOnly = !this._wholeWordsOnly, this.isDirty = !0;
        }), e;
      }
      _initFocusCycling() {
        [this._findInputView, this._findPrevButtonView, this._findNextButtonView, this._replaceInputView, this._advancedOptionsCollapsibleView.buttonView, this._matchCaseSwitchView, this._wholeWordsOnlySwitchView, this._replaceAllButtonView, this._replaceButtonView, this._findButtonView].forEach(t => {
          this._focusables.add(t), this._focusTracker.add(t.element);
        });
      }
      _initKeystrokeHandling() {
        const t = t => t.stopPropagation(),
          e = t => {
            t.stopPropagation(), t.preventDefault();
          };
        this._keystrokes.listenTo(this.element), this._keystrokes.set("f3", t => {
          e(t), this._findNextButtonView.fire("execute");
        }), this._keystrokes.set("shift+f3", t => {
          e(t), this._findPrevButtonView.fire("execute");
        }), this._keystrokes.set("enter", t => {
          const n = t.target;
          n === this._findInputView.fieldView.element ? (this._areCommandsEnabled.findNext ? this._findNextButtonView.fire("execute") : this._findButtonView.fire("execute"), e(t)) : n !== this._replaceInputView.fieldView.element || this.isDirty || (this._replaceButtonView.fire("execute"), e(t));
        }), this._keystrokes.set("shift+enter", t => {
          t.target === this._findInputView.fieldView.element && (this._areCommandsEnabled.findPrevious ? this._findPrevButtonView.fire("execute") : this._findButtonView.fire("execute"), e(t));
        }), this._keystrokes.set("arrowright", t), this._keystrokes.set("arrowleft", t), this._keystrokes.set("arrowup", t), this._keystrokes.set("arrowdown", t);
      }
      _createButton(t) {
        const e = new mm(this.locale);
        return e.set(t), e;
      }
      _createInputField(t, e) {
        const n = new Fm(this.locale, Lg);
        return n.label = t, n.class = e, n;
      }
    }
    const b_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.87 13.786 1.532-1.286 3.857 4.596a1 1 0 1 1-1.532 1.286l-3.857-4.596z"/><path d="M16.004 8.5a6.5 6.5 0 0 1-9.216 5.905c-1.154-.53-.863-1.415-.663-1.615.194-.194.564-.592 1.635-.141a4.5 4.5 0 0 0 5.89-5.904l-.104-.227 1.332-1.331c.045-.046.196-.041.224.007a6.47 6.47 0 0 1 .902 3.306zm-3.4-5.715c.562.305.742 1.106.354 1.494-.388.388-.995.414-1.476.178a4.5 4.5 0 0 0-6.086 5.882l.114.236-1.348 1.349c-.038.037-.17.022-.198-.023a6.5 6.5 0 0 1 5.54-9.9 6.469 6.469 0 0 1 3.1.784z"/><path d="M4.001 11.93.948 8.877a.2.2 0 0 1 .141-.341h6.106a.2.2 0 0 1 .141.341L4.283 11.93a.2.2 0 0 1-.282 0zm11.083-6.789 3.053 3.053a.2.2 0 0 1-.14.342H11.89a.2.2 0 0 1-.14-.342l3.052-3.053a.2.2 0 0 1 .282 0z"/></svg>';
    class w_ extends Nr {
      static get requires() {
        return [Kp];
      }
      static get pluginName() {
        return "FindAndReplaceUI";
      }
      constructor(t) {
        super(t), t.config.define("findAndReplace.uiType", "dialog"), this.formView = null;
      }
      init() {
        const t = this.editor,
          e = "dropdown" === t.config.get("findAndReplace.uiType"),
          n = t.commands.get("find"),
          i = this.editor.t;
        t.ui.componentFactory.add("findAndReplace", () => {
          let i;
          return e ? (i = this._createDropdown(), i.bind("isEnabled").to(n)) : i = this._createDialogButtonForToolbar(), t.keystrokes.set("Ctrl+F", (e, o) => {
            if (n.isEnabled) {
              if (i instanceof Jm) {
                const t = i.buttonView;
                t.isOn || t.fire("execute");
              } else i.isOn ? t.plugins.get("Dialog").view.focus() : i.fire("execute");
              o();
            }
          }), i;
        }), e || t.ui.componentFactory.add("menuBar:findAndReplace", () => this._createDialogButtonForMenuBar()), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: i("Find in the document"),
            keystroke: "CTRL+F"
          }]
        });
      }
      _createDropdown() {
        const t = this.editor,
          e = t.locale.t,
          n = Eg(t.locale);
        return n.once("change:isOpen", () => {
          this.formView = this._createFormView(), this.formView.children.add(new Ip(t.locale, {
            label: e("Find and replace")
          }), 0), n.panelView.children.add(this.formView);
        }), n.on("change:isOpen", (t, e, n) => {
          n ? this._setupFormView() : this.fire("searchReseted");
        }, {
          priority: "low"
        }), n.buttonView.set({
          icon: b_,
          label: e("Find and replace"),
          keystroke: "CTRL+F",
          tooltip: !0
        }), n;
      }
      _createDialogButtonForToolbar() {
        const t = this.editor,
          e = this._createButton(mm),
          n = t.plugins.get("Dialog");
        return e.set({
          tooltip: !0
        }), e.bind("isOn").to(n, "id", t => "findAndReplace" === t), e.on("execute", () => {
          e.isOn ? n.hide() : this._showDialog();
        }), e;
      }
      _createDialogButtonForMenuBar() {
        const t = this._createButton(Uk),
          e = this.editor.plugins.get("Dialog");
        return t.on("execute", () => {
          "findAndReplace" !== e.id ? this._showDialog() : e.hide();
        }), t;
      }
      _createButton(t) {
        const e = this.editor,
          n = e.commands.get("find"),
          i = new t(e.locale),
          o = e.locale.t;
        return i.bind("isEnabled").to(n), i.set({
          icon: b_,
          label: o("Find and replace"),
          keystroke: "CTRL+F"
        }), i;
      }
      _showDialog() {
        const t = this.editor,
          e = t.plugins.get("Dialog"),
          n = t.locale.t;
        this.formView || (this.formView = this._createFormView()), e.show({
          id: "findAndReplace",
          title: n("Find and replace"),
          content: this.formView,
          position: Op,
          onShow: () => {
            this._setupFormView();
          },
          onHide: () => {
            this.fire("searchReseted");
          }
        });
      }
      _createFormView() {
        const t = this.editor,
          e = new (Ir(k_))(t.locale),
          n = t.commands,
          i = this.editor.plugins.get("FindAndReplaceEditing").state;
        e.bind("highlightOffset").to(i, "highlightedOffset"), e.listenTo(i.results, "change", () => {
          e.matchCount = i.results.length;
        });
        const o = n.get("findNext"),
          r = n.get("findPrevious"),
          s = n.get("replace"),
          a = n.get("replaceAll");
        return e.bind("_areCommandsEnabled").to(o, "isEnabled", r, "isEnabled", s, "isEnabled", a, "isEnabled", (t, e, n, i) => ({
          findNext: t,
          findPrevious: e,
          replace: n,
          replaceAll: i
        })), e.delegate("findNext", "findPrevious", "replace", "replaceAll").to(this), e.on("change:isDirty", (t, e, n) => {
          n && this.fire("searchReseted");
        }), e;
      }
      _setupFormView() {
        this.formView.disableCssTransitions(), this.formView.reset(), this.formView._findInputView.fieldView.select(), this.formView.enableCssTransitions();
      }
    }
    class A_ extends Pr {
      constructor(t, e) {
        super(t), this.isEnabled = !0, this.affectsData = !1, this._state = e;
      }
      execute(t) {
        let {
          matchCase: e,
          wholeWords: n
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
            editor: i
          } = this,
          {
            model: o
          } = i,
          r = i.plugins.get("FindAndReplaceUtils");
        let s;
        "string" == typeof t ? (s = r.findByTextCallback(t, {
          matchCase: e,
          wholeWords: n
        }), this._state.searchText = t) : s = t;
        const a = o.document.getRootNames().reduce((t, e) => r.updateFindResultFromRange(o.createRangeIn(o.document.getRoot(e)), o, s, t), null);
        return this._state.clear(o), this._state.results.addMany(a), this._state.highlightedResult = a.get(0), "string" == typeof t && (this._state.searchText = t), s && (this._state.lastSearchCallback = s), this._state.matchCase = !!e, this._state.matchWholeWords = !!n, {
          results: a,
          findCallback: s
        };
      }
    }
    class C_ extends Pr {
      constructor(t, e) {
        super(t), this.isEnabled = !0, this._state = e, this._isEnabledBasedOnSelection = !1;
      }
      _replace(t, e) {
        const {
            model: n
          } = this.editor,
          i = e.marker.getRange();
        n.canEditAt(i) && n.change(o => {
          if ("$graveyard" === i.root.rootName) return void this._state.results.remove(e);
          let r = {};
          for (const t of i.getItems()) if (t.is("$text") || t.is("$textProxy")) {
            r = t.getAttributes();
            break;
          }
          n.insertContent(o.createText(t, r), i), this._state.results.has(e) && this._state.results.remove(e);
        });
      }
    }
    class __ extends C_ {
      execute(t, e) {
        this._replace(t, e);
      }
    }
    class v_ extends C_ {
      execute(t, e) {
        const {
            editor: n
          } = this,
          {
            model: i
          } = n,
          o = n.plugins.get("FindAndReplaceUtils"),
          r = e instanceof Wo ? e : i.document.getRootNames().reduce((t, n) => o.updateFindResultFromRange(i.createRangeIn(i.document.getRoot(n)), i, o.findByTextCallback(e, this._state), t), null);
        r.length && i.change(() => {
          [...r].forEach(e => {
            this._replace(t, e);
          });
        });
      }
    }
    class y_ extends Pr {
      constructor(t, e) {
        super(t), this.affectsData = !1, this._state = e, this.isEnabled = !1, this.listenTo(this._state.results, "change", () => {
          this.isEnabled = this._state.results.length > 1;
        });
      }
      refresh() {
        this.isEnabled = this._state.results.length > 1;
      }
      execute() {
        const t = this._state.results,
          e = t.getIndex(this._state.highlightedResult),
          n = e + 1 >= t.length ? 0 : e + 1;
        this._state.highlightedResult = this._state.results.get(n);
      }
    }
    class x_ extends y_ {
      execute() {
        const t = this._state.results.getIndex(this._state.highlightedResult),
          e = t - 1 < 0 ? this._state.results.length - 1 : t - 1;
        this._state.highlightedResult = this._state.results.get(e);
      }
    }
    class E_ extends q() {
      constructor(t) {
        super(), this.set("results", new Wo()), this.set("highlightedResult", null), this.set("highlightedOffset", 0), this.set("searchText", ""), this.set("replaceText", ""), this.set("lastSearchCallback", null), this.set("matchCase", !1), this.set("matchWholeWords", !1), this.results.on("change", (e, _ref97) => {
          let {
            removed: n,
            index: i
          } = _ref97;
          if (Array.from(n).length) {
            let e = !1;
            if (t.change(i => {
              for (const o of n) this.highlightedResult === o && (e = !0), t.markers.has(o.marker.name) && i.removeMarker(o.marker);
            }), e) {
              const t = i >= this.results.length ? 0 : i;
              this.highlightedResult = this.results.get(t);
            }
          }
        }), this.on("change:highlightedResult", () => {
          this.refreshHighlightOffset();
        });
      }
      clear(t) {
        this.searchText = "", t.change(e => {
          if (this.highlightedResult) {
            const n = this.highlightedResult.marker.name.split(":")[1],
              i = t.markers.get(`findResultHighlighted:${n}`);
            i && e.removeMarker(i);
          }
          [...this.results].forEach(_ref98 => {
            let {
              marker: t
            } = _ref98;
            e.removeMarker(t);
          });
        }), this.results.clear();
      }
      refreshHighlightOffset() {
        const {
            highlightedResult: t,
            results: e
          } = this,
          n = {
            before: -1,
            same: 0,
            after: 1,
            different: 1
          };
        this.highlightedOffset = t ? Array.from(e).sort((t, e) => n[t.marker.getStart().compareWith(e.marker.getStart())]).indexOf(t) + 1 : 0;
      }
    }
    class D_ extends Nr {
      static get pluginName() {
        return "FindAndReplaceUtils";
      }
      updateFindResultFromRange(t, e, n, i) {
        const o = i || new Wo();
        return e.change(i => {
          [...t].forEach(_ref99 => {
            let {
              type: t,
              item: r
            } = _ref99;
            if ("elementStart" === t && e.schema.checkChild(r, "$text")) {
              const t = n({
                item: r,
                text: this.rangeToText(e.createRangeIn(r))
              });
              if (!t) return;
              t.forEach(t => {
                const e = `findResult:${p()}`,
                  n = i.addMarker(e, {
                    usingOperation: !1,
                    affectsData: !1,
                    range: i.createRange(i.createPositionAt(r, t.start), i.createPositionAt(r, t.end))
                  }),
                  s = function (t, e) {
                    const n = t.find(_ref100 => {
                      let {
                        marker: t
                      } = _ref100;
                      return e.getStart().isBefore(t.getStart());
                    });
                    return n ? t.getIndex(n) : t.length;
                  }(o, n);
                (t => o.find(e => {
                  const {
                      marker: n
                    } = e,
                    i = n.getRange(),
                    o = t.getRange();
                  return i.isEqual(o);
                }))(n) || o.add({
                  id: e,
                  label: t.label,
                  marker: n
                }, s);
              });
            }
          });
        }), o;
      }
      rangeToText(t) {
        return Array.from(t.getItems()).reduce((t, e) => e.is("$text") || e.is("$textProxy") ? t + e.data : `${t}\n`, "");
      }
      findByTextCallback(t, e) {
        let n = "gu";
        e.matchCase || (n += "i");
        let i = `(${Qf(t)})`;
        if (e.wholeWords) {
          const e = "[^a-zA-ZÀ-ɏḀ-ỿ]";
          new RegExp("^" + e).test(t) || (i = `(^|${e}|_)${i}`), new RegExp(e + "$").test(t) || (i = `${i}(?=_|${e}|$)`);
        }
        const o = new RegExp(i, n);
        return function (_ref101) {
          let {
            text: t
          } = _ref101;
          return [...t.matchAll(o)].map(B_);
        };
      }
    }
    function B_(t) {
      const e = t.length - 1;
      let n = t.index;
      return 3 === t.length && (n += t[1].length), {
        label: t[e],
        start: n,
        end: n + t[e].length
      };
    }
    var S_ = o(5450),
      T_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(S_.A, T_);
    S_.A.locals;
    class I_ extends Nr {
      constructor() {
        super(...arguments), this._onDocumentChange = () => {
          const t = new Set(),
            e = new Set(),
            n = this.editor.model,
            {
              results: i
            } = this.state,
            o = n.document.differ.getChanges(),
            r = n.document.differ.getChangedMarkers();
          o.forEach(i => {
            i.position && ("$text" === i.name || i.position.nodeAfter && n.schema.isInline(i.position.nodeAfter) ? (t.add(i.position.parent), [...n.markers.getMarkersAtPosition(i.position)].forEach(t => {
              e.add(t.name);
            })) : "insert" === i.type && i.position.nodeAfter && t.add(i.position.nodeAfter));
          }), r.forEach(_ref102 => {
            let {
              name: t,
              data: {
                newRange: n
              }
            } = _ref102;
            n && "$graveyard" === n.start.root.rootName && e.add(t);
          }), t.forEach(t => {
            [...n.markers.getMarkersIntersectingRange(n.createRangeIn(t))].forEach(t => e.add(t.name));
          }), e.forEach(t => {
            i.has(t) && (i.get(t) === this.state.highlightedResult && (this.state.highlightedResult = null), i.remove(t));
          });
          const s = [],
            a = this.editor.plugins.get("FindAndReplaceUtils");
          t.forEach(t => {
            const e = a.updateFindResultFromRange(n.createRangeOn(t), n, this.state.lastSearchCallback, i);
            s.push(...e);
          }), r.forEach(t => {
            if (t.data.newRange) {
              const e = a.updateFindResultFromRange(t.data.newRange, n, this.state.lastSearchCallback, i);
              s.push(...e);
            }
          }), !this.state.highlightedResult && s.length ? this.state.highlightedResult = s[0] : this.state.refreshHighlightOffset();
        };
      }
      static get requires() {
        return [D_];
      }
      static get pluginName() {
        return "FindAndReplaceEditing";
      }
      init() {
        this.state = new E_(this.editor.model), this.set("_isSearchActive", !1), this._defineConverters(), this._defineCommands(), this.listenTo(this.state, "change:highlightedResult", (t, e, n, i) => {
          const {
            model: o
          } = this.editor;
          o.change(t => {
            if (i) {
              const e = i.marker.name.split(":")[1],
                n = o.markers.get(`findResultHighlighted:${e}`);
              n && t.removeMarker(n);
            }
            if (n) {
              const e = n.marker.name.split(":")[1];
              t.addMarker(`findResultHighlighted:${e}`, {
                usingOperation: !1,
                affectsData: !1,
                range: n.marker.getRange()
              });
            }
          });
        });
        const t = kl(((t, e, n) => {
          if (n) {
            const t = this.editor.editing.view.domConverter,
              e = this.editor.editing.mapper.toViewRange(n.marker.getRange());
            eo({
              target: t.viewRangeToDom(e),
              viewportOffset: 40
            });
          }
        }).bind(this), 32);
        this.listenTo(this.state, "change:highlightedResult", t, {
          priority: "low"
        }), this.listenTo(this.editor, "destroy", t.cancel), this.on("change:_isSearchActive", (t, e, n) => {
          n ? this.listenTo(this.editor.model.document, "change:data", this._onDocumentChange) : this.stopListening(this.editor.model.document, "change:data", this._onDocumentChange);
        });
      }
      find(t, e) {
        return this._isSearchActive = !0, this.editor.execute("find", t, e), this.state.results;
      }
      stop() {
        this.state.clear(this.editor.model), this._isSearchActive = !1;
      }
      _defineCommands() {
        this.editor.commands.add("find", new A_(this.editor, this.state)), this.editor.commands.add("findNext", new y_(this.editor, this.state)), this.editor.commands.add("findPrevious", new x_(this.editor, this.state)), this.editor.commands.add("replace", new __(this.editor, this.state)), this.editor.commands.add("replaceAll", new v_(this.editor, this.state));
      }
      _defineConverters() {
        const {
          editor: t
        } = this;
        t.conversion.for("editingDowncast").markerToHighlight({
          model: "findResult",
          view: _ref103 => {
            let {
              markerName: t
            } = _ref103;
            const [, e] = t.split(":");
            return {
              name: "span",
              classes: ["ck-find-result"],
              attributes: {
                "data-find-result": e
              }
            };
          }
        }), t.conversion.for("editingDowncast").markerToHighlight({
          model: "findResultHighlighted",
          view: _ref104 => {
            let {
              markerName: t
            } = _ref104;
            const [, e] = t.split(":");
            return {
              name: "span",
              classes: ["ck-find-result_selected"],
              attributes: {
                "data-find-result": e
              }
            };
          }
        });
      }
    }
    class M_ extends Pr {
      constructor(t, e) {
        super(t), this.attributeKey = e;
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.value = e.selection.getAttribute(this.attributeKey), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document.selection,
          i = t.value,
          o = t.batch,
          r = t => {
            if (n.isCollapsed) i ? t.setSelectionAttribute(this.attributeKey, i) : t.removeSelectionAttribute(this.attributeKey);else {
              const o = e.schema.getValidRanges(n.getRanges(), this.attributeKey);
              for (const e of o) i ? t.setAttribute(this.attributeKey, i, e) : t.removeAttribute(this.attributeKey, e);
            }
          };
        o ? e.enqueueChange(o, t => {
          r(t);
        }) : e.change(t => {
          r(t);
        });
      }
    }
    const L_ = "fontSize",
      N_ = "fontFamily",
      z_ = "fontColor",
      P_ = "fontBackgroundColor";
    function V_(t, e) {
      const n = {
        model: {
          key: t,
          values: []
        },
        view: {},
        upcastAlso: {}
      };
      for (const t of e) n.model.values.push(t.model), n.view[t.model] = t.view, t.upcastAlso && (n.upcastAlso[t.model] = t.upcastAlso);
      return n;
    }
    function R_(t) {
      return e => e.getStyle(t).replace(/\s/g, "");
    }
    function F_(t) {
      return (e, _ref105) => {
        let {
          writer: n
        } = _ref105;
        return n.createAttributeElement("span", {
          style: `${t}:${e}`
        }, {
          priority: 7
        });
      };
    }
    class O_ extends M_ {
      constructor(t) {
        super(t, N_);
      }
    }
    function j_(t) {
      return t.map(H_).filter(t => void 0 !== t);
    }
    function H_(t) {
      return "object" == typeof t ? t : "default" === t ? {
        title: "Default",
        model: void 0
      } : "string" == typeof t ? function (t) {
        const e = t.replace(/"|'/g, "").split(","),
          n = e[0],
          i = e.map(U_).join(", ");
        return {
          title: n,
          model: i,
          view: {
            name: "span",
            styles: {
              "font-family": i
            },
            priority: 7
          }
        };
      }(t) : void 0;
    }
    function U_(t) {
      return (t = t.trim()).indexOf(" ") > 0 && (t = `'${t}'`), t;
    }
    class q_ extends Nr {
      static get pluginName() {
        return "FontFamilyEditing";
      }
      constructor(t) {
        super(t), t.config.define(N_, {
          options: ["default", "Arial, Helvetica, sans-serif", "Courier New, Courier, monospace", "Georgia, serif", "Lucida Sans Unicode, Lucida Grande, sans-serif", "Tahoma, Geneva, sans-serif", "Times New Roman, Times, serif", "Trebuchet MS, Helvetica, sans-serif", "Verdana, Geneva, sans-serif"],
          supportAllValues: !1
        });
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: N_
        }), t.model.schema.setAttributeProperties(N_, {
          isFormatting: !0,
          copyOnEnter: !0
        });
        const e = j_(t.config.get("fontFamily.options")).filter(t => t.model),
          n = V_(N_, e);
        t.config.get("fontFamily.supportAllValues") ? (this._prepareAnyValueConverters(), this._prepareCompatibilityConverter()) : t.conversion.attributeToElement(n), t.commands.add(N_, new O_(t));
      }
      _prepareAnyValueConverters() {
        const t = this.editor;
        t.conversion.for("downcast").attributeToElement({
          model: N_,
          view: (t, _ref106) => {
            let {
              writer: e
            } = _ref106;
            return e.createAttributeElement("span", {
              style: "font-family:" + t
            }, {
              priority: 7
            });
          }
        }), t.conversion.for("upcast").elementToAttribute({
          model: {
            key: N_,
            value: t => t.getStyle("font-family")
          },
          view: {
            name: "span",
            styles: {
              "font-family": /.*/
            }
          }
        });
      }
      _prepareCompatibilityConverter() {
        this.editor.conversion.for("upcast").elementToAttribute({
          view: {
            name: "font",
            attributes: {
              face: /.*/
            }
          },
          model: {
            key: N_,
            value: t => t.getAttribute("face")
          }
        });
      }
    }
    const G_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.03 3h6.149a.75.75 0 1 1 0 1.5h-5.514L11.03 3zm1.27 3h4.879a.75.75 0 1 1 0 1.5h-4.244L12.3 6zm1.27 3h3.609a.75.75 0 1 1 0 1.5h-2.973L13.57 9zm-2.754 2.5L8.038 4.785 5.261 11.5h5.555zm.62 1.5H4.641l-1.666 4.028H1.312l5.789-14h1.875l5.789 14h-1.663L11.436 13z"/></svg>';
    class W_ extends Nr {
      static get pluginName() {
        return "FontFamilyUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = this._getLocalizedOptions(),
          i = t.commands.get(N_),
          o = e("Font Family"),
          r = function (t, e) {
            const n = new Wo();
            for (const i of t) {
              const t = {
                type: "button",
                model: new Mf({
                  commandName: N_,
                  commandParam: i.model,
                  label: i.title,
                  role: "menuitemradio",
                  withText: !0
                })
              };
              t.model.bind("isOn").to(e, "value", t => t === i.model || !(!t || !i.model) && t.split(",")[0].replace(/'/g, "").toLowerCase() === i.model.toLowerCase()), i.view && "string" != typeof i.view && i.view.styles && t.model.set("labelStyle", `font-family: ${i.view.styles["font-family"]}`), n.add(t);
            }
            return n;
          }(n, i);
        t.ui.componentFactory.add(N_, e => {
          const n = Eg(e);
          return Sg(n, r, {
            role: "menu",
            ariaLabel: o
          }), n.buttonView.set({
            label: o,
            icon: G_,
            tooltip: !0
          }), n.extendTemplate({
            attributes: {
              class: "ck-font-family-dropdown"
            }
          }), n.bind("isEnabled").to(i), this.listenTo(n, "execute", e => {
            t.execute(e.source.commandName, {
              value: e.source.commandParam
            }), t.editing.view.focus();
          }), n;
        }), t.ui.componentFactory.add(`menuBar:${N_}`, e => {
          const n = new Fk(e);
          n.buttonView.set({
            label: o,
            icon: G_
          }), n.bind("isEnabled").to(i);
          const s = new Ok(e);
          for (const i of r) {
            const o = new fk(e, n),
              r = new Uk(e);
            r.bind(...Object.keys(i.model)).to(i.model), r.bind("ariaChecked").to(r, "isOn"), r.delegate("execute").to(n), r.on("execute", () => {
              t.execute(i.model.commandName, {
                value: i.model.commandParam
              }), t.editing.view.focus();
            }), o.children.add(r), s.items.add(o);
          }
          return n.panelView.children.add(s), n;
        });
      }
      _getLocalizedOptions() {
        const t = this.editor,
          e = t.t;
        return j_(t.config.get(N_).options).map(t => ("Default" === t.title && (t.title = e("Default")), t));
      }
    }
    class $_ extends Nr {
      static get requires() {
        return [q_, W_];
      }
      static get pluginName() {
        return "FontFamily";
      }
    }
    class K_ extends M_ {
      constructor(t) {
        super(t, L_);
      }
    }
    function Y_(t) {
      return t.map(t => function (t) {
        "number" == typeof t && (t = String(t));
        if ("object" == typeof t && (e = t, e.title && e.model && e.view)) return Z_(t);
        var e;
        const n = function (t) {
          return "string" == typeof t ? Q_[t] : Q_[t.model];
        }(t);
        if (n) return Z_(n);
        if ("default" === t) return {
          model: void 0,
          title: "Default"
        };
        if (function (t) {
          let e;
          if ("object" == typeof t) {
            if (!t.model) throw new b("font-size-invalid-definition", null, t);
            e = parseFloat(t.model);
          } else e = parseFloat(t);
          return isNaN(e);
        }(t)) return;
        return function (t) {
          "string" == typeof t && (t = {
            title: t,
            model: `${parseFloat(t)}px`
          });
          return t.view = {
            name: "span",
            styles: {
              "font-size": t.model
            }
          }, Z_(t);
        }(t);
      }(t)).filter(t => void 0 !== t);
    }
    const Q_ = {
      get tiny() {
        return {
          title: "Tiny",
          model: "tiny",
          view: {
            name: "span",
            classes: "text-tiny",
            priority: 7
          }
        };
      },
      get small() {
        return {
          title: "Small",
          model: "small",
          view: {
            name: "span",
            classes: "text-small",
            priority: 7
          }
        };
      },
      get big() {
        return {
          title: "Big",
          model: "big",
          view: {
            name: "span",
            classes: "text-big",
            priority: 7
          }
        };
      },
      get huge() {
        return {
          title: "Huge",
          model: "huge",
          view: {
            name: "span",
            classes: "text-huge",
            priority: 7
          }
        };
      }
    };
    function Z_(t) {
      return t.view && "string" != typeof t.view && !t.view.priority && (t.view.priority = 7), t;
    }
    const J_ = ["x-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large"];
    class X_ extends Nr {
      static get pluginName() {
        return "FontSizeEditing";
      }
      constructor(t) {
        super(t), t.config.define(L_, {
          options: ["tiny", "small", "default", "big", "huge"],
          supportAllValues: !1
        });
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: L_
        }), t.model.schema.setAttributeProperties(L_, {
          isFormatting: !0,
          copyOnEnter: !0
        });
        const e = t.config.get("fontSize.supportAllValues"),
          n = Y_(this.editor.config.get("fontSize.options")).filter(t => t.model),
          i = V_(L_, n);
        e ? (this._prepareAnyValueConverters(i), this._prepareCompatibilityConverter()) : t.conversion.attributeToElement(i), t.commands.add(L_, new K_(t));
      }
      _prepareAnyValueConverters(t) {
        const e = this.editor,
          n = t.model.values.filter(t => !hh(String(t)) && !gh(String(t)));
        if (n.length) throw new b("font-size-invalid-use-of-named-presets", null, {
          presets: n
        });
        e.conversion.for("downcast").attributeToElement({
          model: L_,
          view: (t, _ref107) => {
            let {
              writer: e
            } = _ref107;
            if (t) return e.createAttributeElement("span", {
              style: "font-size:" + t
            }, {
              priority: 7
            });
          }
        }), e.conversion.for("upcast").elementToAttribute({
          model: {
            key: L_,
            value: t => t.getStyle("font-size")
          },
          view: {
            name: "span",
            styles: {
              "font-size": /.*/
            }
          }
        });
      }
      _prepareCompatibilityConverter() {
        this.editor.conversion.for("upcast").elementToAttribute({
          view: {
            name: "font",
            attributes: {
              size: /^[+-]?\d{1,3}$/
            }
          },
          model: {
            key: L_,
            value: t => {
              const e = t.getAttribute("size"),
                n = "-" === e[0] || "+" === e[0];
              let i = parseInt(e, 10);
              n && (i = 3 + i);
              const o = J_.length - 1,
                r = Math.min(Math.max(i, 0), o);
              return J_[r];
            }
          }
        });
      }
    }
    var tv = o(9465),
      ev = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(tv.A, ev);
    tv.A.locals;
    const nv = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13zm7.55 2.279.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825c0-.042 0-.083.002-.123l-.77.77-.707-.707L17.207 2.5l2.265 2.265-.707.707-.782-.782c.002.043.003.089.003.135v10.454z"/></svg>';
    class iv extends Nr {
      static get pluginName() {
        return "FontSizeUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = this._getLocalizedOptions(),
          i = t.commands.get(L_),
          o = e("Font Size"),
          r = function (t, e) {
            const n = new Wo();
            for (const i of t) {
              const t = {
                type: "button",
                model: new Mf({
                  commandName: L_,
                  commandParam: i.model,
                  label: i.title,
                  class: "ck-fontsize-option",
                  role: "menuitemradio",
                  withText: !0
                })
              };
              i.view && "string" != typeof i.view && (i.view.styles && t.model.set("labelStyle", `font-size:${i.view.styles["font-size"]}`), i.view.classes && t.model.set("class", `${t.model.class} ${i.view.classes}`)), t.model.bind("isOn").to(e, "value", t => t === i.model), n.add(t);
            }
            return n;
          }(n, i);
        t.ui.componentFactory.add(L_, e => {
          const n = Eg(e);
          return Sg(n, r, {
            role: "menu",
            ariaLabel: o
          }), n.buttonView.set({
            label: o,
            icon: nv,
            tooltip: !0
          }), n.extendTemplate({
            attributes: {
              class: ["ck-font-size-dropdown"]
            }
          }), n.bind("isEnabled").to(i), this.listenTo(n, "execute", e => {
            t.execute(e.source.commandName, {
              value: e.source.commandParam
            }), t.editing.view.focus();
          }), n;
        }), t.ui.componentFactory.add(`menuBar:${L_}`, e => {
          const n = new Fk(e);
          n.buttonView.set({
            label: o,
            icon: nv
          }), n.bind("isEnabled").to(i);
          const s = new Ok(e);
          for (const i of r) {
            const o = new fk(e, n),
              r = new Uk(e);
            r.bind(...Object.keys(i.model)).to(i.model), r.bind("ariaChecked").to(r, "isOn"), r.delegate("execute").to(n), r.on("execute", () => {
              t.execute(i.model.commandName, {
                value: i.model.commandParam
              }), t.editing.view.focus();
            }), o.children.add(r), s.items.add(o);
          }
          return n.panelView.children.add(s), n;
        });
      }
      _getLocalizedOptions() {
        const t = this.editor,
          e = t.t,
          n = {
            Default: e("Default"),
            Tiny: e("Tiny"),
            Small: e("Small"),
            Big: e("Big"),
            Huge: e("Huge")
          };
        return Y_(t.config.get(L_).options).map(t => {
          const e = n[t.title];
          return e && e != t.title && (t = Object.assign({}, t, {
            title: e
          })), t;
        });
      }
    }
    class ov extends Nr {
      static get requires() {
        return [X_, iv];
      }
      static get pluginName() {
        return "FontSize";
      }
      normalizeSizeOptions(t) {
        return Y_(t);
      }
    }
    class rv extends M_ {
      constructor(t) {
        super(t, z_);
      }
    }
    class sv extends Nr {
      static get pluginName() {
        return "FontColorEditing";
      }
      constructor(t) {
        super(t), t.config.define(z_, {
          colors: [{
            color: "hsl(0, 0%, 0%)",
            label: "Black"
          }, {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey"
          }, {
            color: "hsl(0, 0%, 60%)",
            label: "Grey"
          }, {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey"
          }, {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: !0
          }, {
            color: "hsl(0, 75%, 60%)",
            label: "Red"
          }, {
            color: "hsl(30, 75%, 60%)",
            label: "Orange"
          }, {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow"
          }, {
            color: "hsl(90, 75%, 60%)",
            label: "Light green"
          }, {
            color: "hsl(120, 75%, 60%)",
            label: "Green"
          }, {
            color: "hsl(150, 75%, 60%)",
            label: "Aquamarine"
          }, {
            color: "hsl(180, 75%, 60%)",
            label: "Turquoise"
          }, {
            color: "hsl(210, 75%, 60%)",
            label: "Light blue"
          }, {
            color: "hsl(240, 75%, 60%)",
            label: "Blue"
          }, {
            color: "hsl(270, 75%, 60%)",
            label: "Purple"
          }],
          columns: 5
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            styles: {
              color: /[\s\S]+/
            }
          },
          model: {
            key: z_,
            value: R_("color")
          }
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "font",
            attributes: {
              color: /^#?\w+$/
            }
          },
          model: {
            key: z_,
            value: t => t.getAttribute("color")
          }
        }), t.conversion.for("downcast").attributeToElement({
          model: z_,
          view: F_("color")
        }), t.commands.add(z_, new rv(t)), t.model.schema.extend("$text", {
          allowAttributes: z_
        }), t.model.schema.setAttributeProperties(z_, {
          isFormatting: !0,
          copyOnEnter: !0
        });
      }
    }
    class av extends Nr {
      constructor(t, _ref108) {
        let {
          commandName: e,
          componentName: n,
          icon: i,
          dropdownLabel: o
        } = _ref108;
        super(t), this.commandName = e, this.componentName = n, this.icon = i, this.dropdownLabel = o, this.columns = t.config.get(`${this.componentName}.columns`);
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = e.t,
          i = t.commands.get(this.commandName),
          o = t.config.get(this.componentName),
          r = vm(e, ym(o.colors)),
          s = o.documentColors,
          a = !1 !== o.colorPicker;
        t.ui.componentFactory.add(this.componentName, e => {
          const l = Eg(e);
          let c = !1;
          const d = function (_ref109) {
            let {
              dropdownView: t,
              colors: e,
              columns: n,
              removeButtonLabel: i,
              colorPickerLabel: o,
              documentColorsLabel: r,
              documentColorsCount: s,
              colorPickerViewConfig: a
            } = _ref109;
            const l = t.locale,
              c = new Ep(l, {
                colors: e,
                columns: n,
                removeButtonLabel: i,
                colorPickerLabel: o,
                documentColorsLabel: r,
                documentColorsCount: s,
                colorPickerViewConfig: a
              });
            return t.colorSelectorView = c, t.panelView.children.add(c), c;
          }({
            dropdownView: l,
            colors: r.map(t => ({
              label: t.label,
              color: t.model,
              options: {
                hasBorder: t.hasBorder
              }
            })),
            columns: this.columns,
            removeButtonLabel: n("Remove color"),
            colorPickerLabel: n("Color picker"),
            documentColorsLabel: 0 !== s ? n("Document colors") : "",
            documentColorsCount: void 0 === s ? this.columns : s,
            colorPickerViewConfig: !!a && (o.colorPicker || {})
          });
          return d.bind("selectedColor").to(i, "value"), l.buttonView.set({
            label: this.dropdownLabel,
            icon: this.icon,
            tooltip: !0
          }), l.extendTemplate({
            attributes: {
              class: "ck-color-ui-dropdown"
            }
          }), l.bind("isEnabled").to(i), d.on("execute", (e, n) => {
            l.isOpen && t.execute(this.commandName, {
              value: n.value,
              batch: this._undoStepBatch
            }), "colorPicker" !== n.source && t.editing.view.focus(), "colorPickerSaveButton" === n.source && (l.isOpen = !1);
          }), d.on("colorPicker:show", () => {
            this._undoStepBatch = t.model.createBatch();
          }), d.on("colorPicker:cancel", () => {
            this._undoStepBatch.operations.length && (l.isOpen = !1, t.execute("undo", this._undoStepBatch)), t.editing.view.focus();
          }), l.on("change:isOpen", (e, n, i) => {
            c || (c = !0, l.colorSelectorView.appendUI()), i && (0 !== s && d.updateDocumentColors(t.model, this.componentName), d.updateSelectedColors(), d.showColorGridsFragment());
          }), Ig(l, () => l.colorSelectorView.colorGridsFragmentView.staticColorsGrid.items.find(t => t.isOn)), l;
        }), t.ui.componentFactory.add(`menuBar:${this.componentName}`, e => {
          const o = new Fk(e);
          o.buttonView.set({
            label: this.dropdownLabel,
            icon: this.icon
          }), o.bind("isEnabled").to(i);
          let a = !1;
          const l = new Ep(e, {
            colors: r.map(t => ({
              label: t.label,
              color: t.model,
              options: {
                hasBorder: t.hasBorder
              }
            })),
            columns: this.columns,
            removeButtonLabel: n("Remove color"),
            colorPickerLabel: n("Color picker"),
            documentColorsLabel: 0 !== s ? n("Document colors") : "",
            documentColorsCount: void 0 === s ? this.columns : s,
            colorPickerViewConfig: !1
          });
          return l.bind("selectedColor").to(i, "value"), l.delegate("execute").to(o), l.on("execute", (e, n) => {
            t.execute(this.commandName, {
              value: n.value,
              batch: this._undoStepBatch
            }), t.editing.view.focus();
          }), o.on("change:isOpen", (e, n, i) => {
            a || (a = !0, l.appendUI()), i && (0 !== s && l.updateDocumentColors(t.model, this.componentName), l.updateSelectedColors(), l.showColorGridsFragment());
          }), o.panelView.children.add(l), o;
        });
      }
    }
    class lv extends av {
      constructor(t) {
        const e = t.locale.t;
        super(t, {
          commandName: z_,
          componentName: z_,
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3 10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>',
          dropdownLabel: e("Font Color")
        });
      }
      static get pluginName() {
        return "FontColorUI";
      }
    }
    class cv extends Nr {
      static get requires() {
        return [sv, lv];
      }
      static get pluginName() {
        return "FontColor";
      }
    }
    class dv extends M_ {
      constructor(t) {
        super(t, P_);
      }
    }
    class uv extends Nr {
      static get pluginName() {
        return "FontBackgroundColorEditing";
      }
      constructor(t) {
        super(t), t.config.define(P_, {
          colors: [{
            color: "hsl(0, 0%, 0%)",
            label: "Black"
          }, {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey"
          }, {
            color: "hsl(0, 0%, 60%)",
            label: "Grey"
          }, {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey"
          }, {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: !0
          }, {
            color: "hsl(0, 75%, 60%)",
            label: "Red"
          }, {
            color: "hsl(30, 75%, 60%)",
            label: "Orange"
          }, {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow"
          }, {
            color: "hsl(90, 75%, 60%)",
            label: "Light green"
          }, {
            color: "hsl(120, 75%, 60%)",
            label: "Green"
          }, {
            color: "hsl(150, 75%, 60%)",
            label: "Aquamarine"
          }, {
            color: "hsl(180, 75%, 60%)",
            label: "Turquoise"
          }, {
            color: "hsl(210, 75%, 60%)",
            label: "Light blue"
          }, {
            color: "hsl(240, 75%, 60%)",
            label: "Blue"
          }, {
            color: "hsl(270, 75%, 60%)",
            label: "Purple"
          }],
          columns: 5
        }), t.data.addStyleProcessorRules(Bh), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            styles: {
              "background-color": /[\s\S]+/
            }
          },
          model: {
            key: P_,
            value: R_("background-color")
          }
        }), t.conversion.for("downcast").attributeToElement({
          model: P_,
          view: F_("background-color")
        }), t.commands.add(P_, new dv(t)), t.model.schema.extend("$text", {
          allowAttributes: P_
        }), t.model.schema.setAttributeProperties(P_, {
          isFormatting: !0,
          copyOnEnter: !0
        });
      }
    }
    class hv extends av {
      constructor(t) {
        const e = t.locale.t;
        super(t, {
          commandName: P_,
          componentName: P_,
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8.38 9.262H7.62L10 5.506l2.38 5.756zm.532 1.285L14.34 16h1.426L10.804 4H9.196L4.234 16H5.66l1.428-3.453h5.824z"/></svg>',
          dropdownLabel: e("Font Background Color")
        });
      }
      static get pluginName() {
        return "FontBackgroundColorUI";
      }
    }
    class mv extends Nr {
      static get requires() {
        return [uv, hv];
      }
      static get pluginName() {
        return "FontBackgroundColor";
      }
    }
    class gv extends Pr {
      constructor(t) {
        super(t), this._isEnabledBasedOnSelection = !1;
      }
      refresh() {
        const t = this.editor.model,
          e = $o(t.document.selection.getSelectedBlocks());
        this.value = !!e && e.is("element", "paragraph"), this.isEnabled = !!e && pv(e, t.schema);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document,
          i = t.selection || n.selection;
        e.canEditAt(i) && e.change(t => {
          const n = i.getSelectedBlocks();
          for (const i of n) !i.is("element", "paragraph") && pv(i, e.schema) && t.rename(i, "paragraph");
        });
      }
    }
    function pv(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }
    class fv extends Pr {
      constructor(t) {
        super(t), this._isEnabledBasedOnSelection = !1;
      }
      execute(t) {
        const e = this.editor.model,
          n = t.attributes;
        let i = t.position;
        e.canEditAt(i) && e.change(t => {
          if (i = this._findPositionToInsertParagraph(i, t), !i) return;
          const o = t.createElement("paragraph");
          n && e.schema.setAllowedAttributes(o, n, t), e.insertContent(o, i), t.setSelection(o, "in");
        });
      }
      _findPositionToInsertParagraph(t, e) {
        const n = this.editor.model;
        if (n.schema.checkChild(t, "paragraph")) return t;
        const i = n.schema.findAllowedParent(t, "paragraph");
        if (!i) return null;
        const o = t.parent,
          r = n.schema.checkChild(o, "$text");
        return o.isEmpty || r && t.isAtEnd ? n.createPositionAfter(o) : !o.isEmpty && r && t.isAtStart ? n.createPositionBefore(o) : e.split(t, i).position;
      }
    }
    class kv extends Nr {
      static get pluginName() {
        return "Paragraph";
      }
      init() {
        const t = this.editor,
          e = t.model;
        t.commands.add("paragraph", new gv(t)), t.commands.add("insertParagraph", new fv(t)), e.schema.register("paragraph", {
          inheritAllFrom: "$block"
        }), t.conversion.elementToElement({
          model: "paragraph",
          view: "p"
        }), t.conversion.for("upcast").elementToElement({
          model: (t, _ref110) => {
            let {
              writer: e
            } = _ref110;
            return kv.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
          },
          view: /.+/,
          converterPriority: "low"
        });
      }
    }
    kv.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
    const bv = kv;
    class wv extends Pr {
      constructor(t, e) {
        super(t), this.modelElements = e;
      }
      refresh() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(e => Av(t, e, this.editor.model.schema));
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document,
          i = t.value;
        e.change(t => {
          const o = Array.from(n.selection.getSelectedBlocks()).filter(t => Av(t, i, e.schema));
          for (const e of o) e.is("element", i) || t.rename(e, i);
        });
      }
    }
    function Av(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }
    const Cv = "paragraph";
    class _v extends Nr {
      static get pluginName() {
        return "HeadingEditing";
      }
      constructor(t) {
        super(t), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
      }
      static get requires() {
        return [bv];
      }
      init() {
        const t = this.editor,
          e = t.config.get("heading.options"),
          n = [];
        for (const i of e) "paragraph" !== i.model && (t.model.schema.register(i.model, {
          inheritAllFrom: "$block"
        }), t.conversion.elementToElement(i), n.push(i.model));
        this._addDefaultH1Conversion(t), t.commands.add("heading", new wv(t, n));
      }
      afterInit() {
        const t = this.editor,
          e = t.commands.get("enter"),
          n = t.config.get("heading.options");
        e && this.listenTo(e, "afterExecute", (e, i) => {
          const o = t.model.document.selection.getFirstPosition().parent;
          n.some(t => o.is("element", t.model)) && !o.is("element", Cv) && 0 === o.childCount && i.writer.rename(o, Cv);
        });
      }
      _addDefaultH1Conversion(t) {
        t.conversion.for("upcast").elementToElement({
          model: "heading1",
          view: "h1",
          converterPriority: f.low + 1
        });
      }
    }
    var vv = o(6186),
      yv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(vv.A, yv);
    vv.A.locals;
    class xv extends Nr {
      static get pluginName() {
        return "HeadingUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = function (t) {
            const e = t.t,
              n = {
                Paragraph: e("Paragraph"),
                "Heading 1": e("Heading 1"),
                "Heading 2": e("Heading 2"),
                "Heading 3": e("Heading 3"),
                "Heading 4": e("Heading 4"),
                "Heading 5": e("Heading 5"),
                "Heading 6": e("Heading 6")
              };
            return t.config.get("heading.options").map(t => {
              const e = n[t.title];
              return e && e != t.title && (t.title = e), t;
            });
          }(t),
          i = e("Choose heading"),
          o = e("Heading");
        t.ui.componentFactory.add("heading", e => {
          const r = {},
            s = new Wo(),
            a = t.commands.get("heading"),
            l = t.commands.get("paragraph"),
            c = [a];
          for (const t of n) {
            const e = {
              type: "button",
              model: new Mf({
                label: t.title,
                class: t.class,
                role: "menuitemradio",
                withText: !0
              })
            };
            "paragraph" === t.model ? (e.model.bind("isOn").to(l, "value"), e.model.set("commandName", "paragraph"), c.push(l)) : (e.model.bind("isOn").to(a, "value", e => e === t.model), e.model.set({
              commandName: "heading",
              commandValue: t.model
            })), s.add(e), r[t.model] = t.title;
          }
          const d = Eg(e);
          return Sg(d, s, {
            ariaLabel: o,
            role: "menu"
          }), d.buttonView.set({
            ariaLabel: o,
            ariaLabelledBy: void 0,
            isOn: !1,
            withText: !0,
            tooltip: o
          }), d.extendTemplate({
            attributes: {
              class: ["ck-heading-dropdown"]
            }
          }), d.bind("isEnabled").toMany(c, "isEnabled", function () {
            for (var _len33 = arguments.length, t = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
              t[_key33] = arguments[_key33];
            }
            return t.some(t => t);
          }), d.buttonView.bind("label").to(a, "value", l, "value", (t, e) => {
            const n = e ? "paragraph" : t;
            return "boolean" == typeof n ? i : r[n] ? r[n] : i;
          }), d.buttonView.bind("ariaLabel").to(a, "value", l, "value", (t, e) => {
            const n = e ? "paragraph" : t;
            return "boolean" == typeof n ? o : r[n] ? `${r[n]}, ${o}` : o;
          }), this.listenTo(d, "execute", e => {
            const {
              commandName: n,
              commandValue: i
            } = e.source;
            t.execute(n, i ? {
              value: i
            } : void 0), t.editing.view.focus();
          }), d;
        }), t.ui.componentFactory.add("menuBar:heading", i => {
          const o = new Fk(i),
            r = t.commands.get("heading"),
            s = t.commands.get("paragraph"),
            a = [r],
            l = new Ok(i);
          o.set({
            class: "ck-heading-dropdown"
          }), l.set({
            ariaLabel: e("Heading"),
            role: "menu"
          }), o.buttonView.set({
            label: e("Heading")
          }), o.panelView.children.add(l);
          for (const e of n) {
            const n = new fk(i, o),
              c = new Uk(i);
            n.children.add(c), l.items.add(n), c.set({
              label: e.title,
              role: "menuitemradio",
              class: e.class
            }), c.bind("ariaChecked").to(c, "isOn"), c.delegate("execute").to(o), c.on("execute", () => {
              const n = "paragraph" === e.model ? "paragraph" : "heading";
              t.execute(n, {
                value: e.model
              }), t.editing.view.focus();
            }), "paragraph" === e.model ? (c.bind("isOn").to(s, "value"), a.push(s)) : c.bind("isOn").to(r, "value", t => t === e.model);
          }
          return o.bind("isEnabled").toMany(a, "isEnabled", function () {
            for (var _len34 = arguments.length, t = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
              t[_key34] = arguments[_key34];
            }
            return t.some(t => t);
          }), o;
        });
      }
    }
    new Set(["paragraph", "heading1", "heading2", "heading3", "heading4", "heading5", "heading6"]);
    class Ev extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.value = e.selection.getAttribute("highlight"), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "highlight");
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document.selection,
          i = t.value;
        e.change(t => {
          if (n.isCollapsed) {
            const e = n.getFirstPosition();
            if (n.hasAttribute("highlight")) {
              const n = t => t.item.hasAttribute("highlight") && t.item.getAttribute("highlight") === this.value,
                o = e.getLastMatchingPosition(n, {
                  direction: "backward"
                }),
                r = e.getLastMatchingPosition(n),
                s = t.createRange(o, r);
              i && this.value !== i ? (e.isEqual(r) || t.setAttribute("highlight", i, s), t.setSelectionAttribute("highlight", i)) : (e.isEqual(r) || t.removeAttribute("highlight", s), t.removeSelectionAttribute("highlight"));
            } else i && t.setSelectionAttribute("highlight", i);
          } else {
            const o = e.schema.getValidRanges(n.getRanges(), "highlight");
            for (const e of o) i ? t.setAttribute("highlight", i, e) : t.removeAttribute("highlight", e);
          }
        });
      }
    }
    class Dv extends Nr {
      static get pluginName() {
        return "HighlightEditing";
      }
      constructor(t) {
        super(t), t.config.define("highlight", {
          options: [{
            model: "yellowMarker",
            class: "marker-yellow",
            title: "Yellow marker",
            color: "var(--ck-highlight-marker-yellow)",
            type: "marker"
          }, {
            model: "greenMarker",
            class: "marker-green",
            title: "Green marker",
            color: "var(--ck-highlight-marker-green)",
            type: "marker"
          }, {
            model: "pinkMarker",
            class: "marker-pink",
            title: "Pink marker",
            color: "var(--ck-highlight-marker-pink)",
            type: "marker"
          }, {
            model: "blueMarker",
            class: "marker-blue",
            title: "Blue marker",
            color: "var(--ck-highlight-marker-blue)",
            type: "marker"
          }, {
            model: "redPen",
            class: "pen-red",
            title: "Red pen",
            color: "var(--ck-highlight-pen-red)",
            type: "pen"
          }, {
            model: "greenPen",
            class: "pen-green",
            title: "Green pen",
            color: "var(--ck-highlight-pen-green)",
            type: "pen"
          }]
        });
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: "highlight"
        });
        const e = t.config.get("highlight.options");
        t.conversion.attributeToElement(function (t) {
          const e = {
            model: {
              key: "highlight",
              values: []
            },
            view: {}
          };
          for (const n of t) e.model.values.push(n.model), e.view[n.model] = {
            name: "mark",
            classes: n.class
          };
          return e;
        }(e)), t.commands.add("highlight", new Ev(t));
      }
    }
    var Bv = o(1862),
      Sv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Bv.A, Sv);
    Bv.A.locals;
    class Tv extends Nr {
      get localizedOptionTitles() {
        const t = this.editor.t;
        return {
          "Yellow marker": t("Yellow marker"),
          "Green marker": t("Green marker"),
          "Pink marker": t("Pink marker"),
          "Blue marker": t("Blue marker"),
          "Red pen": t("Red pen"),
          "Green pen": t("Green pen")
        };
      }
      static get pluginName() {
        return "HighlightUI";
      }
      init() {
        const t = this.editor.config.get("highlight.options");
        for (const e of t) this._addHighlighterButton(e);
        this._addRemoveHighlightButton(), this._addDropdown(t), this._addMenuBarButton(t);
      }
      _addRemoveHighlightButton() {
        const t = this.editor.t,
          e = this.editor.commands.get("highlight");
        this._addButton("removeHighlight", t("Remove highlight"), Yh.eraser, null, t => {
          t.bind("isEnabled").to(e, "isEnabled");
        });
      }
      _addHighlighterButton(t) {
        const e = this.editor.commands.get("highlight");
        this._addButton("highlight:" + t.model, t.title, Iv(t.type), t.model, function (n) {
          n.bind("isEnabled").to(e, "isEnabled"), n.bind("isOn").to(e, "value", e => e === t.model), n.iconView.fillColor = t.color, n.isToggleable = !0;
        });
      }
      _addButton(t, e, n, i, o) {
        const r = this.editor;
        r.ui.componentFactory.add(t, t => {
          const s = new mm(t),
            a = this.localizedOptionTitles[e] ? this.localizedOptionTitles[e] : e;
          return s.set({
            label: a,
            icon: n,
            tooltip: !0
          }), s.on("execute", () => {
            r.execute("highlight", {
              value: i
            }), r.editing.view.focus();
          }), o(s), s;
        });
      }
      _addDropdown(t) {
        const e = this.editor,
          n = e.t,
          i = e.ui.componentFactory,
          o = t[0],
          r = t.reduce((t, e) => (t[e.model] = e, t), {});
        i.add("highlight", s => {
          const a = e.commands.get("highlight"),
            l = Eg(s, Cg),
            c = l.buttonView;
          c.set({
            label: n("Highlight"),
            tooltip: !0,
            lastExecuted: o.model,
            commandValue: o.model,
            isToggleable: !0
          }), c.bind("icon").to(a, "value", t => Iv(d(t, "type"))), c.bind("color").to(a, "value", t => d(t, "color")), c.bind("commandValue").to(a, "value", t => d(t, "model")), c.bind("isOn").to(a, "value", t => !!t), c.delegate("execute").to(l);
          function d(t, e) {
            const n = t && t !== c.lastExecuted ? t : c.lastExecuted;
            return r[n][e];
          }
          return l.bind("isEnabled").to(a, "isEnabled"), Dg(l, () => {
            const e = t.map(t => {
              const e = i.create("highlight:" + t.model);
              return this.listenTo(e, "execute", () => {
                l.buttonView.set({
                  lastExecuted: t.model
                });
              }), e;
            });
            return e.push(new ig()), e.push(i.create("removeHighlight")), e;
          }, {
            enableActiveItemFocusOnDropdownOpen: !0,
            ariaLabel: n("Text highlight toolbar")
          }), function (t) {
            const e = t.buttonView.actionView;
            e.iconView.bind("fillColor").to(t.buttonView, "color");
          }(l), c.on("execute", () => {
            e.execute("highlight", {
              value: c.commandValue
            });
          }), this.listenTo(l, "execute", () => {
            e.editing.view.focus();
          }), l;
        });
      }
      _addMenuBarButton(t) {
        const e = this.editor,
          n = e.t;
        e.ui.componentFactory.add("menuBar:highlight", i => {
          const o = e.commands.get("highlight"),
            r = new Fk(i);
          r.buttonView.set({
            label: n("Highlight"),
            icon: Iv("marker")
          }), r.bind("isEnabled").to(o), r.buttonView.iconView.fillColor = "transparent";
          const s = new Ok(i);
          for (const n of t) {
            const t = new fk(i, r),
              a = new Uk(i);
            a.set({
              label: n.title,
              icon: Iv(n.type)
            }), a.delegate("execute").to(r), a.bind("isOn").to(o, "value", t => t === n.model), a.bind("ariaChecked").to(a, "isOn"), a.iconView.bind("fillColor").to(a, "isOn", t => t ? "transparent" : n.color), a.on("execute", () => {
              e.execute("highlight", {
                value: n.model
              }), e.editing.view.focus();
            }), t.children.add(a), s.items.add(t);
          }
          s.items.add(new gg(i));
          const a = new fk(i, r),
            l = new Uk(i);
          return l.set({
            label: n("Remove highlight"),
            icon: Yh.eraser
          }), l.delegate("execute").to(r), l.on("execute", () => {
            e.execute("highlight", {
              value: null
            }), e.editing.view.focus();
          }), a.children.add(l), s.items.add(a), r.panelView.children.add(s), r;
        });
      }
    }
    function Iv(t) {
      return "marker" === t ? '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M10.798 1.59 3.002 12.875l1.895 1.852 2.521 1.402 6.997-12.194z"/><path d="m2.556 16.727.234-.348c-.297-.151-.462-.293-.498-.426-.036-.137.002-.416.115-.837.094-.25.15-.449.169-.595a4.495 4.495 0 0 0 0-.725c-.209-.621-.303-1.041-.284-1.26.02-.218.178-.506.475-.862l6.77-9.414c.539-.91 1.605-.85 3.199.18 1.594 1.032 2.188 1.928 1.784 2.686l-5.877 10.36c-.158.412-.333.673-.526.782-.193.108-.604.179-1.232.21-.362.131-.608.237-.738.318-.13.081-.305.238-.526.47-.293.265-.504.397-.632.397-.096 0-.27-.075-.524-.226l-.31.41-1.6-1.12zm-.279.415 1.575 1.103-.392.515H1.19l1.087-1.618zm8.1-13.656-4.953 6.9L8.75 12.57l4.247-7.574c.175-.25-.188-.647-1.092-1.192-.903-.546-1.412-.652-1.528-.32zM8.244 18.5 9.59 17h9.406v1.5H8.245z"/></svg>' : '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M10.126 2.268 2.002 13.874l1.895 1.852 2.521 1.402L14.47 5.481l-1.543-2.568-2.801-.645z"/><path d="m4.5 18.088-2.645-1.852-.04-2.95-.006-.005.006-.008v-.025l.011.008L8.73 2.97c.165-.233.356-.417.567-.557l-1.212.308L4.604 7.9l-.83-.558 3.694-5.495 2.708-.69 1.65 1.145.046.018.85-1.216 2.16 1.512-.856 1.222c.828.967 1.144 2.141.432 3.158L7.55 17.286l.006.005-3.055.797H4.5zm-.634.166-1.976.516-.026-1.918 2.002 1.402zM9.968 3.817l-.006-.004-6.123 9.184 3.277 2.294 6.108-9.162.005.003c.317-.452-.16-1.332-1.064-1.966-.891-.624-1.865-.776-2.197-.349zM8.245 18.5 9.59 17h9.406v1.5H8.245z"/></svg>';
    }
    class Mv extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection;
        this.isEnabled = function (t, e, n) {
          const i = function (t, e) {
            const n = zw(t, e),
              i = n.start.parent;
            if (i.isEmpty && !i.is("element", "$root")) return i.parent;
            return i;
          }(t, n);
          return e.checkChild(i, "horizontalLine");
        }(n, e, t);
      }
      execute() {
        const t = this.editor.model;
        t.change(e => {
          const n = e.createElement("horizontalLine");
          t.insertObject(n, null, null, {
            setSelection: "after"
          });
        });
      }
    }
    var Lv = o(1799),
      Nv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Lv.A, Nv);
    Lv.A.locals;
    class zv extends Nr {
      static get pluginName() {
        return "HorizontalLineEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.t,
          i = t.conversion;
        e.register("horizontalLine", {
          inheritAllFrom: "$blockObject"
        }), i.for("dataDowncast").elementToElement({
          model: "horizontalLine",
          view: (t, _ref111) => {
            let {
              writer: e
            } = _ref111;
            return e.createEmptyElement("hr");
          }
        }), i.for("editingDowncast").elementToStructure({
          model: "horizontalLine",
          view: (t, _ref112) => {
            let {
              writer: e
            } = _ref112;
            const i = n("Horizontal line"),
              o = e.createContainerElement("div", null, e.createEmptyElement("hr"));
            return e.addClass("ck-horizontal-line", o), e.setCustomProperty("hr", !0, o), function (t, e, n) {
              return e.setCustomProperty("horizontalLine", !0, t), Tw(t, e, {
                label: n
              });
            }(o, e, i);
          }
        }), i.for("upcast").elementToElement({
          view: "hr",
          model: "horizontalLine"
        }), t.commands.add("horizontalLine", new Mv(t));
      }
    }
    class Pv extends Nr {
      static get pluginName() {
        return "HorizontalLineUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add("horizontalLine", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0
          }), t;
        }), t.ui.componentFactory.add("menuBar:horizontalLine", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("horizontalLine"),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Horizontal line"),
          icon: Yh.horizontalLine
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          e.execute("horizontalLine"), e.editing.view.focus();
        }), o;
      }
    }
    class Vv extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection,
          i = Rv(n);
        this.isEnabled = function (t, e, n) {
          const i = function (t, e) {
            const n = zw(t, e),
              i = n.start.parent;
            if (i.isEmpty && !i.is("rootElement")) return i.parent;
            return i;
          }(t, n);
          return e.checkChild(i, "rawHtml");
        }(n, e, t), this.value = i ? i.getAttribute("value") || "" : null;
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document.selection;
        e.change(i => {
          let o;
          null !== this.value ? o = Rv(n) : (o = i.createElement("rawHtml"), e.insertObject(o, null, null, {
            setSelection: "on"
          })), i.setAttribute("value", t, o);
        });
      }
    }
    function Rv(t) {
      const e = t.getSelectedElement();
      return e && e.is("element", "rawHtml") ? e : null;
    }
    var Fv = o(9856),
      Ov = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Fv.A, Ov);
    Fv.A.locals;
    class jv extends Nr {
      static get pluginName() {
        return "HtmlEmbedEditing";
      }
      constructor(t) {
        super(t), this._widgetButtonViewReferences = new Set(), t.config.define("htmlEmbed", {
          showPreviews: !1,
          sanitizeHtml: t => (w("html-embed-provide-sanitize-function"), {
            html: t,
            hasChanged: !1
          })
        });
      }
      init() {
        const t = this.editor;
        t.model.schema.register("rawHtml", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["value"]
        }), t.commands.add("htmlEmbed", new Vv(t)), this._setupConversion();
      }
      _setupConversion() {
        const t = this.editor,
          e = t.t,
          n = t.editing.view,
          i = this._widgetButtonViewReferences,
          o = t.config.get("htmlEmbed");
        function r(_ref113) {
          let {
            editor: t,
            domElement: n,
            state: o,
            props: r
          } = _ref113;
          n.textContent = "";
          const a = n.ownerDocument;
          let l;
          if (o.isEditable) {
            const t = {
              isDisabled: !1,
              placeholder: r.textareaPlaceholder
            };
            l = s({
              domDocument: a,
              state: o,
              props: t
            }), n.append(l);
          } else if (o.showPreviews) {
            const i = {
              sanitizeHtml: r.sanitizeHtml
            };
            n.append(function (_ref114) {
              let {
                editor: t,
                domDocument: n,
                state: i,
                props: o
              } = _ref114;
              const r = o.sanitizeHtml(i.getRawHtmlValue()),
                s = i.getRawHtmlValue().length > 0 ? e("No preview available") : e("Empty snippet content"),
                a = ft(n, "div", {
                  class: "ck ck-reset_all raw-html-embed__preview-placeholder"
                }, s),
                l = ft(n, "div", {
                  class: "raw-html-embed__preview-content",
                  dir: t.locale.contentLanguageDirection
                }),
                c = n.createRange(),
                d = c.createContextualFragment(r.html);
              l.appendChild(d);
              const u = ft(n, "div", {
                class: "raw-html-embed__preview"
              }, [a, l]);
              return u;
            }({
              domDocument: a,
              state: o,
              props: i,
              editor: t
            }));
          } else {
            const t = {
              isDisabled: !0,
              placeholder: r.textareaPlaceholder
            };
            n.append(s({
              domDocument: a,
              state: o,
              props: t
            }));
          }
          const c = {
            onEditClick: r.onEditClick,
            onSaveClick: () => {
              r.onSaveClick(l.value);
            },
            onCancelClick: r.onCancelClick
          };
          n.prepend(function (_ref115) {
            let {
              editor: t,
              domDocument: e,
              state: n,
              props: o
            } = _ref115;
            const r = ft(e, "div", {
              class: "raw-html-embed__buttons-wrapper"
            });
            if (n.isEditable) {
              const e = Hv(t, "save", o.onSaveClick),
                n = Hv(t, "cancel", o.onCancelClick);
              r.append(e.element, n.element), i.add(e).add(n);
            } else {
              const e = Hv(t, "edit", o.onEditClick);
              r.append(e.element), i.add(e);
            }
            return r;
          }({
            editor: t,
            domDocument: a,
            state: o,
            props: c
          }));
        }
        function s(_ref116) {
          let {
            domDocument: t,
            state: e,
            props: n
          } = _ref116;
          const i = ft(t, "textarea", {
            placeholder: n.placeholder,
            class: "ck ck-reset ck-input ck-input-text raw-html-embed__source"
          });
          return i.disabled = n.isDisabled, i.value = e.getRawHtmlValue(), i;
        }
        this.editor.editing.view.on("render", () => {
          for (const t of i) {
            if (t.element && t.element.isConnected) return;
            t.destroy(), i.delete(t);
          }
        }, {
          priority: "lowest"
        }), t.data.registerRawContentMatcher({
          name: "div",
          classes: "raw-html-embed"
        }), t.conversion.for("upcast").elementToElement({
          view: {
            name: "div",
            classes: "raw-html-embed"
          },
          model: (t, _ref117) => {
            let {
              writer: e
            } = _ref117;
            return e.createElement("rawHtml", {
              value: t.getCustomProperty("$rawContent")
            });
          }
        }), t.conversion.for("dataDowncast").elementToElement({
          model: "rawHtml",
          view: (t, _ref118) => {
            let {
              writer: e
            } = _ref118;
            return e.createRawElement("div", {
              class: "raw-html-embed"
            }, function (e) {
              e.innerHTML = t.getAttribute("value") || "";
            });
          }
        }), t.conversion.for("editingDowncast").elementToStructure({
          model: {
            name: "rawHtml",
            attributes: ["value"]
          },
          view: (i, _ref119) => {
            let {
              writer: s
            } = _ref119;
            let a, l, c;
            const d = s.createRawElement("div", {
                class: "raw-html-embed__content-wrapper"
              }, function (e) {
                a = e, r({
                  editor: t,
                  domElement: e,
                  state: l,
                  props: c
                }), a.addEventListener("mousedown", () => {
                  if (l.isEditable) {
                    const e = t.model;
                    e.document.selection.getSelectedElement() !== i && e.change(t => t.setSelection(i, "on"));
                  }
                }, !0);
              }),
              u = {
                makeEditable() {
                  l = Object.assign({}, l, {
                    isEditable: !0
                  }), r({
                    domElement: a,
                    editor: t,
                    state: l,
                    props: c
                  }), n.change(t => {
                    t.setAttribute("data-cke-ignore-events", "true", d);
                  }), a.querySelector("textarea").focus();
                },
                save(e) {
                  e !== l.getRawHtmlValue() ? (t.execute("htmlEmbed", e), t.editing.view.focus()) : this.cancel();
                },
                cancel() {
                  l = Object.assign({}, l, {
                    isEditable: !1
                  }), r({
                    domElement: a,
                    editor: t,
                    state: l,
                    props: c
                  }), t.editing.view.focus(), n.change(t => {
                    t.removeAttribute("data-cke-ignore-events", d);
                  });
                }
              };
            l = {
              showPreviews: o.showPreviews,
              isEditable: !1,
              getRawHtmlValue: () => i.getAttribute("value") || ""
            }, c = {
              sanitizeHtml: o.sanitizeHtml,
              textareaPlaceholder: e("Paste raw HTML here..."),
              onEditClick() {
                u.makeEditable();
              },
              onSaveClick(t) {
                u.save(t);
              },
              onCancelClick() {
                u.cancel();
              }
            };
            const h = s.createContainerElement("div", {
              class: "raw-html-embed",
              "data-html-embed-label": e("HTML snippet"),
              dir: t.locale.uiLanguageDirection
            }, d);
            return s.setCustomProperty("rawHtmlApi", u, h), s.setCustomProperty("rawHtml", !0, h), Tw(h, s, {
              label: e("HTML snippet"),
              hasSelectionHandle: !0
            });
          }
        });
      }
    }
    function Hv(t, e, n) {
      const {
          t: i
        } = t.locale,
        o = new mm(t.locale),
        r = t.commands.get("htmlEmbed");
      return o.set({
        class: `raw-html-embed__${e}-button`,
        icon: Yh.pencil,
        tooltip: !0,
        tooltipPosition: "rtl" === t.locale.uiLanguageDirection ? "e" : "w"
      }), o.render(), "edit" === e ? (o.set({
        icon: Yh.pencil,
        label: i("Edit source")
      }), o.bind("isEnabled").to(r)) : "save" === e ? (o.set({
        icon: Yh.check,
        label: i("Save changes")
      }), o.bind("isEnabled").to(r)) : o.set({
        icon: Yh.cancel,
        label: i("Cancel")
      }), o.on("execute", n), o;
    }
    class Uv extends Nr {
      static get pluginName() {
        return "HtmlEmbedUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t;
        t.ui.componentFactory.add("htmlEmbed", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0,
            label: e("Insert HTML")
          }), t;
        }), t.ui.componentFactory.add("menuBar:htmlEmbed", () => {
          const t = this._createButton(Uk);
          return t.set({
            label: e("HTML snippet")
          }), t;
        });
      }
      _createButton(t) {
        const e = this.editor,
          n = e.commands.get("htmlEmbed"),
          i = new t(e.locale);
        return i.set({
          icon: Yh.html
        }), i.bind("isEnabled").to(n, "isEnabled"), this.listenTo(i, "execute", () => {
          e.execute("htmlEmbed"), e.editing.view.focus();
          e.editing.view.document.selection.getSelectedElement().getCustomProperty("rawHtmlApi").makeEditable();
        }), i;
      }
    }
    const qv = function (t, e, n, i) {
      var o = -1,
        r = null == t ? 0 : t.length;
      for (i && r && (n = t[++o]); ++o < r;) n = e(n, t[o], o, t);
      return n;
    };
    const Gv = ik({
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    });
    var Wv = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      $v = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
    const Kv = function (t) {
      return (t = _s(t)) && t.replace(Wv, Gv).replace($v, "");
    };
    var Yv = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    const Qv = function (t) {
      return t.match(Yv) || [];
    };
    var Zv = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    const Jv = function (t) {
      return Zv.test(t);
    };
    var Xv = "\\ud800-\\udfff",
      ty = "\\u2700-\\u27bf",
      ey = "a-z\\xdf-\\xf6\\xf8-\\xff",
      ny = "A-Z\\xc0-\\xd6\\xd8-\\xde",
      iy = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      oy = "[" + iy + "]",
      ry = "\\d+",
      sy = "[" + ty + "]",
      ay = "[" + ey + "]",
      ly = "[^" + Xv + iy + ry + ty + ey + ny + "]",
      cy = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      dy = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      uy = "[" + ny + "]",
      hy = "(?:" + ay + "|" + ly + ")",
      my = "(?:" + uy + "|" + ly + ")",
      gy = "(?:['’](?:d|ll|m|re|s|t|ve))?",
      py = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
      fy = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
      ky = "[\\ufe0e\\ufe0f]?",
      by = ky + fy + ("(?:\\u200d(?:" + ["[^" + Xv + "]", cy, dy].join("|") + ")" + ky + fy + ")*"),
      wy = "(?:" + [sy, cy, dy].join("|") + ")" + by,
      Ay = RegExp([uy + "?" + ay + "+" + gy + "(?=" + [oy, uy, "$"].join("|") + ")", my + "+" + py + "(?=" + [oy, uy + hy, "$"].join("|") + ")", uy + "?" + hy + "+" + gy, uy + "+" + py, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ry, wy].join("|"), "g");
    const Cy = function (t) {
      return t.match(Ay) || [];
    };
    const _y = function (t, e, n) {
      return t = _s(t), void 0 === (e = n ? void 0 : e) ? Jv(t) ? Cy(t) : Qv(t) : t.match(e) || [];
    };
    var vy = RegExp("['’]", "g");
    const yy = function (t) {
      return function (e) {
        return qv(_y(Kv(e).replace(vy, "")), t, "");
      };
    };
    const xy = function (t, e, n) {
      var i = t.length;
      return n = void 0 === n ? i : n, !e && n >= i ? t : Ds(t, e, n);
    };
    var Ey = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    const Dy = function (t) {
      return Ey.test(t);
    };
    const By = function (t) {
      return t.split("");
    };
    var Sy = "\\ud800-\\udfff",
      Ty = "[" + Sy + "]",
      Iy = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      My = "\\ud83c[\\udffb-\\udfff]",
      Ly = "[^" + Sy + "]",
      Ny = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      zy = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Py = "(?:" + Iy + "|" + My + ")" + "?",
      Vy = "[\\ufe0e\\ufe0f]?",
      Ry = Vy + Py + ("(?:\\u200d(?:" + [Ly, Ny, zy].join("|") + ")" + Vy + Py + ")*"),
      Fy = "(?:" + [Ly + Iy + "?", Iy, Ny, zy, Ty].join("|") + ")",
      Oy = RegExp(My + "(?=" + My + ")|" + Fy + Ry, "g");
    const jy = function (t) {
      return t.match(Oy) || [];
    };
    const Hy = function (t) {
      return Dy(t) ? jy(t) : By(t);
    };
    const Uy = function (t) {
      return function (e) {
        e = _s(e);
        var n = Dy(e) ? Hy(e) : void 0,
          i = n ? n[0] : e.charAt(0),
          o = n ? xy(n, 1).join("") : e.slice(1);
        return i[t]() + o;
      };
    }("toUpperCase");
    const qy = yy(function (t, e, n) {
      return t + (n ? " " : "") + Uy(e);
    });
    function Gy(t, e, n, i) {
      e && function (t, e, n) {
        if (e.attributes) for (const [i] of Object.entries(e.attributes)) t.removeAttribute(i, n);
        if (e.styles) for (const i of Object.keys(e.styles)) t.removeStyle(i, n);
        e.classes && t.removeClass(e.classes, n);
      }(t, e, i), n && Wy(t, n, i);
    }
    function Wy(t, e, n) {
      if (e.attributes) for (const [i, o] of Object.entries(e.attributes)) t.setAttribute(i, o, n);
      e.styles && t.setStyle(e.styles, n), e.classes && t.addClass(e.classes, n);
    }
    function $y(t, e, n, i, o) {
      const r = e.getAttribute(n),
        s = {};
      for (const t of ["attributes", "styles", "classes"]) {
        if (t != i) {
          r && r[t] && (s[t] = r[t]);
          continue;
        }
        if ("classes" == i) {
          const e = new Set(r && r.classes || []);
          o(e), e.size && (s[t] = Array.from(e));
          continue;
        }
        const e = new Map(Object.entries(r && r[t] || {}));
        o(e), e.size && (s[t] = Object.fromEntries(e));
      }
      Object.keys(s).length ? e.is("documentSelection") ? t.setSelectionAttribute(n, s) : t.setAttribute(n, s, e) : r && (e.is("documentSelection") ? t.removeSelectionAttribute(n) : t.removeAttribute(n, e));
    }
    function Ky(t) {
      return `html${(e = t, qy(e).replace(/ /g, ""))}Attributes`;
      var e;
    }
    function Yy(_ref120) {
      let {
        model: t
      } = _ref120;
      return (e, n) => n.writer.createElement(t, {
        htmlContent: e.getCustomProperty("$rawContent")
      });
    }
    function Qy(t, _ref121) {
      let {
        view: e,
        isInline: n
      } = _ref121;
      const i = t.t;
      return (t, _ref122) => {
        let {
          writer: o
        } = _ref122;
        const r = i("HTML object"),
          s = Zy(e, t, o),
          a = t.getAttribute(Ky(e));
        o.addClass("html-object-embed__content", s), a && Wy(o, a, s);
        return Tw(o.createContainerElement(n ? "span" : "div", {
          class: "html-object-embed",
          "data-html-object-embed-label": r
        }, s), o, {
          label: r
        });
      };
    }
    function Zy(t, e, n) {
      return n.createRawElement(t, null, (t, n) => {
        n.setContentOf(t, e.getAttribute("htmlContent"));
      });
    }
    function Jy(_ref123, i) {
      let {
        view: t,
        model: e,
        allowEmpty: n
      } = _ref123;
      return e => {
        e.on(`element:${t}`, (t, e, r) => {
          let s = i.processViewAttributes(e.viewItem, r);
          if (s || r.consumable.test(e.viewItem, {
            name: !0
          })) {
            if (s = s || {}, r.consumable.consume(e.viewItem, {
              name: !0
            }), e.modelRange || (e = Object.assign(e, r.convertChildren(e.viewItem, e.modelCursor))), n && e.modelRange.isCollapsed && Object.keys(s).length) {
              const t = r.writer.createElement("htmlEmptyElement");
              if (!r.safeInsert(t, e.modelCursor)) return;
              const n = r.getSplitParts(t);
              return e.modelRange = r.writer.createRange(e.modelRange.start, r.writer.createPositionAfter(n[n.length - 1])), r.updateConversionResult(t, e), void o(t, s, r);
            }
            for (const t of e.modelRange.getItems()) o(t, s, r);
          }
        }, {
          priority: "low"
        });
      };
      function o(t, n, i) {
        if (i.schema.checkAttribute(t, e)) {
          const o = function (t, e) {
            const n = Ql(t);
            let i = "attributes";
            for (i in e) n[i] = "classes" == i ? Array.from(new Set([...(t[i] || []), ...e[i]])) : {
              ...t[i],
              ...e[i]
            };
            return n;
          }(n, t.getAttribute(e) || {});
          i.writer.setAttribute(e, o, t);
        }
      }
    }
    function Xy(_ref124, n) {
      let {
        model: t,
        view: e
      } = _ref124;
      return (i, _ref125) => {
        let {
          writer: o,
          consumable: r
        } = _ref125;
        if (!i.hasAttribute(t)) return null;
        const s = o.createContainerElement(e),
          a = i.getAttribute(t);
        return r.consume(i, `attribute:${t}`), Wy(o, a, s), s.getFillerOffset = () => null, n ? Tw(s, o) : s;
      };
    }
    function tx(_ref126) {
      let {
        priority: t,
        view: e
      } = _ref126;
      return (n, i) => {
        if (!n) return;
        const {
            writer: o
          } = i,
          r = o.createAttributeElement(e, null, {
            priority: t
          });
        return Wy(o, n, r), r;
      };
    }
    function ex(_ref127, e) {
      let {
        view: t
      } = _ref127;
      return n => {
        n.on(`element:${t}`, (t, n, i) => {
          if (!n.modelRange || n.modelRange.isCollapsed) return;
          const o = e.processViewAttributes(n.viewItem, i);
          o && i.writer.setAttribute(Ky(n.viewItem.name), o, n.modelRange);
        }, {
          priority: "low"
        });
      };
    }
    function nx(_ref128) {
      let {
        view: t,
        model: e
      } = _ref128;
      return n => {
        n.on(`attribute:${Ky(t)}:${e}`, (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const {
            attributeOldValue: i,
            attributeNewValue: o
          } = e;
          Gy(n.writer, i, o, n.mapper.toViewElement(e.item));
        });
      };
    }
    const ix = [{
        model: "codeBlock",
        view: "pre"
      }, {
        model: "paragraph",
        view: "p"
      }, {
        model: "blockQuote",
        view: "blockquote"
      }, {
        model: "listItem",
        view: "li"
      }, {
        model: "pageBreak",
        view: "div"
      }, {
        model: "rawHtml",
        view: "div"
      }, {
        model: "table",
        view: "table"
      }, {
        model: "tableRow",
        view: "tr"
      }, {
        model: "tableCell",
        view: "td"
      }, {
        model: "tableCell",
        view: "th"
      }, {
        model: "tableColumnGroup",
        view: "colgroup"
      }, {
        model: "tableColumn",
        view: "col"
      }, {
        model: "caption",
        view: "caption"
      }, {
        model: "caption",
        view: "figcaption"
      }, {
        model: "imageBlock",
        view: "img"
      }, {
        model: "imageInline",
        view: "img"
      }, {
        model: "htmlP",
        view: "p",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlBlockquote",
        view: "blockquote",
        modelSchema: {
          inheritAllFrom: "$container"
        }
      }, {
        model: "htmlTable",
        view: "table",
        modelSchema: {
          allowWhere: "$block",
          isBlock: !0
        }
      }, {
        model: "htmlTbody",
        view: "tbody",
        modelSchema: {
          allowIn: "htmlTable",
          isBlock: !1
        }
      }, {
        model: "htmlThead",
        view: "thead",
        modelSchema: {
          allowIn: "htmlTable",
          isBlock: !1
        }
      }, {
        model: "htmlTfoot",
        view: "tfoot",
        modelSchema: {
          allowIn: "htmlTable",
          isBlock: !1
        }
      }, {
        model: "htmlCaption",
        view: "caption",
        modelSchema: {
          allowIn: "htmlTable",
          allowChildren: "$text",
          isBlock: !1
        }
      }, {
        model: "htmlColgroup",
        view: "colgroup",
        modelSchema: {
          allowIn: "htmlTable",
          allowChildren: "col",
          isBlock: !1
        }
      }, {
        model: "htmlCol",
        view: "col",
        modelSchema: {
          allowIn: "htmlColgroup",
          isBlock: !1
        }
      }, {
        model: "htmlTr",
        view: "tr",
        modelSchema: {
          allowIn: ["htmlTable", "htmlThead", "htmlTbody"],
          isLimit: !0
        }
      }, {
        model: "htmlTd",
        view: "td",
        modelSchema: {
          allowIn: "htmlTr",
          allowContentOf: "$container",
          isLimit: !0,
          isBlock: !1
        }
      }, {
        model: "htmlTh",
        view: "th",
        modelSchema: {
          allowIn: "htmlTr",
          allowContentOf: "$container",
          isLimit: !0,
          isBlock: !1
        }
      }, {
        model: "htmlFigure",
        view: "figure",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlFigcaption",
        view: "figcaption",
        modelSchema: {
          allowIn: "htmlFigure",
          allowChildren: "$text",
          isBlock: !1
        }
      }, {
        model: "htmlAddress",
        view: "address",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlAside",
        view: "aside",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlMain",
        view: "main",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlDetails",
        view: "details",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlSummary",
        view: "summary",
        modelSchema: {
          allowChildren: "$text",
          allowIn: "htmlDetails",
          isBlock: !1
        }
      }, {
        model: "htmlDiv",
        view: "div",
        paragraphLikeModel: "htmlDivParagraph",
        modelSchema: {
          inheritAllFrom: "$container"
        }
      }, {
        model: "htmlFieldset",
        view: "fieldset",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlLegend",
        view: "legend",
        modelSchema: {
          allowIn: "htmlFieldset",
          allowChildren: "$text"
        }
      }, {
        model: "htmlHeader",
        view: "header",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlFooter",
        view: "footer",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlForm",
        view: "form",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !0
        }
      }, {
        model: "htmlHgroup",
        view: "hgroup",
        modelSchema: {
          allowChildren: ["htmlH1", "htmlH2", "htmlH3", "htmlH4", "htmlH5", "htmlH6"],
          isBlock: !1
        }
      }, {
        model: "htmlH1",
        view: "h1",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlH2",
        view: "h2",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlH3",
        view: "h3",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlH4",
        view: "h4",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlH5",
        view: "h5",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlH6",
        view: "h6",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "$htmlList",
        modelSchema: {
          allowWhere: "$container",
          allowChildren: ["$htmlList", "htmlLi"],
          isBlock: !1
        }
      }, {
        model: "htmlDir",
        view: "dir",
        modelSchema: {
          inheritAllFrom: "$htmlList"
        }
      }, {
        model: "htmlMenu",
        view: "menu",
        modelSchema: {
          inheritAllFrom: "$htmlList"
        }
      }, {
        model: "htmlUl",
        view: "ul",
        modelSchema: {
          inheritAllFrom: "$htmlList"
        }
      }, {
        model: "htmlOl",
        view: "ol",
        modelSchema: {
          inheritAllFrom: "$htmlList"
        }
      }, {
        model: "htmlLi",
        view: "li",
        modelSchema: {
          allowIn: "$htmlList",
          allowChildren: "$text",
          isBlock: !1
        }
      }, {
        model: "htmlPre",
        view: "pre",
        modelSchema: {
          inheritAllFrom: "$block"
        }
      }, {
        model: "htmlArticle",
        view: "article",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlSection",
        view: "section",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlNav",
        view: "nav",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }, {
        model: "htmlDivDl",
        view: "div",
        modelSchema: {
          allowChildren: ["htmlDt", "htmlDd"],
          allowIn: "htmlDl"
        }
      }, {
        model: "htmlDl",
        view: "dl",
        modelSchema: {
          allowWhere: "$container",
          allowChildren: ["htmlDt", "htmlDd", "htmlDivDl"],
          isBlock: !1
        }
      }, {
        model: "htmlDt",
        view: "dt",
        modelSchema: {
          allowChildren: "$block",
          isBlock: !1
        }
      }, {
        model: "htmlDd",
        view: "dd",
        modelSchema: {
          allowChildren: "$block",
          isBlock: !1
        }
      }, {
        model: "htmlCenter",
        view: "center",
        modelSchema: {
          inheritAllFrom: "$container",
          isBlock: !1
        }
      }],
      ox = [{
        model: "htmlLiAttributes",
        view: "li",
        appliesToBlock: !0,
        coupledAttribute: "listItemId"
      }, {
        model: "htmlOlAttributes",
        view: "ol",
        appliesToBlock: !0,
        coupledAttribute: "listItemId"
      }, {
        model: "htmlUlAttributes",
        view: "ul",
        appliesToBlock: !0,
        coupledAttribute: "listItemId"
      }, {
        model: "htmlFigureAttributes",
        view: "figure",
        appliesToBlock: "table"
      }, {
        model: "htmlTheadAttributes",
        view: "thead",
        appliesToBlock: "table"
      }, {
        model: "htmlTbodyAttributes",
        view: "tbody",
        appliesToBlock: "table"
      }, {
        model: "htmlFigureAttributes",
        view: "figure",
        appliesToBlock: "imageBlock"
      }, {
        model: "htmlAcronym",
        view: "acronym",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlTt",
        view: "tt",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlFont",
        view: "font",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlTime",
        view: "time",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlVar",
        view: "var",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlBig",
        view: "big",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlSmall",
        view: "small",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlSamp",
        view: "samp",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlQ",
        view: "q",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlOutput",
        view: "output",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlKbd",
        view: "kbd",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlBdi",
        view: "bdi",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlBdo",
        view: "bdo",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlAbbr",
        view: "abbr",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlA",
        view: "a",
        priority: 5,
        coupledAttribute: "linkHref"
      }, {
        model: "htmlStrong",
        view: "strong",
        coupledAttribute: "bold",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlB",
        view: "b",
        coupledAttribute: "bold",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlI",
        view: "i",
        coupledAttribute: "italic",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlEm",
        view: "em",
        coupledAttribute: "italic",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlS",
        view: "s",
        coupledAttribute: "strikethrough",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlDel",
        view: "del",
        coupledAttribute: "strikethrough",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlIns",
        view: "ins",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlU",
        view: "u",
        coupledAttribute: "underline",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlSub",
        view: "sub",
        coupledAttribute: "subscript",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlSup",
        view: "sup",
        coupledAttribute: "superscript",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlCode",
        view: "code",
        coupledAttribute: "code",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlMark",
        view: "mark",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlSpan",
        view: "span",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlCite",
        view: "cite",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlLabel",
        view: "label",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlDfn",
        view: "dfn",
        attributeProperties: {
          copyOnEnter: !0,
          isFormatting: !0
        }
      }, {
        model: "htmlObject",
        view: "object",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlIframe",
        view: "iframe",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlInput",
        view: "input",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlButton",
        view: "button",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlTextarea",
        view: "textarea",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlSelect",
        view: "select",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlVideo",
        view: "video",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlEmbed",
        view: "embed",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlOembed",
        view: "oembed",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlAudio",
        view: "audio",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlImg",
        view: "img",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlCanvas",
        view: "canvas",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlMeter",
        view: "meter",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlProgress",
        view: "progress",
        isObject: !0,
        modelSchema: {
          inheritAllFrom: "$inlineObject"
        }
      }, {
        model: "htmlScript",
        view: "script",
        modelSchema: {
          allowWhere: ["$text", "$block"],
          isInline: !0
        }
      }, {
        model: "htmlStyle",
        view: "style",
        modelSchema: {
          allowWhere: ["$text", "$block"],
          isInline: !0
        }
      }, {
        model: "htmlCustomElement",
        view: "$customElement",
        modelSchema: {
          allowWhere: ["$text", "$block"],
          allowAttributesOf: "$inlineObject",
          isInline: !0
        }
      }];
    const rx = Ho(function (t, e, n, i) {
      To(t, e, n, i);
    });
    class sx extends Nr {
      constructor() {
        super(...arguments), this._definitions = [];
      }
      static get pluginName() {
        return "DataSchema";
      }
      init() {
        for (const t of ix) this.registerBlockElement(t);
        for (const t of ox) this.registerInlineElement(t);
      }
      registerBlockElement(t) {
        this._definitions.push({
          ...t,
          isBlock: !0
        });
      }
      registerInlineElement(t) {
        this._definitions.push({
          ...t,
          isInline: !0
        });
      }
      extendBlockElement(t) {
        this._extendDefinition({
          ...t,
          isBlock: !0
        });
      }
      extendInlineElement(t) {
        this._extendDefinition({
          ...t,
          isInline: !0
        });
      }
      getDefinitionsForView(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = new Set();
        for (const i of this._getMatchingViewDefinitions(t)) {
          if (e) for (const t of this._getReferences(i.model)) n.add(t);
          n.add(i);
        }
        return n;
      }
      getDefinitionsForModel(t) {
        return this._definitions.filter(e => e.model == t);
      }
      _getMatchingViewDefinitions(t) {
        return this._definitions.filter(e => e.view && function (t, e) {
          if ("string" == typeof t) return t === e;
          if (t instanceof RegExp) return t.test(e);
          return !1;
        }(t, e.view));
      }
      *_getReferences(t) {
        const e = ["inheritAllFrom", "inheritTypesFrom", "allowWhere", "allowContentOf", "allowAttributesOf"],
          n = this._definitions.filter(e => e.model == t);
        for (const {
          modelSchema: i
        } of n) if (i) for (const n of e) for (const e of vo(i[n] || [])) {
          const n = this._definitions.filter(t => t.model == e);
          for (const i of n) e !== t && (yield* this._getReferences(i.model), yield i);
        }
      }
      _extendDefinition(t) {
        const e = Array.from(this._definitions.entries()).filter(_ref129 => {
          let [, e] = _ref129;
          return e.model == t.model;
        });
        if (0 != e.length) for (const [n, i] of e) this._definitions[n] = rx({}, i, t, (t, e) => Array.isArray(t) ? t.concat(e) : void 0);else this._definitions.push(t);
      }
    }
    var ax = o(8641),
      lx = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(ax.A, lx);
    ax.A.locals;
    class cx extends Nr {
      constructor(t) {
        super(t), this._dataSchema = t.plugins.get("DataSchema"), this._allowedAttributes = new os(), this._disallowedAttributes = new os(), this._allowedElements = new Set(), this._disallowedElements = new Set(), this._dataInitialized = !1, this._coupledAttributes = null, this._registerElementsAfterInit(), this._registerElementHandlers(), this._registerCoupledAttributesPostFixer(), this._registerAssociatedHtmlAttributesPostFixer();
      }
      static get pluginName() {
        return "DataFilter";
      }
      static get requires() {
        return [sx, Jw];
      }
      loadAllowedConfig(t) {
        for (const e of t) {
          const t = e.name || /[\s\S]+/,
            n = gx(e);
          this.allowElement(t), n.forEach(t => this.allowAttributes(t));
        }
      }
      loadDisallowedConfig(t) {
        for (const e of t) {
          const t = e.name || /[\s\S]+/,
            n = gx(e);
          0 == n.length ? this.disallowElement(t) : n.forEach(t => this.disallowAttributes(t));
        }
      }
      loadAllowedEmptyElementsConfig(t) {
        for (const e of t) this.allowEmptyElement(e);
      }
      allowElement(t) {
        for (const e of this._dataSchema.getDefinitionsForView(t, !0)) this._addAllowedElement(e), this._coupledAttributes = null;
      }
      disallowElement(t) {
        for (const e of this._dataSchema.getDefinitionsForView(t, !1)) this._disallowedElements.add(e.view);
      }
      allowEmptyElement(t) {
        for (const e of this._dataSchema.getDefinitionsForView(t, !0)) e.isInline && this._dataSchema.extendInlineElement({
          ...e,
          allowEmpty: !0
        });
      }
      allowAttributes(t) {
        this._allowedAttributes.add(t);
      }
      disallowAttributes(t) {
        this._disallowedAttributes.add(t);
      }
      processViewAttributes(t, e) {
        const {
          consumable: n
        } = e;
        return dx(t, this._disallowedAttributes, n), function (t, _ref130) {
          let {
            attributes: e,
            classes: n,
            styles: i
          } = _ref130;
          if (!e.length && !n.length && !i.length) return null;
          return {
            ...(e.length && {
              attributes: ux(t, e)
            }),
            ...(i.length && {
              styles: hx(t, i)
            }),
            ...(n.length && {
              classes: n
            })
          };
        }(t, dx(t, this._allowedAttributes, n));
      }
      _addAllowedElement(t) {
        if (!this._allowedElements.has(t)) {
          if (this._allowedElements.add(t), "appliesToBlock" in t && "string" == typeof t.appliesToBlock) for (const e of this._dataSchema.getDefinitionsForModel(t.appliesToBlock)) e.isBlock && this._addAllowedElement(e);
          this._dataInitialized && this.editor.data.once("set", () => {
            this._fireRegisterEvent(t);
          }, {
            priority: f.highest + 1
          });
        }
      }
      _registerElementsAfterInit() {
        this.editor.data.on("init", () => {
          this._dataInitialized = !0;
          for (const t of this._allowedElements) this._fireRegisterEvent(t);
        }, {
          priority: f.highest + 1
        });
      }
      _registerElementHandlers() {
        this.on("register", (t, e) => {
          const n = this.editor.model.schema;
          if (e.isObject && !n.isRegistered(e.model)) this._registerObjectElement(e);else if (e.isBlock) this._registerBlockElement(e);else {
            if (!e.isInline) throw new b("data-filter-invalid-definition", null, e);
            this._registerInlineElement(e);
          }
          t.stop();
        }, {
          priority: "lowest"
        });
      }
      _registerCoupledAttributesPostFixer() {
        const t = this.editor.model,
          e = t.document.selection;
        t.document.registerPostFixer(e => {
          const n = t.document.differ.getChanges();
          let i = !1;
          const o = this._getCoupledAttributesMap();
          for (const t of n) {
            if ("attribute" != t.type || null !== t.attributeNewValue) continue;
            const n = o.get(t.attributeKey);
            if (n) for (const {
              item: o
            } of t.range.getWalker()) for (const t of n) o.hasAttribute(t) && (e.removeAttribute(t, o), i = !0);
          }
          return i;
        }), this.listenTo(e, "change:attribute", (n, _ref131) => {
          let {
            attributeKeys: i
          } = _ref131;
          const o = new Set(),
            r = this._getCoupledAttributesMap();
          for (const t of i) {
            if (e.hasAttribute(t)) continue;
            const n = r.get(t);
            if (n) for (const t of n) e.hasAttribute(t) && o.add(t);
          }
          0 != o.size && t.change(t => {
            for (const e of o) t.removeSelectionAttribute(e);
          });
        });
      }
      _registerAssociatedHtmlAttributesPostFixer() {
        const t = this.editor.model;
        t.document.registerPostFixer(e => {
          const n = t.document.differ.getChanges();
          let i = !1;
          for (const o of n) if ("insert" === o.type && "$text" !== o.name) for (const n of o.attributes.keys()) n.startsWith("html") && n.endsWith("Attributes") && (t.schema.checkAttribute(o.name, n) || (e.removeAttribute(n, o.position.nodeAfter), i = !0));
          return i;
        });
      }
      _getCoupledAttributesMap() {
        if (this._coupledAttributes) return this._coupledAttributes;
        this._coupledAttributes = new Map();
        for (const t of this._allowedElements) if (t.coupledAttribute && t.model) {
          const e = this._coupledAttributes.get(t.coupledAttribute);
          e ? e.push(t.model) : this._coupledAttributes.set(t.coupledAttribute, [t.model]);
        }
        return this._coupledAttributes;
      }
      _fireRegisterEvent(t) {
        t.view && this._disallowedElements.has(t.view) || this.fire(t.view ? `register:${t.view}` : "register", t);
      }
      _registerObjectElement(t) {
        const e = this.editor,
          n = e.model.schema,
          i = e.conversion,
          {
            view: o,
            model: r
          } = t;
        n.register(r, t.modelSchema), o && (n.extend(t.model, {
          allowAttributes: [Ky(o), "htmlContent"]
        }), e.data.registerRawContentMatcher({
          name: o
        }), i.for("upcast").elementToElement({
          view: o,
          model: Yy(t),
          converterPriority: f.low + 2
        }), i.for("upcast").add(ex(t, this)), i.for("editingDowncast").elementToStructure({
          model: {
            name: r,
            attributes: [Ky(o)]
          },
          view: Qy(e, t)
        }), i.for("dataDowncast").elementToElement({
          model: r,
          view: (t, _ref132) => {
            let {
              writer: e
            } = _ref132;
            return Zy(o, t, e);
          }
        }), i.for("dataDowncast").add(nx(t)));
      }
      _registerBlockElement(t) {
        const e = this.editor,
          n = e.model.schema,
          i = e.conversion,
          {
            view: o,
            model: r
          } = t;
        if (!n.isRegistered(t.model)) {
          if (n.register(t.model, t.modelSchema), !o) return;
          i.for("upcast").elementToElement({
            model: r,
            view: o,
            converterPriority: f.low + 2
          }), i.for("downcast").elementToElement({
            model: r,
            view: o
          });
        }
        o && (n.extend(t.model, {
          allowAttributes: Ky(o)
        }), i.for("upcast").add(ex(t, this)), i.for("downcast").add(nx(t)));
      }
      _registerInlineElement(t) {
        const e = this.editor,
          n = e.model.schema,
          i = e.conversion,
          o = t.model;
        t.appliesToBlock || (n.extend("$text", {
          allowAttributes: o
        }), t.attributeProperties && n.setAttributeProperties(o, t.attributeProperties), i.for("upcast").add(Jy(t, this)), i.for("downcast").attributeToElement({
          model: o,
          view: tx(t)
        }), t.allowEmpty && (n.setAttributeProperties(o, {
          copyFromObject: !1
        }), n.isRegistered("htmlEmptyElement") || n.register("htmlEmptyElement", {
          inheritAllFrom: "$inlineObject"
        }), e.data.htmlProcessor.domConverter.registerInlineObjectMatcher(e => e.name == t.view && e.isEmpty && Array.from(e.getAttributeKeys()).length ? {
          name: !0
        } : null), i.for("editingDowncast").elementToElement({
          model: "htmlEmptyElement",
          view: Xy(t, !0)
        }), i.for("dataDowncast").elementToElement({
          model: "htmlEmptyElement",
          view: Xy(t)
        })));
      }
    }
    function dx(t, e, n) {
      const i = e.matchAll(t) || [],
        o = t.document.stylesProcessor;
      return i.reduce((e, _ref133) => {
        let {
          match: i
        } = _ref133;
        for (const r of i.styles || []) {
          const i = o.getRelatedStyles(r).filter(t => t.split("-").length > r.split("-").length).sort((t, e) => e.split("-").length - t.split("-").length);
          for (const o of i) n.consume(t, {
            styles: [o]
          }) && e.styles.push(o);
          n.consume(t, {
            styles: [r]
          }) && e.styles.push(r);
        }
        for (const o of i.classes || []) n.consume(t, {
          classes: [o]
        }) && e.classes.push(o);
        for (const o of i.attributes || []) n.consume(t, {
          attributes: [o]
        }) && e.attributes.push(o);
        return e;
      }, {
        attributes: [],
        classes: [],
        styles: []
      });
    }
    function ux(t, e) {
      const n = {};
      for (const i of e) {
        const e = t.getAttribute(i);
        void 0 !== e && Yi(i) && (n[i] = e);
      }
      return n;
    }
    function hx(t, e) {
      const n = new Ns(t.document.stylesProcessor);
      for (const i of e) {
        const e = t.getStyle(i);
        void 0 !== e && n.set(i, e);
      }
      return Object.fromEntries(n.getStylesEntries());
    }
    function mx(t, e) {
      const {
          name: n
        } = t,
        i = t[e];
      return yt(i) ? Object.entries(i).map(_ref134 => {
        let [t, i] = _ref134;
        return {
          name: n,
          [e]: {
            [t]: i
          }
        };
      }) : Array.isArray(i) ? i.map(t => ({
        name: n,
        [e]: [t]
      })) : [t];
    }
    function gx(t) {
      const {
          name: e,
          attributes: n,
          classes: i,
          styles: o
        } = t,
        r = [];
      return n && r.push(...mx({
        name: e,
        attributes: n
      }, "attributes")), i && r.push(...mx({
        name: e,
        classes: i
      }, "classes")), o && r.push(...mx({
        name: e,
        styles: o
      }, "styles")), r;
    }
    class px extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "CodeBlockElementSupport";
      }
      init() {
        if (!this.editor.plugins.has("CodeBlockEditing")) return;
        const t = this.editor.plugins.get(cx);
        t.on("register:pre", (e, n) => {
          if ("codeBlock" !== n.model) return;
          const i = this.editor,
            o = i.model.schema,
            r = i.conversion;
          o.extend("codeBlock", {
            allowAttributes: ["htmlPreAttributes", "htmlContentAttributes"]
          }), r.for("upcast").add(function (t) {
            return e => {
              e.on("element:code", (e, n, i) => {
                const o = n.viewItem,
                  r = o.parent;
                function s(e, o) {
                  const r = t.processViewAttributes(e, i);
                  r && i.writer.setAttribute(o, r, n.modelRange);
                }
                r && r.is("element", "pre") && (s(r, "htmlPreAttributes"), s(o, "htmlContentAttributes"));
              }, {
                priority: "low"
              });
            };
          }(t)), r.for("downcast").add(t => {
            t.on("attribute:htmlPreAttributes:codeBlock", (t, e, n) => {
              if (!n.consumable.consume(e.item, t.name)) return;
              const {
                  attributeOldValue: i,
                  attributeNewValue: o
                } = e,
                r = n.mapper.toViewElement(e.item).parent;
              Gy(n.writer, i, o, r);
            }), t.on("attribute:htmlContentAttributes:codeBlock", (t, e, n) => {
              if (!n.consumable.consume(e.item, t.name)) return;
              const {
                  attributeOldValue: i,
                  attributeNewValue: o
                } = e,
                r = n.mapper.toViewElement(e.item);
              Gy(n.writer, i, o, r);
            });
          }), e.stop();
        });
      }
    }
    class fx extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "DualContentModelElementSupport";
      }
      init() {
        this.editor.plugins.get(cx).on("register", (t, e) => {
          const n = e,
            i = this.editor,
            o = i.model.schema,
            r = i.conversion;
          if (!n.paragraphLikeModel) return;
          if (o.isRegistered(n.model) || o.isRegistered(n.paragraphLikeModel)) return;
          const s = {
            model: n.paragraphLikeModel,
            view: n.view
          };
          o.register(n.model, n.modelSchema), o.register(s.model, {
            inheritAllFrom: "$block"
          }), r.for("upcast").elementToElement({
            view: n.view,
            model: (t, _ref135) => {
              let {
                writer: e
              } = _ref135;
              return this._hasBlockContent(t) ? e.createElement(n.model) : e.createElement(s.model);
            },
            converterPriority: f.low + .5
          }), r.for("downcast").elementToElement({
            view: n.view,
            model: n.model
          }), this._addAttributeConversion(n), r.for("downcast").elementToElement({
            view: s.view,
            model: s.model
          }), this._addAttributeConversion(s), t.stop();
        });
      }
      _hasBlockContent(t) {
        const e = this.editor.editing.view,
          n = e.domConverter.blockElements;
        for (const i of e.createRangeIn(t).getItems()) if (i.is("element") && n.includes(i.name)) return !0;
        return !1;
      }
      _addAttributeConversion(t) {
        const e = this.editor,
          n = e.conversion,
          i = e.plugins.get(cx);
        e.model.schema.extend(t.model, {
          allowAttributes: Ky(t.view)
        }), n.for("upcast").add(ex(t, i)), n.for("downcast").add(nx(t));
      }
    }
    class kx extends Nr {
      static get requires() {
        return [sx, bw];
      }
      static get pluginName() {
        return "HeadingElementSupport";
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("HeadingEditing")) return;
        const e = t.config.get("heading.options");
        this.registerHeadingElements(t, e);
      }
      registerHeadingElements(t, e) {
        const n = t.plugins.get(sx),
          i = [];
        for (const t of e) "model" in t && "view" in t && (n.registerBlockElement({
          view: t.view,
          model: t.model
        }), i.push(t.model));
        n.extendBlockElement({
          model: "htmlHgroup",
          modelSchema: {
            allowChildren: i
          }
        });
      }
    }
    function bx(t, e, n) {
      const i = t.createRangeOn(e);
      for (const {
        item: t
      } of i.getWalker()) if (t.is("element", n)) return t;
    }
    class wx extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "ImageElementSupport";
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("ImageInlineEditing") && !t.plugins.has("ImageBlockEditing")) return;
        const e = t.model.schema,
          n = t.conversion,
          i = t.plugins.get(cx);
        i.on("register:figure", () => {
          n.for("upcast").add(function (t) {
            return e => {
              e.on("element:figure", (e, n, i) => {
                const o = n.viewItem;
                if (!n.modelRange || !o.hasClass("image")) return;
                const r = t.processViewAttributes(o, i);
                r && i.writer.setAttribute("htmlFigureAttributes", r, n.modelRange);
              }, {
                priority: "low"
              });
            };
          }(i));
        }), i.on("register:img", (o, r) => {
          "imageBlock" !== r.model && "imageInline" !== r.model || (e.isRegistered("imageBlock") && e.extend("imageBlock", {
            allowAttributes: ["htmlImgAttributes", "htmlFigureAttributes", "htmlLinkAttributes"]
          }), e.isRegistered("imageInline") && e.extend("imageInline", {
            allowAttributes: ["htmlA", "htmlImgAttributes"]
          }), n.for("upcast").add(function (t) {
            return e => {
              e.on("element:img", (e, n, i) => {
                if (!n.modelRange) return;
                const o = n.viewItem,
                  r = t.processViewAttributes(o, i);
                r && i.writer.setAttribute("htmlImgAttributes", r, n.modelRange);
              }, {
                priority: "low"
              });
            };
          }(i)), n.for("downcast").add(t => {
            function e(e) {
              t.on(`attribute:${e}:imageInline`, (t, e, n) => {
                if (!n.consumable.consume(e.item, t.name)) return;
                const {
                    attributeOldValue: i,
                    attributeNewValue: o
                  } = e,
                  r = n.mapper.toViewElement(e.item);
                Gy(n.writer, i, o, r);
              }, {
                priority: "low"
              });
            }
            function n(e, n) {
              t.on(`attribute:${n}:imageBlock`, (t, n, i) => {
                if (!i.consumable.test(n.item, t.name)) return;
                const {
                    attributeOldValue: o,
                    attributeNewValue: r
                  } = n,
                  s = i.mapper.toViewElement(n.item),
                  a = bx(i.writer, s, e);
                a && (Gy(i.writer, o, r, a), i.consumable.consume(n.item, t.name));
              }, {
                priority: "low"
              }), "a" === e && t.on("attribute:linkHref:imageBlock", (t, e, n) => {
                if (!n.consumable.consume(e.item, "attribute:htmlLinkAttributes:imageBlock")) return;
                const i = n.mapper.toViewElement(e.item),
                  o = bx(n.writer, i, "a");
                Wy(n.writer, e.item.getAttribute("htmlLinkAttributes"), o);
              }, {
                priority: "low"
              });
            }
            e("htmlImgAttributes"), n("img", "htmlImgAttributes"), n("figure", "htmlFigureAttributes"), n("a", "htmlLinkAttributes");
          }), t.plugins.has("LinkImage") && n.for("upcast").add(function (t, e) {
            const n = e.plugins.get("ImageUtils");
            return e => {
              e.on("element:a", (e, i, o) => {
                const r = i.viewItem;
                if (!n.findViewImgElement(r)) return;
                const s = i.modelCursor.parent;
                if (!s.is("element", "imageBlock")) return;
                const a = t.processViewAttributes(r, o);
                a && o.writer.setAttribute("htmlLinkAttributes", a, s);
              }, {
                priority: "low"
              });
            };
          }(i, t)), o.stop());
        });
      }
    }
    class Ax extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "MediaEmbedElementSupport";
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("MediaEmbed") || t.config.get("mediaEmbed.previewsInData")) return;
        const e = t.model.schema,
          n = t.conversion,
          i = this.editor.plugins.get(cx),
          o = this.editor.plugins.get(sx),
          r = t.config.get("mediaEmbed.elementName");
        o.registerBlockElement({
          model: "media",
          view: r
        }), i.on("register:figure", () => {
          n.for("upcast").add(function (t) {
            return e => {
              e.on("element:figure", (e, n, i) => {
                const o = n.viewItem;
                if (!n.modelRange || !o.hasClass("media")) return;
                const r = t.processViewAttributes(o, i);
                r && i.writer.setAttribute("htmlFigureAttributes", r, n.modelRange);
              }, {
                priority: "low"
              });
            };
          }(i));
        }), i.on(`register:${r}`, (t, o) => {
          "media" === o.model && (e.extend("media", {
            allowAttributes: [Ky(r), "htmlFigureAttributes"]
          }), n.for("upcast").add(function (t, e) {
            const n = (n, i, o) => {
              function r(e, n) {
                const r = t.processViewAttributes(e, o);
                r && o.writer.setAttribute(n, r, i.modelRange);
              }
              r(i.viewItem, Ky(e));
            };
            return t => {
              t.on(`element:${e}`, n, {
                priority: "low"
              });
            };
          }(i, r)), n.for("dataDowncast").add(function (t) {
            return e => {
              function n(t, n) {
                e.on(`attribute:${n}:media`, (e, n, i) => {
                  if (!i.consumable.consume(n.item, e.name)) return;
                  const {
                      attributeOldValue: o,
                      attributeNewValue: r
                    } = n,
                    s = i.mapper.toViewElement(n.item),
                    a = bx(i.writer, s, t);
                  Gy(i.writer, o, r, a);
                });
              }
              n(t, Ky(t)), n("figure", "htmlFigureAttributes");
            };
          }(r)), t.stop());
        });
      }
    }
    class Cx extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "ScriptElementSupport";
      }
      init() {
        const t = this.editor.plugins.get(cx);
        t.on("register:script", (e, n) => {
          const i = this.editor,
            o = i.model.schema,
            r = i.conversion;
          o.register("htmlScript", n.modelSchema), o.extend("htmlScript", {
            allowAttributes: ["htmlScriptAttributes", "htmlContent"],
            isContent: !0
          }), i.data.registerRawContentMatcher({
            name: "script"
          }), r.for("upcast").elementToElement({
            view: "script",
            model: Yy(n)
          }), r.for("upcast").add(ex(n, t)), r.for("downcast").elementToElement({
            model: "htmlScript",
            view: (t, _ref136) => {
              let {
                writer: e
              } = _ref136;
              return Zy("script", t, e);
            }
          }), r.for("downcast").add(nx(n)), e.stop();
        });
      }
    }
    class _x extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "TableElementSupport";
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("TableEditing")) return;
        const e = t.model.schema,
          n = t.conversion,
          i = t.plugins.get(cx),
          o = t.plugins.get("TableUtils");
        i.on("register:figure", () => {
          n.for("upcast").add(function (t) {
            return e => {
              e.on("element:figure", (e, n, i) => {
                const o = n.viewItem;
                if (!n.modelRange || !o.hasClass("table")) return;
                const r = t.processViewAttributes(o, i);
                r && i.writer.setAttribute("htmlFigureAttributes", r, n.modelRange);
              }, {
                priority: "low"
              });
            };
          }(i));
        }), i.on("register:table", (r, s) => {
          "table" === s.model && (e.extend("table", {
            allowAttributes: ["htmlTableAttributes", "htmlFigureAttributes", "htmlTheadAttributes", "htmlTbodyAttributes"]
          }), n.for("upcast").add(function (t) {
            return e => {
              e.on("element:table", (e, n, i) => {
                if (!n.modelRange) return;
                const o = n.viewItem;
                r(o, "htmlTableAttributes");
                for (const t of o.getChildren()) t.is("element", "thead") && r(t, "htmlTheadAttributes"), t.is("element", "tbody") && r(t, "htmlTbodyAttributes");
                function r(e, o) {
                  const r = t.processViewAttributes(e, i);
                  r && i.writer.setAttribute(o, r, n.modelRange);
                }
              }, {
                priority: "low"
              });
            };
          }(i)), n.for("downcast").add(t => {
            function e(e, n) {
              t.on(`attribute:${n}:table`, (t, n, i) => {
                if (!i.consumable.test(n.item, t.name)) return;
                const o = i.mapper.toViewElement(n.item),
                  r = bx(i.writer, o, e);
                r && (i.consumable.consume(n.item, t.name), Gy(i.writer, n.attributeOldValue, n.attributeNewValue, r));
              });
            }
            e("table", "htmlTableAttributes"), e("figure", "htmlFigureAttributes"), e("thead", "htmlTheadAttributes"), e("tbody", "htmlTbodyAttributes");
          }), t.model.document.registerPostFixer(function (t, e) {
            return n => {
              const i = t.document.differ.getChanges();
              let o = !1;
              for (const t of i) {
                if ("attribute" != t.type || "headingRows" != t.attributeKey) continue;
                const i = t.range.start.nodeAfter,
                  r = i.getAttribute("htmlTheadAttributes"),
                  s = i.getAttribute("htmlTbodyAttributes");
                r && !t.attributeNewValue ? (n.removeAttribute("htmlTheadAttributes", i), o = !0) : s && t.attributeNewValue == e.getRows(i) && (n.removeAttribute("htmlTbodyAttributes", i), o = !0);
              }
              return o;
            };
          }(t.model, o)), r.stop());
        });
      }
    }
    class vx extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "StyleElementSupport";
      }
      init() {
        const t = this.editor.plugins.get(cx);
        t.on("register:style", (e, n) => {
          const i = this.editor,
            o = i.model.schema,
            r = i.conversion;
          o.register("htmlStyle", n.modelSchema), o.extend("htmlStyle", {
            allowAttributes: ["htmlStyleAttributes", "htmlContent"],
            isContent: !0
          }), i.data.registerRawContentMatcher({
            name: "style"
          }), r.for("upcast").elementToElement({
            view: "style",
            model: Yy(n)
          }), r.for("upcast").add(ex(n, t)), r.for("downcast").elementToElement({
            model: "htmlStyle",
            view: (t, _ref137) => {
              let {
                writer: e
              } = _ref137;
              return Zy("style", t, e);
            }
          }), r.for("downcast").add(nx(n)), e.stop();
        });
      }
    }
    class yx extends Nr {
      static get requires() {
        return [cx];
      }
      static get pluginName() {
        return "ListElementSupport";
      }
      init() {
        const t = this.editor;
        if (!t.plugins.has("ListEditing")) return;
        const e = t.model.schema,
          n = t.conversion,
          i = t.plugins.get(cx),
          o = t.plugins.get("ListEditing"),
          r = t.plugins.get("ListUtils"),
          s = ["ul", "ol", "li"];
        o.registerDowncastStrategy({
          scope: "item",
          attributeName: "htmlLiAttributes",
          setAttributeOnDowncast: Wy
        }), o.registerDowncastStrategy({
          scope: "list",
          attributeName: "htmlUlAttributes",
          setAttributeOnDowncast: Wy
        }), o.registerDowncastStrategy({
          scope: "list",
          attributeName: "htmlOlAttributes",
          setAttributeOnDowncast: Wy
        }), i.on("register", (t, o) => {
          if (!s.includes(o.view)) return;
          if (t.stop(), e.checkAttribute("$block", "htmlLiAttributes")) return;
          const r = s.map(t => Ky(t));
          e.extend("$listItem", {
            allowAttributes: r
          }), n.for("upcast").add(t => {
            t.on("element:ul", xx("htmlUlAttributes", i), {
              priority: "low"
            }), t.on("element:ol", xx("htmlOlAttributes", i), {
              priority: "low"
            }), t.on("element:li", xx("htmlLiAttributes", i), {
              priority: "low"
            });
          });
        }), o.on("postFixer", (t, _ref138) => {
          let {
            listNodes: e,
            writer: n
          } = _ref138;
          for (const {
            node: i,
            previousNodeInList: o
          } of e) if (o) {
            if (o.getAttribute("listType") == i.getAttribute("listType")) {
              const e = Ex(o.getAttribute("listType")),
                r = o.getAttribute(e);
              !Yd(i.getAttribute(e), r) && n.model.schema.checkAttribute(i, e) && (n.setAttribute(e, r, i), t.return = !0);
            }
            if (o.getAttribute("listItemId") == i.getAttribute("listItemId")) {
              const e = o.getAttribute("htmlLiAttributes");
              !Yd(i.getAttribute("htmlLiAttributes"), e) && n.model.schema.checkAttribute(i, "htmlLiAttributes") && (n.setAttribute("htmlLiAttributes", e, i), t.return = !0);
            }
          }
        }), o.on("postFixer", (t, _ref139) => {
          let {
            listNodes: e,
            writer: n
          } = _ref139;
          for (const {
            node: i
          } of e) {
            const e = i.getAttribute("listType");
            !r.isNumberedListType(e) && i.getAttribute("htmlOlAttributes") && (n.removeAttribute("htmlOlAttributes", i), t.return = !0), r.isNumberedListType(e) && i.getAttribute("htmlUlAttributes") && (n.removeAttribute("htmlUlAttributes", i), t.return = !0);
          }
        });
      }
      afterInit() {
        const t = this.editor;
        if (!t.commands.get("indentList")) return;
        const e = t.commands.get("indentList");
        this.listenTo(e, "afterExecute", (e, n) => {
          t.model.change(e => {
            for (const i of n) {
              const n = Ex(i.getAttribute("listType"));
              t.model.schema.checkAttribute(i, n) && e.setAttribute(n, {}, i);
            }
          });
        });
      }
    }
    function xx(t, e) {
      return (n, i, o) => {
        const r = i.viewItem;
        i.modelRange || Object.assign(i, o.convertChildren(i.viewItem, i.modelCursor));
        const s = e.processViewAttributes(r, o);
        for (const e of i.modelRange.getItems({
          shallow: !0
        })) e.hasAttribute("listItemId") && (e.hasAttribute("htmlUlAttributes") || e.hasAttribute("htmlOlAttributes") || o.writer.model.schema.checkAttribute(e, t) && o.writer.setAttribute(t, s || {}, e));
      };
    }
    function Ex(t) {
      return "numbered" === t || "customNumbered" == t ? "htmlOlAttributes" : "htmlUlAttributes";
    }
    class Dx extends Nr {
      static get requires() {
        return [cx, sx];
      }
      static get pluginName() {
        return "CustomElementSupport";
      }
      init() {
        const t = this.editor.plugins.get(cx),
          e = this.editor.plugins.get(sx);
        t.on("register:$customElement", (n, i) => {
          n.stop();
          const o = this.editor,
            r = o.model.schema,
            s = o.conversion,
            a = o.editing.view.domConverter.unsafeElements,
            l = o.data.htmlProcessor.domConverter.preElements;
          r.register(i.model, i.modelSchema), r.extend(i.model, {
            allowAttributes: ["htmlElementName", "htmlCustomElementAttributes", "htmlContent"],
            isContent: !0
          }), o.data.htmlProcessor.domConverter.registerRawContentMatcher({
            name: "template"
          }), s.for("upcast").elementToElement({
            view: /.*/,
            model: (n, r) => {
              if ("$comment" == n.name) return null;
              if (!function (t) {
                try {
                  document.createElement(t);
                } catch (t) {
                  return !1;
                }
                return !0;
              }(n.name)) return null;
              if (e.getDefinitionsForView(n.name).size) return null;
              a.includes(n.name) || a.push(n.name), l.includes(n.name) || l.push(n.name);
              const s = r.writer.createElement(i.model, {
                  htmlElementName: n.name
                }),
                c = t.processViewAttributes(n, r);
              let d;
              if (c && r.writer.setAttribute("htmlCustomElementAttributes", c, s), n.is("element", "template") && n.getCustomProperty("$rawContent")) d = n.getCustomProperty("$rawContent");else {
                const t = new th(n.document).createDocumentFragment(n),
                  e = o.data.htmlProcessor.domConverter.viewToDom(t),
                  i = e.firstChild;
                for (; i.firstChild;) e.appendChild(i.firstChild);
                i.remove(), d = o.data.htmlProcessor.htmlWriter.getHtml(e);
              }
              r.writer.setAttribute("htmlContent", d, s);
              for (const {
                item: t
              } of o.editing.view.createRangeIn(n)) r.consumable.consume(t, {
                name: !0
              });
              return s;
            },
            converterPriority: "low"
          }), s.for("editingDowncast").elementToElement({
            model: {
              name: i.model,
              attributes: ["htmlElementName", "htmlCustomElementAttributes", "htmlContent"]
            },
            view: (t, _ref140) => {
              let {
                writer: e
              } = _ref140;
              const n = t.getAttribute("htmlElementName"),
                i = e.createRawElement(n);
              return t.hasAttribute("htmlCustomElementAttributes") && Wy(e, t.getAttribute("htmlCustomElementAttributes"), i), i;
            }
          }), s.for("dataDowncast").elementToElement({
            model: {
              name: i.model,
              attributes: ["htmlElementName", "htmlCustomElementAttributes", "htmlContent"]
            },
            view: (t, _ref141) => {
              let {
                writer: e
              } = _ref141;
              const n = t.getAttribute("htmlElementName"),
                i = t.getAttribute("htmlContent"),
                o = e.createRawElement(n, null, (t, e) => {
                  e.setContentOf(t, i);
                });
              return t.hasAttribute("htmlCustomElementAttributes") && Wy(e, t.getAttribute("htmlCustomElementAttributes"), o), o;
            }
          });
        });
      }
    }
    function* Bx(t, e, n) {
      if (e) if (!(Symbol.iterator in e) && e.is("documentSelection") && e.isCollapsed) t.schema.checkAttributeInSelection(e, n) && (yield e);else for (const i of function (t, e, n) {
        return !(Symbol.iterator in e) && (e.is("node") || e.is("$text") || e.is("$textProxy")) ? t.schema.checkAttribute(e, n) ? [t.createRangeOn(e)] : [] : t.schema.getValidRanges(t.createSelection(e).getRanges(), n);
      }(t, e, n)) yield* i.getItems({
        shallow: !0
      });
    }
    function Sx(t) {
      return t.createContainerElement("figure", {
        class: "image"
      }, [t.createEmptyElement("img"), t.createSlot("children")]);
    }
    function Tx(t, e) {
      const n = t.plugins.get("ImageUtils"),
        i = t.plugins.has("ImageInlineEditing") && t.plugins.has("ImageBlockEditing");
      return t => {
        if (!n.isInlineImageView(t)) return null;
        if (!i) return o(t);
        return ("block" == t.getStyle("display") || t.findAncestor(n.isBlockImageView) ? "imageBlock" : "imageInline") !== e ? null : o(t);
      };
      function o(t) {
        const e = {
          name: !0
        };
        return t.hasAttribute("src") && (e.attributes = ["src"]), e;
      }
    }
    function Ix(t, e) {
      const n = $o(e.getSelectedBlocks());
      return !n || t.isObject(n) || n.isEmpty && "listItem" != n.name ? "imageBlock" : "imageInline";
    }
    function Mx(t) {
      return t && t.endsWith("px") ? parseInt(t) : null;
    }
    function Lx(t) {
      const e = Mx(t.getStyle("width")),
        n = Mx(t.getStyle("height"));
      return !(!e || !n);
    }
    const Nx = /^(image|image-inline)$/;
    class zx extends Nr {
      constructor() {
        super(...arguments), this._domEmitter = new (Bi())();
      }
      static get pluginName() {
        return "ImageUtils";
      }
      isImage(t) {
        return this.isInlineImage(t) || this.isBlockImage(t);
      }
      isInlineImageView(t) {
        return !!t && t.is("element", "img");
      }
      isBlockImageView(t) {
        return !!t && t.is("element", "figure") && t.hasClass("image");
      }
      insertImage() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const o = this.editor,
          r = o.model,
          s = r.document.selection,
          a = Px(o, e || s, n);
        t = {
          ...Object.fromEntries(s.getAttributes()),
          ...t
        };
        for (const e in t) r.schema.checkAttribute(a, e) || delete t[e];
        return r.change(n => {
          const {
              setImageSizes: o = !0
            } = i,
            s = n.createElement(a, t);
          return r.insertObject(s, e, null, {
            setSelection: "on",
            findOptimalPosition: e || "imageInline" == a ? void 0 : "auto"
          }), s.parent ? (o && this.setImageNaturalSizeAttributes(s), s) : null;
        });
      }
      setImageNaturalSizeAttributes(t) {
        const n = t.getAttribute("src");
        n && (t.getAttribute("width") || t.getAttribute("height") || this.editor.model.change(i => {
          const o = new e.window.Image();
          this._domEmitter.listenTo(o, "load", () => {
            t.getAttribute("width") || t.getAttribute("height") || this.editor.model.enqueueChange(i.batch, e => {
              e.setAttribute("width", o.naturalWidth, t), e.setAttribute("height", o.naturalHeight, t);
            }), this._domEmitter.stopListening(o, "load");
          }), o.src = n;
        }));
      }
      getClosestSelectedImageWidget(t) {
        const e = t.getFirstPosition();
        if (!e) return null;
        const n = t.getSelectedElement();
        if (n && this.isImageWidget(n)) return n;
        let i = e.parent;
        for (; i;) {
          if (i.is("element") && this.isImageWidget(i)) return i;
          i = i.parent;
        }
        return null;
      }
      getClosestSelectedImageElement(t) {
        const e = t.getSelectedElement();
        return this.isImage(e) ? e : t.getFirstPosition().findAncestor("imageBlock");
      }
      getImageWidgetFromImageView(t) {
        return t.findAncestor({
          classes: Nx
        });
      }
      isImageAllowed() {
        const t = this.editor.model.document.selection;
        return function (t, e) {
          const n = Px(t, e, null);
          if ("imageBlock" == n) {
            const n = function (t, e) {
              const n = zw(t, e),
                i = n.start.parent;
              if (i.isEmpty && !i.is("element", "$root")) return i.parent;
              return i;
            }(e, t.model);
            if (t.model.schema.checkChild(n, "imageBlock")) return !0;
          } else if (t.model.schema.checkChild(e.focus, "imageInline")) return !0;
          return !1;
        }(this.editor, t) && function (t) {
          return [...t.focus.getAncestors()].every(t => !t.is("element", "imageBlock"));
        }(t);
      }
      toImageWidget(t, e, n) {
        e.setCustomProperty("image", !0, t);
        return Tw(t, e, {
          label: () => {
            const e = this.findViewImgElement(t).getAttribute("alt");
            return e ? `${e} ${n}` : n;
          }
        });
      }
      isImageWidget(t) {
        return !!t.getCustomProperty("image") && Sw(t);
      }
      isBlockImage(t) {
        return !!t && t.is("element", "imageBlock");
      }
      isInlineImage(t) {
        return !!t && t.is("element", "imageInline");
      }
      findViewImgElement(t) {
        if (this.isInlineImageView(t)) return t;
        const e = this.editor.editing.view;
        for (const {
          item: n
        } of e.createRangeIn(t)) if (this.isInlineImageView(n)) return n;
      }
      destroy() {
        return this._domEmitter.stopListening(), super.destroy();
      }
    }
    function Px(t, e, n) {
      const i = t.model.schema,
        o = t.config.get("image.insert.type");
      return t.plugins.has("ImageBlockEditing") ? t.plugins.has("ImageInlineEditing") ? n || ("inline" === o ? "imageInline" : "auto" !== o ? "imageBlock" : e.is("selection") ? Ix(i, e) : i.checkChild(e, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
    }
    new RegExp(String(/^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source + /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/.source + /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source + /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source));
    class Vx extends Pr {
      refresh() {
        const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!t, this.isEnabled && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
      }
      execute(t) {
        const e = this.editor,
          n = e.plugins.get("ImageUtils"),
          i = e.model,
          o = n.getClosestSelectedImageElement(i.document.selection);
        i.change(e => {
          e.setAttribute("alt", t.newValue, o);
        });
      }
    }
    class Rx extends Nr {
      static get requires() {
        return [zx];
      }
      static get pluginName() {
        return "ImageTextAlternativeEditing";
      }
      init() {
        this.editor.commands.add("imageTextAlternative", new Vx(this.editor));
      }
    }
    var Fx = o(8429),
      Ox = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Fx.A, Ox);
    Fx.A.locals;
    class jx extends Sr {
      constructor(t) {
        super(t);
        const e = this.locale.t;
        this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(e("Save"), Yh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(e("Cancel"), Yh.cancel, "ck-button-cancel", "cancel"), this._focusables = new nr(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.labeledInput, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element), Mr({
          view: this
        }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createButton(t, e, n, i) {
        const o = new mm(this.locale);
        return o.set({
          label: t,
          icon: e,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
      _createLabeledInputView() {
        const t = this.locale.t,
          e = new Fm(this.locale, Lg);
        return e.label = t("Text alternative"), e;
      }
    }
    function Hx(t) {
      const e = t.editing.view,
        n = ef.defaultPositions,
        i = t.plugins.get("ImageUtils");
      return {
        target: e.domConverter.mapViewToDom(i.getClosestSelectedImageWidget(e.document.selection)),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast, n.viewportStickyNorth]
      };
    }
    class Ux extends Nr {
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "ImageTextAlternativeUI";
      }
      init() {
        this._createButton();
      }
      destroy() {
        super.destroy(), this._form && this._form.destroy();
      }
      _createButton() {
        const t = this.editor,
          e = t.t;
        t.ui.componentFactory.add("imageTextAlternative", n => {
          const i = t.commands.get("imageTextAlternative"),
            o = new mm(n);
          return o.set({
            label: e("Change image text alternative"),
            icon: Yh.textAlternative,
            tooltip: !0
          }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", t => !!t), this.listenTo(o, "execute", () => {
            this._showForm();
          }), o;
        });
      }
      _createForm() {
        const t = this.editor,
          e = t.editing.view.document,
          n = t.plugins.get("ImageUtils");
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new (Ir(jx))(t.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
          t.execute("imageTextAlternative", {
            newValue: this._form.labeledInput.fieldView.element.value
          }), this._hideForm(!0);
        }), this.listenTo(this._form, "cancel", () => {
          this._hideForm(!0);
        }), this._form.keystrokes.set("Esc", (t, e) => {
          this._hideForm(!0), e();
        }), this.listenTo(t.ui, "update", () => {
          n.getClosestSelectedImageWidget(e.selection) ? this._isVisible && function (t) {
            const e = t.plugins.get("ContextualBalloon");
            if (t.plugins.get("ImageUtils").getClosestSelectedImageWidget(t.editing.view.document.selection)) {
              const n = Hx(t);
              e.updatePosition(n);
            }
          }(t) : this._hideForm(!0);
        }), Tr({
          emitter: this._form,
          activator: () => this._isVisible,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideForm()
        });
      }
      _showForm() {
        if (this._isVisible) return;
        this._form || this._createForm();
        const t = this.editor,
          e = t.commands.get("imageTextAlternative"),
          n = this._form.labeledInput;
        this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
          view: this._form,
          position: Hx(t)
        }), n.fieldView.value = n.fieldView.element.value = e.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
      }
      _hideForm() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
      }
      get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
      }
      get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
      }
    }
    class qx extends Nr {
      static get requires() {
        return [Rx, Ux];
      }
      static get pluginName() {
        return "ImageTextAlternative";
      }
    }
    function Gx(t, e) {
      const n = (e, n, i) => {
        if (!i.consumable.consume(n.item, e.name)) return;
        const o = i.writer,
          r = i.mapper.toViewElement(n.item),
          s = t.findViewImgElement(r);
        null === n.attributeNewValue ? (o.removeAttribute("srcset", s), o.removeAttribute("sizes", s)) : n.attributeNewValue && (o.setAttribute("srcset", n.attributeNewValue, s), o.setAttribute("sizes", "100vw", s));
      };
      return t => {
        t.on(`attribute:srcset:${e}`, n);
      };
    }
    function Wx(t, e, n) {
      const i = (e, n, i) => {
        if (!i.consumable.consume(n.item, e.name)) return;
        const o = i.writer,
          r = i.mapper.toViewElement(n.item),
          s = t.findViewImgElement(r);
        o.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
      };
      return t => {
        t.on(`attribute:${n}:${e}`, i);
      };
    }
    class $x extends tl {
      observe(t) {
        this.listenTo(t, "load", (t, e) => {
          const n = e.target;
          this.checkShouldIgnoreEventFromTarget(n) || "IMG" == n.tagName && this._fireEvents(e);
        }, {
          useCapture: !0
        });
      }
      stopObserving(t) {
        this.stopListening(t);
      }
      _fireEvents(t) {
        this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
      }
    }
    class Kx extends Pr {
      constructor(t) {
        super(t);
        const e = t.config.get("image.insert.type");
        t.plugins.has("ImageBlockEditing") || "block" === e && w("image-block-plugin-required"), t.plugins.has("ImageInlineEditing") || "inline" === e && w("image-inline-plugin-required");
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils");
        this.isEnabled = t.isImageAllowed();
      }
      execute(t) {
        const e = vo(t.source),
          n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageUtils"),
          o = Object.fromEntries(n.getAttributes());
        e.forEach((t, e) => {
          const r = n.getSelectedElement();
          if ("string" == typeof t && (t = {
            src: t
          }), e && r && i.isImage(r)) {
            const e = this.editor.model.createPositionAfter(r);
            i.insertImage({
              ...t,
              ...o
            }, e);
          } else i.insertImage({
            ...t,
            ...o
          });
        });
      }
    }
    class Yx extends Pr {
      constructor(t) {
        super(t), this.decorate("cleanupImage");
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils"),
          e = this.editor.model.document.selection.getSelectedElement();
        this.isEnabled = t.isImage(e), this.value = this.isEnabled ? e.getAttribute("src") : null;
      }
      execute(t) {
        const e = this.editor.model.document.selection.getSelectedElement(),
          n = this.editor.plugins.get("ImageUtils");
        this.editor.model.change(i => {
          i.setAttribute("src", t.source, e), this.cleanupImage(i, e), n.setImageNaturalSizeAttributes(e);
        });
      }
      cleanupImage(t, e) {
        t.removeAttribute("srcset", e), t.removeAttribute("sizes", e), t.removeAttribute("sources", e), t.removeAttribute("width", e), t.removeAttribute("height", e), t.removeAttribute("alt", e);
      }
    }
    class Qx extends Nr {
      static get requires() {
        return [zx];
      }
      static get pluginName() {
        return "ImageEditing";
      }
      init() {
        const t = this.editor,
          e = t.conversion;
        t.editing.view.addObserver($x), e.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "alt"
          },
          model: "alt"
        }).attributeToAttribute({
          view: {
            name: "img",
            key: "srcset"
          },
          model: "srcset"
        });
        const n = new Kx(t),
          i = new Yx(t);
        t.commands.add("insertImage", n), t.commands.add("replaceImageSource", i), t.commands.add("imageInsert", n);
      }
    }
    class Zx extends Nr {
      static get requires() {
        return [zx];
      }
      static get pluginName() {
        return "ImageSizeAttributes";
      }
      afterInit() {
        this._registerSchema(), this._registerConverters("imageBlock"), this._registerConverters("imageInline");
      }
      _registerSchema() {
        this.editor.plugins.has("ImageBlockEditing") && this.editor.model.schema.extend("imageBlock", {
          allowAttributes: ["width", "height"]
        }), this.editor.plugins.has("ImageInlineEditing") && this.editor.model.schema.extend("imageInline", {
          allowAttributes: ["width", "height"]
        });
      }
      _registerConverters(t) {
        const e = this.editor,
          n = e.plugins.get("ImageUtils"),
          i = "imageBlock" === t ? "figure" : "img";
        function o(e, i, o, r) {
          e.on(`attribute:${i}:${t}`, (e, i, s) => {
            if (!s.consumable.consume(i.item, e.name)) return;
            const a = s.writer,
              l = s.mapper.toViewElement(i.item),
              c = n.findViewImgElement(l);
            if (null !== i.attributeNewValue ? a.setAttribute(o, i.attributeNewValue, c) : a.removeAttribute(o, c), i.item.hasAttribute("sources")) return;
            const d = i.item.hasAttribute("resizedWidth");
            if ("imageInline" === t && !d && !r) return;
            const u = i.item.getAttribute("width"),
              h = i.item.getAttribute("height");
            u && h && a.setStyle("aspect-ratio", `${u}/${h}`, c);
          });
        }
        e.conversion.for("upcast").attributeToAttribute({
          view: {
            name: i,
            styles: {
              width: /.+/
            }
          },
          model: {
            key: "width",
            value: t => Lx(t) ? Mx(t.getStyle("width")) : null
          }
        }).attributeToAttribute({
          view: {
            name: i,
            key: "width"
          },
          model: "width"
        }).attributeToAttribute({
          view: {
            name: i,
            styles: {
              height: /.+/
            }
          },
          model: {
            key: "height",
            value: t => Lx(t) ? Mx(t.getStyle("height")) : null
          }
        }).attributeToAttribute({
          view: {
            name: i,
            key: "height"
          },
          model: "height"
        }), e.conversion.for("editingDowncast").add(t => {
          o(t, "width", "width", !0), o(t, "height", "height", !0);
        }), e.conversion.for("dataDowncast").add(t => {
          o(t, "width", "width", !1), o(t, "height", "height", !1);
        });
      }
    }
    class Jx extends Pr {
      constructor(t, e) {
        super(t), this._modelElementName = e;
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils"),
          e = t.getClosestSelectedImageElement(this.editor.model.document.selection);
        "imageBlock" === this._modelElementName ? this.isEnabled = t.isInlineImage(e) : this.isEnabled = t.isBlockImage(e);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor,
          n = this.editor.model,
          i = e.plugins.get("ImageUtils"),
          o = i.getClosestSelectedImageElement(n.document.selection),
          r = Object.fromEntries(o.getAttributes());
        return r.src || r.uploadId ? n.change(e => {
          const {
              setImageSizes: s = !0
            } = t,
            a = Array.from(n.markers).filter(t => t.getRange().containsItem(o)),
            l = i.insertImage(r, n.createSelection(o, "on"), this._modelElementName, {
              setImageSizes: s
            });
          if (!l) return null;
          const c = e.createRangeOn(l);
          for (const t of a) {
            const n = t.getRange(),
              i = "$graveyard" != n.root.rootName ? n.getJoined(c, !0) : c;
            e.updateMarker(t, {
              range: i
            });
          }
          return {
            oldElement: o,
            newElement: l
          };
        }) : null;
      }
    }
    var Xx = o(1091),
      tE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Xx.A, tE);
    Xx.A.locals;
    class eE extends Nr {
      static get requires() {
        return [zx];
      }
      static get pluginName() {
        return "ImagePlaceholder";
      }
      afterInit() {
        this._setupSchema(), this._setupConversion(), this._setupLoadListener();
      }
      _setupSchema() {
        const t = this.editor.model.schema;
        t.isRegistered("imageBlock") && t.extend("imageBlock", {
          allowAttributes: ["placeholder"]
        }), t.isRegistered("imageInline") && t.extend("imageInline", {
          allowAttributes: ["placeholder"]
        });
      }
      _setupConversion() {
        const t = this.editor,
          e = t.conversion,
          n = t.plugins.get("ImageUtils");
        e.for("editingDowncast").add(t => {
          t.on("attribute:placeholder", (t, e, i) => {
            if (!i.consumable.test(e.item, t.name)) return;
            if (!e.item.is("element", "imageBlock") && !e.item.is("element", "imageInline")) return;
            i.consumable.consume(e.item, t.name);
            const o = i.writer,
              r = i.mapper.toViewElement(e.item),
              s = n.findViewImgElement(r);
            e.attributeNewValue ? (o.addClass("image_placeholder", s), o.setStyle("background-image", `url(${e.attributeNewValue})`, s), o.setCustomProperty("editingPipeline:doNotReuseOnce", !0, s)) : (o.removeClass("image_placeholder", s), o.removeStyle("background-image", s));
          });
        });
      }
      _setupLoadListener() {
        const t = this.editor,
          e = t.model,
          n = t.editing,
          i = n.view,
          o = t.plugins.get("ImageUtils");
        i.addObserver($x), this.listenTo(i.document, "imageLoaded", (t, r) => {
          const s = i.domConverter.mapDomToView(r.target);
          if (!s) return;
          const a = o.getImageWidgetFromImageView(s);
          if (!a) return;
          const l = n.mapper.toModelElement(a);
          l && l.hasAttribute("placeholder") && e.enqueueChange({
            isUndoable: !1
          }, t => {
            t.removeAttribute("placeholder", l);
          });
        });
      }
    }
    class nE extends Nr {
      static get requires() {
        return [Qx, Zx, zx, eE, Mb];
      }
      static get pluginName() {
        return "ImageBlockEditing";
      }
      init() {
        const t = this.editor;
        t.model.schema.register("imageBlock", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), this._setupConversion(), t.plugins.has("ImageInlineEditing") && (t.commands.add("imageTypeBlock", new Jx(this.editor, "imageBlock")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const t = this.editor,
          e = t.t,
          n = t.conversion,
          i = t.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToStructure({
          model: "imageBlock",
          view: (t, _ref142) => {
            let {
              writer: e
            } = _ref142;
            return Sx(e);
          }
        }), n.for("editingDowncast").elementToStructure({
          model: "imageBlock",
          view: (t, _ref143) => {
            let {
              writer: n
            } = _ref143;
            return i.toImageWidget(Sx(n), n, e("image widget"));
          }
        }), n.for("downcast").add(Wx(i, "imageBlock", "src")).add(Wx(i, "imageBlock", "alt")).add(Gx(i, "imageBlock")), n.for("upcast").elementToElement({
          view: Tx(t, "imageBlock"),
          model: (t, _ref144) => {
            let {
              writer: e
            } = _ref144;
            return e.createElement("imageBlock", t.hasAttribute("src") ? {
              src: t.getAttribute("src")
            } : void 0);
          }
        }).add(function (t) {
          const e = (e, n, i) => {
            if (!i.consumable.test(n.viewItem, {
              name: !0,
              classes: "image"
            })) return;
            const o = t.findViewImgElement(n.viewItem);
            if (!o || !i.consumable.test(o, {
              name: !0
            })) return;
            i.consumable.consume(n.viewItem, {
              name: !0,
              classes: "image"
            });
            const r = $o(i.convertItem(o, n.modelCursor).modelRange.getItems());
            r ? (i.convertChildren(n.viewItem, r), i.updateConversionResult(r, n)) : i.consumable.revert(n.viewItem, {
              name: !0,
              classes: "image"
            });
          };
          return t => {
            t.on("element:figure", e);
          };
        }(i));
      }
      _setupClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = t.plugins.get("ImageUtils"),
          o = t.plugins.get("ClipboardPipeline");
        this.listenTo(o, "inputTransformation", (o, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(i.isInlineImageView)) return;
          a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
          const l = e.createSelection(a);
          if ("imageBlock" === Ix(e.schema, l)) {
            const t = new th(n.document),
              e = s.map(e => t.createElement("figure", {
                class: "image"
              }, e));
            r.content = t.createDocumentFragment(e);
          }
        }), this.listenTo(o, "contentInsertion", (t, n) => {
          "paste" === n.method && e.change(t => {
            const e = t.createRangeIn(n.content);
            for (const t of e.getItems()) t.is("element", "imageBlock") && i.setImageNaturalSizeAttributes(t);
          });
        });
      }
    }
    var iE = o(1545),
      oE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(iE.A, oE);
    iE.A.locals;
    class rE extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        super(t), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusables = new nr(), this.children = this.createCollection(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        for (const t of e) this.children.add(t), this._focusables.add(t), t instanceof _m && this._focusables.addMany(t.children);
        if (this._focusables.length > 1) for (const t of this._focusables) sE(t) && (t.focusCycler.on("forwardCycle", t => {
          this._focusCycler.focusNext(), t.stop();
        }), t.focusCycler.on("backwardCycle", t => {
          this._focusCycler.focusPrevious(), t.stop();
        }));
        this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-image-insert-form"],
            tabindex: -1
          },
          children: this.children
        });
      }
      render() {
        super.render(), Mr({
          view: this
        });
        for (const t of this._focusables) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element);
        const t = t => t.stopPropagation();
        this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
    }
    function sE(t) {
      return "focusCycler" in t;
    }
    class aE extends Nr {
      static get pluginName() {
        return "ImageInsertUI";
      }
      static get requires() {
        return [zx];
      }
      constructor(t) {
        super(t), this._integrations = new Map(), t.config.define("image.insert.integrations", ["upload", "assetManager", "url"]);
      }
      init() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("ImageUtils");
        this.set("isImageSelected", !1), this.listenTo(t.model.document, "change", () => {
          this.isImageSelected = n.isImage(e.getSelectedElement());
        });
        const i = t => this._createToolbarComponent(t);
        t.ui.componentFactory.add("insertImage", i), t.ui.componentFactory.add("imageInsert", i);
      }
      registerIntegration(_ref145) {
        let {
          name: t,
          observable: e,
          buttonViewCreator: n,
          formViewCreator: i,
          requiresForm: o
        } = _ref145;
        this._integrations.has(t) && w("image-insert-integration-exists", {
          name: t
        }), this._integrations.set(t, {
          observable: e,
          buttonViewCreator: n,
          formViewCreator: i,
          requiresForm: !!o
        });
      }
      _createToolbarComponent(t) {
        const e = this.editor,
          n = t.t,
          i = this._prepareIntegrations();
        if (!i.length) return null;
        let o;
        const r = i[0];
        if (1 == i.length) {
          if (!r.requiresForm) return r.buttonViewCreator(!0);
          o = r.buttonViewCreator(!0);
        } else {
          const e = r.buttonViewCreator(!1);
          o = new Cg(t, e), o.tooltip = !0, o.bind("label").to(this, "isImageSelected", t => n(t ? "Replace image" : "Insert image"));
        }
        const s = this.dropdownView = Eg(t, o),
          a = i.map(_ref146 => {
            let {
              observable: t
            } = _ref146;
            return "function" == typeof t ? t() : t;
          });
        return s.bind("isEnabled").toMany(a, "isEnabled", function () {
          for (var _len35 = arguments.length, t = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
            t[_key35] = arguments[_key35];
          }
          return t.some(t => t);
        }), s.once("change:isOpen", () => {
          const t = i.map(_ref147 => {
              let {
                formViewCreator: t
              } = _ref147;
              return t(1 == i.length);
            }),
            n = new rE(e.locale, t);
          s.panelView.children.add(n);
        }), s;
      }
      _prepareIntegrations() {
        const t = this.editor.config.get("image.insert.integrations"),
          e = [];
        if (!t.length) return w("image-insert-integrations-not-specified"), e;
        for (const n of t) this._integrations.has(n) ? e.push(this._integrations.get(n)) : ["upload", "assetManager", "url"].includes(n) || w("image-insert-unknown-integration", {
          item: n
        });
        return e.length || w("image-insert-integrations-not-registered"), e;
      }
    }
    var lE = o(8574),
      cE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(lE.A, cE);
    lE.A.locals;
    class dE extends Nr {
      static get requires() {
        return [nE, Jw, qx, aE];
      }
      static get pluginName() {
        return "ImageBlock";
      }
    }
    class uE extends Nr {
      static get requires() {
        return [Qx, Zx, zx, eE, Mb];
      }
      static get pluginName() {
        return "ImageInlineEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        e.register("imageInline", {
          inheritAllFrom: "$inlineObject",
          allowAttributes: ["alt", "src", "srcset"]
        }), e.addChildCheck((t, e) => {
          if (t.endsWith("caption") && "imageInline" === e.name) return !1;
        }), this._setupConversion(), t.plugins.has("ImageBlockEditing") && (t.commands.add("imageTypeInline", new Jx(this.editor, "imageInline")), this._setupClipboardIntegration());
      }
      _setupConversion() {
        const t = this.editor,
          e = t.t,
          n = t.conversion,
          i = t.plugins.get("ImageUtils");
        n.for("dataDowncast").elementToElement({
          model: "imageInline",
          view: (t, _ref148) => {
            let {
              writer: e
            } = _ref148;
            return e.createEmptyElement("img");
          }
        }), n.for("editingDowncast").elementToStructure({
          model: "imageInline",
          view: (t, _ref149) => {
            let {
              writer: n
            } = _ref149;
            return i.toImageWidget(function (t) {
              return t.createContainerElement("span", {
                class: "image-inline"
              }, t.createEmptyElement("img"));
            }(n), n, e("image widget"));
          }
        }), n.for("downcast").add(Wx(i, "imageInline", "src")).add(Wx(i, "imageInline", "alt")).add(Gx(i, "imageInline")), n.for("upcast").elementToElement({
          view: Tx(t, "imageInline"),
          model: (t, _ref150) => {
            let {
              writer: e
            } = _ref150;
            return e.createElement("imageInline", t.hasAttribute("src") ? {
              src: t.getAttribute("src")
            } : void 0);
          }
        });
      }
      _setupClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view,
          i = t.plugins.get("ImageUtils"),
          o = t.plugins.get("ClipboardPipeline");
        this.listenTo(o, "inputTransformation", (o, r) => {
          const s = Array.from(r.content.getChildren());
          let a;
          if (!s.every(i.isBlockImageView)) return;
          a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
          const l = e.createSelection(a);
          if ("imageInline" === Ix(e.schema, l)) {
            const t = new th(n.document),
              e = s.map(e => 1 === e.childCount ? (Array.from(e.getAttributes()).forEach(n => t.setAttribute(...n, i.findViewImgElement(e))), e.getChild(0)) : e);
            r.content = t.createDocumentFragment(e);
          }
        }), this.listenTo(o, "contentInsertion", (t, n) => {
          "paste" === n.method && e.change(t => {
            const e = t.createRangeIn(n.content);
            for (const t of e.getItems()) t.is("element", "imageInline") && i.setImageNaturalSizeAttributes(t);
          });
        });
      }
    }
    class hE extends Nr {
      static get requires() {
        return [uE, Jw, qx, aE];
      }
      static get pluginName() {
        return "ImageInline";
      }
    }
    class mE extends Nr {
      static get pluginName() {
        return "ImageCaptionUtils";
      }
      static get requires() {
        return [zx];
      }
      getCaptionFromImageModelElement(t) {
        for (const e of t.getChildren()) if (e && e.is("element", "caption")) return e;
        return null;
      }
      getCaptionFromModelSelection(t) {
        const e = this.editor.plugins.get("ImageUtils"),
          n = t.getFirstPosition().findAncestor("caption");
        return n && e.isBlockImage(n.parent) ? n : null;
      }
      matchImageCaptionViewElement(t) {
        const e = this.editor.plugins.get("ImageUtils");
        return "figcaption" == t.name && e.isBlockImageView(t.parent) ? {
          name: !0
        } : null;
      }
    }
    class gE extends Pr {
      refresh() {
        const t = this.editor,
          e = t.plugins.get("ImageCaptionUtils"),
          n = t.plugins.get("ImageUtils");
        if (!t.plugins.has(nE)) return this.isEnabled = !1, void (this.value = !1);
        const i = t.model.document.selection,
          o = i.getSelectedElement();
        if (!o) {
          const t = e.getCaptionFromModelSelection(i);
          return this.isEnabled = !!t, void (this.value = !!t);
        }
        this.isEnabled = n.isImage(o), this.isEnabled ? this.value = !!e.getCaptionFromImageModelElement(o) : this.value = !1;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          focusCaptionOnShow: e
        } = t;
        this.editor.model.change(t => {
          this.value ? this._hideImageCaption(t) : this._showImageCaption(t, e);
        });
      }
      _showImageCaption(t, e) {
        const n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageCaptionEditing"),
          o = this.editor.plugins.get("ImageUtils");
        let r = n.getSelectedElement();
        const s = i._getSavedCaption(r);
        o.isInlineImage(r) && (this.editor.execute("imageTypeBlock"), r = n.getSelectedElement());
        const a = s || t.createElement("caption");
        t.append(a, r), e && t.setSelection(a, "in");
      }
      _hideImageCaption(t) {
        const e = this.editor,
          n = e.model.document.selection,
          i = e.plugins.get("ImageCaptionEditing"),
          o = e.plugins.get("ImageCaptionUtils");
        let r,
          s = n.getSelectedElement();
        s ? r = o.getCaptionFromImageModelElement(s) : (r = o.getCaptionFromModelSelection(n), s = r.parent), i._saveCaption(s, r), t.setSelection(s, "on"), t.remove(r);
      }
    }
    class pE extends Nr {
      static get requires() {
        return [zx, mE];
      }
      static get pluginName() {
        return "ImageCaptionEditing";
      }
      constructor(t) {
        super(t), this._savedCaptionsMap = new WeakMap();
      }
      init() {
        const t = this.editor,
          e = t.model.schema;
        e.isRegistered("caption") ? e.extend("caption", {
          allowIn: "imageBlock"
        }) : e.register("caption", {
          allowIn: "imageBlock",
          allowContentOf: "$block",
          isLimit: !0
        }), t.commands.add("toggleImageCaption", new gE(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration(), this._registerCaptionReconversion();
      }
      _setupConversion() {
        const t = this.editor,
          e = t.editing.view,
          n = t.plugins.get("ImageUtils"),
          i = t.plugins.get("ImageCaptionUtils"),
          o = t.t;
        t.conversion.for("upcast").elementToElement({
          view: t => i.matchImageCaptionViewElement(t),
          model: "caption"
        }), t.conversion.for("dataDowncast").elementToElement({
          model: "caption",
          view: (t, _ref151) => {
            let {
              writer: e
            } = _ref151;
            return n.isBlockImage(t.parent) ? e.createContainerElement("figcaption") : null;
          }
        }), t.conversion.for("editingDowncast").elementToElement({
          model: "caption",
          view: (t, _ref152) => {
            let {
              writer: i
            } = _ref152;
            if (!n.isBlockImage(t.parent)) return null;
            const r = i.createEditableElement("figcaption");
            i.setCustomProperty("imageCaption", !0, r), r.placeholder = o("Enter image caption"), Wr({
              view: e,
              element: r,
              keepOnFocus: !0
            });
            const s = t.parent.getAttribute("alt");
            return Nw(r, i, {
              label: s ? o("Caption for image: %0", [s]) : o("Caption for the image")
            });
          }
        });
      }
      _setupImageTypeCommandsIntegration() {
        const t = this.editor,
          e = t.plugins.get("ImageUtils"),
          n = t.plugins.get("ImageCaptionUtils"),
          i = t.commands.get("imageTypeInline"),
          o = t.commands.get("imageTypeBlock"),
          r = t => {
            if (!t.return) return;
            const {
              oldElement: i,
              newElement: o
            } = t.return;
            if (!i) return;
            if (e.isBlockImage(i)) {
              const t = n.getCaptionFromImageModelElement(i);
              if (t) return void this._saveCaption(o, t);
            }
            const r = this._getSavedCaption(i);
            r && this._saveCaption(o, r);
          };
        i && this.listenTo(i, "execute", r, {
          priority: "low"
        }), o && this.listenTo(o, "execute", r, {
          priority: "low"
        });
      }
      _getSavedCaption(t) {
        const e = this._savedCaptionsMap.get(t);
        return e ? ic.fromJSON(e) : null;
      }
      _saveCaption(t, e) {
        this._savedCaptionsMap.set(t, e.toJSON());
      }
      _registerCaptionReconversion() {
        const t = this.editor,
          e = t.model,
          n = t.plugins.get("ImageUtils"),
          i = t.plugins.get("ImageCaptionUtils");
        e.document.on("change:data", () => {
          const o = e.document.differ.getChanges();
          for (const e of o) {
            if ("alt" !== e.attributeKey) continue;
            const o = e.range.start.nodeAfter;
            if (n.isBlockImage(o)) {
              const e = i.getCaptionFromImageModelElement(o);
              if (!e) return;
              t.editing.reconvertItem(e);
            }
          }
        });
      }
    }
    class fE extends Nr {
      static get requires() {
        return [mE];
      }
      static get pluginName() {
        return "ImageCaptionUI";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = t.plugins.get("ImageCaptionUtils"),
          i = t.t;
        t.ui.componentFactory.add("toggleImageCaption", o => {
          const r = t.commands.get("toggleImageCaption"),
            s = new mm(o);
          return s.set({
            icon: Yh.caption,
            tooltip: !0,
            isToggleable: !0
          }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", t => i(t ? "Toggle caption off" : "Toggle caption on")), this.listenTo(s, "execute", () => {
            t.execute("toggleImageCaption", {
              focusCaptionOnShow: !0
            });
            const i = n.getCaptionFromModelSelection(t.model.document.selection);
            if (i) {
              const n = t.editing.mapper.toViewElement(i);
              e.scrollToTheSelection(), e.change(t => {
                t.addClass("image__caption_highlighted", n);
              });
            }
            t.editing.view.focus();
          }), s;
        });
      }
    }
    var kE = o(3038),
      bE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(kE.A, bE);
    kE.A.locals;
    function wE(t) {
      const e = t.map(t => t.replace("+", "\\+"));
      return new RegExp(`^image\\/(${e.join("|")})$`);
    }
    function AE(t) {
      return new Promise((n, i) => {
        const o = t.getAttribute("src");
        fetch(o).then(t => t.blob()).then(t => {
          const e = CE(t, o),
            i = e.replace("image/", ""),
            r = new File([t], `image.${i}`, {
              type: e
            });
          n(r);
        }).catch(t => t && "TypeError" === t.name ? function (t) {
          return function (t) {
            return new Promise((n, i) => {
              const o = e.document.createElement("img");
              o.addEventListener("load", () => {
                const t = e.document.createElement("canvas");
                t.width = o.width, t.height = o.height;
                t.getContext("2d").drawImage(o, 0, 0), t.toBlob(t => t ? n(t) : i());
              }), o.addEventListener("error", () => i()), o.src = t;
            });
          }(t).then(e => {
            const n = CE(e, t),
              i = n.replace("image/", "");
            return new File([e], `image.${i}`, {
              type: n
            });
          });
        }(o).then(n).catch(i) : i(t));
      });
    }
    function CE(t, e) {
      return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
    }
    class _E extends Nr {
      static get pluginName() {
        return "ImageUploadUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = () => {
            const t = this._createButton(km);
            return t.set({
              label: e("Upload image from computer"),
              tooltip: !0
            }), t;
          };
        if (t.ui.componentFactory.add("uploadImage", n), t.ui.componentFactory.add("imageUpload", n), t.ui.componentFactory.add("menuBar:uploadImage", () => {
          const t = this._createButton(qk);
          return t.label = e("Image from computer"), t;
        }), t.plugins.has("ImageInsertUI")) {
          const n = t.plugins.get("ImageInsertUI");
          n.registerIntegration({
            name: "upload",
            observable: () => t.commands.get("uploadImage"),
            buttonViewCreator: () => {
              const i = t.ui.componentFactory.create("uploadImage");
              return i.bind("label").to(n, "isImageSelected", t => e(t ? "Replace image from computer" : "Upload image from computer")), i;
            },
            formViewCreator: () => {
              const i = t.ui.componentFactory.create("uploadImage");
              return i.withText = !0, i.bind("label").to(n, "isImageSelected", t => e(t ? "Replace from computer" : "Upload from computer")), i.on("execute", () => {
                n.dropdownView.isOpen = !1;
              }), i;
            }
          });
        }
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("uploadImage"),
          o = e.config.get("image.upload.types"),
          r = wE(o),
          s = new t(e.locale),
          a = n.t;
        return s.set({
          acceptedType: o.map(t => `image/${t}`).join(","),
          allowMultipleFiles: !0,
          label: a("Upload image from computer"),
          icon: Yh.imageUpload
        }), s.bind("isEnabled").to(i), s.on("done", (t, n) => {
          const i = Array.from(n).filter(t => r.test(t.type));
          i.length && (e.execute("uploadImage", {
            file: i
          }), e.editing.view.focus());
        }), s;
      }
    }
    class vE extends q() {
      constructor() {
        super();
        const t = new window.FileReader();
        this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = t => {
          this.loaded = t.loaded;
        };
      }
      get error() {
        return this._reader.error;
      }
      get data() {
        return this._data;
      }
      read(t) {
        const e = this._reader;
        return this.total = t.size, new Promise((n, i) => {
          e.onload = () => {
            const t = e.result;
            this._data = t, n(t);
          }, e.onerror = () => {
            i("error");
          }, e.onabort = () => {
            i("aborted");
          }, this._reader.readAsDataURL(t);
        });
      }
      abort() {
        this._reader.abort();
      }
    }
    class yE extends Nr {
      constructor() {
        super(...arguments), this.loaders = new Wo(), this._loadersMap = new Map(), this._pendingAction = null;
      }
      static get pluginName() {
        return "FileRepository";
      }
      static get requires() {
        return [Kh];
      }
      init() {
        this.loaders.on("change", () => this._updatePendingAction()), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t, e) => e ? t / e * 100 : 0);
      }
      getLoader(t) {
        return this._loadersMap.get(t) || null;
      }
      createLoader(t) {
        if (!this.createUploadAdapter) return w("filerepository-no-upload-adapter"), null;
        const e = new xE(Promise.resolve(t), this.createUploadAdapter);
        return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(t => {
          this._loadersMap.set(t, e);
        }).catch(() => {}), e.on("change:uploaded", () => {
          let t = 0;
          for (const e of this.loaders) t += e.uploaded;
          this.uploaded = t;
        }), e.on("change:uploadTotal", () => {
          let t = 0;
          for (const e of this.loaders) e.uploadTotal && (t += e.uploadTotal);
          this.uploadTotal = t;
        }), e;
      }
      destroyLoader(t) {
        const e = t instanceof xE ? t : this.getLoader(t);
        e._destroy(), this.loaders.remove(e), this._loadersMap.forEach((t, n) => {
          t === e && this._loadersMap.delete(n);
        });
      }
      _updatePendingAction() {
        const t = this.editor.plugins.get(Kh);
        if (this.loaders.length) {
          if (!this._pendingAction) {
            const e = this.editor.t,
              n = t => `${e("Upload in progress")} ${parseInt(t)}%.`;
            this._pendingAction = t.add(n(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", n);
          }
        } else t.remove(this._pendingAction), this._pendingAction = null;
      }
    }
    class xE extends q() {
      constructor(t, e) {
        super(), this.id = p(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new vE(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t, e) => e ? t / e * 100 : 0), this.set("uploadResponse", null);
      }
      get file() {
        return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(t => this._filePromiseWrapper ? t : null) : Promise.resolve(null);
      }
      get data() {
        return this._reader.data;
      }
      read() {
        if ("idle" != this.status) throw new b("filerepository-read-wrong-status", this);
        return this.status = "reading", this.file.then(t => this._reader.read(t)).then(t => {
          if ("reading" !== this.status) throw this.status;
          return this.status = "idle", t;
        }).catch(t => {
          if ("aborted" === t) throw this.status = "aborted", "aborted";
          throw this.status = "error", this._reader.error ? this._reader.error : t;
        });
      }
      upload() {
        if ("idle" != this.status) throw new b("filerepository-upload-wrong-status", this);
        return this.status = "uploading", this.file.then(() => this._adapter.upload()).then(t => (this.uploadResponse = t, this.status = "idle", t)).catch(t => {
          if ("aborted" === this.status) throw "aborted";
          throw this.status = "error", t;
        });
      }
      abort() {
        const t = this.status;
        this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(() => {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
      }
      _destroy() {
        this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
      }
      _createFilePromiseWrapper(t) {
        const e = {};
        return e.promise = new Promise((n, i) => {
          e.rejecter = i, e.isFulfilled = !1, t.then(t => {
            e.isFulfilled = !0, n(t);
          }).catch(t => {
            e.isFulfilled = !0, i(t);
          });
        }), e;
      }
    }
    var EE = o(7504),
      DE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(EE.A, DE);
    EE.A.locals;
    var BE = o(1230),
      SE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(BE.A, SE);
    BE.A.locals;
    var TE = o(1160),
      IE = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(TE.A, IE);
    TE.A.locals;
    class ME extends Nr {
      static get pluginName() {
        return "ImageUploadProgress";
      }
      constructor(t) {
        super(t), this.uploadStatusChange = (t, e, n) => {
          const i = this.editor,
            o = e.item,
            r = o.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          const s = i.plugins.get("ImageUtils"),
            a = i.plugins.get(yE),
            l = r ? e.attributeNewValue : null,
            c = this.placeholder,
            d = i.editing.mapper.toViewElement(o),
            u = n.writer;
          if ("reading" == l) return LE(d, u), void NE(s, c, d, u);
          if ("uploading" == l) {
            const t = a.loaders.get(r);
            return LE(d, u), void (t ? (zE(d, u), function (t, e, n, i) {
              const o = function (t) {
                const e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);
              e.insert(e.createPositionAt(t, "end"), o), n.on("change:uploadedPercent", (t, e, n) => {
                i.change(t => {
                  t.setStyle("width", n + "%", o);
                });
              });
            }(d, u, t, i.editing.view), function (t, e, n, i) {
              if (i.data) {
                const o = t.findViewImgElement(e);
                n.setAttribute("src", i.data, o);
              }
            }(s, d, u, t)) : NE(s, c, d, u));
          }
          "complete" == l && a.loaders.get(r) && function (t, e, n) {
            const i = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), i), setTimeout(() => {
              n.change(t => t.remove(t.createRangeOn(i)));
            }, 3e3);
          }(d, u, i.editing.view), function (t, e) {
            VE(t, e, "progressBar");
          }(d, u), zE(d, u), function (t, e) {
            e.removeClass("ck-appear", t);
          }(d, u);
        }, this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      }
      init() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange), t.plugins.has("ImageInlineEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
      }
    }
    function LE(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }
    function NE(t, e, n, i) {
      n.hasClass("ck-image-upload-placeholder") || i.addClass("ck-image-upload-placeholder", n);
      const o = t.findViewImgElement(n);
      o.getAttribute("src") !== e && i.setAttribute("src", e, o), PE(n, "placeholder") || i.insert(i.createPositionAfter(o), function (t) {
        const e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(i));
    }
    function zE(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), VE(t, e, "placeholder");
    }
    function PE(t, e) {
      for (const n of t.getChildren()) if (n.getCustomProperty(e)) return n;
    }
    function VE(t, e, n) {
      const i = PE(t, n);
      i && e.remove(e.createRangeOn(i));
    }
    class RE extends Pr {
      refresh() {
        const t = this.editor,
          e = t.plugins.get("ImageUtils"),
          n = t.model.document.selection.getSelectedElement();
        this.isEnabled = e.isImageAllowed() || e.isImage(n);
      }
      execute(t) {
        const e = vo(t.file),
          n = this.editor.model.document.selection,
          i = this.editor.plugins.get("ImageUtils"),
          o = Object.fromEntries(n.getAttributes());
        e.forEach((t, e) => {
          const r = n.getSelectedElement();
          if (e && r && i.isImage(r)) {
            const e = this.editor.model.createPositionAfter(r);
            this._uploadImage(t, o, e);
          } else this._uploadImage(t, o);
        });
      }
      _uploadImage(t, e, n) {
        const i = this.editor,
          o = i.plugins.get(yE).createLoader(t),
          r = i.plugins.get("ImageUtils");
        o && r.insertImage({
          ...e,
          uploadId: o.id
        }, n);
      }
    }
    class FE extends Nr {
      static get requires() {
        return [yE, If, Mb, zx];
      }
      static get pluginName() {
        return "ImageUploadEditing";
      }
      constructor(t) {
        super(t), t.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        }), this._uploadImageElements = new Map();
      }
      init() {
        const t = this.editor,
          e = t.model.document,
          n = t.conversion,
          i = t.plugins.get(yE),
          o = t.plugins.get("ImageUtils"),
          r = t.plugins.get("ClipboardPipeline"),
          s = wE(t.config.get("image.upload.types")),
          a = new RE(t);
        t.commands.add("uploadImage", a), t.commands.add("imageUpload", a), n.for("upcast").attributeToAttribute({
          view: {
            name: "img",
            key: "uploadId"
          },
          model: "uploadId"
        }), this.listenTo(t.editing.view.document, "clipboardInput", (e, n) => {
          if (i = n.dataTransfer, Array.from(i.types).includes("text/html") && "" !== i.getData("text/html")) return;
          var i;
          const o = Array.from(n.dataTransfer.files).filter(t => !!t && s.test(t.type));
          o.length && (e.stop(), t.model.change(e => {
            n.targetRanges && e.setSelection(n.targetRanges.map(e => t.editing.mapper.toModelRange(e))), t.execute("uploadImage", {
              file: o
            });
          }));
        }), this.listenTo(r, "inputTransformation", (e, n) => {
          const r = Array.from(t.editing.view.createRangeIn(n.content)).map(t => t.item).filter(t => function (t, e) {
            return !(!t.isInlineImageView(e) || !e.getAttribute("src") || !e.getAttribute("src").match(/^data:image\/\w+;base64,/g) && !e.getAttribute("src").match(/^blob:/g));
          }(o, t) && !t.getAttribute("uploadProcessed")).map(t => ({
            promise: AE(t),
            imageElement: t
          }));
          if (!r.length) return;
          const s = new th(t.editing.view.document);
          for (const t of r) {
            s.setAttribute("uploadProcessed", !0, t.imageElement);
            const e = i.createLoader(t.promise);
            e && (s.setAttribute("src", "", t.imageElement), s.setAttribute("uploadId", e.id, t.imageElement));
          }
        }), t.editing.view.document.on("dragover", (t, e) => {
          e.preventDefault();
        }), e.on("change", () => {
          const n = e.differ.getChanges({
              includeChangesInGraveyard: !0
            }).reverse(),
            o = new Set();
          for (const e of n) if ("insert" == e.type && "$text" != e.name) {
            const n = e.position.nodeAfter,
              r = "$graveyard" == e.position.root.rootName;
            for (const e of OE(t, n)) {
              const t = e.getAttribute("uploadId");
              if (!t) continue;
              const n = i.loaders.get(t);
              n && (r ? o.has(t) || n.abort() : (o.add(t), this._uploadImageElements.set(t, e), "idle" == n.status && this._readAndUpload(n)));
            }
          }
        }), this.on("uploadComplete", (t, _ref153) => {
          let {
            imageElement: e,
            data: n
          } = _ref153;
          const i = n.urls ? n.urls : n;
          this.editor.model.change(t => {
            t.setAttribute("src", i.default, e), this._parseAndSetSrcsetAttributeOnImage(i, e, t), o.setImageNaturalSizeAttributes(e);
          });
        }, {
          priority: "low"
        });
      }
      afterInit() {
        const t = this.editor.model.schema;
        this.editor.plugins.has("ImageBlockEditing") && t.extend("imageBlock", {
          allowAttributes: ["uploadId", "uploadStatus"]
        }), this.editor.plugins.has("ImageInlineEditing") && t.extend("imageInline", {
          allowAttributes: ["uploadId", "uploadStatus"]
        });
      }
      _readAndUpload(t) {
        const e = this.editor,
          n = e.model,
          i = e.locale.t,
          o = e.plugins.get(yE),
          r = e.plugins.get(If),
          a = e.plugins.get("ImageUtils"),
          l = this._uploadImageElements;
        return n.enqueueChange({
          isUndoable: !1
        }, e => {
          e.setAttribute("uploadStatus", "reading", l.get(t.id));
        }), t.read().then(() => {
          const o = t.upload(),
            r = l.get(t.id);
          if (s.isSafari) {
            const t = e.editing.mapper.toViewElement(r),
              n = a.findViewImgElement(t);
            e.editing.view.once("render", () => {
              if (!n.parent) return;
              const t = e.editing.view.domConverter.mapViewToDom(n.parent);
              if (!t) return;
              const i = t.style.display;
              t.style.display = "none", t._ckHack = t.offsetHeight, t.style.display = i;
            });
          }
          return e.ui && e.ui.ariaLiveAnnouncer.announce(i("Uploading image")), n.enqueueChange({
            isUndoable: !1
          }, t => {
            t.setAttribute("uploadStatus", "uploading", r);
          }), o;
        }).then(o => {
          n.enqueueChange({
            isUndoable: !1
          }, n => {
            const r = l.get(t.id);
            n.setAttribute("uploadStatus", "complete", r), e.ui && e.ui.ariaLiveAnnouncer.announce(i("Image upload complete")), this.fire("uploadComplete", {
              data: o,
              imageElement: r
            });
          }), c();
        }).catch(o => {
          if (e.ui && e.ui.ariaLiveAnnouncer.announce(i("Error during image upload")), "error" !== t.status && "aborted" !== t.status) throw o;
          "error" == t.status && o && r.showWarning(o, {
            title: i("Upload failed"),
            namespace: "upload"
          }), n.enqueueChange({
            isUndoable: !1
          }, e => {
            e.remove(l.get(t.id));
          }), c();
        });
        function c() {
          n.enqueueChange({
            isUndoable: !1
          }, e => {
            const n = l.get(t.id);
            e.removeAttribute("uploadId", n), e.removeAttribute("uploadStatus", n), l.delete(t.id);
          }), o.destroyLoader(t);
        }
      }
      _parseAndSetSrcsetAttributeOnImage(t, e, n) {
        let i = 0;
        const o = Object.keys(t).filter(t => {
          const e = parseInt(t, 10);
          if (!isNaN(e)) return i = Math.max(i, e), !0;
        }).map(e => `${t[e]} ${e}w`).join(", ");
        if ("" != o) {
          const t = {
            srcset: o
          };
          e.hasAttribute("width") || e.hasAttribute("height") || (t.width = i), n.setAttributes(t, e);
        }
      }
    }
    function OE(t, e) {
      const n = t.plugins.get("ImageUtils");
      return Array.from(t.model.createRangeOn(e)).filter(t => n.isImage(t.item)).map(t => t.item);
    }
    class jE extends Nr {
      static get pluginName() {
        return "ImageUpload";
      }
      static get requires() {
        return [FE, _E, ME];
      }
    }
    class HE extends Sr {
      constructor(t) {
        super(t), this.set("imageURLInputValue", ""), this.set("isImageSelected", !1), this.set("isEnabled", !0), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusables = new nr(), this.focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.urlInputView = this._createUrlInputView(), this.insertButtonView = this._createInsertButton(), this.cancelButtonView = this._createCancelButton(), this._focusables.addMany([this.urlInputView, this.insertButtonView, this.cancelButtonView]), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-image-insert-url"]
          },
          children: [this.urlInputView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-image-insert-url__action-row"]
            },
            children: [this.insertButtonView, this.cancelButtonView]
          }]
        });
      }
      render() {
        super.render();
        for (const t of this._focusables) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createUrlInputView() {
        const t = this.locale,
          e = t.t,
          n = new Fm(t, Lg);
        return n.bind("label").to(this, "isImageSelected", t => e(t ? "Update image URL" : "Insert image via URL")), n.bind("isEnabled").to(this), n.fieldView.placeholder = "https://example.com/image.png", n.fieldView.bind("value").to(this, "imageURLInputValue", t => t || ""), n.fieldView.on("input", () => {
          this.imageURLInputValue = n.fieldView.element.value.trim();
        }), n;
      }
      _createInsertButton() {
        const t = this.locale,
          e = t.t,
          n = new mm(t);
        return n.set({
          icon: Yh.check,
          class: "ck-button-save",
          type: "submit",
          withText: !0
        }), n.bind("label").to(this, "isImageSelected", t => e(t ? "Update" : "Insert")), n.bind("isEnabled").to(this, "imageURLInputValue", this, "isEnabled", function () {
          for (var _len36 = arguments.length, t = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
            t[_key36] = arguments[_key36];
          }
          return t.every(t => t);
        }), n.delegate("execute").to(this, "submit"), n;
      }
      _createCancelButton() {
        const t = this.locale,
          e = t.t,
          n = new mm(t);
        return n.set({
          label: e("Cancel"),
          icon: Yh.cancel,
          class: "ck-button-cancel",
          withText: !0
        }), n.bind("isEnabled").to(this), n.delegate("execute").to(this, "cancel"), n;
      }
      focus(t) {
        -1 === t ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
    }
    class UE extends Nr {
      static get pluginName() {
        return "ImageInsertViaUrlUI";
      }
      static get requires() {
        return [aE];
      }
      afterInit() {
        this._imageInsertUI = this.editor.plugins.get("ImageInsertUI"), this._imageInsertUI.registerIntegration({
          name: "url",
          observable: () => this.editor.commands.get("insertImage"),
          requiresForm: !0,
          buttonViewCreator: t => this._createInsertUrlButton(t),
          formViewCreator: t => this._createInsertUrlView(t)
        });
      }
      _createInsertUrlView(t) {
        const e = this.editor,
          n = e.locale,
          i = n.t,
          o = e.commands.get("replaceImageSource"),
          r = e.commands.get("insertImage"),
          s = new HE(n),
          a = t ? null : new _m(n, [s]);
        return s.bind("isImageSelected").to(this._imageInsertUI), s.bind("isEnabled").toMany([r, o], "isEnabled", function () {
          for (var _len37 = arguments.length, t = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
            t[_key37] = arguments[_key37];
          }
          return t.some(t => t);
        }), s.imageURLInputValue = o.value || "", this._imageInsertUI.dropdownView.on("change:isOpen", () => {
          this._imageInsertUI.dropdownView.isOpen && (s.imageURLInputValue = o.value || "", a && (a.isCollapsed = !0));
        }, {
          priority: "low"
        }), s.on("submit", () => {
          o.isEnabled ? e.execute("replaceImageSource", {
            source: s.imageURLInputValue
          }) : e.execute("insertImage", {
            source: s.imageURLInputValue
          }), this._closePanel();
        }), s.on("cancel", () => this._closePanel()), a ? (a.set({
          isCollapsed: !0
        }), a.bind("label").to(this._imageInsertUI, "isImageSelected", t => i(t ? "Update image URL" : "Insert image via URL")), a) : s;
      }
      _createInsertUrlButton(t) {
        const e = t ? Xm : mm,
          n = this.editor,
          i = new e(n.locale),
          o = n.locale.t;
        return i.set({
          icon: Yh.imageUrl,
          tooltip: !0
        }), i.bind("label").to(this._imageInsertUI, "isImageSelected", t => o(t ? "Update image URL" : "Insert image via URL")), i;
      }
      _closePanel() {
        this.editor.editing.view.focus(), this._imageInsertUI.dropdownView.isOpen = !1;
      }
    }
    class qE extends Nr {
      static get pluginName() {
        return "ImageInsertViaUrl";
      }
      static get requires() {
        return [UE, aE];
      }
    }
    const GE = function (t, e) {
      return function (n, i) {
        if (null == n) return n;
        if (!sn(n)) return t(n, i);
        for (var o = n.length, r = e ? o : -1, s = Object(n); (e ? r-- : ++r < o) && !1 !== i(s[r], r, s););
        return n;
      };
    }(fb);
    const WE = function (t, e) {
      var n = -1,
        i = sn(t) ? Array(t.length) : [];
      return GE(t, function (t, o, r) {
        i[++n] = e(t, o, r);
      }), i;
    };
    const $E = function (t, e) {
      return (mt(t) ? bs : WE)(t, Sb(e, 3));
    };
    class KE extends Pr {
      refresh() {
        const t = this.editor,
          e = t.plugins.get("ImageUtils").getClosestSelectedImageElement(t.model.document.selection);
        this.isEnabled = !!e, e && e.hasAttribute("resizedWidth") ? this.value = {
          width: e.getAttribute("resizedWidth"),
          height: null
        } : this.value = null;
      }
      execute(t) {
        const e = this.editor,
          n = e.model,
          i = e.plugins.get("ImageUtils"),
          o = i.getClosestSelectedImageElement(n.document.selection);
        this.value = {
          width: t.width,
          height: null
        }, o && n.change(e => {
          e.setAttribute("resizedWidth", t.width, o), e.removeAttribute("resizedHeight", o), i.setImageNaturalSizeAttributes(o);
        });
      }
    }
    class YE extends Nr {
      static get requires() {
        return [zx];
      }
      static get pluginName() {
        return "ImageResizeEditing";
      }
      constructor(t) {
        super(t), t.config.define("image", {
          resizeUnit: "%",
          resizeOptions: [{
            name: "resizeImage:original",
            value: null,
            icon: "original"
          }, {
            name: "resizeImage:custom",
            value: "custom",
            icon: "custom"
          }, {
            name: "resizeImage:25",
            value: "25",
            icon: "small"
          }, {
            name: "resizeImage:50",
            value: "50",
            icon: "medium"
          }, {
            name: "resizeImage:75",
            value: "75",
            icon: "large"
          }]
        });
      }
      init() {
        const t = this.editor,
          e = new KE(t);
        this._registerConverters("imageBlock"), this._registerConverters("imageInline"), t.commands.add("resizeImage", e), t.commands.add("imageResize", e);
      }
      afterInit() {
        this._registerSchema();
      }
      _registerSchema() {
        this.editor.plugins.has("ImageBlockEditing") && this.editor.model.schema.extend("imageBlock", {
          allowAttributes: ["resizedWidth", "resizedHeight"]
        }), this.editor.plugins.has("ImageInlineEditing") && this.editor.model.schema.extend("imageInline", {
          allowAttributes: ["resizedWidth", "resizedHeight"]
        });
      }
      _registerConverters(t) {
        const e = this.editor,
          n = e.plugins.get("ImageUtils");
        e.conversion.for("downcast").add(e => e.on(`attribute:resizedWidth:${t}`, (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) return;
          const i = n.writer,
            o = n.mapper.toViewElement(e.item);
          null !== e.attributeNewValue ? (i.setStyle("width", e.attributeNewValue, o), i.addClass("image_resized", o)) : (i.removeStyle("width", o), i.removeClass("image_resized", o));
        })), e.conversion.for("dataDowncast").attributeToAttribute({
          model: {
            name: t,
            key: "resizedHeight"
          },
          view: t => ({
            key: "style",
            value: {
              height: t
            }
          })
        }), e.conversion.for("editingDowncast").add(e => e.on(`attribute:resizedHeight:${t}`, (e, i, o) => {
          if (!o.consumable.consume(i.item, e.name)) return;
          const r = o.writer,
            s = o.mapper.toViewElement(i.item),
            a = "imageInline" === t ? n.findViewImgElement(s) : s;
          null !== i.attributeNewValue ? r.setStyle("height", i.attributeNewValue, a) : r.removeStyle("height", a);
        })), e.conversion.for("upcast").attributeToAttribute({
          view: {
            name: "imageBlock" === t ? "figure" : "img",
            styles: {
              width: /.+/
            }
          },
          model: {
            key: "resizedWidth",
            value: t => Lx(t) ? null : t.getStyle("width")
          }
        }), e.conversion.for("upcast").attributeToAttribute({
          view: {
            name: "imageBlock" === t ? "figure" : "img",
            styles: {
              height: /.+/
            }
          },
          model: {
            key: "resizedHeight",
            value: t => Lx(t) ? null : t.getStyle("height")
          }
        });
      }
    }
    const QE = {
      small: Yh.objectSizeSmall,
      medium: Yh.objectSizeMedium,
      large: Yh.objectSizeLarge,
      custom: Yh.objectSizeCustom,
      original: Yh.objectSizeFull
    };
    class ZE extends Nr {
      static get requires() {
        return [YE];
      }
      static get pluginName() {
        return "ImageResizeButtons";
      }
      constructor(t) {
        super(t), this._resizeUnit = t.config.get("image.resizeUnit");
      }
      init() {
        const t = this.editor,
          e = t.config.get("image.resizeOptions"),
          n = t.commands.get("resizeImage");
        this.bind("isEnabled").to(n);
        for (const t of e) this._registerImageResizeButton(t);
        this._registerImageResizeDropdown(e);
      }
      _registerImageResizeButton(t) {
        const e = this.editor,
          {
            name: n,
            value: i,
            icon: o
          } = t;
        e.ui.componentFactory.add(n, n => {
          const r = new mm(n),
            s = e.commands.get("resizeImage"),
            a = this._getOptionLabelValue(t, !0);
          if (!QE[o]) throw new b("imageresizebuttons-missing-icon", e, t);
          if (r.set({
            label: a,
            icon: QE[o],
            tooltip: a,
            isToggleable: !0
          }), r.bind("isEnabled").to(this), e.plugins.has("ImageCustomResizeUI") && JE(t)) {
            const t = e.plugins.get("ImageCustomResizeUI");
            this.listenTo(r, "execute", () => {
              t._showForm(this._resizeUnit);
            });
          } else {
            const t = i ? i + this._resizeUnit : null;
            r.bind("isOn").to(s, "value", XE(t)), this.listenTo(r, "execute", () => {
              e.execute("resizeImage", {
                width: t
              });
            });
          }
          return r;
        });
      }
      _registerImageResizeDropdown(t) {
        const e = this.editor,
          n = e.t,
          i = t.find(t => !t.value),
          o = o => {
            const r = e.commands.get("resizeImage"),
              s = Eg(o, Xm),
              a = s.buttonView,
              l = n("Resize image");
            return a.set({
              tooltip: l,
              commandValue: i.value,
              icon: QE.medium,
              isToggleable: !0,
              label: this._getOptionLabelValue(i),
              withText: !0,
              class: "ck-resize-image-button",
              ariaLabel: l,
              ariaLabelledBy: void 0
            }), a.bind("label").to(r, "value", t => t && t.width ? t.width : this._getOptionLabelValue(i)), s.bind("isEnabled").to(this), Sg(s, () => this._getResizeDropdownListItemDefinitions(t, r), {
              ariaLabel: n("Image resize list"),
              role: "menu"
            }), this.listenTo(s, "execute", t => {
              "onClick" in t.source ? t.source.onClick() : (e.execute(t.source.commandName, {
                width: t.source.commandValue
              }), e.editing.view.focus());
            }), s;
          };
        e.ui.componentFactory.add("resizeImage", o), e.ui.componentFactory.add("imageResize", o);
      }
      _getOptionLabelValue(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const n = this.editor.t;
        return t.label ? t.label : e ? JE(t) ? n("Custom image size") : t.value ? n("Resize image to %0", t.value + this._resizeUnit) : n("Resize image to the original size") : JE(t) ? n("Custom") : t.value ? t.value + this._resizeUnit : n("Original");
      }
      _getResizeDropdownListItemDefinitions(t, e) {
        const {
            editor: n
          } = this,
          i = new Wo(),
          o = t.map(t => JE(t) ? {
            ...t,
            valueWithUnits: "custom"
          } : t.value ? {
            ...t,
            valueWithUnits: `${t.value}${this._resizeUnit}`
          } : {
            ...t,
            valueWithUnits: null
          });
        for (const t of o) {
          let r = null;
          if (n.plugins.has("ImageCustomResizeUI") && JE(t)) {
            const i = n.plugins.get("ImageCustomResizeUI");
            r = {
              type: "button",
              model: new Mf({
                label: this._getOptionLabelValue(t),
                role: "menuitemradio",
                withText: !0,
                icon: null,
                onClick: () => {
                  i._showForm(this._resizeUnit);
                }
              })
            };
            const s = $E(o, "valueWithUnits");
            r.model.bind("isOn").to(e, "value", tD(s));
          } else r = {
            type: "button",
            model: new Mf({
              commandName: "resizeImage",
              commandValue: t.valueWithUnits,
              label: this._getOptionLabelValue(t),
              role: "menuitemradio",
              withText: !0,
              icon: null
            })
          }, r.model.bind("isOn").to(e, "value", XE(t.valueWithUnits));
          r.model.bind("isEnabled").to(e, "isEnabled"), i.add(r);
        }
        return i;
      }
    }
    function JE(t) {
      return "custom" === t.value;
    }
    function XE(t) {
      return e => null === t && e === t || null !== e && e.width === t;
    }
    function tD(t) {
      return e => !t.some(t => XE(t)(e));
    }
    const eD = "image_resized";
    class nD extends Nr {
      static get requires() {
        return [dA, zx];
      }
      static get pluginName() {
        return "ImageResizeHandles";
      }
      init() {
        const t = this.editor.commands.get("resizeImage");
        this.bind("isEnabled").to(t), this._setupResizerCreator();
      }
      _setupResizerCreator() {
        const t = this.editor,
          e = t.editing.view,
          n = t.plugins.get("ImageUtils");
        e.addObserver($x), this.listenTo(e.document, "imageLoaded", (i, o) => {
          if (!o.target.matches("figure.image.ck-widget > img,figure.image.ck-widget > picture > img,figure.image.ck-widget > a > img,figure.image.ck-widget > a > picture > img,span.image-inline.ck-widget > img,span.image-inline.ck-widget > picture > img")) return;
          const r = t.editing.view.domConverter,
            s = r.domToView(o.target),
            a = n.getImageWidgetFromImageView(s);
          let l = this.editor.plugins.get(dA).getResizerByViewElement(a);
          if (l) return void l.redraw();
          const c = t.editing.mapper,
            d = c.toModelElement(a);
          l = t.plugins.get(dA).attachTo({
            unit: t.config.get("image.resizeUnit"),
            modelElement: d,
            viewElement: a,
            editor: t,
            getHandleHost: t => t.querySelector("img"),
            getResizeHost: () => r.mapViewToDom(c.toViewElement(d)),
            isCentered: () => "alignCenter" == d.getAttribute("imageStyle"),
            onCommit(n) {
              e.change(t => {
                t.removeClass(eD, a);
              }), t.execute("resizeImage", {
                width: n
              });
            }
          }), l.on("updateSize", () => {
            a.hasClass(eD) || e.change(t => {
              t.addClass(eD, a);
            });
            const t = "imageInline" === d.name ? s : a;
            t.getStyle("height") && e.change(e => {
              e.removeStyle("height", t);
            });
          }), l.bind("isEnabled").to(this);
        });
      }
    }
    function iD(t) {
      if (!t) return null;
      const [, e, n] = t.trim().match(/([.,\d]+)(%|px)$/) || [],
        i = Number.parseFloat(e);
      return Number.isNaN(i) ? null : {
        value: i,
        unit: n
      };
    }
    function oD(t, e, n) {
      return "px" === n ? {
        value: e.value,
        unit: "px"
      } : {
        value: e.value / t * 100,
        unit: "%"
      };
    }
    function rD(t) {
      const {
          editing: e
        } = t,
        n = t.plugins.get("ImageUtils").getClosestSelectedImageElement(t.model.document.selection);
      if (!n) return null;
      const i = e.mapper.toViewElement(n);
      return {
        model: n,
        view: i,
        dom: e.view.domConverter.mapViewToDom(i)
      };
    }
    var sD = o(1173),
      aD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(sD.A, aD);
    sD.A.locals;
    class lD extends Sr {
      constructor(t, e, n) {
        super(t);
        const i = this.locale.t;
        this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.unit = e, this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(i("Save"), Yh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(i("Cancel"), Yh.cancel, "ck-button-cancel", "cancel"), this._focusables = new nr(), this._validators = n, this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-image-custom-resize-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.labeledInput, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), this.keystrokes.listenTo(this.element), Mr({
          view: this
        }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        });
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createButton(t, e, n, i) {
        const o = new mm(this.locale);
        return o.set({
          label: t,
          icon: e,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
      _createLabeledInputView() {
        const t = this.locale.t,
          e = new Fm(this.locale, Ng);
        return e.label = t("Resize image (in %0)", this.unit), e.fieldView.set({
          step: .1
        }), e;
      }
      isValid() {
        this.resetFormStatus();
        for (const t of this._validators) {
          const e = t(this);
          if (e) return this.labeledInput.errorText = e, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.labeledInput.errorText = null;
      }
      get rawSize() {
        const {
          element: t
        } = this.labeledInput.fieldView;
        return t ? t.value : null;
      }
      get parsedSize() {
        const {
          rawSize: t
        } = this;
        if (null === t) return null;
        const e = Number.parseFloat(t);
        return Number.isNaN(e) ? null : e;
      }
      get sizeWithUnits() {
        const {
          parsedSize: t,
          unit: e
        } = this;
        return null === t ? null : `${t}${e}`;
      }
    }
    class cD extends Nr {
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "ImageCustomResizeUI";
      }
      destroy() {
        super.destroy(), this._form && this._form.destroy();
      }
      _createForm(t) {
        const e = this.editor;
        this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new (Ir(lD))(e.locale, t, function (t) {
          const e = t.t;
          return [t => "" === t.rawSize.trim() ? e("The value must not be empty.") : null === t.parsedSize ? e("The value should be a plain number.") : void 0];
        }(e)), this._form.render(), this.listenTo(this._form, "submit", () => {
          this._form.isValid() && (e.execute("resizeImage", {
            width: this._form.sizeWithUnits
          }), this._hideForm(!0));
        }), this.listenTo(this._form.labeledInput, "change:errorText", () => {
          e.ui.update();
        }), this.listenTo(this._form, "cancel", () => {
          this._hideForm(!0);
        }), this._form.keystrokes.set("Esc", (t, e) => {
          this._hideForm(!0), e();
        }), Tr({
          emitter: this._form,
          activator: () => this._isVisible,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideForm()
        });
      }
      _showForm(t) {
        if (this._isVisible) return;
        this._form || this._createForm(t);
        const e = this.editor,
          n = this._form.labeledInput;
        this._form.disableCssTransitions(), this._form.resetFormStatus(), this._isInBalloon || this._balloon.add({
          view: this._form,
          position: Hx(e)
        });
        const i = function (t, e) {
            const n = rD(t);
            if (!n) return null;
            const i = iD(n.model.getAttribute("resizedWidth") || null);
            return i ? i.unit === e ? i : oD(Vw(n.dom), {
              unit: "px",
              value: new Pi(n.dom).width
            }, e) : null;
          }(e, t),
          o = i ? i.value.toFixed(1) : "",
          r = function (t, e) {
            const n = rD(t);
            if (!n) return null;
            const i = Vw(n.dom),
              o = iD(window.getComputedStyle(n.dom).minWidth) || {
                value: 1,
                unit: "px"
              };
            return {
              unit: e,
              lower: Math.max(.1, oD(i, o, e).value),
              upper: "px" === e ? i : 100
            };
          }(e, t);
        n.fieldView.value = n.fieldView.element.value = o, r && Object.assign(n.fieldView, {
          min: r.lower.toFixed(1),
          max: Math.ceil(r.upper).toFixed(1)
        }), this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
      }
      _hideForm() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
      }
      get _isVisible() {
        return !!this._balloon && this._balloon.visibleView === this._form;
      }
      get _isInBalloon() {
        return !!this._balloon && this._balloon.hasView(this._form);
      }
    }
    var dD = o(4214),
      uD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(dD.A, uD);
    dD.A.locals;
    class hD extends Pr {
      constructor(t, e) {
        super(t), this._defaultStyles = {
          imageBlock: !1,
          imageInline: !1
        }, this._styles = new Map(e.map(t => {
          if (t.isDefault) for (const e of t.modelElements) this._defaultStyles[e] = t.name;
          return [t.name, t];
        }));
      }
      refresh() {
        const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
        this.isEnabled = !!t, this.isEnabled ? t.hasAttribute("imageStyle") ? this.value = t.getAttribute("imageStyle") : this.value = this._defaultStyles[t.name] : this.value = !1;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor,
          n = e.model,
          i = e.plugins.get("ImageUtils");
        n.change(e => {
          const o = t.value,
            {
              setImageSizes: r = !0
            } = t;
          let s = i.getClosestSelectedImageElement(n.document.selection);
          o && this.shouldConvertImageType(o, s) && (this.editor.execute(i.isBlockImage(s) ? "imageTypeInline" : "imageTypeBlock", {
            setImageSizes: r
          }), s = i.getClosestSelectedImageElement(n.document.selection)), !o || this._styles.get(o).isDefault ? e.removeAttribute("imageStyle", s) : e.setAttribute("imageStyle", o, s), r && i.setImageNaturalSizeAttributes(s);
        });
      }
      shouldConvertImageType(t, e) {
        return !this._styles.get(t).modelElements.includes(e.name);
      }
    }
    const {
        objectFullWidth: mD,
        objectInline: gD,
        objectLeft: pD,
        objectRight: fD,
        objectCenter: kD,
        objectBlockLeft: bD,
        objectBlockRight: wD
      } = Yh,
      AD = {
        get inline() {
          return {
            name: "inline",
            title: "In line",
            icon: gD,
            modelElements: ["imageInline"],
            isDefault: !0
          };
        },
        get alignLeft() {
          return {
            name: "alignLeft",
            title: "Left aligned image",
            icon: pD,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-left"
          };
        },
        get alignBlockLeft() {
          return {
            name: "alignBlockLeft",
            title: "Left aligned image",
            icon: bD,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-left"
          };
        },
        get alignCenter() {
          return {
            name: "alignCenter",
            title: "Centered image",
            icon: kD,
            modelElements: ["imageBlock"],
            className: "image-style-align-center"
          };
        },
        get alignRight() {
          return {
            name: "alignRight",
            title: "Right aligned image",
            icon: fD,
            modelElements: ["imageBlock", "imageInline"],
            className: "image-style-align-right"
          };
        },
        get alignBlockRight() {
          return {
            name: "alignBlockRight",
            title: "Right aligned image",
            icon: wD,
            modelElements: ["imageBlock"],
            className: "image-style-block-align-right"
          };
        },
        get block() {
          return {
            name: "block",
            title: "Centered image",
            icon: kD,
            modelElements: ["imageBlock"],
            isDefault: !0
          };
        },
        get side() {
          return {
            name: "side",
            title: "Side image",
            icon: fD,
            modelElements: ["imageBlock"],
            className: "image-style-side"
          };
        }
      },
      CD = {
        full: mD,
        left: bD,
        right: wD,
        center: kD,
        inlineLeft: pD,
        inlineRight: fD,
        inline: gD
      },
      _D = [{
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
      }, {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
      }];
    function vD(t) {
      w("image-style-configuration-definition-invalid", t);
    }
    const yD = {
      normalizeStyles: function (t) {
        return (t.configuredStyles.options || []).map(t => function (t) {
          t = "string" == typeof t ? AD[t] ? {
            ...AD[t]
          } : {
            name: t
          } : function (t, e) {
            const n = {
              ...e
            };
            for (const i in t) Object.prototype.hasOwnProperty.call(e, i) || (n[i] = t[i]);
            return n;
          }(AD[t.name], t);
          "string" == typeof t.icon && (t.icon = CD[t.icon] || t.icon);
          return t;
        }(t)).filter(e => function (t, _ref154) {
          let {
            isBlockPluginLoaded: e,
            isInlinePluginLoaded: n
          } = _ref154;
          const {
            modelElements: i,
            name: o
          } = t;
          if (!(i && i.length && o)) return vD({
            style: t
          }), !1;
          {
            const o = [e ? "imageBlock" : null, n ? "imageInline" : null];
            if (!i.some(t => o.includes(t))) return w("image-style-missing-dependency", {
              style: t,
              missingPlugins: i.map(t => "imageBlock" === t ? "ImageBlockEditing" : "ImageInlineEditing")
            }), !1;
          }
          return !0;
        }(e, t));
      },
      getDefaultStylesConfiguration: function (t, e) {
        return t && e ? {
          options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
        } : t ? {
          options: ["block", "side"]
        } : e ? {
          options: ["inline", "alignLeft", "alignRight"]
        } : {};
      },
      getDefaultDropdownDefinitions: function (t) {
        return t.has("ImageBlockEditing") && t.has("ImageInlineEditing") ? [..._D] : [];
      },
      warnInvalidStyle: vD,
      DEFAULT_OPTIONS: AD,
      DEFAULT_ICONS: CD,
      DEFAULT_DROPDOWN_DEFINITIONS: _D
    };
    function xD(t, e) {
      for (const n of e) if (n.name === t) return n;
    }
    class ED extends Nr {
      static get pluginName() {
        return "ImageStyleEditing";
      }
      static get requires() {
        return [zx];
      }
      init() {
        const {
            normalizeStyles: t,
            getDefaultStylesConfiguration: e
          } = yD,
          n = this.editor,
          i = n.plugins.has("ImageBlockEditing"),
          o = n.plugins.has("ImageInlineEditing");
        n.config.define("image.styles", e(i, o)), this.normalizedStyles = t({
          configuredStyles: n.config.get("image.styles"),
          isBlockPluginLoaded: i,
          isInlinePluginLoaded: o
        }), this._setupConversion(i, o), this._setupPostFixer(), n.commands.add("imageStyle", new hD(n, this.normalizedStyles));
      }
      _setupConversion(t, e) {
        const n = this.editor,
          i = n.model.schema,
          o = (r = this.normalizedStyles, (t, e, n) => {
            if (!n.consumable.consume(e.item, t.name)) return;
            const i = xD(e.attributeNewValue, r),
              o = xD(e.attributeOldValue, r),
              s = n.mapper.toViewElement(e.item),
              a = n.writer;
            o && a.removeClass(o.className, s), i && a.addClass(i.className, s);
          });
        var r;
        const s = function (t) {
          const e = {
            imageInline: t.filter(t => !t.isDefault && t.modelElements.includes("imageInline")),
            imageBlock: t.filter(t => !t.isDefault && t.modelElements.includes("imageBlock"))
          };
          return (t, n, i) => {
            if (!n.modelRange) return;
            const o = n.viewItem,
              r = $o(n.modelRange.getItems());
            if (r && i.schema.checkAttribute(r, "imageStyle")) for (const t of e[r.name]) i.consumable.consume(o, {
              classes: t.className
            }) && i.writer.setAttribute("imageStyle", t.name, r);
          };
        }(this.normalizedStyles);
        n.editing.downcastDispatcher.on("attribute:imageStyle", o), n.data.downcastDispatcher.on("attribute:imageStyle", o), t && (i.extend("imageBlock", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:figure", s, {
          priority: "low"
        })), e && (i.extend("imageInline", {
          allowAttributes: "imageStyle"
        }), n.data.upcastDispatcher.on("element:img", s, {
          priority: "low"
        }));
      }
      _setupPostFixer() {
        const t = this.editor,
          e = t.model.document,
          n = t.plugins.get(zx),
          i = new Map(this.normalizedStyles.map(t => [t.name, t]));
        e.registerPostFixer(t => {
          let o = !1;
          for (const r of e.differ.getChanges()) if ("insert" == r.type || "attribute" == r.type && "imageStyle" == r.attributeKey) {
            let e = "insert" == r.type ? r.position.nodeAfter : r.range.start.nodeAfter;
            if (e && e.is("element", "paragraph") && e.childCount > 0 && (e = e.getChild(0)), !n.isImage(e)) continue;
            const s = e.getAttribute("imageStyle");
            if (!s) continue;
            const a = i.get(s);
            a && a.modelElements.includes(e.name) || (t.removeAttribute("imageStyle", e), o = !0);
          }
          return o;
        });
      }
    }
    var DD = o(7879),
      BD = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(DD.A, BD);
    DD.A.locals;
    class SD extends Nr {
      static get requires() {
        return [ED];
      }
      static get pluginName() {
        return "ImageStyleUI";
      }
      get localizedDefaultStylesTitles() {
        const t = this.editor.t;
        return {
          "Wrap text": t("Wrap text"),
          "Break text": t("Break text"),
          "In line": t("In line"),
          "Full size image": t("Full size image"),
          "Side image": t("Side image"),
          "Left aligned image": t("Left aligned image"),
          "Centered image": t("Centered image"),
          "Right aligned image": t("Right aligned image")
        };
      }
      init() {
        const t = this.editor.plugins,
          e = this.editor.config.get("image.toolbar") || [],
          n = TD(t.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
        for (const t of n) this._createButton(t);
        const i = TD([...e.filter(V), ...yD.getDefaultDropdownDefinitions(t)], this.localizedDefaultStylesTitles);
        for (const t of i) this._createDropdown(t, n);
      }
      _createDropdown(t, e) {
        const n = this.editor.ui.componentFactory;
        n.add(t.name, i => {
          let o;
          const {
              defaultItem: r,
              items: s,
              title: a
            } = t,
            l = s.filter(t => e.find(_ref155 => {
              let {
                name: e
              } = _ref155;
              return ID(e) === t;
            })).map(t => {
              const e = n.create(t);
              return t === r && (o = e), e;
            });
          s.length !== l.length && yD.warnInvalidStyle({
            dropdown: t
          });
          const c = Eg(i, Cg),
            d = c.buttonView,
            u = d.arrowView;
          return Dg(c, l, {
            enableActiveItemFocusOnDropdownOpen: !0
          }), d.set({
            label: MD(a, o.label),
            class: null,
            tooltip: !0
          }), u.unbind("label"), u.set({
            label: a
          }), d.bind("icon").toMany(l, "isOn", function () {
            for (var _len38 = arguments.length, t = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
              t[_key38] = arguments[_key38];
            }
            const e = t.findIndex(Io);
            return e < 0 ? o.icon : l[e].icon;
          }), d.bind("label").toMany(l, "isOn", function () {
            for (var _len39 = arguments.length, t = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
              t[_key39] = arguments[_key39];
            }
            const e = t.findIndex(Io);
            return MD(a, e < 0 ? o.label : l[e].label);
          }), d.bind("isOn").toMany(l, "isOn", function () {
            for (var _len40 = arguments.length, t = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
              t[_key40] = arguments[_key40];
            }
            return t.some(Io);
          }), d.bind("class").toMany(l, "isOn", function () {
            for (var _len41 = arguments.length, t = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
              t[_key41] = arguments[_key41];
            }
            return t.some(Io) ? "ck-splitbutton_flatten" : void 0;
          }), d.on("execute", () => {
            l.some(_ref156 => {
              let {
                isOn: t
              } = _ref156;
              return t;
            }) ? c.isOpen = !c.isOpen : o.fire("execute");
          }), c.bind("isEnabled").toMany(l, "isEnabled", function () {
            for (var _len42 = arguments.length, t = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
              t[_key42] = arguments[_key42];
            }
            return t.some(Io);
          }), this.listenTo(c, "execute", () => {
            this.editor.editing.view.focus();
          }), c;
        });
      }
      _createButton(t) {
        const e = t.name;
        this.editor.ui.componentFactory.add(ID(e), n => {
          const i = this.editor.commands.get("imageStyle"),
            o = new mm(n);
          return o.set({
            label: t.title,
            icon: t.icon,
            tooltip: !0,
            isToggleable: !0
          }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", t => t === e), o.on("execute", this._executeCommand.bind(this, e)), o;
        });
      }
      _executeCommand(t) {
        this.editor.execute("imageStyle", {
          value: t
        }), this.editor.editing.view.focus();
      }
    }
    function TD(t, e) {
      for (const n of t) e[n.title] && (n.title = e[n.title]);
      return t;
    }
    function ID(t) {
      return `imageStyle:${t}`;
    }
    function MD(t, e) {
      return (t ? t + ": " : "") + e;
    }
    class LD extends Nr {
      static get pluginName() {
        return "IndentEditing";
      }
      init() {
        const t = this.editor;
        t.commands.add("indent", new Rr(t)), t.commands.add("outdent", new Rr(t));
      }
    }
    class ND extends Nr {
      static get pluginName() {
        return "IndentUI";
      }
      init() {
        const t = this.editor,
          e = t.locale,
          n = t.t,
          i = "ltr" == e.uiLanguageDirection ? Yh.indent : Yh.outdent,
          o = "ltr" == e.uiLanguageDirection ? Yh.outdent : Yh.indent;
        this._defineButton("indent", n("Increase indent"), i), this._defineButton("outdent", n("Decrease indent"), o);
      }
      _defineButton(t, e, n) {
        const i = this.editor;
        i.ui.componentFactory.add(t, () => {
          const i = this._createButton(mm, t, e, n);
          return i.set({
            tooltip: !0
          }), i;
        }), i.ui.componentFactory.add("menuBar:" + t, () => this._createButton(Uk, t, e, n));
      }
      _createButton(t, e, n, i) {
        const o = this.editor,
          r = o.commands.get(e),
          s = new t(o.locale);
        return s.set({
          label: n,
          icon: i
        }), s.bind("isEnabled").to(r, "isEnabled"), this.listenTo(s, "execute", () => {
          o.execute(e), o.editing.view.focus();
        }), s;
      }
    }
    class zD extends Pr {
      constructor(t, e) {
        super(t), this._indentBehavior = e;
      }
      refresh() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        t && this._isIndentationChangeAllowed(t) ? this.isEnabled = this._indentBehavior.checkEnabled(t.getAttribute("blockIndent")) : this.isEnabled = !1;
      }
      execute() {
        const t = this.editor.model,
          e = this._getBlocksToChange();
        t.change(t => {
          for (const n of e) {
            const e = n.getAttribute("blockIndent"),
              i = this._indentBehavior.getNextIndent(e);
            i ? t.setAttribute("blockIndent", i, n) : t.removeAttribute("blockIndent", n);
          }
        });
      }
      _getBlocksToChange() {
        const t = this.editor.model.document.selection;
        return Array.from(t.getSelectedBlocks()).filter(t => this._isIndentationChangeAllowed(t));
      }
      _isIndentationChangeAllowed(t) {
        const e = this.editor;
        if (!e.model.schema.checkAttribute(t, "blockIndent")) return !1;
        if (!e.plugins.has("ListUtils")) return !0;
        if (!this._indentBehavior.isForward) return !0;
        return !e.plugins.get("ListUtils").isListItemBlock(t);
      }
    }
    class PD {
      constructor(t) {
        this.isForward = "forward" === t.direction, this.offset = t.offset, this.unit = t.unit;
      }
      checkEnabled(t) {
        const e = parseFloat(t || "0");
        return this.isForward || e > 0;
      }
      getNextIndent(t) {
        const e = parseFloat(t || "0");
        if (!(!t || t.endsWith(this.unit))) return this.isForward ? this.offset + this.unit : void 0;
        const n = e + (this.isForward ? this.offset : -this.offset);
        return n > 0 ? n + this.unit : void 0;
      }
    }
    class VD {
      constructor(t) {
        this.isForward = "forward" === t.direction, this.classes = t.classes;
      }
      checkEnabled(t) {
        const e = this.classes.indexOf(t);
        return this.isForward ? e < this.classes.length - 1 : e >= 0;
      }
      getNextIndent(t) {
        const e = this.classes.indexOf(t),
          n = this.isForward ? 1 : -1;
        return this.classes[e + n];
      }
    }
    const RD = ["paragraph", "heading1", "heading2", "heading3", "heading4", "heading5", "heading6"];
    function FD(t, e) {
      return `${t}:${e = e || _o(t)}`;
    }
    class OD extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "language");
      }
      execute() {
        let {
          languageCode: t,
          textDirection: e
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const n = this.editor.model,
          i = n.document.selection,
          o = !!t && FD(t, e);
        n.change(t => {
          if (i.isCollapsed) o ? t.setSelectionAttribute("language", o) : t.removeSelectionAttribute("language");else {
            const e = n.schema.getValidRanges(i.getRanges(), "language");
            for (const n of e) o ? t.setAttribute("language", o, n) : t.removeAttribute("language", n);
          }
        });
      }
      _getValueFromFirstAllowedNode() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection;
        if (n.isCollapsed) return n.getAttribute("language") || !1;
        for (const t of n.getRanges()) for (const n of t.getItems()) if (e.checkAttribute(n, "language")) return n.getAttribute("language") || !1;
        return !1;
      }
    }
    class jD extends Nr {
      static get pluginName() {
        return "TextPartLanguageEditing";
      }
      constructor(t) {
        super(t), t.config.define("language", {
          textPartLanguage: [{
            title: "Arabic",
            languageCode: "ar"
          }, {
            title: "French",
            languageCode: "fr"
          }, {
            title: "Spanish",
            languageCode: "es"
          }]
        });
      }
      init() {
        const t = this.editor;
        t.model.schema.extend("$text", {
          allowAttributes: "language"
        }), t.model.schema.setAttributeProperties("language", {
          copyOnEnter: !0
        }), this._defineConverters(), t.commands.add("textPartLanguage", new OD(t));
      }
      _defineConverters() {
        const t = this.editor.conversion;
        t.for("upcast").elementToAttribute({
          model: {
            key: "language",
            value: t => FD(t.getAttribute("lang"), t.getAttribute("dir"))
          },
          view: {
            name: "span",
            attributes: {
              lang: /[\s\S]+/
            }
          }
        }), t.for("downcast").attributeToElement({
          model: "language",
          view: (t, _ref157, n) => {
            let {
              writer: e
            } = _ref157;
            if (!t) return;
            if (!n.item.is("$textProxy") && !n.item.is("documentSelection")) return;
            const {
              languageCode: i,
              textDirection: o
            } = function (t) {
              const [e, n] = t.split(":");
              return {
                languageCode: e,
                textDirection: n
              };
            }(t);
            return e.createAttributeElement("span", {
              lang: i,
              dir: o
            });
          }
        });
      }
    }
    class HD extends Nr {
      static get pluginName() {
        return "TextPartLanguageUI";
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = e("Choose language"),
          i = e("Language");
        t.ui.componentFactory.add("textPartLanguage", e => {
          const {
              definitions: o,
              titles: r
            } = this._getItemMetadata(),
            s = t.commands.get("textPartLanguage"),
            a = Eg(e);
          return Sg(a, o, {
            ariaLabel: i,
            role: "menu"
          }), a.buttonView.set({
            ariaLabel: i,
            ariaLabelledBy: void 0,
            isOn: !1,
            withText: !0,
            tooltip: i
          }), a.extendTemplate({
            attributes: {
              class: ["ck-text-fragment-language-dropdown"]
            }
          }), a.bind("isEnabled").to(s, "isEnabled"), a.buttonView.bind("label").to(s, "value", t => t && r[t] || n), a.buttonView.bind("ariaLabel").to(s, "value", t => {
            const e = t && r[t];
            return e ? `${e}, ${i}` : i;
          }), this.listenTo(a, "execute", e => {
            s.execute({
              languageCode: e.source.languageCode,
              textDirection: e.source.textDirection
            }), t.editing.view.focus();
          }), a;
        }), t.ui.componentFactory.add("menuBar:textPartLanguage", n => {
          const {
              definitions: o
            } = this._getItemMetadata(),
            r = t.commands.get("textPartLanguage"),
            s = new Fk(n);
          s.buttonView.set({
            label: i
          });
          const a = new Ok(n);
          a.set({
            ariaLabel: e("Language"),
            role: "menu"
          });
          for (const t of o) {
            if ("button" != t.type) {
              a.items.add(new gg(n));
              continue;
            }
            const e = new fk(n, s),
              i = new Uk(n);
            i.bind(...Object.keys(t.model)).to(t.model), i.bind("ariaChecked").to(i, "isOn"), i.delegate("execute").to(s), e.children.add(i), a.items.add(e);
          }
          return s.bind("isEnabled").to(r, "isEnabled"), s.panelView.children.add(a), s.on("execute", e => {
            r.execute({
              languageCode: e.source.languageCode,
              textDirection: e.source.textDirection
            }), t.editing.view.focus();
          }), s;
        });
      }
      _getItemMetadata() {
        const t = this.editor,
          e = new Wo(),
          n = {},
          i = t.commands.get("textPartLanguage"),
          o = t.config.get("language.textPartLanguage"),
          r = (0, t.locale.t)("Remove language");
        e.add({
          type: "button",
          model: new Mf({
            label: r,
            languageCode: !1,
            withText: !0
          })
        }), e.add({
          type: "separator"
        });
        for (const t of o) {
          const o = {
              type: "button",
              model: new Mf({
                label: t.title,
                languageCode: t.languageCode,
                role: "menuitemradio",
                textDirection: t.textDirection,
                withText: !0
              })
            },
            r = FD(t.languageCode, t.textDirection);
          o.model.bind("isOn").to(i, "value", t => t === r), e.add(o), n[r] = t.title;
        }
        return {
          definitions: e,
          titles: n
        };
      }
    }
    class UD {
      constructor() {
        this._definitions = new Set();
      }
      get length() {
        return this._definitions.size;
      }
      add(t) {
        Array.isArray(t) ? t.forEach(t => this._definitions.add(t)) : this._definitions.add(t);
      }
      getDispatcher() {
        return t => {
          t.on("attribute:linkHref", (t, e, n) => {
            if (!n.consumable.test(e.item, "attribute:linkHref")) return;
            if (!e.item.is("selection") && !n.schema.isInline(e.item)) return;
            const i = n.writer,
              o = i.document.selection;
            for (const t of this._definitions) {
              const r = i.createAttributeElement("a", t.attributes, {
                priority: 5
              });
              t.classes && i.addClass(t.classes, r);
              for (const e in t.styles) i.setStyle(e, t.styles[e], r);
              i.setCustomProperty("link", !0, r), t.callback(e.attributeNewValue) ? e.item.is("selection") ? i.wrap(o.getFirstRange(), r) : i.wrap(n.mapper.toViewRange(e.range), r) : i.unwrap(n.mapper.toViewRange(e.range), r);
            }
          }, {
            priority: "high"
          });
        };
      }
      getDispatcherForLinkedImage() {
        return t => {
          t.on("attribute:linkHref:imageBlock", (t, e, _ref158) => {
            let {
              writer: n,
              mapper: i
            } = _ref158;
            const o = i.toViewElement(e.item),
              r = Array.from(o.getChildren()).find(t => t.is("element", "a"));
            for (const t of this._definitions) {
              const i = Qo(t.attributes);
              if (t.callback(e.attributeNewValue)) {
                for (const [t, e] of i) "class" === t ? n.addClass(e, r) : n.setAttribute(t, e, r);
                t.classes && n.addClass(t.classes, r);
                for (const e in t.styles) n.setStyle(e, t.styles[e], r);
              } else {
                for (const [t, e] of i) "class" === t ? n.removeClass(e, r) : n.removeAttribute(t, r);
                t.classes && n.removeClass(t.classes, r);
                for (const e in t.styles) n.removeStyle(e, r);
              }
            }
          });
        };
      }
    }
    const qD = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
      GD = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
      WD = /^((\w+:(\/{2,})?)|(\W))/i,
      $D = ["https?", "ftps?", "mailto"],
      KD = "Ctrl+K";
    function YD(t, _ref159) {
      let {
        writer: e
      } = _ref159;
      const n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }
    function QD(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $D;
      const n = String(t),
        i = e.join("|");
      return function (t, e) {
        const n = t.replace(qD, "");
        return !!n.match(e);
      }(n, new RegExp(`${"^(?:(?:<protocols>):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))".replace("<protocols>", i)}`, "i")) ? n : "#";
    }
    function ZD(t, e) {
      return !!t && e.checkAttribute(t.name, "linkHref");
    }
    function JD(t, e) {
      const n = (i = t, GD.test(i) ? "mailto:" : e);
      var i;
      const o = !!n && !XD(t);
      return t && o ? n + t : t;
    }
    function XD(t) {
      return WD.test(t);
    }
    function tB(t) {
      window.open(t, "_blank", "noopener");
    }
    class eB extends Pr {
      constructor() {
        super(...arguments), this.manualDecorators = new Wo(), this.automaticDecorators = new UD();
      }
      restoreManualDecoratorStates() {
        for (const t of this.manualDecorators) t.value = this._getDecoratorStateFromModel(t.id);
      }
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = e.getSelectedElement() || $o(e.getSelectedBlocks());
        ZD(n, t.schema) ? (this.value = n.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(n, "linkHref")) : (this.value = e.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref"));
        for (const t of this.manualDecorators) t.value = this._getDecoratorStateFromModel(t.id);
      }
      execute(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = n.document.selection,
          o = [],
          r = [];
        for (const t in e) e[t] ? o.push(t) : r.push(t);
        n.change(e => {
          if (i.isCollapsed) {
            const s = i.getFirstPosition();
            if (i.hasAttribute("linkHref")) {
              const a = nB(i);
              let l = dw(s, "linkHref", i.getAttribute("linkHref"), n);
              i.getAttribute("linkHref") === a && (l = this._updateLinkContent(n, e, l, t)), e.setAttribute("linkHref", t, l), o.forEach(t => {
                e.setAttribute(t, !0, l);
              }), r.forEach(t => {
                e.removeAttribute(t, l);
              }), e.setSelection(e.createPositionAfter(l.end.nodeBefore));
            } else if ("" !== t) {
              const r = Qo(i.getAttributes());
              r.set("linkHref", t), o.forEach(t => {
                r.set(t, !0);
              });
              const {
                end: a
              } = n.insertContent(e.createText(t, r), s);
              e.setSelection(a);
            }
            ["linkHref", ...o, ...r].forEach(t => {
              e.removeSelectionAttribute(t);
            });
          } else {
            const s = n.schema.getValidRanges(i.getRanges(), "linkHref"),
              a = [];
            for (const t of i.getSelectedBlocks()) n.schema.checkAttribute(t, "linkHref") && a.push(e.createRangeOn(t));
            const l = a.slice();
            for (const t of s) this._isRangeToUpdate(t, a) && l.push(t);
            for (const s of l) {
              let a = s;
              if (1 === l.length) {
                const o = nB(i);
                i.getAttribute("linkHref") === o && (a = this._updateLinkContent(n, e, s, t), e.setSelection(e.createSelection(a)));
              }
              e.setAttribute("linkHref", t, a), o.forEach(t => {
                e.setAttribute(t, !0, a);
              }), r.forEach(t => {
                e.removeAttribute(t, a);
              });
            }
          }
        });
      }
      _getDecoratorStateFromModel(t) {
        const e = this.editor.model,
          n = e.document.selection,
          i = n.getSelectedElement();
        return ZD(i, e.schema) ? i.getAttribute(t) : n.getAttribute(t);
      }
      _isRangeToUpdate(t, e) {
        for (const n of e) if (n.containsRange(t)) return !1;
        return !0;
      }
      _updateLinkContent(t, e, n, i) {
        const o = e.createText(i, {
          linkHref: i
        });
        return t.insertContent(o, n);
      }
    }
    function nB(t) {
      if (t.isCollapsed) {
        const e = t.getFirstPosition();
        return e.textNode && e.textNode.data;
      }
      {
        const e = Array.from(t.getFirstRange().getItems());
        if (e.length > 1) return null;
        const n = e[0];
        return n.is("$text") || n.is("$textProxy") ? n.data : null;
      }
    }
    class iB extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = e.getSelectedElement();
        ZD(n, t.schema) ? this.isEnabled = t.schema.checkAttribute(n, "linkHref") : this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
      }
      execute() {
        const t = this.editor,
          e = this.editor.model,
          n = e.document.selection,
          i = t.commands.get("link");
        e.change(t => {
          const o = n.isCollapsed ? [dw(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref");
          for (const e of o) if (t.removeAttribute("linkHref", e), i) for (const n of i.manualDecorators) t.removeAttribute(n.id, e);
        });
      }
    }
    class oB extends q() {
      constructor(_ref160) {
        let {
          id: t,
          label: e,
          attributes: n,
          classes: i,
          styles: o,
          defaultValue: r
        } = _ref160;
        super(), this.id = t, this.set("value", void 0), this.defaultValue = r, this.label = e, this.attributes = n, this.classes = i, this.styles = o;
      }
      _createPattern() {
        return {
          attributes: this.attributes,
          classes: this.classes,
          styles: this.styles
        };
      }
    }
    var rB = o(7456),
      sB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(rB.A, sB);
    rB.A.locals;
    const aB = "automatic",
      lB = /^(https?:)?\/\//;
    class cB extends Nr {
      static get pluginName() {
        return "LinkEditing";
      }
      static get requires() {
        return [Qb, Vb, Mb];
      }
      constructor(t) {
        super(t), t.config.define("link", {
          allowCreatingEmptyLinks: !1,
          addTargetToExternalLinks: !1
        });
      }
      init() {
        const t = this.editor,
          e = this.editor.config.get("link.allowedProtocols");
        t.model.schema.extend("$text", {
          allowAttributes: "linkHref"
        }), t.conversion.for("dataDowncast").attributeToElement({
          model: "linkHref",
          view: YD
        }), t.conversion.for("editingDowncast").attributeToElement({
          model: "linkHref",
          view: (t, n) => YD(QD(t, e), n)
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "a",
            attributes: {
              href: !0
            }
          },
          model: {
            key: "linkHref",
            value: t => t.getAttribute("href")
          }
        }), t.commands.add("link", new eB(t)), t.commands.add("unlink", new iB(t));
        const n = function (t, e) {
          const n = {
            "Open in a new tab": t("Open in a new tab"),
            Downloadable: t("Downloadable")
          };
          return e.forEach(t => ("label" in t && n[t.label] && (t.label = n[t.label]), t)), e;
        }(t.t, function (t) {
          const e = [];
          if (t) for (const [n, i] of Object.entries(t)) {
            const t = Object.assign({}, i, {
              id: `link${Uy(n)}`
            });
            e.push(t);
          }
          return e;
        }(t.config.get("link.decorators")));
        this._enableAutomaticDecorators(n.filter(t => t.mode === aB)), this._enableManualDecorators(n.filter(t => "manual" === t.mode));
        t.plugins.get(Qb).registerAttribute("linkHref"), hw(t, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableSelectionAttributesFixer(), this._enableClipboardIntegration();
      }
      _enableAutomaticDecorators(t) {
        const e = this.editor,
          n = e.commands.get("link").automaticDecorators;
        e.config.get("link.addTargetToExternalLinks") && n.add({
          id: "linkIsExternal",
          mode: aB,
          callback: t => !!t && lB.test(t),
          attributes: {
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
      }
      _enableManualDecorators(t) {
        if (!t.length) return;
        const e = this.editor,
          n = e.commands.get("link").manualDecorators;
        t.forEach(t => {
          e.model.schema.extend("$text", {
            allowAttributes: t.id
          });
          const i = new oB(t);
          n.add(i), e.conversion.for("downcast").attributeToElement({
            model: i.id,
            view: (t, _ref161, _ref162) => {
              let {
                writer: e,
                schema: n
              } = _ref161;
              let {
                item: o
              } = _ref162;
              if ((o.is("selection") || n.isInline(o)) && t) {
                const t = e.createAttributeElement("a", i.attributes, {
                  priority: 5
                });
                i.classes && e.addClass(i.classes, t);
                for (const n in i.styles) e.setStyle(n, i.styles[n], t);
                return e.setCustomProperty("link", !0, t), t;
              }
            }
          }), e.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              ...i._createPattern()
            },
            model: {
              key: i.id
            }
          });
        });
      }
      _enableLinkOpen() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "click", (t, e) => {
          if (!(s.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey)) return;
          let n = e.domTarget;
          if ("a" != n.tagName.toLowerCase() && (n = n.closest("a")), !n) return;
          const i = n.getAttribute("href");
          i && (t.stop(), e.preventDefault(), tB(i));
        }, {
          context: "$capture"
        }), this.listenTo(e, "keydown", (e, n) => {
          const i = t.commands.get("link").value;
          !!i && n.keyCode === po.enter && n.altKey && (e.stop(), tB(i));
        });
      }
      _enableSelectionAttributesFixer() {
        const t = this.editor.model,
          e = t.document.selection;
        this.listenTo(e, "change:attribute", (n, _ref163) => {
          let {
            attributeKeys: i
          } = _ref163;
          i.includes("linkHref") && !e.hasAttribute("linkHref") && t.change(e => {
            var n;
            !function (t, e) {
              t.removeSelectionAttribute("linkHref");
              for (const n of e) t.removeSelectionAttribute(n);
            }(e, (n = t.schema, n.getDefinition("$text").allowAttributes.filter(t => t.startsWith("link"))));
          });
        });
      }
      _enableClipboardIntegration() {
        const t = this.editor,
          e = t.model,
          n = this.editor.config.get("link.defaultProtocol");
        n && this.listenTo(t.plugins.get("ClipboardPipeline"), "contentInsertion", (t, i) => {
          e.change(t => {
            const e = t.createRangeIn(i.content);
            for (const i of e.getItems()) if (i.hasAttribute("linkHref")) {
              const e = JD(i.getAttribute("linkHref"), n);
              t.setAttribute("linkHref", e, i);
            }
          });
        });
      }
    }
    var dB = o(2350),
      uB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(dB.A, uB);
    dB.A.locals;
    class hB extends Sr {
      constructor(t, e, n) {
        super(t), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusables = new nr();
        const i = t.t;
        this._validators = n, this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(i("Save"), Yh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(i("Cancel"), Yh.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(e), this.children = this._createFormChildren(e.manualDecorators), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        const o = ["ck", "ck-link-form", "ck-responsive-form"];
        e.manualDecorators.length && o.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({
          tag: "form",
          attributes: {
            class: o,
            tabindex: "-1"
          },
          children: this.children
        });
      }
      getDecoratorSwitchesState() {
        return Array.from(this._manualDecoratorSwitches).reduce((t, e) => (t[e.name] = e.isOn, t), {});
      }
      render() {
        super.render(), Mr({
          view: this
        });
        [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      isValid() {
        this.resetFormStatus();
        for (const t of this._validators) {
          const e = t(this);
          if (e) return this.urlInputView.errorText = e, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null;
      }
      _createUrlInput() {
        const t = this.locale.t,
          e = new Fm(this.locale, Lg);
        return e.label = t("Link URL"), e;
      }
      _createButton(t, e, n, i) {
        const o = new mm(this.locale);
        return o.set({
          label: t,
          icon: e,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
      _createManualDecoratorSwitches(t) {
        const e = this.createCollection();
        for (const n of t.manualDecorators) {
          const i = new fm(this.locale);
          i.set({
            name: n.id,
            label: n.label,
            withText: !0
          }), i.bind("isOn").toMany([n, t], "value", (t, e) => void 0 === e && void 0 === t ? !!n.defaultValue : !!t), i.on("execute", () => {
            n.set("value", !i.isOn);
          }), e.add(i);
        }
        return e;
      }
      _createFormChildren(t) {
        const e = this.createCollection();
        if (e.add(this.urlInputView), t.length) {
          const t = new Sr();
          t.setTemplate({
            tag: "ul",
            children: this._manualDecoratorSwitches.map(t => ({
              tag: "li",
              children: [t],
              attributes: {
                class: ["ck", "ck-list__item"]
              }
            })),
            attributes: {
              class: ["ck", "ck-reset", "ck-list"]
            }
          }), e.add(t);
        }
        return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
      }
      get url() {
        const {
          element: t
        } = this.urlInputView.fieldView;
        return t ? t.value.trim() : null;
      }
    }
    var mB = o(8040),
      gB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(mB.A, gB);
    mB.A.locals;
    class pB extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusables = new nr();
        const n = t.t;
        this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(n("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), this.editButtonView = this._createButton(n("Edit link"), Yh.pencil, "edit"), this.set("href", void 0), this._linkConfig = e, this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView]
        });
      }
      render() {
        super.render();
        [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createButton(t, e, n) {
        const i = new mm(this.locale);
        return i.set({
          label: t,
          icon: e,
          tooltip: !0
        }), i.delegate("execute").to(this, n), i;
      }
      _createPreviewButton() {
        const t = new mm(this.locale),
          e = this.bindTemplate,
          n = this.t;
        return t.set({
          withText: !0,
          tooltip: n("Open link in new tab")
        }), t.extendTemplate({
          attributes: {
            class: ["ck", "ck-link-actions__preview"],
            href: e.to("href", t => t && QD(t, this._linkConfig.allowedProtocols)),
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }), t.bind("label").to(this, "href", t => t || n("This link has no URL")), t.bind("isEnabled").to(this, "href", t => !!t), t.template.tag = "a", t.template.eventListeners = {}, t;
      }
    }
    const fB = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>',
      kB = "link-ui";
    class bB extends Nr {
      constructor() {
        super(...arguments), this.actionsView = null, this.formView = null;
      }
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "LinkUI";
      }
      init() {
        const t = this.editor,
          e = this.editor.t;
        t.editing.view.addObserver(Ju), this._balloon = t.plugins.get(Rf), this._createToolbarLinkButton(), this._enableBalloonActivators(), t.conversion.for("editingDowncast").markerToHighlight({
          model: kB,
          view: {
            classes: ["ck-fake-link-selection"]
          }
        }), t.conversion.for("editingDowncast").markerToElement({
          model: kB,
          view: {
            name: "span",
            classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
          }
        }), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Create link"),
            keystroke: KD
          }, {
            label: e("Move out of a link"),
            keystroke: [["arrowleft", "arrowleft"], ["arrowright", "arrowright"]]
          }]
        });
      }
      destroy() {
        super.destroy(), this.formView && this.formView.destroy(), this.actionsView && this.actionsView.destroy();
      }
      _createViews() {
        this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._enableUserBalloonInteractions();
      }
      _createActionsView() {
        const t = this.editor,
          e = new pB(t.locale, t.config.get("link")),
          n = t.commands.get("link"),
          i = t.commands.get("unlink");
        return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(e, "edit", () => {
          this._addFormView();
        }), this.listenTo(e, "unlink", () => {
          t.execute("unlink"), this._hideUI();
        }), e.keystrokes.set("Esc", (t, e) => {
          this._hideUI(), e();
        }), e.keystrokes.set(KD, (t, e) => {
          this._addFormView(), e();
        }), e;
      }
      _createFormView() {
        const t = this.editor,
          e = t.commands.get("link"),
          n = t.config.get("link.defaultProtocol"),
          i = new (Ir(hB))(t.locale, e, function (t) {
            const e = t.t,
              n = t.config.get("link.allowCreatingEmptyLinks");
            return [t => {
              if (!n && !t.url.length) return e("Link URL must not be empty.");
            }];
          }(t));
        return i.urlInputView.fieldView.bind("value").to(e, "value"), i.urlInputView.bind("isEnabled").to(e, "isEnabled"), i.saveButtonView.bind("isEnabled").to(e, "isEnabled"), this.listenTo(i, "submit", () => {
          if (i.isValid()) {
            const {
                value: e
              } = i.urlInputView.fieldView.element,
              o = JD(e, n);
            t.execute("link", o, i.getDecoratorSwitchesState()), this._closeFormView();
          }
        }), this.listenTo(i.urlInputView, "change:errorText", () => {
          t.ui.update();
        }), this.listenTo(i, "cancel", () => {
          this._closeFormView();
        }), i.keystrokes.set("Esc", (t, e) => {
          this._closeFormView(), e();
        }), i;
      }
      _createToolbarLinkButton() {
        const t = this.editor,
          e = t.commands.get("link");
        t.ui.componentFactory.add("link", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0,
            isToggleable: !0
          }), t.bind("isOn").to(e, "value", t => !!t), t;
        }), t.ui.componentFactory.add("menuBar:link", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("link"),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Link"),
          icon: fB,
          keystroke: KD
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => this._showUI(!0)), o;
      }
      _enableBalloonActivators() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "click", () => {
          this._getSelectedLinkElement() && this._showUI();
        }), t.keystrokes.set(KD, (e, n) => {
          n(), t.commands.get("link").isEnabled && this._showUI(!0);
        });
      }
      _enableUserBalloonInteractions() {
        this.editor.keystrokes.set("Tab", (t, e) => {
          this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), e());
        }, {
          priority: "high"
        }), this.editor.keystrokes.set("Esc", (t, e) => {
          this._isUIVisible && (this._hideUI(), e());
        }), Tr({
          emitter: this.formView,
          activator: () => this._isUIInPanel,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideUI()
        });
      }
      _addActionsView() {
        this.actionsView || this._createViews(), this._areActionsInPanel || this._balloon.add({
          view: this.actionsView,
          position: this._getBalloonPositionData()
        });
      }
      _addFormView() {
        if (this.formView || this._createViews(), this._isFormInPanel) return;
        const t = this.editor.commands.get("link");
        this.formView.disableCssTransitions(), this.formView.resetFormStatus(), this._balloon.add({
          view: this.formView,
          position: this._getBalloonPositionData()
        }), this.formView.urlInputView.fieldView.value = t.value || "", this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions();
      }
      _closeFormView() {
        const t = this.editor.commands.get("link");
        t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
      }
      _removeFormView() {
        this._isFormInPanel && (this.formView.saveButtonView.focus(), this.formView.urlInputView.fieldView.reset(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
      }
      _showUI() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
        this.formView || this._createViews(), this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
      }
      _hideUI() {
        if (!this._isUIInPanel) return;
        const t = this.editor;
        this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
      }
      _startUpdatingUI() {
        const t = this.editor,
          e = t.editing.view.document;
        let n = this._getSelectedLinkElement(),
          i = r();
        const o = () => {
          const t = this._getSelectedLinkElement(),
            e = r();
          n && !t || !n && e !== i ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), n = t, i = e;
        };
        function r() {
          return e.selection.focus.getAncestors().reverse().find(t => t.is("element"));
        }
        this.listenTo(t.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
      }
      get _isFormInPanel() {
        return !!this.formView && this._balloon.hasView(this.formView);
      }
      get _areActionsInPanel() {
        return !!this.actionsView && this._balloon.hasView(this.actionsView);
      }
      get _areActionsVisible() {
        return !!this.actionsView && this._balloon.visibleView === this.actionsView;
      }
      get _isUIInPanel() {
        return this._isFormInPanel || this._areActionsInPanel;
      }
      get _isUIVisible() {
        const t = this._balloon.visibleView;
        return !!this.formView && t == this.formView || this._areActionsVisible;
      }
      _getBalloonPositionData() {
        const t = this.editor.editing.view,
          e = this.editor.model,
          n = t.document;
        let i;
        if (e.markers.has(kB)) {
          const e = Array.from(this.editor.editing.mapper.markerNameToElements(kB)),
            n = t.createRange(t.createPositionBefore(e[0]), t.createPositionAfter(e[e.length - 1]));
          i = t.domConverter.viewRangeToDom(n);
        } else i = () => {
          const e = this._getSelectedLinkElement();
          return e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(n.selection.getFirstRange());
        };
        return {
          target: i
        };
      }
      _getSelectedLinkElement() {
        const t = this.editor.editing.view,
          e = t.document.selection,
          n = e.getSelectedElement();
        if (e.isCollapsed || n && Sw(n)) return wB(e.getFirstPosition());
        {
          const n = e.getFirstRange().getTrimmed(),
            i = wB(n.start),
            o = wB(n.end);
          return i && i == o && t.createRangeIn(i).getTrimmed().isEqual(n) ? i : null;
        }
      }
      _showFakeVisualSelection() {
        const t = this.editor.model;
        t.change(e => {
          const n = t.document.selection.getFirstRange();
          if (t.markers.has(kB)) e.updateMarker(kB, {
            range: n
          });else if (n.start.isAtEnd) {
            const i = n.start.getLastMatchingPosition(_ref164 => {
              let {
                item: e
              } = _ref164;
              return !t.schema.isContent(e);
            }, {
              boundaries: n
            });
            e.addMarker(kB, {
              usingOperation: !1,
              affectsData: !1,
              range: e.createRange(i, n.end)
            });
          } else e.addMarker(kB, {
            usingOperation: !1,
            affectsData: !1,
            range: n
          });
        });
      }
      _hideFakeVisualSelection() {
        const t = this.editor.model;
        t.markers.has(kB) && t.change(t => {
          t.removeMarker(kB);
        });
      }
    }
    function wB(t) {
      return t.getAncestors().find(t => {
        return (e = t).is("attributeElement") && !!e.getCustomProperty("link");
        var e;
      }) || null;
    }
    const AB = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
    class CB extends Nr {
      static get requires() {
        return [Wb, cB];
      }
      static get pluginName() {
        return "AutoLink";
      }
      init() {
        const t = this.editor.model.document.selection;
        t.on("change:range", () => {
          this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
        }), this._enableTypingHandling();
      }
      afterInit() {
        this._enableEnterHandling(), this._enableShiftEnterHandling(), this._enablePasteLinking();
      }
      _expandLinkRange(t, e) {
        return e.textNode && e.textNode.hasAttribute("linkHref") ? dw(e, "linkHref", e.textNode.getAttribute("linkHref"), t) : null;
      }
      _selectEntireLinks(t, e) {
        const n = this.editor.model,
          i = n.document.selection,
          o = i.getFirstPosition(),
          r = i.getLastPosition();
        let s = e.getJoined(this._expandLinkRange(n, o) || e);
        s && (s = s.getJoined(this._expandLinkRange(n, r) || e)), s && (s.start.isBefore(o) || s.end.isAfter(r)) && t.setSelection(s);
      }
      _enablePasteLinking() {
        const t = this.editor,
          e = t.model,
          n = e.document.selection,
          i = t.plugins.get("ClipboardPipeline"),
          o = t.commands.get("link");
        i.on("inputTransformation", (t, i) => {
          if (!this.isEnabled || !o.isEnabled || n.isCollapsed || "paste" !== i.method) return;
          if (n.rangeCount > 1) return;
          const r = n.getFirstRange(),
            s = i.dataTransfer.getData("text/plain");
          if (!s) return;
          const a = s.match(AB);
          a && a[2] === s && (e.change(t => {
            this._selectEntireLinks(t, r), o.execute(s);
          }), t.stop());
        }, {
          priority: "high"
        });
      }
      _enableTypingHandling() {
        const t = this.editor,
          e = new Yb(t.model, t => {
            if (!function (t) {
              return t.length > 4 && " " === t[t.length - 1] && " " !== t[t.length - 2];
            }(t)) return;
            const e = _B(t.substr(0, t.length - 1));
            return e ? {
              url: e
            } : void 0;
          });
        e.on("matched:data", (e, n) => {
          const {
            batch: i,
            range: o,
            url: r
          } = n;
          if (!i.isTyping) return;
          const s = o.end.getShiftedBy(-1),
            a = s.getShiftedBy(-r.length),
            l = t.model.createRange(a, s);
          this._applyAutoLink(r, l);
        }), e.bind("isEnabled").to(this);
      }
      _enableEnterHandling() {
        const t = this.editor,
          e = t.model,
          n = t.commands.get("enter");
        n && n.on("execute", () => {
          const t = e.document.selection.getFirstPosition();
          if (!t.parent.previousSibling) return;
          const n = e.createRangeIn(t.parent.previousSibling);
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _enableShiftEnterHandling() {
        const t = this.editor,
          e = t.model,
          n = t.commands.get("shiftEnter");
        n && n.on("execute", () => {
          const t = e.document.selection.getFirstPosition(),
            n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));
          this._checkAndApplyAutoLinkOnRange(n);
        });
      }
      _checkAndApplyAutoLinkOnRange(t) {
        const e = this.editor.model,
          {
            text: n,
            range: i
          } = Kb(t, e),
          o = _B(n);
        if (o) {
          const t = e.createRange(i.end.getShiftedBy(-o.length), i.end);
          this._applyAutoLink(o, t);
        }
      }
      _applyAutoLink(t, e) {
        const n = this.editor.model,
          i = JD(t, this.editor.config.get("link.defaultProtocol"));
        this.isEnabled && function (t, e) {
          return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
        }(e, n) && XD(i) && !function (t) {
          const e = t.start.nodeAfter;
          return !!e && e.hasAttribute("linkHref");
        }(e) && this._persistAutoLink(i, e);
      }
      _persistAutoLink(t, e) {
        const n = this.editor.model,
          i = this.editor.plugins.get("Delete");
        n.enqueueChange(o => {
          o.setAttribute("linkHref", t, e), n.enqueueChange(() => {
            i.requestUndoOnBackspace();
          });
        });
      }
    }
    function _B(t) {
      const e = AB.exec(t);
      return e ? e[2] : null;
    }
    class vB extends Nr {
      static get requires() {
        return ["ImageEditing", "ImageUtils", cB];
      }
      static get pluginName() {
        return "LinkImageEditing";
      }
      afterInit() {
        const t = this.editor,
          e = t.model.schema;
        t.plugins.has("ImageBlockEditing") && e.extend("imageBlock", {
          allowAttributes: ["linkHref"]
        }), t.conversion.for("upcast").add(function (t) {
          const e = t.plugins.has("ImageInlineEditing"),
            n = t.plugins.get("ImageUtils");
          return t => {
            t.on("element:a", (t, i, o) => {
              const r = i.viewItem,
                s = n.findViewImgElement(r);
              if (!s) return;
              const a = s.findAncestor(t => n.isBlockImageView(t));
              if (e && !a) return;
              const l = {
                attributes: ["href"]
              };
              if (!o.consumable.consume(r, l)) return;
              const c = r.getAttribute("href");
              if (!c) return;
              let d = i.modelCursor.parent;
              if (!d.is("element", "imageBlock")) {
                const t = o.convertItem(s, i.modelCursor);
                i.modelRange = t.modelRange, i.modelCursor = t.modelCursor, d = i.modelCursor.nodeBefore;
              }
              d && d.is("element", "imageBlock") && o.writer.setAttribute("linkHref", c, d);
            }, {
              priority: "high"
            });
          };
        }(t)), t.conversion.for("downcast").add(function (t) {
          const e = t.plugins.get("ImageUtils");
          return t => {
            t.on("attribute:linkHref:imageBlock", (t, n, i) => {
              if (!i.consumable.consume(n.item, t.name)) return;
              const o = i.mapper.toViewElement(n.item),
                r = i.writer,
                s = Array.from(o.getChildren()).find(t => t.is("element", "a")),
                a = e.findViewImgElement(o),
                l = a.parent.is("element", "picture") ? a.parent : a;
              if (s) n.attributeNewValue ? r.setAttribute("href", n.attributeNewValue, s) : (r.move(r.createRangeOn(l), r.createPositionAt(o, 0)), r.remove(s));else {
                const t = r.createContainerElement("a", {
                  href: n.attributeNewValue
                });
                r.insert(r.createPositionAt(o, 0), t), r.move(r.createRangeOn(l), r.createPositionAt(t, 0));
              }
            }, {
              priority: "high"
            });
          };
        }(t)), this._enableAutomaticDecorators(), this._enableManualDecorators();
      }
      _enableAutomaticDecorators() {
        const t = this.editor,
          e = t.commands.get("link").automaticDecorators;
        e.length && t.conversion.for("downcast").add(e.getDispatcherForLinkedImage());
      }
      _enableManualDecorators() {
        const t = this.editor,
          e = t.commands.get("link");
        for (const n of e.manualDecorators) t.plugins.has("ImageBlockEditing") && t.model.schema.extend("imageBlock", {
          allowAttributes: n.id
        }), t.plugins.has("ImageInlineEditing") && t.model.schema.extend("imageInline", {
          allowAttributes: n.id
        }), t.conversion.for("downcast").add(yB(n)), t.conversion.for("upcast").add(xB(t, n));
      }
    }
    function yB(t) {
      return e => {
        e.on(`attribute:${t.id}:imageBlock`, (e, n, i) => {
          const o = i.mapper.toViewElement(n.item),
            r = Array.from(o.getChildren()).find(t => t.is("element", "a"));
          if (r) {
            for (const [e, n] of Qo(t.attributes)) i.writer.setAttribute(e, n, r);
            t.classes && i.writer.addClass(t.classes, r);
            for (const e in t.styles) i.writer.setStyle(e, t.styles[e], r);
          }
        });
      };
    }
    function xB(t, e) {
      const n = t.plugins.has("ImageInlineEditing"),
        i = t.plugins.get("ImageUtils");
      return t => {
        t.on("element:a", (t, o, r) => {
          const s = o.viewItem,
            a = i.findViewImgElement(s);
          if (!a) return;
          const l = a.findAncestor(t => i.isBlockImageView(t));
          if (n && !l) return;
          const c = new os(e._createPattern()).match(s);
          if (!c) return;
          if (!r.consumable.consume(s, c.match)) return;
          const d = o.modelCursor.nodeBefore || o.modelCursor.parent;
          r.writer.setAttribute(e.id, !0, d);
        }, {
          priority: "high"
        });
      };
    }
    class EB extends Nr {
      static get requires() {
        return [cB, bB, "ImageBlockEditing"];
      }
      static get pluginName() {
        return "LinkImageUI";
      }
      init() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "click", (e, n) => {
          this._isSelectedLinkedImage(t.model.document.selection) && (n.preventDefault(), e.stop());
        }, {
          priority: "high"
        }), this._createToolbarLinkImageButton();
      }
      _createToolbarLinkImageButton() {
        const t = this.editor,
          e = t.t;
        t.ui.componentFactory.add("linkImage", n => {
          const i = new mm(n),
            o = t.plugins.get("LinkUI"),
            r = t.commands.get("link");
          return i.set({
            isEnabled: !0,
            label: e("Link image"),
            icon: fB,
            keystroke: KD,
            tooltip: !0,
            isToggleable: !0
          }), i.bind("isEnabled").to(r, "isEnabled"), i.bind("isOn").to(r, "value", t => !!t), this.listenTo(i, "execute", () => {
            this._isSelectedLinkedImage(t.model.document.selection) ? o._addActionsView() : o._showUI(!0);
          }), i;
        });
      }
      _isSelectedLinkedImage(t) {
        const e = t.getSelectedElement();
        return this.editor.plugins.get("ImageUtils").isImage(e) && e.hasAttribute("linkHref");
      }
    }
    var DB = o(3669),
      BB = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(DB.A, BB);
    DB.A.locals;
    class SB {
      constructor(t, e) {
        this._startElement = t, this._referenceIndent = t.getAttribute("listIndent"), this._isForward = "forward" == e.direction, this._includeSelf = !!e.includeSelf, this._sameAttributes = vo(e.sameAttributes || []), this._sameIndent = !!e.sameIndent, this._lowerIndent = !!e.lowerIndent, this._higherIndent = !!e.higherIndent;
      }
      static first(t, e) {
        return $o(new this(t, e)[Symbol.iterator]());
      }
      *[Symbol.iterator]() {
        const t = [];
        for (const {
          node: e
        } of TB(this._getStartNode(), this._isForward ? "forward" : "backward")) {
          const n = e.getAttribute("listIndent");
          if (n < this._referenceIndent) {
            if (!this._lowerIndent) break;
            this._referenceIndent = n;
          } else if (n > this._referenceIndent) {
            if (!this._higherIndent) continue;
            if (!this._isForward) {
              t.push(e);
              continue;
            }
          } else {
            if (!this._sameIndent) {
              if (this._higherIndent) {
                t.length && (yield* t, t.length = 0);
                break;
              }
              continue;
            }
            if (this._sameAttributes.some(t => e.getAttribute(t) !== this._startElement.getAttribute(t))) break;
          }
          t.length && (yield* t, t.length = 0), yield e;
        }
      }
      _getStartNode() {
        return this._includeSelf ? this._startElement : this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
      }
    }
    function TB(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "forward";
      return function* () {
        const n = "forward" == e,
          i = [];
        let o = null;
        for (; LB(t);) {
          let e = null;
          if (o) {
            const n = t.getAttribute("listIndent"),
              r = o.getAttribute("listIndent");
            n > r ? i[r] = o : n < r ? (e = i[n], i.length = n) : e = o;
          }
          yield {
            node: t,
            previous: o,
            previousNodeInList: e
          }, o = t, t = n ? t.nextSibling : t.previousSibling;
        }
      }();
    }
    class IB {
      constructor(t) {
        this._listHead = t;
      }
      [Symbol.iterator]() {
        return TB(this._listHead, "forward");
      }
    }
    class MB {
      static next() {
        return p();
      }
    }
    function LB(t) {
      return !!t && t.is("element") && t.hasAttribute("listItemId");
    }
    function NB(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return [...zB(t, {
        ...e,
        direction: "backward"
      }), ...zB(t, {
        ...e,
        direction: "forward"
      })];
    }
    function zB(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const n = "forward" == e.direction,
        i = Array.from(new SB(t, {
          ...e,
          includeSelf: n,
          sameIndent: !0,
          sameAttributes: "listItemId"
        }));
      return n ? i : i.reverse();
    }
    function PB(t, e) {
      const n = new SB(t, {
          sameIndent: !0,
          sameAttributes: "listType",
          ...e
        }),
        i = new SB(t, {
          sameIndent: !0,
          sameAttributes: "listType",
          includeSelf: !0,
          direction: "forward",
          ...e
        });
      return [...Array.from(n).reverse(), ...i];
    }
    function VB(t) {
      return !SB.first(t, {
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function RB(t) {
      return !SB.first(t, {
        direction: "forward",
        sameIndent: !0,
        sameAttributes: "listItemId"
      });
    }
    function FB(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      t = vo(t);
      const n = !1 !== e.withNested,
        i = new Set();
      for (const e of t) for (const t of NB(e, {
        higherIndent: n
      })) i.add(t);
      return WB(i);
    }
    function OB(t) {
      t = vo(t);
      const e = new Set();
      for (const n of t) for (const t of PB(n)) e.add(t);
      return WB(e);
    }
    function jB(t, e) {
      const n = zB(t, {
          direction: "forward"
        }),
        i = MB.next();
      for (const t of n) e.setAttribute("listItemId", i, t);
      return n;
    }
    function HB(t, e, n) {
      const i = {};
      for (const [t, n] of e.getAttributes()) t.startsWith("list") && (i[t] = n);
      const o = zB(t, {
        direction: "forward"
      });
      for (const t of o) n.setAttributes(i, t);
      return o;
    }
    function UB(t, e) {
      let {
        expand: n,
        indentBy: i = 1
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      t = vo(t);
      const o = n ? FB(t) : t;
      for (const t of o) {
        const n = t.getAttribute("listIndent") + i;
        n < 0 ? qB(t, e) : e.setAttribute("listIndent", n, t);
      }
      return o;
    }
    function qB(t, e) {
      t = vo(t);
      for (const n of t) n.is("element", "listItem") && e.rename(n, "paragraph");
      for (const n of t) for (const t of n.getAttributeKeys()) t.startsWith("list") && e.removeAttribute(t, n);
      return t;
    }
    function GB(t) {
      if (!t.length) return !1;
      const e = t[0].getAttribute("listItemId");
      return !!e && !t.some(t => t.getAttribute("listItemId") != e);
    }
    function WB(t) {
      return Array.from(t).filter(t => "$graveyard" !== t.root.rootName).sort((t, e) => t.index - e.index);
    }
    function $B(t) {
      const e = t.document.selection.getSelectedElement();
      return e && t.schema.isObject(e) && t.schema.isBlock(e) ? e : null;
    }
    function KB(t, e) {
      return e.checkChild(t.parent, "listItem") && e.checkChild(t, "$text") && !e.isObject(t);
    }
    function YB(t) {
      return "numbered" == t || "customNumbered" == t;
    }
    function QB(t, e, n) {
      return zB(e, {
        direction: "forward"
      }).pop().index > t.index ? HB(t, e, n) : [];
    }
    class ZB extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        const t = this.editor.model,
          e = JB(t.document.selection);
        t.change(t => {
          const n = [];
          GB(e) && !VB(e[0]) ? ("forward" == this._direction && n.push(...UB(e, t)), n.push(...jB(e[0], t))) : "forward" == this._direction ? n.push(...UB(e, t, {
            expand: !0
          })) : n.push(...function (t, e) {
            const n = FB(t = vo(t)),
              i = new Set(),
              o = Math.min(...n.map(t => t.getAttribute("listIndent"))),
              r = new Map();
            for (const t of n) r.set(t, SB.first(t, {
              lowerIndent: !0
            }));
            for (const t of n) {
              if (i.has(t)) continue;
              i.add(t);
              const n = t.getAttribute("listIndent") - 1;
              if (n < 0) qB(t, e);else {
                if (t.getAttribute("listIndent") == o) {
                  const n = QB(t, r.get(t), e);
                  for (const t of n) i.add(t);
                  if (n.length) continue;
                }
                e.setAttribute("listIndent", n, t);
              }
            }
            return WB(i);
          }(e, t));
          for (const e of n) {
            if (!e.hasAttribute("listType")) continue;
            const n = SB.first(e, {
              sameIndent: !0
            });
            n && t.setAttribute("listType", n.getAttribute("listType"), e);
          }
          this._fireAfterExecute(n);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", WB(new Set(t)));
      }
      _checkEnabled() {
        let t = JB(this.editor.model.document.selection),
          e = t[0];
        if (!e) return !1;
        if ("backward" == this._direction) return !0;
        if (GB(t) && !VB(t[0])) return !0;
        t = FB(t), e = t[0];
        const n = SB.first(e, {
          sameIndent: !0
        });
        return !!n && n.getAttribute("listType") == e.getAttribute("listType");
      }
    }
    function JB(t) {
      const e = Array.from(t.getSelectedBlocks()),
        n = e.findIndex(t => !LB(t));
      return -1 != n && (e.length = n), e;
    }
    class XB extends Pr {
      constructor(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super(t), this.type = e, this._listWalkerOptions = n.multiLevel ? {
          higherIndent: !0,
          lowerIndent: !0,
          sameAttributes: []
        } : void 0;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document,
          i = $B(e),
          o = Array.from(n.selection.getSelectedBlocks()).filter(t => e.schema.checkAttribute(t, "listType") || KB(t, e.schema)),
          r = void 0 !== t.forceValue ? !t.forceValue : this.value;
        e.change(s => {
          if (r) {
            const t = o[o.length - 1],
              e = zB(t, {
                direction: "forward"
              }),
              n = [];
            e.length > 1 && n.push(...jB(e[1], s)), n.push(...qB(o, s)), n.push(...function (t, e) {
              const n = [];
              let i = Number.POSITIVE_INFINITY;
              for (const {
                node: o
              } of TB(t.nextSibling, "forward")) {
                const t = o.getAttribute("listIndent");
                if (0 == t) break;
                t < i && (i = t);
                const r = t - i;
                e.setAttribute("listIndent", r, o), n.push(o);
              }
              return n;
            }(t, s)), this._fireAfterExecute(n);
          } else if ((i || n.selection.isCollapsed) && LB(o[0])) {
            const e = PB(i || o[0], this._listWalkerOptions);
            for (const n of e) s.setAttributes({
              ...t.additionalAttributes,
              listType: this.type
            }, n);
            this._fireAfterExecute(e);
          } else {
            const n = [];
            for (const i of o) if (i.hasAttribute("listType")) for (const e of FB(i, {
              withNested: !1
            })) e.getAttribute("listType") != this.type && (s.setAttributes({
              ...t.additionalAttributes,
              listType: this.type
            }, e), n.push(e));else !i.is("element", "listItem") && KB(i, e.schema) && s.rename(i, "listItem"), s.setAttributes({
              ...t.additionalAttributes,
              listIndent: 0,
              listItemId: MB.next(),
              listType: this.type
            }, i), n.push(i);
            this._fireAfterExecute(n);
          }
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", WB(new Set(t)));
      }
      _getValue() {
        const t = this.editor.model.document.selection,
          e = Array.from(t.getSelectedBlocks());
        if (!e.length) return !1;
        for (const t of e) if (t.getAttribute("listType") != this.type) return !1;
        return !0;
      }
      _checkEnabled() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection,
          i = Array.from(n.getSelectedBlocks());
        if (!i.length) return !1;
        if (this.value) return !0;
        for (const t of i) if (e.checkAttribute(t, "listType") || KB(t, e)) return !0;
        return !1;
      }
    }
    class tS extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        let {
          shouldMergeOnBlocksContentLevel: t = !1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document.selection,
          i = [];
        e.change(o => {
          const {
              firstElement: r,
              lastElement: s
            } = this._getMergeSubjectElements(n, t),
            a = r.getAttribute("listIndent") || 0,
            l = s.getAttribute("listIndent"),
            c = s.getAttribute("listItemId");
          if (a != l) {
            const t = (d = s, Array.from(new SB(d, {
              direction: "forward",
              higherIndent: !0
            })));
            i.push(...UB([s, ...t], o, {
              indentBy: a - l,
              expand: a < l
            }));
          }
          var d;
          if (t) {
            let t = n;
            n.isCollapsed && (t = o.createSelection(o.createRange(o.createPositionAt(r, "end"), o.createPositionAt(s, 0)))), e.deleteContent(t, {
              doNotResetEntireContent: n.isCollapsed
            });
            const a = t.getLastPosition().parent,
              l = a.nextSibling;
            i.push(a), l && l !== s && l.getAttribute("listItemId") == c && i.push(...HB(l, a, o));
          } else i.push(...HB(s, r, o));
          this._fireAfterExecute(i);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", WB(new Set(t)));
      }
      _checkEnabled() {
        const t = this.editor.model,
          e = t.document.selection,
          n = $B(t);
        if (e.isCollapsed || n) {
          const t = n || e.getFirstPosition().parent;
          if (!LB(t)) return !1;
          const i = "backward" == this._direction ? t.previousSibling : t.nextSibling;
          if (!i) return !1;
          if (GB([t, i])) return !1;
        } else {
          const t = e.getLastPosition(),
            n = e.getFirstPosition();
          if (t.parent === n.parent) return !1;
          if (!LB(t.parent)) return !1;
        }
        return !0;
      }
      _getMergeSubjectElements(t, e) {
        const n = $B(this.editor.model);
        let i, o;
        if (t.isCollapsed || n) {
          const r = n || t.getFirstPosition().parent,
            s = VB(r);
          "backward" == this._direction ? (o = r, i = s && !e ? SB.first(r, {
            sameIndent: !0,
            lowerIndent: !0
          }) : r.previousSibling) : (i = r, o = r.nextSibling);
        } else i = t.getFirstPosition().parent, o = t.getLastPosition().parent;
        return {
          firstElement: i,
          lastElement: o
        };
      }
    }
    class eS extends Pr {
      constructor(t, e) {
        super(t), this._direction = e;
      }
      refresh() {
        this.isEnabled = this._checkEnabled();
      }
      execute() {
        this.editor.model.change(t => {
          const e = jB(this._getStartBlock(), t);
          this._fireAfterExecute(e);
        });
      }
      _fireAfterExecute(t) {
        this.fire("afterExecute", WB(new Set(t)));
      }
      _checkEnabled() {
        const t = this.editor.model.document.selection,
          e = this._getStartBlock();
        return t.isCollapsed && LB(e) && !VB(e);
      }
      _getStartBlock() {
        const t = this.editor.model.document.selection.getFirstPosition().parent;
        return "before" == this._direction ? t : t.nextSibling;
      }
    }
    class nS extends Nr {
      static get pluginName() {
        return "ListUtils";
      }
      expandListBlocksToCompleteList(t) {
        return OB(t);
      }
      isFirstBlockOfListItem(t) {
        return VB(t);
      }
      isListItemBlock(t) {
        return LB(t);
      }
      expandListBlocksToCompleteItems(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return FB(t, e);
      }
      isNumberedListType(t) {
        return YB(t);
      }
    }
    function iS(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function oS(t) {
      return t.is("element", "li");
    }
    function rS(t, e, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : lS(n, e);
      return t.createAttributeElement(aS(n), null, {
        priority: 2 * e / 100 - 100,
        id: i
      });
    }
    function sS(t, e, n) {
      return t.createAttributeElement("li", null, {
        priority: (2 * e + 1) / 100 - 100,
        id: n
      });
    }
    function aS(t) {
      return "numbered" == t || "customNumbered" == t ? "ol" : "ul";
    }
    function lS(t, e) {
      return `list-${t}-${e}`;
    }
    function cS(t, e) {
      const n = t.nodeBefore;
      if (LB(n)) {
        let t = n;
        for (const {
          node: n
        } of TB(t, "backward")) if (t = n, e.has(t)) return;
        e.set(n, t);
      } else {
        const n = t.nodeAfter;
        LB(n) && e.set(n, n);
      }
    }
    function dS() {
      return (t, e, n) => {
        const {
          writer: i,
          schema: o
        } = n;
        if (!e.modelRange) return;
        const r = Array.from(e.modelRange.getItems({
          shallow: !0
        })).filter(t => o.checkAttribute(t, "listItemId"));
        if (!r.length) return;
        const s = MB.next(),
          a = function (t) {
            let e = 0,
              n = t.parent;
            for (; n;) {
              if (oS(n)) e++;else {
                const t = n.previousSibling;
                t && oS(t) && e++;
              }
              n = n.parent;
            }
            return e;
          }(e.viewItem);
        let l = e.viewItem.parent && e.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
        const c = r[0].getAttribute("listType");
        c && (l = c);
        const d = {
          listItemId: s,
          listIndent: a,
          listType: l
        };
        for (const t of r) t.hasAttribute("listItemId") || i.setAttributes(d, t);
        r.length > 1 && r[1].getAttribute("listItemId") != d.listItemId && n.keepEmptyElement(r[0]);
      };
    }
    function uS() {
      return (t, e, n) => {
        if (!n.consumable.test(e.viewItem, {
          name: !0
        })) return;
        const i = new th(e.viewItem.document);
        for (const t of Array.from(e.viewItem.getChildren())) oS(t) || iS(t) || i.remove(t);
      };
    }
    function hS(t, e, n) {
      let {
        dataPipeline: i
      } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const o = function (t) {
        return (e, n) => {
          const i = [];
          for (const n of t) e.hasAttribute(n) && i.push(`attribute:${n}`);
          return !!i.every(t => !1 !== n.test(e, t)) && (i.forEach(t => n.consume(e, t)), !0);
        };
      }(t);
      return (r, s, a) => {
        const {
            writer: l,
            mapper: c,
            consumable: d
          } = a,
          u = s.item;
        if (!t.includes(s.attributeKey)) return;
        if (!o(u, d)) return;
        const h = function (t, e, n) {
          const i = n.createRangeOn(t),
            o = e.toViewRange(i).getTrimmed();
          return o.end.nodeBefore;
        }(u, c, n);
        gS(h, l, c), function (t, e) {
          let n = t.parent;
          for (; n.is("attributeElement") && ["ul", "ol", "li"].includes(n.name);) {
            const i = n.parent;
            e.unwrap(e.createRangeOn(t), n), n = i;
          }
        }(h, l);
        const m = function (t, e, n, i, _ref165) {
          let {
            dataPipeline: o
          } = _ref165;
          let r = i.createRangeOn(e);
          if (!VB(t)) return r;
          for (const s of n) {
            if ("itemMarker" != s.scope) continue;
            const n = s.createElement(i, t, {
              dataPipeline: o
            });
            if (!n) continue;
            if (i.setCustomProperty("listItemMarker", !0, n), s.canInjectMarkerIntoElement && s.canInjectMarkerIntoElement(t) ? i.insert(i.createPositionAt(e, 0), n) : (i.insert(r.start, n), r = i.createRange(i.createPositionBefore(n), i.createPositionAfter(e))), !s.createWrapperElement || !s.canWrapElement) continue;
            const a = s.createWrapperElement(i, t, {
              dataPipeline: o
            });
            i.setCustomProperty("listItemWrapper", !0, a), s.canWrapElement(t) ? r = i.wrap(r, a) : (r = i.wrap(i.createRangeOn(n), a), r = i.createRange(r.start, i.createPositionAfter(e)));
          }
          return r;
        }(u, h, e, l, {
          dataPipeline: i
        });
        !function (t, e, n, i) {
          if (!t.hasAttribute("listIndent")) return;
          const o = t.getAttribute("listIndent");
          let r = t;
          for (let t = o; t >= 0; t--) {
            const o = sS(i, t, r.getAttribute("listItemId")),
              s = rS(i, t, r.getAttribute("listType"));
            for (const t of n) "list" != t.scope && "item" != t.scope || !r.hasAttribute(t.attributeName) || t.setAttributeOnDowncast(i, r.getAttribute(t.attributeName), "list" == t.scope ? s : o);
            if (e = i.wrap(e, o), e = i.wrap(e, s), 0 == t) break;
            if (r = SB.first(r, {
              lowerIndent: !0
            }), !r) break;
          }
        }(u, m, e, l);
      };
    }
    function mS(t) {
      let {
        dataPipeline: e
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (n, _ref166) => {
        let {
          writer: i
        } = _ref166;
        if (!pS(n, t)) return null;
        if (!e) return i.createContainerElement("span", {
          class: "ck-list-bogus-paragraph"
        });
        const o = i.createContainerElement("p");
        return i.setCustomProperty("dataPipeline:transparentRendering", !0, o), o;
      };
    }
    function gS(t, e, n) {
      for (; t.parent.is("attributeElement") && t.parent.getCustomProperty("listItemWrapper");) e.unwrap(e.createRangeOn(t), t.parent);
      const i = [];
      o(e.createPositionBefore(t).getWalker({
        direction: "backward"
      })), o(e.createRangeIn(t).getWalker());
      for (const t of i) e.remove(t);
      function o(t) {
        for (const {
          item: e
        } of t) {
          if (e.is("element") && n.toModelElement(e)) break;
          e.is("element") && e.getCustomProperty("listItemMarker") && i.push(e);
        }
      }
    }
    function pS(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NB(t);
      if (!LB(t)) return !1;
      for (const n of t.getAttributeKeys()) if (!n.startsWith("selection:") && !e.includes(n)) return !1;
      return n.length < 2;
    }
    var fS = o(7875),
      kS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(fS.A, kS);
    fS.A.locals;
    var bS = o(532),
      wS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(bS.A, wS);
    bS.A.locals;
    const AS = ["listType", "listIndent", "listItemId"];
    class CS extends Nr {
      static get pluginName() {
        return "ListEditing";
      }
      static get requires() {
        return [bw, Wb, nS, Mb];
      }
      constructor(t) {
        super(t), this._downcastStrategies = [], t.config.define("list.multiBlock", !0);
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.config.get("list.multiBlock");
        if (t.plugins.has("LegacyListEditing")) throw new b("list-feature-conflict", this, {
          conflictPlugin: "LegacyListEditing"
        });
        e.schema.register("$listItem", {
          allowAttributes: AS
        }), n ? (e.schema.extend("$container", {
          allowAttributesOf: "$listItem"
        }), e.schema.extend("$block", {
          allowAttributesOf: "$listItem"
        }), e.schema.extend("$blockObject", {
          allowAttributesOf: "$listItem"
        })) : e.schema.register("listItem", {
          inheritAllFrom: "$block",
          allowAttributesOf: "$listItem"
        });
        for (const t of AS) e.schema.setAttributeProperties(t, {
          copyOnReplace: !0
        });
        t.commands.add("numberedList", new XB(t, "numbered")), t.commands.add("bulletedList", new XB(t, "bulleted")), t.commands.add("customNumberedList", new XB(t, "customNumbered", {
          multiLevel: !0
        })), t.commands.add("customBulletedList", new XB(t, "customBulleted", {
          multiLevel: !0
        })), t.commands.add("indentList", new ZB(t, "forward")), t.commands.add("outdentList", new ZB(t, "backward")), t.commands.add("splitListItemBefore", new eS(t, "before")), t.commands.add("splitListItemAfter", new eS(t, "after")), n && (t.commands.add("mergeListItemBackward", new tS(t, "backward")), t.commands.add("mergeListItemForward", new tS(t, "forward"))), this._setupDeleteIntegration(), this._setupEnterIntegration(), this._setupTabIntegration(), this._setupClipboardIntegration(), this._setupAccessibilityIntegration();
      }
      afterInit() {
        const t = this.editor.commands,
          e = t.get("indent"),
          n = t.get("outdent");
        e && e.registerChildCommand(t.get("indentList"), {
          priority: "high"
        }), n && n.registerChildCommand(t.get("outdentList"), {
          priority: "lowest"
        }), this._setupModelPostFixing(), this._setupConversion();
      }
      registerDowncastStrategy(t) {
        this._downcastStrategies.push(t);
      }
      getListAttributeNames() {
        return [...AS, ...this._downcastStrategies.map(t => t.attributeName)];
      }
      _setupDeleteIntegration() {
        const t = this.editor,
          e = t.commands.get("mergeListItemBackward"),
          n = t.commands.get("mergeListItemForward");
        this.listenTo(t.editing.view.document, "delete", (i, o) => {
          const r = t.model.document.selection;
          $B(t.model) || t.model.change(() => {
            const s = r.getFirstPosition();
            if (r.isCollapsed && "backward" == o.direction) {
              if (!s.isAtStart) return;
              const n = s.parent;
              if (!LB(n)) return;
              if (SB.first(n, {
                sameAttributes: "listType",
                sameIndent: !0
              }) || 0 !== n.getAttribute("listIndent")) {
                if (!e || !e.isEnabled) return;
                e.execute({
                  shouldMergeOnBlocksContentLevel: _S(t.model, "backward")
                });
              } else RB(n) || t.execute("splitListItemAfter"), t.execute("outdentList");
              o.preventDefault(), i.stop();
            } else {
              if (r.isCollapsed && !r.getLastPosition().isAtEnd) return;
              if (!n || !n.isEnabled) return;
              n.execute({
                shouldMergeOnBlocksContentLevel: _S(t.model, "forward")
              }), o.preventDefault(), i.stop();
            }
          });
        }, {
          context: "li"
        });
      }
      _setupEnterIntegration() {
        const t = this.editor,
          e = t.model,
          n = t.commands,
          i = n.get("enter");
        this.listenTo(t.editing.view.document, "enter", (n, i) => {
          const o = e.document,
            r = o.selection.getFirstPosition().parent;
          if (o.selection.isCollapsed && LB(r) && r.isEmpty && !i.isSoft) {
            const e = VB(r),
              o = RB(r);
            e && o ? (t.execute("outdentList"), i.preventDefault(), n.stop()) : e && !o ? (t.execute("splitListItemAfter"), i.preventDefault(), n.stop()) : o && (t.execute("splitListItemBefore"), i.preventDefault(), n.stop());
          }
        }, {
          context: "li"
        }), this.listenTo(i, "afterExecute", () => {
          const e = n.get("splitListItemBefore");
          if (e.refresh(), !e.isEnabled) return;
          2 === NB(t.model.document.selection.getLastPosition().parent).length && e.execute();
        });
      }
      _setupTabIntegration() {
        const t = this.editor;
        this.listenTo(t.editing.view.document, "tab", (e, n) => {
          const i = n.shiftKey ? "outdentList" : "indentList";
          this.editor.commands.get(i).isEnabled && (t.execute(i), n.stopPropagation(), n.preventDefault(), e.stop());
        }, {
          context: "li"
        });
      }
      _setupConversion() {
        const t = this.editor,
          e = t.model,
          n = this.getListAttributeNames(),
          i = t.config.get("list.multiBlock"),
          o = i ? "paragraph" : "listItem";
        t.conversion.for("upcast").elementToElement({
          view: "li",
          model: (t, _ref167) => {
            let {
              writer: e
            } = _ref167;
            return e.createElement(o, {
              listType: ""
            });
          }
        }).elementToElement({
          view: "p",
          model: (t, _ref168) => {
            let {
              writer: e
            } = _ref168;
            return t.parent && t.parent.is("element", "li") ? e.createElement(o, {
              listType: ""
            }) : null;
          },
          converterPriority: "high"
        }).add(t => {
          t.on("element:li", dS()), t.on("element:ul", uS(), {
            priority: "high"
          }), t.on("element:ol", uS(), {
            priority: "high"
          });
        }), i || t.conversion.for("downcast").elementToElement({
          model: "listItem",
          view: "p"
        }), t.conversion.for("editingDowncast").elementToElement({
          model: o,
          view: mS(n),
          converterPriority: "high"
        }).add(t => {
          var i;
          t.on("attribute", hS(n, this._downcastStrategies, e)), t.on("remove", (i = e.schema, (t, e, n) => {
            const {
                writer: o,
                mapper: r
              } = n,
              s = t.name.split(":")[1];
            if (!i.checkAttribute(s, "listItemId")) return;
            const a = r.toViewPosition(e.position),
              l = e.position.getShiftedBy(e.length),
              c = r.toViewPosition(l, {
                isPhantom: !0
              }),
              d = o.createRange(a, c).getTrimmed().end.nodeBefore;
            d && gS(d, o, r);
          }));
        }), t.conversion.for("dataDowncast").elementToElement({
          model: o,
          view: mS(n, {
            dataPipeline: !0
          }),
          converterPriority: "high"
        }).add(t => {
          t.on("attribute", hS(n, this._downcastStrategies, e, {
            dataPipeline: !0
          }));
        });
        const r = (s = this._downcastStrategies, a = t.editing.view, (t, e) => {
          if (e.modelPosition.offset > 0) return;
          const n = e.modelPosition.parent;
          if (!LB(n)) return;
          if (!s.some(t => "itemMarker" == t.scope && t.canInjectMarkerIntoElement && t.canInjectMarkerIntoElement(n))) return;
          const i = e.mapper.toViewElement(n),
            o = a.createRangeIn(i),
            r = o.getWalker();
          let l = o.start;
          for (const {
            item: t
          } of r) {
            if (t.is("element") && e.mapper.toModelElement(t) || t.is("$textProxy")) break;
            t.is("element") && t.getCustomProperty("listItemMarker") && (l = a.createPositionAfter(t), r.skip(_ref169 => {
              let {
                previousPosition: t
              } = _ref169;
              return !t.isEqual(l);
            }));
          }
          e.viewPosition = l;
        });
        var s, a;
        t.editing.mapper.on("modelToViewPosition", r), t.data.mapper.on("modelToViewPosition", r), this.listenTo(e.document, "change:data", function (t, e, n, i) {
          return () => {
            const i = t.document.differ.getChanges(),
              s = [],
              a = new Map(),
              l = new Set();
            for (const t of i) if ("insert" == t.type && "$text" != t.name) cS(t.position, a), t.attributes.has("listItemId") ? l.add(t.position.nodeAfter) : cS(t.position.getShiftedBy(t.length), a);else if ("remove" == t.type && t.attributes.has("listItemId")) cS(t.position, a);else if ("attribute" == t.type) {
              const e = t.range.start.nodeAfter;
              n.includes(t.attributeKey) ? (cS(t.range.start, a), null === t.attributeNewValue ? (cS(t.range.start.getShiftedBy(1), a), r(e) && s.push(e)) : l.add(e)) : LB(e) && r(e) && s.push(e);
            }
            for (const t of a.values()) s.push(...o(t, l));
            for (const t of new Set(s)) e.reconvertItem(t);
          };
          function o(t, e) {
            const i = [],
              o = new Set(),
              a = [];
            for (const {
              node: l,
              previous: c
            } of TB(t, "forward")) {
              if (o.has(l)) continue;
              const t = l.getAttribute("listIndent");
              c && t < c.getAttribute("listIndent") && (a.length = t + 1), a[t] = Object.fromEntries(Array.from(l.getAttributes()).filter(_ref170 => {
                let [t] = _ref170;
                return n.includes(t);
              }));
              const d = zB(l, {
                direction: "forward"
              });
              for (const t of d) o.add(t), (r(t, d) || s(t, a, e)) && i.push(t);
            }
            return i;
          }
          function r(t, o) {
            const r = e.mapper.toViewElement(t);
            if (!r) return !1;
            if (i.fire("checkElement", {
              modelElement: t,
              viewElement: r
            })) return !0;
            if (!t.is("element", "paragraph") && !t.is("element", "listItem")) return !1;
            const s = pS(t, n, o);
            return !(!s || !r.is("element", "p")) || !(s || !r.is("element", "span"));
          }
          function s(t, n, o) {
            if (o.has(t)) return !1;
            const r = e.mapper.toViewElement(t);
            let s = n.length - 1;
            for (let t = r.parent; !t.is("editableElement"); t = t.parent) {
              const e = oS(t),
                o = iS(t);
              if (!o && !e) continue;
              const r = "checkAttributes:" + (e ? "item" : "list");
              if (i.fire(r, {
                viewElement: t,
                modelAttributes: n[s]
              })) break;
              if (o && (s--, s < 0)) return !1;
            }
            return !0;
          }
        }(e, t.editing, n, this), {
          priority: "high"
        }), this.on("checkAttributes:item", (t, _ref171) => {
          let {
            viewElement: e,
            modelAttributes: n
          } = _ref171;
          e.id != n.listItemId && (t.return = !0, t.stop());
        }), this.on("checkAttributes:list", (t, _ref172) => {
          let {
            viewElement: e,
            modelAttributes: n
          } = _ref172;
          e.name == aS(n.listType) && e.id == lS(n.listType, n.listIndent) || (t.return = !0, t.stop());
        });
      }
      _setupModelPostFixing() {
        const t = this.editor.model,
          e = this.getListAttributeNames();
        t.document.registerPostFixer(n => function (t, e, n, i) {
          const o = t.document.differ.getChanges(),
            r = new Map(),
            s = i.editor.config.get("list.multiBlock");
          let a = !1;
          for (const i of o) {
            if ("insert" == i.type && "$text" != i.name) {
              const o = i.position.nodeAfter;
              if (!t.schema.checkAttribute(o, "listItemId")) for (const t of Array.from(o.getAttributeKeys())) n.includes(t) && (e.removeAttribute(t, o), a = !0);
              cS(i.position, r), i.attributes.has("listItemId") || cS(i.position.getShiftedBy(i.length), r);
              for (const {
                item: e,
                previousPosition: n
              } of t.createRangeIn(o)) LB(e) && cS(n, r);
            } else "remove" == i.type ? cS(i.position, r) : "attribute" == i.type && n.includes(i.attributeKey) && (cS(i.range.start, r), null === i.attributeNewValue && cS(i.range.start.getShiftedBy(1), r));
            if (!s && "attribute" == i.type && AS.includes(i.attributeKey)) {
              const t = i.range.start.nodeAfter;
              null === i.attributeNewValue && t && t.is("element", "listItem") ? (e.rename(t, "paragraph"), a = !0) : null === i.attributeOldValue && t && t.is("element") && "listItem" != t.name && (e.rename(t, "listItem"), a = !0);
            }
          }
          const l = new Set();
          for (const t of r.values()) a = i.fire("postFixer", {
            listNodes: new IB(t),
            listHead: t,
            writer: e,
            seenIds: l
          }) || a;
          return a;
        }(t, n, e, this)), this.on("postFixer", (t, _ref173) => {
          let {
            listNodes: e,
            writer: n
          } = _ref173;
          t.return = function (t, e) {
            let n = 0,
              i = -1,
              o = null,
              r = !1;
            for (const {
              node: s
            } of t) {
              const t = s.getAttribute("listIndent");
              if (t > n) {
                let a;
                null === o ? (o = t - n, a = n) : (o > t && (o = t), a = t - o), a > i + 1 && (a = i + 1), e.setAttribute("listIndent", a, s), r = !0, i = a;
              } else o = null, n = t + 1, i = t;
            }
            return r;
          }(e, n) || t.return;
        }, {
          priority: "high"
        }), this.on("postFixer", (t, _ref174) => {
          let {
            listNodes: e,
            writer: n,
            seenIds: i
          } = _ref174;
          t.return = function (t, e, n) {
            const i = new Set();
            let o = !1;
            for (const {
              node: r
            } of t) {
              if (i.has(r)) continue;
              let t = r.getAttribute("listType"),
                s = r.getAttribute("listItemId");
              if (e.has(s) && (s = MB.next()), e.add(s), r.is("element", "listItem")) r.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, r), o = !0);else for (const e of zB(r, {
                direction: "forward"
              })) i.add(e), e.getAttribute("listType") != t && (s = MB.next(), t = e.getAttribute("listType")), e.getAttribute("listItemId") != s && (n.setAttribute("listItemId", s, e), o = !0);
            }
            return o;
          }(e, i, n) || t.return;
        }, {
          priority: "high"
        });
      }
      _setupClipboardIntegration() {
        const t = this.editor.model,
          e = this.editor.plugins.get("ClipboardPipeline");
        this.listenTo(t, "insertContent", function (t) {
          return (e, _ref175) => {
            let [n, i] = _ref175;
            const o = n.is("documentFragment") ? Array.from(n.getChildren()) : [n];
            if (!o.length) return;
            const r = (i ? t.createSelection(i) : t.document.selection).getFirstPosition();
            let s;
            if (LB(r.parent)) s = r.parent;else {
              if (!LB(r.nodeBefore)) return;
              s = r.nodeBefore;
            }
            t.change(t => {
              const e = s.getAttribute("listType"),
                n = s.getAttribute("listIndent"),
                i = o[0].getAttribute("listIndent") || 0,
                r = Math.max(n - i, 0);
              for (const n of o) {
                const i = LB(n);
                s.is("element", "listItem") && n.is("element", "paragraph") && t.rename(n, "listItem"), t.setAttributes({
                  listIndent: (i ? n.getAttribute("listIndent") : 0) + r,
                  listItemId: i ? n.getAttribute("listItemId") : MB.next(),
                  listType: e
                }, n);
              }
            });
          };
        }(t), {
          priority: "high"
        }), this.listenTo(e, "outputTransformation", (e, n) => {
          t.change(t => {
            const e = Array.from(n.content.getChildren()),
              i = e[e.length - 1];
            if (e.length > 1 && i.is("element") && i.isEmpty) {
              e.slice(0, -1).every(LB) && t.remove(i);
            }
            if ("copy" == n.method || "cut" == n.method) {
              const e = Array.from(n.content.getChildren());
              GB(e) && qB(e, t);
            }
          });
        });
      }
      _setupAccessibilityIntegration() {
        const t = this.editor,
          e = t.t;
        t.accessibility.addKeystrokeInfoGroup({
          id: "list",
          label: e("Keystrokes that can be used in a list"),
          keystrokes: [{
            label: e("Increase list item indent"),
            keystroke: "Tab"
          }, {
            label: e("Decrease list item indent"),
            keystroke: "Shift+Tab"
          }]
        });
      }
    }
    function _S(t, e) {
      const n = t.document.selection;
      if (!n.isCollapsed) return !$B(t);
      if ("forward" === e) return !0;
      const i = n.getFirstPosition().parent,
        o = i.previousSibling;
      return !t.schema.isObject(o) && (!!o.isEmpty || GB([i, o]));
    }
    function vS(t, e, n, i) {
      t.ui.componentFactory.add(e, () => {
        const o = yS(mm, t, e, n, i);
        return o.set({
          tooltip: !0,
          isToggleable: !0
        }), o;
      }), t.ui.componentFactory.add(`menuBar:${e}`, () => yS(Uk, t, e, n, i));
    }
    function yS(t, e, n, i, o) {
      const r = e.commands.get(n),
        s = new t(e.locale);
      return s.set({
        label: i,
        icon: o
      }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", () => {
        e.execute(n), e.editing.view.focus();
      }), s;
    }
    class xS extends Nr {
      static get pluginName() {
        return "ListUI";
      }
      init() {
        const t = this.editor.t;
        this.editor.ui.componentFactory.has("numberedList") || vS(this.editor, "numberedList", t("Numbered List"), Yh.numberedList), this.editor.ui.componentFactory.has("bulletedList") || vS(this.editor, "bulletedList", t("Bulleted List"), Yh.bulletedList);
      }
    }
    class ES extends Nr {
      static get requires() {
        return [CS, xS];
      }
      static get pluginName() {
        return "List";
      }
    }
    class DS extends Pr {
      refresh() {
        const t = this._getValue();
        this.value = t, this.isEnabled = null != t;
      }
      execute() {
        let {
          startIndex: t = 1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document;
        let i = Array.from(n.selection.getSelectedBlocks()).filter(t => LB(t) && YB(t.getAttribute("listType")));
        i = OB(i), e.change(e => {
          for (const n of i) e.setAttribute("listStart", t >= 0 ? t : 1, n);
        });
      }
      _getValue() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        return t && LB(t) && YB(t.getAttribute("listType")) ? t.getAttribute("listStart") : null;
      }
    }
    const BS = {},
      SS = {},
      TS = {},
      IS = [{
        listStyle: "disc",
        typeAttribute: "disc",
        listType: "bulleted"
      }, {
        listStyle: "circle",
        typeAttribute: "circle",
        listType: "bulleted"
      }, {
        listStyle: "square",
        typeAttribute: "square",
        listType: "bulleted"
      }, {
        listStyle: "decimal",
        typeAttribute: "1",
        listType: "numbered"
      }, {
        listStyle: "decimal-leading-zero",
        typeAttribute: null,
        listType: "numbered"
      }, {
        listStyle: "lower-roman",
        typeAttribute: "i",
        listType: "numbered"
      }, {
        listStyle: "upper-roman",
        typeAttribute: "I",
        listType: "numbered"
      }, {
        listStyle: "lower-alpha",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-alpha",
        typeAttribute: "A",
        listType: "numbered"
      }, {
        listStyle: "lower-latin",
        typeAttribute: "a",
        listType: "numbered"
      }, {
        listStyle: "upper-latin",
        typeAttribute: "A",
        listType: "numbered"
      }];
    for (const {
      listStyle: t,
      typeAttribute: e,
      listType: n
    } of IS) BS[t] = n, SS[t] = e, e && (TS[e] = t);
    function MS() {
      return IS.map(t => t.listStyle);
    }
    function LS(t) {
      return BS[t] || null;
    }
    function NS(t) {
      return TS[t] || null;
    }
    function zS(t) {
      return SS[t] || null;
    }
    class PS extends Pr {
      constructor(t, e, n) {
        super(t), this.defaultType = e, this._supportedTypes = n;
      }
      refresh() {
        this.value = this._getValue(), this.isEnabled = this._checkEnabled();
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document;
        e.change(e => {
          this._tryToConvertItemsToList(t);
          let i = Array.from(n.selection.getSelectedBlocks()).filter(t => t.hasAttribute("listType"));
          if (i.length) {
            i = OB(i);
            for (const n of i) e.setAttribute("listStyle", t.type || this.defaultType, n);
          }
        });
      }
      isStyleTypeSupported(t) {
        return !this._supportedTypes || this._supportedTypes.includes(t);
      }
      _getValue() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        return LB(t) ? t.getAttribute("listStyle") : null;
      }
      _checkEnabled() {
        const t = this.editor,
          e = t.commands.get("numberedList"),
          n = t.commands.get("bulletedList");
        return e.isEnabled || n.isEnabled;
      }
      _tryToConvertItemsToList(t) {
        if (!t.type) return;
        const e = LS(t.type);
        if (!e) return;
        const n = this.editor,
          i = `${e}List`;
        n.commands.get(i).value || n.execute(i);
      }
    }
    class VS extends Pr {
      refresh() {
        const t = this._getValue();
        this.value = t, this.isEnabled = null != t;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document;
        let i = Array.from(n.selection.getSelectedBlocks()).filter(t => LB(t) && "numbered" == t.getAttribute("listType"));
        i = OB(i), e.change(e => {
          for (const n of i) e.setAttribute("listReversed", !!t.reversed, n);
        });
      }
      _getValue() {
        const t = $o(this.editor.model.document.selection.getSelectedBlocks());
        return LB(t) && "numbered" == t.getAttribute("listType") ? t.getAttribute("listReversed") : null;
      }
    }
    function RS(t) {
      return (e, n, i) => {
        const {
          writer: o,
          schema: r,
          consumable: s
        } = i;
        if (!1 === s.test(n.viewItem, t.viewConsumables)) return;
        n.modelRange || Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor));
        let a = !1;
        for (const e of n.modelRange.getItems({
          shallow: !0
        })) r.checkAttribute(e, t.attributeName) && t.appliesToListItem(e) && (e.hasAttribute(t.attributeName) || (o.setAttribute(t.attributeName, t.getAttributeOnUpcast(n.viewItem), e), a = !0));
        a && s.consume(n.viewItem, t.viewConsumables);
      };
    }
    class FS extends Nr {
      static get pluginName() {
        return "ListPropertiesUtils";
      }
      getAllSupportedStyleTypes() {
        return MS();
      }
      getListTypeFromListStyleType(t) {
        return LS(t);
      }
      getListStyleTypeFromTypeAttribute(t) {
        return NS(t);
      }
      getTypeAttributeFromListStyleType(t) {
        return zS(t);
      }
    }
    const OS = "default";
    class jS extends Nr {
      static get requires() {
        return [CS, FS];
      }
      static get pluginName() {
        return "ListPropertiesEditing";
      }
      constructor(t) {
        super(t), t.config.define("list.properties", {
          styles: !0,
          startIndex: !1,
          reversed: !1
        });
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.plugins.get(CS),
          i = function (t) {
            const e = [];
            if (t.styles) {
              const n = "object" == typeof t.styles && t.styles.useAttribute;
              e.push({
                attributeName: "listStyle",
                defaultValue: OS,
                viewConsumables: {
                  styles: "list-style-type"
                },
                addCommand(t) {
                  let e = MS();
                  n && (e = e.filter(t => !!zS(t))), t.commands.add("listStyle", new PS(t, OS, e));
                },
                appliesToListItem: t => "numbered" == t.getAttribute("listType") || "bulleted" == t.getAttribute("listType"),
                hasValidAttribute(t) {
                  if (!this.appliesToListItem(t)) return !t.hasAttribute("listStyle");
                  if (!t.hasAttribute("listStyle")) return !1;
                  const e = t.getAttribute("listStyle");
                  return e == OS || LS(e) == t.getAttribute("listType");
                },
                setAttributeOnDowncast(t, e, i) {
                  if (e && e !== OS) {
                    if (!n) return void t.setStyle("list-style-type", e, i);
                    {
                      const n = zS(e);
                      if (n) return void t.setAttribute("type", n, i);
                    }
                  }
                  t.removeStyle("list-style-type", i), t.removeAttribute("type", i);
                },
                getAttributeOnUpcast(t) {
                  const e = t.getStyle("list-style-type");
                  if (e) return e;
                  const n = t.getAttribute("type");
                  return n ? NS(n) : OS;
                }
              });
            }
            t.reversed && e.push({
              attributeName: "listReversed",
              defaultValue: !1,
              viewConsumables: {
                attributes: "reversed"
              },
              addCommand(t) {
                t.commands.add("listReversed", new VS(t));
              },
              appliesToListItem: t => "numbered" == t.getAttribute("listType"),
              hasValidAttribute(t) {
                return this.appliesToListItem(t) == t.hasAttribute("listReversed");
              },
              setAttributeOnDowncast(t, e, n) {
                e ? t.setAttribute("reversed", "reversed", n) : t.removeAttribute("reversed", n);
              },
              getAttributeOnUpcast: t => t.hasAttribute("reversed")
            });
            t.startIndex && e.push({
              attributeName: "listStart",
              defaultValue: 1,
              viewConsumables: {
                attributes: "start"
              },
              addCommand(t) {
                t.commands.add("listStart", new DS(t));
              },
              appliesToListItem: t => YB(t.getAttribute("listType")),
              hasValidAttribute(t) {
                return this.appliesToListItem(t) == t.hasAttribute("listStart");
              },
              setAttributeOnDowncast(t, e, n) {
                0 == e || e > 1 ? t.setAttribute("start", e, n) : t.removeAttribute("start", n);
              },
              getAttributeOnUpcast(t) {
                const e = t.getAttribute("start");
                return e >= 0 ? e : 1;
              }
            });
            return e;
          }(t.config.get("list.properties"));
        for (const o of i) o.addCommand(t), e.schema.extend("$listItem", {
          allowAttributes: o.attributeName
        }), n.registerDowncastStrategy({
          scope: "list",
          attributeName: o.attributeName,
          setAttributeOnDowncast(t, e, n) {
            o.setAttributeOnDowncast(t, e, n);
          }
        });
        t.conversion.for("upcast").add(t => {
          for (const e of i) t.on("element:ol", RS(e)), t.on("element:ul", RS(e));
        }), n.on("checkAttributes:list", (t, _ref176) => {
          let {
            viewElement: e,
            modelAttributes: n
          } = _ref176;
          for (const o of i) o.getAttributeOnUpcast(e) != n[o.attributeName] && (t.return = !0, t.stop());
        }), this.listenTo(t.commands.get("indentList"), "afterExecute", (t, n) => {
          e.change(t => {
            for (const e of n) for (const n of i) n.appliesToListItem(e) && t.setAttribute(n.attributeName, n.defaultValue, e);
          });
        }), n.on("postFixer", (t, _ref177) => {
          let {
            listNodes: e,
            writer: n
          } = _ref177;
          for (const {
            node: o
          } of e) for (const e of i) e.hasValidAttribute(o) || (e.appliesToListItem(o) ? n.setAttribute(e.attributeName, e.defaultValue, o) : n.removeAttribute(e.attributeName, o), t.return = !0);
        }), n.on("postFixer", (t, _ref178) => {
          let {
            listNodes: e,
            writer: n
          } = _ref178;
          for (const {
            node: o,
            previousNodeInList: r
          } of e) if (r && r.getAttribute("listType") == o.getAttribute("listType")) for (const e of i) {
            const {
              attributeName: i
            } = e;
            if (!e.appliesToListItem(o)) continue;
            const s = r.getAttribute(i);
            o.getAttribute(i) != s && (n.setAttribute(i, s, o), t.return = !0);
          }
        });
      }
    }
    var HS = o(1911),
      US = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(HS.A, US);
    HS.A.locals;
    class qS extends Sr {
      constructor(t, _ref179) {
        let {
          enabledProperties: e,
          styleButtonViews: n,
          styleGridAriaLabel: i
        } = _ref179;
        super(t), this.stylesView = null, this.additionalPropertiesCollapsibleView = null, this.startIndexFieldView = null, this.reversedSwitchButtonView = null, this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.focusables = new nr();
        const o = ["ck", "ck-list-properties"];
        this.children = this.createCollection(), this.focusCycler = new tg({
          focusables: this.focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), e.styles ? (this.stylesView = this._createStylesView(n, i), this.children.add(this.stylesView)) : o.push("ck-list-properties_without-styles"), (e.startIndex || e.reversed) && (this._addNumberedListPropertyViews(e), o.push("ck-list-properties_with-numbered-properties")), this.setTemplate({
          tag: "div",
          attributes: {
            class: o
          },
          children: this.children
        });
      }
      render() {
        if (super.render(), this.stylesView) {
          this.focusables.add(this.stylesView), this.focusTracker.add(this.stylesView.element), (this.startIndexFieldView || this.reversedSwitchButtonView) && (this.focusables.add(this.children.last.buttonView), this.focusTracker.add(this.children.last.buttonView.element));
          for (const t of this.stylesView.children) this.stylesView.focusTracker.add(t.element);
          Lr({
            keystrokeHandler: this.stylesView.keystrokes,
            focusTracker: this.stylesView.focusTracker,
            gridItems: this.stylesView.children,
            numberOfColumns: () => e.window.getComputedStyle(this.stylesView.element).getPropertyValue("grid-template-columns").split(" ").length,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
          });
        }
        if (this.startIndexFieldView) {
          this.focusables.add(this.startIndexFieldView), this.focusTracker.add(this.startIndexFieldView.element);
          const t = t => t.stopPropagation();
          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
        }
        this.reversedSwitchButtonView && (this.focusables.add(this.reversedSwitchButtonView), this.focusTracker.add(this.reversedSwitchButtonView.element)), this.keystrokes.listenTo(this.element);
      }
      focus() {
        this.focusCycler.focusFirst();
      }
      focusLast() {
        this.focusCycler.focusLast();
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createStylesView(t, e) {
        const n = new Sr(this.locale);
        return n.children = n.createCollection(), n.children.addMany(t), n.setTemplate({
          tag: "div",
          attributes: {
            "aria-label": e,
            class: ["ck", "ck-list-styles-list"]
          },
          children: n.children
        }), n.children.delegate("execute").to(this), n.focus = function () {
          this.children.first.focus();
        }, n.focusTracker = new Ko(), n.keystrokes = new Yo(), n.render(), n.keystrokes.listenTo(n.element), n;
      }
      _addNumberedListPropertyViews(t) {
        const e = this.locale.t,
          n = [];
        t.startIndex && (this.startIndexFieldView = this._createStartIndexField(), n.push(this.startIndexFieldView)), t.reversed && (this.reversedSwitchButtonView = this._createReversedSwitchButton(), n.push(this.reversedSwitchButtonView)), t.styles ? (this.additionalPropertiesCollapsibleView = new _m(this.locale, n), this.additionalPropertiesCollapsibleView.set({
          label: e("List properties"),
          isCollapsed: !0
        }), this.additionalPropertiesCollapsibleView.buttonView.bind("isEnabled").toMany(n, "isEnabled", function () {
          for (var _len43 = arguments.length, t = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
            t[_key43] = arguments[_key43];
          }
          return t.some(t => t);
        }), this.additionalPropertiesCollapsibleView.buttonView.on("change:isEnabled", (t, e, n) => {
          n || (this.additionalPropertiesCollapsibleView.isCollapsed = !0);
        }), this.children.add(this.additionalPropertiesCollapsibleView)) : this.children.addMany(n);
      }
      _createStartIndexField() {
        const t = this.locale.t,
          e = new Fm(this.locale, Ng);
        return e.set({
          label: t("Start at"),
          class: "ck-numbered-list-properties__start-index"
        }), e.fieldView.set({
          min: 0,
          step: 1,
          value: 1,
          inputMode: "numeric"
        }), e.fieldView.on("input", () => {
          const n = e.fieldView.element,
            i = n.valueAsNumber;
          Number.isNaN(i) ? e.errorText = t("Invalid start index value.") : n.checkValidity() ? this.fire("listStart", {
            startIndex: i
          }) : e.errorText = t("Start index must be greater than 0.");
        }), e;
      }
      _createReversedSwitchButton() {
        const t = this.locale.t,
          e = new fm(this.locale);
        return e.set({
          withText: !0,
          label: t("Reversed order"),
          class: "ck-numbered-list-properties__reversed-order"
        }), e.delegate("execute").to(this, "listReversed"), e;
      }
    }
    var GS = o(1330),
      WS = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(GS.A, WS);
    GS.A.locals;
    class $S extends Nr {
      static get pluginName() {
        return "ListPropertiesUI";
      }
      init() {
        const t = this.editor,
          e = t.locale.t,
          n = t.config.get("list.properties");
        if (n.styles) {
          const i = [{
              label: e("Toggle the disc list style"),
              tooltip: e("Disc"),
              type: "disc",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></svg>'
            }, {
              label: e("Toggle the circle list style"),
              tooltip: e("Circle"),
              type: "circle",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>'
            }, {
              label: e("Toggle the square list style"),
              tooltip: e("Square"),
              type: "square",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M14 27v6H8v-6h6zm0-9v6H8v-6h6zm0-9v6H8V9h6z"/></svg>'
            }],
            o = e("Bulleted List"),
            r = e("Bulleted list styles toolbar"),
            s = "bulletedList";
          t.ui.componentFactory.add(s, KS({
            editor: t,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            buttonIcon: Yh.bulletedList,
            styleGridAriaLabel: r,
            styleDefinitions: i
          })), t.ui.componentFactory.add(`menuBar:${s}`, QS({
            editor: t,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            styleGridAriaLabel: r,
            styleDefinitions: i
          }));
        }
        if (n.styles || n.startIndex || n.reversed) {
          const i = [{
              label: e("Toggle the decimal list style"),
              tooltip: e("Decimal"),
              type: "decimal",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M10.29 15V8.531H9.286c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 0 0 1.595-.936V15h1.235zm3.343 0v-1.235h-1.235V15h1.235zM11.3 24v-1.147H8.848c.064-.111.148-.226.252-.343.104-.117.351-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.494-.824.104-.263.156-.539.156-.829 0-.51-.182-.936-.545-1.279-.363-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.153-.155.358-.233.616-.233.26 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.468.536-1.024 1.055-.692.641-1.155 1.156-1.389 1.544-.234.389-.375.8-.422 1.233H11.3zm2.333 0v-1.235h-1.235V24h1.235zM9.204 34.11c.615 0 1.129-.2 1.542-.598.413-.398.62-.88.62-1.446 0-.39-.11-.722-.332-.997a1.5 1.5 0 0 0-.886-.532c.619-.337.928-.788.928-1.353 0-.399-.151-.756-.453-1.073-.366-.386-.852-.58-1.459-.58a2.25 2.25 0 0 0-.96.2 1.617 1.617 0 0 0-.668.55c-.16.232-.28.544-.358.933l1.138.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.215 0 .386.065.515.194s.193.302.193.518c0 .255-.087.46-.263.613-.176.154-.43.227-.765.218l-.136 1.006c.22-.061.409-.092.567-.092.24 0 .444.09.61.272.168.182.251.428.251.739 0 .328-.087.589-.261.782a.833.833 0 0 1-.644.29.841.841 0 0 1-.607-.242c-.167-.16-.27-.394-.307-.698l-1.196.145c.062.542.285.98.668 1.316.384.335.868.503 1.45.503zm4.43-.11v-1.235h-1.236V34h1.235z"/></svg>'
            }, {
              label: e("Toggle the decimal with leading zero list style"),
              tooltip: e("Decimal with leading zero"),
              type: "decimal-leading-zero",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M5.714 15.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm6.078.914V8.531H10.79c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 0 0 1.595-.936V15h1.235zm3.344 0v-1.235h-1.235V15h1.235zm-9.422 9.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm7.088.914v-1.147H10.35c.065-.111.149-.226.253-.343.104-.117.35-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.493-.824.104-.263.156-.539.156-.829 0-.51-.181-.936-.544-1.279-.364-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.152-.155.357-.233.615-.233.261 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.467.536-1.024 1.055-.691.641-1.154 1.156-1.388 1.544-.235.389-.375.8-.422 1.233h4.328zm2.334 0v-1.235h-1.235V24h1.235zM5.714 34.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 0 1-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 0 1 .4-.143.61.61 0 0 1 .398.143c.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 0 1-.4.143zm4.992 1.024c.616 0 1.13-.2 1.543-.598.413-.398.62-.88.62-1.446 0-.39-.111-.722-.332-.997a1.5 1.5 0 0 0-.886-.532c.618-.337.927-.788.927-1.353 0-.399-.15-.756-.452-1.073-.366-.386-.853-.58-1.46-.58a2.25 2.25 0 0 0-.96.2 1.617 1.617 0 0 0-.667.55c-.16.232-.28.544-.359.933l1.139.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.214 0 .386.065.515.194s.193.302.193.518c0 .255-.088.46-.264.613-.175.154-.43.227-.764.218l-.136 1.006c.22-.061.408-.092.566-.092.24 0 .444.09.611.272.167.182.25.428.25.739 0 .328-.086.589-.26.782a.833.833 0 0 1-.644.29.841.841 0 0 1-.607-.242c-.167-.16-.27-.394-.308-.698l-1.195.145c.062.542.284.98.668 1.316.384.335.867.503 1.45.503zm4.43-.11v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: e("Toggle the lower–roman list style"),
              tooltip: e("Lower–roman"),
              type: "lower-roman",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.88 8.7V7.558h-1.234V8.7h1.234zm0 5.3V9.333h-1.234V14h1.234zm2.5 0v-1.235h-1.234V14h1.235zm-4.75 4.7v-1.142H8.395V18.7H9.63zm0 5.3v-4.667H8.395V24H9.63zm2.5-5.3v-1.142h-1.234V18.7h1.235zm0 5.3v-4.667h-1.234V24h1.235zm2.501 0v-1.235h-1.235V24h1.235zM7.38 28.7v-1.142H6.145V28.7H7.38zm0 5.3v-4.667H6.145V34H7.38zm2.5-5.3v-1.142H8.646V28.7H9.88zm0 5.3v-4.667H8.646V34H9.88zm2.5-5.3v-1.142h-1.234V28.7h1.235zm0 5.3v-4.667h-1.234V34h1.235zm2.501 0v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: e("Toggle the upper–roman list style"),
              tooltip: e("Upper-roman"),
              type: "upper-roman",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.916 15V8.558h-1.301V15h1.3zm2.465 0v-1.235h-1.235V15h1.235zM9.665 25v-6.442h-1.3V25h1.3zm2.5 0v-6.442h-1.3V25h1.3zm2.466 0v-1.235h-1.235V25h1.235zm-7.216 9v-6.442h-1.3V34h1.3zm2.5 0v-6.442h-1.3V34h1.3zm2.501 0v-6.442h-1.3V34h1.3zm2.465 0v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: e("Toggle the lower–latin list style"),
              tooltip: e("Lower-latin"),
              type: "lower-latin",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M9.62 14.105c.272 0 .528-.05.768-.153s.466-.257.677-.462c.009.024.023.072.044.145.047.161.086.283.119.365h1.221a2.649 2.649 0 0 1-.222-.626c-.04-.195-.059-.498-.059-.908l.013-1.441c0-.536-.055-.905-.165-1.105-.11-.201-.3-.367-.569-.497-.27-.13-.68-.195-1.23-.195-.607 0-1.064.108-1.371.325-.308.217-.525.55-.65 1.002l1.12.202c.076-.217.176-.369.299-.455.123-.086.294-.13.514-.13.325 0 .546.05.663.152.118.101.176.27.176.508v.123c-.222.093-.622.194-1.2.303-.427.082-.755.178-.982.288-.227.11-.403.268-.53.474a1.327 1.327 0 0 0-.188.706c0 .398.138.728.415.988.277.261.656.391 1.136.391zm.368-.87a.675.675 0 0 1-.492-.189.606.606 0 0 1-.193-.448c0-.176.08-.32.241-.435.106-.07.33-.142.673-.215a7.19 7.19 0 0 0 .751-.19v.247c0 .296-.016.496-.048.602a.773.773 0 0 1-.295.409 1.07 1.07 0 0 1-.637.22zm4.645.765v-1.235h-1.235V14h1.235zM10.2 25.105c.542 0 1.003-.215 1.382-.646.38-.43.57-1.044.57-1.84 0-.771-.187-1.362-.559-1.774a1.82 1.82 0 0 0-1.41-.617c-.522 0-.973.216-1.354.65v-2.32H7.594V25h1.147v-.686a1.9 1.9 0 0 0 .67.592c.26.133.523.2.79.2zm-.299-.975c-.354 0-.638-.164-.852-.492-.153-.232-.229-.59-.229-1.073 0-.468.098-.818.295-1.048a.93.93 0 0 1 .738-.345c.302 0 .55.118.743.354.193.236.29.62.29 1.154 0 .5-.096.868-.288 1.1-.192.233-.424.35-.697.35zm4.478.87v-1.235h-1.234V25h1.234zm-4.017 9.105c.6 0 1.08-.142 1.437-.426.357-.284.599-.704.725-1.261l-1.213-.207c-.061.326-.167.555-.316.688a.832.832 0 0 1-.576.2.916.916 0 0 1-.75-.343c-.185-.228-.278-.62-.278-1.173 0-.498.091-.853.274-1.066.183-.212.429-.318.736-.318.232 0 .42.061.565.184.145.123.238.306.28.55l1.216-.22c-.146-.501-.387-.874-.722-1.119-.336-.244-.788-.366-1.356-.366-.695 0-1.245.214-1.653.643-.407.43-.61 1.03-.61 1.8 0 .762.202 1.358.608 1.788.406.431.95.646 1.633.646zM14.633 34v-1.235h-1.235V34h1.235z"/></svg>'
            }, {
              label: e("Toggle the upper–latin list style"),
              tooltip: e("Upper-latin"),
              type: "upper-latin",
              icon: '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="m7.88 15 .532-1.463h2.575L11.549 15h1.415l-2.58-6.442H9.01L6.5 15h1.38zm2.69-2.549H8.811l.87-2.39.887 2.39zM14.88 15v-1.235h-1.234V15h1.234zM9.352 25c.83-.006 1.352-.02 1.569-.044.346-.038.636-.14.872-.305.236-.166.422-.387.558-.664.137-.277.205-.562.205-.855 0-.372-.106-.695-.317-.97-.21-.276-.512-.471-.905-.585a1.51 1.51 0 0 0 .661-.567 1.5 1.5 0 0 0 .244-.83c0-.28-.066-.53-.197-.754a1.654 1.654 0 0 0-.495-.539 1.676 1.676 0 0 0-.672-.266c-.25-.042-.63-.063-1.14-.063H7.158V25h2.193zm.142-3.88H8.46v-1.49h.747c.612 0 .983.007 1.112.022.217.026.38.102.49.226.11.125.165.287.165.486a.68.68 0 0 1-.192.503.86.86 0 0 1-.525.23 11.47 11.47 0 0 1-.944.023h.18zm.17 2.795H8.46v-1.723h1.05c.592 0 .977.03 1.154.092.177.062.313.16.406.295a.84.84 0 0 1 .14.492c0 .228-.06.41-.181.547a.806.806 0 0 1-.473.257c-.126.026-.423.04-.892.04zM14.88 25v-1.235h-1.234V25h1.234zm-5.018 9.11c.691 0 1.262-.17 1.711-.512.45-.341.772-.864.965-1.567l-1.261-.4c-.109.472-.287.818-.536 1.037-.25.22-.547.33-.892.33-.47 0-.85-.173-1.143-.519-.293-.345-.44-.925-.44-1.74 0-.767.15-1.322.447-1.665.297-.343.684-.514 1.162-.514.346 0 .64.096.881.29.242.193.4.457.477.79l1.288-.307c-.147-.516-.367-.911-.66-1.187-.492-.465-1.132-.698-1.92-.698-.902 0-1.63.296-2.184.89-.554.593-.83 1.426-.83 2.498 0 1.014.275 1.813.825 2.397.551.585 1.254.877 2.11.877zM14.88 34v-1.235h-1.234V34h1.234z"/></svg>'
            }],
            o = e("Numbered List"),
            r = e("Numbered list styles toolbar"),
            s = "numberedList";
          t.ui.componentFactory.add(s, KS({
            editor: t,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            buttonIcon: Yh.numberedList,
            styleGridAriaLabel: r,
            styleDefinitions: i
          })), n.styles && t.ui.componentFactory.add(`menuBar:${s}`, QS({
            editor: t,
            propertiesConfig: n,
            parentCommandName: s,
            buttonLabel: o,
            styleGridAriaLabel: r,
            styleDefinitions: i
          }));
        }
      }
    }
    function KS(_ref180) {
      let {
        editor: t,
        propertiesConfig: e,
        parentCommandName: n,
        buttonLabel: i,
        buttonIcon: o,
        styleGridAriaLabel: r,
        styleDefinitions: s
      } = _ref180;
      const a = t.commands.get(n);
      return l => {
        const c = Eg(l, Cg),
          d = c.buttonView;
        return c.bind("isEnabled").to(a), c.class = "ck-list-styles-dropdown", d.on("execute", () => {
          t.execute(n), t.editing.view.focus();
        }), d.set({
          label: i,
          icon: o,
          tooltip: !0,
          isToggleable: !0
        }), d.bind("isOn").to(a, "value", t => !!t), c.once("change:isOpen", () => {
          const i = function (_ref181) {
            let {
              editor: t,
              propertiesConfig: e,
              dropdownView: n,
              parentCommandName: i,
              styleDefinitions: o,
              styleGridAriaLabel: r
            } = _ref181;
            const s = t.locale,
              a = {
                ...e
              };
            "numberedList" != i && (a.startIndex = !1, a.reversed = !1);
            let l = null;
            if (a.styles) {
              const e = t.commands.get("listStyle"),
                n = YS({
                  editor: t,
                  parentCommandName: i,
                  listStyleCommand: e
                }),
                r = ZS(e);
              l = o.filter(r).map(n);
            }
            const c = new qS(s, {
              styleGridAriaLabel: r,
              enabledProperties: a,
              styleButtonViews: l
            });
            a.styles && Ig(n, () => c.stylesView.children.find(t => t.isOn));
            if (a.startIndex) {
              const e = t.commands.get("listStart");
              c.startIndexFieldView.bind("isEnabled").to(e), c.startIndexFieldView.fieldView.bind("value").to(e), c.on("listStart", (e, n) => t.execute("listStart", n));
            }
            if (a.reversed) {
              const e = t.commands.get("listReversed");
              c.reversedSwitchButtonView.bind("isEnabled").to(e), c.reversedSwitchButtonView.bind("isOn").to(e, "value", t => !!t), c.on("listReversed", () => {
                const n = e.value;
                t.execute("listReversed", {
                  reversed: !n
                });
              });
            }
            return c.delegate("execute").to(n), c;
          }({
            editor: t,
            propertiesConfig: e,
            dropdownView: c,
            parentCommandName: n,
            styleGridAriaLabel: r,
            styleDefinitions: s
          });
          c.panelView.children.add(i);
        }), c.on("execute", () => {
          t.editing.view.focus();
        }), c;
      };
    }
    function YS(_ref182) {
      let {
        editor: t,
        listStyleCommand: e,
        parentCommandName: n
      } = _ref182;
      const i = t.locale,
        o = t.commands.get(n);
      return _ref183 => {
        let {
          label: r,
          type: s,
          icon: a,
          tooltip: l
        } = _ref183;
        const c = new mm(i);
        return c.set({
          label: r,
          icon: a,
          tooltip: l
        }), e.on("change:value", () => {
          c.isOn = e.value === s;
        }), c.on("execute", () => {
          o.value ? e.value === s ? t.execute(n) : e.value !== s && t.execute("listStyle", {
            type: s
          }) : t.model.change(() => {
            t.execute("listStyle", {
              type: s
            });
          });
        }), c;
      };
    }
    function QS(_ref184) {
      let {
        editor: t,
        propertiesConfig: e,
        parentCommandName: n,
        buttonLabel: i,
        styleGridAriaLabel: o,
        styleDefinitions: r
      } = _ref184;
      return s => {
        const a = new Fk(s),
          l = t.commands.get(n),
          c = t.commands.get("listStyle"),
          d = ZS(c),
          u = YS({
            editor: t,
            parentCommandName: n,
            listStyleCommand: c
          }),
          h = r.filter(d).map(u),
          m = new qS(s, {
            styleGridAriaLabel: o,
            enabledProperties: {
              ...e,
              startIndex: !1,
              reversed: !1
            },
            styleButtonViews: h
          });
        return m.delegate("execute").to(a), a.buttonView.set({
          label: i,
          icon: Yh[n]
        }), a.panelView.children.add(m), a.bind("isEnabled").to(l, "isEnabled"), a.on("execute", () => {
          t.editing.view.focus();
        }), a;
      };
    }
    function ZS(t) {
      return "function" == typeof t.isStyleTypeSupported ? e => t.isStyleTypeSupported(e.type) : () => !0;
    }
    class JS extends Nr {
      static get requires() {
        return [jS, $S];
      }
      static get pluginName() {
        return "ListProperties";
      }
    }
    class XS extends Pr {
      constructor(t) {
        super(t), this.on("execute", () => {
          this.refresh();
        }, {
          priority: "highest"
        });
      }
      refresh() {
        const t = this._getSelectedItems();
        this.value = this._getValue(t), this.isEnabled = !!t.length;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.editor.model.change(e => {
          const n = this._getSelectedItems(),
            i = void 0 === t.forceValue ? !this._getValue(n) : t.forceValue;
          for (const t of n) i ? e.setAttribute("todoListChecked", !0, t) : e.removeAttribute("todoListChecked", t);
        });
      }
      _getValue(t) {
        return t.every(t => t.getAttribute("todoListChecked"));
      }
      _getSelectedItems() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection.getFirstRange(),
          i = n.start.parent,
          o = [];
        e.checkAttribute(i, "todoListChecked") && o.push(...NB(i));
        for (const t of n.getItems({
          shallow: !0
        })) e.checkAttribute(t, "todoListChecked") && !o.includes(t) && o.push(...NB(t));
        return o;
      }
    }
    class tT extends il {
      constructor() {
        super(...arguments), this.domEventType = ["change"];
      }
      onDomEvent(t) {
        if (t.target) {
          const e = this.view.domConverter.mapDomToView(t.target);
          e && e.is("element", "input") && "checkbox" == e.getAttribute("type") && e.findAncestor({
            classes: "todo-list__label"
          }) && this.fire("todoCheckboxChange", t);
        }
      }
    }
    const eT = bo("Ctrl+Enter");
    class nT extends Nr {
      static get pluginName() {
        return "TodoListEditing";
      }
      static get requires() {
        return [CS];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing,
          i = t.plugins.get(CS),
          o = t.config.get("list.multiBlock") ? "paragraph" : "listItem";
        t.commands.add("todoList", new XB(t, "todo")), t.commands.add("checkTodoList", new XS(t)), n.view.addObserver(tT), e.schema.extend("$listItem", {
          allowAttributes: "todoListChecked"
        }), e.schema.addAttributeCheck((t, e) => {
          const n = t.last;
          if ("todoListChecked" == e) return !(!n.getAttribute("listItemId") || "todo" != n.getAttribute("listType")) && void 0;
        }), t.conversion.for("upcast").add(t => {
          t.on("element:input", (t, e, n) => {
            const i = e.modelCursor,
              o = i.parent,
              r = e.viewItem;
            if (!n.consumable.test(r, {
              name: !0
            })) return;
            if ("checkbox" != r.getAttribute("type") || !i.isAtStart || !o.hasAttribute("listType")) return;
            n.consumable.consume(r, {
              name: !0
            });
            const s = n.writer;
            s.setAttribute("listType", "todo", o), e.viewItem.hasAttribute("checked") && s.setAttribute("todoListChecked", !0, o), e.modelRange = s.createRange(i);
          }), t.on("element:label", iT({
            name: "label",
            classes: "todo-list__label"
          })), t.on("element:label", iT({
            name: "label",
            classes: ["todo-list__label", "todo-list__label_without-description"]
          })), t.on("element:span", iT({
            name: "span",
            classes: "todo-list__label__description"
          })), t.on("element:ul", function (t) {
            const e = new os(t);
            return (t, n, i) => {
              const o = e.match(n.viewItem);
              if (!o) return;
              const r = o.match;
              r.name = !1, i.consumable.consume(n.viewItem, r);
            };
          }({
            name: "ul",
            classes: "todo-list"
          }));
        }), t.conversion.for("downcast").elementToElement({
          model: o,
          view: (t, _ref185) => {
            let {
              writer: e
            } = _ref185;
            if (oT(t, i.getListAttributeNames())) return e.createContainerElement("span", {
              class: "todo-list__label__description"
            });
          },
          converterPriority: "highest"
        }), i.registerDowncastStrategy({
          scope: "list",
          attributeName: "listType",
          setAttributeOnDowncast(t, e, n) {
            "todo" == e ? t.addClass("todo-list", n) : t.removeClass("todo-list", n);
          }
        }), i.registerDowncastStrategy({
          scope: "itemMarker",
          attributeName: "todoListChecked",
          createElement(t, e, _ref186) {
            let {
              dataPipeline: n
            } = _ref186;
            if ("todo" != e.getAttribute("listType")) return null;
            const i = t.createUIElement("input", {
              type: "checkbox",
              ...(e.getAttribute("todoListChecked") ? {
                checked: "checked"
              } : null),
              ...(n ? {
                disabled: "disabled"
              } : {
                tabindex: "-1"
              })
            });
            if (n) return i;
            const o = t.createContainerElement("span", {
              contenteditable: "false"
            }, i);
            return o.getFillerOffset = () => null, o;
          },
          canWrapElement: t => oT(t, i.getListAttributeNames()),
          createWrapperElement(t, e, _ref187) {
            let {
              dataPipeline: n
            } = _ref187;
            const o = ["todo-list__label"];
            return oT(e, i.getListAttributeNames()) || o.push("todo-list__label_without-description"), t.createAttributeElement(n ? "label" : "span", {
              class: o.join(" ")
            });
          }
        }), i.on("checkElement", (t, _ref188) => {
          let {
            modelElement: e,
            viewElement: n
          } = _ref188;
          const o = oT(e, i.getListAttributeNames());
          n.hasClass("todo-list__label__description") != o && (t.return = !0, t.stop());
        }), i.on("checkElement", (e, _ref189) => {
          let {
            modelElement: n,
            viewElement: i
          } = _ref189;
          const o = "todo" == n.getAttribute("listType") && VB(n);
          let r = !1;
          const s = t.editing.view.createPositionBefore(i).getWalker({
            direction: "backward"
          });
          for (const {
            item: e
          } of s) {
            if (e.is("element") && t.editing.mapper.toModelElement(e)) break;
            e.is("element", "input") && "checkbox" == e.getAttribute("type") && (r = !0);
          }
          r != o && (e.return = !0, e.stop());
        }), i.on("postFixer", (t, _ref190) => {
          let {
            listNodes: e,
            writer: n
          } = _ref190;
          for (const {
            node: i,
            previousNodeInList: o
          } of e) {
            if (!o) continue;
            if (o.getAttribute("listItemId") != i.getAttribute("listItemId")) continue;
            const e = o.hasAttribute("todoListChecked"),
              r = i.hasAttribute("todoListChecked");
            r && !e ? (n.removeAttribute("todoListChecked", i), t.return = !0) : !r && e && (n.setAttribute("todoListChecked", !0, i), t.return = !0);
          }
        }), e.document.registerPostFixer(t => {
          const n = e.document.differ.getChanges();
          let i = !1;
          for (const e of n) if ("attribute" == e.type && "listType" == e.attributeKey) {
            const n = e.range.start.nodeAfter;
            "todo" == e.attributeOldValue && n.hasAttribute("todoListChecked") && (t.removeAttribute("todoListChecked", n), i = !0);
          } else if ("insert" == e.type && "$text" != e.name) for (const {
            item: n
          } of t.createRangeOn(e.position.nodeAfter)) n.is("element") && "todo" != n.getAttribute("listType") && n.hasAttribute("todoListChecked") && (t.removeAttribute("todoListChecked", n), i = !0);
          return i;
        }), this.listenTo(n.view.document, "keydown", (e, n) => {
          ko(n) === eT && (t.execute("checkTodoList"), e.stop());
        }, {
          priority: "high"
        }), this.listenTo(n.view.document, "todoCheckboxChange", (t, e) => {
          const i = e.target;
          if (!i || !i.is("element", "input")) return;
          const o = n.view.createPositionAfter(i),
            r = n.mapper.toModelPosition(o).parent;
          r && LB(r) && "todo" == r.getAttribute("listType") && this._handleCheckmarkChange(r);
        }), this.listenTo(n.view.document, "arrowKey", function (t, e) {
          return (n, i) => {
            const o = Ao(i.keyCode, e.contentLanguageDirection),
              r = t.schema,
              s = t.document.selection;
            if (!s.isCollapsed) return;
            const a = s.getFirstPosition(),
              l = a.parent;
            if ("right" == o && a.isAtEnd) {
              const e = r.getNearestSelectionRange(t.createPositionAfter(l), "forward");
              if (!e) return;
              const o = e.start.parent;
              o && LB(o) && "todo" == o.getAttribute("listType") && (t.change(t => t.setSelection(e)), i.preventDefault(), i.stopPropagation(), n.stop());
            } else if ("left" == o && a.isAtStart && LB(l) && "todo" == l.getAttribute("listType")) {
              const e = r.getNearestSelectionRange(t.createPositionBefore(l), "backward");
              if (!e) return;
              t.change(t => t.setSelection(e)), i.preventDefault(), i.stopPropagation(), n.stop();
            }
          };
        }(e, t.locale), {
          context: "$text"
        }), this.listenTo(n.mapper, "viewToModelPosition", (t, n) => {
          const i = n.viewPosition.parent,
            o = i.is("attributeElement", "li") && 0 == n.viewPosition.offset,
            r = rT(i) && n.viewPosition.offset <= 1,
            s = i.is("element", "span") && "false" == i.getAttribute("contenteditable") && rT(i.parent);
          if (!o && !r && !s) return;
          const a = n.modelPosition.nodeAfter;
          a && "todo" == a.getAttribute("listType") && (n.modelPosition = e.createPositionAt(a, 0));
        }, {
          priority: "low"
        }), this._initAriaAnnouncements();
      }
      _handleCheckmarkChange(t) {
        const e = this.editor,
          n = e.model,
          i = Array.from(n.document.selection.getRanges());
        n.change(n => {
          n.setSelection(t, "end"), e.execute("checkTodoList"), n.setSelection(i);
        });
      }
      _initAriaAnnouncements() {
        const {
          model: t,
          ui: e,
          t: n
        } = this.editor;
        let i = null;
        e && t.document.selection.on("change:range", () => {
          const o = t.document.selection.focus.parent,
            r = sT(i),
            s = sT(o);
          r && !s ? e.ariaLiveAnnouncer.announce(n("Leaving a to-do list")) : !r && s && e.ariaLiveAnnouncer.announce(n("Entering a to-do list")), i = o;
        });
      }
    }
    function iT(t) {
      const e = new os(t);
      return (t, n, i) => {
        const o = e.match(n.viewItem);
        o && i.consumable.consume(n.viewItem, o.match) && Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor));
      };
    }
    function oT(t, e) {
      return (t.is("element", "paragraph") || t.is("element", "listItem")) && "todo" == t.getAttribute("listType") && VB(t) && function (t, e) {
        for (const n of t.getAttributeKeys()) if (!n.startsWith("selection:") && !e.includes(n)) return !1;
        return !0;
      }(t, e);
    }
    function rT(t) {
      return !!t && t.is("attributeElement") && t.hasClass("todo-list__label");
    }
    function sT(t) {
      return !!t && !(!t.is("element", "paragraph") && !t.is("element", "listItem")) && "todo" == t.getAttribute("listType");
    }
    class aT extends Nr {
      static get pluginName() {
        return "TodoListUI";
      }
      init() {
        const t = this.editor.t;
        vS(this.editor, "todoList", t("To-do List"), Yh.todoList);
      }
    }
    var lT = o(5484),
      cT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(lT.A, cT);
    lT.A.locals;
    class dT extends Nr {
      static get requires() {
        return [nT, aT];
      }
      static get pluginName() {
        return "TodoList";
      }
    }
    bo("Ctrl+Enter");
    function uT(t, e) {
      const n = (n, i, o) => {
        if (!o.consumable.consume(i.item, n.name)) return;
        const r = i.attributeNewValue,
          s = o.writer,
          a = o.mapper.toViewElement(i.item),
          l = [...a.getChildren()].find(t => t.getCustomProperty("media-content"));
        s.remove(l);
        const c = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), c);
      };
      return t => {
        t.on("attribute:url:media", n);
      };
    }
    function hT(t, e, n, i) {
      return t.createContainerElement("figure", {
        class: "media"
      }, [e.getMediaViewElement(t, n, i), t.createSlot()]);
    }
    function mT(t) {
      const e = t.getSelectedElement();
      return e && e.is("element", "media") ? e : null;
    }
    function gT(t, e, n, i) {
      t.change(o => {
        const r = o.createElement("media", {
          url: e
        });
        t.insertObject(r, n, null, {
          setSelection: "on",
          findOptimalPosition: i ? "auto" : void 0
        });
      });
    }
    class pT extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = mT(e);
        this.value = n ? n.getAttribute("url") : void 0, this.isEnabled = function (t) {
          const e = t.getSelectedElement();
          return !!e && "media" === e.name;
        }(e) || function (t, e) {
          const n = zw(t, e);
          let i = n.start.parent;
          i.isEmpty && !e.schema.isLimit(i) && (i = i.parent);
          return e.schema.checkChild(i, "media");
        }(e, t);
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document.selection,
          i = mT(n);
        i ? e.change(e => {
          e.setAttribute("url", t, i);
        }) : gT(e, t, n, !0);
      }
    }
    class fT {
      constructor(t, e) {
        const n = e.providers,
          i = e.extraProviders || [],
          o = new Set(e.removeProviders),
          r = n.concat(i).filter(t => {
            const e = t.name;
            return e ? !o.has(e) : (w("media-embed-no-provider-name", {
              provider: t
            }), !1);
          });
        this.locale = t, this.providerDefinitions = r;
      }
      hasMedia(t) {
        return !!this._getMedia(t);
      }
      getMediaViewElement(t, e, n) {
        return this._getMedia(e).getViewElement(t, n);
      }
      _getMedia(t) {
        if (!t) return new kT(this.locale);
        t = t.trim();
        for (const e of this.providerDefinitions) {
          const n = e.html,
            i = vo(e.url);
          for (const e of i) {
            const i = this._getUrlMatches(t, e);
            if (i) return new kT(this.locale, t, i, n);
          }
        }
        return null;
      }
      _getUrlMatches(t, e) {
        let n = t.match(e);
        if (n) return n;
        let i = t.replace(/^https?:\/\//, "");
        return n = i.match(e), n || (i = i.replace(/^www\./, ""), n = i.match(e), n || null);
      }
    }
    class kT {
      constructor(t, e, n, i) {
        this.url = this._getValidUrl(e), this._locale = t, this._match = n, this._previewRenderer = i;
      }
      getViewElement(t, e) {
        const n = {};
        let i;
        if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
          this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");
          const o = this._getPreviewHtml(e);
          i = t.createRawElement("div", n, (t, e) => {
            e.setContentOf(t, o);
          });
        } else this.url && (n.url = this.url), i = t.createEmptyElement(e.elementName, n);
        return t.setCustomProperty("media-content", !0, i), i;
      }
      _getPreviewHtml(t) {
        return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
      }
      _getPlaceholderHtml() {
        const t = new cm(),
          e = this._locale.t;
        t.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t.viewBox = "0 0 64 42";
        return new ir({
          tag: "div",
          attributes: {
            class: "ck ck-reset_all ck-media__placeholder"
          },
          children: [{
            tag: "div",
            attributes: {
              class: "ck-media__placeholder__icon"
            },
            children: [t]
          }, {
            tag: "a",
            attributes: {
              class: "ck-media__placeholder__url",
              target: "_blank",
              rel: "noopener noreferrer",
              href: this.url,
              "data-cke-tooltip-text": e("Open media in new tab")
            },
            children: [{
              tag: "span",
              attributes: {
                class: "ck-media__placeholder__url__text"
              },
              children: [this.url]
            }]
          }]
        }).render().outerHTML;
      }
      _getValidUrl(t) {
        return t ? t.match(/^https?/) ? t : "https://" + t : null;
      }
    }
    var bT = o(5767),
      wT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(bT.A, wT);
    bT.A.locals;
    class AT extends Nr {
      static get pluginName() {
        return "MediaEmbedEditing";
      }
      constructor(t) {
        super(t), t.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: [/^dailymotion\.com\/video\/(\w+)/, /^dai.ly\/(\w+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/, /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/, /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/],
            html: t => {
              const e = t[1],
                n = t[2];
              return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${e}${n ? `?start=${n}` : ""}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: t => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), this.registry = new fT(t.locale, t.config.get("mediaEmbed"));
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.t,
          i = t.conversion,
          o = t.config.get("mediaEmbed.previewsInData"),
          r = t.config.get("mediaEmbed.elementName"),
          s = this.registry;
        t.commands.add("mediaEmbed", new pT(t)), e.register("media", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["url"]
        }), i.for("dataDowncast").elementToStructure({
          model: "media",
          view: (t, _ref191) => {
            let {
              writer: e
            } = _ref191;
            const n = t.getAttribute("url");
            return hT(e, s, n, {
              elementName: r,
              renderMediaPreview: !!n && o
            });
          }
        }), i.for("dataDowncast").add(uT(s, {
          elementName: r,
          renderMediaPreview: o
        })), i.for("editingDowncast").elementToStructure({
          model: "media",
          view: (t, _ref192) => {
            let {
              writer: e
            } = _ref192;
            const i = t.getAttribute("url");
            return function (t, e, n) {
              return e.setCustomProperty("media", !0, t), Tw(t, e, {
                label: n
              });
            }(hT(e, s, i, {
              elementName: r,
              renderForEditingView: !0
            }), e, n("media widget"));
          }
        }), i.for("editingDowncast").add(uT(s, {
          elementName: r,
          renderForEditingView: !0
        })), i.for("upcast").elementToElement({
          view: t => ["oembed", r].includes(t.name) && t.getAttribute("url") ? {
            name: !0
          } : null,
          model: (t, _ref193) => {
            let {
              writer: e
            } = _ref193;
            const n = t.getAttribute("url");
            return s.hasMedia(n) ? e.createElement("media", {
              url: n
            }) : null;
          }
        }).elementToElement({
          view: {
            name: "div",
            attributes: {
              "data-oembed-url": !0
            }
          },
          model: (t, _ref194) => {
            let {
              writer: e
            } = _ref194;
            const n = t.getAttribute("data-oembed-url");
            return s.hasMedia(n) ? e.createElement("media", {
              url: n
            }) : null;
          }
        }).add(t => {
          t.on("element:figure", (t, e, n) => {
            if (!n.consumable.consume(e.viewItem, {
              name: !0,
              classes: "media"
            })) return;
            const {
              modelRange: i,
              modelCursor: o
            } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = i, e.modelCursor = o;
            $o(i.getItems()) || n.consumable.revert(e.viewItem, {
              name: !0,
              classes: "media"
            });
          });
        });
      }
    }
    const CT = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
    class _T extends Nr {
      static get requires() {
        return [DA, Wb, jA];
      }
      static get pluginName() {
        return "AutoMediaEmbed";
      }
      constructor(t) {
        super(t), this._timeoutId = null, this._positionToInsert = null;
      }
      init() {
        const t = this.editor,
          n = t.model.document,
          i = t.plugins.get("ClipboardPipeline");
        this.listenTo(i, "inputTransformation", () => {
          const t = n.selection.getFirstRange(),
            e = gu.fromPosition(t.start);
          e.stickiness = "toPrevious";
          const i = gu.fromPosition(t.end);
          i.stickiness = "toNext", n.once("change:data", () => {
            this._embedMediaBetweenPositions(e, i), e.detach(), i.detach();
          }, {
            priority: "high"
          });
        });
        t.commands.get("undo").on("execute", () => {
          this._timeoutId && (e.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
        }, {
          priority: "high"
        });
      }
      _embedMediaBetweenPositions(t, n) {
        const i = this.editor,
          o = i.plugins.get(AT).registry,
          r = new Ec(t, n),
          s = r.getWalker({
            ignoreElementEnd: !0
          });
        let a = "";
        for (const t of s) t.item.is("$textProxy") && (a += t.item.data);
        if (a = a.trim(), !a.match(CT)) return void r.detach();
        if (!o.hasMedia(a)) return void r.detach();
        i.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = gu.fromPosition(t), this._timeoutId = e.window.setTimeout(() => {
          i.model.change(t => {
            this._timeoutId = null, t.remove(r), r.detach();
            let e = null;
            "$graveyard" !== this._positionToInsert.root.rootName && (e = this._positionToInsert), gT(i.model, a, e, !1), this._positionToInsert.detach(), this._positionToInsert = null;
          }), i.plugins.get(Wb).requestUndoOnBackspace();
        }, 100)) : r.detach();
      }
    }
    var vT = o(6004),
      yT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(vT.A, yT);
    vT.A.locals;
    class xT extends Sr {
      constructor(t, e) {
        super(e);
        const n = e.t;
        this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.set("mediaURLInputValue", ""), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n("Save"), Yh.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n("Cancel"), Yh.cancel, "ck-button-cancel", "cancel"), this._focusables = new nr(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this._validators = t, this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [this.urlInputView, this.saveButtonView, this.cancelButtonView]
        });
      }
      render() {
        super.render(), Mr({
          view: this
        });
        [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
        const t = t => t.stopPropagation();
        this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      get url() {
        return this.urlInputView.fieldView.element.value.trim();
      }
      set url(t) {
        this.urlInputView.fieldView.element.value = t.trim();
      }
      isValid() {
        this.resetFormStatus();
        for (const t of this._validators) {
          const e = t(this);
          if (e) return this.urlInputView.errorText = e, !1;
        }
        return !0;
      }
      resetFormStatus() {
        this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
      }
      _createUrlInput() {
        const t = this.locale.t,
          e = new Fm(this.locale, Lg),
          n = e.fieldView;
        return this._urlInputViewInfoDefault = t("Paste the media URL in the input."), this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster."), e.label = t("Media URL"), e.infoText = this._urlInputViewInfoDefault, n.on("input", () => {
          e.infoText = n.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault, this.mediaURLInputValue = n.element.value.trim();
        }), e;
      }
      _createButton(t, e, n, i) {
        const o = new mm(this.locale);
        return o.set({
          label: t,
          icon: e,
          tooltip: !0
        }), o.extendTemplate({
          attributes: {
            class: n
          }
        }), i && o.delegate("execute").to(this, i), o;
      }
    }
    class ET extends Nr {
      static get requires() {
        return [AT];
      }
      static get pluginName() {
        return "MediaEmbedUI";
      }
      init() {
        const t = this.editor,
          e = t.commands.get("mediaEmbed");
        t.ui.componentFactory.add("mediaEmbed", t => {
          const n = Eg(t);
          return this._setUpDropdown(n, e), n;
        });
      }
      _setUpDropdown(t, e) {
        const n = this.editor,
          i = n.t,
          o = t.buttonView,
          r = n.plugins.get(AT).registry;
        t.once("change:isOpen", () => {
          const i = new (Ir(xT))(function (t, e) {
            return [e => {
              if (!e.url.length) return t("The URL must not be empty.");
            }, n => {
              if (!e.hasMedia(n.url)) return t("This media URL is not supported.");
            }];
          }(n.t, r), n.locale);
          t.panelView.children.add(i), o.on("open", () => {
            i.disableCssTransitions(), i.url = e.value || "", i.urlInputView.fieldView.select(), i.enableCssTransitions();
          }, {
            priority: "low"
          }), t.on("submit", () => {
            i.isValid() && (n.execute("mediaEmbed", i.url), n.editing.view.focus());
          }), t.on("change:isOpen", () => i.resetFormStatus()), t.on("cancel", () => {
            n.editing.view.focus();
          }), i.delegate("submit", "cancel").to(t), i.urlInputView.fieldView.bind("value").to(e, "value"), i.urlInputView.on("change:errorText", () => {
            n.ui.update();
          }), i.urlInputView.bind("isEnabled").to(e, "isEnabled");
        }), t.bind("isEnabled").to(e), o.set({
          label: i("Insert media"),
          icon: '<svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.587 1.5c-.612 0-.601-.029-.601.551v14.84c0 .59-.01.559.591.559h18.846c.602 0 .591.03.591-.56V2.052c0-.58.01-.55-.591-.55H1.587Zm.701.971h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-14.24 1h13.008v12H4.467l.029-12Zm-2.208 1h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003v1H2.288v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h1.003l-.029 1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Zm-16.448 2h.974v1h-.974v-1Zm16.448 0h1.003v1h-1.003v-1Z"/><path d="M8.374 6.648a.399.399 0 0 1 .395-.4.402.402 0 0 1 .2.049l5.148 2.824a.4.4 0 0 1 0 .7l-5.148 2.824a.403.403 0 0 1-.595-.35V6.648Z"/></svg>',
          tooltip: !0
        });
      }
    }
    var DT = o(3155),
      BT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(DT.A, BT);
    DT.A.locals;
    const ST = {
      "(": ")",
      "[": "]",
      "{": "}"
    };
    class TT extends Pr {
      constructor(t) {
        super(t), this._isEnabledBasedOnSelection = !1;
      }
      refresh() {
        const t = this.editor.model,
          e = t.document;
        this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "mention");
      }
      execute(t) {
        const e = this.editor.model,
          n = e.document.selection,
          i = "string" == typeof t.mention ? {
            id: t.mention
          } : t.mention,
          o = i.id,
          r = t.range || n.getFirstRange();
        if (!e.canEditAt(r)) return;
        const s = t.text || o,
          a = MT({
            _text: s,
            id: o
          }, i);
        if (1 != t.marker.length) throw new b("mentioncommand-incorrect-marker", this);
        if (o.charAt(0) != t.marker) throw new b("mentioncommand-incorrect-id", this);
        e.change(t => {
          const i = Qo(n.getAttributes()),
            o = new Map(i.entries());
          o.set("mention", a);
          const l = e.insertContent(t.createText(s, o), r),
            c = l.start.nodeBefore,
            d = l.end.nodeAfter,
            u = d && d.is("$text") && d.data.startsWith(" ");
          let h = !1;
          if (c && d && c.is("$text") && d.is("$text")) {
            const t = c.data.slice(-1),
              e = (t in ST),
              n = e && d.data.startsWith(ST[t]);
            h = e && n;
          }
          h || u || e.insertContent(t.createText(" ", i), r.start.getShiftedBy(s.length));
        });
      }
    }
    class IT extends Nr {
      static get pluginName() {
        return "MentionEditing";
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = e.document;
        e.schema.extend("$text", {
          allowAttributes: "mention"
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            key: "data-mention",
            classes: "mention"
          },
          model: {
            key: "mention",
            value: t => LT(t)
          }
        }), t.conversion.for("downcast").attributeToElement({
          model: "mention",
          view: zT
        }), t.conversion.for("downcast").add(NT), n.registerPostFixer(t => function (t, e, n) {
          const i = e.differ.getChanges();
          let o = !1;
          for (const e of i) {
            if ("attribute" == e.type) continue;
            const i = e.position;
            if ("$text" == e.name) {
              const e = i.textNode && i.textNode.nextSibling;
              o = VT(i.textNode, t) || o, o = VT(e, t) || o, o = VT(i.nodeBefore, t) || o, o = VT(i.nodeAfter, t) || o;
            }
            if ("$text" != e.name && "insert" == e.type) {
              const e = i.nodeAfter;
              for (const n of t.createRangeIn(e).getItems()) o = VT(n, t) || o;
            }
            if ("insert" == e.type && n.isInline(e.name)) {
              const e = i.nodeAfter && i.nodeAfter.nextSibling;
              o = VT(i.nodeBefore, t) || o, o = VT(e, t) || o;
            }
          }
          return o;
        }(t, n, e.schema)), n.registerPostFixer(t => function (t, e) {
          const n = e.differ.getChanges();
          let i = !1;
          for (const e of n) if ("attribute" === e.type && "mention" != e.attributeKey) {
            const n = e.range.start.nodeBefore,
              o = e.range.end.nodeAfter;
            for (const r of [n, o]) PT(r) && r.getAttribute(e.attributeKey) != e.attributeNewValue && (t.setAttribute(e.attributeKey, e.attributeNewValue, r), i = !0);
          }
          return i;
        }(t, n)), n.registerPostFixer(t => function (t, e) {
          const n = e.selection,
            i = n.focus;
          if (n.isCollapsed && n.hasAttribute("mention") && function (t) {
            const e = t.isAtStart;
            return t.nodeBefore && t.nodeBefore.is("$text") || e;
          }(i)) return t.removeSelectionAttribute("mention"), !0;
          return !1;
        }(t, n)), t.commands.add("mention", new TT(t));
      }
    }
    function MT(t, e) {
      return Object.assign({
        uid: p()
      }, t, e || {});
    }
    function LT(t, e) {
      const n = t.getAttribute("data-mention"),
        i = t.getChild(0);
      if (!i) return;
      return MT({
        id: n,
        _text: i.data
      }, e);
    }
    function NT(t) {
      t.on("attribute:mention", (t, e, n) => {
        const i = e.attributeNewValue;
        if (!e.item.is("$textProxy") || !i) return;
        const o = e.range.start;
        (o.textNode || o.nodeAfter).data != i._text && n.consumable.consume(e.item, t.name);
      }, {
        priority: "highest"
      });
    }
    function zT(t, _ref195) {
      let {
        writer: e
      } = _ref195;
      if (!t) return;
      const n = {
          class: "mention",
          "data-mention": t.id
        },
        i = {
          id: t.uid,
          priority: 20
        };
      return e.createAttributeElement("span", n, i);
    }
    function PT(t) {
      if (!t || !t.is("$text") && !t.is("$textProxy") || !t.hasAttribute("mention")) return !1;
      return t.data != t.getAttribute("mention")._text;
    }
    function VT(t, e) {
      return !!PT(t) && (e.removeAttribute("mention", t), !0);
    }
    var RT = o(7216),
      FT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(RT.A, FT);
    RT.A.locals;
    class OT extends bg {
      constructor(t) {
        super(t), this.extendTemplate({
          attributes: {
            class: ["ck-mentions"],
            tabindex: "-1"
          }
        });
      }
      selectFirst() {
        this.select(0);
      }
      selectNext() {
        const t = this.selected,
          e = this.items.getIndex(t);
        this.select(e + 1);
      }
      selectPrevious() {
        const t = this.selected,
          e = this.items.getIndex(t);
        this.select(e - 1);
      }
      select(t) {
        let e = 0;
        t > 0 && t < this.items.length ? e = t : t < 0 && (e = this.items.length - 1);
        const n = this.items.get(e);
        this.selected !== n && (this.selected && this.selected.removeHighlight(), n.highlight(), this.selected = n, this._isItemVisibleInScrolledArea(n) || (this.element.scrollTop = n.element.offsetTop));
      }
      executeSelected() {
        this.selected.fire("execute");
      }
      _isItemVisibleInScrolledArea(t) {
        return new Pi(this.element).contains(new Pi(t.element));
      }
    }
    class jT extends Sr {
      constructor(t, e) {
        super(t), this.template = void 0, this.domElement = e, this.domElement.classList.add("ck-button"), this.set("isOn", !1), this.on("change:isOn", (t, e, n) => {
          n ? (this.domElement.classList.add("ck-on"), this.domElement.classList.remove("ck-off")) : (this.domElement.classList.add("ck-off"), this.domElement.classList.remove("ck-on"));
        }), this.listenTo(this.domElement, "click", () => {
          this.fire("execute");
        });
      }
      render() {
        super.render(), this.element = this.domElement;
      }
      focus() {
        this.domElement.focus();
      }
    }
    class HT extends mg {
      highlight() {
        this.children.first.isOn = !0;
      }
      removeHighlight() {
        this.children.first.isOn = !1;
      }
    }
    const UT = [po.arrowup, po.arrowdown, po.esc],
      qT = [po.enter, po.tab];
    class GT extends Nr {
      static get pluginName() {
        return "MentionUI";
      }
      static get requires() {
        return [Rf];
      }
      constructor(t) {
        super(t), this._items = new Wo(), this._mentionsView = this._createMentionView(), this._mentionsConfigurations = new Map(), this._requestFeedDebounced = kl(this._requestFeed, 100), t.config.define("mention", {
          feeds: []
        });
      }
      init() {
        const t = this.editor,
          e = t.config.get("mention.commitKeys") || qT,
          n = UT.concat(e);
        this._balloon = t.plugins.get(Rf), t.editing.view.document.on("keydown", (t, i) => {
          var o;
          o = i.keyCode, n.includes(o) && this._isUIVisible && (i.preventDefault(), t.stop(), i.keyCode == po.arrowdown && this._mentionsView.selectNext(), i.keyCode == po.arrowup && this._mentionsView.selectPrevious(), e.includes(i.keyCode) && this._mentionsView.executeSelected(), i.keyCode == po.esc && this._hideUIAndRemoveMarker());
        }, {
          priority: "highest"
        }), Tr({
          emitter: this._mentionsView,
          activator: () => this._isUIVisible,
          contextElements: () => [this._balloon.view.element],
          callback: () => this._hideUIAndRemoveMarker()
        });
        const i = t.config.get("mention.feeds");
        for (const t of i) {
          const {
            feed: e,
            marker: n,
            dropdownLimit: i
          } = t;
          if (!QT(n)) throw new b("mentionconfig-incorrect-marker", null, {
            marker: n
          });
          const o = {
            marker: n,
            feedCallback: "function" == typeof e ? e.bind(this.editor) : YT(e),
            itemRenderer: t.itemRenderer,
            dropdownLimit: i
          };
          this._mentionsConfigurations.set(n, o);
        }
        this._setupTextWatcher(i), this.listenTo(t, "change:isReadOnly", () => {
          this._hideUIAndRemoveMarker();
        }), this.on("requestFeed:response", (t, e) => this._handleFeedResponse(e)), this.on("requestFeed:error", () => this._hideUIAndRemoveMarker());
      }
      destroy() {
        super.destroy(), this._mentionsView.destroy();
      }
      get _isUIVisible() {
        return this._balloon.visibleView === this._mentionsView;
      }
      _createMentionView() {
        const t = this.editor.locale,
          e = new OT(t);
        return e.items.bindTo(this._items).using(n => {
          const {
              item: i,
              marker: o
            } = n,
            {
              dropdownLimit: r
            } = this._mentionsConfigurations.get(o),
            s = r || this.editor.config.get("mention.dropdownLimit") || 10;
          if (e.items.length >= s) return null;
          const a = new HT(t),
            l = this._renderItem(i, o);
          return l.delegate("execute").to(a), a.children.add(l), a.item = i, a.marker = o, a.on("execute", () => {
            e.fire("execute", {
              item: i,
              marker: o
            });
          }), a;
        }), e.on("execute", (t, e) => {
          const n = this.editor,
            i = n.model,
            o = e.item,
            r = e.marker,
            s = n.model.markers.get("mention"),
            a = i.createPositionAt(i.document.selection.focus),
            l = i.createPositionAt(s.getStart()),
            c = i.createRange(l, a);
          this._hideUIAndRemoveMarker(), n.execute("mention", {
            mention: o,
            text: o.text,
            marker: r,
            range: c
          }), n.editing.view.focus();
        }), e;
      }
      _getItemRenderer(t) {
        const {
          itemRenderer: e
        } = this._mentionsConfigurations.get(t);
        return e;
      }
      _requestFeed(t, e) {
        this._lastRequested = e;
        const {
            feedCallback: n
          } = this._mentionsConfigurations.get(t),
          i = n(e);
        i instanceof Promise ? i.then(n => {
          this._lastRequested == e ? this.fire("requestFeed:response", {
            feed: n,
            marker: t,
            feedText: e
          }) : this.fire("requestFeed:discarded", {
            feed: n,
            marker: t,
            feedText: e
          });
        }).catch(e => {
          this.fire("requestFeed:error", {
            error: e
          }), w("mention-feed-callback-error", {
            marker: t
          });
        }) : this.fire("requestFeed:response", {
          feed: i,
          marker: t,
          feedText: e
        });
      }
      _setupTextWatcher(t) {
        const e = this.editor,
          n = t.map(t => ({
            ...t,
            pattern: KT(t.marker, t.minimumCharacters || 0)
          })),
          i = new Yb(e.model, function (t) {
            const e = e => {
              const n = $T(t, e);
              if (!n) return !1;
              let i = 0;
              0 !== n.position && (i = n.position - 1);
              const o = e.substring(i);
              return n.pattern.test(o);
            };
            return e;
          }(n));
        i.on("matched", (t, i) => {
          const o = $T(n, i.text),
            r = e.model.document.selection.focus,
            s = e.model.createPositionAt(r.parent, o.position);
          if (function (t) {
            const e = t.textNode && t.textNode.hasAttribute("mention"),
              n = t.nodeBefore;
            return e || n && n.is("$text") && n.hasAttribute("mention");
          }(r) || function (t) {
            const e = t.nodeAfter;
            return e && e.is("$text") && e.hasAttribute("mention");
          }(s)) return void this._hideUIAndRemoveMarker();
          const a = function (t, e) {
              let n = 0;
              0 !== t.position && (n = t.position - 1);
              const i = KT(t.marker, 0),
                o = e.substring(n);
              return o.match(i)[2];
            }(o, i.text),
            l = o.marker.length + a.length,
            c = r.getShiftedBy(-l),
            d = r.getShiftedBy(-a.length),
            u = e.model.createRange(c, d);
          if (ZT(e)) {
            const t = e.model.markers.get("mention");
            e.model.change(e => {
              e.updateMarker(t, {
                range: u
              });
            });
          } else e.model.change(t => {
            t.addMarker("mention", {
              range: u,
              usingOperation: !1,
              affectsData: !1
            });
          });
          this._requestFeedDebounced(o.marker, a);
        }), i.on("unmatched", () => {
          this._hideUIAndRemoveMarker();
        });
        const o = e.commands.get("mention");
        return i.bind("isEnabled").to(o), i;
      }
      _handleFeedResponse(t) {
        const {
          feed: e,
          marker: n
        } = t;
        if (!ZT(this.editor)) return;
        this._items.clear();
        for (const t of e) {
          const e = "object" != typeof t ? {
            id: t,
            text: t
          } : t;
          this._items.add({
            item: e,
            marker: n
          });
        }
        const i = this.editor.model.markers.get("mention");
        this._items.length ? this._showOrUpdateUI(i) : this._hideUIAndRemoveMarker();
      }
      _showOrUpdateUI(t) {
        this._isUIVisible ? this._balloon.updatePosition(this._getBalloonPanelPositionData(t, this._mentionsView.position)) : this._balloon.add({
          view: this._mentionsView,
          position: this._getBalloonPanelPositionData(t, this._mentionsView.position),
          singleViewMode: !0
        }), this._mentionsView.position = this._balloon.view.position, this._mentionsView.selectFirst();
      }
      _hideUIAndRemoveMarker() {
        this._balloon.hasView(this._mentionsView) && this._balloon.remove(this._mentionsView), ZT(this.editor) && this.editor.model.change(t => t.removeMarker("mention")), this._mentionsView.position = void 0;
      }
      _renderItem(t, e) {
        const n = this.editor;
        let i,
          o = t.id;
        const r = this._getItemRenderer(e);
        if (r) {
          const e = r(t);
          "string" != typeof e ? i = new jT(n.locale, e) : o = e;
        }
        if (!i) {
          const t = new mm(n.locale);
          t.label = o, t.withText = !0, i = t;
        }
        return i;
      }
      _getBalloonPanelPositionData(t, e) {
        const n = this.editor,
          i = n.editing,
          o = i.view.domConverter,
          r = i.mapper;
        return {
          target: () => {
            let e = t.getRange();
            "$graveyard" == e.start.root.rootName && (e = n.model.document.selection.getFirstRange());
            const i = r.toViewRange(e);
            return Pi.getDomRangeRects(o.viewRangeToDom(i)).pop();
          },
          limiter: () => {
            const t = this.editor.editing.view,
              e = t.document.selection.editableElement;
            return e ? t.domConverter.mapViewToDom(e.root) : null;
          },
          positions: WT(e, n.locale.uiLanguageDirection)
        };
      }
    }
    function WT(t, e) {
      const n = {
        caret_se: t => ({
          top: t.bottom + 3,
          left: t.right,
          name: "caret_se",
          config: {
            withArrow: !1
          }
        }),
        caret_ne: (t, e) => ({
          top: t.top - e.height - 3,
          left: t.right,
          name: "caret_ne",
          config: {
            withArrow: !1
          }
        }),
        caret_sw: (t, e) => ({
          top: t.bottom + 3,
          left: t.right - e.width,
          name: "caret_sw",
          config: {
            withArrow: !1
          }
        }),
        caret_nw: (t, e) => ({
          top: t.top - e.height - 3,
          left: t.right - e.width,
          name: "caret_nw",
          config: {
            withArrow: !1
          }
        })
      };
      return Object.prototype.hasOwnProperty.call(n, t) ? [n[t]] : "rtl" !== e ? [n.caret_se, n.caret_sw, n.caret_ne, n.caret_nw] : [n.caret_sw, n.caret_se, n.caret_nw, n.caret_ne];
    }
    function $T(t, e) {
      let n;
      for (const i of t) {
        const t = e.lastIndexOf(i.marker);
        t > 0 && !e.substring(t - 1).match(i.pattern) || (!n || t >= n.position) && (n = {
          marker: i.marker,
          position: t,
          minimumCharacters: i.minimumCharacters,
          pattern: i.pattern
        });
      }
      return n;
    }
    function KT(t, e) {
      const n = 0 == e ? "*" : `{${e},}`,
        i = s.features.isRegExpUnicodePropertySupported ? "\\p{Ps}\\p{Pi}\"'" : "\\(\\[{\"'";
      return new RegExp(`(?:^|[ ${i}])([${t}])(.${n})$`, "u");
    }
    function YT(t) {
      return e => t.filter(t => ("string" == typeof t ? t : String(t.id)).toLowerCase().includes(e.toLowerCase()));
    }
    function QT(t) {
      return t && 1 == t.length;
    }
    function ZT(t) {
      return t.model.markers.has("mention");
    }
    var JT = o(1478),
      XT = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(JT.A, XT);
    JT.A.locals;
    class tI extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.schema,
          n = t.document.selection;
        this.isEnabled = function (t, e, n) {
          const i = function (t, e) {
            const n = zw(t, e),
              i = n.start.parent;
            if (i.isEmpty && !i.is("element", "$root")) return i.parent;
            return i;
          }(t, n);
          return e.checkChild(i, "pageBreak");
        }(n, e, t);
      }
      execute() {
        const t = this.editor.model;
        t.change(e => {
          const n = e.createElement("pageBreak");
          t.insertObject(n, null, null, {
            setSelection: "after"
          });
        });
      }
    }
    var eI = o(5079),
      nI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(eI.A, nI);
    eI.A.locals;
    class iI extends Nr {
      static get pluginName() {
        return "PageBreakEditing";
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.t,
          i = t.conversion;
        e.register("pageBreak", {
          inheritAllFrom: "$blockObject"
        }), i.for("dataDowncast").elementToStructure({
          model: "pageBreak",
          view: (t, _ref196) => {
            let {
              writer: e
            } = _ref196;
            return e.createContainerElement("div", {
              class: "page-break",
              style: "page-break-after: always"
            }, e.createContainerElement("span", {
              style: "display: none"
            }));
          }
        }), i.for("editingDowncast").elementToStructure({
          model: "pageBreak",
          view: (t, _ref197) => {
            let {
              writer: e
            } = _ref197;
            const i = n("Page break"),
              o = e.createContainerElement("div"),
              r = e.createRawElement("span", {
                class: "page-break__label"
              }, function (t) {
                t.innerText = n("Page break");
              });
            return e.addClass("page-break", o), e.insert(e.createPositionAt(o, 0), r), function (t, e, n) {
              return e.setCustomProperty("pageBreak", !0, t), Tw(t, e, {
                label: n
              });
            }(o, e, i);
          }
        }), i.for("upcast").elementToElement({
          view: t => {
            const e = "always" == t.getStyle("page-break-before"),
              n = "always" == t.getStyle("page-break-after");
            if (!e && !n) return null;
            if (1 == t.childCount) {
              const e = t.getChild(0);
              if (!e.is("element", "span") || "none" != e.getStyle("display")) return null;
            } else if (t.childCount > 1) return null;
            return {
              name: !0
            };
          },
          model: "pageBreak",
          converterPriority: "high"
        }), t.commands.add("pageBreak", new tI(t));
      }
    }
    class oI extends Nr {
      static get pluginName() {
        return "PageBreakUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add("pageBreak", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0
          }), t;
        }), t.ui.componentFactory.add("menuBar:pageBreak", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("pageBreak"),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Page break"),
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.598.687h1.5v5h-1.5zm14.5 0h1.5v5h-1.5z"/><path d="M19.598 4.187v1.5h-16v-1.5zm-16 14.569h1.5v-5h-1.5zm14.5 0h1.5v-5h-1.5z"/><path d="M19.598 15.256v-1.5h-16v1.5zM5.081 9h6v2h-6zm8 0h6v2h-6zm-9.483 1L0 12.5v-5z"/></svg>'
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          e.execute("pageBreak"), e.editing.view.focus();
        }), o;
      }
    }
    function rI(t) {
      return void 0 !== t && t.endsWith("px");
    }
    function sI(t) {
      return t.toFixed(2).replace(/\.?0+$/, "") + "px";
    }
    function aI(t, e, n) {
      if (!t.childCount) return;
      const i = new th(t.document),
        o = function (t, e) {
          const n = e.createRangeIn(t),
            i = [],
            o = new Set();
          for (const t of n.getItems()) {
            if (!t.is("element") || !t.name.match(/^(p|h\d+|li|div)$/)) continue;
            let e = pI(t);
            if (void 0 === e || 0 != parseFloat(e) || Array.from(t.getClassNames()).find(t => t.startsWith("MsoList")) || (e = void 0), t.hasStyle("mso-list") || void 0 !== e && o.has(e)) {
              const n = mI(t);
              i.push({
                element: t,
                id: n.id,
                order: n.order,
                indent: n.indent,
                marginLeft: e
              }), void 0 !== e && o.add(e);
            } else o.clear();
          }
          return i;
        }(t, i);
      if (!o.length) return;
      const r = {},
        s = [];
      for (const t of o) if (void 0 !== t.indent) {
        lI(t) || (s.length = 0);
        const o = `${t.id}:${t.indent}`,
          a = Math.min(t.indent - 1, s.length);
        if (a < s.length && s[a].id !== t.id && (s.length = a), a < s.length - 1) s.length = a + 1;else {
          const l = dI(t, e);
          if (a > s.length - 1 || s[a].listElement.name != l.type) {
            0 == a && "ol" == l.type && void 0 !== t.id && r[o] && (l.startIndex = r[o]);
            const e = hI(l, i, n);
            if (rI(t.marginLeft) && (0 == a || rI(s[a - 1].marginLeft))) {
              let n = t.marginLeft;
              a > 0 && (n = sI(parseFloat(n) - parseFloat(s[a - 1].marginLeft))), i.setStyle("padding-left", n, e);
            }
            if (0 == s.length) {
              const n = t.element.parent,
                o = n.getChildIndex(t.element) + 1;
              i.insertChild(o, e, n);
            } else {
              const t = s[a - 1].listItemElements;
              i.appendChild(e, t[t.length - 1]);
            }
            s[a] = {
              ...t,
              listElement: e,
              listItemElements: []
            }, 0 == a && void 0 !== t.id && (r[o] = l.startIndex || 1);
          }
        }
        const l = "li" == t.element.name ? t.element : i.createElement("li");
        i.appendChild(l, s[a].listElement), s[a].listItemElements.push(l), 0 == a && void 0 !== t.id && r[o]++, t.element != l && i.appendChild(t.element, l), gI(t.element, i), i.removeStyle("text-indent", t.element), i.removeStyle("margin-left", t.element);
      } else {
        const e = s.find(e => e.marginLeft == t.marginLeft);
        if (e) {
          const n = e.listItemElements;
          i.appendChild(t.element, n[n.length - 1]), i.removeStyle("margin-left", t.element);
        } else s.length = 0;
      }
    }
    function lI(t) {
      const e = t.element.previousSibling;
      return cI(e || t.element.parent);
    }
    function cI(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function dI(t, e) {
      const n = new RegExp(`@list l${t.id}:level${t.indent}\\s*({[^}]*)`, "gi"),
        i = /mso-level-number-format:([^;]{0,100});/gi,
        o = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
        r = new RegExp(`@list\\s+l${t.id}:level\\d\\s*{[^{]*mso-level-text:"%\\d\\\\.`, "gi"),
        s = new RegExp(`@list l${t.id}:level\\d\\s*{[^{]*mso-level-number-format:`, "gi"),
        a = r.exec(e),
        l = s.exec(e),
        c = a && !l,
        d = n.exec(e);
      let u = "decimal",
        h = "ol",
        m = null;
      if (d && d[1]) {
        const e = i.exec(d[1]);
        if (e && e[1] && (u = e[1].trim(), h = "bullet" !== u && "image" !== u ? "ol" : "ul"), "bullet" === u) {
          const e = function (t) {
            if ("li" == t.name && "ul" == t.parent.name && t.parent.hasAttribute("type")) return t.parent.getAttribute("type");
            const e = function (t) {
              if (t.getChild(0).is("$text")) return null;
              for (const e of t.getChildren()) {
                if (!e.is("element", "span")) continue;
                const t = e.getChild(0);
                if (t) return t.is("$text") ? t : t.getChild(0);
              }
              return null;
            }(t);
            if (!e) return null;
            const n = e._data;
            if ("o" === n) return "circle";
            if ("·" === n) return "disc";
            if ("§" === n) return "square";
            return null;
          }(t.element);
          e && (u = e);
        } else {
          const t = o.exec(d[1]);
          t && t[1] && (m = parseInt(t[1]));
        }
        c && (h = "ol");
      }
      return {
        type: h,
        startIndex: m,
        style: uI(u),
        isLegalStyleList: c
      };
    }
    function uI(t) {
      if (t.startsWith("arabic-leading-zero")) return "decimal-leading-zero";
      switch (t) {
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return t;
        default:
          return null;
      }
    }
    function hI(t, e, n) {
      const i = e.createElement(t.type);
      return t.style && e.setStyle("list-style-type", t.style, i), t.startIndex && t.startIndex > 1 && e.setAttribute("start", t.startIndex, i), t.isLegalStyleList && n && e.addClass("legal-list", i), i;
    }
    function mI(t) {
      const e = t.getStyle("mso-list");
      if (void 0 === e) return {};
      const n = e.match(/(^|\s{1,100})l(\d+)/i),
        i = e.match(/\s{0,100}lfo(\d+)/i),
        o = e.match(/\s{0,100}level(\d+)/i);
      return n && i && o ? {
        id: n[2],
        order: i[1],
        indent: parseInt(o[1])
      } : {
        indent: 1
      };
    }
    function gI(t, e) {
      const n = new os({
          name: "span",
          styles: {
            "mso-list": "Ignore"
          }
        }),
        i = e.createRangeIn(t);
      for (const t of i) "elementStart" === t.type && n.match(t.item) && e.remove(t.item);
    }
    function pI(t) {
      const e = t.getStyle("margin-left");
      return void 0 === e || e.endsWith("px") ? e : function (t) {
        const e = parseFloat(t);
        return t.endsWith("pt") ? sI(96 * e / 72) : t.endsWith("pc") ? sI(12 * e * 96 / 72) : t.endsWith("in") ? sI(96 * e) : t.endsWith("cm") ? sI(96 * e / 2.54) : t.endsWith("mm") ? sI(e / 10 * 96 / 2.54) : t;
      }(e);
    }
    function fI(t, e) {
      if (!t.childCount) return;
      const n = new th(t.document),
        i = function (t, e) {
          const n = e.createRangeIn(t),
            i = new os({
              name: /v:(.+)/
            }),
            o = [];
          for (const t of n) {
            if ("elementStart" != t.type) continue;
            const e = t.item,
              n = e.previousSibling,
              r = n && n.is("element") ? n.name : null,
              s = ["Chart"],
              a = i.match(e),
              l = e.getAttribute("o:gfxdata"),
              c = "v:shapetype" === r,
              d = l && s.some(t => e.getAttribute("id").includes(t));
            a && l && !c && !d && o.push(t.item.getAttribute("id"));
          }
          return o;
        }(t, n);
      !function (t, e, n) {
        const i = n.createRangeIn(e),
          o = new os({
            name: "img"
          }),
          r = [];
        for (const e of i) if (e.item.is("element") && o.match(e.item)) {
          const n = e.item,
            i = n.getAttribute("v:shapes") ? n.getAttribute("v:shapes").split(" ") : [];
          i.length && i.every(e => t.indexOf(e) > -1) ? r.push(n) : n.getAttribute("src") || r.push(n);
        }
        for (const t of r) n.remove(t);
      }(i, t, n), function (t, e, n) {
        const i = n.createRangeIn(e),
          o = [];
        for (const e of i) if ("elementStart" == e.type && e.item.is("element", "v:shape")) {
          const n = e.item.getAttribute("id");
          if (t.includes(n)) continue;
          r(e.item.parent.getChildren(), n) || o.push(e.item);
        }
        for (const t of o) {
          const e = {
            src: s(t)
          };
          t.hasAttribute("alt") && (e.alt = t.getAttribute("alt"));
          const i = n.createElement("img", e);
          n.insertChild(t.index + 1, i, t.parent);
        }
        function r(t, e) {
          for (const n of t) if (n.is("element")) {
            if ("img" == n.name && n.getAttribute("v:shapes") == e) return !0;
            if (r(n.getChildren(), e)) return !0;
          }
          return !1;
        }
        function s(t) {
          for (const e of t.getChildren()) if (e.is("element") && e.getAttribute("src")) return e.getAttribute("src");
        }
      }(i, t, n), function (t, e) {
        const n = e.createRangeIn(t),
          i = new os({
            name: /v:(.+)/
          }),
          o = [];
        for (const t of n) "elementStart" == t.type && i.match(t.item) && o.push(t.item);
        for (const t of o) e.remove(t);
      }(t, n);
      const o = function (t, e) {
        const n = e.createRangeIn(t),
          i = new os({
            name: "img"
          }),
          o = [];
        for (const t of n) t.item.is("element") && i.match(t.item) && t.item.getAttribute("src").startsWith("file://") && o.push(t.item);
        return o;
      }(t, n);
      o.length && function (t, e, n) {
        if (t.length === e.length) for (let i = 0; i < t.length; i++) {
          const o = `data:${e[i].type};base64,${kI(e[i].hex)}`;
          n.setAttribute("src", o, t[i]);
        }
      }(o, function (t) {
        if (!t) return [];
        const e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
          n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
          i = t.match(n),
          o = [];
        if (i) for (const t of i) {
          let n = !1;
          t.includes("\\pngblip") ? n = "image/png" : t.includes("\\jpegblip") && (n = "image/jpeg"), n && o.push({
            hex: t.replace(e, "").replace(/[^\da-fA-F]/g, ""),
            type: n
          });
        }
        return o;
      }(e), n);
    }
    function kI(t) {
      return btoa(t.match(/\w{2}/g).map(t => String.fromCharCode(parseInt(t, 16))).join(""));
    }
    const bI = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
      wI = /xmlns:o="urn:schemas-microsoft-com/i;
    class AI {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        this.document = t, this.hasMultiLevelListPlugin = e;
      }
      isActive(t) {
        return bI.test(t) || wI.test(t);
      }
      execute(t) {
        const {
          body: e,
          stylesString: n
        } = t._parsedData;
        aI(e, n, this.hasMultiLevelListPlugin), fI(e, t.dataTransfer.getData("text/rtf")), function (t) {
          const e = [],
            n = new th(t.document);
          for (const {
            item: i
          } of n.createRangeIn(t)) if (i.is("element")) {
            for (const t of i.getClassNames()) /\bmso/gi.exec(t) && n.removeClass(t, i);
            for (const t of i.getStyleNames()) /\bmso/gi.exec(t) && n.removeStyle(t, i);
            (i.is("element", "w:sdt") || i.is("element", "w:sdtpr") && i.isEmpty || i.is("element", "o:p") && i.isEmpty) && e.push(i);
          }
          for (const t of e) {
            const e = t.parent,
              i = e.getChildIndex(t);
            n.insertChild(i, t.getChildren(), e), n.remove(t);
          }
        }(e), t.content = e;
      }
    }
    function CI(t, e, n, _ref198) {
      let {
        blockElements: i,
        inlineObjectElements: o
      } = _ref198;
      let r = n.createPositionAt(t, "forward" == e ? "after" : "before");
      return r = r.getLastMatchingPosition(_ref199 => {
        let {
          item: t
        } = _ref199;
        return t.is("element") && !i.includes(t.name) && !o.includes(t.name);
      }, {
        direction: e
      }), "forward" == e ? r.nodeAfter : r.nodeBefore;
    }
    function _I(t, e) {
      return !!t && t.is("element") && e.includes(t.name);
    }
    const vI = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    class yI {
      constructor(t) {
        this.document = t;
      }
      isActive(t) {
        return vI.test(t);
      }
      execute(t) {
        const e = new th(this.document),
          {
            body: n
          } = t._parsedData;
        !function (t, e) {
          for (const n of t.getChildren()) if (n.is("element", "b") && "normal" === n.getStyle("font-weight")) {
            const i = t.getChildIndex(n);
            e.remove(n), e.insertChild(i, n.getChildren(), t);
          }
        }(n, e), function (t, e) {
          for (const n of e.createRangeIn(t)) {
            const t = n.item;
            if (t.is("element", "li")) {
              const n = t.getChild(0);
              n && n.is("element", "p") && e.unwrapElement(n);
            }
          }
        }(n, e), function (t, e) {
          const n = new oa(e.document.stylesProcessor),
            i = new Ya(n, {
              renderingMode: "data"
            }),
            o = i.blockElements,
            r = i.inlineObjectElements,
            s = [];
          for (const n of e.createRangeIn(t)) {
            const t = n.item;
            if (t.is("element", "br")) {
              const n = CI(t, "forward", e, {
                  blockElements: o,
                  inlineObjectElements: r
                }),
                i = CI(t, "backward", e, {
                  blockElements: o,
                  inlineObjectElements: r
                }),
                a = _I(n, o);
              (_I(i, o) || a) && s.push(t);
            }
          }
          for (const t of s) t.hasClass("Apple-interchange-newline") ? e.remove(t) : e.replace(t, e.createElement("p"));
        }(n, e), t.content = n;
      }
    }
    const xI = /<google-sheets-html-origin/i;
    class EI {
      constructor(t) {
        this.document = t;
      }
      isActive(t) {
        return xI.test(t);
      }
      execute(t) {
        const e = new th(this.document),
          {
            body: n
          } = t._parsedData;
        !function (t, e) {
          for (const n of t.getChildren()) if (n.is("element", "google-sheets-html-origin")) {
            const i = t.getChildIndex(n);
            e.remove(n), e.insertChild(i, n.getChildren(), t);
          }
        }(n, e), function (t, e) {
          for (const n of t.getChildren()) n.is("element", "table") && n.hasAttribute("xmlns") && e.removeAttribute("xmlns", n);
        }(n, e), function (t, e) {
          for (const n of t.getChildren()) n.is("element", "table") && "0px" === n.getStyle("width") && e.removeStyle("width", n);
        }(n, e), function (t, e) {
          for (const n of Array.from(t.getChildren())) n.is("element", "style") && e.remove(n);
        }(n, e), t.content = n;
      }
    }
    function DI(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, e) => 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length));
    }
    function BI(t, e) {
      const n = new DOMParser(),
        i = function (t) {
          return DI(DI(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/(<span\s+style=['"]letter-spacing:[^'"]+?['"]>)[\r\n]+(<\/span>)/g, "$1 $2").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (t) {
          const e = "</body>",
            n = "</html>",
            i = t.indexOf(e);
          if (i < 0) return t;
          const o = t.indexOf(n, i + e.length);
          return t.substring(0, i + e.length) + (o >= 0 ? t.substring(o) : "");
        }(t = (t = t.replace(/<!--\[if gte vml 1]>/g, "")).replace(/<o:SmartTagType(?:\s+[^\s>=]+(?:="[^"]*")?)*\s*\/?>/gi, ""))),
        o = n.parseFromString(i, "text/html");
      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(t => {
          const e = t,
            n = e.innerText.length || 0;
          e.innerText = Array(n + 1).join("  ").substr(0, n);
        });
      }(o);
      const r = o.body.innerHTML,
        s = function (t, e) {
          const n = new oa(e),
            i = new Ya(n, {
              renderingMode: "data"
            }),
            o = t.createDocumentFragment(),
            r = t.body.childNodes;
          for (; r.length > 0;) o.appendChild(r[0]);
          return i.domToView(o, {
            skipComments: !0
          });
        }(o, e),
        a = function (t) {
          const e = [],
            n = [],
            i = Array.from(t.getElementsByTagName("style"));
          for (const t of i) t.sheet && t.sheet.cssRules && t.sheet.cssRules.length && (e.push(t.sheet), n.push(t.innerHTML));
          return {
            styles: e,
            stylesString: n.join(" ")
          };
        }(o);
      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    const SI = "removeFormat";
    class TI extends Nr {
      static get pluginName() {
        return "RemoveFormatUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add(SI, () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0
          }), t;
        }), t.ui.componentFactory.add(`menuBar:${SI}`, () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get(SI),
          o = new t(e.locale),
          r = n.t;
        return o.set({
          label: r("Remove Format"),
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.69 14.915c.053.052.173.083.36.093a.366.366 0 0 1 .345.485l-.003.01a.738.738 0 0 1-.697.497h-2.67a.374.374 0 0 1-.353-.496l.013-.038a.681.681 0 0 1 .644-.458c.197-.012.325-.043.386-.093a.28.28 0 0 0 .072-.11L9.592 4.5H6.269c-.359-.017-.609.013-.75.09-.142.078-.289.265-.442.563-.192.29-.516.464-.864.464H4.17a.43.43 0 0 1-.407-.569L4.46 3h13.08l-.62 2.043a.81.81 0 0 1-.775.574h-.114a.486.486 0 0 1-.486-.486c.001-.284-.054-.464-.167-.54-.112-.076-.367-.106-.766-.091h-3.28l-2.68 10.257c-.006.074.007.127.038.158zM3 17h8a.5.5 0 1 1 0 1H3a.5.5 0 1 1 0-1zm11.299 1.17a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.06-1.06l1.415 1.414 1.414-1.415a.75.75 0 1 1 1.06 1.06l-1.413 1.415 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414-1.414 1.414z"/></svg>'
        }), o.bind("isEnabled").to(i, "isEnabled"), this.listenTo(o, "execute", () => {
          e.execute(SI), e.editing.view.focus();
        }), o;
      }
    }
    class II extends Pr {
      refresh() {
        const t = this.editor.model;
        this.isEnabled = !!$o(this._getFormattingItems(t.document.selection, t.schema));
      }
      execute() {
        const t = this.editor.model,
          e = t.schema;
        t.change(n => {
          for (const i of this._getFormattingItems(t.document.selection, e)) if (i.is("selection")) for (const t of this._getFormattingAttributes(i, e)) n.removeSelectionAttribute(t);else {
            const t = n.createRangeOn(i);
            for (const o of this._getFormattingAttributes(i, e)) n.removeAttribute(o, t);
          }
        });
      }
      *_getFormattingItems(t, e) {
        const n = t => !!$o(this._getFormattingAttributes(t, e));
        for (const i of t.getRanges()) for (const t of i.getItems()) !e.isBlock(t) && n(t) && (yield t);
        for (const e of t.getSelectedBlocks()) n(e) && (yield e);
        n(t) && (yield t);
      }
      *_getFormattingAttributes(t, e) {
        for (const [n] of t.getAttributes()) {
          const t = e.getAttributeProperties(n);
          t && t.isFormatting && (yield n);
        }
      }
    }
    class MI extends Nr {
      static get pluginName() {
        return "RemoveFormatEditing";
      }
      init() {
        const t = this.editor;
        t.commands.add("removeFormat", new II(t));
      }
    }
    class LI extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1, this.value = !1;
      }
      execute() {
        const t = "ck-show-blocks",
          e = this.editor.editing.view;
        e.change(n => {
          for (const i of e.document.roots) i.hasClass(t) ? (n.removeClass(t, i), this.value = !1) : (n.addClass(t, i), this.value = !0);
        });
      }
    }
    class NI extends Nr {
      static get pluginName() {
        return "ShowBlocksEditing";
      }
      init() {
        const {
          editor: t
        } = this;
        t.commands.add("showBlocks", new LI(t));
      }
    }
    var zI = o(4975),
      PI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(zI.A, PI);
    zI.A.locals;
    class VI extends Nr {
      static get pluginName() {
        return "ShowBlocksUI";
      }
      init() {
        const t = this.editor;
        t.ui.componentFactory.add("showBlocks", () => {
          const t = this._createButton(mm);
          return t.set({
            tooltip: !0,
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m6.395 9.196 2.545-.007V6.498a.598.598 0 0 1 .598-.598h.299a.598.598 0 0 1 .598.598v6.877a.598.598 0 0 1-.598.598h-.299a.598.598 0 0 1-.598-.598v-2.691l-2.545.007v2.691a.598.598 0 0 1-.598.598h-.299a.598.598 0 0 1-.598-.598V6.505a.598.598 0 0 1 .598-.598h.299a.598.598 0 0 1 .598.598v2.691Z"/><path d="M15.094 13.417V6.462a.562.562 0 0 0-.562-.562h-.782a1 1 0 0 0-.39.08l-1.017.43a.562.562 0 0 0-.343.517v.197c0 .4.406.67.775.519l.819-.337v6.111c0 .31.251.562.561.562h.377c.31 0 .562-.251.562-.562Z"/><path d="M0 15.417v1.5h1.5v-1.5H0Z"/><path d="M18.5 15.417v1.5H20v-1.5h-1.5Z"/><path d="M18.5 12.333v1.5H20v-1.5h-1.5Z"/><path d="M18.5 9.25v1.5H20v-1.5h-1.5Z"/><path d="M18.5 6.167v1.5H20v-1.5h-1.5Z"/><path d="M0 18.5v.5a1 1 0 0 0 1 1h.5v-1.5H0Z"/><path d="M3.083 18.5V20h1.5v-1.5h-1.5Z"/><path d="M6.167 18.5V20h1.5v-1.5h-1.5Z"/><path d="M9.25 18.5V20h1.5v-1.5h-1.5Z"/><path d="M12.333 18.5V20h1.5v-1.5h-1.5Z"/><path d="M15.417 18.5V20h1.5v-1.5h-1.5Z"/><path d="M18.5 18.5V20h.5a1 1 0 0 0 1-1v-.5h-1.5Z"/><path clip-rule="evenodd" d="M0 1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.583h-1.5V1.5h-17v12.333H0V1Z"/></svg>'
          }), t;
        }), t.ui.componentFactory.add("menuBar:showBlocks", () => this._createButton(Uk));
      }
      _createButton(t) {
        const e = this.editor,
          n = e.locale,
          i = e.commands.get("showBlocks"),
          o = new t(n),
          r = n.t;
        return o.set({
          label: r("Show blocks")
        }), o.bind("isEnabled").to(i), o.bind("isOn").to(i, "value", i, "isEnabled", (t, e) => t && e), this.listenTo(o, "execute", () => {
          e.execute("showBlocks"), e.editing.view.focus();
        }), o;
      }
    }
    function RI(t) {
      const e = [{
          name: "address",
          isVoid: !1
        }, {
          name: "article",
          isVoid: !1
        }, {
          name: "aside",
          isVoid: !1
        }, {
          name: "blockquote",
          isVoid: !1
        }, {
          name: "details",
          isVoid: !1
        }, {
          name: "dialog",
          isVoid: !1
        }, {
          name: "dd",
          isVoid: !1
        }, {
          name: "div",
          isVoid: !1
        }, {
          name: "dl",
          isVoid: !1
        }, {
          name: "dt",
          isVoid: !1
        }, {
          name: "fieldset",
          isVoid: !1
        }, {
          name: "figcaption",
          isVoid: !1
        }, {
          name: "figure",
          isVoid: !1
        }, {
          name: "footer",
          isVoid: !1
        }, {
          name: "form",
          isVoid: !1
        }, {
          name: "h1",
          isVoid: !1
        }, {
          name: "h2",
          isVoid: !1
        }, {
          name: "h3",
          isVoid: !1
        }, {
          name: "h4",
          isVoid: !1
        }, {
          name: "h5",
          isVoid: !1
        }, {
          name: "h6",
          isVoid: !1
        }, {
          name: "header",
          isVoid: !1
        }, {
          name: "hgroup",
          isVoid: !1
        }, {
          name: "hr",
          isVoid: !0
        }, {
          name: "li",
          isVoid: !1
        }, {
          name: "main",
          isVoid: !1
        }, {
          name: "nav",
          isVoid: !1
        }, {
          name: "ol",
          isVoid: !1
        }, {
          name: "p",
          isVoid: !1
        }, {
          name: "section",
          isVoid: !1
        }, {
          name: "table",
          isVoid: !1
        }, {
          name: "tbody",
          isVoid: !1
        }, {
          name: "td",
          isVoid: !1
        }, {
          name: "th",
          isVoid: !1
        }, {
          name: "thead",
          isVoid: !1
        }, {
          name: "tr",
          isVoid: !1
        }, {
          name: "ul",
          isVoid: !1
        }],
        n = e.map(t => t.name).join("|"),
        i = t.replace(new RegExp(`</?(${n})( .*?)?>`, "g"), "\n$&\n").replace(/<br[^>]*>/g, "$&\n").split("\n");
      let o = 0,
        r = !1;
      return i.filter(t => t.length).map(t => (r = function (t, e) {
        return new RegExp("<pre( .*?)?>").test(t) ? "first" : new RegExp("</pre>").test(t) ? "last" : ("first" === e || "middle" === e) && "middle";
      }(t, r), function (t, e) {
        return e.some(e => !e.isVoid && !!new RegExp(`<${e.name}( .*?)?>`).test(t));
      }(t, e) ? FI(t, o++) : function (t, e) {
        return e.some(e => new RegExp(`</${e.name}>`).test(t));
      }(t, e) ? FI(t, --o) : "middle" === r || "last" === r ? t : FI(t, o))).join("\n");
    }
    function FI(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "    ";
      return `${n.repeat(Math.max(0, e))}${t}`;
    }
    var OI = o(9227),
      jI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(OI.A, jI);
    OI.A.locals;
    const HI = "SourceEditingMode";
    function UI(t) {
      return function (t) {
        return t.startsWith("<");
      }(t) ? RI(t) : t;
    }
    class qI extends Ip {
      constructor(t, e) {
        super(t);
        const n = t.t;
        this.set("class", "ck-special-characters-navigation"), this.groupDropdownView = this._createGroupDropdown(e), this.groupDropdownView.panelPosition = "rtl" === t.uiLanguageDirection ? "se" : "sw", this.label = n("Special characters"), this.children.add(this.groupDropdownView);
      }
      get currentGroupName() {
        return this.groupDropdownView.value;
      }
      focus() {
        this.groupDropdownView.focus();
      }
      _createGroupDropdown(t) {
        const e = this.locale,
          n = e.t,
          i = Eg(e),
          o = this._getCharacterGroupListItemDefinitions(i, t),
          r = n("Character categories");
        return i.set("value", o.first.model.name), i.buttonView.bind("label").to(i, "value", e => t.get(e)), i.buttonView.set({
          isOn: !1,
          withText: !0,
          tooltip: r,
          class: ["ck-dropdown__button_label-width_auto"],
          ariaLabel: r,
          ariaLabelledBy: void 0
        }), i.on("execute", t => {
          i.value = t.source.name;
        }), i.delegate("execute").to(this), Sg(i, o, {
          ariaLabel: r,
          role: "menu"
        }), i;
      }
      _getCharacterGroupListItemDefinitions(t, e) {
        const n = new Wo();
        for (const [i, o] of e) {
          const e = new Mf({
            name: i,
            label: o,
            withText: !0,
            role: "menuitemradio"
          });
          e.bind("isOn").to(t, "value", t => t === e.name), n.add({
            type: "button",
            model: e
          });
        }
        return n;
      }
    }
    var GI = o(2221),
      WI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(GI.A, WI);
    GI.A.locals;
    class $I extends Sr {
      constructor(t) {
        super(t), this.tiles = this.createCollection(), this.setTemplate({
          tag: "div",
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-character-grid__tiles"]
            },
            children: this.tiles
          }],
          attributes: {
            class: ["ck", "ck-character-grid"]
          }
        }), this.focusTracker = new Ko(), this.keystrokes = new Yo(), Lr({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.tiles,
          numberOfColumns: () => e.window.getComputedStyle(this.element.firstChild).getPropertyValue("grid-template-columns").split(" ").length,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
      }
      createTile(t, e) {
        const n = new mm(this.locale);
        return n.set({
          label: t,
          withText: !0,
          class: "ck-character-grid__tile"
        }), n.extendTemplate({
          attributes: {
            title: e
          },
          on: {
            mouseover: n.bindTemplate.to("mouseover"),
            focus: n.bindTemplate.to("focus")
          }
        }), n.on("mouseover", () => {
          this.fire("tileHover", {
            name: e,
            character: t
          });
        }), n.on("focus", () => {
          this.fire("tileFocus", {
            name: e,
            character: t
          });
        }), n.on("execute", () => {
          this.fire("execute", {
            name: e,
            character: t
          });
        }), n;
      }
      render() {
        super.render();
        for (const t of this.tiles) this.focusTracker.add(t.element);
        this.tiles.on("change", (t, _ref200) => {
          let {
            added: e,
            removed: n
          } = _ref200;
          if (e.length > 0) for (const t of e) this.focusTracker.add(t.element);
          if (n.length > 0) for (const t of n) this.focusTracker.remove(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this.tiles.first.focus();
      }
    }
    var KI = o(3445),
      YI = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(KI.A, YI);
    KI.A.locals;
    class QI extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.set("character", null), this.set("name", null), this.bind("code").to(this, "character", ZI), this.setTemplate({
          tag: "div",
          children: [{
            tag: "span",
            attributes: {
              class: ["ck-character-info__name"]
            },
            children: [{
              text: e.to("name", t => t || "​")
            }]
          }, {
            tag: "span",
            attributes: {
              class: ["ck-character-info__code"]
            },
            children: [{
              text: e.to("code")
            }]
          }],
          attributes: {
            class: ["ck", "ck-character-info"]
          }
        });
      }
    }
    function ZI(t) {
      if (null === t) return "";
      return "U+" + ("0000" + t.codePointAt(0).toString(16)).slice(-4);
    }
    class JI extends Sr {
      constructor(t, e, n, i) {
        super(t), this.navigationView = e, this.gridView = n, this.infoView = i, this.items = this.createCollection(), this.focusTracker = new Ko(), this.keystrokes = new Yo(), this._focusCycler = new tg({
          focusables: this.items,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          children: [this.navigationView, this.gridView, this.infoView],
          attributes: {
            tabindex: "-1"
          }
        }), this.items.add(this.navigationView.groupDropdownView.buttonView), this.items.add(this.gridView);
      }
      render() {
        super.render(), this.focusTracker.add(this.navigationView.groupDropdownView.buttonView.element), this.focusTracker.add(this.gridView.element), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this.navigationView.focus();
      }
    }
    var XI = o(7405),
      tM = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(XI.A, tM);
    XI.A.locals;
    const eM = "All";
    class nM extends Nr {
      static get pluginName() {
        return "SpecialCharactersArrows";
      }
      init() {
        const t = this.editor,
          e = t.t;
        t.plugins.get("SpecialCharacters").addItems("Arrows", [{
          title: e("leftwards simple arrow"),
          character: "←"
        }, {
          title: e("rightwards simple arrow"),
          character: "→"
        }, {
          title: e("upwards simple arrow"),
          character: "↑"
        }, {
          title: e("downwards simple arrow"),
          character: "↓"
        }, {
          title: e("leftwards double arrow"),
          character: "⇐"
        }, {
          title: e("rightwards double arrow"),
          character: "⇒"
        }, {
          title: e("upwards double arrow"),
          character: "⇑"
        }, {
          title: e("downwards double arrow"),
          character: "⇓"
        }, {
          title: e("leftwards dashed arrow"),
          character: "⇠"
        }, {
          title: e("rightwards dashed arrow"),
          character: "⇢"
        }, {
          title: e("upwards dashed arrow"),
          character: "⇡"
        }, {
          title: e("downwards dashed arrow"),
          character: "⇣"
        }, {
          title: e("leftwards arrow to bar"),
          character: "⇤"
        }, {
          title: e("rightwards arrow to bar"),
          character: "⇥"
        }, {
          title: e("upwards arrow to bar"),
          character: "⤒"
        }, {
          title: e("downwards arrow to bar"),
          character: "⤓"
        }, {
          title: e("up down arrow with base"),
          character: "↨"
        }, {
          title: e("back with leftwards arrow above"),
          character: "🔙"
        }, {
          title: e("end with leftwards arrow above"),
          character: "🔚"
        }, {
          title: e("on with exclamation mark with left right arrow above"),
          character: "🔛"
        }, {
          title: e("soon with rightwards arrow above"),
          character: "🔜"
        }, {
          title: e("top with upwards arrow above"),
          character: "🔝"
        }], {
          label: e("Arrows")
        });
      }
    }
    class iM extends Nr {
      static get pluginName() {
        return "SpecialCharactersText";
      }
      init() {
        const t = this.editor,
          e = t.t;
        t.plugins.get("SpecialCharacters").addItems("Text", [{
          character: "‹",
          title: e("Single left-pointing angle quotation mark")
        }, {
          character: "›",
          title: e("Single right-pointing angle quotation mark")
        }, {
          character: "«",
          title: e("Left-pointing double angle quotation mark")
        }, {
          character: "»",
          title: e("Right-pointing double angle quotation mark")
        }, {
          character: "‘",
          title: e("Left single quotation mark")
        }, {
          character: "’",
          title: e("Right single quotation mark")
        }, {
          character: "“",
          title: e("Left double quotation mark")
        }, {
          character: "”",
          title: e("Right double quotation mark")
        }, {
          character: "‚",
          title: e("Single low-9 quotation mark")
        }, {
          character: "„",
          title: e("Double low-9 quotation mark")
        }, {
          character: "¡",
          title: e("Inverted exclamation mark")
        }, {
          character: "¿",
          title: e("Inverted question mark")
        }, {
          character: "‥",
          title: e("Two dot leader")
        }, {
          character: "…",
          title: e("Horizontal ellipsis")
        }, {
          character: "‡",
          title: e("Double dagger")
        }, {
          character: "‰",
          title: e("Per mille sign")
        }, {
          character: "‱",
          title: e("Per ten thousand sign")
        }, {
          character: "‼",
          title: e("Double exclamation mark")
        }, {
          character: "⁈",
          title: e("Question exclamation mark")
        }, {
          character: "⁉",
          title: e("Exclamation question mark")
        }, {
          character: "⁇",
          title: e("Double question mark")
        }, {
          character: "©",
          title: e("Copyright sign")
        }, {
          character: "®",
          title: e("Registered sign")
        }, {
          character: "™",
          title: e("Trade mark sign")
        }, {
          character: "§",
          title: e("Section sign")
        }, {
          character: "¶",
          title: e("Paragraph sign")
        }, {
          character: "⁋",
          title: e("Reversed paragraph sign")
        }], {
          label: e("Text")
        });
      }
    }
    class oM extends Nr {
      static get pluginName() {
        return "SpecialCharactersMathematical";
      }
      init() {
        const t = this.editor,
          e = t.t;
        t.plugins.get("SpecialCharacters").addItems("Mathematical", [{
          character: "<",
          title: e("Less-than sign")
        }, {
          character: ">",
          title: e("Greater-than sign")
        }, {
          character: "≤",
          title: e("Less-than or equal to")
        }, {
          character: "≥",
          title: e("Greater-than or equal to")
        }, {
          character: "–",
          title: e("En dash")
        }, {
          character: "—",
          title: e("Em dash")
        }, {
          character: "¯",
          title: e("Macron")
        }, {
          character: "‾",
          title: e("Overline")
        }, {
          character: "°",
          title: e("Degree sign")
        }, {
          character: "−",
          title: e("Minus sign")
        }, {
          character: "±",
          title: e("Plus-minus sign")
        }, {
          character: "÷",
          title: e("Division sign")
        }, {
          character: "⁄",
          title: e("Fraction slash")
        }, {
          character: "×",
          title: e("Multiplication sign")
        }, {
          character: "ƒ",
          title: e("Latin small letter f with hook")
        }, {
          character: "∫",
          title: e("Integral")
        }, {
          character: "∑",
          title: e("N-ary summation")
        }, {
          character: "∞",
          title: e("Infinity")
        }, {
          character: "√",
          title: e("Square root")
        }, {
          character: "∼",
          title: e("Tilde operator")
        }, {
          character: "≅",
          title: e("Approximately equal to")
        }, {
          character: "≈",
          title: e("Almost equal to")
        }, {
          character: "≠",
          title: e("Not equal to")
        }, {
          character: "≡",
          title: e("Identical to")
        }, {
          character: "∈",
          title: e("Element of")
        }, {
          character: "∉",
          title: e("Not an element of")
        }, {
          character: "∋",
          title: e("Contains as member")
        }, {
          character: "∏",
          title: e("N-ary product")
        }, {
          character: "∧",
          title: e("Logical and")
        }, {
          character: "∨",
          title: e("Logical or")
        }, {
          character: "¬",
          title: e("Not sign")
        }, {
          character: "∩",
          title: e("Intersection")
        }, {
          character: "∪",
          title: e("Union")
        }, {
          character: "∂",
          title: e("Partial differential")
        }, {
          character: "∀",
          title: e("For all")
        }, {
          character: "∃",
          title: e("There exists")
        }, {
          character: "∅",
          title: e("Empty set")
        }, {
          character: "∇",
          title: e("Nabla")
        }, {
          character: "∗",
          title: e("Asterisk operator")
        }, {
          character: "∝",
          title: e("Proportional to")
        }, {
          character: "∠",
          title: e("Angle")
        }, {
          character: "¼",
          title: e("Vulgar fraction one quarter")
        }, {
          character: "½",
          title: e("Vulgar fraction one half")
        }, {
          character: "¾",
          title: e("Vulgar fraction three quarters")
        }], {
          label: e("Mathematical")
        });
      }
    }
    class rM extends Nr {
      static get pluginName() {
        return "SpecialCharactersLatin";
      }
      init() {
        const t = this.editor,
          e = t.t;
        t.plugins.get("SpecialCharacters").addItems("Latin", [{
          character: "Ā",
          title: e("Latin capital letter a with macron")
        }, {
          character: "ā",
          title: e("Latin small letter a with macron")
        }, {
          character: "Ă",
          title: e("Latin capital letter a with breve")
        }, {
          character: "ă",
          title: e("Latin small letter a with breve")
        }, {
          character: "Ą",
          title: e("Latin capital letter a with ogonek")
        }, {
          character: "ą",
          title: e("Latin small letter a with ogonek")
        }, {
          character: "Ć",
          title: e("Latin capital letter c with acute")
        }, {
          character: "ć",
          title: e("Latin small letter c with acute")
        }, {
          character: "Ĉ",
          title: e("Latin capital letter c with circumflex")
        }, {
          character: "ĉ",
          title: e("Latin small letter c with circumflex")
        }, {
          character: "Ċ",
          title: e("Latin capital letter c with dot above")
        }, {
          character: "ċ",
          title: e("Latin small letter c with dot above")
        }, {
          character: "Č",
          title: e("Latin capital letter c with caron")
        }, {
          character: "č",
          title: e("Latin small letter c with caron")
        }, {
          character: "Ď",
          title: e("Latin capital letter d with caron")
        }, {
          character: "ď",
          title: e("Latin small letter d with caron")
        }, {
          character: "Đ",
          title: e("Latin capital letter d with stroke")
        }, {
          character: "đ",
          title: e("Latin small letter d with stroke")
        }, {
          character: "Ē",
          title: e("Latin capital letter e with macron")
        }, {
          character: "ē",
          title: e("Latin small letter e with macron")
        }, {
          character: "Ĕ",
          title: e("Latin capital letter e with breve")
        }, {
          character: "ĕ",
          title: e("Latin small letter e with breve")
        }, {
          character: "Ė",
          title: e("Latin capital letter e with dot above")
        }, {
          character: "ė",
          title: e("Latin small letter e with dot above")
        }, {
          character: "Ę",
          title: e("Latin capital letter e with ogonek")
        }, {
          character: "ę",
          title: e("Latin small letter e with ogonek")
        }, {
          character: "Ě",
          title: e("Latin capital letter e with caron")
        }, {
          character: "ě",
          title: e("Latin small letter e with caron")
        }, {
          character: "Ĝ",
          title: e("Latin capital letter g with circumflex")
        }, {
          character: "ĝ",
          title: e("Latin small letter g with circumflex")
        }, {
          character: "Ğ",
          title: e("Latin capital letter g with breve")
        }, {
          character: "ğ",
          title: e("Latin small letter g with breve")
        }, {
          character: "Ġ",
          title: e("Latin capital letter g with dot above")
        }, {
          character: "ġ",
          title: e("Latin small letter g with dot above")
        }, {
          character: "Ģ",
          title: e("Latin capital letter g with cedilla")
        }, {
          character: "ģ",
          title: e("Latin small letter g with cedilla")
        }, {
          character: "Ĥ",
          title: e("Latin capital letter h with circumflex")
        }, {
          character: "ĥ",
          title: e("Latin small letter h with circumflex")
        }, {
          character: "Ħ",
          title: e("Latin capital letter h with stroke")
        }, {
          character: "ħ",
          title: e("Latin small letter h with stroke")
        }, {
          character: "Ĩ",
          title: e("Latin capital letter i with tilde")
        }, {
          character: "ĩ",
          title: e("Latin small letter i with tilde")
        }, {
          character: "Ī",
          title: e("Latin capital letter i with macron")
        }, {
          character: "ī",
          title: e("Latin small letter i with macron")
        }, {
          character: "Ĭ",
          title: e("Latin capital letter i with breve")
        }, {
          character: "ĭ",
          title: e("Latin small letter i with breve")
        }, {
          character: "Į",
          title: e("Latin capital letter i with ogonek")
        }, {
          character: "į",
          title: e("Latin small letter i with ogonek")
        }, {
          character: "İ",
          title: e("Latin capital letter i with dot above")
        }, {
          character: "ı",
          title: e("Latin small letter dotless i")
        }, {
          character: "Ĳ",
          title: e("Latin capital ligature ij")
        }, {
          character: "ĳ",
          title: e("Latin small ligature ij")
        }, {
          character: "Ĵ",
          title: e("Latin capital letter j with circumflex")
        }, {
          character: "ĵ",
          title: e("Latin small letter j with circumflex")
        }, {
          character: "Ķ",
          title: e("Latin capital letter k with cedilla")
        }, {
          character: "ķ",
          title: e("Latin small letter k with cedilla")
        }, {
          character: "ĸ",
          title: e("Latin small letter kra")
        }, {
          character: "Ĺ",
          title: e("Latin capital letter l with acute")
        }, {
          character: "ĺ",
          title: e("Latin small letter l with acute")
        }, {
          character: "Ļ",
          title: e("Latin capital letter l with cedilla")
        }, {
          character: "ļ",
          title: e("Latin small letter l with cedilla")
        }, {
          character: "Ľ",
          title: e("Latin capital letter l with caron")
        }, {
          character: "ľ",
          title: e("Latin small letter l with caron")
        }, {
          character: "Ŀ",
          title: e("Latin capital letter l with middle dot")
        }, {
          character: "ŀ",
          title: e("Latin small letter l with middle dot")
        }, {
          character: "Ł",
          title: e("Latin capital letter l with stroke")
        }, {
          character: "ł",
          title: e("Latin small letter l with stroke")
        }, {
          character: "Ń",
          title: e("Latin capital letter n with acute")
        }, {
          character: "ń",
          title: e("Latin small letter n with acute")
        }, {
          character: "Ņ",
          title: e("Latin capital letter n with cedilla")
        }, {
          character: "ņ",
          title: e("Latin small letter n with cedilla")
        }, {
          character: "Ň",
          title: e("Latin capital letter n with caron")
        }, {
          character: "ň",
          title: e("Latin small letter n with caron")
        }, {
          character: "ŉ",
          title: e("Latin small letter n preceded by apostrophe")
        }, {
          character: "Ŋ",
          title: e("Latin capital letter eng")
        }, {
          character: "ŋ",
          title: e("Latin small letter eng")
        }, {
          character: "Ō",
          title: e("Latin capital letter o with macron")
        }, {
          character: "ō",
          title: e("Latin small letter o with macron")
        }, {
          character: "Ŏ",
          title: e("Latin capital letter o with breve")
        }, {
          character: "ŏ",
          title: e("Latin small letter o with breve")
        }, {
          character: "Ő",
          title: e("Latin capital letter o with double acute")
        }, {
          character: "ő",
          title: e("Latin small letter o with double acute")
        }, {
          character: "Œ",
          title: e("Latin capital ligature oe")
        }, {
          character: "œ",
          title: e("Latin small ligature oe")
        }, {
          character: "Ŕ",
          title: e("Latin capital letter r with acute")
        }, {
          character: "ŕ",
          title: e("Latin small letter r with acute")
        }, {
          character: "Ŗ",
          title: e("Latin capital letter r with cedilla")
        }, {
          character: "ŗ",
          title: e("Latin small letter r with cedilla")
        }, {
          character: "Ř",
          title: e("Latin capital letter r with caron")
        }, {
          character: "ř",
          title: e("Latin small letter r with caron")
        }, {
          character: "Ś",
          title: e("Latin capital letter s with acute")
        }, {
          character: "ś",
          title: e("Latin small letter s with acute")
        }, {
          character: "Ŝ",
          title: e("Latin capital letter s with circumflex")
        }, {
          character: "ŝ",
          title: e("Latin small letter s with circumflex")
        }, {
          character: "Ş",
          title: e("Latin capital letter s with cedilla")
        }, {
          character: "ş",
          title: e("Latin small letter s with cedilla")
        }, {
          character: "Š",
          title: e("Latin capital letter s with caron")
        }, {
          character: "š",
          title: e("Latin small letter s with caron")
        }, {
          character: "Ţ",
          title: e("Latin capital letter t with cedilla")
        }, {
          character: "ţ",
          title: e("Latin small letter t with cedilla")
        }, {
          character: "Ť",
          title: e("Latin capital letter t with caron")
        }, {
          character: "ť",
          title: e("Latin small letter t with caron")
        }, {
          character: "Ŧ",
          title: e("Latin capital letter t with stroke")
        }, {
          character: "ŧ",
          title: e("Latin small letter t with stroke")
        }, {
          character: "Ũ",
          title: e("Latin capital letter u with tilde")
        }, {
          character: "ũ",
          title: e("Latin small letter u with tilde")
        }, {
          character: "Ū",
          title: e("Latin capital letter u with macron")
        }, {
          character: "ū",
          title: e("Latin small letter u with macron")
        }, {
          character: "Ŭ",
          title: e("Latin capital letter u with breve")
        }, {
          character: "ŭ",
          title: e("Latin small letter u with breve")
        }, {
          character: "Ů",
          title: e("Latin capital letter u with ring above")
        }, {
          character: "ů",
          title: e("Latin small letter u with ring above")
        }, {
          character: "Ű",
          title: e("Latin capital letter u with double acute")
        }, {
          character: "ű",
          title: e("Latin small letter u with double acute")
        }, {
          character: "Ų",
          title: e("Latin capital letter u with ogonek")
        }, {
          character: "ų",
          title: e("Latin small letter u with ogonek")
        }, {
          character: "Ŵ",
          title: e("Latin capital letter w with circumflex")
        }, {
          character: "ŵ",
          title: e("Latin small letter w with circumflex")
        }, {
          character: "Ŷ",
          title: e("Latin capital letter y with circumflex")
        }, {
          character: "ŷ",
          title: e("Latin small letter y with circumflex")
        }, {
          character: "Ÿ",
          title: e("Latin capital letter y with diaeresis")
        }, {
          character: "Ź",
          title: e("Latin capital letter z with acute")
        }, {
          character: "ź",
          title: e("Latin small letter z with acute")
        }, {
          character: "Ż",
          title: e("Latin capital letter z with dot above")
        }, {
          character: "ż",
          title: e("Latin small letter z with dot above")
        }, {
          character: "Ž",
          title: e("Latin capital letter z with caron")
        }, {
          character: "ž",
          title: e("Latin small letter z with caron")
        }, {
          character: "ſ",
          title: e("Latin small letter long s")
        }], {
          label: e("Latin")
        });
      }
    }
    class sM extends Nr {
      static get pluginName() {
        return "SpecialCharactersCurrency";
      }
      init() {
        const t = this.editor,
          e = t.t;
        t.plugins.get("SpecialCharacters").addItems("Currency", [{
          character: "$",
          title: e("Dollar sign")
        }, {
          character: "€",
          title: e("Euro sign")
        }, {
          character: "¥",
          title: e("Yen sign")
        }, {
          character: "£",
          title: e("Pound sign")
        }, {
          character: "¢",
          title: e("Cent sign")
        }, {
          character: "₠",
          title: e("Euro-currency sign")
        }, {
          character: "₡",
          title: e("Colon sign")
        }, {
          character: "₢",
          title: e("Cruzeiro sign")
        }, {
          character: "₣",
          title: e("French franc sign")
        }, {
          character: "₤",
          title: e("Lira sign")
        }, {
          character: "¤",
          title: e("Currency sign")
        }, {
          character: "₿",
          title: e("Bitcoin sign")
        }, {
          character: "₥",
          title: e("Mill sign")
        }, {
          character: "₦",
          title: e("Naira sign")
        }, {
          character: "₧",
          title: e("Peseta sign")
        }, {
          character: "₨",
          title: e("Rupee sign")
        }, {
          character: "₩",
          title: e("Won sign")
        }, {
          character: "₪",
          title: e("New sheqel sign")
        }, {
          character: "₫",
          title: e("Dong sign")
        }, {
          character: "₭",
          title: e("Kip sign")
        }, {
          character: "₮",
          title: e("Tugrik sign")
        }, {
          character: "₯",
          title: e("Drachma sign")
        }, {
          character: "₰",
          title: e("German penny sign")
        }, {
          character: "₱",
          title: e("Peso sign")
        }, {
          character: "₲",
          title: e("Guarani sign")
        }, {
          character: "₳",
          title: e("Austral sign")
        }, {
          character: "₴",
          title: e("Hryvnia sign")
        }, {
          character: "₵",
          title: e("Cedi sign")
        }, {
          character: "₶",
          title: e("Livre tournois sign")
        }, {
          character: "₷",
          title: e("Spesmilo sign")
        }, {
          character: "₸",
          title: e("Tenge sign")
        }, {
          character: "₹",
          title: e("Indian rupee sign")
        }, {
          character: "₺",
          title: e("Turkish lira sign")
        }, {
          character: "₻",
          title: e("Nordic mark sign")
        }, {
          character: "₼",
          title: e("Manat sign")
        }, {
          character: "₽",
          title: e("Ruble sign")
        }], {
          label: e("Currency")
        });
      }
    }
    function aM(t, e) {
      const {
        modelAttribute: n,
        styleName: i,
        viewElement: o,
        defaultValue: r,
        reduceBoxSides: s = !1,
        shouldUpcast: a = () => !0
      } = e;
      t.for("upcast").attributeToAttribute({
        view: {
          name: o,
          styles: {
            [i]: /[\s\S]+/
          }
        },
        model: {
          key: n,
          value: t => {
            if (!a(t)) return;
            const e = t.getNormalizedStyle(i),
              n = s ? uM(e) : e;
            return r !== n ? n : void 0;
          }
        }
      });
    }
    function lM(t, e, n, i) {
      t.for("upcast").add(t => t.on("element:" + e, (t, e, o) => {
        if (!e.modelRange) return;
        const r = ["border-top-width", "border-top-color", "border-top-style", "border-bottom-width", "border-bottom-color", "border-bottom-style", "border-right-width", "border-right-color", "border-right-style", "border-left-width", "border-left-color", "border-left-style"].filter(t => e.viewItem.hasStyle(t));
        if (!r.length) return;
        const s = {
          styles: r
        };
        if (!o.consumable.test(e.viewItem, s)) return;
        const a = [...e.modelRange.getItems({
          shallow: !0
        })].pop();
        o.consumable.consume(e.viewItem, s);
        const l = {
            style: e.viewItem.getNormalizedStyle("border-style"),
            color: e.viewItem.getNormalizedStyle("border-color"),
            width: e.viewItem.getNormalizedStyle("border-width")
          },
          c = {
            style: uM(l.style),
            color: uM(l.color),
            width: uM(l.width)
          };
        c.style !== i.style && o.writer.setAttribute(n.style, c.style, a), c.color !== i.color && o.writer.setAttribute(n.color, c.color, a), c.width !== i.width && o.writer.setAttribute(n.width, c.width, a);
      }));
    }
    function cM(t, e) {
      const {
        modelElement: n,
        modelAttribute: i,
        styleName: o
      } = e;
      t.for("downcast").attributeToAttribute({
        model: {
          name: n,
          key: i
        },
        view: t => ({
          key: "style",
          value: {
            [o]: t
          }
        })
      });
    }
    function dM(t, e) {
      const {
        modelAttribute: n,
        styleName: i
      } = e;
      t.for("downcast").add(t => t.on(`attribute:${n}:table`, (t, e, n) => {
        const {
            item: o,
            attributeNewValue: r
          } = e,
          {
            mapper: s,
            writer: a
          } = n;
        if (!n.consumable.consume(e.item, t.name)) return;
        const l = [...s.toViewElement(o).getChildren()].find(t => t.is("element", "table"));
        r ? a.setStyle(i, r, l) : a.removeStyle(i, l);
      }));
    }
    function uM(t) {
      if (!t) return;
      const e = ["top", "right", "bottom", "left"];
      if (!e.every(e => t[e])) return t;
      const n = t.top;
      return e.every(e => t[e] === n) ? n : t;
    }
    function hM(t, e, n, i) {
      let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      null != e && null != o && e > o ? i.setAttribute(t, e, n) : i.removeAttribute(t, n);
    }
    function mM(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const i = t.createElement("tableCell", n);
      return t.insertElement("paragraph", i), t.insert(i, e), i;
    }
    function gM(t, e) {
      const n = e.parent.parent,
        i = parseInt(n.getAttribute("headingColumns") || "0"),
        {
          column: o
        } = t.getCellLocation(e);
      return !!i && o < i;
    }
    function pM(t, e, n) {
      const {
        modelAttribute: i
      } = n;
      t.extend("tableCell", {
        allowAttributes: [i]
      }), aM(e, {
        viewElement: /^(td|th)$/,
        ...n
      }), cM(e, {
        modelElement: "tableCell",
        ...n
      });
    }
    function fM(t) {
      const e = t.getSelectedElement();
      return e && e.is("element", "table") ? e : t.getFirstPosition().findAncestor("table");
    }
    function kM() {
      return t => {
        t.on("element:table", (t, e, n) => {
          const i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;
          const {
              rows: o,
              headingRows: r,
              headingColumns: s
            } = function (t) {
              let e,
                n = 0;
              const i = [],
                o = [];
              let r;
              for (const s of Array.from(t.getChildren())) {
                if ("tbody" !== s.name && "thead" !== s.name && "tfoot" !== s.name) continue;
                "thead" !== s.name || r || (r = s);
                const t = Array.from(s.getChildren()).filter(t => t.is("element", "tr"));
                for (const a of t) if (r && s === r || "tbody" === s.name && Array.from(a.getChildren()).length && Array.from(a.getChildren()).every(t => t.is("element", "th"))) n++, i.push(a);else {
                  o.push(a);
                  const t = wM(a);
                  (!e || t < e) && (e = t);
                }
              }
              return {
                headingRows: n,
                headingColumns: e || 0,
                rows: [...i, ...o]
              };
            }(i),
            a = {};
          s && (a.headingColumns = s), r && (a.headingRows = r);
          const l = n.writer.createElement("table", a);
          if (n.safeInsert(l, e.modelCursor)) {
            if (n.consumable.consume(i, {
              name: !0
            }), o.forEach(t => n.convertItem(t, n.writer.createPositionAt(l, "end"))), n.convertChildren(i, n.writer.createPositionAt(l, "end")), l.isEmpty) {
              const t = n.writer.createElement("tableRow");
              n.writer.insert(t, n.writer.createPositionAt(l, "end")), mM(n.writer, n.writer.createPositionAt(t, "end"));
            }
            n.updateConversionResult(l, e);
          }
        });
      };
    }
    function bM(t) {
      return e => {
        e.on(`element:${t}`, (t, e, _ref201) => {
          let {
            writer: n
          } = _ref201;
          if (!e.modelRange) return;
          const i = e.modelRange.start.nodeAfter,
            o = n.createPositionAt(i, 0);
          if (e.viewItem.isEmpty) return void n.insertElement("paragraph", o);
          const r = Array.from(i.getChildren());
          if (r.every(t => t.is("element", "$marker"))) {
            const t = n.createElement("paragraph");
            n.insert(t, n.createPositionAt(i, 0));
            for (const e of r) n.move(n.createRangeOn(e), n.createPositionAt(t, "end"));
          }
        }, {
          priority: "low"
        });
      };
    }
    function wM(t) {
      let e = 0,
        n = 0;
      const i = Array.from(t.getChildren()).filter(t => "th" === t.name || "td" === t.name);
      for (; n < i.length && "th" === i[n].name;) {
        const t = i[n];
        e += parseInt(t.getAttribute("colspan") || "1"), n++;
      }
      return e;
    }
    class AM {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._jumpedToStartRow = !1, this._table = t, this._startRow = void 0 !== e.row ? e.row : e.startRow || 0, this._endRow = void 0 !== e.row ? e.row : e.endRow, this._startColumn = void 0 !== e.column ? e.column : e.startColumn || 0, this._endColumn = void 0 !== e.column ? e.column : e.endColumn, this._includeAllSlots = !!e.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }
      [Symbol.iterator]() {
        return this;
      }
      next() {
        this._canJumpToStartRow() && this._jumpToNonSpannedRowClosestToStartRow();
        const t = this._table.getChild(this._rowIndex);
        if (!t || this._isOverEndRow()) return {
          done: !0,
          value: void 0
        };
        if (!t.is("element", "tableRow")) return this._rowIndex++, this.next();
        if (this._isOverEndColumn()) return this._advanceToNextRow();
        let e = null;
        const n = this._getSpanned();
        if (n) this._includeAllSlots && !this._shouldSkipSlot() && (e = this._formatOutValue(n.cell, n.row, n.column));else {
          const n = t.getChild(this._cellIndex);
          if (!n) return this._advanceToNextRow();
          const i = parseInt(n.getAttribute("colspan") || "1"),
            o = parseInt(n.getAttribute("rowspan") || "1");
          (i > 1 || o > 1) && this._recordSpans(n, o, i), this._shouldSkipSlot() || (e = this._formatOutValue(n)), this._nextCellAtColumn = this._column + i;
        }
        return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, e || this.next();
      }
      skipRow(t) {
        this._skipRows.add(t);
      }
      _advanceToNextRow() {
        return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
      }
      _isOverEndRow() {
        return void 0 !== this._endRow && this._row > this._endRow;
      }
      _isOverEndColumn() {
        return void 0 !== this._endColumn && this._column > this._endColumn;
      }
      _formatOutValue(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
        return {
          done: !1,
          value: new CM(this, t, e, n)
        };
      }
      _shouldSkipSlot() {
        const t = this._skipRows.has(this._row),
          e = this._row < this._startRow,
          n = this._column < this._startColumn,
          i = void 0 !== this._endColumn && this._column > this._endColumn;
        return t || e || n || i;
      }
      _getSpanned() {
        const t = this._spannedCells.get(this._row);
        return t && t.get(this._column) || null;
      }
      _recordSpans(t, e, n) {
        const i = {
          cell: t,
          row: this._row,
          column: this._column
        };
        for (let t = this._row; t < this._row + e; t++) for (let e = this._column; e < this._column + n; e++) t == this._row && e == this._column || this._markSpannedCell(t, e, i);
      }
      _markSpannedCell(t, e, n) {
        this._spannedCells.has(t) || this._spannedCells.set(t, new Map());
        this._spannedCells.get(t).set(e, n);
      }
      _canJumpToStartRow() {
        return !!this._startRow && this._startRow > 0 && !this._jumpedToStartRow;
      }
      _jumpToNonSpannedRowClosestToStartRow() {
        const t = this._getRowLength(0);
        for (let e = this._startRow; !this._jumpedToStartRow; e--) t === this._getRowLength(e) && (this._row = e, this._rowIndex = e, this._jumpedToStartRow = !0);
      }
      _getRowLength(t) {
        return [...this._table.getChild(t).getChildren()].reduce((t, e) => t + parseInt(e.getAttribute("colspan") || "1"), 0);
      }
    }
    class CM {
      constructor(t, e, n, i) {
        this.cell = e, this.row = t._row, this.column = t._column, this.cellAnchorRow = n, this.cellAnchorColumn = i, this._cellIndex = t._cellIndex, this._rowIndex = t._rowIndex, this._table = t._table;
      }
      get isAnchor() {
        return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
      }
      get cellWidth() {
        return parseInt(this.cell.getAttribute("colspan") || "1");
      }
      get cellHeight() {
        return parseInt(this.cell.getAttribute("rowspan") || "1");
      }
      get rowIndex() {
        return this._rowIndex;
      }
      getPositionBefore() {
        return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
      }
    }
    function _M(t, e) {
      return (n, _ref202) => {
        let {
          writer: i
        } = _ref202;
        const o = n.getAttribute("headingRows") || 0,
          r = i.createContainerElement("table", null, []),
          s = i.createContainerElement("figure", {
            class: "table"
          }, r);
        o > 0 && i.insert(i.createPositionAt(r, "end"), i.createContainerElement("thead", null, i.createSlot(t => t.is("element", "tableRow") && t.index < o))), o < t.getRows(n) && i.insert(i.createPositionAt(r, "end"), i.createContainerElement("tbody", null, i.createSlot(t => t.is("element", "tableRow") && t.index >= o)));
        for (const {
          positionOffset: t,
          filter: n
        } of e.additionalSlots) i.insert(i.createPositionAt(r, t), i.createSlot(n));
        return i.insert(i.createPositionAt(r, "after"), i.createSlot(t => !t.is("element", "tableRow") && !e.additionalSlots.some(_ref203 => {
          let {
            filter: e
          } = _ref203;
          return e(t);
        }))), e.asWidget ? function (t, e) {
          return e.setCustomProperty("table", !0, t), Tw(t, e, {
            hasSelectionHandle: !0
          });
        }(s, i) : s;
      };
    }
    function vM() {
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (e, _ref204) => {
        let {
          writer: n
        } = _ref204;
        const i = e.parent,
          o = i.parent,
          r = o.getChildIndex(i),
          s = new AM(o, {
            row: r
          }),
          a = o.getAttribute("headingRows") || 0,
          l = o.getAttribute("headingColumns") || 0;
        let c = null;
        for (const i of s) if (i.cell == e) {
          const e = i.row < a || i.column < l ? "th" : "td";
          c = t.asWidget ? Nw(n.createEditableElement(e), n) : n.createContainerElement(e);
          break;
        }
        return c;
      };
    }
    function yM() {
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (e, _ref205) => {
        let {
          writer: n
        } = _ref205;
        if (!e.parent.is("element", "tableCell")) return null;
        if (!xM(e)) return null;
        if (t.asWidget) return n.createContainerElement("span", {
          class: "ck-table-bogus-paragraph"
        });
        {
          const t = n.createContainerElement("p");
          return n.setCustomProperty("dataPipeline:transparentRendering", !0, t), t;
        }
      };
    }
    function xM(t) {
      return 1 == t.parent.childCount && !!t.getAttributeKeys().next().done;
    }
    class EM extends Pr {
      refresh() {
        const t = this.editor.model,
          e = t.document.selection,
          n = t.schema;
        this.isEnabled = function (t, e) {
          const n = t.getFirstPosition().parent,
            i = n === n.root ? n : n.parent;
          return e.checkChild(i, "table");
        }(e, n);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor,
          n = e.model,
          i = e.plugins.get("TableUtils"),
          o = e.config.get("table.defaultHeadings.rows"),
          r = e.config.get("table.defaultHeadings.columns");
        void 0 === t.headingRows && o && (t.headingRows = o), void 0 === t.headingColumns && r && (t.headingColumns = r), n.change(e => {
          const o = i.createTable(e, t);
          n.insertObject(o, null, null, {
            findOptimalPosition: "auto"
          }), e.setSelection(e.createPositionAt(o.getNodeByPath([0, 0, 0]), 0));
        });
      }
    }
    class DM extends Pr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this.order = e.order || "below";
      }
      refresh() {
        const t = this.editor.model.document.selection,
          e = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
        this.isEnabled = e;
      }
      execute() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("TableUtils"),
          i = "above" === this.order,
          o = n.getSelectionAffectedTableCells(e),
          r = n.getRowIndexes(o),
          s = i ? r.first : r.last,
          a = o[0].findAncestor("table");
        n.insertRows(a, {
          at: i ? s : s + 1,
          copyStructureFromAbove: !i
        });
      }
    }
    class BM extends Pr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this.order = e.order || "right";
      }
      refresh() {
        const t = this.editor.model.document.selection,
          e = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
        this.isEnabled = e;
      }
      execute() {
        const t = this.editor,
          e = t.model.document.selection,
          n = t.plugins.get("TableUtils"),
          i = "left" === this.order,
          o = n.getSelectionAffectedTableCells(e),
          r = n.getColumnIndexes(o),
          s = i ? r.first : r.last,
          a = o[0].findAncestor("table");
        n.insertColumns(a, {
          columns: 1,
          at: i ? s : s + 1
        });
      }
    }
    class SM extends Pr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t), this.direction = e.direction || "horizontally";
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = 1 === t.length;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
        "horizontally" === this.direction ? t.splitCellHorizontally(e, 2) : t.splitCellVertically(e, 2);
      }
    }
    function TM(t, e, n) {
      const {
          startRow: i,
          startColumn: o,
          endRow: r,
          endColumn: s
        } = e,
        a = n.createElement("table"),
        l = r - i + 1;
      for (let t = 0; t < l; t++) n.insertElement("tableRow", a, "end");
      const c = [...new AM(t, {
        startRow: i,
        endRow: r,
        startColumn: o,
        endColumn: s,
        includeAllSlots: !0
      })];
      for (const {
        row: t,
        column: e,
        cell: l,
        isAnchor: d,
        cellAnchorRow: u,
        cellAnchorColumn: h
      } of c) {
        const c = t - i,
          m = a.getChild(c);
        if (d) {
          const i = n.cloneElement(l);
          n.append(i, m), zM(i, t, e, r, s, n);
        } else (u < i || h < o) && mM(n, n.createPositionAt(m, "end"));
      }
      return function (t, e, n, i, o) {
        const r = parseInt(e.getAttribute("headingRows") || "0");
        if (r > 0) {
          hM("headingRows", r - n, t, o, 0);
        }
        const s = parseInt(e.getAttribute("headingColumns") || "0");
        if (s > 0) {
          hM("headingColumns", s - i, t, o, 0);
        }
      }(a, t, i, o, n), a;
    }
    function IM(t, e) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      const i = [],
        o = new AM(t, {
          startRow: n,
          endRow: e - 1
        });
      for (const t of o) {
        const {
          row: n,
          cellHeight: o
        } = t;
        n < e && e <= n + o - 1 && i.push(t);
      }
      return i;
    }
    function MM(t, e, n) {
      const i = t.parent,
        o = i.parent,
        r = i.index,
        s = e - r,
        a = {},
        l = parseInt(t.getAttribute("rowspan")) - s;
      l > 1 && (a.rowspan = l);
      const c = parseInt(t.getAttribute("colspan") || "1");
      c > 1 && (a.colspan = c);
      const d = r + s,
        u = [...new AM(o, {
          startRow: r,
          endRow: d,
          includeAllSlots: !0
        })];
      let h,
        m = null;
      for (const e of u) {
        const {
          row: i,
          column: o,
          cell: r
        } = e;
        r === t && void 0 === h && (h = o), void 0 !== h && h === o && i === d && (m = mM(n, e.getPositionBefore(), a));
      }
      return hM("rowspan", s, t, n), m;
    }
    function LM(t, e) {
      const n = [],
        i = new AM(t);
      for (const t of i) {
        const {
          column: i,
          cellWidth: o
        } = t;
        i < e && e <= i + o - 1 && n.push(t);
      }
      return n;
    }
    function NM(t, e, n, i) {
      const o = n - e,
        r = {},
        s = parseInt(t.getAttribute("colspan")) - o;
      s > 1 && (r.colspan = s);
      const a = parseInt(t.getAttribute("rowspan") || "1");
      a > 1 && (r.rowspan = a);
      const l = mM(i, i.createPositionAfter(t), r);
      return hM("colspan", o, t, i), l;
    }
    function zM(t, e, n, i, o, r) {
      const s = parseInt(t.getAttribute("colspan") || "1"),
        a = parseInt(t.getAttribute("rowspan") || "1");
      if (n + s - 1 > o) {
        hM("colspan", o - n + 1, t, r, 1);
      }
      if (e + a - 1 > i) {
        hM("rowspan", i - e + 1, t, r, 1);
      }
    }
    function PM(t, e) {
      const n = e.getColumns(t),
        i = new Array(n).fill(0);
      for (const {
        column: e
      } of new AM(t)) i[e]++;
      const o = i.reduce((t, e, n) => e ? t : [...t, n], []);
      if (o.length > 0) {
        const n = o[o.length - 1];
        return e.removeColumns(t, {
          at: n
        }), !0;
      }
      return !1;
    }
    function VM(t, e) {
      const n = [],
        i = e.getRows(t);
      for (let e = 0; e < i; e++) {
        t.getChild(e).isEmpty && n.push(e);
      }
      if (n.length > 0) {
        const i = n[n.length - 1];
        return e.removeRows(t, {
          at: i
        }), !0;
      }
      return !1;
    }
    function RM(t, e) {
      PM(t, e) || VM(t, e);
    }
    function FM(t, e) {
      const n = Array.from(new AM(t, {
        startColumn: e.firstColumn,
        endColumn: e.lastColumn,
        row: e.lastRow
      }));
      if (n.every(_ref206 => {
        let {
          cellHeight: t
        } = _ref206;
        return 1 === t;
      })) return e.lastRow;
      const i = n[0].cellHeight - 1;
      return e.lastRow + i;
    }
    function OM(t, e) {
      const n = Array.from(new AM(t, {
        startRow: e.firstRow,
        endRow: e.lastRow,
        column: e.lastColumn
      }));
      if (n.every(_ref207 => {
        let {
          cellWidth: t
        } = _ref207;
        return 1 === t;
      })) return e.lastColumn;
      const i = n[0].cellWidth - 1;
      return e.lastColumn + i;
    }
    class jM extends Pr {
      constructor(t, e) {
        super(t), this.direction = e.direction, this.isHorizontal = "right" == this.direction || "left" == this.direction;
      }
      refresh() {
        const t = this._getMergeableCell();
        this.value = t, this.isEnabled = !!t;
      }
      execute() {
        const t = this.editor.model,
          e = t.document,
          n = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(e.selection)[0],
          i = this.value,
          o = this.direction;
        t.change(t => {
          const e = "right" == o || "down" == o,
            r = e ? n : i,
            s = e ? i : n,
            a = s.parent;
          !function (t, e, n) {
            HM(t) || (HM(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
            n.remove(t);
          }(s, r, t);
          const l = this.isHorizontal ? "colspan" : "rowspan",
            c = parseInt(n.getAttribute(l) || "1"),
            d = parseInt(i.getAttribute(l) || "1");
          t.setAttribute(l, c + d, r), t.setSelection(t.createRangeIn(r));
          const u = this.editor.plugins.get("TableUtils");
          RM(a.findAncestor("table"), u);
        });
      }
      _getMergeableCell() {
        const t = this.editor.model.document,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getTableCellsContainingSelection(t.selection)[0];
        if (!n) return;
        const i = this.isHorizontal ? function (t, e, n) {
          const i = t.parent,
            o = i.parent,
            r = "right" == e ? t.nextSibling : t.previousSibling,
            s = (o.getAttribute("headingColumns") || 0) > 0;
          if (!r) return;
          const a = "right" == e ? t : r,
            l = "right" == e ? r : t,
            {
              column: c
            } = n.getCellLocation(a),
            {
              column: d
            } = n.getCellLocation(l),
            u = parseInt(a.getAttribute("colspan") || "1"),
            h = gM(n, a),
            m = gM(n, l);
          if (s && h != m) return;
          return c + u === d ? r : void 0;
        }(n, this.direction, e) : function (t, e, n) {
          const i = t.parent,
            o = i.parent,
            r = o.getChildIndex(i);
          if ("down" == e && r === n.getRows(o) - 1 || "up" == e && 0 === r) return null;
          const s = parseInt(t.getAttribute("rowspan") || "1"),
            a = o.getAttribute("headingRows") || 0,
            l = "down" == e && r + s === a,
            c = "up" == e && r === a;
          if (a && (l || c)) return null;
          const d = parseInt(t.getAttribute("rowspan") || "1"),
            u = "down" == e ? r + d : r,
            h = [...new AM(o, {
              endRow: u
            })],
            m = h.find(e => e.cell === t),
            g = m.column,
            p = h.find(_ref208 => {
              let {
                row: t,
                cellHeight: n,
                column: i
              } = _ref208;
              return i === g && ("down" == e ? t === u : u === t + n);
            });
          return p && p.cell ? p.cell : null;
        }(n, this.direction, e);
        if (!i) return;
        const o = this.isHorizontal ? "rowspan" : "colspan",
          r = parseInt(n.getAttribute(o) || "1");
        return parseInt(i.getAttribute(o) || "1") === r ? i : void 0;
      }
    }
    function HM(t) {
      const e = t.getChild(0);
      return 1 == t.childCount && e.is("element", "paragraph") && e.isEmpty;
    }
    class UM extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = e[0];
        if (n) {
          const i = n.findAncestor("table"),
            o = t.getRows(i) - 1,
            r = t.getRowIndexes(e),
            s = 0 === r.first && r.last === o;
          this.isEnabled = !s;
        } else this.isEnabled = !1;
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          i = e.getRowIndexes(n),
          o = n[0],
          r = o.findAncestor("table"),
          s = e.getCellLocation(o).column;
        t.change(t => {
          const n = i.last - i.first + 1;
          e.removeRows(r, {
            at: i.first,
            rows: n
          });
          const o = function (t, e, n, i) {
            const o = t.getChild(Math.min(e, i - 1));
            let r = o.getChild(0),
              s = 0;
            for (const t of o.getChildren()) {
              if (s > n) return r;
              r = t, s += parseInt(t.getAttribute("colspan") || "1");
            }
            return r;
          }(r, i.first, s, e.getRows(r));
          t.setSelection(t.createPositionAt(o, 0));
        });
      }
    }
    class qM extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = t.getSelectionAffectedTableCells(this.editor.model.document.selection),
          n = e[0];
        if (n) {
          const i = n.findAncestor("table"),
            o = t.getColumns(i),
            {
              first: r,
              last: s
            } = t.getColumnIndexes(e);
          this.isEnabled = s - r < o - 1;
        } else this.isEnabled = !1;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          [e, n] = function (t, e) {
            const n = e.getSelectionAffectedTableCells(t),
              i = n[0],
              o = n.pop(),
              r = [i, o];
            return i.isBefore(o) ? r : r.reverse();
          }(this.editor.model.document.selection, t),
          i = e.parent.parent,
          o = [...new AM(i)],
          r = {
            first: o.find(t => t.cell === e).column,
            last: o.find(t => t.cell === n).column
          },
          s = function (t, e, n, i) {
            const o = parseInt(n.getAttribute("colspan") || "1");
            return o > 1 ? n : e.previousSibling || n.nextSibling ? n.nextSibling || e.previousSibling : i.first ? t.reverse().find(_ref209 => {
              let {
                column: t
              } = _ref209;
              return t < i.first;
            }).cell : t.reverse().find(_ref210 => {
              let {
                column: t
              } = _ref210;
              return t > i.last;
            }).cell;
          }(o, e, n, r);
        this.editor.model.change(e => {
          const n = r.last - r.first + 1;
          t.removeColumns(i, {
            at: r.first,
            columns: n
          }), e.setSelection(e.createPositionAt(s, 0));
        });
      }
    }
    class GM extends Pr {
      refresh() {
        const t = this.editor.plugins.get("TableUtils"),
          e = this.editor.model,
          n = t.getSelectionAffectedTableCells(e.document.selection),
          i = n.length > 0;
        this.isEnabled = i, this.value = i && n.every(t => this._isInHeading(t, t.parent.parent));
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (t.forceValue === this.value) return;
        const e = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          i = e.getSelectionAffectedTableCells(n.document.selection),
          o = i[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = e.getRowIndexes(i),
          a = this.value ? r : s + 1,
          l = o.getAttribute("headingRows") || 0;
        n.change(t => {
          if (a) {
            const e = IM(o, a, a > l ? l : 0);
            for (const {
              cell: n
            } of e) MM(n, a, t);
          }
          hM("headingRows", a, o, t, 0);
        });
      }
      _isInHeading(t, e) {
        const n = parseInt(e.getAttribute("headingRows") || "0");
        return !!n && t.parent.index < n;
      }
    }
    class WM extends Pr {
      refresh() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          i = n.length > 0;
        this.isEnabled = i, this.value = i && n.every(t => gM(e, t));
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (t.forceValue === this.value) return;
        const e = this.editor.plugins.get("TableUtils"),
          n = this.editor.model,
          i = e.getSelectionAffectedTableCells(n.document.selection),
          o = i[0].findAncestor("table"),
          {
            first: r,
            last: s
          } = e.getColumnIndexes(i),
          a = this.value ? r : s + 1;
        n.change(t => {
          if (a) {
            const e = LM(o, a);
            for (const {
              cell: n,
              column: i
            } of e) NM(n, i, a, t);
          }
          hM("headingColumns", a, o, t, 0);
        });
      }
    }
    function $M(t, e) {
      return 4e3 / KM(t, e);
    }
    function KM(t, e) {
      const n = YM(t, "tbody", e) || YM(t, "thead", e);
      return QM(e.editing.view.domConverter.mapViewToDom(n));
    }
    function YM(t, e, n) {
      return [...[...n.editing.mapper.toViewElement(t).getChildren()].find(t => t.is("element", "table")).getChildren()].find(t => t.is("element", e));
    }
    function QM(t) {
      const n = e.window.getComputedStyle(t);
      return "border-box" === n.boxSizing ? parseFloat(n.width) - parseFloat(n.paddingLeft) - parseFloat(n.paddingRight) - parseFloat(n.borderLeftWidth) - parseFloat(n.borderRightWidth) : parseFloat(n.width);
    }
    function ZM(t) {
      const e = Math.pow(10, 2),
        n = "number" == typeof t ? t : parseFloat(t);
      return Math.round(n * e) / e;
    }
    function JM(t, e) {
      return Array(t).fill(e);
    }
    function XM(t) {
      return t.map(t => "number" == typeof t ? t : parseFloat(t)).filter(t => !Number.isNaN(t)).reduce((t, e) => t + e, 0);
    }
    function tL(t) {
      let e = function (t) {
        const e = t.filter(t => "auto" === t).length;
        if (0 === e) return t.map(t => ZM(t));
        const n = XM(t),
          i = Math.max((100 - n) / e, 5);
        return t.map(t => "auto" === t ? i : t).map(t => ZM(t));
      }(t.map(t => "auto" === t ? t : parseFloat(t.replace("%", ""))));
      const n = XM(e);
      return 100 !== n && (e = e.map(t => ZM(100 * t / n)).map((t, e, n) => {
        if (!(e === n.length - 1)) return t;
        return ZM(t + 100 - XM(n));
      })), e.map(t => t + "%");
    }
    function eL(t) {
      const n = e.window.getComputedStyle(t);
      return "border-box" === n.boxSizing ? parseInt(n.width) : parseFloat(n.width) + parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderWidth);
    }
    function nL(t, e, n, i) {
      for (let o = 0; o < Math.max(n.length, t.length); o++) {
        const r = t[o],
          s = n[o];
        s ? r ? i.setAttribute("columnWidth", s, r) : i.appendElement("tableColumn", {
          columnWidth: s
        }, e) : i.remove(r);
      }
    }
    function iL(t) {
      if (t.is("element", "tableColumnGroup")) return t;
      const e = t.getChildren();
      return Array.from(e).find(t => t.is("element", "tableColumnGroup"));
    }
    function oL(t) {
      const e = iL(t);
      return e ? Array.from(e.getChildren()) : [];
    }
    class rL extends Nr {
      static get pluginName() {
        return "TableUtils";
      }
      init() {
        this.decorate("insertColumns"), this.decorate("insertRows");
      }
      getCellLocation(t) {
        const e = t.parent,
          n = e.parent,
          i = n.getChildIndex(e),
          o = new AM(n, {
            row: i
          });
        for (const {
          cell: e,
          row: n,
          column: i
        } of o) if (e === t) return {
          row: n,
          column: i
        };
      }
      createTable(t, e) {
        const n = t.createElement("table"),
          i = e.rows || 2,
          o = e.columns || 2;
        return sL(t, n, 0, i, o), e.headingRows && hM("headingRows", Math.min(e.headingRows, i), n, t, 0), e.headingColumns && hM("headingColumns", Math.min(e.headingColumns, o), n, t, 0), n;
      }
      insertRows(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = e.at || 0,
          o = e.rows || 1,
          r = void 0 !== e.copyStructureFromAbove,
          s = e.copyStructureFromAbove ? i - 1 : i,
          a = this.getRows(t),
          l = this.getColumns(t);
        if (i > a) throw new b("tableutils-insertrows-insert-out-of-range", this, {
          options: e
        });
        n.change(e => {
          const n = t.getAttribute("headingRows") || 0;
          if (n > i && hM("headingRows", n + o, t, e, 0), !r && (0 === i || i === a)) return void sL(e, t, i, o, l);
          const c = r ? Math.max(i, s) : i,
            d = new AM(t, {
              endRow: c
            }),
            u = new Array(l).fill(1);
          for (const {
            row: t,
            column: n,
            cellHeight: a,
            cellWidth: l,
            cell: c
          } of d) {
            const d = t + a - 1,
              h = t <= s && s <= d;
            t < i && i <= d ? (e.setAttribute("rowspan", a + o, c), u[n] = -l) : r && h && (u[n] = l);
          }
          for (let n = 0; n < o; n++) {
            const n = e.createElement("tableRow");
            e.insert(n, t, i);
            for (let t = 0; t < u.length; t++) {
              const i = u[t],
                o = e.createPositionAt(n, "end");
              i > 0 && mM(e, o, i > 1 ? {
                colspan: i
              } : void 0), t += Math.abs(i) - 1;
            }
          }
        });
      }
      insertColumns(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = this.editor.model,
          i = e.at || 0,
          o = e.columns || 1;
        n.change(e => {
          const n = t.getAttribute("headingColumns");
          i < n && e.setAttribute("headingColumns", n + o, t);
          const r = this.getColumns(t);
          if (0 === i || r === i) {
            for (const n of t.getChildren()) n.is("element", "tableRow") && aL(o, e, e.createPositionAt(n, i ? "end" : 0));
            return;
          }
          const s = new AM(t, {
            column: i,
            includeAllSlots: !0
          });
          for (const t of s) {
            const {
              row: n,
              cell: r,
              cellAnchorColumn: a,
              cellAnchorRow: l,
              cellWidth: c,
              cellHeight: d
            } = t;
            if (a < i) {
              e.setAttribute("colspan", c + o, r);
              const t = l + d - 1;
              for (let e = n; e <= t; e++) s.skipRow(e);
            } else aL(o, e, t.getPositionBefore());
          }
        });
      }
      removeRows(t, e) {
        const n = this.editor.model,
          i = e.rows || 1,
          o = this.getRows(t),
          r = e.at,
          s = r + i - 1;
        if (s > o - 1) throw new b("tableutils-removerows-row-index-out-of-range", this, {
          table: t,
          options: e
        });
        n.change(e => {
          const n = {
              first: r,
              last: s
            },
            {
              cellsToMove: i,
              cellsToTrim: o
            } = function (t, _ref211) {
              let {
                first: e,
                last: n
              } = _ref211;
              const i = new Map(),
                o = [];
              for (const {
                row: r,
                column: s,
                cellHeight: a,
                cell: l
              } of new AM(t, {
                endRow: n
              })) {
                const t = r + a - 1;
                if (r >= e && r <= n && t > n) {
                  const t = a - (n - r + 1);
                  i.set(s, {
                    cell: l,
                    rowspan: t
                  });
                }
                if (r < e && t >= e) {
                  let i;
                  i = t >= n ? n - e + 1 : t - e + 1, o.push({
                    cell: l,
                    rowspan: a - i
                  });
                }
              }
              return {
                cellsToMove: i,
                cellsToTrim: o
              };
            }(t, n);
          if (i.size) {
            !function (t, e, n, i) {
              const o = new AM(t, {
                  includeAllSlots: !0,
                  row: e
                }),
                r = [...o],
                s = t.getChild(e);
              let a;
              for (const {
                column: t,
                cell: e,
                isAnchor: o
              } of r) if (n.has(t)) {
                const {
                    cell: e,
                    rowspan: o
                  } = n.get(t),
                  r = a ? i.createPositionAfter(a) : i.createPositionAt(s, 0);
                i.move(i.createRangeOn(e), r), hM("rowspan", o, e, i), a = e;
              } else o && (a = e);
            }(t, s + 1, i, e);
          }
          for (let n = s; n >= r; n--) e.remove(t.getChild(n));
          for (const {
            rowspan: t,
            cell: n
          } of o) hM("rowspan", t, n, e);
          !function (t, _ref212, i) {
            let {
              first: e,
              last: n
            } = _ref212;
            const o = t.getAttribute("headingRows") || 0;
            if (e < o) {
              hM("headingRows", n < o ? o - (n - e + 1) : e, t, i, 0);
            }
          }(t, n, e), PM(t, this) || VM(t, this);
        });
      }
      removeColumns(t, e) {
        const n = this.editor.model,
          i = e.at,
          o = e.columns || 1,
          r = e.at + o - 1;
        n.change(e => {
          !function (t, e, n) {
            const i = t.getAttribute("headingColumns") || 0;
            if (i && e.first < i) {
              const o = Math.min(i - 1, e.last) - e.first + 1;
              n.setAttribute("headingColumns", i - o, t);
            }
          }(t, {
            first: i,
            last: r
          }, e);
          const n = oL(t);
          for (let o = r; o >= i; o--) {
            for (const {
              cell: n,
              column: i,
              cellWidth: r
            } of [...new AM(t)]) i <= o && r > 1 && i + r > o ? hM("colspan", r - 1, n, e) : i === o && e.remove(n);
            if (n[o]) {
              const t = 0 === o ? n[1] : n[o - 1],
                i = parseFloat(n[o].getAttribute("columnWidth")),
                r = parseFloat(t.getAttribute("columnWidth"));
              e.remove(n[o]), e.setAttribute("columnWidth", i + r + "%", t);
            }
          }
          VM(t, this) || PM(t, this);
        });
      }
      splitCellVertically(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        const n = this.editor.model,
          i = t.parent.parent,
          o = parseInt(t.getAttribute("rowspan") || "1"),
          r = parseInt(t.getAttribute("colspan") || "1");
        n.change(n => {
          if (r > 1) {
            const {
              newCellsSpan: i,
              updatedSpan: s
            } = lL(r, e);
            hM("colspan", s, t, n);
            const a = {};
            i > 1 && (a.colspan = i), o > 1 && (a.rowspan = o);
            aL(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), a);
          }
          if (r < e) {
            const s = e - r,
              a = [...new AM(i)],
              {
                column: l
              } = a.find(_ref213 => {
                let {
                  cell: e
                } = _ref213;
                return e === t;
              }),
              c = a.filter(_ref214 => {
                let {
                  cell: e,
                  cellWidth: n,
                  column: i
                } = _ref214;
                return e !== t && i === l || i < l && i + n > l;
              });
            for (const {
              cell: t,
              cellWidth: e
            } of c) n.setAttribute("colspan", e + s, t);
            const d = {};
            o > 1 && (d.rowspan = o), aL(s, n, n.createPositionAfter(t), d);
            const u = i.getAttribute("headingColumns") || 0;
            u > l && hM("headingColumns", u + s, i, n);
          }
        });
      }
      splitCellHorizontally(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        const n = this.editor.model,
          i = t.parent,
          o = i.parent,
          r = o.getChildIndex(i),
          s = parseInt(t.getAttribute("rowspan") || "1"),
          a = parseInt(t.getAttribute("colspan") || "1");
        n.change(n => {
          if (s > 1) {
            const i = [...new AM(o, {
                startRow: r,
                endRow: r + s - 1,
                includeAllSlots: !0
              })],
              {
                newCellsSpan: l,
                updatedSpan: c
              } = lL(s, e);
            hM("rowspan", c, t, n);
            const {
                column: d
              } = i.find(_ref215 => {
                let {
                  cell: e
                } = _ref215;
                return e === t;
              }),
              u = {};
            l > 1 && (u.rowspan = l), a > 1 && (u.colspan = a);
            for (const t of i) {
              const {
                column: e,
                row: i
              } = t;
              i >= r + c && e === d && (i + r + c) % l === 0 && aL(1, n, t.getPositionBefore(), u);
            }
          }
          if (s < e) {
            const i = e - s,
              l = [...new AM(o, {
                startRow: 0,
                endRow: r
              })];
            for (const {
              cell: e,
              cellHeight: o,
              row: s
            } of l) if (e !== t && s + o > r) {
              const t = o + i;
              n.setAttribute("rowspan", t, e);
            }
            const c = {};
            a > 1 && (c.colspan = a), sL(n, o, r + 1, i, 1, c);
            const d = o.getAttribute("headingRows") || 0;
            d > r && hM("headingRows", d + i, o, n);
          }
        });
      }
      getColumns(t) {
        return [...t.getChild(0).getChildren()].filter(t => t.is("element", "tableCell")).reduce((t, e) => t + parseInt(e.getAttribute("colspan") || "1"), 0);
      }
      getRows(t) {
        return Array.from(t.getChildren()).reduce((t, e) => e.is("element", "tableRow") ? t + 1 : t, 0);
      }
      createTableWalker(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new AM(t, e);
      }
      getSelectedTableCells(t) {
        const e = [];
        for (const n of this.sortRanges(t.getRanges())) {
          const t = n.getContainedElement();
          t && t.is("element", "tableCell") && e.push(t);
        }
        return e;
      }
      getTableCellsContainingSelection(t) {
        const e = [];
        for (const n of t.getRanges()) {
          const t = n.start.findAncestor("tableCell");
          t && e.push(t);
        }
        return e;
      }
      getSelectionAffectedTableCells(t) {
        const e = this.getSelectedTableCells(t);
        return e.length ? e : this.getTableCellsContainingSelection(t);
      }
      getRowIndexes(t) {
        const e = t.map(t => t.parent.index);
        return this._getFirstLastIndexesObject(e);
      }
      getColumnIndexes(t) {
        const e = t[0].findAncestor("table"),
          n = [...new AM(e)].filter(e => t.includes(e.cell)).map(t => t.column);
        return this._getFirstLastIndexesObject(n);
      }
      isSelectionRectangular(t) {
        if (t.length < 2 || !this._areCellInTheSameTableSection(t)) return !1;
        const e = new Set(),
          n = new Set();
        let i = 0;
        for (const o of t) {
          const {
              row: t,
              column: r
            } = this.getCellLocation(o),
            s = parseInt(o.getAttribute("rowspan")) || 1,
            a = parseInt(o.getAttribute("colspan")) || 1;
          e.add(t), n.add(r), s > 1 && e.add(t + s - 1), a > 1 && n.add(r + a - 1), i += s * a;
        }
        const o = function (t, e) {
          const n = Array.from(t.values()),
            i = Array.from(e.values()),
            o = Math.max(...n),
            r = Math.min(...n),
            s = Math.max(...i),
            a = Math.min(...i);
          return (o - r + 1) * (s - a + 1);
        }(e, n);
        return o == i;
      }
      sortRanges(t) {
        return Array.from(t).sort(cL);
      }
      _getFirstLastIndexesObject(t) {
        const e = t.sort((t, e) => t - e);
        return {
          first: e[0],
          last: e[e.length - 1]
        };
      }
      _areCellInTheSameTableSection(t) {
        const e = t[0].findAncestor("table"),
          n = this.getRowIndexes(t),
          i = parseInt(e.getAttribute("headingRows")) || 0;
        if (!this._areIndexesInSameSection(n, i)) return !1;
        const o = this.getColumnIndexes(t),
          r = parseInt(e.getAttribute("headingColumns")) || 0;
        return this._areIndexesInSameSection(o, r);
      }
      _areIndexesInSameSection(_ref216, n) {
        let {
          first: t,
          last: e
        } = _ref216;
        return t < n === e < n;
      }
    }
    function sL(t, e, n, i, o) {
      let r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      for (let s = 0; s < i; s++) {
        const i = t.createElement("tableRow");
        t.insert(i, e, n), aL(o, t, t.createPositionAt(i, "end"), r);
      }
    }
    function aL(t, e, n) {
      let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      for (let o = 0; o < t; o++) mM(e, n, i);
    }
    function lL(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      const n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }
    function cL(t, e) {
      const n = t.start,
        i = e.start;
      return n.isBefore(i) ? -1 : 1;
    }
    class dL extends Pr {
      refresh() {
        const t = this.editor.plugins.get(rL),
          e = t.getSelectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.isSelectionRectangular(e);
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get(rL);
        t.change(n => {
          const i = e.getSelectedTableCells(t.document.selection),
            o = i.shift(),
            {
              mergeWidth: r,
              mergeHeight: s
            } = function (t, e, n) {
              let i = 0,
                o = 0;
              for (const t of e) {
                const {
                  row: e,
                  column: r
                } = n.getCellLocation(t);
                i = mL(t, r, i, "colspan"), o = mL(t, e, o, "rowspan");
              }
              const {
                  row: r,
                  column: s
                } = n.getCellLocation(t),
                a = i - s,
                l = o - r;
              return {
                mergeWidth: a,
                mergeHeight: l
              };
            }(o, i, e);
          hM("colspan", r, o, n), hM("rowspan", s, o, n);
          for (const t of i) uL(t, o, n);
          RM(o.findAncestor("table"), e), n.setSelection(o, "in");
        });
      }
    }
    function uL(t, e, n) {
      hL(t) || (hL(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end"))), n.remove(t);
    }
    function hL(t) {
      const e = t.getChild(0);
      return 1 == t.childCount && e.is("element", "paragraph") && e.isEmpty;
    }
    function mL(t, e, n, i) {
      const o = parseInt(t.getAttribute(i) || "1");
      return Math.max(n, e + o);
    }
    class gL extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.length > 0;
      }
      execute() {
        const t = this.editor.model,
          e = this.editor.plugins.get("TableUtils"),
          n = e.getSelectionAffectedTableCells(t.document.selection),
          i = e.getRowIndexes(n),
          o = n[0].findAncestor("table"),
          r = [];
        for (let e = i.first; e <= i.last; e++) for (const n of o.getChild(e).getChildren()) r.push(t.createRangeOn(n));
        t.change(t => {
          t.setSelection(r);
        });
      }
    }
    class pL extends Pr {
      constructor(t) {
        super(t), this.affectsData = !1;
      }
      refresh() {
        const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
        this.isEnabled = t.length > 0;
      }
      execute() {
        const t = this.editor.plugins.get("TableUtils"),
          e = this.editor.model,
          n = t.getSelectionAffectedTableCells(e.document.selection),
          i = n[0],
          o = n.pop(),
          r = i.findAncestor("table"),
          s = t.getCellLocation(i),
          a = t.getCellLocation(o),
          l = Math.min(s.column, a.column),
          c = Math.max(s.column, a.column),
          d = [];
        for (const t of new AM(r, {
          startColumn: l,
          endColumn: c
        })) d.push(e.createRangeOn(t.cell));
        e.change(t => {
          t.setSelection(d);
        });
      }
    }
    function fL(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.differ.getChanges();
        let i = !1;
        const o = new Set();
        for (const e of n) {
          let n = null;
          "insert" == e.type && "table" == e.name && (n = e.position.nodeAfter), "insert" != e.type && "remove" != e.type || "tableRow" != e.name && "tableCell" != e.name || (n = e.position.findAncestor("table")), wL(e) && (n = e.range.start.findAncestor("table")), n && !o.has(n) && (i = kL(n, t) || i, i = bL(n, t) || i, o.add(n));
        }
        return i;
      }(e, t));
    }
    function kL(t, e) {
      let n = !1;
      const i = function (t) {
        const e = parseInt(t.getAttribute("headingRows") || "0"),
          n = Array.from(t.getChildren()).reduce((t, e) => e.is("element", "tableRow") ? t + 1 : t, 0),
          i = [];
        for (const {
          row: o,
          cell: r,
          cellHeight: s
        } of new AM(t)) {
          if (s < 2) continue;
          const t = o < e ? e : n;
          if (o + s > t) {
            const e = t - o;
            i.push({
              cell: r,
              rowspan: e
            });
          }
        }
        return i;
      }(t);
      if (i.length) {
        n = !0;
        for (const t of i) hM("rowspan", t.rowspan, t.cell, e, 1);
      }
      return n;
    }
    function bL(t, e) {
      let n = !1;
      const i = function (t) {
          const e = new Array(t.childCount).fill(0);
          for (const {
            rowIndex: n
          } of new AM(t, {
            includeAllSlots: !0
          })) e[n]++;
          return e;
        }(t),
        o = [];
      for (const [e, n] of i.entries()) !n && t.getChild(e).is("element", "tableRow") && o.push(e);
      if (o.length) {
        n = !0;
        for (const n of o.reverse()) e.remove(t.getChild(n)), i.splice(n, 1);
      }
      const r = i.filter((e, n) => t.getChild(n).is("element", "tableRow")),
        s = r[0];
      if (!r.every(t => t === s)) {
        const i = r.reduce((t, e) => e > t ? e : t, 0);
        for (const [o, s] of r.entries()) {
          const r = i - s;
          if (r) {
            for (let n = 0; n < r; n++) mM(e, e.createPositionAt(t.getChild(o), "end"));
            n = !0;
          }
        }
      }
      return n;
    }
    function wL(t) {
      if ("attribute" !== t.type) return !1;
      const e = t.attributeKey;
      return "headingRows" === e || "colspan" === e || "rowspan" === e;
    }
    function AL(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.differ.getChanges();
        let i = !1;
        for (const e of n) "insert" == e.type && "table" == e.name && (i = CL(e.position.nodeAfter, t) || i), "insert" == e.type && "tableRow" == e.name && (i = _L(e.position.nodeAfter, t) || i), "insert" == e.type && "tableCell" == e.name && (i = vL(e.position.nodeAfter, t) || i), "remove" != e.type && "insert" != e.type || !yL(e) || (i = vL(e.position.parent, t) || i);
        return i;
      }(e, t));
    }
    function CL(t, e) {
      let n = !1;
      for (const i of t.getChildren()) i.is("element", "tableRow") && (n = _L(i, e) || n);
      return n;
    }
    function _L(t, e) {
      let n = !1;
      for (const i of t.getChildren()) n = vL(i, e) || n;
      return n;
    }
    function vL(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      const n = Array.from(t.getChildren()).filter(t => t.is("$text"));
      for (const t of n) e.wrap(e.createRangeOn(t), "paragraph");
      return !!n.length;
    }
    function yL(t) {
      return !!t.position.parent.is("element", "tableCell") && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
    }
    function xL(t, e) {
      if (!t.is("element", "paragraph")) return !1;
      const n = e.toViewElement(t);
      return !!n && xM(t) !== n.is("element", "span");
    }
    var EL = o(8864),
      DL = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(EL.A, DL);
    EL.A.locals;
    class BL extends Nr {
      static get pluginName() {
        return "TableEditing";
      }
      static get requires() {
        return [rL];
      }
      constructor(t) {
        super(t), this._additionalSlots = [];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = e.schema,
          i = t.conversion,
          o = t.plugins.get(rL);
        n.register("table", {
          inheritAllFrom: "$blockObject",
          allowAttributes: ["headingRows", "headingColumns"]
        }), n.register("tableRow", {
          allowIn: "table",
          isLimit: !0
        }), n.register("tableCell", {
          allowContentOf: "$container",
          allowIn: "tableRow",
          allowAttributes: ["colspan", "rowspan"],
          isLimit: !0,
          isSelectable: !0
        }), i.for("upcast").add(t => {
          t.on("element:figure", (t, e, n) => {
            if (!n.consumable.test(e.viewItem, {
              name: !0,
              classes: "table"
            })) return;
            const i = function (t) {
              for (const e of t.getChildren()) if (e.is("element", "table")) return e;
            }(e.viewItem);
            if (!i || !n.consumable.test(i, {
              name: !0
            })) return;
            n.consumable.consume(e.viewItem, {
              name: !0,
              classes: "table"
            });
            const o = $o(n.convertItem(i, e.modelCursor).modelRange.getItems());
            o ? (n.convertChildren(e.viewItem, n.writer.createPositionAt(o, "end")), n.updateConversionResult(o, e)) : n.consumable.revert(e.viewItem, {
              name: !0,
              classes: "table"
            });
          });
        }), i.for("upcast").add(kM()), i.for("editingDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: _M(o, {
            asWidget: !0,
            additionalSlots: this._additionalSlots
          })
        }), i.for("dataDowncast").elementToStructure({
          model: {
            name: "table",
            attributes: ["headingRows"]
          },
          view: _M(o, {
            additionalSlots: this._additionalSlots
          })
        }), i.for("upcast").elementToElement({
          model: "tableRow",
          view: "tr"
        }), i.for("upcast").add(t => {
          t.on("element:tr", (t, e) => {
            e.viewItem.isEmpty && 0 == e.modelCursor.index && t.stop();
          }, {
            priority: "high"
          });
        }), i.for("downcast").elementToElement({
          model: "tableRow",
          view: (t, _ref217) => {
            let {
              writer: e
            } = _ref217;
            return t.isEmpty ? e.createEmptyElement("tr") : e.createContainerElement("tr");
          }
        }), i.for("upcast").elementToElement({
          model: "tableCell",
          view: "td"
        }), i.for("upcast").elementToElement({
          model: "tableCell",
          view: "th"
        }), i.for("upcast").add(bM("td")), i.for("upcast").add(bM("th")), i.for("editingDowncast").elementToElement({
          model: "tableCell",
          view: vM({
            asWidget: !0
          })
        }), i.for("dataDowncast").elementToElement({
          model: "tableCell",
          view: vM()
        }), i.for("editingDowncast").elementToElement({
          model: "paragraph",
          view: yM({
            asWidget: !0
          }),
          converterPriority: "high"
        }), i.for("dataDowncast").elementToElement({
          model: "paragraph",
          view: yM(),
          converterPriority: "high"
        }), i.for("downcast").attributeToAttribute({
          model: "colspan",
          view: "colspan"
        }), i.for("upcast").attributeToAttribute({
          model: {
            key: "colspan",
            value: SL("colspan")
          },
          view: "colspan"
        }), i.for("downcast").attributeToAttribute({
          model: "rowspan",
          view: "rowspan"
        }), i.for("upcast").attributeToAttribute({
          model: {
            key: "rowspan",
            value: SL("rowspan")
          },
          view: "rowspan"
        }), t.config.define("table.defaultHeadings.rows", 0), t.config.define("table.defaultHeadings.columns", 0), t.commands.add("insertTable", new EM(t)), t.commands.add("insertTableRowAbove", new DM(t, {
          order: "above"
        })), t.commands.add("insertTableRowBelow", new DM(t, {
          order: "below"
        })), t.commands.add("insertTableColumnLeft", new BM(t, {
          order: "left"
        })), t.commands.add("insertTableColumnRight", new BM(t, {
          order: "right"
        })), t.commands.add("removeTableRow", new UM(t)), t.commands.add("removeTableColumn", new qM(t)), t.commands.add("splitTableCellVertically", new SM(t, {
          direction: "vertically"
        })), t.commands.add("splitTableCellHorizontally", new SM(t, {
          direction: "horizontally"
        })), t.commands.add("mergeTableCells", new dL(t)), t.commands.add("mergeTableCellRight", new jM(t, {
          direction: "right"
        })), t.commands.add("mergeTableCellLeft", new jM(t, {
          direction: "left"
        })), t.commands.add("mergeTableCellDown", new jM(t, {
          direction: "down"
        })), t.commands.add("mergeTableCellUp", new jM(t, {
          direction: "up"
        })), t.commands.add("setTableColumnHeader", new WM(t)), t.commands.add("setTableRowHeader", new GM(t)), t.commands.add("selectTableRow", new gL(t)), t.commands.add("selectTableColumn", new pL(t)), fL(e), AL(e), this.listenTo(e.document, "change:data", () => {
          !function (t, e) {
            const n = t.document.differ;
            for (const t of n.getChanges()) {
              let n,
                i = !1;
              if ("attribute" == t.type) {
                const e = t.range.start.nodeAfter;
                if (!e || !e.is("element", "table")) continue;
                if ("headingRows" != t.attributeKey && "headingColumns" != t.attributeKey) continue;
                n = e, i = "headingRows" == t.attributeKey;
              } else "tableRow" != t.name && "tableCell" != t.name || (n = t.position.findAncestor("table"), i = "tableRow" == t.name);
              if (!n) continue;
              const o = n.getAttribute("headingRows") || 0,
                r = n.getAttribute("headingColumns") || 0,
                s = new AM(n);
              for (const t of s) {
                const n = t.row < o || t.column < r ? "th" : "td",
                  s = e.mapper.toViewElement(t.cell);
                s && s.is("element") && s.name != n && e.reconvertItem(i ? t.cell.parent : t.cell);
              }
            }
          }(e, t.editing), function (t, e) {
            const n = t.document.differ,
              i = new Set();
            for (const t of n.getChanges()) {
              const e = "attribute" == t.type ? t.range.start.parent : t.position.parent;
              e.is("element", "tableCell") && i.add(e);
            }
            for (const t of i.values()) {
              const n = Array.from(t.getChildren()).filter(t => xL(t, e.mapper));
              for (const t of n) e.reconvertItem(t);
            }
          }(e, t.editing);
        });
      }
      registerAdditionalSlot(t) {
        this._additionalSlots.push(t);
      }
    }
    function SL(t) {
      return e => {
        const n = parseInt(e.getAttribute(t));
        return Number.isNaN(n) || n <= 0 ? null : n;
      };
    }
    var TL = o(8603),
      IL = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(TL.A, IL);
    TL.A.locals;
    class ML extends Sr {
      constructor(t) {
        super(t);
        const e = this.bindTemplate;
        this.items = this._createGridCollection(), this.keystrokes = new Yo(), this.focusTracker = new Ko(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (t, e) => `${e} × ${t}`), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": e.to("boxover")
            },
            children: this.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-insert-table-dropdown__label"],
              "aria-hidden": !0
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(t => {
              t.preventDefault();
            }),
            click: e.to(() => {
              this.fire("execute");
            })
          }
        }), this.on("boxover", (t, e) => {
          const {
            row: n,
            column: i
          } = e.target.dataset;
          this.items.get(10 * (parseInt(n, 10) - 1) + (parseInt(i, 10) - 1)).focus();
        }), this.focusTracker.on("change:focusedElement", (t, e, n) => {
          if (!n) return;
          const {
            row: i,
            column: o
          } = n.dataset;
          this.set({
            rows: parseInt(i),
            columns: parseInt(o)
          });
        }), this.on("change:columns", () => this._highlightGridBoxes()), this.on("change:rows", () => this._highlightGridBoxes());
      }
      render() {
        super.render(), Lr({
          keystrokeHandler: this.keystrokes,
          focusTracker: this.focusTracker,
          gridItems: this.items,
          numberOfColumns: 10,
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
        for (const t of this.items) this.focusTracker.add(t.element);
        this.keystrokes.listenTo(this.element);
      }
      reset() {
        this.set({
          rows: 1,
          columns: 1
        });
      }
      focus() {
        this.items.get(0).focus();
      }
      focusLast() {
        this.items.get(0).focus();
      }
      _highlightGridBoxes() {
        const t = this.rows,
          e = this.columns;
        this.items.map((n, i) => {
          const o = Math.floor(i / 10) < t && i % 10 < e;
          n.set("isOn", o);
        });
      }
      _createGridButton(t, e, n, i) {
        const o = new mm(t);
        return o.set({
          label: i,
          class: "ck-insert-table-dropdown-grid-box"
        }), o.extendTemplate({
          attributes: {
            "data-row": e,
            "data-column": n
          }
        }), o;
      }
      _createGridCollection() {
        const t = [];
        for (let e = 0; e < 100; e++) {
          const n = Math.floor(e / 10),
            i = e % 10,
            o = `${n + 1} × ${i + 1}`;
          t.push(this._createGridButton(this.locale, n + 1, i + 1, o));
        }
        return this.createCollection(t);
      }
    }
    class LL extends Nr {
      static get pluginName() {
        return "TableUI";
      }
      init() {
        const t = this.editor,
          e = this.editor.t,
          n = "ltr" === t.locale.contentLanguageDirection;
        t.ui.componentFactory.add("insertTable", n => {
          const i = t.commands.get("insertTable"),
            o = Eg(n);
          let r;
          return o.bind("isEnabled").to(i), o.buttonView.set({
            icon: Yh.table,
            label: e("Insert table"),
            tooltip: !0
          }), o.on("change:isOpen", () => {
            r || (r = new ML(n), o.panelView.children.add(r), r.delegate("execute").to(o), o.on("execute", () => {
              t.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), t.editing.view.focus();
            }));
          }), o;
        }), t.ui.componentFactory.add("menuBar:insertTable", n => {
          const i = t.commands.get("insertTable"),
            o = new Fk(n),
            r = new ML(n);
          return r.delegate("execute").to(o), o.on("change:isOpen", (t, e, n) => {
            n || r.reset();
          }), r.on("execute", () => {
            t.execute("insertTable", {
              rows: r.rows,
              columns: r.columns
            }), t.editing.view.focus();
          }), o.buttonView.set({
            label: e("Table"),
            icon: Yh.table
          }), o.panelView.children.add(r), o.bind("isEnabled").to(i), o;
        }), t.ui.componentFactory.add("tableColumn", t => {
          const i = [{
            type: "switchbutton",
            model: {
              commandName: "setTableColumnHeader",
              label: e("Header column"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
              label: e("Insert column left")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
              label: e("Insert column right")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableColumn",
              label: e("Delete column")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableColumn",
              label: e("Select column")
            }
          }];
          return this._prepareDropdown(e("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', i, t);
        }), t.ui.componentFactory.add("tableRow", t => {
          const n = [{
            type: "switchbutton",
            model: {
              commandName: "setTableRowHeader",
              label: e("Header row"),
              bindIsOn: !0
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowAbove",
              label: e("Insert row above")
            }
          }, {
            type: "button",
            model: {
              commandName: "insertTableRowBelow",
              label: e("Insert row below")
            }
          }, {
            type: "button",
            model: {
              commandName: "removeTableRow",
              label: e("Delete row")
            }
          }, {
            type: "button",
            model: {
              commandName: "selectTableRow",
              label: e("Select row")
            }
          }];
          return this._prepareDropdown(e("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n, t);
        }), t.ui.componentFactory.add("mergeTableCells", t => {
          const i = [{
            type: "button",
            model: {
              commandName: "mergeTableCellUp",
              label: e("Merge cell up")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
              label: e("Merge cell right")
            }
          }, {
            type: "button",
            model: {
              commandName: "mergeTableCellDown",
              label: e("Merge cell down")
            }
          }, {
            type: "button",
            model: {
              commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
              label: e("Merge cell left")
            }
          }, {
            type: "separator"
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellVertically",
              label: e("Split cell vertically")
            }
          }, {
            type: "button",
            model: {
              commandName: "splitTableCellHorizontally",
              label: e("Split cell horizontally")
            }
          }];
          return this._prepareMergeSplitButtonDropdown(e("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', i, t);
        });
      }
      _prepareDropdown(t, e, n, i) {
        const o = this.editor,
          r = Eg(i),
          s = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: t,
          icon: e,
          tooltip: !0
        }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
          for (var _len44 = arguments.length, t = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
            t[_key44] = arguments[_key44];
          }
          return t.some(t => t);
        }), this.listenTo(r, "execute", t => {
          o.execute(t.source.commandName), t.source instanceof fm || o.editing.view.focus();
        }), r;
      }
      _prepareMergeSplitButtonDropdown(t, e, n, i) {
        const o = this.editor,
          r = Eg(i, Cg),
          s = "mergeTableCells",
          a = o.commands.get(s),
          l = this._fillDropdownWithListOptions(r, n);
        return r.buttonView.set({
          label: t,
          icon: e,
          tooltip: !0,
          isEnabled: !0
        }), r.bind("isEnabled").toMany([a, ...l], "isEnabled", function () {
          for (var _len45 = arguments.length, t = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
            t[_key45] = arguments[_key45];
          }
          return t.some(t => t);
        }), this.listenTo(r.buttonView, "execute", () => {
          o.execute(s), o.editing.view.focus();
        }), this.listenTo(r, "execute", t => {
          o.execute(t.source.commandName), o.editing.view.focus();
        }), r;
      }
      _fillDropdownWithListOptions(t, e) {
        const n = this.editor,
          i = [],
          o = new Wo();
        for (const t of e) NL(t, n, i, o);
        return Sg(t, o), i;
      }
    }
    function NL(t, e, n, i) {
      if ("button" === t.type || "switchbutton" === t.type) {
        const i = t.model = new Mf(t.model),
          {
            commandName: o,
            bindIsOn: r
          } = t.model,
          s = e.commands.get(o);
        n.push(s), i.set({
          commandName: o
        }), i.bind("isEnabled").to(s), r && i.bind("isOn").to(s, "value"), i.set({
          withText: !0
        });
      }
      i.add(t);
    }
    var zL = o(2850),
      PL = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(zL.A, PL);
    zL.A.locals;
    class VL extends Nr {
      static get pluginName() {
        return "TableSelection";
      }
      static get requires() {
        return [rL, rL];
      }
      init() {
        const t = this.editor,
          e = t.model,
          n = t.editing.view;
        this.listenTo(e, "deleteContent", (t, e) => this._handleDeleteContent(t, e), {
          priority: "high"
        }), this.listenTo(n.document, "insertText", (t, e) => this._handleInsertTextEvent(t, e), {
          priority: "high"
        }), this._defineSelectionConverter(), this._enablePluginDisabling();
      }
      getSelectedTableCells() {
        const t = this.editor.plugins.get(rL),
          e = this.editor.model.document.selection,
          n = t.getSelectedTableCells(e);
        return 0 == n.length ? null : n;
      }
      getSelectionAsFragment() {
        const t = this.editor.plugins.get(rL),
          e = this.getSelectedTableCells();
        return e ? this.editor.model.change(n => {
          const i = n.createDocumentFragment(),
            {
              first: o,
              last: r
            } = t.getColumnIndexes(e),
            {
              first: s,
              last: a
            } = t.getRowIndexes(e),
            l = e[0].findAncestor("table");
          let c = a,
            d = r;
          if (t.isSelectionRectangular(e)) {
            const t = {
              firstColumn: o,
              lastColumn: r,
              firstRow: s,
              lastRow: a
            };
            c = FM(l, t), d = OM(l, t);
          }
          const u = TM(l, {
            startRow: s,
            startColumn: o,
            endRow: c,
            endColumn: d
          }, n);
          return n.insert(u, i, 0), i;
        }) : null;
      }
      setCellSelection(t, e) {
        const n = this._getCellsToSelect(t, e);
        this.editor.model.change(t => {
          t.setSelection(n.cells.map(e => t.createRangeOn(e)), {
            backward: n.backward
          });
        });
      }
      getFocusCell() {
        const t = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
        return t && t.is("element", "tableCell") ? t : null;
      }
      getAnchorCell() {
        const t = $o(this.editor.model.document.selection.getRanges()).getContainedElement();
        return t && t.is("element", "tableCell") ? t : null;
      }
      _defineSelectionConverter() {
        const t = this.editor,
          e = new Set();
        t.conversion.for("editingDowncast").add(t => t.on("selection", (t, n, i) => {
          const o = i.writer;
          !function (t) {
            for (const n of e) t.removeClass("ck-editor__editable_selected", n);
            e.clear();
          }(o);
          const r = this.getSelectedTableCells();
          if (!r) return;
          for (const t of r) {
            const n = i.mapper.toViewElement(t);
            o.addClass("ck-editor__editable_selected", n), e.add(n);
          }
          const s = i.mapper.toViewElement(r[r.length - 1]);
          o.setSelection(s, 0);
        }, {
          priority: "lowest"
        }));
      }
      _enablePluginDisabling() {
        const t = this.editor;
        this.on("change:isEnabled", () => {
          if (!this.isEnabled) {
            const e = this.getSelectedTableCells();
            if (!e) return;
            t.model.change(n => {
              const i = n.createPositionAt(e[0], 0),
                o = t.model.schema.getNearestSelectionRange(i);
              n.setSelection(o);
            });
          }
        });
      }
      _handleDeleteContent(t, e) {
        const n = this.editor.plugins.get(rL),
          i = e[0],
          o = e[1],
          r = this.editor.model,
          s = !o || "backward" == o.direction,
          a = n.getSelectedTableCells(i);
        a.length && (t.stop(), r.change(t => {
          const e = a[s ? a.length - 1 : 0];
          r.change(t => {
            for (const e of a) r.deleteContent(t.createSelection(e, "in"));
          });
          const n = r.schema.getNearestSelectionRange(t.createPositionAt(e, 0));
          i.is("documentSelection") ? t.setSelection(n) : i.setTo(n);
        }));
      }
      _handleInsertTextEvent(t, e) {
        const n = this.editor,
          i = this.getSelectedTableCells();
        if (!i) return;
        const o = n.editing.view,
          r = n.editing.mapper,
          s = i.map(t => o.createRangeOn(r.toViewElement(t)));
        e.selection = o.createSelection(s);
      }
      _getCellsToSelect(t, e) {
        const n = this.editor.plugins.get("TableUtils"),
          i = n.getCellLocation(t),
          o = n.getCellLocation(e),
          r = Math.min(i.row, o.row),
          s = Math.max(i.row, o.row),
          a = Math.min(i.column, o.column),
          l = Math.max(i.column, o.column),
          c = new Array(s - r + 1).fill(null).map(() => []),
          d = {
            startRow: r,
            endRow: s,
            startColumn: a,
            endColumn: l
          };
        for (const {
          row: e,
          cell: n
        } of new AM(t.findAncestor("table"), d)) c[e - r].push(n);
        const u = o.row < i.row,
          h = o.column < i.column;
        return u && c.reverse(), h && c.forEach(t => t.reverse()), {
          cells: c.flat(),
          backward: u || h
        };
      }
    }
    class RL extends Nr {
      static get pluginName() {
        return "TableClipboard";
      }
      static get requires() {
        return [Ib, Mb, VL, rL];
      }
      init() {
        const t = this.editor,
          e = t.editing.view.document;
        this.listenTo(e, "copy", (t, e) => this._onCopyCut(t, e)), this.listenTo(e, "cut", (t, e) => this._onCopyCut(t, e)), this.listenTo(t.model, "insertContent", (t, _ref218) => {
          let [e, n] = _ref218;
          return this._onInsertContent(t, e, n);
        }, {
          priority: "high"
        }), this.decorate("_replaceTableSlotCell");
      }
      _onCopyCut(t, e) {
        const n = this.editor.editing.view,
          i = this.editor.plugins.get(VL),
          o = this.editor.plugins.get(Ib);
        i.getSelectedTableCells() && ("cut" != t.name || this.editor.model.canEditAt(this.editor.model.document.selection)) && (e.preventDefault(), t.stop(), this.editor.model.enqueueChange({
          isUndoable: "cut" === t.name
        }, () => {
          const r = o._copySelectedFragmentWithMarkers(t.name, this.editor.model.document.selection, () => i.getSelectionAsFragment());
          n.document.fire("clipboardOutput", {
            dataTransfer: e.dataTransfer,
            content: this.editor.data.toView(r),
            method: t.name
          });
        }));
      }
      _onInsertContent(t, e, n) {
        if (n && !n.is("documentSelection")) return;
        const i = this.editor.model,
          o = this.editor.plugins.get(rL),
          r = this.editor.plugins.get(Ib),
          s = this.getTableIfOnlyTableInContent(e, i);
        if (!s) return;
        const a = o.getSelectionAffectedTableCells(i.document.selection);
        a.length ? (t.stop(), e.is("documentFragment") ? r._pasteMarkersIntoTransformedElement(e.markers, t => this._replaceSelectedCells(s, a, t)) : this.editor.model.change(t => {
          this._replaceSelectedCells(s, a, t);
        })) : RM(s, o);
      }
      _replaceSelectedCells(t, e, n) {
        const i = this.editor.plugins.get(rL),
          o = {
            width: i.getColumns(t),
            height: i.getRows(t)
          },
          r = function (t, e, n, i) {
            const o = t[0].findAncestor("table"),
              r = i.getColumnIndexes(t),
              s = i.getRowIndexes(t),
              a = {
                firstColumn: r.first,
                lastColumn: r.last,
                firstRow: s.first,
                lastRow: s.last
              },
              l = 1 === t.length;
            l && (a.lastRow += e.height - 1, a.lastColumn += e.width - 1, function (t, e, n, i) {
              const o = i.getColumns(t),
                r = i.getRows(t);
              n > o && i.insertColumns(t, {
                at: o,
                columns: n - o
              });
              e > r && i.insertRows(t, {
                at: r,
                rows: e - r
              });
            }(o, a.lastRow + 1, a.lastColumn + 1, i));
            l || !i.isSelectionRectangular(t) ? function (t, e, n) {
              const {
                  firstRow: i,
                  lastRow: o,
                  firstColumn: r,
                  lastColumn: s
                } = e,
                a = {
                  first: i,
                  last: o
                },
                l = {
                  first: r,
                  last: s
                };
              OL(t, r, a, n), OL(t, s + 1, a, n), FL(t, i, l, n), FL(t, o + 1, l, n, i);
            }(o, a, n) : (a.lastRow = FM(o, a), a.lastColumn = OM(o, a));
            return a;
          }(e, o, n, i),
          s = r.lastRow - r.firstRow + 1,
          a = r.lastColumn - r.firstColumn + 1;
        t = TM(t, {
          startRow: 0,
          startColumn: 0,
          endRow: Math.min(s, o.height) - 1,
          endColumn: Math.min(a, o.width) - 1
        }, n);
        const l = e[0].findAncestor("table"),
          c = this._replaceSelectedCellsWithPasted(t, o, l, r, n);
        if (this.editor.plugins.get("TableSelection").isEnabled) {
          const t = i.sortRanges(c.map(t => n.createRangeOn(t)));
          n.setSelection(t);
        } else n.setSelection(c[0], 0);
        return l;
      }
      _replaceSelectedCellsWithPasted(t, e, n, i, o) {
        const {
            width: r,
            height: s
          } = e,
          a = function (t, e, n) {
            const i = new Array(n).fill(null).map(() => new Array(e).fill(null));
            for (const {
              column: e,
              row: n,
              cell: o
            } of new AM(t)) i[n][e] = o;
            return i;
          }(t, r, s),
          l = [...new AM(n, {
            startRow: i.firstRow,
            endRow: i.lastRow,
            startColumn: i.firstColumn,
            endColumn: i.lastColumn,
            includeAllSlots: !0
          })],
          c = [];
        let d;
        for (const t of l) {
          const {
            row: e,
            column: n
          } = t;
          n === i.firstColumn && (d = t.getPositionBefore());
          const l = e - i.firstRow,
            u = n - i.firstColumn,
            h = a[l % s][u % r],
            m = h ? o.cloneElement(h) : null,
            g = this._replaceTableSlotCell(t, m, d, o);
          g && (zM(g, e, n, i.lastRow, i.lastColumn, o), c.push(g), d = o.createPositionAfter(g));
        }
        const u = parseInt(n.getAttribute("headingRows") || "0"),
          h = parseInt(n.getAttribute("headingColumns") || "0"),
          m = i.firstRow < u && u <= i.lastRow,
          g = i.firstColumn < h && h <= i.lastColumn;
        if (m) {
          const t = FL(n, u, {
            first: i.firstColumn,
            last: i.lastColumn
          }, o, i.firstRow);
          c.push(...t);
        }
        if (g) {
          const t = OL(n, h, {
            first: i.firstRow,
            last: i.lastRow
          }, o);
          c.push(...t);
        }
        return c;
      }
      _replaceTableSlotCell(t, e, n, i) {
        const {
          cell: o,
          isAnchor: r
        } = t;
        return r && i.remove(o), e ? (i.insert(e, n), e) : null;
      }
      getTableIfOnlyTableInContent(t, e) {
        if (!t.is("documentFragment") && !t.is("element")) return null;
        if (t.is("element", "table")) return t;
        if (1 == t.childCount && t.getChild(0).is("element", "table")) return t.getChild(0);
        const n = e.createRangeIn(t);
        for (const t of n.getItems()) if (t.is("element", "table")) {
          const i = e.createRange(n.start, e.createPositionBefore(t));
          if (e.hasContent(i, {
            ignoreWhitespaces: !0
          })) return null;
          const o = e.createRange(e.createPositionAfter(t), n.end);
          return e.hasContent(o, {
            ignoreWhitespaces: !0
          }) ? null : t;
        }
        return null;
      }
    }
    function FL(t, e, n, i) {
      let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (e < 1) return;
      return IM(t, e, o).filter(_ref219 => {
        let {
          column: t,
          cellWidth: e
        } = _ref219;
        return jL(t, e, n);
      }).map(_ref220 => {
        let {
          cell: t
        } = _ref220;
        return MM(t, e, i);
      });
    }
    function OL(t, e, n, i) {
      if (e < 1) return;
      return LM(t, e).filter(_ref221 => {
        let {
          row: t,
          cellHeight: e
        } = _ref221;
        return jL(t, e, n);
      }).map(_ref222 => {
        let {
          cell: t,
          column: n
        } = _ref222;
        return NM(t, n, e, i);
      });
    }
    function jL(t, e, n) {
      const i = t + e - 1,
        {
          first: o,
          last: r
        } = n;
      return t >= o && t <= r || t < o && i >= o;
    }
    class HL extends Nr {
      static get pluginName() {
        return "TableKeyboard";
      }
      static get requires() {
        return [VL, rL];
      }
      init() {
        var _this11 = this;
        const t = this.editor,
          e = t.editing.view.document,
          n = t.t;
        this.listenTo(e, "arrowKey", function () {
          return _this11._onArrowKey(...arguments);
        }, {
          context: "table"
        }), this.listenTo(e, "tab", function () {
          return _this11._handleTabOnSelectedTable(...arguments);
        }, {
          context: "figure"
        }), this.listenTo(e, "tab", function () {
          return _this11._handleTab(...arguments);
        }, {
          context: ["th", "td"]
        }), t.accessibility.addKeystrokeInfoGroup({
          id: "table",
          label: n("Keystrokes that can be used in a table cell"),
          keystrokes: [{
            label: n("Move the selection to the next cell"),
            keystroke: "Tab"
          }, {
            label: n("Move the selection to the previous cell"),
            keystroke: "Shift+Tab"
          }, {
            label: n("Insert a new table row (when in the last cell of a table)"),
            keystroke: "Tab"
          }, {
            label: n("Navigate through the table"),
            keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
          }]
        });
      }
      _handleTabOnSelectedTable(t, e) {
        const n = this.editor,
          i = n.model.document.selection.getSelectedElement();
        i && i.is("element", "table") && (e.preventDefault(), e.stopPropagation(), t.stop(), n.model.change(t => {
          t.setSelection(t.createRangeIn(i.getChild(0).getChild(0)));
        }));
      }
      _handleTab(t, e) {
        const n = this.editor,
          i = this.editor.plugins.get(rL),
          o = this.editor.plugins.get("TableSelection"),
          r = n.model.document.selection,
          s = !e.shiftKey;
        let a = i.getTableCellsContainingSelection(r)[0];
        if (a || (a = o.getFocusCell()), !a) return;
        e.preventDefault(), e.stopPropagation(), t.stop();
        const l = a.parent,
          c = l.parent,
          d = c.getChildIndex(l),
          u = l.getChildIndex(a),
          h = 0 === u;
        if (!s && h && 0 === d) return void n.model.change(t => {
          t.setSelection(t.createRangeOn(c));
        });
        const m = u === l.childCount - 1,
          g = d === i.getRows(c) - 1;
        if (s && g && m && (n.execute("insertTableRowBelow"), d === i.getRows(c) - 1)) return void n.model.change(t => {
          t.setSelection(t.createRangeOn(c));
        });
        let p;
        if (s && m) {
          const t = c.getChild(d + 1);
          p = t.getChild(0);
        } else if (!s && h) {
          const t = c.getChild(d - 1);
          p = t.getChild(t.childCount - 1);
        } else p = l.getChild(u + (s ? 1 : -1));
        n.model.change(t => {
          t.setSelection(t.createRangeIn(p));
        });
      }
      _onArrowKey(t, e) {
        const n = this.editor,
          i = Ao(e.keyCode, n.locale.contentLanguageDirection);
        this._handleArrowKeys(i, e.shiftKey) && (e.preventDefault(), e.stopPropagation(), t.stop());
      }
      _handleArrowKeys(t, e) {
        const n = this.editor.plugins.get(rL),
          i = this.editor.plugins.get("TableSelection"),
          o = this.editor.model,
          r = o.document.selection,
          s = ["right", "down"].includes(t),
          a = n.getSelectedTableCells(r);
        if (a.length) {
          let n;
          return n = e ? i.getFocusCell() : s ? a[a.length - 1] : a[0], this._navigateFromCellInDirection(n, t, e), !0;
        }
        const l = r.focus.findAncestor("tableCell");
        if (!l) return !1;
        if (!r.isCollapsed) if (e) {
          if (r.isBackward == s && !r.containsEntireContent(l)) return !1;
        } else {
          const t = r.getSelectedElement();
          if (!t || !o.schema.isObject(t)) return !1;
        }
        return !!this._isSelectionAtCellEdge(r, l, s) && (this._navigateFromCellInDirection(l, t, e), !0);
      }
      _isSelectionAtCellEdge(t, e, n) {
        const i = this.editor.model,
          o = this.editor.model.schema,
          r = n ? t.getLastPosition() : t.getFirstPosition();
        if (!o.getLimitElement(r).is("element", "tableCell")) {
          return i.createPositionAt(e, n ? "end" : 0).isTouching(r);
        }
        const s = i.createSelection(r);
        return i.modifySelection(s, {
          direction: n ? "forward" : "backward"
        }), r.isEqual(s.focus);
      }
      _navigateFromCellInDirection(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        const i = this.editor.model,
          o = t.findAncestor("table"),
          r = [...new AM(o, {
            includeAllSlots: !0
          })],
          {
            row: s,
            column: a
          } = r[r.length - 1],
          l = r.find(_ref223 => {
            let {
              cell: e
            } = _ref223;
            return e == t;
          });
        let {
          row: c,
          column: d
        } = l;
        switch (e) {
          case "left":
            d--;
            break;
          case "up":
            c--;
            break;
          case "right":
            d += l.cellWidth;
            break;
          case "down":
            c += l.cellHeight;
        }
        if (c < 0 || c > s || d < 0 && c <= 0 || d > a && c >= s) return void i.change(t => {
          t.setSelection(t.createRangeOn(o));
        });
        d < 0 ? (d = n ? 0 : a, c--) : d > a && (d = n ? a : 0, c++);
        const u = r.find(t => t.row == c && t.column == d).cell,
          h = ["right", "down"].includes(e),
          m = this.editor.plugins.get("TableSelection");
        if (n && m.isEnabled) {
          const e = m.getAnchorCell() || t;
          m.setCellSelection(e, u);
        } else {
          const t = i.createPositionAt(u, h ? 0 : "end");
          i.change(e => {
            e.setSelection(t);
          });
        }
      }
    }
    class UL extends il {
      constructor() {
        super(...arguments), this.domEventType = ["mousemove", "mouseleave"];
      }
      onDomEvent(t) {
        this.fire(t.type, t);
      }
    }
    class qL extends Nr {
      static get pluginName() {
        return "TableMouse";
      }
      static get requires() {
        return [VL, rL];
      }
      init() {
        this.editor.editing.view.addObserver(UL), this._enableShiftClickSelection(), this._enableMouseDragSelection();
      }
      _enableShiftClickSelection() {
        const t = this.editor,
          e = t.plugins.get(rL);
        let n = !1;
        const i = t.plugins.get(VL);
        this.listenTo(t.editing.view.document, "mousedown", (o, r) => {
          const s = t.model.document.selection;
          if (!this.isEnabled || !i.isEnabled) return;
          if (!r.domEvent.shiftKey) return;
          const a = i.getAnchorCell() || e.getTableCellsContainingSelection(s)[0];
          if (!a) return;
          const l = this._getModelTableCellFromDomEvent(r);
          l && GL(a, l) && (n = !0, i.setCellSelection(a, l), r.preventDefault());
        }), this.listenTo(t.editing.view.document, "mouseup", () => {
          n = !1;
        }), this.listenTo(t.editing.view.document, "selectionChange", t => {
          n && t.stop();
        }, {
          priority: "highest"
        });
      }
      _enableMouseDragSelection() {
        const t = this.editor;
        let e,
          n,
          i = !1,
          o = !1;
        const r = t.plugins.get(VL);
        this.listenTo(t.editing.view.document, "mousedown", (t, n) => {
          this.isEnabled && r.isEnabled && (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (e = this._getModelTableCellFromDomEvent(n)));
        }), this.listenTo(t.editing.view.document, "mousemove", (t, s) => {
          if (!s.domEvent.buttons) return;
          if (!e) return;
          const a = this._getModelTableCellFromDomEvent(s);
          a && GL(e, a) && (n = a, i || n == e || (i = !0)), i && (o = !0, r.setCellSelection(e, n), s.preventDefault());
        }), this.listenTo(t.editing.view.document, "mouseup", () => {
          i = !1, o = !1, e = null, n = null;
        }), this.listenTo(t.editing.view.document, "selectionChange", t => {
          o && t.stop();
        }, {
          priority: "highest"
        });
      }
      _getModelTableCellFromDomEvent(t) {
        const e = t.target,
          n = this.editor.editing.view.createPositionAt(e, 0);
        return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor("tableCell", {
          includeSelf: !0
        });
      }
    }
    function GL(t, e) {
      return t.parent.parent == e.parent.parent;
    }
    var WL = o(9969),
      $L = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(WL.A, $L);
    WL.A.locals;
    function KL(t) {
      const e = YL(t);
      return e || QL(t);
    }
    function YL(t) {
      const e = t.getSelectedElement();
      return e && ZL(e) ? e : null;
    }
    function QL(t) {
      const e = t.getFirstPosition();
      if (!e) return null;
      let n = e.parent;
      for (; n;) {
        if (n.is("element") && ZL(n)) return n;
        n = n.parent;
      }
      return null;
    }
    function ZL(t) {
      return !!t.getCustomProperty("table") && Sw(t);
    }
    var JL = o(4307),
      XL = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(JL.A, XL);
    JL.A.locals;
    class tN extends Sr {
      constructor(t, e) {
        super(t), this.set("value", ""), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isEmpty", !0), this.options = e, this.focusTracker = new Ko(), this._focusables = new nr(), this.dropdownView = this._createDropdownView(), this.inputView = this._createInputTextView(), this.keystrokes = new Yo(), this._stillTyping = !1, this.focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-input-color"]
          },
          children: [this.dropdownView, this.inputView]
        }), this.on("change:value", (t, e, n) => this._setInputValue(n));
      }
      render() {
        super.render(), [this.inputView, this.dropdownView.buttonView].forEach(t => {
          this.focusTracker.add(t.element), this._focusables.add(t);
        }), this.keystrokes.listenTo(this.element);
      }
      focus(t) {
        -1 === t ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      _createDropdownView() {
        const t = this.locale,
          e = t.t,
          n = this.bindTemplate,
          i = this._createColorSelector(t),
          o = Eg(t),
          r = new Sr();
        return r.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-input-color__button__preview"],
            style: {
              backgroundColor: n.to("value")
            }
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-input-color__button__preview__no-color-indicator", n.if("value", "ck-hidden", t => "" != t)]
            }
          }]
        }), o.buttonView.extendTemplate({
          attributes: {
            class: "ck-input-color__button"
          }
        }), o.buttonView.children.add(r), o.buttonView.label = e("Color picker"), o.buttonView.tooltip = !0, o.panelPosition = "rtl" === t.uiLanguageDirection ? "se" : "sw", o.panelView.children.add(i), o.bind("isEnabled").to(this, "isReadOnly", t => !t), o.on("change:isOpen", (t, e, n) => {
          n && (i.updateSelectedColors(), i.showColorGridsFragment());
        }), o;
      }
      _createInputTextView() {
        const t = this.locale,
          e = new qm(t);
        return e.extendTemplate({
          on: {
            blur: e.bindTemplate.to("blur")
          }
        }), e.value = this.value, e.bind("isReadOnly", "hasError").to(this), this.bind("isFocused", "isEmpty").to(e), e.on("input", () => {
          const t = e.element.value,
            n = this.options.colorDefinitions.find(e => t === e.label);
          this._stillTyping = !0, this.value = n && n.color || t;
        }), e.on("blur", () => {
          this._stillTyping = !1, this._setInputValue(e.element.value);
        }), e.delegate("input").to(this), e;
      }
      _createColorSelector(t) {
        const e = t.t,
          n = this.options.defaultColorValue || "",
          i = e(n ? "Restore default" : "Remove color"),
          o = new Ep(t, {
            colors: this.options.colorDefinitions,
            columns: this.options.columns,
            removeButtonLabel: i,
            colorPickerLabel: e("Color picker"),
            colorPickerViewConfig: !1 !== this.options.colorPickerConfig && {
              ...this.options.colorPickerConfig,
              hideInput: !0
            }
          });
        o.appendUI(), o.on("execute", (t, e) => {
          "colorPickerSaveButton" !== e.source ? (this.value = e.value || n, this.fire("input"), "colorPicker" !== e.source && (this.dropdownView.isOpen = !1)) : this.dropdownView.isOpen = !1;
        });
        let r = this.value;
        return o.on("colorPicker:cancel", () => {
          this.value = r, this.fire("input"), this.dropdownView.isOpen = !1;
        }), o.colorGridsFragmentView.colorPickerButtonView.on("execute", () => {
          r = this.value;
        }), o.bind("selectedColor").to(this, "value"), o;
      }
      _setInputValue(t) {
        if (!this._stillTyping) {
          const e = eN(t),
            n = this.options.colorDefinitions.find(t => e === eN(t.color));
          this.inputView.value = n ? n.label : t || "";
        }
      }
    }
    function eN(t) {
      return t.replace(/([(,])\s+/g, "$1").replace(/^\s+|\s+(?=[),\s]|$)/g, "").replace(/,|\s/g, " ");
    }
    const nN = t => "" === t;
    function iN(t) {
      return {
        none: t("None"),
        solid: t("Solid"),
        dotted: t("Dotted"),
        dashed: t("Dashed"),
        double: t("Double"),
        groove: t("Groove"),
        ridge: t("Ridge"),
        inset: t("Inset"),
        outset: t("Outset")
      };
    }
    function oN(t) {
      return t('The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".');
    }
    function rN(t) {
      return t('The value is invalid. Try "10px" or "2em" or simply "2".');
    }
    function sN(t) {
      return t = t.trim().toLowerCase(), nN(t) || lh(t);
    }
    function aN(t) {
      return t = t.trim(), nN(t) || mN(t) || hh(t) || gh(t);
    }
    function lN(t) {
      return t = t.trim(), nN(t) || mN(t) || hh(t);
    }
    function cN(t, e) {
      const n = new Wo(),
        i = iN(t.t);
      for (const o in i) {
        const r = {
          type: "button",
          model: new Mf({
            _borderStyleValue: o,
            label: i[o],
            role: "menuitemradio",
            withText: !0
          })
        };
        "none" === o ? r.model.bind("isOn").to(t, "borderStyle", t => "none" === e ? !t : t === o) : r.model.bind("isOn").to(t, "borderStyle", t => t === o), n.add(r);
      }
      return n;
    }
    function dN(t) {
      const {
        view: e,
        icons: n,
        toolbar: i,
        labels: o,
        propertyName: r,
        nameToValue: s,
        defaultValue: a
      } = t;
      for (const t in o) {
        const l = new mm(e.locale);
        l.set({
          label: o[t],
          icon: n[t],
          tooltip: o[t]
        });
        const c = s ? s(t) : t;
        l.bind("isOn").to(e, r, t => {
          let e = t;
          return "" === t && a && (e = a), c === e;
        }), l.on("execute", () => {
          e[r] = c;
        }), i.items.add(l);
      }
    }
    const uN = [{
      color: "hsl(0, 0%, 0%)",
      label: "Black"
    }, {
      color: "hsl(0, 0%, 30%)",
      label: "Dim grey"
    }, {
      color: "hsl(0, 0%, 60%)",
      label: "Grey"
    }, {
      color: "hsl(0, 0%, 90%)",
      label: "Light grey"
    }, {
      color: "hsl(0, 0%, 100%)",
      label: "White",
      hasBorder: !0
    }, {
      color: "hsl(0, 75%, 60%)",
      label: "Red"
    }, {
      color: "hsl(30, 75%, 60%)",
      label: "Orange"
    }, {
      color: "hsl(60, 75%, 60%)",
      label: "Yellow"
    }, {
      color: "hsl(90, 75%, 60%)",
      label: "Light green"
    }, {
      color: "hsl(120, 75%, 60%)",
      label: "Green"
    }, {
      color: "hsl(150, 75%, 60%)",
      label: "Aquamarine"
    }, {
      color: "hsl(180, 75%, 60%)",
      label: "Turquoise"
    }, {
      color: "hsl(210, 75%, 60%)",
      label: "Light blue"
    }, {
      color: "hsl(240, 75%, 60%)",
      label: "Blue"
    }, {
      color: "hsl(270, 75%, 60%)",
      label: "Purple"
    }];
    function hN(t) {
      return (e, n, i) => {
        const o = new tN(e.locale, {
          colorDefinitions: (r = t.colorConfig, r.map(t => ({
            color: t.model,
            label: t.label,
            options: {
              hasBorder: t.hasBorder
            }
          }))),
          columns: t.columns,
          defaultColorValue: t.defaultColorValue,
          colorPickerConfig: t.colorPickerConfig
        });
        var r;
        return o.inputView.set({
          id: n,
          ariaDescribedById: i
        }), o.bind("isReadOnly").to(e, "isEnabled", t => !t), o.bind("hasError").to(e, "errorText", t => !!t), o.on("input", () => {
          e.errorText = null;
        }), e.bind("isEmpty", "isFocused").to(o), o;
      };
    }
    function mN(t) {
      const e = parseFloat(t);
      return !Number.isNaN(e) && t === String(e);
    }
    var gN = o(6016),
      pN = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(gN.A, pN);
    gN.A.locals;
    class fN extends Sr {
      constructor(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(t);
        const n = this.bindTemplate;
        this.set("class", e.class || null), this.children = this.createCollection(), e.children && e.children.forEach(t => this.children.add(t)), this.set("_role", null), this.set("_ariaLabelledBy", null), e.labelView && this.set({
          _role: "group",
          _ariaLabelledBy: e.labelView.id
        }), this.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-form__row", n.to("class")],
            role: n.to("_role"),
            "aria-labelledby": n.to("_ariaLabelledBy")
          },
          children: this.children
        });
      }
    }
    var kN = o(1806),
      bN = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(kN.A, bN);
    kN.A.locals;
    var wN = o(5704),
      AN = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(wN.A, AN);
    wN.A.locals;
    var CN = o(6701),
      _N = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(CN.A, _N);
    CN.A.locals;
    const vN = {
      left: Yh.alignLeft,
      center: Yh.alignCenter,
      right: Yh.alignRight,
      justify: Yh.alignJustify,
      top: Yh.alignTop,
      middle: Yh.alignMiddle,
      bottom: Yh.alignBottom
    };
    class yN extends Sr {
      constructor(t, e) {
        super(t), this.set({
          borderStyle: "",
          borderWidth: "",
          borderColor: "",
          padding: "",
          backgroundColor: "",
          width: "",
          height: "",
          horizontalAlignment: "",
          verticalAlignment: ""
        }), this.options = e;
        const {
            borderStyleDropdown: n,
            borderWidthInput: i,
            borderColorInput: o,
            borderRowLabel: r
          } = this._createBorderFields(),
          {
            backgroundRowLabel: s,
            backgroundInput: a
          } = this._createBackgroundFields(),
          {
            widthInput: l,
            operatorLabel: c,
            heightInput: d,
            dimensionsLabel: u
          } = this._createDimensionFields(),
          {
            horizontalAlignmentToolbar: h,
            verticalAlignmentToolbar: m,
            alignmentLabel: g
          } = this._createAlignmentFields();
        this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.children = this.createCollection(), this.borderStyleDropdown = n, this.borderWidthInput = i, this.borderColorInput = o, this.backgroundInput = a, this.paddingInput = this._createPaddingField(), this.widthInput = l, this.heightInput = d, this.horizontalAlignmentToolbar = h, this.verticalAlignmentToolbar = m;
        const {
          saveButtonView: p,
          cancelButtonView: f
        } = this._createActionButtons();
        this.saveButtonView = p, this.cancelButtonView = f, this._focusables = new nr(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.children.add(new Ip(t, {
          label: this.t("Cell properties")
        })), this.children.add(new fN(t, {
          labelView: r,
          children: [r, n, o, i],
          class: "ck-table-form__border-row"
        })), this.children.add(new fN(t, {
          labelView: s,
          children: [s, a],
          class: "ck-table-form__background-row"
        })), this.children.add(new fN(t, {
          children: [new fN(t, {
            labelView: u,
            children: [u, l, c, d],
            class: "ck-table-form__dimensions-row"
          }), new fN(t, {
            children: [this.paddingInput],
            class: "ck-table-cell-properties-form__padding-row"
          })]
        })), this.children.add(new fN(t, {
          labelView: g,
          children: [g, h, m],
          class: "ck-table-cell-properties-form__alignment-row"
        })), this.children.add(new fN(t, {
          children: [this.saveButtonView, this.cancelButtonView],
          class: "ck-table-form__action-row"
        })), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-form", "ck-table-form", "ck-table-cell-properties-form"],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), Mr({
          view: this
        }), [this.borderColorInput, this.backgroundInput].forEach(t => {
          t.fieldView.focusCycler.on("forwardCycle", t => {
            this._focusCycler.focusNext(), t.stop();
          }), t.fieldView.focusCycler.on("backwardCycle", t => {
            this._focusCycler.focusPrevious(), t.stop();
          });
        }), [this.borderStyleDropdown, this.borderColorInput, this.borderWidthInput, this.backgroundInput, this.widthInput, this.heightInput, this.paddingInput, this.horizontalAlignmentToolbar, this.verticalAlignmentToolbar, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createBorderFields() {
        const t = this.options.defaultTableCellProperties,
          e = {
            style: t.borderStyle,
            width: t.borderWidth,
            color: t.borderColor
          },
          n = hN({
            colorConfig: this.options.borderColors,
            columns: 5,
            defaultColorValue: e.color,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          i = this.locale,
          o = this.t,
          r = o("Style"),
          s = new Jh(i);
        s.text = o("Border");
        const a = iN(o),
          l = new Fm(i, zg);
        l.set({
          label: r,
          class: "ck-table-form__border-style"
        }), l.fieldView.buttonView.set({
          ariaLabel: r,
          ariaLabelledBy: void 0,
          isOn: !1,
          withText: !0,
          tooltip: r
        }), l.fieldView.buttonView.bind("label").to(this, "borderStyle", t => a[t || "none"]), l.fieldView.on("execute", t => {
          this.borderStyle = t.source._borderStyleValue;
        }), l.bind("isEmpty").to(this, "borderStyle", t => !t), Sg(l.fieldView, cN(this, e.style), {
          role: "menu",
          ariaLabel: r
        });
        const c = new Fm(i, Lg);
        c.set({
          label: o("Width"),
          class: "ck-table-form__border-width"
        }), c.fieldView.bind("value").to(this, "borderWidth"), c.bind("isEnabled").to(this, "borderStyle", xN), c.fieldView.on("input", () => {
          this.borderWidth = c.fieldView.element.value;
        });
        const d = new Fm(i, n);
        return d.set({
          label: o("Color"),
          class: "ck-table-form__border-color"
        }), d.fieldView.bind("value").to(this, "borderColor"), d.bind("isEnabled").to(this, "borderStyle", xN), d.fieldView.on("input", () => {
          this.borderColor = d.fieldView.value;
        }), this.on("change:borderStyle", (t, n, i, o) => {
          xN(i) || (this.borderColor = "", this.borderWidth = ""), xN(o) || (this.borderColor = e.color, this.borderWidth = e.width);
        }), {
          borderRowLabel: s,
          borderStyleDropdown: l,
          borderColorInput: d,
          borderWidthInput: c
        };
      }
      _createBackgroundFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Background");
        const i = hN({
            colorConfig: this.options.backgroundColors,
            columns: 5,
            defaultColorValue: this.options.defaultTableCellProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          o = new Fm(t, i);
        return o.set({
          label: e("Color"),
          class: "ck-table-cell-properties-form__background"
        }), o.fieldView.bind("value").to(this, "backgroundColor"), o.fieldView.on("input", () => {
          this.backgroundColor = o.fieldView.value;
        }), {
          backgroundRowLabel: n,
          backgroundInput: o
        };
      }
      _createDimensionFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Dimensions");
        const i = new Fm(t, Lg);
        i.set({
          label: e("Width"),
          class: "ck-table-form__dimensions-row__width"
        }), i.fieldView.bind("value").to(this, "width"), i.fieldView.on("input", () => {
          this.width = i.fieldView.element.value;
        });
        const o = new Sr(t);
        o.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck-table-form__dimension-operator"]
          },
          children: [{
            text: "×"
          }]
        });
        const r = new Fm(t, Lg);
        return r.set({
          label: e("Height"),
          class: "ck-table-form__dimensions-row__height"
        }), r.fieldView.bind("value").to(this, "height"), r.fieldView.on("input", () => {
          this.height = r.fieldView.element.value;
        }), {
          dimensionsLabel: n,
          widthInput: i,
          operatorLabel: o,
          heightInput: r
        };
      }
      _createPaddingField() {
        const t = this.locale,
          e = this.t,
          n = new Fm(t, Lg);
        return n.set({
          label: e("Padding"),
          class: "ck-table-cell-properties-form__padding"
        }), n.fieldView.bind("value").to(this, "padding"), n.fieldView.on("input", () => {
          this.padding = n.fieldView.element.value;
        }), n;
      }
      _createAlignmentFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Table cell text alignment");
        const i = new cg(t),
          o = "rtl" === t.contentLanguageDirection;
        i.set({
          isCompact: !0,
          ariaLabel: e("Horizontal text alignment toolbar")
        }), dN({
          view: this,
          icons: vN,
          toolbar: i,
          labels: this._horizontalAlignmentLabels,
          propertyName: "horizontalAlignment",
          nameToValue: t => {
            if (o) {
              if ("left" === t) return "right";
              if ("right" === t) return "left";
            }
            return t;
          },
          defaultValue: this.options.defaultTableCellProperties.horizontalAlignment
        });
        const r = new cg(t);
        return r.set({
          isCompact: !0,
          ariaLabel: e("Vertical text alignment toolbar")
        }), dN({
          view: this,
          icons: vN,
          toolbar: r,
          labels: this._verticalAlignmentLabels,
          propertyName: "verticalAlignment",
          defaultValue: this.options.defaultTableCellProperties.verticalAlignment
        }), {
          horizontalAlignmentToolbar: i,
          verticalAlignmentToolbar: r,
          alignmentLabel: n
        };
      }
      _createActionButtons() {
        const t = this.locale,
          e = this.t,
          n = new mm(t),
          i = new mm(t),
          o = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.paddingInput];
        return n.set({
          label: e("Save"),
          icon: Yh.check,
          class: "ck-button-save",
          type: "submit",
          withText: !0
        }), n.bind("isEnabled").toMany(o, "errorText", function () {
          for (var _len46 = arguments.length, t = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
            t[_key46] = arguments[_key46];
          }
          return t.every(t => !t);
        }), i.set({
          label: e("Cancel"),
          icon: Yh.cancel,
          class: "ck-button-cancel",
          withText: !0
        }), i.delegate("execute").to(this, "cancel"), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      get _horizontalAlignmentLabels() {
        const t = this.locale,
          e = this.t,
          n = e("Align cell text to the left"),
          i = e("Align cell text to the center"),
          o = e("Align cell text to the right"),
          r = e("Justify cell text");
        return "rtl" === t.uiLanguageDirection ? {
          right: o,
          center: i,
          left: n,
          justify: r
        } : {
          left: n,
          center: i,
          right: o,
          justify: r
        };
      }
      get _verticalAlignmentLabels() {
        const t = this.t;
        return {
          top: t("Align cell text to the top"),
          middle: t("Align cell text to the middle"),
          bottom: t("Align cell text to the bottom")
        };
      }
    }
    function xN(t) {
      return "none" !== t;
    }
    const EN = ef.defaultPositions,
      DN = [EN.northArrowSouth, EN.northArrowSouthWest, EN.northArrowSouthEast, EN.southArrowNorth, EN.southArrowNorthWest, EN.southArrowNorthEast, EN.viewportStickyNorth];
    function BN(t, e) {
      const n = t.plugins.get("ContextualBalloon"),
        i = t.editing.view.document.selection;
      let o;
      "cell" === e ? QL(i) && (o = TN(t)) : KL(i) && (o = SN(t)), o && n.updatePosition(o);
    }
    function SN(t) {
      const e = fM(t.model.document.selection),
        n = t.editing.mapper.toViewElement(e);
      return {
        target: t.editing.view.domConverter.mapViewToDom(n),
        positions: DN
      };
    }
    function TN(t) {
      const e = t.editing.mapper,
        n = t.editing.view.domConverter,
        i = t.model.document.selection;
      if (i.rangeCount > 1) return {
        target: () => function (t, e) {
          const n = e.editing.mapper,
            i = e.editing.view.domConverter,
            o = Array.from(t).map(t => {
              const e = IN(t.start),
                o = n.toViewElement(e);
              return new Pi(i.mapViewToDom(o));
            });
          return Pi.getBoundingRect(o);
        }(i.getRanges(), t),
        positions: DN
      };
      const o = IN(i.getFirstPosition()),
        r = e.toViewElement(o);
      return {
        target: n.mapViewToDom(r),
        positions: DN
      };
    }
    function IN(t) {
      return t.nodeAfter && t.nodeAfter.is("element", "tableCell") ? t.nodeAfter : t.findAncestor("tableCell");
    }
    function MN(t) {
      if (!t || !V(t)) return t;
      const {
        top: e,
        right: n,
        bottom: i,
        left: o
      } = t;
      return e == n && n == i && i == o ? e : void 0;
    }
    function LN(t, e) {
      const n = parseFloat(t);
      return Number.isNaN(n) || String(n) !== String(t) ? t : `${n}${e}`;
    }
    function NN(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const n = {
        borderStyle: "none",
        borderWidth: "",
        borderColor: "",
        backgroundColor: "",
        width: "",
        height: "",
        ...t
      };
      return e.includeAlignmentProperty && !n.alignment && (n.alignment = "center"), e.includePaddingProperty && !n.padding && (n.padding = ""), e.includeVerticalAlignmentProperty && !n.verticalAlignment && (n.verticalAlignment = "middle"), e.includeHorizontalAlignmentProperty && !n.horizontalAlignment && (n.horizontalAlignment = e.isRightToLeftContent ? "right" : "left"), n;
    }
    const zN = {
      borderStyle: "tableCellBorderStyle",
      borderColor: "tableCellBorderColor",
      borderWidth: "tableCellBorderWidth",
      height: "tableCellHeight",
      width: "tableCellWidth",
      padding: "tableCellPadding",
      backgroundColor: "tableCellBackgroundColor",
      horizontalAlignment: "tableCellHorizontalAlignment",
      verticalAlignment: "tableCellVerticalAlignment"
    };
    class PN extends Nr {
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "TableCellPropertiesUI";
      }
      constructor(t) {
        super(t), t.config.define("table.tableCellProperties", {
          borderColors: uN,
          backgroundColors: uN
        });
      }
      init() {
        const t = this.editor,
          e = t.t;
        this._defaultTableCellProperties = NN(t.config.get("table.tableCellProperties.defaultProperties"), {
          includeVerticalAlignmentProperty: !0,
          includeHorizontalAlignmentProperty: !0,
          includePaddingProperty: !0,
          isRightToLeftContent: "rtl" === t.locale.contentLanguageDirection
        }), this._balloon = t.plugins.get(Rf), this.view = null, this._isReady = !1, t.ui.componentFactory.add("tableCellProperties", n => {
          const i = new mm(n);
          i.set({
            label: e("Cell properties"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5h3.105zM2 12h5V8H2v4zm10-4H8v4h4V8zM2 2v5h5V2H2zm0 16h5v-5H2v5zM13 7h5V2h-5v5zM8 2v5h4V2H8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM13 6a1 1 0 0 1 1 1v3.172a2.047 2.047 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.976 1.976 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm-1 2H8v4h4V8z"/></svg>',
            tooltip: !0
          }), this.listenTo(i, "execute", () => this._showView());
          const o = Object.values(zN).map(e => t.commands.get(e));
          return i.bind("isEnabled").toMany(o, "isEnabled", function () {
            for (var _len47 = arguments.length, t = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
              t[_key47] = arguments[_key47];
            }
            return t.some(t => t);
          }), i;
        });
      }
      destroy() {
        super.destroy(), this.view && this.view.destroy();
      }
      _createPropertiesView() {
        const t = this.editor,
          e = t.config.get("table.tableCellProperties"),
          n = ym(e.borderColors),
          i = vm(t.locale, n),
          o = ym(e.backgroundColors),
          r = vm(t.locale, o),
          s = !1 !== e.colorPicker,
          a = new yN(t.locale, {
            borderColors: i,
            backgroundColors: r,
            defaultTableCellProperties: this._defaultTableCellProperties,
            colorPickerConfig: !!s && (e.colorPicker || {})
          }),
          l = t.t;
        a.render(), this.listenTo(a, "submit", () => {
          this._hideView();
        }), this.listenTo(a, "cancel", () => {
          this._undoStepBatch.operations.length && t.execute("undo", this._undoStepBatch), this._hideView();
        }), a.keystrokes.set("Esc", (t, e) => {
          this._hideView(), e();
        }), Tr({
          emitter: a,
          activator: () => this._isViewInBalloon,
          contextElements: [this._balloon.view.element],
          callback: () => this._hideView()
        });
        const c = oN(l),
          d = rN(l);
        return a.on("change:borderStyle", this._getPropertyChangeCallback("tableCellBorderStyle")), a.on("change:borderColor", this._getValidatedPropertyChangeCallback({
          viewField: a.borderColorInput,
          commandName: "tableCellBorderColor",
          errorText: c,
          validator: sN
        })), a.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
          viewField: a.borderWidthInput,
          commandName: "tableCellBorderWidth",
          errorText: d,
          validator: lN
        })), a.on("change:padding", this._getValidatedPropertyChangeCallback({
          viewField: a.paddingInput,
          commandName: "tableCellPadding",
          errorText: d,
          validator: aN
        })), a.on("change:width", this._getValidatedPropertyChangeCallback({
          viewField: a.widthInput,
          commandName: "tableCellWidth",
          errorText: d,
          validator: aN
        })), a.on("change:height", this._getValidatedPropertyChangeCallback({
          viewField: a.heightInput,
          commandName: "tableCellHeight",
          errorText: d,
          validator: aN
        })), a.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
          viewField: a.backgroundInput,
          commandName: "tableCellBackgroundColor",
          errorText: c,
          validator: sN
        })), a.on("change:horizontalAlignment", this._getPropertyChangeCallback("tableCellHorizontalAlignment")), a.on("change:verticalAlignment", this._getPropertyChangeCallback("tableCellVerticalAlignment")), a;
      }
      _fillViewFormFromCommandValues() {
        const t = this.editor.commands,
          e = t.get("tableCellBorderStyle");
        Object.entries(zN).map(_ref224 => {
          let [e, n] = _ref224;
          const i = this._defaultTableCellProperties[e] || "";
          return [e, t.get(n).value || i];
        }).forEach(_ref225 => {
          let [t, n] = _ref225;
          ("borderColor" !== t && "borderWidth" !== t || "none" !== e.value) && this.view.set(t, n);
        }), this._isReady = !0;
      }
      _showView() {
        const t = this.editor;
        this.view || (this.view = this._createPropertiesView()), this.listenTo(t.ui, "update", () => {
          this._updateView();
        }), this._fillViewFormFromCommandValues(), this._balloon.add({
          view: this.view,
          position: TN(t)
        }), this._undoStepBatch = t.model.createBatch(), this.view.focus();
      }
      _hideView() {
        const t = this.editor;
        this.stopListening(t.ui, "update"), this._isReady = !1, this.view.saveButtonView.focus(), this._balloon.remove(this.view), this.editor.editing.view.focus();
      }
      _updateView() {
        const t = this.editor;
        QL(t.editing.view.document.selection) ? this._isViewVisible && BN(t, "cell") : this._hideView();
      }
      get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
      }
      get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
      }
      _getPropertyChangeCallback(t) {
        return (e, n, i) => {
          this._isReady && this.editor.execute(t, {
            value: i,
            batch: this._undoStepBatch
          });
        };
      }
      _getValidatedPropertyChangeCallback(t) {
        const {
            commandName: e,
            viewField: n,
            validator: i,
            errorText: o
          } = t,
          r = kl(() => {
            n.errorText = o;
          }, 500);
        return (t, o, s) => {
          r.cancel(), this._isReady && (i(s) ? (this.editor.execute(e, {
            value: s,
            batch: this._undoStepBatch
          }), n.errorText = null) : r());
        };
      }
    }
    class VN extends Pr {
      constructor(t, e, n) {
        super(t), this.attributeName = e, this._defaultValue = n;
      }
      refresh() {
        const t = this.editor,
          e = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t.model.document.selection);
        this.isEnabled = !!e.length, this.value = this._getSingleValue(e);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
            value: e,
            batch: n
          } = t,
          i = this.editor.model,
          o = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(i.document.selection),
          r = this._getValueToSet(e);
        i.enqueueChange(n, t => {
          r ? o.forEach(e => t.setAttribute(this.attributeName, r, e)) : o.forEach(e => t.removeAttribute(this.attributeName, e));
        });
      }
      _getAttribute(t) {
        if (!t) return;
        const e = t.getAttribute(this.attributeName);
        return e !== this._defaultValue ? e : void 0;
      }
      _getValueToSet(t) {
        if (t !== this._defaultValue) return t;
      }
      _getSingleValue(t) {
        const e = this._getAttribute(t[0]);
        return t.every(t => this._getAttribute(t) === e) ? e : void 0;
      }
    }
    class RN extends VN {
      constructor(t, e) {
        super(t, "tableCellWidth", e);
      }
      _getValueToSet(t) {
        if ((t = LN(t, "px")) !== this._defaultValue) return t;
      }
    }
    class FN extends Nr {
      static get pluginName() {
        return "TableCellWidthEditing";
      }
      static get requires() {
        return [BL];
      }
      init() {
        const t = this.editor,
          e = NN(t.config.get("table.tableCellProperties.defaultProperties"));
        pM(t.model.schema, t.conversion, {
          modelAttribute: "tableCellWidth",
          styleName: "width",
          defaultValue: e.width
        }), t.commands.add("tableCellWidth", new RN(t, e.width));
      }
    }
    class ON extends VN {
      constructor(t, e) {
        super(t, "tableCellPadding", e);
      }
      _getAttribute(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
      _getValueToSet(t) {
        const e = LN(t, "px");
        if (e !== this._defaultValue) return e;
      }
    }
    class jN extends VN {
      constructor(t, e) {
        super(t, "tableCellHeight", e);
      }
      _getValueToSet(t) {
        const e = LN(t, "px");
        if (e !== this._defaultValue) return e;
      }
    }
    class HN extends VN {
      constructor(t, e) {
        super(t, "tableCellBackgroundColor", e);
      }
    }
    class UN extends VN {
      constructor(t, e) {
        super(t, "tableCellVerticalAlignment", e);
      }
    }
    class qN extends VN {
      constructor(t, e) {
        super(t, "tableCellHorizontalAlignment", e);
      }
    }
    class GN extends VN {
      constructor(t, e) {
        super(t, "tableCellBorderStyle", e);
      }
      _getAttribute(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
    }
    class WN extends VN {
      constructor(t, e) {
        super(t, "tableCellBorderColor", e);
      }
      _getAttribute(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
    }
    class $N extends VN {
      constructor(t, e) {
        super(t, "tableCellBorderWidth", e);
      }
      _getAttribute(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
      _getValueToSet(t) {
        const e = LN(t, "px");
        if (e !== this._defaultValue) return e;
      }
    }
    const KN = /^(top|middle|bottom)$/,
      YN = /^(left|center|right|justify)$/;
    class QN extends Nr {
      static get pluginName() {
        return "TableCellPropertiesEditing";
      }
      static get requires() {
        return [BL, FN];
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.conversion;
        t.config.define("table.tableCellProperties.defaultProperties", {});
        const i = NN(t.config.get("table.tableCellProperties.defaultProperties"), {
          includeVerticalAlignmentProperty: !0,
          includeHorizontalAlignmentProperty: !0,
          includePaddingProperty: !0,
          isRightToLeftContent: "rtl" === t.locale.contentLanguageDirection
        });
        t.data.addStyleProcessorRules(Sh), function (t, e, n) {
          const i = {
            width: "tableCellBorderWidth",
            color: "tableCellBorderColor",
            style: "tableCellBorderStyle"
          };
          t.extend("tableCell", {
            allowAttributes: Object.values(i)
          }), lM(e, "td", i, n), lM(e, "th", i, n), cM(e, {
            modelElement: "tableCell",
            modelAttribute: i.style,
            styleName: "border-style"
          }), cM(e, {
            modelElement: "tableCell",
            modelAttribute: i.color,
            styleName: "border-color"
          }), cM(e, {
            modelElement: "tableCell",
            modelAttribute: i.width,
            styleName: "border-width"
          });
        }(e, n, {
          color: i.borderColor,
          style: i.borderStyle,
          width: i.borderWidth
        }), t.commands.add("tableCellBorderStyle", new GN(t, i.borderStyle)), t.commands.add("tableCellBorderColor", new WN(t, i.borderColor)), t.commands.add("tableCellBorderWidth", new $N(t, i.borderWidth)), pM(e, n, {
          modelAttribute: "tableCellHeight",
          styleName: "height",
          defaultValue: i.height
        }), t.commands.add("tableCellHeight", new jN(t, i.height)), t.data.addStyleProcessorRules(Oh), pM(e, n, {
          modelAttribute: "tableCellPadding",
          styleName: "padding",
          reduceBoxSides: !0,
          defaultValue: i.padding
        }), t.commands.add("tableCellPadding", new ON(t, i.padding)), t.data.addStyleProcessorRules(Bh), pM(e, n, {
          modelAttribute: "tableCellBackgroundColor",
          styleName: "background-color",
          defaultValue: i.backgroundColor
        }), t.commands.add("tableCellBackgroundColor", new HN(t, i.backgroundColor)), function (t, e, n) {
          t.extend("tableCell", {
            allowAttributes: ["tableCellHorizontalAlignment"]
          }), e.for("downcast").attributeToAttribute({
            model: {
              name: "tableCell",
              key: "tableCellHorizontalAlignment"
            },
            view: t => ({
              key: "style",
              value: {
                "text-align": t
              }
            })
          }), e.for("upcast").attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              styles: {
                "text-align": YN
              }
            },
            model: {
              key: "tableCellHorizontalAlignment",
              value: t => {
                const e = t.getStyle("text-align");
                return e === n ? null : e;
              }
            }
          }).attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              attributes: {
                align: YN
              }
            },
            model: {
              key: "tableCellHorizontalAlignment",
              value: t => {
                const e = t.getAttribute("align");
                return e === n ? null : e;
              }
            }
          });
        }(e, n, i.horizontalAlignment), t.commands.add("tableCellHorizontalAlignment", new qN(t, i.horizontalAlignment)), function (t, e, n) {
          t.extend("tableCell", {
            allowAttributes: ["tableCellVerticalAlignment"]
          }), e.for("downcast").attributeToAttribute({
            model: {
              name: "tableCell",
              key: "tableCellVerticalAlignment"
            },
            view: t => ({
              key: "style",
              value: {
                "vertical-align": t
              }
            })
          }), e.for("upcast").attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              styles: {
                "vertical-align": KN
              }
            },
            model: {
              key: "tableCellVerticalAlignment",
              value: t => {
                const e = t.getStyle("vertical-align");
                return e === n ? null : e;
              }
            }
          }).attributeToAttribute({
            view: {
              name: /^(td|th)$/,
              attributes: {
                valign: KN
              }
            },
            model: {
              key: "tableCellVerticalAlignment",
              value: t => {
                const e = t.getAttribute("valign");
                return e === n ? null : e;
              }
            }
          });
        }(e, n, i.verticalAlignment), t.commands.add("tableCellVerticalAlignment", new UN(t, i.verticalAlignment));
      }
    }
    class ZN extends Pr {
      constructor(t, e, n) {
        super(t), this.attributeName = e, this._defaultValue = n;
      }
      refresh() {
        const t = fM(this.editor.model.document.selection);
        this.isEnabled = !!t, this.value = this._getValue(t);
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const e = this.editor.model,
          n = e.document.selection,
          {
            value: i,
            batch: o
          } = t,
          r = fM(n),
          s = this._getValueToSet(i);
        e.enqueueChange(o, t => {
          s ? t.setAttribute(this.attributeName, s, r) : t.removeAttribute(this.attributeName, r);
        });
      }
      _getValue(t) {
        if (!t) return;
        const e = t.getAttribute(this.attributeName);
        return e !== this._defaultValue ? e : void 0;
      }
      _getValueToSet(t) {
        if (t !== this._defaultValue) return t;
      }
    }
    class JN extends ZN {
      constructor(t, e) {
        super(t, "tableBackgroundColor", e);
      }
    }
    class XN extends ZN {
      constructor(t, e) {
        super(t, "tableBorderColor", e);
      }
      _getValue(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
    }
    class tz extends ZN {
      constructor(t, e) {
        super(t, "tableBorderStyle", e);
      }
      _getValue(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
    }
    class ez extends ZN {
      constructor(t, e) {
        super(t, "tableBorderWidth", e);
      }
      _getValue(t) {
        if (!t) return;
        const e = MN(t.getAttribute(this.attributeName));
        return e !== this._defaultValue ? e : void 0;
      }
      _getValueToSet(t) {
        const e = LN(t, "px");
        if (e !== this._defaultValue) return e;
      }
    }
    class nz extends ZN {
      constructor(t, e) {
        super(t, "tableWidth", e);
      }
      _getValueToSet(t) {
        if ((t = LN(t, "px")) !== this._defaultValue) return t;
      }
    }
    class iz extends ZN {
      constructor(t, e) {
        super(t, "tableHeight", e);
      }
      _getValueToSet(t) {
        if ((t = LN(t, "px")) !== this._defaultValue) return t;
      }
    }
    class oz extends ZN {
      constructor(t, e) {
        super(t, "tableAlignment", e);
      }
    }
    const rz = /^(left|center|right)$/,
      sz = /^(left|none|right)$/;
    class az extends Nr {
      static get pluginName() {
        return "TablePropertiesEditing";
      }
      static get requires() {
        return [BL];
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.conversion;
        t.config.define("table.tableProperties.defaultProperties", {});
        const i = NN(t.config.get("table.tableProperties.defaultProperties"), {
          includeAlignmentProperty: !0
        });
        t.data.addStyleProcessorRules(Sh), function (t, e, n) {
          const i = {
            width: "tableBorderWidth",
            color: "tableBorderColor",
            style: "tableBorderStyle"
          };
          t.extend("table", {
            allowAttributes: Object.values(i)
          }), lM(e, "table", i, n), dM(e, {
            modelAttribute: i.color,
            styleName: "border-color"
          }), dM(e, {
            modelAttribute: i.style,
            styleName: "border-style"
          }), dM(e, {
            modelAttribute: i.width,
            styleName: "border-width"
          });
        }(e, n, {
          color: i.borderColor,
          style: i.borderStyle,
          width: i.borderWidth
        }), t.commands.add("tableBorderColor", new XN(t, i.borderColor)), t.commands.add("tableBorderStyle", new tz(t, i.borderStyle)), t.commands.add("tableBorderWidth", new ez(t, i.borderWidth)), function (t, e, n) {
          t.extend("table", {
            allowAttributes: ["tableAlignment"]
          }), e.for("downcast").attributeToAttribute({
            model: {
              name: "table",
              key: "tableAlignment"
            },
            view: t => ({
              key: "style",
              value: {
                float: "center" === t ? "none" : t
              }
            }),
            converterPriority: "high"
          }), e.for("upcast").attributeToAttribute({
            view: {
              name: /^(table|figure)$/,
              styles: {
                float: sz
              }
            },
            model: {
              key: "tableAlignment",
              value: t => {
                let e = t.getStyle("float");
                return "none" === e && (e = "center"), e === n ? null : e;
              }
            }
          }).attributeToAttribute({
            view: {
              attributes: {
                align: rz
              }
            },
            model: {
              name: "table",
              key: "tableAlignment",
              value: t => {
                const e = t.getAttribute("align");
                return e === n ? null : e;
              }
            }
          });
        }(e, n, i.alignment), t.commands.add("tableAlignment", new oz(t, i.alignment)), lz(e, n, {
          modelAttribute: "tableWidth",
          styleName: "width",
          defaultValue: i.width
        }), t.commands.add("tableWidth", new nz(t, i.width)), lz(e, n, {
          modelAttribute: "tableHeight",
          styleName: "height",
          defaultValue: i.height
        }), t.commands.add("tableHeight", new iz(t, i.height)), t.data.addStyleProcessorRules(Bh), function (t, e, n) {
          const {
            modelAttribute: i
          } = n;
          t.extend("table", {
            allowAttributes: [i]
          }), aM(e, {
            viewElement: "table",
            ...n
          }), dM(e, n);
        }(e, n, {
          modelAttribute: "tableBackgroundColor",
          styleName: "background-color",
          defaultValue: i.backgroundColor
        }), t.commands.add("tableBackgroundColor", new JN(t, i.backgroundColor));
      }
    }
    function lz(t, e, n) {
      const {
        modelAttribute: i
      } = n;
      t.extend("table", {
        allowAttributes: [i]
      }), aM(e, {
        viewElement: /^(table|figure)$/,
        shouldUpcast: t => !("table" == t.name && "figure" == t.parent.name),
        ...n
      }), cM(e, {
        modelElement: "table",
        ...n
      });
    }
    var cz = o(4001),
      dz = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(cz.A, dz);
    cz.A.locals;
    const uz = {
      left: Yh.objectLeft,
      center: Yh.objectCenter,
      right: Yh.objectRight
    };
    class hz extends Sr {
      constructor(t, e) {
        super(t), this.set({
          borderStyle: "",
          borderWidth: "",
          borderColor: "",
          backgroundColor: "",
          width: "",
          height: "",
          alignment: ""
        }), this.options = e;
        const {
            borderStyleDropdown: n,
            borderWidthInput: i,
            borderColorInput: o,
            borderRowLabel: r
          } = this._createBorderFields(),
          {
            backgroundRowLabel: s,
            backgroundInput: a
          } = this._createBackgroundFields(),
          {
            widthInput: l,
            operatorLabel: c,
            heightInput: d,
            dimensionsLabel: u
          } = this._createDimensionFields(),
          {
            alignmentToolbar: h,
            alignmentLabel: m
          } = this._createAlignmentFields();
        this.focusTracker = new Ko(), this.keystrokes = new Yo(), this.children = this.createCollection(), this.borderStyleDropdown = n, this.borderWidthInput = i, this.borderColorInput = o, this.backgroundInput = a, this.widthInput = l, this.heightInput = d, this.alignmentToolbar = h;
        const {
          saveButtonView: g,
          cancelButtonView: p
        } = this._createActionButtons();
        this.saveButtonView = g, this.cancelButtonView = p, this._focusables = new nr(), this._focusCycler = new tg({
          focusables: this._focusables,
          focusTracker: this.focusTracker,
          keystrokeHandler: this.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), this.children.add(new Ip(t, {
          label: this.t("Table properties")
        })), this.children.add(new fN(t, {
          labelView: r,
          children: [r, n, o, i],
          class: "ck-table-form__border-row"
        })), this.children.add(new fN(t, {
          labelView: s,
          children: [s, a],
          class: "ck-table-form__background-row"
        })), this.children.add(new fN(t, {
          children: [new fN(t, {
            labelView: u,
            children: [u, l, c, d],
            class: "ck-table-form__dimensions-row"
          }), new fN(t, {
            labelView: m,
            children: [m, h],
            class: "ck-table-properties-form__alignment-row"
          })]
        })), this.children.add(new fN(t, {
          children: [this.saveButtonView, this.cancelButtonView],
          class: "ck-table-form__action-row"
        })), this.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-form", "ck-table-form", "ck-table-properties-form"],
            tabindex: "-1"
          },
          children: this.children
        });
      }
      render() {
        super.render(), Mr({
          view: this
        }), [this.borderColorInput, this.backgroundInput].forEach(t => {
          t.fieldView.focusCycler.on("forwardCycle", t => {
            this._focusCycler.focusNext(), t.stop();
          }), t.fieldView.focusCycler.on("backwardCycle", t => {
            this._focusCycler.focusPrevious(), t.stop();
          });
        }), [this.borderStyleDropdown, this.borderColorInput, this.borderWidthInput, this.backgroundInput, this.widthInput, this.heightInput, this.alignmentToolbar, this.saveButtonView, this.cancelButtonView].forEach(t => {
          this._focusables.add(t), this.focusTracker.add(t.element);
        }), this.keystrokes.listenTo(this.element);
      }
      destroy() {
        super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
      }
      focus() {
        this._focusCycler.focusFirst();
      }
      _createBorderFields() {
        const t = this.options.defaultTableProperties,
          e = {
            style: t.borderStyle,
            width: t.borderWidth,
            color: t.borderColor
          },
          n = hN({
            colorConfig: this.options.borderColors,
            columns: 5,
            defaultColorValue: e.color,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          i = this.locale,
          o = this.t,
          r = o("Style"),
          s = new Jh(i);
        s.text = o("Border");
        const a = iN(o),
          l = new Fm(i, zg);
        l.set({
          label: r,
          class: "ck-table-form__border-style"
        }), l.fieldView.buttonView.set({
          ariaLabel: r,
          ariaLabelledBy: void 0,
          isOn: !1,
          withText: !0,
          tooltip: r
        }), l.fieldView.buttonView.bind("label").to(this, "borderStyle", t => a[t || "none"]), l.fieldView.on("execute", t => {
          this.borderStyle = t.source._borderStyleValue;
        }), l.bind("isEmpty").to(this, "borderStyle", t => !t), Sg(l.fieldView, cN(this, e.style), {
          role: "menu",
          ariaLabel: r
        });
        const c = new Fm(i, Lg);
        c.set({
          label: o("Width"),
          class: "ck-table-form__border-width"
        }), c.fieldView.bind("value").to(this, "borderWidth"), c.bind("isEnabled").to(this, "borderStyle", mz), c.fieldView.on("input", () => {
          this.borderWidth = c.fieldView.element.value;
        });
        const d = new Fm(i, n);
        return d.set({
          label: o("Color"),
          class: "ck-table-form__border-color"
        }), d.fieldView.bind("value").to(this, "borderColor"), d.bind("isEnabled").to(this, "borderStyle", mz), d.fieldView.on("input", () => {
          this.borderColor = d.fieldView.value;
        }), this.on("change:borderStyle", (t, n, i, o) => {
          mz(i) || (this.borderColor = "", this.borderWidth = ""), mz(o) || (this.borderColor = e.color, this.borderWidth = e.width);
        }), {
          borderRowLabel: s,
          borderStyleDropdown: l,
          borderColorInput: d,
          borderWidthInput: c
        };
      }
      _createBackgroundFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Background");
        const i = hN({
            colorConfig: this.options.backgroundColors,
            columns: 5,
            defaultColorValue: this.options.defaultTableProperties.backgroundColor,
            colorPickerConfig: this.options.colorPickerConfig
          }),
          o = new Fm(t, i);
        return o.set({
          label: e("Color"),
          class: "ck-table-properties-form__background"
        }), o.fieldView.bind("value").to(this, "backgroundColor"), o.fieldView.on("input", () => {
          this.backgroundColor = o.fieldView.value;
        }), {
          backgroundRowLabel: n,
          backgroundInput: o
        };
      }
      _createDimensionFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Dimensions");
        const i = new Fm(t, Lg);
        i.set({
          label: e("Width"),
          class: "ck-table-form__dimensions-row__width"
        }), i.fieldView.bind("value").to(this, "width"), i.fieldView.on("input", () => {
          this.width = i.fieldView.element.value;
        });
        const o = new Sr(t);
        o.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck-table-form__dimension-operator"]
          },
          children: [{
            text: "×"
          }]
        });
        const r = new Fm(t, Lg);
        return r.set({
          label: e("Height"),
          class: "ck-table-form__dimensions-row__height"
        }), r.fieldView.bind("value").to(this, "height"), r.fieldView.on("input", () => {
          this.height = r.fieldView.element.value;
        }), {
          dimensionsLabel: n,
          widthInput: i,
          operatorLabel: o,
          heightInput: r
        };
      }
      _createAlignmentFields() {
        const t = this.locale,
          e = this.t,
          n = new Jh(t);
        n.text = e("Alignment");
        const i = new cg(t);
        return i.set({
          isCompact: !0,
          ariaLabel: e("Table alignment toolbar")
        }), dN({
          view: this,
          icons: uz,
          toolbar: i,
          labels: this._alignmentLabels,
          propertyName: "alignment",
          defaultValue: this.options.defaultTableProperties.alignment
        }), {
          alignmentLabel: n,
          alignmentToolbar: i
        };
      }
      _createActionButtons() {
        const t = this.locale,
          e = this.t,
          n = new mm(t),
          i = new mm(t),
          o = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.widthInput, this.heightInput];
        return n.set({
          label: e("Save"),
          icon: Yh.check,
          class: "ck-button-save",
          type: "submit",
          withText: !0
        }), n.bind("isEnabled").toMany(o, "errorText", function () {
          for (var _len48 = arguments.length, t = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
            t[_key48] = arguments[_key48];
          }
          return t.every(t => !t);
        }), i.set({
          label: e("Cancel"),
          icon: Yh.cancel,
          class: "ck-button-cancel",
          withText: !0
        }), i.delegate("execute").to(this, "cancel"), {
          saveButtonView: n,
          cancelButtonView: i
        };
      }
      get _alignmentLabels() {
        const t = this.locale,
          e = this.t,
          n = e("Align table to the left"),
          i = e("Center table"),
          o = e("Align table to the right");
        return "rtl" === t.uiLanguageDirection ? {
          right: o,
          center: i,
          left: n
        } : {
          left: n,
          center: i,
          right: o
        };
      }
    }
    function mz(t) {
      return "none" !== t;
    }
    const gz = {
      borderStyle: "tableBorderStyle",
      borderColor: "tableBorderColor",
      borderWidth: "tableBorderWidth",
      backgroundColor: "tableBackgroundColor",
      width: "tableWidth",
      height: "tableHeight",
      alignment: "tableAlignment"
    };
    class pz extends Nr {
      static get requires() {
        return [Rf];
      }
      static get pluginName() {
        return "TablePropertiesUI";
      }
      constructor(t) {
        super(t), this.view = null, t.config.define("table.tableProperties", {
          borderColors: uN,
          backgroundColors: uN
        });
      }
      init() {
        const t = this.editor,
          e = t.t;
        this._defaultTableProperties = NN(t.config.get("table.tableProperties.defaultProperties"), {
          includeAlignmentProperty: !0
        }), this._balloon = t.plugins.get(Rf), t.ui.componentFactory.add("tableProperties", n => {
          const i = new mm(n);
          i.set({
            label: e("Table properties"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2h1zm4 6H8v4h4V8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2.048 2.048 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14z"/></svg>',
            tooltip: !0
          }), this.listenTo(i, "execute", () => this._showView());
          const o = Object.values(gz).map(e => t.commands.get(e));
          return i.bind("isEnabled").toMany(o, "isEnabled", function () {
            for (var _len49 = arguments.length, t = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
              t[_key49] = arguments[_key49];
            }
            return t.some(t => t);
          }), i;
        });
      }
      destroy() {
        super.destroy(), this.view && this.view.destroy();
      }
      _createPropertiesView() {
        const t = this.editor,
          e = t.config.get("table.tableProperties"),
          n = ym(e.borderColors),
          i = vm(t.locale, n),
          o = ym(e.backgroundColors),
          r = vm(t.locale, o),
          s = !1 !== e.colorPicker,
          a = new hz(t.locale, {
            borderColors: i,
            backgroundColors: r,
            defaultTableProperties: this._defaultTableProperties,
            colorPickerConfig: !!s && (e.colorPicker || {})
          }),
          l = t.t;
        a.render(), this.listenTo(a, "submit", () => {
          this._hideView();
        }), this.listenTo(a, "cancel", () => {
          this._undoStepBatch.operations.length && t.execute("undo", this._undoStepBatch), this._hideView();
        }), a.keystrokes.set("Esc", (t, e) => {
          this._hideView(), e();
        }), Tr({
          emitter: a,
          activator: () => this._isViewInBalloon,
          contextElements: [this._balloon.view.element],
          callback: () => this._hideView()
        });
        const c = oN(l),
          d = rN(l);
        return a.on("change:borderStyle", this._getPropertyChangeCallback("tableBorderStyle")), a.on("change:borderColor", this._getValidatedPropertyChangeCallback({
          viewField: a.borderColorInput,
          commandName: "tableBorderColor",
          errorText: c,
          validator: sN
        })), a.on("change:borderWidth", this._getValidatedPropertyChangeCallback({
          viewField: a.borderWidthInput,
          commandName: "tableBorderWidth",
          errorText: d,
          validator: lN
        })), a.on("change:backgroundColor", this._getValidatedPropertyChangeCallback({
          viewField: a.backgroundInput,
          commandName: "tableBackgroundColor",
          errorText: c,
          validator: sN
        })), a.on("change:width", this._getValidatedPropertyChangeCallback({
          viewField: a.widthInput,
          commandName: "tableWidth",
          errorText: d,
          validator: aN
        })), a.on("change:height", this._getValidatedPropertyChangeCallback({
          viewField: a.heightInput,
          commandName: "tableHeight",
          errorText: d,
          validator: aN
        })), a.on("change:alignment", this._getPropertyChangeCallback("tableAlignment")), a;
      }
      _fillViewFormFromCommandValues() {
        const t = this.editor.commands,
          e = t.get("tableBorderStyle");
        Object.entries(gz).map(_ref226 => {
          let [e, n] = _ref226;
          const i = e,
            o = this._defaultTableProperties[i] || "";
          return [i, t.get(n).value || o];
        }).forEach(_ref227 => {
          let [t, n] = _ref227;
          ("borderColor" !== t && "borderWidth" !== t || "none" !== e.value) && this.view.set(t, n);
        }), this._isReady = !0;
      }
      _showView() {
        const t = this.editor;
        this.view || (this.view = this._createPropertiesView()), this.listenTo(t.ui, "update", () => {
          this._updateView();
        }), this._fillViewFormFromCommandValues(), this._balloon.add({
          view: this.view,
          position: SN(t)
        }), this._undoStepBatch = t.model.createBatch(), this.view.focus();
      }
      _hideView() {
        const t = this.editor;
        this.stopListening(t.ui, "update"), this._isReady = !1, this.view.saveButtonView.focus(), this._balloon.remove(this.view), this.editor.editing.view.focus();
      }
      _updateView() {
        const t = this.editor;
        KL(t.editing.view.document.selection) ? this._isViewVisible && BN(t, "table") : this._hideView();
      }
      get _isViewVisible() {
        return !!this.view && this._balloon.visibleView === this.view;
      }
      get _isViewInBalloon() {
        return !!this.view && this._balloon.hasView(this.view);
      }
      _getPropertyChangeCallback(t) {
        return (e, n, i) => {
          this._isReady && this.editor.execute(t, {
            value: i,
            batch: this._undoStepBatch
          });
        };
      }
      _getValidatedPropertyChangeCallback(t) {
        const {
            commandName: e,
            viewField: n,
            validator: i,
            errorText: o
          } = t,
          r = kl(() => {
            n.errorText = o;
          }, 500);
        return (t, o, s) => {
          r.cancel(), this._isReady && (i(s) ? (this.editor.execute(e, {
            value: s,
            batch: this._undoStepBatch
          }), n.errorText = null) : r());
        };
      }
    }
    function fz(t) {
      t.document.registerPostFixer(e => function (t, e) {
        const n = e.document.differ.getChanges();
        let i = !1;
        for (const e of n) {
          if ("insert" != e.type) continue;
          const n = e.position.parent;
          if (n.is("element", "table") || "table" == e.name) {
            const o = "table" == e.name ? e.position.nodeAfter : n,
              r = Array.from(o.getChildren()).filter(t => t.is("element", "caption")),
              s = r.shift();
            if (!s) continue;
            for (const e of r) t.move(t.createRangeIn(e), s, "end"), t.remove(e);
            s.nextSibling && (t.move(t.createRangeOn(s), o, "end"), i = !0), i = !!r.length || i;
          }
        }
        return i;
      }(e, t));
    }
    function kz(t) {
      return !!t && t.is("element", "table");
    }
    function bz(t) {
      for (const e of t.getChildren()) if (e.is("element", "caption")) return e;
      return null;
    }
    function wz(t) {
      const e = t.parent;
      return "figcaption" == t.name && e && e.is("element", "figure") && e.hasClass("table") || "caption" == t.name && e && e.is("element", "table") ? {
        name: !0
      } : null;
    }
    class Az extends Pr {
      refresh() {
        const t = fM(this.editor.model.document.selection);
        this.isEnabled = !!t, this.isEnabled ? this.value = !!bz(t) : this.value = !1;
      }
      execute() {
        let {
          focusCaptionOnShow: t = !1
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.editor.model.change(e => {
          this.value ? this._hideTableCaption(e) : this._showTableCaption(e, t);
        });
      }
      _showTableCaption(t, e) {
        const n = this.editor.model,
          i = fM(n.document.selection),
          o = this.editor.plugins.get("TableCaptionEditing")._getSavedCaption(i) || t.createElement("caption");
        n.insertContent(o, i, "end"), e && t.setSelection(o, "in");
      }
      _hideTableCaption(t) {
        const e = this.editor.model,
          n = fM(e.document.selection),
          i = this.editor.plugins.get("TableCaptionEditing"),
          o = bz(n);
        i._saveCaption(n, o), e.deleteContent(t.createSelection(o, "on"));
      }
    }
    class Cz extends Nr {
      static get pluginName() {
        return "TableCaptionEditing";
      }
      constructor(t) {
        super(t), this._savedCaptionsMap = new WeakMap();
      }
      init() {
        const t = this.editor,
          e = t.model.schema,
          n = t.editing.view,
          i = t.t;
        e.isRegistered("caption") ? e.extend("caption", {
          allowIn: "table"
        }) : e.register("caption", {
          allowIn: "table",
          allowContentOf: "$block",
          isLimit: !0
        }), t.commands.add("toggleTableCaption", new Az(this.editor)), t.conversion.for("upcast").elementToElement({
          view: wz,
          model: "caption"
        }), t.conversion.for("dataDowncast").elementToElement({
          model: "caption",
          view: (t, _ref228) => {
            let {
              writer: e
            } = _ref228;
            return kz(t.parent) ? e.createContainerElement("figcaption") : null;
          }
        }), t.conversion.for("editingDowncast").elementToElement({
          model: "caption",
          view: (t, _ref229) => {
            let {
              writer: e
            } = _ref229;
            if (!kz(t.parent)) return null;
            const o = e.createEditableElement("figcaption");
            return e.setCustomProperty("tableCaption", !0, o), o.placeholder = i("Enter table caption"), Wr({
              view: n,
              element: o,
              keepOnFocus: !0
            }), Nw(o, e);
          }
        }), fz(t.model);
      }
      _getSavedCaption(t) {
        const e = this._savedCaptionsMap.get(t);
        return e ? ic.fromJSON(e) : null;
      }
      _saveCaption(t, e) {
        this._savedCaptionsMap.set(t, e.toJSON());
      }
    }
    class _z extends Nr {
      static get pluginName() {
        return "TableCaptionUI";
      }
      init() {
        const t = this.editor,
          e = t.editing.view,
          n = t.t;
        t.ui.componentFactory.add("toggleTableCaption", i => {
          const o = t.commands.get("toggleTableCaption"),
            r = new mm(i);
          return r.set({
            icon: Yh.caption,
            tooltip: !0,
            isToggleable: !0
          }), r.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), r.bind("label").to(o, "value", t => n(t ? "Toggle caption off" : "Toggle caption on")), this.listenTo(r, "execute", () => {
            if (t.execute("toggleTableCaption", {
              focusCaptionOnShow: !0
            }), o.value) {
              const n = function (t) {
                  const e = fM(t);
                  return e ? bz(e) : null;
                }(t.model.document.selection),
                i = t.editing.mapper.toViewElement(n);
              if (!i) return;
              e.scrollToTheSelection(), e.change(t => {
                t.addClass("table__caption_highlighted", i);
              });
            }
            t.editing.view.focus();
          }), r;
        });
      }
    }
    var vz = o(7406),
      yz = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(vz.A, yz);
    vz.A.locals;
    class xz extends Pr {
      refresh() {
        this.isEnabled = !0;
      }
      execute() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          model: e,
          plugins: n
        } = this.editor;
        let {
          table: i = e.document.selection.getSelectedElement(),
          columnWidths: o,
          tableWidth: r
        } = t;
        o && (o = Array.isArray(o) ? o : o.split(",")), e.change(t => {
          r ? t.setAttribute("tableWidth", r, i) : t.removeAttribute("tableWidth", i);
          const e = n.get("TableColumnResizeEditing").getColumnGroupElement(i);
          if (!o && !e) return;
          if (!o) return t.remove(e);
          const s = tL(o);
          if (e) Array.from(e.getChildren()).forEach((e, n) => t.setAttribute("columnWidth", s[n], e));else {
            const e = t.createElement("tableColumnGroup");
            s.forEach(n => t.appendElement("tableColumn", {
              columnWidth: n
            }, e)), t.append(e, i);
          }
        });
      }
    }
    function Ez(t) {
      return e => e.on("element:colgroup", (e, n, i) => {
        const o = n.modelCursor.findAncestor("table"),
          r = iL(o);
        if (!r) return;
        const s = oL(r),
          a = t.getColumns(o);
        let l = (c = r, d = i.writer, oL(c).reduce((t, e) => {
          const n = e.getAttribute("columnWidth"),
            i = e.getAttribute("colSpan");
          if (!i) return t.push(n), t;
          for (let e = 0; e < i; e++) t.push(n);
          return d.removeAttribute("colSpan", e), t;
        }, []));
        var c, d;
        l = Array.from({
          length: a
        }, (t, e) => l[e] || "auto"), (l.length != s.length || l.includes("auto")) && nL(s, r, tL(l), i.writer);
      }, {
        priority: "low"
      });
    }
    class Dz extends Nr {
      static get requires() {
        return [BL, rL];
      }
      static get pluginName() {
        return "TableColumnResizeEditing";
      }
      constructor(t) {
        super(t), this._isResizingActive = !1, this.set("_isResizingAllowed", !0), this._resizingData = null, this._domEmitter = new (Bi())(), this._tableUtilsPlugin = t.plugins.get("TableUtils"), this.on("change:_isResizingAllowed", (e, n, i) => {
          const o = i ? "removeClass" : "addClass";
          t.editing.view.change(e => {
            for (const n of t.editing.view.document.roots) e[o]("ck-column-resize_disabled", t.editing.view.document.getRoot(n.rootName));
          });
        });
      }
      init() {
        this._extendSchema(), this._registerPostFixer(), this._registerConverters(), this._registerResizingListeners(), this._registerResizerInserter();
        const t = this.editor,
          e = t.plugins.get("TableColumnResize");
        t.plugins.get("TableEditing").registerAdditionalSlot({
          filter: t => t.is("element", "tableColumnGroup"),
          positionOffset: 0
        });
        const n = new xz(t);
        t.commands.add("resizeTableWidth", n), t.commands.add("resizeColumnWidths", n), this.bind("_isResizingAllowed").to(t, "isReadOnly", e, "isEnabled", n, "isEnabled", (t, e, n) => !t && e && n);
      }
      destroy() {
        this._domEmitter.stopListening(), super.destroy();
      }
      getColumnGroupElement(t) {
        return iL(t);
      }
      getTableColumnElements(t) {
        return oL(t);
      }
      getTableColumnsWidths(t) {
        return function (t) {
          return oL(t).map(t => t.getAttribute("columnWidth"));
        }(t);
      }
      _extendSchema() {
        this.editor.model.schema.extend("table", {
          allowAttributes: ["tableWidth"]
        }), this.editor.model.schema.register("tableColumnGroup", {
          allowIn: "table",
          isLimit: !0
        }), this.editor.model.schema.register("tableColumn", {
          allowIn: "tableColumnGroup",
          allowAttributes: ["columnWidth", "colSpan"],
          isLimit: !0
        });
      }
      _registerPostFixer() {
        const t = this.editor.model;
        function e(t, e, n) {
          const i = n._tableUtilsPlugin.getColumns(e);
          if (0 === i - t.length) return t;
          const o = t.map(t => Number(t.replace("%", ""))),
            r = function (t, e) {
              const n = new Set();
              for (const i of t.getChanges()) if ("insert" == i.type && i.position.nodeAfter && "tableCell" == i.position.nodeAfter.name && i.position.nodeAfter.getAncestors().includes(e)) n.add(i.position.nodeAfter);else if ("remove" == i.type) {
                const t = i.position.nodeBefore || i.position.nodeAfter;
                "tableCell" == t.name && t.getAncestors().includes(e) && n.add(t);
              }
              return n;
            }(n.editor.model.document.differ, e);
          for (const t of r) {
            const r = i - o.length;
            if (0 === r) continue;
            const s = r > 0,
              a = n._tableUtilsPlugin.getCellLocation(t).column;
            if (s) {
              const t = JM(r, $M(e, n.editor));
              o.splice(a, 0, ...t);
            } else {
              const t = o.splice(a, Math.abs(r));
              o[a] += XM(t);
            }
          }
          return o.map(t => t + "%");
        }
        t.document.registerPostFixer(n => {
          let i = !1;
          for (const o of function (t) {
            const e = new Set();
            for (const n of t.document.differ.getChanges()) {
              let i = null;
              switch (n.type) {
                case "insert":
                  i = ["table", "tableRow", "tableCell"].includes(n.name) ? n.position : null;
                  break;
                case "remove":
                  i = ["tableRow", "tableCell"].includes(n.name) ? n.position : null;
                  break;
                case "attribute":
                  n.range.start.nodeAfter && (i = ["table", "tableRow", "tableCell"].includes(n.range.start.nodeAfter.name) ? n.range.start : null);
              }
              if (!i) continue;
              const o = i.nodeAfter && i.nodeAfter.is("element", "table") ? i.nodeAfter : i.findAncestor("table");
              for (const n of t.createRangeOn(o).getItems()) n.is("element", "table") && iL(n) && e.add(n);
            }
            return e;
          }(t)) {
            const t = this.getColumnGroupElement(o),
              r = this.getTableColumnElements(t),
              s = this.getTableColumnsWidths(t);
            let a = tL(s);
            a = e(a, o, this), Yd(s, a) || (nL(r, t, a, n), i = !0);
          }
          return i;
        });
      }
      _registerConverters() {
        const t = this.editor.conversion;
        t.for("upcast").attributeToAttribute({
          view: {
            name: "figure",
            key: "style",
            value: {
              width: /[\s\S]+/
            }
          },
          model: {
            name: "table",
            key: "tableWidth",
            value: t => t.getStyle("width")
          }
        }), t.for("downcast").attributeToAttribute({
          model: {
            name: "table",
            key: "tableWidth"
          },
          view: t => ({
            name: "figure",
            key: "style",
            value: {
              width: t
            }
          })
        }), t.elementToElement({
          model: "tableColumnGroup",
          view: "colgroup"
        }), t.elementToElement({
          model: "tableColumn",
          view: "col"
        }), t.for("downcast").add(t => t.on("insert:table", (t, e, n) => {
          const i = n.writer,
            o = e.item,
            r = n.mapper.toViewElement(o),
            s = r.is("element", "table") ? r : Array.from(r.getChildren()).find(t => t.is("element", "table"));
          iL(o) ? i.addClass("ck-table-resized", s) : i.removeClass("ck-table-resized", s);
        }, {
          priority: "low"
        })), t.for("upcast").add(Ez(this._tableUtilsPlugin)), t.for("upcast").attributeToAttribute({
          view: {
            name: "col",
            styles: {
              width: /.*/
            }
          },
          model: {
            key: "columnWidth",
            value: t => {
              const e = t.getStyle("width");
              return e && (e.endsWith("%") || e.endsWith("pt")) ? e : "auto";
            }
          }
        }), t.for("upcast").attributeToAttribute({
          view: {
            name: "col",
            key: "span"
          },
          model: "colSpan"
        }), t.for("downcast").attributeToAttribute({
          model: {
            name: "tableColumn",
            key: "columnWidth"
          },
          view: t => ({
            key: "style",
            value: {
              width: t
            }
          })
        });
      }
      _registerResizingListeners() {
        const t = this.editor.editing.view;
        t.addObserver(UL), t.document.on("mousedown", this._onMouseDownHandler.bind(this), {
          priority: "high"
        }), this._domEmitter.listenTo(e.window.document, "mousemove", hf(this._onMouseMoveHandler.bind(this), 50)), this._domEmitter.listenTo(e.window.document, "mouseup", this._onMouseUpHandler.bind(this));
      }
      _onMouseDownHandler(t, e) {
        const n = e.target;
        if (!n.hasClass("ck-table-column-resizer")) return;
        if (!this._isResizingAllowed) return;
        const i = this.editor,
          o = i.editing.mapper.toModelElement(n.findAncestor("figure"));
        if (!i.model.canEditAt(o)) return;
        e.preventDefault(), t.stop();
        const r = function (t, e, n) {
            const i = Array(e.getColumns(t)),
              o = new AM(t);
            for (const t of o) {
              const e = n.editing.mapper.toViewElement(t.cell),
                o = eL(n.editing.view.domConverter.mapViewToDom(e));
              (!i[t.column] || o < i[t.column]) && (i[t.column] = ZM(o));
            }
            return i;
          }(o, this._tableUtilsPlugin, i),
          s = n.findAncestor("table"),
          a = i.editing.view;
        Array.from(s.getChildren()).find(t => t.is("element", "colgroup")) || a.change(t => {
          !function (t, e, n) {
            const i = t.createContainerElement("colgroup");
            for (let n = 0; n < e.length; n++) {
              const o = t.createEmptyElement("col"),
                r = `${ZM(e[n] / XM(e) * 100)}%`;
              t.setStyle("width", r, o), t.insert(t.createPositionAt(i, "end"), o);
            }
            t.insert(t.createPositionAt(n, 0), i);
          }(t, r, s);
        }), this._isResizingActive = !0, this._resizingData = this._getResizingData(e, r), a.change(t => function (t, e, n) {
          const i = n.widths.viewFigureWidth / n.widths.viewFigureParentWidth;
          t.addClass("ck-table-resized", e), t.addClass("ck-table-column-resizer__active", n.elements.viewResizer), t.setStyle("width", `${ZM(100 * i)}%`, e.findAncestor("figure"));
        }(t, s, this._resizingData));
      }
      _onMouseMoveHandler(t, e) {
        if (!this._isResizingActive) return;
        if (!this._isResizingAllowed) return void this._onMouseUpHandler();
        const {
            columnPosition: n,
            flags: {
              isRightEdge: i,
              isTableCentered: o,
              isLtrContent: r
            },
            elements: {
              viewFigure: s,
              viewLeftColumn: a,
              viewRightColumn: l
            },
            widths: {
              viewFigureParentWidth: c,
              tableWidth: d,
              leftColumnWidth: u,
              rightColumnWidth: h
            }
          } = this._resizingData,
          m = 40 - u,
          g = i ? c - d : h - 40,
          p = (r ? 1 : -1) * (i && o ? 2 : 1),
          f = (k = (e.clientX - n) * p, b = Math.min(m, 0), w = Math.max(g, 0), ZM(k <= b ? b : k >= w ? w : k));
        var k, b, w;
        0 !== f && this.editor.editing.view.change(t => {
          const e = ZM(100 * (u + f) / d);
          if (t.setStyle("width", `${e}%`, a), i) {
            const e = ZM(100 * (d + f) / c);
            t.setStyle("width", `${e}%`, s);
          } else {
            const e = ZM(100 * (h - f) / d);
            t.setStyle("width", `${e}%`, l);
          }
        });
      }
      _onMouseUpHandler() {
        if (!this._isResizingActive) return;
        const {
            viewResizer: t,
            modelTable: e,
            viewFigure: n,
            viewColgroup: i
          } = this._resizingData.elements,
          o = this.editor,
          r = o.editing.view,
          s = this.getColumnGroupElement(e),
          a = Array.from(i.getChildren()).filter(t => t.is("view:element")),
          l = s ? this.getTableColumnsWidths(s) : null,
          c = a.map(t => t.getStyle("width")),
          d = !Yd(l, c),
          u = e.getAttribute("tableWidth"),
          h = n.getStyle("width"),
          m = u !== h;
        (d || m) && (this._isResizingAllowed ? o.execute("resizeTableWidth", {
          table: e,
          tableWidth: `${ZM(h)}%`,
          columnWidths: c
        }) : r.change(t => {
          if (l) for (const e of a) t.setStyle("width", l.shift(), e);else t.remove(i);
          m && (u ? t.setStyle("width", u, n) : t.removeStyle("width", n)), l || u || t.removeClass("ck-table-resized", [...n.getChildren()].find(t => "table" === t.name));
        })), r.change(e => {
          e.removeClass("ck-table-column-resizer__active", t);
        }), this._isResizingActive = !1, this._resizingData = null;
      }
      _getResizingData(t, e) {
        const n = this.editor,
          i = t.domEvent.clientX,
          o = t.target,
          r = o.findAncestor("td") || o.findAncestor("th"),
          s = n.editing.mapper.toModelElement(r),
          a = s.findAncestor("table"),
          l = function (t, e) {
            const n = e.getCellLocation(t).column;
            return {
              leftEdge: n,
              rightEdge: n + (t.getAttribute("colspan") || 1) - 1
            };
          }(s, this._tableUtilsPlugin).rightEdge,
          c = l === this._tableUtilsPlugin.getColumns(a) - 1,
          d = !a.hasAttribute("tableAlignment"),
          u = "rtl" !== n.locale.contentLanguageDirection,
          h = r.findAncestor("table"),
          m = h.findAncestor("figure"),
          g = [...h.getChildren()].find(t => t.is("element", "colgroup")),
          p = g.getChild(l),
          f = c ? void 0 : g.getChild(l + 1);
        return {
          columnPosition: i,
          flags: {
            isRightEdge: c,
            isTableCentered: d,
            isLtrContent: u
          },
          elements: {
            viewResizer: o,
            modelTable: a,
            viewFigure: m,
            viewColgroup: g,
            viewLeftColumn: p,
            viewRightColumn: f
          },
          widths: {
            viewFigureParentWidth: QM(n.editing.view.domConverter.mapViewToDom(m.parent)),
            viewFigureWidth: QM(n.editing.view.domConverter.mapViewToDom(m)),
            tableWidth: KM(a, n),
            leftColumnWidth: e[l],
            rightColumnWidth: c ? void 0 : e[l + 1]
          }
        };
      }
      _registerResizerInserter() {
        this.editor.conversion.for("editingDowncast").add(t => {
          t.on("insert:tableCell", (t, e, n) => {
            const i = e.item,
              o = n.mapper.toViewElement(i),
              r = n.writer;
            r.insert(r.createPositionAt(o, "end"), r.createUIElement("div", {
              class: "ck-table-column-resizer"
            }));
          }, {
            priority: "lowest"
          });
        });
      }
    }
    var Bz = o(4204),
      Sz = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Er()(Bz.A, Sz);
    Bz.A.locals;
    function Tz(t) {
      if (t.is("$text") || t.is("$textProxy")) return t.data;
      const e = t;
      let n = "",
        i = null;
      for (const t of e.getChildren()) {
        const e = Tz(t);
        i && i.is("element") && (n += "\n"), n += e, i = t;
      }
      return n;
    }
    class Iz extends cb {}
    Iz.builtinPlugins = [class extends Nr {
      static get requires() {
        return [om, DA, bw, LA, _w, $b, jA];
      }
      static get pluginName() {
        return "Essentials";
      }
    }, class extends Nr {
      static get requires() {
        return [Wb];
      }
      static get pluginName() {
        return "Autoformat";
      }
      afterInit() {
        const t = this.editor,
          e = this.editor.t;
        this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats(), t.accessibility.addKeystrokeInfos({
          keystrokes: [{
            label: e("Revert autoformatting action"),
            keystroke: "Backspace"
          }]
        });
      }
      _addListAutoformats() {
        const t = this.editor.commands;
        t.get("bulletedList") && HA(this.editor, this, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && HA(this.editor, this, /^1[.|)]\s$/, "numberedList"), t.get("todoList") && HA(this.editor, this, /^\[\s?\]\s$/, "todoList"), t.get("checkTodoList") && HA(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
          this.editor.execute("todoList"), this.editor.execute("checkTodoList");
        });
      }
      _addBasicStylesAutoformats() {
        const t = this.editor.commands;
        if (t.get("bold")) {
          const t = GA(this.editor, "bold");
          UA(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t), UA(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
        }
        if (t.get("italic")) {
          const t = GA(this.editor, "italic");
          UA(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t), UA(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
        }
        if (t.get("code")) {
          const t = GA(this.editor, "code");
          UA(this.editor, this, /(`)([^`]+)(`)$/g, t);
        }
        if (t.get("strikethrough")) {
          const t = GA(this.editor, "strikethrough");
          UA(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
        }
      }
      _addHeadingAutoformats() {
        const t = this.editor.commands.get("heading");
        t && t.modelElements.filter(t => t.match(/^heading[1-6]$/)).forEach(e => {
          const n = e[7],
            i = new RegExp(`^(#{${n}})\\s$`);
          HA(this.editor, this, i, () => {
            if (!t.isEnabled || t.value === e) return !1;
            this.editor.execute("heading", {
              value: e
            });
          });
        });
      }
      _addBlockQuoteAutoformats() {
        this.editor.commands.get("blockQuote") && HA(this.editor, this, /^>\s$/, "blockQuote");
      }
      _addCodeBlockAutoformats() {
        const t = this.editor,
          e = t.model.document.selection;
        t.commands.get("codeBlock") && HA(t, this, /^```$/, () => {
          if (e.getFirstPosition().parent.is("element", "listItem")) return !1;
          this.editor.execute("codeBlock", {
            usePreviousLanguageChoice: !0
          });
        });
      }
      _addHorizontalLineAutoformats() {
        this.editor.commands.get("horizontalLine") && HA(this.editor, this, /^---$/, "horizontalLine");
      }
    }, class extends Nr {
      static get requires() {
        return [KA, ZA];
      }
      static get pluginName() {
        return "Bold";
      }
    }, class extends Nr {
      static get requires() {
        return [rC, aC];
      }
      static get pluginName() {
        return "Italic";
      }
    }, class extends Nr {
      static get requires() {
        return [CC, vC];
      }
      static get pluginName() {
        return "Underline";
      }
    }, class extends Nr {
      static get requires() {
        return [cC, uC];
      }
      static get pluginName() {
        return "Strikethrough";
      }
    }, class extends Nr {
      static get requires() {
        return [mC, pC];
      }
      static get pluginName() {
        return "Subscript";
      }
    }, class extends Nr {
      static get requires() {
        return [kC, wC];
      }
      static get pluginName() {
        return "Superscript";
      }
    }, class extends Nr {
      static get requires() {
        return [XA, iC];
      }
      static get pluginName() {
        return "Code";
      }
    }, class extends Nr {
      static get requires() {
        return [TC, MC];
      }
      static get pluginName() {
        return "Alignment";
      }
    }, class extends Nr {
      static get requires() {
        return [VC, OC];
      }
      static get pluginName() {
        return "BlockQuote";
      }
    }, class extends Nr {
      static get requires() {
        return [t_, r_];
      }
      static get pluginName() {
        return "CodeBlock";
      }
    }, class extends jr {
      constructor() {
        super(...arguments), this.token = null, this._tokens = new Map();
      }
      static get pluginName() {
        return "CloudServices";
      }
      static get requires() {
        return [h_];
      }
      async init() {
        const t = this.context.config.get("cloudServices") || {};
        for (const [e, n] of Object.entries(t)) this[e] = n;
        if (!this.tokenUrl) return void (this.token = null);
        const e = this.context.plugins.get("CloudServicesCore");
        this.token = await e.createToken(this.tokenUrl).init(), this._tokens.set(this.tokenUrl, this.token);
      }
      async registerTokenUrl(t) {
        if (this._tokens.has(t)) return this.getTokenFor(t);
        const e = this.context.plugins.get("CloudServicesCore"),
          n = await e.createToken(t).init();
        return this._tokens.set(t, n), n;
      }
      getTokenFor(t) {
        const e = this._tokens.get(t);
        if (!e) throw new b("cloudservices-token-not-registered", this);
        return e;
      }
      destroy() {
        super.destroy();
        for (const t of this._tokens.values()) t.destroy();
      }
    }, class extends Nr {
      static get requires() {
        return [I_, w_];
      }
      static get pluginName() {
        return "FindAndReplace";
      }
      init() {
        const t = this.editor.plugins.get("FindAndReplaceUI"),
          e = this.editor.plugins.get("FindAndReplaceEditing"),
          n = e.state;
        t.on("findNext", (t, i) => {
          i ? (n.searchText = i.searchText, e.find(i.searchText, i)) : this.editor.execute("findNext");
        }), t.on("findPrevious", (t, i) => {
          i && n.searchText !== i.searchText ? e.find(i.searchText) : this.editor.execute("findPrevious");
        }), t.on("replace", (t, i) => {
          n.searchText !== i.searchText && e.find(i.searchText);
          const o = n.highlightedResult;
          o && this.editor.execute("replace", i.replaceText, o);
        }), t.on("replaceAll", (t, i) => {
          n.searchText !== i.searchText && e.find(i.searchText), this.editor.execute("replaceAll", i.replaceText, n.results);
        }), t.on("searchReseted", () => {
          n.clear(this.editor.model), e.stop();
        });
      }
    }, class extends Nr {
      static get requires() {
        return [$_, ov, cv, mv];
      }
      static get pluginName() {
        return "Font";
      }
    }, class extends Nr {
      static get requires() {
        return [_v, xv];
      }
      static get pluginName() {
        return "Heading";
      }
    }, class extends Nr {
      static get requires() {
        return [Dv, Tv];
      }
      static get pluginName() {
        return "Highlight";
      }
    }, class extends Nr {
      static get requires() {
        return [zv, Pv, Jw];
      }
      static get pluginName() {
        return "HorizontalLine";
      }
    }, class extends Nr {
      static get requires() {
        return [jv, Uv, Jw];
      }
      static get pluginName() {
        return "HtmlEmbed";
      }
    }, class extends Nr {
      static get pluginName() {
        return "GeneralHtmlSupport";
      }
      static get requires() {
        return [cx, px, fx, kx, wx, Ax, Cx, _x, vx, yx, Dx];
      }
      init() {
        const t = this.editor,
          e = t.plugins.get(cx);
        e.loadAllowedEmptyElementsConfig(t.config.get("htmlSupport.allowEmpty") || []), e.loadAllowedConfig(t.config.get("htmlSupport.allow") || []), e.loadDisallowedConfig(t.config.get("htmlSupport.disallow") || []);
      }
      getGhsAttributeNameForElement(t) {
        const e = this.editor.plugins.get("DataSchema"),
          n = Array.from(e.getDefinitionsForView(t, !1)),
          i = n.find(t => t.isInline && !n[0].isObject);
        return i ? i.model : Ky(t);
      }
      addModelHtmlClass(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "classes", t => {
            for (const n of vo(e)) t.add(n);
          });
        });
      }
      removeModelHtmlClass(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "classes", t => {
            for (const n of vo(e)) t.delete(n);
          });
        });
      }
      setModelHtmlAttributes(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "attributes", t => {
            for (const [n, i] of Object.entries(e)) t.set(n, i);
          });
        });
      }
      removeModelHtmlAttributes(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "attributes", t => {
            for (const n of vo(e)) t.delete(n);
          });
        });
      }
      setModelHtmlStyles(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "styles", t => {
            for (const [n, i] of Object.entries(e)) t.set(n, i);
          });
        });
      }
      removeModelHtmlStyles(t, e, n) {
        const i = this.editor.model,
          o = this.getGhsAttributeNameForElement(t);
        i.change(t => {
          for (const r of Bx(i, n, o)) $y(t, r, o, "styles", t => {
            for (const n of vo(e)) t.delete(n);
          });
        });
      }
    }, class extends Nr {
      static get pluginName() {
        return "HtmlComment";
      }
      init() {
        const t = this.editor,
          e = new Map();
        t.data.processor.skipComments = !1, t.model.schema.addAttributeCheck((t, e) => {
          if (t.endsWith("$root") && e.startsWith("$comment")) return !0;
        }), t.conversion.for("upcast").elementToMarker({
          view: "$comment",
          model: t => {
            const n = `$comment:${p()}`,
              i = t.getCustomProperty("$rawContent");
            return e.set(n, i), n;
          }
        }), t.conversion.for("dataDowncast").markerToElement({
          model: "$comment",
          view: (t, _ref230) => {
            let {
              writer: e
            } = _ref230;
            let n;
            for (const e of this.editor.model.document.getRootNames()) if (n = this.editor.model.document.getRoot(e), n.hasAttribute(t.markerName)) break;
            const i = t.markerName,
              o = n.getAttribute(i),
              r = e.createUIElement("$comment");
            return e.setCustomProperty("$rawContent", o, r), r;
          }
        }), t.model.document.registerPostFixer(n => {
          let i = !1;
          const o = t.model.document.differ.getChangedMarkers().filter(t => t.name.startsWith("$comment:"));
          for (const t of o) {
            const {
              oldRange: o,
              newRange: r
            } = t.data;
            if (!o || !r || o.root != r.root) {
              if (o) {
                const e = o.root;
                e.hasAttribute(t.name) && (n.removeAttribute(t.name, e), i = !0);
              }
              if (r) {
                const o = r.root;
                "$graveyard" == o.rootName ? (n.removeMarker(t.name), i = !0) : o.hasAttribute(t.name) || (n.setAttribute(t.name, e.get(t.name) || "", o), i = !0);
              }
            }
          }
          return i;
        }), t.data.on("set", () => {
          for (const e of t.model.markers.getMarkersGroup("$comment")) this.removeHtmlComment(e.name);
        }, {
          priority: "high"
        }), t.model.on("deleteContent", (e, _ref231) => {
          let [n] = _ref231;
          for (const e of n.getRanges()) {
            const n = t.model.schema.getLimitElement(e),
              i = t.model.createPositionAt(n, 0),
              o = t.model.createPositionAt(n, "end");
            let r;
            r = i.isTouching(e.start) && o.isTouching(e.end) ? this.getHtmlCommentsInRange(t.model.createRange(i, o)) : this.getHtmlCommentsInRange(e, {
              skipBoundaries: !0
            });
            for (const t of r) this.removeHtmlComment(t);
          }
        }, {
          priority: "high"
        });
      }
      createHtmlComment(t, e) {
        const n = p(),
          i = this.editor.model,
          o = i.document.getRoot(t.root.rootName),
          r = `$comment:${n}`;
        return i.change(n => {
          const i = n.createRange(t);
          return n.addMarker(r, {
            usingOperation: !0,
            affectsData: !0,
            range: i
          }), n.setAttribute(r, e, o), r;
        });
      }
      removeHtmlComment(t) {
        const e = this.editor,
          n = e.model.markers.get(t);
        return !!n && (e.model.change(t => {
          t.removeMarker(n);
        }), !0);
      }
      getHtmlCommentData(t) {
        const e = this.editor.model.markers.get(t);
        if (!e) return null;
        let n = "";
        for (const e of this.editor.model.document.getRoots()) if (e.hasAttribute(t)) {
          n = e.getAttribute(t);
          break;
        }
        return {
          content: n,
          position: e.getStart()
        };
      }
      getHtmlCommentsInRange(t) {
        let {
          skipBoundaries: e = !1
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const n = !e;
        return Array.from(this.editor.model.markers.getMarkersGroup("$comment")).filter(e => function (t, e) {
          const i = t.getRange().start;
          return (i.isAfter(e.start) || n && i.isEqual(e.start)) && (i.isBefore(e.end) || n && i.isEqual(e.end));
        }(e, t)).map(t => t.name);
      }
    }, class extends Nr {
      static get requires() {
        return [dE, hE];
      }
      static get pluginName() {
        return "Image";
      }
    }, class extends Nr {
      static get requires() {
        return [pE, fE];
      }
      static get pluginName() {
        return "ImageCaption";
      }
    }, class extends Nr {
      static get requires() {
        return [ED, SD];
      }
      static get pluginName() {
        return "ImageStyle";
      }
    }, class extends Nr {
      static get requires() {
        return [tA, zx];
      }
      static get pluginName() {
        return "ImageToolbar";
      }
      afterInit() {
        const t = this.editor,
          e = t.t,
          n = t.plugins.get(tA),
          i = t.plugins.get("ImageUtils");
        var o;
        n.register("image", {
          ariaLabel: e("Image toolbar"),
          items: (o = t.config.get("image.toolbar") || [], o.map(t => V(t) ? t.name : t)),
          getRelatedElement: t => i.getClosestSelectedImageWidget(t)
        });
      }
    }, jE, class extends Nr {
      static get pluginName() {
        return "ImageInsert";
      }
      static get requires() {
        return [jE, qE, aE];
      }
    }, class extends Nr {
      static get requires() {
        return [YE, nD, cD, ZE];
      }
      static get pluginName() {
        return "ImageResize";
      }
    }, class extends Nr {
      static get requires() {
        return [Qx, zx];
      }
      static get pluginName() {
        return "PictureEditing";
      }
      afterInit() {
        const t = this.editor;
        t.plugins.has("ImageBlockEditing") && t.model.schema.extend("imageBlock", {
          allowAttributes: ["sources"]
        }), t.plugins.has("ImageInlineEditing") && t.model.schema.extend("imageInline", {
          allowAttributes: ["sources"]
        }), this._setupConversion(), this._setupImageUploadEditingIntegration();
      }
      _setupConversion() {
        const t = this.editor,
          e = t.conversion,
          n = t.plugins.get("ImageUtils");
        e.for("upcast").add(function (t) {
          const e = ["srcset", "media", "type", "sizes"],
            n = (n, i, o) => {
              const r = i.viewItem;
              if (!o.consumable.test(r, {
                name: !0
              })) return;
              const s = new Map();
              for (const t of r.getChildren()) if (t.is("element", "source")) {
                const n = {};
                for (const i of e) t.hasAttribute(i) && o.consumable.test(t, {
                  attributes: i
                }) && (n[i] = t.getAttribute(i));
                Object.keys(n).length && s.set(t, n);
              }
              const a = t.findViewImgElement(r);
              if (!a) return;
              let l = i.modelCursor.parent;
              if (!l.is("element", "imageBlock")) {
                const t = o.convertItem(a, i.modelCursor);
                i.modelRange = t.modelRange, i.modelCursor = t.modelCursor, l = $o(t.modelRange.getItems());
              }
              o.consumable.consume(r, {
                name: !0
              });
              for (const [t, e] of s) o.consumable.consume(t, {
                attributes: Object.keys(e)
              });
              s.size && o.writer.setAttribute("sources", Array.from(s.values()), l), o.convertChildren(r, l);
            };
          return t => {
            t.on("element:picture", n);
          };
        }(n)), e.for("downcast").add(function (t) {
          const e = (e, n, i) => {
            if (!i.consumable.consume(n.item, e.name)) return;
            const o = i.writer,
              r = i.mapper.toViewElement(n.item),
              s = t.findViewImgElement(r),
              a = n.attributeNewValue;
            if (a && a.length) {
              const t = o.createContainerElement("picture", null, a.map(t => o.createEmptyElement("source", t))),
                e = [];
              let n = s.parent;
              for (; n && n.is("attributeElement");) {
                const t = n.parent;
                o.unwrap(o.createRangeOn(s), n), e.unshift(n), n = t;
              }
              o.insert(o.createPositionBefore(s), t), o.move(o.createRangeOn(s), o.createPositionAt(t, "end"));
              for (const n of e) o.wrap(o.createRangeOn(t), n);
            } else if (s.parent.is("element", "picture")) {
              const t = s.parent;
              o.move(o.createRangeOn(s), o.createPositionBefore(t)), o.remove(t);
            }
          };
          return t => {
            t.on("attribute:sources:imageBlock", e), t.on("attribute:sources:imageInline", e);
          };
        }(n));
      }
      _setupImageUploadEditingIntegration() {
        const t = this.editor;
        if (!t.plugins.has("ImageUploadEditing")) return;
        const e = t.plugins.get("ImageUploadEditing");
        this.listenTo(e, "uploadComplete", (e, _ref232) => {
          let {
            imageElement: n,
            data: i
          } = _ref232;
          const o = i.sources;
          o && t.model.change(t => {
            t.setAttributes({
              sources: o
            }, n);
          });
        });
      }
    }, class extends Nr {
      static get pluginName() {
        return "Indent";
      }
      static get requires() {
        return [LD, ND];
      }
    }, class extends Nr {
      constructor(t) {
        super(t), t.config.define("indentBlock", {
          offset: 40,
          unit: "px"
        });
      }
      static get pluginName() {
        return "IndentBlock";
      }
      init() {
        const t = this.editor,
          e = t.config.get("indentBlock");
        e.classes && e.classes.length ? (this._setupConversionUsingClasses(e.classes), t.commands.add("indentBlock", new zD(t, new VD({
          direction: "forward",
          classes: e.classes
        }))), t.commands.add("outdentBlock", new zD(t, new VD({
          direction: "backward",
          classes: e.classes
        })))) : (t.data.addStyleProcessorRules(Fh), this._setupConversionUsingOffset(), t.commands.add("indentBlock", new zD(t, new PD({
          direction: "forward",
          offset: e.offset,
          unit: e.unit
        }))), t.commands.add("outdentBlock", new zD(t, new PD({
          direction: "backward",
          offset: e.offset,
          unit: e.unit
        }))));
      }
      afterInit() {
        const t = this.editor,
          e = t.model.schema,
          n = t.commands.get("indent"),
          i = t.commands.get("outdent"),
          o = t.config.get("heading.options");
        (o && o.map(t => t.model) || RD).forEach(t => {
          e.isRegistered(t) && e.extend(t, {
            allowAttributes: "blockIndent"
          });
        }), e.setAttributeProperties("blockIndent", {
          isFormatting: !0
        }), n.registerChildCommand(t.commands.get("indentBlock")), i.registerChildCommand(t.commands.get("outdentBlock"));
      }
      _setupConversionUsingOffset() {
        const t = this.editor.conversion,
          e = "rtl" === this.editor.locale.contentLanguageDirection ? "margin-right" : "margin-left";
        t.for("upcast").attributeToAttribute({
          view: {
            styles: {
              [e]: /[\s\S]+/
            }
          },
          model: {
            key: "blockIndent",
            value: t => {
              if (!t.is("element", "li")) return t.getStyle(e);
            }
          }
        }), t.for("downcast").attributeToAttribute({
          model: "blockIndent",
          view: t => ({
            key: "style",
            value: {
              [e]: t
            }
          })
        });
      }
      _setupConversionUsingClasses(t) {
        const e = {
          model: {
            key: "blockIndent",
            values: []
          },
          view: {}
        };
        for (const n of t) e.model.values.push(n), e.view[n] = {
          key: "class",
          value: [n]
        };
        this.editor.conversion.attributeToAttribute(e);
      }
    }, class extends Nr {
      static get requires() {
        return [jD, HD];
      }
      static get pluginName() {
        return "TextPartLanguage";
      }
    }, class extends Nr {
      static get requires() {
        return [cB, bB, CB];
      }
      static get pluginName() {
        return "Link";
      }
    }, CB, class extends Nr {
      static get requires() {
        return [vB, EB];
      }
      static get pluginName() {
        return "LinkImage";
      }
    }, ES, JS, dT, class extends Nr {
      static get requires() {
        return [AT, ET, _T, Jw];
      }
      static get pluginName() {
        return "MediaEmbed";
      }
    }, class extends Nr {
      toMentionAttribute(t, e) {
        return LT(t, e);
      }
      static get pluginName() {
        return "Mention";
      }
      static get requires() {
        return [IT, GT];
      }
    }, class extends Nr {
      static get requires() {
        return [iI, oI, Jw];
      }
      static get pluginName() {
        return "PageBreak";
      }
    }, bv, class extends Nr {
      static get pluginName() {
        return "PasteFromOffice";
      }
      static get requires() {
        return [Mb];
      }
      init() {
        const t = this.editor,
          e = t.plugins.get("ClipboardPipeline"),
          n = t.editing.view.document,
          i = [],
          o = this.editor.plugins.has("MultiLevelList");
        i.push(new AI(n, o)), i.push(new yI(n)), i.push(new EI(n)), e.on("inputTransformation", (e, o) => {
          if (o._isTransformedWithPasteFromOffice) return;
          if (t.model.document.selection.getFirstPosition().parent.is("element", "codeBlock")) return;
          const r = o.dataTransfer.getData("text/html"),
            s = i.find(t => t.isActive(r));
          s && (o._parsedData || (o._parsedData = BI(r, n.stylesProcessor)), s.execute(o), o._isTransformedWithPasteFromOffice = !0);
        }, {
          priority: "high"
        });
      }
    }, class extends Nr {
      static get requires() {
        return [MI, TI];
      }
      static get pluginName() {
        return "RemoveFormat";
      }
    }, LA, class extends Nr {
      static get pluginName() {
        return "ShowBlocks";
      }
      static get requires() {
        return [NI, VI];
      }
    }, class extends Nr {
      static get pluginName() {
        return "SourceEditing";
      }
      static get requires() {
        return [Kh];
      }
      constructor(t) {
        super(t), this.set("isSourceEditingMode", !1), this._elementReplacer = new Q(), this._replacedRoots = new Map(), this._dataFromRoots = new Map(), t.config.define("sourceEditing.allowCollaborationFeatures", !1);
      }
      init() {
        this._checkCompatibility();
        const t = this.editor,
          e = t.locale.t;
        t.ui.componentFactory.add("sourceEditing", () => {
          const t = this._createButton(mm);
          return t.set({
            label: e("Source"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"/><path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"/></svg>',
            tooltip: !0,
            class: "ck-source-editing-button"
          }), t;
        }), t.ui.componentFactory.add("menuBar:sourceEditing", () => {
          const t = this._createButton(Uk);
          return t.set({
            label: e("Show source")
          }), t;
        }), this._isAllowedToHandleSourceEditingMode() && (this.on("change:isSourceEditingMode", (t, e, n) => {
          n ? (this._hideVisibleDialog(), this._showSourceEditing(), this._disableCommands()) : (this._hideSourceEditing(), this._enableCommands());
        }), this.on("change:isEnabled", (t, e, n) => this._handleReadOnlyMode(!n)), this.listenTo(t, "change:isReadOnly", (t, e, n) => this._handleReadOnlyMode(n))), t.data.on("get", () => {
          this.isSourceEditingMode && this.updateEditorData();
        }, {
          priority: "high"
        });
      }
      updateEditorData() {
        const t = this.editor,
          e = {};
        for (const [t, n] of this._replacedRoots) {
          const i = this._dataFromRoots.get(t),
            o = n.dataset.value;
          i !== o && (e[t] = o, this._dataFromRoots.set(t, o));
        }
        Object.keys(e).length && t.data.set(e, {
          batchType: {
            isUndoable: !0
          },
          suppressErrorInCollaboration: !0
        });
      }
      _checkCompatibility() {
        const t = this.editor,
          e = t.config.get("sourceEditing.allowCollaborationFeatures");
        if (!e && t.plugins.has("RealTimeCollaborativeEditing")) throw new b("source-editing-incompatible-with-real-time-collaboration", null);
        !e && ["CommentsEditing", "TrackChangesEditing", "RevisionHistory"].some(e => t.plugins.has(e)) && console.warn("You initialized the editor with the source editing feature and at least one of the collaboration features. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the collaboration features."), t.plugins.has("RestrictedEditingModeEditing") && console.warn("You initialized the editor with the source editing feature and restricted editing feature. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the restricted editing feature.");
      }
      _showSourceEditing() {
        const t = this.editor,
          e = t.editing.view,
          n = t.model;
        n.change(t => {
          t.setSelection(null), t.removeSelectionAttribute(n.document.selection.getAttributeKeys());
        });
        for (const [n, i] of e.domRoots) {
          const o = UI(t.data.get({
              rootName: n
            })),
            r = ft(i.ownerDocument, "textarea", {
              rows: "1",
              "aria-label": "Source code editing area"
            }),
            s = ft(i.ownerDocument, "div", {
              class: "ck-source-editing-area",
              "data-value": o
            }, [r]);
          r.value = o, r.setSelectionRange(0, 0), r.addEventListener("input", () => {
            s.dataset.value = r.value, t.ui.update();
          }), e.change(t => {
            const i = e.document.getRoot(n);
            t.addClass("ck-hidden", i);
          }), t.ui.setEditableElement("sourceEditing:" + n, r), this._replacedRoots.set(n, s), this._elementReplacer.replace(i, s), this._dataFromRoots.set(n, o);
        }
        this._focusSourceEditing();
      }
      _hideSourceEditing() {
        const t = this.editor.editing.view;
        this.updateEditorData(), t.change(e => {
          for (const [n] of this._replacedRoots) e.removeClass("ck-hidden", t.document.getRoot(n));
        }), this._elementReplacer.restore(), this._replacedRoots.clear(), this._dataFromRoots.clear(), t.focus();
      }
      _focusSourceEditing() {
        const t = this.editor,
          [e] = this._replacedRoots.values(),
          n = e.querySelector("textarea");
        t.editing.view.document.isFocused = !1, n.focus();
      }
      _disableCommands() {
        const t = this.editor;
        for (const e of t.commands.commands()) e.forceDisabled(HI);
        t.plugins.has("CommentsArchiveUI") && t.plugins.get("CommentsArchiveUI").forceDisabled(HI);
      }
      _enableCommands() {
        const t = this.editor;
        for (const e of t.commands.commands()) e.clearForceDisabled(HI);
        t.plugins.has("CommentsArchiveUI") && t.plugins.get("CommentsArchiveUI").clearForceDisabled(HI);
      }
      _handleReadOnlyMode(t) {
        if (this.isSourceEditingMode) for (const [, e] of this._replacedRoots) e.querySelector("textarea").readOnly = t;
      }
      _isAllowedToHandleSourceEditingMode() {
        const t = this.editor.ui.view.editable;
        return t && !t.hasExternalElement;
      }
      _hideVisibleDialog() {
        if (this.editor.plugins.has("Dialog")) {
          const t = this.editor.plugins.get("Dialog");
          t.isOpen && t.hide();
        }
      }
      _createButton(t) {
        const e = this.editor,
          n = new t(e.locale);
        return n.set({
          withText: !0
        }), n.bind("isOn").to(this, "isSourceEditingMode"), n.bind("isEnabled").to(this, "isEnabled", e, "isReadOnly", e.plugins.get(Kh), "hasAny", (t, e, n) => !!t && !e && !n), this.listenTo(n, "execute", () => {
          this.isSourceEditingMode = !this.isSourceEditingMode;
        }), n;
      }
    }, class extends Nr {
      static get requires() {
        return [$b];
      }
      static get pluginName() {
        return "SpecialCharacters";
      }
      constructor(t) {
        super(t);
        const e = t.t;
        this._characters = new Map(), this._groups = new Map(), this._allSpecialCharactersGroupLabel = e("All");
      }
      init() {
        const t = this.editor,
          e = t.t,
          n = t.commands.get("insertText");
        t.ui.componentFactory.add("specialCharacters", i => {
          const o = Eg(i);
          let r;
          return o.buttonView.set({
            label: e("Special characters"),
            icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.5a7.47 7.47 0 0 1 4.231 1.31 7.268 7.268 0 0 1 2.703 3.454 7.128 7.128 0 0 1 .199 4.353c-.39 1.436-1.475 2.72-2.633 3.677h2.013c0-.226.092-.443.254-.603a.876.876 0 0 1 1.229 0c.163.16.254.377.254.603v.853c0 .209-.078.41-.22.567a.873.873 0 0 1-.547.28l-.101.006h-4.695a.517.517 0 0 1-.516-.518v-1.265c0-.21.128-.398.317-.489a5.601 5.601 0 0 0 2.492-2.371 5.459 5.459 0 0 0 .552-3.693 5.53 5.53 0 0 0-1.955-3.2A5.71 5.71 0 0 0 10 4.206 5.708 5.708 0 0 0 6.419 5.46 5.527 5.527 0 0 0 4.46 8.663a5.457 5.457 0 0 0 .554 3.695 5.6 5.6 0 0 0 2.497 2.37.55.55 0 0 1 .317.49v1.264c0 .286-.23.518-.516.518H2.618a.877.877 0 0 1-.614-.25.845.845 0 0 1-.254-.603v-.853c0-.226.091-.443.254-.603a.876.876 0 0 1 1.228 0c.163.16.255.377.255.603h1.925c-1.158-.958-2.155-2.241-2.545-3.678a7.128 7.128 0 0 1 .199-4.352 7.268 7.268 0 0 1 2.703-3.455A7.475 7.475 0 0 1 10 2.5z"/></svg>',
            tooltip: !0
          }), o.bind("isEnabled").to(n), o.on("execute", (e, n) => {
            t.execute("insertText", {
              text: n.character
            }), t.editing.view.focus();
          }), o.on("change:isOpen", () => {
            if (!r) {
              r = this._createDropdownPanelContent(i, o);
              const t = new JI(i, r.navigationView, r.gridView, r.infoView);
              o.panelView.children.add(t);
            }
            r.infoView.set({
              character: null,
              name: null
            });
          }), o;
        });
      }
      addItems(t, e) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          label: t
        };
        if (t === eM) throw new b("special-character-invalid-group-name", null);
        const i = this._getGroup(t, n.label);
        for (const t of e) i.items.add(t.title), this._characters.set(t.title, t.character);
      }
      getGroups() {
        const t = Array.from(this._groups.keys()),
          e = this.editor.config.get("specialCharacters.order") || [],
          n = e.find(e => !t.includes(e));
        if (n) throw new b("special-character-invalid-order-group-name", null, {
          invalidGroup: n
        });
        return new Set([...e, ...t]);
      }
      getCharactersForGroup(t) {
        if (t === eM) return new Set(this._characters.keys());
        const e = this._groups.get(t);
        return e ? e.items : void 0;
      }
      getCharacter(t) {
        return this._characters.get(t);
      }
      _getGroup(t, e) {
        return this._groups.has(t) || this._groups.set(t, {
          items: new Set(),
          label: e
        }), this._groups.get(t);
      }
      _updateGrid(t, e) {
        e.tiles.clear();
        const n = this.getCharactersForGroup(t);
        for (const t of n) {
          const n = this.getCharacter(t);
          e.tiles.add(e.createTile(n, t));
        }
      }
      _createDropdownPanelContent(t, e) {
        const n = Array.from(this.getGroups()).map(t => [t, this._groups.get(t).label]),
          i = new Map([[eM, this._allSpecialCharactersGroupLabel], ...n]),
          o = new qI(t, i),
          r = new $I(t),
          s = new QI(t);
        return r.delegate("execute").to(e), r.on("tileHover", (t, e) => {
          s.set(e);
        }), r.on("tileFocus", (t, e) => {
          s.set(e);
        }), o.on("execute", () => {
          this._updateGrid(o.currentGroupName, r);
        }), this._updateGrid(o.currentGroupName, r), {
          navigationView: o,
          gridView: r,
          infoView: s
        };
      }
    }, class extends Nr {
      static get pluginName() {
        return "SpecialCharactersEssentials";
      }
      static get requires() {
        return [sM, iM, oM, nM, rM];
      }
    }, class extends Nr {
      static get requires() {
        return [BL, LL, VL, qL, HL, RL, Jw];
      }
      static get pluginName() {
        return "Table";
      }
    }, class extends Nr {
      static get requires() {
        return [tA];
      }
      static get pluginName() {
        return "TableToolbar";
      }
      afterInit() {
        const t = this.editor,
          e = t.t,
          n = t.plugins.get(tA),
          i = t.config.get("table.contentToolbar"),
          o = t.config.get("table.tableToolbar");
        i && n.register("tableContent", {
          ariaLabel: e("Table toolbar"),
          items: i,
          getRelatedElement: QL
        }), o && n.register("table", {
          ariaLabel: e("Table toolbar"),
          items: o,
          getRelatedElement: YL
        });
      }
    }, class extends Nr {
      static get pluginName() {
        return "TableProperties";
      }
      static get requires() {
        return [az, pz];
      }
    }, class extends Nr {
      static get pluginName() {
        return "TableCellProperties";
      }
      static get requires() {
        return [QN, PN];
      }
    }, class extends Nr {
      static get pluginName() {
        return "TableCaption";
      }
      static get requires() {
        return [Cz, _z];
      }
    }, class extends Nr {
      static get requires() {
        return [Dz, FN];
      }
      static get pluginName() {
        return "TableColumnResize";
      }
    }, class extends Nr {
      static get requires() {
        return ["Delete", "Input"];
      }
      static get pluginName() {
        return "TextTransformation";
      }
      constructor(t) {
        super(t), t.config.define("typing", {
          transformations: {
            include: rw
          }
        });
      }
      init() {
        const t = this.editor.model.document.selection;
        t.on("change:range", () => {
          this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
        }), this._enableTransformationWatchers();
      }
      _enableTransformationWatchers() {
        const t = this.editor,
          e = t.model,
          n = t.plugins.get("Delete"),
          i = function (t) {
            const e = t.extra || [],
              n = t.remove || [],
              i = t => !n.includes(t);
            return function (t) {
              const e = new Set();
              for (const n of t) if ("string" == typeof n && ow[n]) for (const t of ow[n]) e.add(t);else e.add(n);
              return Array.from(e);
            }(t.include.concat(e).filter(i)).filter(i).map(t => "string" == typeof t && iw[t] ? iw[t] : t).filter(t => "object" == typeof t).map(t => ({
              from: sw(t.from),
              to: aw(t.to)
            }));
          }(t.config.get("typing.transformations")),
          o = new Yb(t.model, t => {
            for (const e of i) {
              if (e.from.test(t)) return {
                normalizedTransformation: e
              };
            }
          });
        o.on("matched:data", (t, i) => {
          if (!i.batch.isTyping) return;
          const {
              from: o,
              to: r
            } = i.normalizedTransformation,
            s = o.exec(i.text),
            a = r(s.slice(1)),
            l = i.range;
          let c = s.index;
          e.enqueueChange(t => {
            for (let n = 1; n < s.length; n++) {
              const i = s[n],
                o = a[n - 1];
              if (null == o) {
                c += i.length;
                continue;
              }
              const r = l.start.getShiftedBy(c),
                d = e.createRange(r, r.getShiftedBy(i.length)),
                u = lw(r);
              e.insertContent(t.createText(o, u), d), c += o.length;
            }
            e.enqueueChange(() => {
              n.requestUndoOnBackspace();
            });
          });
        }), o.bind("isEnabled").to(this);
      }
    }, class extends Nr {
      constructor(t) {
        super(t), this.set("characters", 0), this.set("words", 0), Object.defineProperties(this, {
          characters: {
            get() {
              return this.characters = this._getCharacters(this._getText());
            }
          },
          words: {
            get() {
              return this.words = this._getWords(this._getText());
            }
          }
        }), this.set("_wordsLabel", void 0), this.set("_charactersLabel", void 0), this._config = t.config.get("wordCount") || {}, this._outputView = void 0, this._wordsMatchRegExp = s.features.isRegExpUnicodePropertySupported ? new RegExp("([\\p{L}\\p{N}]+\\S?)+", "gu") : /([a-zA-Z0-9À-ž]+\S?)+/gu;
      }
      static get pluginName() {
        return "WordCount";
      }
      init() {
        this.editor.model.document.on("change:data", hf(this._refreshStats.bind(this), 250)), "function" == typeof this._config.onUpdate && this.on("update", (t, e) => {
          this._config.onUpdate(e);
        }), Ci(this._config.container) && this._config.container.appendChild(this.wordCountContainer);
      }
      destroy() {
        this._outputView && (this._outputView.element.remove(), this._outputView.destroy()), super.destroy();
      }
      get wordCountContainer() {
        const t = this.editor,
          e = t.t,
          n = t.config.get("wordCount.displayWords"),
          i = t.config.get("wordCount.displayCharacters"),
          o = ir.bind(this, this),
          r = [];
        return this._outputView || (this._outputView = new Sr(), (n || void 0 === n) && (this.bind("_wordsLabel").to(this, "words", t => e("Words: %0", t)), r.push({
          tag: "div",
          children: [{
            text: [o.to("_wordsLabel")]
          }],
          attributes: {
            class: "ck-word-count__words"
          }
        })), (i || void 0 === i) && (this.bind("_charactersLabel").to(this, "characters", t => e("Characters: %0", t)), r.push({
          tag: "div",
          children: [{
            text: [o.to("_charactersLabel")]
          }],
          attributes: {
            class: "ck-word-count__characters"
          }
        })), this._outputView.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-word-count"]
          },
          children: r
        }), this._outputView.render()), this._outputView.element;
      }
      _getText() {
        let t = "";
        for (const e of this.editor.model.document.getRoots()) "" !== t && (t += "\n"), t += Tz(e);
        return t;
      }
      _getCharacters(t) {
        return t.replace(/\n/g, "").length;
      }
      _getWords(t) {
        return (t.match(this._wordsMatchRegExp) || []).length;
      }
      _refreshStats() {
        const t = this._getText(),
          e = this.words = this._getWords(t),
          n = this.characters = this._getCharacters(t);
        this.fire("update", {
          words: e,
          characters: n
        });
      }
    }], Iz.defaultConfig = {
      toolbar: {
        items: ["undo", "redo", "|", "heading", "|", "bold", "italic", "underline", "strikethrough", "code", "subscript", "superscript", "removeFormat", "|", "fontSize", "fontFamily", "fontColor", "fontBackgroundColor", "highlight", "|", "alignment", "|", "numberedList", "bulletedList", "todoList", "outdent", "indent", "|", "blockQuote", "codeBlock", "horizontalLine", "|", "link", "insertImage", "mediaEmbed", "insertTable", "specialCharacters", "pageBreak", "htmlEmbed", "|", "findAndReplace", "showBlocks", "sourceEditing"],
        shouldNotGroupWhenFull: !0
      },
      language: "en"
    };
  })(), r = r.default;
})());